
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire43b3"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire43b3"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("iEsO5", function(module, exports) {

$parcel$export(module.exports, "Fragment", () => $d9424ee0654801a7$export$ffb0004e005737fa, (v) => $d9424ee0654801a7$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "jsx", () => $d9424ee0654801a7$export$34b9dba7ce09269b, (v) => $d9424ee0654801a7$export$34b9dba7ce09269b = v);
$parcel$export(module.exports, "jsxs", () => $d9424ee0654801a7$export$25062201e9e25d76, (v) => $d9424ee0654801a7$export$25062201e9e25d76 = v);
/**
 * @license React
 * react-jsx-runtime.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $d9424ee0654801a7$export$ffb0004e005737fa;
var $d9424ee0654801a7$export$34b9dba7ce09269b;
var $d9424ee0654801a7$export$25062201e9e25d76;
"use strict";
var $d9424ee0654801a7$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $d9424ee0654801a7$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment");
function $d9424ee0654801a7$var$jsxProd(type, config, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config.key && (key = "" + config.key);
    if ("key" in config) {
        maybeKey = {};
        for(var propName in config)"key" !== propName && (maybeKey[propName] = config[propName]);
    } else maybeKey = config;
    config = maybeKey.ref;
    return {
        $$typeof: $d9424ee0654801a7$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== config ? config : null,
        props: maybeKey
    };
}
$d9424ee0654801a7$export$ffb0004e005737fa = $d9424ee0654801a7$var$REACT_FRAGMENT_TYPE;
$d9424ee0654801a7$export$34b9dba7ce09269b = $d9424ee0654801a7$var$jsxProd;
$d9424ee0654801a7$export$25062201e9e25d76 = $d9424ee0654801a7$var$jsxProd;

});

parcelRegister("aZSru", function(module, exports) {
'use strict';

module.exports = (parcelRequire("b4Lnw"));

});
parcelRegister("b4Lnw", function(module, exports) {

$parcel$export(module.exports, "Activity", () => $8104d1cc2ac2053d$export$9c16c1426311996d, (v) => $8104d1cc2ac2053d$export$9c16c1426311996d = v);
$parcel$export(module.exports, "Children", () => $8104d1cc2ac2053d$export$dca3b0875bd9a954, (v) => $8104d1cc2ac2053d$export$dca3b0875bd9a954 = v);
$parcel$export(module.exports, "Component", () => $8104d1cc2ac2053d$export$16fa2f45be04daa8, (v) => $8104d1cc2ac2053d$export$16fa2f45be04daa8 = v);
$parcel$export(module.exports, "Fragment", () => $8104d1cc2ac2053d$export$ffb0004e005737fa, (v) => $8104d1cc2ac2053d$export$ffb0004e005737fa = v);
$parcel$export(module.exports, "Profiler", () => $8104d1cc2ac2053d$export$e2c29f18771995cb, (v) => $8104d1cc2ac2053d$export$e2c29f18771995cb = v);
$parcel$export(module.exports, "PureComponent", () => $8104d1cc2ac2053d$export$221d75b3f55bb0bd, (v) => $8104d1cc2ac2053d$export$221d75b3f55bb0bd = v);
$parcel$export(module.exports, "StrictMode", () => $8104d1cc2ac2053d$export$5f8d39834fd61797, (v) => $8104d1cc2ac2053d$export$5f8d39834fd61797 = v);
$parcel$export(module.exports, "Suspense", () => $8104d1cc2ac2053d$export$74bf444e3cd11ea5, (v) => $8104d1cc2ac2053d$export$74bf444e3cd11ea5 = v);
$parcel$export(module.exports, "ViewTransition", () => $8104d1cc2ac2053d$export$8cdaa4703948c5e9, (v) => $8104d1cc2ac2053d$export$8cdaa4703948c5e9 = v);
$parcel$export(module.exports, "__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $8104d1cc2ac2053d$export$1ced07cd6b1985ce, (v) => $8104d1cc2ac2053d$export$1ced07cd6b1985ce = v);
$parcel$export(module.exports, "__COMPILER_RUNTIME", () => $8104d1cc2ac2053d$export$abd8e32b826d7ea7, (v) => $8104d1cc2ac2053d$export$abd8e32b826d7ea7 = v);
$parcel$export(module.exports, "addTransitionType", () => $8104d1cc2ac2053d$export$87c99536b1b8cdd8, (v) => $8104d1cc2ac2053d$export$87c99536b1b8cdd8 = v);
$parcel$export(module.exports, "cache", () => $8104d1cc2ac2053d$export$69a3209f1a06c04d, (v) => $8104d1cc2ac2053d$export$69a3209f1a06c04d = v);
$parcel$export(module.exports, "cacheSignal", () => $8104d1cc2ac2053d$export$8c538325882c7eec, (v) => $8104d1cc2ac2053d$export$8c538325882c7eec = v);
$parcel$export(module.exports, "cloneElement", () => $8104d1cc2ac2053d$export$e530037191fcd5d7, (v) => $8104d1cc2ac2053d$export$e530037191fcd5d7 = v);
$parcel$export(module.exports, "createContext", () => $8104d1cc2ac2053d$export$fd42f52fd3ae1109, (v) => $8104d1cc2ac2053d$export$fd42f52fd3ae1109 = v);
$parcel$export(module.exports, "createElement", () => $8104d1cc2ac2053d$export$c8a8987d4410bf2d, (v) => $8104d1cc2ac2053d$export$c8a8987d4410bf2d = v);
$parcel$export(module.exports, "createRef", () => $8104d1cc2ac2053d$export$7d1e3a5e95ceca43, (v) => $8104d1cc2ac2053d$export$7d1e3a5e95ceca43 = v);
$parcel$export(module.exports, "forwardRef", () => $8104d1cc2ac2053d$export$257a8862b851cb5b, (v) => $8104d1cc2ac2053d$export$257a8862b851cb5b = v);
$parcel$export(module.exports, "isValidElement", () => $8104d1cc2ac2053d$export$a8257692ac88316c, (v) => $8104d1cc2ac2053d$export$a8257692ac88316c = v);
$parcel$export(module.exports, "lazy", () => $8104d1cc2ac2053d$export$488013bae63b21da, (v) => $8104d1cc2ac2053d$export$488013bae63b21da = v);
$parcel$export(module.exports, "memo", () => $8104d1cc2ac2053d$export$7c73462e0d25e514, (v) => $8104d1cc2ac2053d$export$7c73462e0d25e514 = v);
$parcel$export(module.exports, "startTransition", () => $8104d1cc2ac2053d$export$7568632d0d33d16d, (v) => $8104d1cc2ac2053d$export$7568632d0d33d16d = v);
$parcel$export(module.exports, "unstable_useCacheRefresh", () => $8104d1cc2ac2053d$export$f93f40ac0ca7e3a8, (v) => $8104d1cc2ac2053d$export$f93f40ac0ca7e3a8 = v);
$parcel$export(module.exports, "use", () => $8104d1cc2ac2053d$export$1f96ae73734a86cc, (v) => $8104d1cc2ac2053d$export$1f96ae73734a86cc = v);
$parcel$export(module.exports, "useActionState", () => $8104d1cc2ac2053d$export$9a47ced3238df325, (v) => $8104d1cc2ac2053d$export$9a47ced3238df325 = v);
$parcel$export(module.exports, "useCallback", () => $8104d1cc2ac2053d$export$35808ee640e87ca7, (v) => $8104d1cc2ac2053d$export$35808ee640e87ca7 = v);
$parcel$export(module.exports, "useContext", () => $8104d1cc2ac2053d$export$fae74005e78b1a27, (v) => $8104d1cc2ac2053d$export$fae74005e78b1a27 = v);
$parcel$export(module.exports, "useDebugValue", () => $8104d1cc2ac2053d$export$dc8fbce3eb94dc1e, (v) => $8104d1cc2ac2053d$export$dc8fbce3eb94dc1e = v);
$parcel$export(module.exports, "useDeferredValue", () => $8104d1cc2ac2053d$export$6a7bc4e911dc01cf, (v) => $8104d1cc2ac2053d$export$6a7bc4e911dc01cf = v);
$parcel$export(module.exports, "useEffect", () => $8104d1cc2ac2053d$export$6d9c69b0de29b591, (v) => $8104d1cc2ac2053d$export$6d9c69b0de29b591 = v);
$parcel$export(module.exports, "useEffectEvent", () => $8104d1cc2ac2053d$export$7f54fc3180508a52, (v) => $8104d1cc2ac2053d$export$7f54fc3180508a52 = v);
$parcel$export(module.exports, "useId", () => $8104d1cc2ac2053d$export$f680877a34711e37, (v) => $8104d1cc2ac2053d$export$f680877a34711e37 = v);
$parcel$export(module.exports, "useImperativeHandle", () => $8104d1cc2ac2053d$export$d5a552a76deda3c2, (v) => $8104d1cc2ac2053d$export$d5a552a76deda3c2 = v);
$parcel$export(module.exports, "useInsertionEffect", () => $8104d1cc2ac2053d$export$aaabe4eda9ed9969, (v) => $8104d1cc2ac2053d$export$aaabe4eda9ed9969 = v);
$parcel$export(module.exports, "useLayoutEffect", () => $8104d1cc2ac2053d$export$e5c5a5f917a5871c, (v) => $8104d1cc2ac2053d$export$e5c5a5f917a5871c = v);
$parcel$export(module.exports, "useMemo", () => $8104d1cc2ac2053d$export$1538c33de8887b59, (v) => $8104d1cc2ac2053d$export$1538c33de8887b59 = v);
$parcel$export(module.exports, "useOptimistic", () => $8104d1cc2ac2053d$export$fca7f784ae7a249a, (v) => $8104d1cc2ac2053d$export$fca7f784ae7a249a = v);
$parcel$export(module.exports, "useReducer", () => $8104d1cc2ac2053d$export$13e3392192263954, (v) => $8104d1cc2ac2053d$export$13e3392192263954 = v);
$parcel$export(module.exports, "useRef", () => $8104d1cc2ac2053d$export$b8f5890fc79d6aca, (v) => $8104d1cc2ac2053d$export$b8f5890fc79d6aca = v);
$parcel$export(module.exports, "useState", () => $8104d1cc2ac2053d$export$60241385465d0a34, (v) => $8104d1cc2ac2053d$export$60241385465d0a34 = v);
$parcel$export(module.exports, "useSyncExternalStore", () => $8104d1cc2ac2053d$export$306c0aa65ff9ec16, (v) => $8104d1cc2ac2053d$export$306c0aa65ff9ec16 = v);
$parcel$export(module.exports, "useTransition", () => $8104d1cc2ac2053d$export$7b286972b8d8ccbf, (v) => $8104d1cc2ac2053d$export$7b286972b8d8ccbf = v);
$parcel$export(module.exports, "version", () => $8104d1cc2ac2053d$export$83d89fbfd8236492, (v) => $8104d1cc2ac2053d$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $8104d1cc2ac2053d$export$9c16c1426311996d;
var $8104d1cc2ac2053d$export$dca3b0875bd9a954;
var $8104d1cc2ac2053d$export$16fa2f45be04daa8;
var $8104d1cc2ac2053d$export$ffb0004e005737fa;
var $8104d1cc2ac2053d$export$e2c29f18771995cb;
var $8104d1cc2ac2053d$export$221d75b3f55bb0bd;
var $8104d1cc2ac2053d$export$5f8d39834fd61797;
var $8104d1cc2ac2053d$export$74bf444e3cd11ea5;
var $8104d1cc2ac2053d$export$8cdaa4703948c5e9;
var $8104d1cc2ac2053d$export$1ced07cd6b1985ce;
var $8104d1cc2ac2053d$export$abd8e32b826d7ea7;
var $8104d1cc2ac2053d$export$87c99536b1b8cdd8;
var $8104d1cc2ac2053d$export$69a3209f1a06c04d;
var $8104d1cc2ac2053d$export$8c538325882c7eec;
var $8104d1cc2ac2053d$export$e530037191fcd5d7;
var $8104d1cc2ac2053d$export$fd42f52fd3ae1109;
var $8104d1cc2ac2053d$export$c8a8987d4410bf2d;
var $8104d1cc2ac2053d$export$7d1e3a5e95ceca43;
var $8104d1cc2ac2053d$export$257a8862b851cb5b;
var $8104d1cc2ac2053d$export$a8257692ac88316c;
var $8104d1cc2ac2053d$export$488013bae63b21da;
var $8104d1cc2ac2053d$export$7c73462e0d25e514;
var $8104d1cc2ac2053d$export$7568632d0d33d16d;
var $8104d1cc2ac2053d$export$f93f40ac0ca7e3a8;
var $8104d1cc2ac2053d$export$1f96ae73734a86cc;
var $8104d1cc2ac2053d$export$9a47ced3238df325;
var $8104d1cc2ac2053d$export$35808ee640e87ca7;
var $8104d1cc2ac2053d$export$fae74005e78b1a27;
var $8104d1cc2ac2053d$export$dc8fbce3eb94dc1e;
var $8104d1cc2ac2053d$export$6a7bc4e911dc01cf;
var $8104d1cc2ac2053d$export$6d9c69b0de29b591;
var $8104d1cc2ac2053d$export$7f54fc3180508a52;
var $8104d1cc2ac2053d$export$f680877a34711e37;
var $8104d1cc2ac2053d$export$d5a552a76deda3c2;
var $8104d1cc2ac2053d$export$aaabe4eda9ed9969;
var $8104d1cc2ac2053d$export$e5c5a5f917a5871c;
var $8104d1cc2ac2053d$export$1538c33de8887b59;
var $8104d1cc2ac2053d$export$fca7f784ae7a249a;
var $8104d1cc2ac2053d$export$13e3392192263954;
var $8104d1cc2ac2053d$export$b8f5890fc79d6aca;
var $8104d1cc2ac2053d$export$60241385465d0a34;
var $8104d1cc2ac2053d$export$306c0aa65ff9ec16;
var $8104d1cc2ac2053d$export$7b286972b8d8ccbf;
var $8104d1cc2ac2053d$export$83d89fbfd8236492;
"use strict";
var $8104d1cc2ac2053d$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $8104d1cc2ac2053d$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $8104d1cc2ac2053d$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $8104d1cc2ac2053d$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $8104d1cc2ac2053d$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $8104d1cc2ac2053d$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $8104d1cc2ac2053d$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $8104d1cc2ac2053d$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $8104d1cc2ac2053d$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $8104d1cc2ac2053d$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $8104d1cc2ac2053d$var$REACT_LAZY_TYPE = Symbol.for("react.lazy"), $8104d1cc2ac2053d$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $8104d1cc2ac2053d$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $8104d1cc2ac2053d$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $8104d1cc2ac2053d$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $8104d1cc2ac2053d$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$8104d1cc2ac2053d$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $8104d1cc2ac2053d$var$ReactNoopUpdateQueue = {
    isMounted: function() {
        return !1;
    },
    enqueueForceUpdate: function() {},
    enqueueReplaceState: function() {},
    enqueueSetState: function() {}
}, $8104d1cc2ac2053d$var$assign = Object.assign, $8104d1cc2ac2053d$var$emptyObject = {};
function $8104d1cc2ac2053d$var$Component(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8104d1cc2ac2053d$var$emptyObject;
    this.updater = updater || $8104d1cc2ac2053d$var$ReactNoopUpdateQueue;
}
$8104d1cc2ac2053d$var$Component.prototype.isReactComponent = {};
$8104d1cc2ac2053d$var$Component.prototype.setState = function(partialState, callback) {
    if ("object" !== typeof partialState && "function" !== typeof partialState && null != partialState) throw Error("takes an object of state variables to update or a function which returns an object of state variables.");
    this.updater.enqueueSetState(this, partialState, callback, "setState");
};
$8104d1cc2ac2053d$var$Component.prototype.forceUpdate = function(callback) {
    this.updater.enqueueForceUpdate(this, callback, "forceUpdate");
};
function $8104d1cc2ac2053d$var$ComponentDummy() {}
$8104d1cc2ac2053d$var$ComponentDummy.prototype = $8104d1cc2ac2053d$var$Component.prototype;
function $8104d1cc2ac2053d$var$PureComponent(props, context, updater) {
    this.props = props;
    this.context = context;
    this.refs = $8104d1cc2ac2053d$var$emptyObject;
    this.updater = updater || $8104d1cc2ac2053d$var$ReactNoopUpdateQueue;
}
var $8104d1cc2ac2053d$var$pureComponentPrototype = $8104d1cc2ac2053d$var$PureComponent.prototype = new $8104d1cc2ac2053d$var$ComponentDummy();
$8104d1cc2ac2053d$var$pureComponentPrototype.constructor = $8104d1cc2ac2053d$var$PureComponent;
$8104d1cc2ac2053d$var$assign($8104d1cc2ac2053d$var$pureComponentPrototype, $8104d1cc2ac2053d$var$Component.prototype);
$8104d1cc2ac2053d$var$pureComponentPrototype.isPureReactComponent = !0;
var $8104d1cc2ac2053d$var$isArrayImpl = Array.isArray;
function $8104d1cc2ac2053d$var$noop() {}
var $8104d1cc2ac2053d$var$ReactSharedInternals = {
    H: null,
    A: null,
    T: null,
    S: null
}, $8104d1cc2ac2053d$var$hasOwnProperty = Object.prototype.hasOwnProperty;
function $8104d1cc2ac2053d$var$ReactElement(type, key, props) {
    var refProp = props.ref;
    return {
        $$typeof: $8104d1cc2ac2053d$var$REACT_ELEMENT_TYPE,
        type: type,
        key: key,
        ref: void 0 !== refProp ? refProp : null,
        props: props
    };
}
function $8104d1cc2ac2053d$var$cloneAndReplaceKey(oldElement, newKey) {
    return $8104d1cc2ac2053d$var$ReactElement(oldElement.type, newKey, oldElement.props);
}
function $8104d1cc2ac2053d$var$isValidElement(object) {
    return "object" === typeof object && null !== object && object.$$typeof === $8104d1cc2ac2053d$var$REACT_ELEMENT_TYPE;
}
function $8104d1cc2ac2053d$var$escape(key) {
    var escaperLookup = {
        "=": "=0",
        ":": "=2"
    };
    return "$" + key.replace(/[=:]/g, function(match) {
        return escaperLookup[match];
    });
}
var $8104d1cc2ac2053d$var$userProvidedKeyEscapeRegex = /\/+/g;
function $8104d1cc2ac2053d$var$getElementKey(element, index) {
    return "object" === typeof element && null !== element && null != element.key ? $8104d1cc2ac2053d$var$escape("" + element.key) : index.toString(36);
}
function $8104d1cc2ac2053d$var$resolveThenable(thenable) {
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            throw thenable.reason;
        default:
            switch("string" === typeof thenable.status ? thenable.then($8104d1cc2ac2053d$var$noop, $8104d1cc2ac2053d$var$noop) : (thenable.status = "pending", thenable.then(function(fulfilledValue) {
                "pending" === thenable.status && (thenable.status = "fulfilled", thenable.value = fulfilledValue);
            }, function(error) {
                "pending" === thenable.status && (thenable.status = "rejected", thenable.reason = error);
            })), thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenable.reason;
            }
    }
    throw thenable;
}
function $8104d1cc2ac2053d$var$mapIntoArray(children, array, escapedPrefix, nameSoFar, callback) {
    var type = typeof children;
    if ("undefined" === type || "boolean" === type) children = null;
    var invokeCallback = !1;
    if (null === children) invokeCallback = !0;
    else switch(type){
        case "bigint":
        case "string":
        case "number":
            invokeCallback = !0;
            break;
        case "object":
            switch(children.$$typeof){
                case $8104d1cc2ac2053d$var$REACT_ELEMENT_TYPE:
                case $8104d1cc2ac2053d$var$REACT_PORTAL_TYPE:
                    invokeCallback = !0;
                    break;
                case $8104d1cc2ac2053d$var$REACT_LAZY_TYPE:
                    return invokeCallback = children._init, $8104d1cc2ac2053d$var$mapIntoArray(invokeCallback(children._payload), array, escapedPrefix, nameSoFar, callback);
            }
    }
    if (invokeCallback) return callback = callback(children), invokeCallback = "" === nameSoFar ? "." + $8104d1cc2ac2053d$var$getElementKey(children, 0) : nameSoFar, $8104d1cc2ac2053d$var$isArrayImpl(callback) ? (escapedPrefix = "", null != invokeCallback && (escapedPrefix = invokeCallback.replace($8104d1cc2ac2053d$var$userProvidedKeyEscapeRegex, "$&/") + "/"), $8104d1cc2ac2053d$var$mapIntoArray(callback, array, escapedPrefix, "", function(c) {
        return c;
    })) : null != callback && ($8104d1cc2ac2053d$var$isValidElement(callback) && (callback = $8104d1cc2ac2053d$var$cloneAndReplaceKey(callback, escapedPrefix + (null == callback.key || children && children.key === callback.key ? "" : ("" + callback.key).replace($8104d1cc2ac2053d$var$userProvidedKeyEscapeRegex, "$&/") + "/") + invokeCallback)), array.push(callback)), 1;
    invokeCallback = 0;
    var nextNamePrefix = "" === nameSoFar ? "." : nameSoFar + ":";
    if ($8104d1cc2ac2053d$var$isArrayImpl(children)) for(var i = 0; i < children.length; i++)nameSoFar = children[i], type = nextNamePrefix + $8104d1cc2ac2053d$var$getElementKey(nameSoFar, i), invokeCallback += $8104d1cc2ac2053d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if (i = $8104d1cc2ac2053d$var$getIteratorFn(children), "function" === typeof i) for(children = i.call(children), i = 0; !(nameSoFar = children.next()).done;)nameSoFar = nameSoFar.value, type = nextNamePrefix + $8104d1cc2ac2053d$var$getElementKey(nameSoFar, i++), invokeCallback += $8104d1cc2ac2053d$var$mapIntoArray(nameSoFar, array, escapedPrefix, type, callback);
    else if ("object" === type) {
        if ("function" === typeof children.then) return $8104d1cc2ac2053d$var$mapIntoArray($8104d1cc2ac2053d$var$resolveThenable(children), array, escapedPrefix, nameSoFar, callback);
        array = String(children);
        throw Error("Objects are not valid as a React child (found: " + ("[object Object]" === array ? "object with keys {" + Object.keys(children).join(", ") + "}" : array) + "). If you meant to render a collection of children, use an array instead.");
    }
    return invokeCallback;
}
function $8104d1cc2ac2053d$var$mapChildren(children, func, context) {
    if (null == children) return children;
    var result = [], count = 0;
    $8104d1cc2ac2053d$var$mapIntoArray(children, result, "", "", function(child) {
        return func.call(context, child, count++);
    });
    return result;
}
function $8104d1cc2ac2053d$var$lazyInitializer(payload) {
    if (-1 === payload._status) {
        var ctor = payload._result, thenable = ctor();
        thenable.then(function(moduleObject) {
            if (0 === payload._status || -1 === payload._status) payload._status = 1, payload._result = moduleObject, void 0 === thenable.status && (thenable.status = "fulfilled", thenable.value = moduleObject);
        }, function(error) {
            if (0 === payload._status || -1 === payload._status) payload._status = 2, payload._result = error, void 0 === thenable.status && (thenable.status = "rejected", thenable.reason = error);
        });
        -1 === payload._status && (payload._status = 0, payload._result = thenable);
    }
    if (1 === payload._status) return payload._result.default;
    throw payload._result;
}
var $8104d1cc2ac2053d$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
};
function $8104d1cc2ac2053d$var$startTransition(scope) {
    var prevTransition = $8104d1cc2ac2053d$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $8104d1cc2ac2053d$var$ReactSharedInternals.T = currentTransition;
    try {
        var returnValue = scope(), onStartTransitionFinish = $8104d1cc2ac2053d$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && returnValue.then($8104d1cc2ac2053d$var$noop, $8104d1cc2ac2053d$var$reportGlobalError);
    } catch (error) {
        $8104d1cc2ac2053d$var$reportGlobalError(error);
    } finally{
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $8104d1cc2ac2053d$var$ReactSharedInternals.T = prevTransition;
    }
}
function $8104d1cc2ac2053d$var$addTransitionType(type) {
    var transition = $8104d1cc2ac2053d$var$ReactSharedInternals.T;
    if (null !== transition) {
        var transitionTypes = transition.types;
        null === transitionTypes ? transition.types = [
            type
        ] : -1 === transitionTypes.indexOf(type) && transitionTypes.push(type);
    } else $8104d1cc2ac2053d$var$startTransition($8104d1cc2ac2053d$var$addTransitionType.bind(null, type));
}
var $8104d1cc2ac2053d$var$Children = {
    map: $8104d1cc2ac2053d$var$mapChildren,
    forEach: function(children, forEachFunc, forEachContext) {
        $8104d1cc2ac2053d$var$mapChildren(children, function() {
            forEachFunc.apply(this, arguments);
        }, forEachContext);
    },
    count: function(children) {
        var n = 0;
        $8104d1cc2ac2053d$var$mapChildren(children, function() {
            n++;
        });
        return n;
    },
    toArray: function(children) {
        return $8104d1cc2ac2053d$var$mapChildren(children, function(child) {
            return child;
        }) || [];
    },
    only: function(children) {
        if (!$8104d1cc2ac2053d$var$isValidElement(children)) throw Error("React.Children.only expected to receive a single React element child.");
        return children;
    }
};
$8104d1cc2ac2053d$export$9c16c1426311996d = $8104d1cc2ac2053d$var$REACT_ACTIVITY_TYPE;
$8104d1cc2ac2053d$export$dca3b0875bd9a954 = $8104d1cc2ac2053d$var$Children;
$8104d1cc2ac2053d$export$16fa2f45be04daa8 = $8104d1cc2ac2053d$var$Component;
$8104d1cc2ac2053d$export$ffb0004e005737fa = $8104d1cc2ac2053d$var$REACT_FRAGMENT_TYPE;
$8104d1cc2ac2053d$export$e2c29f18771995cb = $8104d1cc2ac2053d$var$REACT_PROFILER_TYPE;
$8104d1cc2ac2053d$export$221d75b3f55bb0bd = $8104d1cc2ac2053d$var$PureComponent;
$8104d1cc2ac2053d$export$5f8d39834fd61797 = $8104d1cc2ac2053d$var$REACT_STRICT_MODE_TYPE;
$8104d1cc2ac2053d$export$74bf444e3cd11ea5 = $8104d1cc2ac2053d$var$REACT_SUSPENSE_TYPE;
$8104d1cc2ac2053d$export$8cdaa4703948c5e9 = $8104d1cc2ac2053d$var$REACT_VIEW_TRANSITION_TYPE;
$8104d1cc2ac2053d$export$1ced07cd6b1985ce = $8104d1cc2ac2053d$var$ReactSharedInternals;
$8104d1cc2ac2053d$export$abd8e32b826d7ea7 = {
    __proto__: null,
    c: function(size) {
        return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useMemoCache(size);
    }
};
$8104d1cc2ac2053d$export$87c99536b1b8cdd8 = $8104d1cc2ac2053d$var$addTransitionType;
$8104d1cc2ac2053d$export$69a3209f1a06c04d = function(fn) {
    return function() {
        return fn.apply(null, arguments);
    };
};
$8104d1cc2ac2053d$export$8c538325882c7eec = function() {
    return null;
};
$8104d1cc2ac2053d$export$e530037191fcd5d7 = function(element, config, children) {
    if (null === element || void 0 === element) throw Error("The argument must be a React element, but you passed " + element + ".");
    var props = $8104d1cc2ac2053d$var$assign({}, element.props), key = element.key;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)!$8104d1cc2ac2053d$var$hasOwnProperty.call(config, propName) || "key" === propName || "__self" === propName || "__source" === propName || "ref" === propName && void 0 === config.ref || (props[propName] = config[propName]);
    var propName = arguments.length - 2;
    if (1 === propName) props.children = children;
    else if (1 < propName) {
        for(var childArray = Array(propName), i = 0; i < propName; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    return $8104d1cc2ac2053d$var$ReactElement(element.type, key, props);
};
$8104d1cc2ac2053d$export$fd42f52fd3ae1109 = function(defaultValue) {
    defaultValue = {
        $$typeof: $8104d1cc2ac2053d$var$REACT_CONTEXT_TYPE,
        _currentValue: defaultValue,
        _currentValue2: defaultValue,
        _threadCount: 0,
        Provider: null,
        Consumer: null
    };
    defaultValue.Provider = defaultValue;
    defaultValue.Consumer = {
        $$typeof: $8104d1cc2ac2053d$var$REACT_CONSUMER_TYPE,
        _context: defaultValue
    };
    return defaultValue;
};
$8104d1cc2ac2053d$export$c8a8987d4410bf2d = function(type, config, children) {
    var propName, props = {}, key = null;
    if (null != config) for(propName in void 0 !== config.key && (key = "" + config.key), config)$8104d1cc2ac2053d$var$hasOwnProperty.call(config, propName) && "key" !== propName && "__self" !== propName && "__source" !== propName && (props[propName] = config[propName]);
    var childrenLength = arguments.length - 2;
    if (1 === childrenLength) props.children = children;
    else if (1 < childrenLength) {
        for(var childArray = Array(childrenLength), i = 0; i < childrenLength; i++)childArray[i] = arguments[i + 2];
        props.children = childArray;
    }
    if (type && type.defaultProps) for(propName in childrenLength = type.defaultProps, childrenLength)void 0 === props[propName] && (props[propName] = childrenLength[propName]);
    return $8104d1cc2ac2053d$var$ReactElement(type, key, props);
};
$8104d1cc2ac2053d$export$7d1e3a5e95ceca43 = function() {
    return {
        current: null
    };
};
$8104d1cc2ac2053d$export$257a8862b851cb5b = function(render) {
    return {
        $$typeof: $8104d1cc2ac2053d$var$REACT_FORWARD_REF_TYPE,
        render: render
    };
};
$8104d1cc2ac2053d$export$a8257692ac88316c = $8104d1cc2ac2053d$var$isValidElement;
$8104d1cc2ac2053d$export$488013bae63b21da = function(ctor) {
    return {
        $$typeof: $8104d1cc2ac2053d$var$REACT_LAZY_TYPE,
        _payload: {
            _status: -1,
            _result: ctor
        },
        _init: $8104d1cc2ac2053d$var$lazyInitializer
    };
};
$8104d1cc2ac2053d$export$7c73462e0d25e514 = function(type, compare) {
    return {
        $$typeof: $8104d1cc2ac2053d$var$REACT_MEMO_TYPE,
        type: type,
        compare: void 0 === compare ? null : compare
    };
};
$8104d1cc2ac2053d$export$7568632d0d33d16d = $8104d1cc2ac2053d$var$startTransition;
$8104d1cc2ac2053d$export$f93f40ac0ca7e3a8 = function() {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useCacheRefresh();
};
$8104d1cc2ac2053d$export$1f96ae73734a86cc = function(usable) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.use(usable);
};
$8104d1cc2ac2053d$export$9a47ced3238df325 = function(action, initialState, permalink) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useActionState(action, initialState, permalink);
};
$8104d1cc2ac2053d$export$35808ee640e87ca7 = function(callback, deps) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useCallback(callback, deps);
};
$8104d1cc2ac2053d$export$fae74005e78b1a27 = function(Context) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useContext(Context);
};
$8104d1cc2ac2053d$export$dc8fbce3eb94dc1e = function() {};
$8104d1cc2ac2053d$export$6a7bc4e911dc01cf = function(value, initialValue) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useDeferredValue(value, initialValue);
};
$8104d1cc2ac2053d$export$6d9c69b0de29b591 = function(create, deps) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useEffect(create, deps);
};
$8104d1cc2ac2053d$export$7f54fc3180508a52 = function(callback) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useEffectEvent(callback);
};
$8104d1cc2ac2053d$export$f680877a34711e37 = function() {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useId();
};
$8104d1cc2ac2053d$export$d5a552a76deda3c2 = function(ref, create, deps) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useImperativeHandle(ref, create, deps);
};
$8104d1cc2ac2053d$export$aaabe4eda9ed9969 = function(create, deps) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useInsertionEffect(create, deps);
};
$8104d1cc2ac2053d$export$e5c5a5f917a5871c = function(create, deps) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useLayoutEffect(create, deps);
};
$8104d1cc2ac2053d$export$1538c33de8887b59 = function(create, deps) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useMemo(create, deps);
};
$8104d1cc2ac2053d$export$fca7f784ae7a249a = function(passthrough, reducer) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useOptimistic(passthrough, reducer);
};
$8104d1cc2ac2053d$export$13e3392192263954 = function(reducer, initialArg, init) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useReducer(reducer, initialArg, init);
};
$8104d1cc2ac2053d$export$b8f5890fc79d6aca = function(initialValue) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useRef(initialValue);
};
$8104d1cc2ac2053d$export$60241385465d0a34 = function(initialState) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useState(initialState);
};
$8104d1cc2ac2053d$export$306c0aa65ff9ec16 = function(subscribe, getSnapshot, getServerSnapshot) {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useSyncExternalStore(subscribe, getSnapshot, getServerSnapshot);
};
$8104d1cc2ac2053d$export$7b286972b8d8ccbf = function() {
    return $8104d1cc2ac2053d$var$ReactSharedInternals.H.useTransition();
};
$8104d1cc2ac2053d$export$83d89fbfd8236492 = "19.3.0";

});


parcelRegister("7TJov", function(module, exports) {

$parcel$export(module.exports, "createRoot", () => $5c00e1cb1faeed50$export$882461b6382ed46c, (v) => $5c00e1cb1faeed50$export$882461b6382ed46c = v);
$parcel$export(module.exports, "hydrateRoot", () => $5c00e1cb1faeed50$export$757ceba2d55c277e, (v) => $5c00e1cb1faeed50$export$757ceba2d55c277e = v);
$parcel$export(module.exports, "version", () => $5c00e1cb1faeed50$export$83d89fbfd8236492, (v) => $5c00e1cb1faeed50$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom-client.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ /*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/ var $5c00e1cb1faeed50$export$882461b6382ed46c;
var $5c00e1cb1faeed50$export$757ceba2d55c277e;
var $5c00e1cb1faeed50$export$83d89fbfd8236492;
"use strict";

var $1wkuA = parcelRequire("1wkuA");

var $aZSru = parcelRequire("aZSru");

var $4lOAY = parcelRequire("4lOAY");
function $5c00e1cb1faeed50$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $5c00e1cb1faeed50$var$isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
}
function $5c00e1cb1faeed50$var$getNearestMountedFiber(fiber) {
    for(var node = fiber, nextNode = node; nextNode && !nextNode.alternate;)node = nextNode, 0 !== (node.flags & 4098) && (fiber = node.return), nextNode = node.return;
    for(; node.return;)node = node.return;
    return 3 === node.tag ? fiber : null;
}
function $5c00e1cb1faeed50$var$getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
}
function $5c00e1cb1faeed50$var$getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
    }
    return null;
}
function $5c00e1cb1faeed50$var$assertIsMounted(fiber) {
    if ($5c00e1cb1faeed50$var$getNearestMountedFiber(fiber) !== fiber) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(188));
}
function $5c00e1cb1faeed50$var$findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
        alternate = $5c00e1cb1faeed50$var$getNearestMountedFiber(fiber);
        if (null === alternate) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(188));
        return alternate !== fiber ? null : fiber;
    }
    for(var a = fiber, b = alternate;;){
        var parentA = a.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
            b = parentA.return;
            if (null !== b) {
                a = b;
                continue;
            }
            break;
        }
        if (parentA.child === parentB.child) {
            for(parentB = parentA.child; parentB;){
                if (parentB === a) return $5c00e1cb1faeed50$var$assertIsMounted(parentA), fiber;
                if (parentB === b) return $5c00e1cb1faeed50$var$assertIsMounted(parentA), alternate;
                parentB = parentB.sibling;
            }
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(188));
        }
        if (a.return !== b.return) a = parentA, b = parentB;
        else {
            for(var didFindChild = !1, child$0 = parentA.child; child$0;){
                if (child$0 === a) {
                    didFindChild = !0;
                    a = parentA;
                    b = parentB;
                    break;
                }
                if (child$0 === b) {
                    didFindChild = !0;
                    b = parentA;
                    a = parentB;
                    break;
                }
                child$0 = child$0.sibling;
            }
            if (!didFindChild) {
                for(child$0 = parentB.child; child$0;){
                    if (child$0 === a) {
                        didFindChild = !0;
                        a = parentB;
                        b = parentA;
                        break;
                    }
                    if (child$0 === b) {
                        didFindChild = !0;
                        b = parentB;
                        a = parentA;
                        break;
                    }
                    child$0 = child$0.sibling;
                }
                if (!didFindChild) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(189));
            }
        }
        if (a.alternate !== b) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(190));
    }
    if (3 !== a.tag) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(188));
    return a.stateNode.current === a ? fiber : alternate;
}
function $5c00e1cb1faeed50$var$findCurrentHostFiberImpl(node) {
    var tag = node.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return node;
    for(node = node.child; null !== node;){
        tag = $5c00e1cb1faeed50$var$findCurrentHostFiberImpl(node);
        if (null !== tag) return tag;
        node = node.sibling;
    }
    return null;
}
function $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(child, searchWithinHosts, fn, a, b, c) {
    for(; null !== child;){
        if ((5 === child.tag || 27 === child.tag || 6 === child.tag) && fn(child, a, b, c) || (22 !== child.tag || null === child.memoizedState) && (searchWithinHosts || 5 !== child.tag && 27 !== child.tag) && $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(child.child, searchWithinHosts, fn, a, b, c)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(fiber) {
    for(fiber = fiber.return; null !== fiber;){
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) return fiber;
        fiber = fiber.return;
    }
    return null;
}
function $5c00e1cb1faeed50$var$fiberIsPortaledIntoHost(fiber) {
    var foundPortalParent = !1;
    for(fiber = fiber.return; null !== fiber;){
        4 === fiber.tag && (foundPortalParent = !0);
        if (3 === fiber.tag || 5 === fiber.tag || 27 === fiber.tag) break;
        fiber = fiber.return;
    }
    return foundPortalParent;
}
function $5c00e1cb1faeed50$var$getFragmentInstanceOrTextInstanceSiblings(fiber) {
    var result = [
        null,
        null
    ], parentHostFiber = $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(fiber);
    if (null === parentHostFiber) return result;
    $5c00e1cb1faeed50$var$findFragmentInstanceOrTextInstanceSiblings(result, fiber, parentHostFiber.child, {
        foundSelf: !1
    });
    return result;
}
function $5c00e1cb1faeed50$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child, state) {
    for(; null !== child;){
        if (child === self) state.foundSelf = !0;
        else if (5 === child.tag || 27 === child.tag || 6 === child.tag) {
            if (state.foundSelf) return result[1] = child, !0;
            result[0] = child;
        } else if ((22 !== child.tag || null === child.memoizedState) && $5c00e1cb1faeed50$var$findFragmentInstanceOrTextInstanceSiblings(result, self, child.child, state)) return !0;
        child = child.sibling;
    }
    return !1;
}
function $5c00e1cb1faeed50$var$getInstanceFromHostFiber(fiber) {
    switch(fiber.tag){
        case 5:
        case 27:
        case 6:
            return fiber.stateNode;
        case 3:
            return fiber.stateNode.containerInfo;
        default:
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(559));
    }
}
var $5c00e1cb1faeed50$var$searchTarget = null, $5c00e1cb1faeed50$var$searchBoundary = null;
function $5c00e1cb1faeed50$var$isFiberPrecedingCheck(child, target, boundary) {
    return child === boundary ? !0 : child === target ? ($5c00e1cb1faeed50$var$searchTarget = child, !0) : !1;
}
function $5c00e1cb1faeed50$var$isFiberFollowingCheck(child, target, boundary) {
    return child === boundary ? ($5c00e1cb1faeed50$var$searchBoundary = child, !1) : child === target ? (null !== $5c00e1cb1faeed50$var$searchBoundary && ($5c00e1cb1faeed50$var$searchTarget = child), !0) : !1;
}
function $5c00e1cb1faeed50$var$getParentForFragmentAncestors(inst) {
    if (null === inst) return null;
    do inst = null === inst ? null : inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag && 3 !== inst.tag);
    return inst ? inst : null;
}
function $5c00e1cb1faeed50$var$getLowestCommonAncestor(instA, instB, getParent) {
    for(var depthA = 0, tempA = instA; tempA; tempA = getParent(tempA))depthA++;
    tempA = 0;
    for(var tempB = instB; tempB; tempB = getParent(tempB))tempA++;
    for(; 0 < depthA - tempA;)instA = getParent(instA), depthA--;
    for(; 0 < tempA - depthA;)instB = getParent(instB), tempA--;
    for(; depthA--;){
        if (instA === instB || null !== instB && instA === instB.alternate) return instA;
        instA = getParent(instA);
        instB = getParent(instB);
    }
    return null;
}
var $5c00e1cb1faeed50$var$assign = Object.assign, $5c00e1cb1faeed50$var$REACT_LEGACY_ELEMENT_TYPE = Symbol.for("react.element"), $5c00e1cb1faeed50$var$REACT_ELEMENT_TYPE = Symbol.for("react.transitional.element"), $5c00e1cb1faeed50$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE = Symbol.for("react.fragment"), $5c00e1cb1faeed50$var$REACT_STRICT_MODE_TYPE = Symbol.for("react.strict_mode"), $5c00e1cb1faeed50$var$REACT_PROFILER_TYPE = Symbol.for("react.profiler"), $5c00e1cb1faeed50$var$REACT_CONSUMER_TYPE = Symbol.for("react.consumer"), $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE = Symbol.for("react.context"), $5c00e1cb1faeed50$var$REACT_FORWARD_REF_TYPE = Symbol.for("react.forward_ref"), $5c00e1cb1faeed50$var$REACT_SUSPENSE_TYPE = Symbol.for("react.suspense"), $5c00e1cb1faeed50$var$REACT_SUSPENSE_LIST_TYPE = Symbol.for("react.suspense_list"), $5c00e1cb1faeed50$var$REACT_MEMO_TYPE = Symbol.for("react.memo"), $5c00e1cb1faeed50$var$REACT_LAZY_TYPE = Symbol.for("react.lazy");
Symbol.for("react.scope");
var $5c00e1cb1faeed50$var$REACT_ACTIVITY_TYPE = Symbol.for("react.activity"), $5c00e1cb1faeed50$var$REACT_LEGACY_HIDDEN_TYPE = Symbol.for("react.legacy_hidden");
Symbol.for("react.tracing_marker");
var $5c00e1cb1faeed50$var$REACT_MEMO_CACHE_SENTINEL = Symbol.for("react.memo_cache_sentinel"), $5c00e1cb1faeed50$var$REACT_VIEW_TRANSITION_TYPE = Symbol.for("react.view_transition"), $5c00e1cb1faeed50$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $5c00e1cb1faeed50$var$MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
function $5c00e1cb1faeed50$var$getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = $5c00e1cb1faeed50$var$MAYBE_ITERATOR_SYMBOL && maybeIterable[$5c00e1cb1faeed50$var$MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
}
var $5c00e1cb1faeed50$var$REACT_CLIENT_REFERENCE = Symbol.for("react.client.reference");
function $5c00e1cb1faeed50$var$getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type) return type.$$typeof === $5c00e1cb1faeed50$var$REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch(type){
        case $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE:
            return "Fragment";
        case $5c00e1cb1faeed50$var$REACT_PROFILER_TYPE:
            return "Profiler";
        case $5c00e1cb1faeed50$var$REACT_STRICT_MODE_TYPE:
            return "StrictMode";
        case $5c00e1cb1faeed50$var$REACT_SUSPENSE_TYPE:
            return "Suspense";
        case $5c00e1cb1faeed50$var$REACT_SUSPENSE_LIST_TYPE:
            return "SuspenseList";
        case $5c00e1cb1faeed50$var$REACT_ACTIVITY_TYPE:
            return "Activity";
        case $5c00e1cb1faeed50$var$REACT_VIEW_TRANSITION_TYPE:
            return "ViewTransition";
    }
    if ("object" === typeof type) switch(type.$$typeof){
        case $5c00e1cb1faeed50$var$REACT_PORTAL_TYPE:
            return "Portal";
        case $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
        case $5c00e1cb1faeed50$var$REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
        case $5c00e1cb1faeed50$var$REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
        case $5c00e1cb1faeed50$var$REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : $5c00e1cb1faeed50$var$getComponentNameFromType(type.type) || "Memo";
        case $5c00e1cb1faeed50$var$REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
                return $5c00e1cb1faeed50$var$getComponentNameFromType(type(innerType));
            } catch (x) {}
    }
    return null;
}
var $5c00e1cb1faeed50$var$isArrayImpl = Array.isArray, $5c00e1cb1faeed50$var$ReactSharedInternals = $aZSru.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $5c00e1cb1faeed50$var$ReactDOMSharedInternals = $4lOAY.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, $5c00e1cb1faeed50$var$sharedNotPendingObject = {
    pending: !1,
    data: null,
    method: null,
    action: null
}, $5c00e1cb1faeed50$var$valueStack = [], $5c00e1cb1faeed50$var$index = -1;
function $5c00e1cb1faeed50$var$createCursor(defaultValue) {
    return {
        current: defaultValue
    };
}
function $5c00e1cb1faeed50$var$pop(cursor) {
    0 > $5c00e1cb1faeed50$var$index || (cursor.current = $5c00e1cb1faeed50$var$valueStack[$5c00e1cb1faeed50$var$index], $5c00e1cb1faeed50$var$valueStack[$5c00e1cb1faeed50$var$index] = null, $5c00e1cb1faeed50$var$index--);
}
function $5c00e1cb1faeed50$var$push(cursor, value) {
    $5c00e1cb1faeed50$var$index++;
    $5c00e1cb1faeed50$var$valueStack[$5c00e1cb1faeed50$var$index] = cursor.current;
    cursor.current = value;
}
var $5c00e1cb1faeed50$var$contextStackCursor = $5c00e1cb1faeed50$var$createCursor(null), $5c00e1cb1faeed50$var$contextFiberStackCursor = $5c00e1cb1faeed50$var$createCursor(null), $5c00e1cb1faeed50$var$rootInstanceStackCursor = $5c00e1cb1faeed50$var$createCursor(null), $5c00e1cb1faeed50$var$hostTransitionProviderCursor = $5c00e1cb1faeed50$var$createCursor(null);
function $5c00e1cb1faeed50$var$pushHostContainer(fiber, nextRootInstance) {
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$rootInstanceStackCursor, nextRootInstance);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$contextFiberStackCursor, fiber);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$contextStackCursor, null);
    switch(nextRootInstance.nodeType){
        case 9:
        case 11:
            fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? $5c00e1cb1faeed50$var$getOwnHostContext(fiber) : 0 : 0;
            break;
        default:
            if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI) nextRootInstance = $5c00e1cb1faeed50$var$getOwnHostContext(nextRootInstance), fiber = $5c00e1cb1faeed50$var$getChildHostContextProd(nextRootInstance, fiber);
            else switch(fiber){
                case "svg":
                    fiber = 1;
                    break;
                case "math":
                    fiber = 2;
                    break;
                default:
                    fiber = 0;
            }
    }
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$contextStackCursor);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$contextStackCursor, fiber);
}
function $5c00e1cb1faeed50$var$popHostContainer() {
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$contextStackCursor);
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$contextFiberStackCursor);
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$rootInstanceStackCursor);
}
function $5c00e1cb1faeed50$var$pushHostContext(fiber) {
    var stateHook = fiber.memoizedState;
    null !== stateHook && ($5c00e1cb1faeed50$var$HostTransitionContext._currentValue = stateHook.memoizedState, $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$hostTransitionProviderCursor, fiber));
    stateHook = $5c00e1cb1faeed50$var$contextStackCursor.current;
    var JSCompiler_inline_result = $5c00e1cb1faeed50$var$getChildHostContextProd(stateHook, fiber.type);
    stateHook !== JSCompiler_inline_result && ($5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$contextFiberStackCursor, fiber), $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$contextStackCursor, JSCompiler_inline_result));
}
function $5c00e1cb1faeed50$var$popHostContext(fiber) {
    $5c00e1cb1faeed50$var$contextFiberStackCursor.current === fiber && ($5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$contextStackCursor), $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$contextFiberStackCursor));
    $5c00e1cb1faeed50$var$hostTransitionProviderCursor.current === fiber && ($5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$hostTransitionProviderCursor), $5c00e1cb1faeed50$var$HostTransitionContext._currentValue = $5c00e1cb1faeed50$var$sharedNotPendingObject);
}
var $5c00e1cb1faeed50$var$prefix, $5c00e1cb1faeed50$var$suffix;
function $5c00e1cb1faeed50$var$describeBuiltInComponentFrame(name) {
    if (void 0 === $5c00e1cb1faeed50$var$prefix) try {
        throw Error();
    } catch (x) {
        var match = x.stack.trim().match(/\n( *(at )?)/);
        $5c00e1cb1faeed50$var$prefix = match && match[1] || "";
        $5c00e1cb1faeed50$var$suffix = -1 < x.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x.stack.indexOf("@") ? "@unknown:0:0" : "";
    }
    return "\n" + $5c00e1cb1faeed50$var$prefix + name + $5c00e1cb1faeed50$var$suffix;
}
var $5c00e1cb1faeed50$var$reentry = !1;
function $5c00e1cb1faeed50$var$describeNativeComponentFrame(fn, construct) {
    if (!fn || $5c00e1cb1faeed50$var$reentry) return "";
    $5c00e1cb1faeed50$var$reentry = !0;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
        var RunInRootFrame = {
            DetermineComponentFrameRoot: function() {
                try {
                    if (construct) {
                        var Fake = function() {
                            throw Error();
                        };
                        Object.defineProperty(Fake.prototype, "props", {
                            set: function() {
                                throw Error();
                            }
                        });
                        if ("object" === typeof Reflect && Reflect.construct) {
                            try {
                                Reflect.construct(Fake, []);
                            } catch (x) {
                                var control = x;
                            }
                            Reflect.construct(fn, [], Fake);
                        } else {
                            try {
                                Fake.call();
                            } catch (x$1) {
                                control = x$1;
                            }
                            Fake = !1;
                            try {
                                var prevProps = Object.getOwnPropertyDescriptor(fn.prototype, "props");
                                Object.defineProperty(fn.prototype, "props", {
                                    configurable: !0,
                                    set: function() {
                                        throw Error();
                                    }
                                });
                                Fake = !0;
                                new fn();
                            } finally{
                                Fake && (void 0 !== prevProps ? Object.defineProperty(fn.prototype, "props", prevProps) : delete fn.prototype.props);
                            }
                        }
                    } else {
                        try {
                            throw Error();
                        } catch (x$2) {
                            control = x$2;
                        }
                        (Fake = fn()) && "function" === typeof Fake.catch && Fake.catch(function() {});
                    }
                } catch (sample) {
                    if (sample && control && "string" === typeof sample.stack) return [
                        sample.stack,
                        control.stack
                    ];
                }
                return [
                    null,
                    null
                ];
            }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(RunInRootFrame.DetermineComponentFrameRoot, "name");
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(RunInRootFrame.DetermineComponentFrameRoot, "name", {
            value: "DetermineComponentFrameRoot"
        });
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
            var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
            for(namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot");)RunInRootFrame++;
            for(; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes("DetermineComponentFrameRoot");)namePropDescriptor++;
            if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length) for(RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor];)namePropDescriptor--;
            for(; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
                    do if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                        var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                        fn.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn.displayName));
                        return frame;
                    }
                    while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
                }
                break;
            }
        }
    } finally{
        $5c00e1cb1faeed50$var$reentry = !1, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn ? fn.displayName || fn.name : "") ? $5c00e1cb1faeed50$var$describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
}
function $5c00e1cb1faeed50$var$describeFiber(fiber, childFiber) {
    switch(fiber.tag){
        case 26:
        case 27:
        case 5:
            return $5c00e1cb1faeed50$var$describeBuiltInComponentFrame(fiber.type);
        case 16:
            return $5c00e1cb1faeed50$var$describeBuiltInComponentFrame("Lazy");
        case 13:
            return fiber.child !== childFiber && null !== childFiber ? $5c00e1cb1faeed50$var$describeBuiltInComponentFrame("Suspense Fallback") : $5c00e1cb1faeed50$var$describeBuiltInComponentFrame("Suspense");
        case 19:
            return $5c00e1cb1faeed50$var$describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
            return $5c00e1cb1faeed50$var$describeNativeComponentFrame(fiber.type, !1);
        case 11:
            return $5c00e1cb1faeed50$var$describeNativeComponentFrame(fiber.type.render, !1);
        case 1:
            return $5c00e1cb1faeed50$var$describeNativeComponentFrame(fiber.type, !0);
        case 31:
            return $5c00e1cb1faeed50$var$describeBuiltInComponentFrame("Activity");
        case 30:
            return $5c00e1cb1faeed50$var$describeBuiltInComponentFrame("ViewTransition");
        default:
            return "";
    }
}
function $5c00e1cb1faeed50$var$getStackByFiberInDevAndProd(workInProgress) {
    try {
        var info = "", previous = null;
        do info += $5c00e1cb1faeed50$var$describeFiber(workInProgress, previous), previous = workInProgress, workInProgress = workInProgress.return;
        while (workInProgress);
        return info;
    } catch (x) {
        return "\nError generating stack: " + x.message + "\n" + x.stack;
    }
}
var $5c00e1cb1faeed50$var$hasOwnProperty = Object.prototype.hasOwnProperty, $5c00e1cb1faeed50$var$scheduleCallback$3 = $1wkuA.unstable_scheduleCallback, $5c00e1cb1faeed50$var$cancelCallback$1 = $1wkuA.unstable_cancelCallback, $5c00e1cb1faeed50$var$shouldYield = $1wkuA.unstable_shouldYield, $5c00e1cb1faeed50$var$requestPaint = $1wkuA.unstable_requestPaint, $5c00e1cb1faeed50$var$now = $1wkuA.unstable_now, $5c00e1cb1faeed50$var$getCurrentPriorityLevel = $1wkuA.unstable_getCurrentPriorityLevel, $5c00e1cb1faeed50$var$ImmediatePriority = $1wkuA.unstable_ImmediatePriority, $5c00e1cb1faeed50$var$UserBlockingPriority = $1wkuA.unstable_UserBlockingPriority, $5c00e1cb1faeed50$var$NormalPriority$1 = $1wkuA.unstable_NormalPriority, $5c00e1cb1faeed50$var$LowPriority = $1wkuA.unstable_LowPriority, $5c00e1cb1faeed50$var$IdlePriority = $1wkuA.unstable_IdlePriority, $5c00e1cb1faeed50$var$log$1 = $1wkuA.log, $5c00e1cb1faeed50$var$unstable_setDisableYieldValue = $1wkuA.unstable_setDisableYieldValue, $5c00e1cb1faeed50$var$rendererID = null, $5c00e1cb1faeed50$var$injectedHook = null;
function $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof $5c00e1cb1faeed50$var$log$1 && $5c00e1cb1faeed50$var$unstable_setDisableYieldValue(newIsStrictMode);
    if ($5c00e1cb1faeed50$var$injectedHook && "function" === typeof $5c00e1cb1faeed50$var$injectedHook.setStrictMode) try {
        $5c00e1cb1faeed50$var$injectedHook.setStrictMode($5c00e1cb1faeed50$var$rendererID, newIsStrictMode);
    } catch (err) {}
}
var $5c00e1cb1faeed50$var$clz32 = Math.clz32 ? Math.clz32 : $5c00e1cb1faeed50$var$clz32Fallback, $5c00e1cb1faeed50$var$log = Math.log, $5c00e1cb1faeed50$var$LN2 = Math.LN2;
function $5c00e1cb1faeed50$var$clz32Fallback(x) {
    x >>>= 0;
    return 0 === x ? 32 : 31 - ($5c00e1cb1faeed50$var$log(x) / $5c00e1cb1faeed50$var$LN2 | 0) | 0;
}
var $5c00e1cb1faeed50$var$nextTransitionUpdateLane = 256, $5c00e1cb1faeed50$var$nextTransitionDeferredLane = 262144, $5c00e1cb1faeed50$var$nextRetryLane = 4194304;
function $5c00e1cb1faeed50$var$getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch(lanes & -lanes){
        case 1:
            return 1;
        case 2:
            return 2;
        case 4:
            return 4;
        case 8:
            return 8;
        case 16:
            return 16;
        case 32:
            return 32;
        case 64:
            return 64;
        case 128:
            return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
            return lanes & -lanes;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return lanes & 62914560;
        case 67108864:
            return 67108864;
        case 134217728:
            return 134217728;
        case 268435456:
            return 268435456;
        case 536870912:
            return 536870912;
        case 1073741824:
            return 0;
        default:
            return lanes;
    }
}
function $5c00e1cb1faeed50$var$getNextLanes(root, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes;
    root = root.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root, 0 !== rootHasPendingCommit && (nextLanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
}
function $5c00e1cb1faeed50$var$checkIfRootIsPrerendering(root, renderLanes) {
    return 0 === (root.pendingLanes & ~(root.suspendedLanes & ~root.pingedLanes) & renderLanes);
}
function $5c00e1cb1faeed50$var$getEntangledLanes(root, renderLanes) {
    0 !== (renderLanes & 8) && (renderLanes |= renderLanes & 32);
    var allEntangledLanes = root.entangledLanes;
    if (0 !== allEntangledLanes) for(root = root.entanglements, allEntangledLanes &= renderLanes; 0 < allEntangledLanes;){
        var index$4 = 31 - $5c00e1cb1faeed50$var$clz32(allEntangledLanes), lane = 1 << index$4;
        renderLanes |= root[index$4];
        allEntangledLanes &= ~lane;
    }
    return renderLanes;
}
function $5c00e1cb1faeed50$var$computeExpirationTime(lane, currentTime) {
    switch(lane){
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
            return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
            return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
            return -1;
        default:
            return -1;
    }
}
function $5c00e1cb1faeed50$var$claimNextRetryLane() {
    var lane = $5c00e1cb1faeed50$var$nextRetryLane;
    $5c00e1cb1faeed50$var$nextRetryLane <<= 1;
    0 === ($5c00e1cb1faeed50$var$nextRetryLane & 62914560) && ($5c00e1cb1faeed50$var$nextRetryLane = 4194304);
    return lane;
}
function $5c00e1cb1faeed50$var$createLaneMap(initial) {
    for(var laneMap = [], i = 0; 31 > i; i++)laneMap.push(initial);
    return laneMap;
}
function $5c00e1cb1faeed50$var$markRootUpdated$1(root, updateLane) {
    root.pendingLanes |= updateLane;
    268435456 !== updateLane && (root.suspendedLanes = 0, root.pingedLanes = 0, root.warmLanes = 0);
}
function $5c00e1cb1faeed50$var$markRootFinished(root, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root.pendingLanes;
    root.pendingLanes = remainingLanes;
    root.suspendedLanes = 0;
    root.pingedLanes = 0;
    root.warmLanes = 0;
    root.expiredLanes &= remainingLanes;
    root.entangledLanes &= remainingLanes;
    root.errorRecoveryDisabledLanes &= remainingLanes;
    root.shellSuspendCounter = 0;
    var entanglements = root.entanglements, expirationTimes = root.expirationTimes, hiddenUpdates = root.hiddenUpdates;
    for(remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes;){
        var index$7 = 31 - $5c00e1cb1faeed50$var$clz32(remainingLanes), lane = 1 << index$7;
        entanglements[index$7] = 0;
        expirationTimes[index$7] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index$7];
        if (null !== hiddenUpdatesForLane) for(hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++){
            var update = hiddenUpdatesForLane[index$7];
            null !== update && (update.lane &= -536870913);
        }
        remainingLanes &= ~lane;
    }
    0 !== spawnedLane && $5c00e1cb1faeed50$var$markSpawnedDeferredLane(root, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root.tag && (root.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
}
function $5c00e1cb1faeed50$var$markSpawnedDeferredLane(root, spawnedLane, entangledLanes) {
    root.pendingLanes |= spawnedLane;
    root.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - $5c00e1cb1faeed50$var$clz32(spawnedLane);
    root.entangledLanes |= spawnedLane;
    root.entanglements[spawnedLaneIndex] = root.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
}
function $5c00e1cb1faeed50$var$markRootEntangled(root, entangledLanes) {
    var rootEntangledLanes = root.entangledLanes |= entangledLanes;
    for(root = root.entanglements; rootEntangledLanes;){
        var index$8 = 31 - $5c00e1cb1faeed50$var$clz32(rootEntangledLanes), lane = 1 << index$8;
        lane & entangledLanes | root[index$8] & entangledLanes && (root[index$8] |= entangledLanes);
        rootEntangledLanes &= ~lane;
    }
}
function $5c00e1cb1faeed50$var$getBumpedLaneForHydration(root, renderLanes) {
    var renderLane = renderLanes & -renderLanes;
    renderLane = 0 !== (renderLane & 42) ? 1 : $5c00e1cb1faeed50$var$getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root.suspendedLanes | renderLanes)) ? 0 : renderLane;
}
function $5c00e1cb1faeed50$var$getBumpedLaneForHydrationByLane(lane) {
    switch(lane){
        case 2:
            lane = 1;
            break;
        case 8:
            lane = 4;
            break;
        case 32:
            lane = 16;
            break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
            lane = 128;
            break;
        case 268435456:
            lane = 134217728;
            break;
        default:
            lane = 0;
    }
    return lane;
}
function $5c00e1cb1faeed50$var$lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
}
function $5c00e1cb1faeed50$var$resolveUpdatePriority() {
    var updatePriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : $5c00e1cb1faeed50$var$getEventPriority(updatePriority.type);
}
function $5c00e1cb1faeed50$var$runWithPriority(priority, fn) {
    var previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
    try {
        return $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = priority, fn();
    } finally{
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority;
    }
}
var $5c00e1cb1faeed50$var$randomKey = Math.random().toString(36).slice(2), $5c00e1cb1faeed50$var$internalInstanceKey = "__reactFiber$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalPropsKey = "__reactProps$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalContainerInstanceKey = "__reactContainer$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalEventHandlersKey = "__reactEvents$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalEventHandlerListenersKey = "__reactListeners$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalEventHandlesSetKey = "__reactHandles$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalRootNodeResourcesKey = "__reactResources$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalHoistableMarker = "__reactMarker$" + $5c00e1cb1faeed50$var$randomKey, $5c00e1cb1faeed50$var$internalLoadPendingKey = "__reactLoad$" + $5c00e1cb1faeed50$var$randomKey;
function $5c00e1cb1faeed50$var$detachDeletedInstance(node) {
    delete node[$5c00e1cb1faeed50$var$internalInstanceKey];
    delete node[$5c00e1cb1faeed50$var$internalPropsKey];
    delete node[$5c00e1cb1faeed50$var$internalEventHandlerListenersKey];
    delete node[$5c00e1cb1faeed50$var$internalEventHandlesSetKey];
}
function $5c00e1cb1faeed50$var$getClosestInstanceFromNode(targetNode) {
    var targetInst;
    if (targetInst = targetNode[$5c00e1cb1faeed50$var$internalInstanceKey]) return targetInst;
    for(var parentNode = targetNode.parentNode; parentNode;){
        if (targetInst = parentNode[$5c00e1cb1faeed50$var$internalContainerInstanceKey] || parentNode[$5c00e1cb1faeed50$var$internalInstanceKey]) {
            parentNode = targetInst.alternate;
            if (null !== targetInst.child || null !== parentNode && null !== parentNode.child) for(targetNode = $5c00e1cb1faeed50$var$getParentHydrationBoundary(targetNode); null !== targetNode;){
                if (parentNode = targetNode[$5c00e1cb1faeed50$var$internalInstanceKey]) return parentNode;
                targetNode = $5c00e1cb1faeed50$var$getParentHydrationBoundary(targetNode);
            }
            return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
    }
    return null;
}
function $5c00e1cb1faeed50$var$getInstanceFromNode(node) {
    if (node = node[$5c00e1cb1faeed50$var$internalInstanceKey] || node[$5c00e1cb1faeed50$var$internalContainerInstanceKey]) {
        var tag = node.tag;
        if (5 === tag || 6 === tag || 13 === tag || 31 === tag || 26 === tag || 27 === tag || 3 === tag) return node;
    }
    return null;
}
function $5c00e1cb1faeed50$var$getNodeFromInstance(inst) {
    var tag = inst.tag;
    if (5 === tag || 26 === tag || 27 === tag || 6 === tag) return inst.stateNode;
    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(33));
}
function $5c00e1cb1faeed50$var$getResourcesFromRoot(root) {
    var resources = root[$5c00e1cb1faeed50$var$internalRootNodeResourcesKey];
    resources || (resources = root[$5c00e1cb1faeed50$var$internalRootNodeResourcesKey] = {
        hoistableStyles: new Map(),
        hoistableScripts: new Map()
    });
    return resources;
}
function $5c00e1cb1faeed50$var$markNodeAsHoistable(node) {
    node[$5c00e1cb1faeed50$var$internalHoistableMarker] = !0;
}
function $5c00e1cb1faeed50$var$clearPendingLoadOnNode(node) {
    node[$5c00e1cb1faeed50$var$internalLoadPendingKey] = void 0;
}
var $5c00e1cb1faeed50$var$allNativeEvents = new Set(), $5c00e1cb1faeed50$var$registrationNameDependencies = {};
function $5c00e1cb1faeed50$var$registerTwoPhaseEvent(registrationName, dependencies) {
    $5c00e1cb1faeed50$var$registerDirectEvent(registrationName, dependencies);
    $5c00e1cb1faeed50$var$registerDirectEvent(registrationName + "Capture", dependencies);
}
function $5c00e1cb1faeed50$var$registerDirectEvent(registrationName, dependencies) {
    $5c00e1cb1faeed50$var$registrationNameDependencies[registrationName] = dependencies;
    for(registrationName = 0; registrationName < dependencies.length; registrationName++)$5c00e1cb1faeed50$var$allNativeEvents.add(dependencies[registrationName]);
}
var $5c00e1cb1faeed50$var$VALID_ATTRIBUTE_NAME_REGEX = RegExp("^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"), $5c00e1cb1faeed50$var$illegalAttributeNameCache = {}, $5c00e1cb1faeed50$var$validatedAttributeNameCache = {};
function $5c00e1cb1faeed50$var$isAttributeNameSafe(attributeName) {
    if ($5c00e1cb1faeed50$var$hasOwnProperty.call($5c00e1cb1faeed50$var$validatedAttributeNameCache, attributeName)) return !0;
    if ($5c00e1cb1faeed50$var$hasOwnProperty.call($5c00e1cb1faeed50$var$illegalAttributeNameCache, attributeName)) return !1;
    if ($5c00e1cb1faeed50$var$VALID_ATTRIBUTE_NAME_REGEX.test(attributeName)) return $5c00e1cb1faeed50$var$validatedAttributeNameCache[attributeName] = !0;
    $5c00e1cb1faeed50$var$illegalAttributeNameCache[attributeName] = !0;
    return !1;
}
var $5c00e1cb1faeed50$var$viewTransitionMutationContext = !1;
function $5c00e1cb1faeed50$var$pushMutationContext() {
    var prev = $5c00e1cb1faeed50$var$viewTransitionMutationContext;
    $5c00e1cb1faeed50$var$viewTransitionMutationContext = !1;
    return prev;
}
function $5c00e1cb1faeed50$var$setValueForAttribute(node, name, value) {
    if ($5c00e1cb1faeed50$var$isAttributeNameSafe(name)) {
        if (null === value) node.removeAttribute(name);
        else {
            switch(typeof value){
                case "undefined":
                case "function":
                case "symbol":
                    node.removeAttribute(name);
                    return;
                case "boolean":
                    var prefix$10 = name.toLowerCase().slice(0, 5);
                    if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
                        node.removeAttribute(name);
                        return;
                    }
            }
            node.setAttribute(name, value);
        }
    }
}
function $5c00e1cb1faeed50$var$setValueForKnownAttribute(node, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttribute(name, value);
    }
}
function $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(node, namespace, name, value) {
    if (null === value) node.removeAttribute(name);
    else {
        switch(typeof value){
            case "undefined":
            case "function":
            case "symbol":
            case "boolean":
                node.removeAttribute(name);
                return;
        }
        node.setAttributeNS(namespace, name, value);
    }
}
function $5c00e1cb1faeed50$var$getToStringValue(value) {
    switch(typeof value){
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
            return value;
        case "object":
            return value;
        default:
            return "";
    }
}
function $5c00e1cb1faeed50$var$isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
}
function $5c00e1cb1faeed50$var$trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(node.constructor.prototype, valueField);
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get = descriptor.get, set = descriptor.set;
        Object.defineProperty(node, valueField, {
            configurable: !0,
            get: function() {
                return get.call(this);
            },
            set: function(value) {
                currentValue = "" + value;
                set.call(this, value);
            }
        });
        Object.defineProperty(node, valueField, {
            enumerable: descriptor.enumerable
        });
        return {
            getValue: function() {
                return currentValue;
            },
            setValue: function(value) {
                currentValue = "" + value;
            },
            stopTracking: function() {
                node._valueTracker = null;
                delete node[valueField];
            }
        };
    }
}
function $5c00e1cb1faeed50$var$track(node) {
    if (!node._valueTracker) {
        var valueField = $5c00e1cb1faeed50$var$isCheckable(node) ? "checked" : "value";
        node._valueTracker = $5c00e1cb1faeed50$var$trackValueOnNode(node, valueField, "" + node[valueField]);
    }
}
function $5c00e1cb1faeed50$var$updateValueIfChanged(node) {
    if (!node) return !1;
    var tracker = node._valueTracker;
    if (!tracker) return !0;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = $5c00e1cb1faeed50$var$isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), !0) : !1;
}
var $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
function $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace($5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotesRegex, function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
    });
}
function $5c00e1cb1faeed50$var$updateInput(element, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name) {
    element.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element.type = type : element.removeAttribute("type");
    if (null != value) {
        if ("number" === type) {
            if (0 === value && "" === element.value || element.value != value) element.value = "" + $5c00e1cb1faeed50$var$getToStringValue(value);
        } else element.value !== "" + $5c00e1cb1faeed50$var$getToStringValue(value) && (element.value = "" + $5c00e1cb1faeed50$var$getToStringValue(value));
    } else "submit" !== type && "reset" !== type || element.removeAttribute("value");
    null != value ? "number" === type && element.value == value ? $5c00e1cb1faeed50$var$setDefaultValue(element, $5c00e1cb1faeed50$var$getToStringValue(element.value)) : $5c00e1cb1faeed50$var$setDefaultValue(element, $5c00e1cb1faeed50$var$getToStringValue(value)) : null != defaultValue ? $5c00e1cb1faeed50$var$setDefaultValue(element, $5c00e1cb1faeed50$var$getToStringValue(defaultValue)) : null != lastDefaultValue && element.removeAttribute("value");
    null == checked && null != defaultChecked && (element.defaultChecked = !!defaultChecked);
    null != checked && (element.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name ? element.name = "" + $5c00e1cb1faeed50$var$getToStringValue(name) : element.removeAttribute("name");
}
function $5c00e1cb1faeed50$var$initInput(element, value, defaultValue, checked, defaultChecked, type, name, isHydrating) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element.type = type);
    if (null != value || null != defaultValue) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
            $5c00e1cb1faeed50$var$track(element);
            return;
        }
        defaultValue = null != defaultValue ? "" + $5c00e1cb1faeed50$var$getToStringValue(defaultValue) : "";
        value = null != value ? "" + $5c00e1cb1faeed50$var$getToStringValue(value) : defaultValue;
        isHydrating || value === element.value || (element.value = value);
        element.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element.checked = isHydrating ? element.checked : !!checked;
    element.defaultChecked = !!checked;
    null != name && "function" !== typeof name && "symbol" !== typeof name && "boolean" !== typeof name && (element.name = name);
    $5c00e1cb1faeed50$var$track(element);
}
function $5c00e1cb1faeed50$var$setDefaultValue(node, value) {
    node.defaultValue !== "" + value && (node.defaultValue = "" + value);
}
function $5c00e1cb1faeed50$var$updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
        multiple = {};
        for(var i = 0; i < propValue.length; i++)multiple["$" + propValue[i]] = !0;
        for(propValue = 0; propValue < node.length; propValue++)i = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i && (node[propValue].selected = i), i && setDefaultSelected && (node[propValue].defaultSelected = !0);
    } else {
        propValue = "" + $5c00e1cb1faeed50$var$getToStringValue(propValue);
        multiple = null;
        for(i = 0; i < node.length; i++){
            if (node[i].value === propValue) {
                node[i].selected = !0;
                setDefaultSelected && (node[i].defaultSelected = !0);
                return;
            }
            null !== multiple || node[i].disabled || (multiple = node[i]);
        }
        null !== multiple && (multiple.selected = !0);
    }
}
function $5c00e1cb1faeed50$var$updateTextarea(element, value, defaultValue) {
    if (null != value && (value = "" + $5c00e1cb1faeed50$var$getToStringValue(value), value !== element.value && (element.value = value), null == defaultValue)) {
        element.defaultValue !== value && (element.defaultValue = value);
        return;
    }
    element.defaultValue = null != defaultValue ? "" + $5c00e1cb1faeed50$var$getToStringValue(defaultValue) : "";
}
function $5c00e1cb1faeed50$var$initTextarea(element, value, defaultValue, children) {
    if (null == value) {
        if (null != children) {
            if (null != defaultValue) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(92));
            if ($5c00e1cb1faeed50$var$isArrayImpl(children)) {
                if (1 < children.length) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(93));
                children = children[0];
            }
            defaultValue = children;
        }
        null == defaultValue && (defaultValue = "");
        value = defaultValue;
    }
    defaultValue = $5c00e1cb1faeed50$var$getToStringValue(value);
    element.defaultValue = defaultValue;
    children = element.textContent;
    children === defaultValue && "" !== children && null !== children && (element.value = children);
    $5c00e1cb1faeed50$var$track(element);
}
function $5c00e1cb1faeed50$var$setTextContent(node, text) {
    if (text) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
            firstChild.nodeValue = text;
            return;
        }
    }
    node.textContent = text;
}
var $5c00e1cb1faeed50$var$unitlessNumbers = new Set("animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(" "));
function $5c00e1cb1faeed50$var$setValueForStyle(style, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style.setProperty(styleName, "") : "float" === styleName ? style.cssFloat = "" : style[styleName] = "" : isCustomProperty ? style.setProperty(styleName, value) : "number" !== typeof value || 0 === value || $5c00e1cb1faeed50$var$unitlessNumbers.has(styleName) ? "float" === styleName ? style.cssFloat = value : style[styleName] = ("" + value).trim() : style[styleName] = value + "px";
}
function $5c00e1cb1faeed50$var$setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(62));
    node = node.style;
    if (null != prevStyles) {
        for(var styleName in prevStyles)!prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "", $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
        for(var styleName$16 in styles)styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && ($5c00e1cb1faeed50$var$setValueForStyle(node, styleName$16, styleName), $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
    } else for(var styleName$17 in styles)styles.hasOwnProperty(styleName$17) && $5c00e1cb1faeed50$var$setValueForStyle(node, styleName$17, styles[styleName$17]);
}
function $5c00e1cb1faeed50$var$isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return !1;
    switch(tagName){
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
            return !1;
        default:
            return !0;
    }
}
var $5c00e1cb1faeed50$var$aliases = new Map([
    [
        "acceptCharset",
        "accept-charset"
    ],
    [
        "htmlFor",
        "for"
    ],
    [
        "httpEquiv",
        "http-equiv"
    ],
    [
        "crossOrigin",
        "crossorigin"
    ],
    [
        "accentHeight",
        "accent-height"
    ],
    [
        "alignmentBaseline",
        "alignment-baseline"
    ],
    [
        "arabicForm",
        "arabic-form"
    ],
    [
        "baselineShift",
        "baseline-shift"
    ],
    [
        "capHeight",
        "cap-height"
    ],
    [
        "clipPath",
        "clip-path"
    ],
    [
        "clipRule",
        "clip-rule"
    ],
    [
        "colorInterpolation",
        "color-interpolation"
    ],
    [
        "colorInterpolationFilters",
        "color-interpolation-filters"
    ],
    [
        "colorProfile",
        "color-profile"
    ],
    [
        "colorRendering",
        "color-rendering"
    ],
    [
        "dominantBaseline",
        "dominant-baseline"
    ],
    [
        "enableBackground",
        "enable-background"
    ],
    [
        "fillOpacity",
        "fill-opacity"
    ],
    [
        "fillRule",
        "fill-rule"
    ],
    [
        "floodColor",
        "flood-color"
    ],
    [
        "floodOpacity",
        "flood-opacity"
    ],
    [
        "fontFamily",
        "font-family"
    ],
    [
        "fontSize",
        "font-size"
    ],
    [
        "fontSizeAdjust",
        "font-size-adjust"
    ],
    [
        "fontStretch",
        "font-stretch"
    ],
    [
        "fontStyle",
        "font-style"
    ],
    [
        "fontVariant",
        "font-variant"
    ],
    [
        "fontWeight",
        "font-weight"
    ],
    [
        "glyphName",
        "glyph-name"
    ],
    [
        "glyphOrientationHorizontal",
        "glyph-orientation-horizontal"
    ],
    [
        "glyphOrientationVertical",
        "glyph-orientation-vertical"
    ],
    [
        "horizAdvX",
        "horiz-adv-x"
    ],
    [
        "horizOriginX",
        "horiz-origin-x"
    ],
    [
        "imageRendering",
        "image-rendering"
    ],
    [
        "letterSpacing",
        "letter-spacing"
    ],
    [
        "lightingColor",
        "lighting-color"
    ],
    [
        "markerEnd",
        "marker-end"
    ],
    [
        "markerMid",
        "marker-mid"
    ],
    [
        "markerStart",
        "marker-start"
    ],
    [
        "maskType",
        "mask-type"
    ],
    [
        "overlinePosition",
        "overline-position"
    ],
    [
        "overlineThickness",
        "overline-thickness"
    ],
    [
        "paintOrder",
        "paint-order"
    ],
    [
        "panose-1",
        "panose-1"
    ],
    [
        "pointerEvents",
        "pointer-events"
    ],
    [
        "renderingIntent",
        "rendering-intent"
    ],
    [
        "shapeRendering",
        "shape-rendering"
    ],
    [
        "stopColor",
        "stop-color"
    ],
    [
        "stopOpacity",
        "stop-opacity"
    ],
    [
        "strikethroughPosition",
        "strikethrough-position"
    ],
    [
        "strikethroughThickness",
        "strikethrough-thickness"
    ],
    [
        "strokeDasharray",
        "stroke-dasharray"
    ],
    [
        "strokeDashoffset",
        "stroke-dashoffset"
    ],
    [
        "strokeLinecap",
        "stroke-linecap"
    ],
    [
        "strokeLinejoin",
        "stroke-linejoin"
    ],
    [
        "strokeMiterlimit",
        "stroke-miterlimit"
    ],
    [
        "strokeOpacity",
        "stroke-opacity"
    ],
    [
        "strokeWidth",
        "stroke-width"
    ],
    [
        "textAnchor",
        "text-anchor"
    ],
    [
        "textDecoration",
        "text-decoration"
    ],
    [
        "textRendering",
        "text-rendering"
    ],
    [
        "transformOrigin",
        "transform-origin"
    ],
    [
        "underlinePosition",
        "underline-position"
    ],
    [
        "underlineThickness",
        "underline-thickness"
    ],
    [
        "unicodeBidi",
        "unicode-bidi"
    ],
    [
        "unicodeRange",
        "unicode-range"
    ],
    [
        "unitsPerEm",
        "units-per-em"
    ],
    [
        "vAlphabetic",
        "v-alphabetic"
    ],
    [
        "vHanging",
        "v-hanging"
    ],
    [
        "vIdeographic",
        "v-ideographic"
    ],
    [
        "vMathematical",
        "v-mathematical"
    ],
    [
        "vectorEffect",
        "vector-effect"
    ],
    [
        "vertAdvY",
        "vert-adv-y"
    ],
    [
        "vertOriginX",
        "vert-origin-x"
    ],
    [
        "vertOriginY",
        "vert-origin-y"
    ],
    [
        "wordSpacing",
        "word-spacing"
    ],
    [
        "writingMode",
        "writing-mode"
    ],
    [
        "xmlnsXlink",
        "xmlns:xlink"
    ],
    [
        "xHeight",
        "x-height"
    ]
]), $5c00e1cb1faeed50$var$isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
function $5c00e1cb1faeed50$var$sanitizeURL(url) {
    return $5c00e1cb1faeed50$var$isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
}
function $5c00e1cb1faeed50$var$noop$1() {}
var $5c00e1cb1faeed50$var$currentReplayingEvent = null;
function $5c00e1cb1faeed50$var$getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
}
var $5c00e1cb1faeed50$var$restoreTarget = null, $5c00e1cb1faeed50$var$restoreQueue = null;
function $5c00e1cb1faeed50$var$restoreStateOfTarget(target) {
    var internalInstance = $5c00e1cb1faeed50$var$getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
        var props = target[$5c00e1cb1faeed50$var$internalPropsKey] || null;
        a: switch(target = internalInstance.stateNode, internalInstance.type){
            case "input":
                $5c00e1cb1faeed50$var$updateInput(target, props.value, props.defaultValue, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name);
                internalInstance = props.name;
                if ("radio" === props.type && null != internalInstance) {
                    for(props = target; props.parentNode;)props = props.parentNode;
                    props = props.querySelectorAll('input[name="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes("" + internalInstance) + '"][type="radio"]');
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++){
                        var otherNode = props[internalInstance];
                        if (otherNode !== target && otherNode.form === target.form) {
                            var otherProps = otherNode[$5c00e1cb1faeed50$var$internalPropsKey] || null;
                            if (!otherProps) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(90));
                            $5c00e1cb1faeed50$var$updateInput(otherNode, otherProps.value, otherProps.defaultValue, otherProps.defaultValue, otherProps.checked, otherProps.defaultChecked, otherProps.type, otherProps.name);
                        }
                    }
                    for(internalInstance = 0; internalInstance < props.length; internalInstance++)otherNode = props[internalInstance], otherNode.form === target.form && $5c00e1cb1faeed50$var$updateValueIfChanged(otherNode);
                }
                break a;
            case "textarea":
                $5c00e1cb1faeed50$var$updateTextarea(target, props.value, props.defaultValue);
                break a;
            case "select":
                internalInstance = props.value, null != internalInstance && $5c00e1cb1faeed50$var$updateOptions(target, !!props.multiple, internalInstance, !1);
        }
    }
}
var $5c00e1cb1faeed50$var$isInsideEventHandler = !1;
function $5c00e1cb1faeed50$var$batchedUpdates$1(fn, a, b) {
    if ($5c00e1cb1faeed50$var$isInsideEventHandler) return fn(a, b);
    $5c00e1cb1faeed50$var$isInsideEventHandler = !0;
    try {
        var JSCompiler_inline_result = fn(a);
        return JSCompiler_inline_result;
    } finally{
        if ($5c00e1cb1faeed50$var$isInsideEventHandler = !1, null !== $5c00e1cb1faeed50$var$restoreTarget || null !== $5c00e1cb1faeed50$var$restoreQueue) {
            if ($5c00e1cb1faeed50$var$flushSyncWork$1(), $5c00e1cb1faeed50$var$restoreTarget && (a = $5c00e1cb1faeed50$var$restoreTarget, fn = $5c00e1cb1faeed50$var$restoreQueue, $5c00e1cb1faeed50$var$restoreQueue = $5c00e1cb1faeed50$var$restoreTarget = null, $5c00e1cb1faeed50$var$restoreStateOfTarget(a), fn)) for(a = 0; a < fn.length; a++)$5c00e1cb1faeed50$var$restoreStateOfTarget(fn[a]);
        }
    }
}
function $5c00e1cb1faeed50$var$getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props = stateNode[$5c00e1cb1faeed50$var$internalPropsKey] || null;
    if (null === props) return null;
    stateNode = props[registrationName];
    a: switch(registrationName){
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
            (props = !props.disabled) || (inst = inst.type, props = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
            inst = !props;
            break a;
        default:
            inst = !1;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(231, registrationName, typeof stateNode));
    return stateNode;
}
var $5c00e1cb1faeed50$var$canUseDOM = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), $5c00e1cb1faeed50$var$passiveBrowserEventsSupported = !1;
if ($5c00e1cb1faeed50$var$canUseDOM) try {
    var $5c00e1cb1faeed50$var$options = {};
    Object.defineProperty($5c00e1cb1faeed50$var$options, "passive", {
        get: function() {
            $5c00e1cb1faeed50$var$passiveBrowserEventsSupported = !0;
        }
    });
    window.addEventListener("test", $5c00e1cb1faeed50$var$options, $5c00e1cb1faeed50$var$options);
    window.removeEventListener("test", $5c00e1cb1faeed50$var$options, $5c00e1cb1faeed50$var$options);
} catch (e) {
    $5c00e1cb1faeed50$var$passiveBrowserEventsSupported = !1;
}
var $5c00e1cb1faeed50$var$root = null, $5c00e1cb1faeed50$var$startText = null, $5c00e1cb1faeed50$var$fallbackText = null;
function $5c00e1cb1faeed50$var$getData() {
    if ($5c00e1cb1faeed50$var$fallbackText) return $5c00e1cb1faeed50$var$fallbackText;
    var start, startValue = $5c00e1cb1faeed50$var$startText, startLength = startValue.length, end, endValue = "value" in $5c00e1cb1faeed50$var$root ? $5c00e1cb1faeed50$var$root.value : $5c00e1cb1faeed50$var$root.textContent, endLength = endValue.length;
    for(start = 0; start < startLength && startValue[start] === endValue[start]; start++);
    var minEnd = startLength - start;
    for(end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++);
    return $5c00e1cb1faeed50$var$fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
}
function $5c00e1cb1faeed50$var$getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
}
function $5c00e1cb1faeed50$var$functionThatReturnsTrue() {
    return !0;
}
function $5c00e1cb1faeed50$var$functionThatReturnsFalse() {
    return !1;
}
function $5c00e1cb1faeed50$var$createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for(var propName in Interface)Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : !1 === nativeEvent.returnValue) ? $5c00e1cb1faeed50$var$functionThatReturnsTrue : $5c00e1cb1faeed50$var$functionThatReturnsFalse;
        this.isPropagationStopped = $5c00e1cb1faeed50$var$functionThatReturnsFalse;
        return this;
    }
    $5c00e1cb1faeed50$var$assign(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
            this.defaultPrevented = !0;
            var event = this.nativeEvent;
            event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = !1), this.isDefaultPrevented = $5c00e1cb1faeed50$var$functionThatReturnsTrue);
        },
        stopPropagation: function() {
            var event = this.nativeEvent;
            event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = !0), this.isPropagationStopped = $5c00e1cb1faeed50$var$functionThatReturnsTrue);
        },
        persist: function() {},
        isPersistent: $5c00e1cb1faeed50$var$functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
}
var $5c00e1cb1faeed50$var$EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
        return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
}, $5c00e1cb1faeed50$var$SyntheticEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$EventInterface), $5c00e1cb1faeed50$var$UIEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    view: 0,
    detail: 0
}), $5c00e1cb1faeed50$var$SyntheticUIEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$UIEventInterface), $5c00e1cb1faeed50$var$lastMovementX, $5c00e1cb1faeed50$var$lastMovementY, $5c00e1cb1faeed50$var$lastMouseEvent, $5c00e1cb1faeed50$var$MouseEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: $5c00e1cb1faeed50$var$getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== $5c00e1cb1faeed50$var$lastMouseEvent && ($5c00e1cb1faeed50$var$lastMouseEvent && "mousemove" === event.type ? ($5c00e1cb1faeed50$var$lastMovementX = event.screenX - $5c00e1cb1faeed50$var$lastMouseEvent.screenX, $5c00e1cb1faeed50$var$lastMovementY = event.screenY - $5c00e1cb1faeed50$var$lastMouseEvent.screenY) : $5c00e1cb1faeed50$var$lastMovementY = $5c00e1cb1faeed50$var$lastMovementX = 0, $5c00e1cb1faeed50$var$lastMouseEvent = event);
        return $5c00e1cb1faeed50$var$lastMovementX;
    },
    movementY: function(event) {
        return "movementY" in event ? event.movementY : $5c00e1cb1faeed50$var$lastMovementY;
    }
}), $5c00e1cb1faeed50$var$SyntheticMouseEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$MouseEventInterface), $5c00e1cb1faeed50$var$DragEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$MouseEventInterface, {
    dataTransfer: 0
}), $5c00e1cb1faeed50$var$SyntheticDragEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$DragEventInterface), $5c00e1cb1faeed50$var$FocusEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$UIEventInterface, {
    relatedTarget: 0
}), $5c00e1cb1faeed50$var$SyntheticFocusEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$FocusEventInterface), $5c00e1cb1faeed50$var$AnimationEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5c00e1cb1faeed50$var$SyntheticAnimationEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$AnimationEventInterface), $5c00e1cb1faeed50$var$ClipboardEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
}), $5c00e1cb1faeed50$var$SyntheticClipboardEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$ClipboardEventInterface), $5c00e1cb1faeed50$var$CompositionEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    data: 0
}), $5c00e1cb1faeed50$var$SyntheticCompositionEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$CompositionEventInterface), $5c00e1cb1faeed50$var$normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
}, $5c00e1cb1faeed50$var$translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
}, $5c00e1cb1faeed50$var$modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
};
function $5c00e1cb1faeed50$var$modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = $5c00e1cb1faeed50$var$modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : !1;
}
function $5c00e1cb1faeed50$var$getEventModifierState() {
    return $5c00e1cb1faeed50$var$modifierStateGetter;
}
var $5c00e1cb1faeed50$var$KeyboardEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$UIEventInterface, {
    key: function(nativeEvent) {
        if (nativeEvent.key) {
            var key = $5c00e1cb1faeed50$var$normalizeKey[nativeEvent.key] || nativeEvent.key;
            if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = $5c00e1cb1faeed50$var$getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? $5c00e1cb1faeed50$var$translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: $5c00e1cb1faeed50$var$getEventModifierState,
    charCode: function(event) {
        return "keypress" === event.type ? $5c00e1cb1faeed50$var$getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
        return "keypress" === event.type ? $5c00e1cb1faeed50$var$getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
}), $5c00e1cb1faeed50$var$SyntheticKeyboardEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$KeyboardEventInterface), $5c00e1cb1faeed50$var$PointerEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
}), $5c00e1cb1faeed50$var$SyntheticPointerEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$PointerEventInterface), $5c00e1cb1faeed50$var$SubmitEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    submitter: 0
}), $5c00e1cb1faeed50$var$SyntheticSubmitEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$SubmitEventInterface), $5c00e1cb1faeed50$var$TouchEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: $5c00e1cb1faeed50$var$getEventModifierState
}), $5c00e1cb1faeed50$var$SyntheticTouchEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$TouchEventInterface), $5c00e1cb1faeed50$var$TransitionEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
}), $5c00e1cb1faeed50$var$SyntheticTransitionEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$TransitionEventInterface), $5c00e1cb1faeed50$var$WheelEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$MouseEventInterface, {
    deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
}), $5c00e1cb1faeed50$var$SyntheticWheelEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$WheelEventInterface), $5c00e1cb1faeed50$var$ToggleEventInterface = $5c00e1cb1faeed50$var$assign({}, $5c00e1cb1faeed50$var$EventInterface, {
    newState: 0,
    oldState: 0,
    source: 0
}), $5c00e1cb1faeed50$var$SyntheticToggleEvent = $5c00e1cb1faeed50$var$createSyntheticEvent($5c00e1cb1faeed50$var$ToggleEventInterface), $5c00e1cb1faeed50$var$END_KEYCODES = [
    9,
    13,
    27,
    32
], $5c00e1cb1faeed50$var$canUseCompositionEvent = $5c00e1cb1faeed50$var$canUseDOM && "CompositionEvent" in window, $5c00e1cb1faeed50$var$documentMode = null;
$5c00e1cb1faeed50$var$canUseDOM && "documentMode" in document && ($5c00e1cb1faeed50$var$documentMode = document.documentMode);
var $5c00e1cb1faeed50$var$canUseTextInputEvent = $5c00e1cb1faeed50$var$canUseDOM && "TextEvent" in window && !$5c00e1cb1faeed50$var$documentMode, $5c00e1cb1faeed50$var$useFallbackCompositionData = $5c00e1cb1faeed50$var$canUseDOM && (!$5c00e1cb1faeed50$var$canUseCompositionEvent || $5c00e1cb1faeed50$var$documentMode && 8 < $5c00e1cb1faeed50$var$documentMode && 11 >= $5c00e1cb1faeed50$var$documentMode), $5c00e1cb1faeed50$var$SPACEBAR_CHAR = String.fromCharCode(32), $5c00e1cb1faeed50$var$hasSpaceKeypress = !1;
function $5c00e1cb1faeed50$var$isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch(domEventName){
        case "keyup":
            return -1 !== $5c00e1cb1faeed50$var$END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
            return 229 !== nativeEvent.keyCode;
        case "keypress":
        case "mousedown":
        case "focusout":
            return !0;
        default:
            return !1;
    }
}
function $5c00e1cb1faeed50$var$getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
}
var $5c00e1cb1faeed50$var$isComposing = !1;
function $5c00e1cb1faeed50$var$getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch(domEventName){
        case "compositionend":
            return $5c00e1cb1faeed50$var$getDataFromCustomEvent(nativeEvent);
        case "keypress":
            if (32 !== nativeEvent.which) return null;
            $5c00e1cb1faeed50$var$hasSpaceKeypress = !0;
            return $5c00e1cb1faeed50$var$SPACEBAR_CHAR;
        case "textInput":
            return domEventName = nativeEvent.data, domEventName === $5c00e1cb1faeed50$var$SPACEBAR_CHAR && $5c00e1cb1faeed50$var$hasSpaceKeypress ? null : domEventName;
        default:
            return null;
    }
}
function $5c00e1cb1faeed50$var$getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if ($5c00e1cb1faeed50$var$isComposing) return "compositionend" === domEventName || !$5c00e1cb1faeed50$var$canUseCompositionEvent && $5c00e1cb1faeed50$var$isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = $5c00e1cb1faeed50$var$getData(), $5c00e1cb1faeed50$var$fallbackText = $5c00e1cb1faeed50$var$startText = $5c00e1cb1faeed50$var$root = null, $5c00e1cb1faeed50$var$isComposing = !1, domEventName) : null;
    switch(domEventName){
        case "paste":
            return null;
        case "keypress":
            if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
                if (nativeEvent.char && 1 < nativeEvent.char.length) return nativeEvent.char;
                if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
            }
            return null;
        case "compositionend":
            return $5c00e1cb1faeed50$var$useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
            return null;
    }
}
var $5c00e1cb1faeed50$var$supportedInputTypes = {
    color: !0,
    date: !0,
    datetime: !0,
    "datetime-local": !0,
    email: !0,
    month: !0,
    number: !0,
    password: !0,
    range: !0,
    search: !0,
    tel: !0,
    text: !0,
    time: !0,
    url: !0,
    week: !0
};
function $5c00e1cb1faeed50$var$isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!$5c00e1cb1faeed50$var$supportedInputTypes[elem.type] : "textarea" === nodeName ? !0 : !1;
}
function $5c00e1cb1faeed50$var$createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    $5c00e1cb1faeed50$var$restoreTarget ? $5c00e1cb1faeed50$var$restoreQueue ? $5c00e1cb1faeed50$var$restoreQueue.push(target) : $5c00e1cb1faeed50$var$restoreQueue = [
        target
    ] : $5c00e1cb1faeed50$var$restoreTarget = target;
    inst = $5c00e1cb1faeed50$var$accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new $5c00e1cb1faeed50$var$SyntheticEvent("onChange", "change", null, nativeEvent, target), dispatchQueue.push({
        event: nativeEvent,
        listeners: inst
    }));
}
var $5c00e1cb1faeed50$var$activeElement$1 = null, $5c00e1cb1faeed50$var$activeElementInst$1 = null;
function $5c00e1cb1faeed50$var$runEventInBatch(dispatchQueue) {
    $5c00e1cb1faeed50$var$processDispatchQueue(dispatchQueue, 0);
}
function $5c00e1cb1faeed50$var$getInstIfValueChanged(targetInst) {
    var targetNode = $5c00e1cb1faeed50$var$getNodeFromInstance(targetInst);
    if ($5c00e1cb1faeed50$var$updateValueIfChanged(targetNode)) return targetInst;
}
function $5c00e1cb1faeed50$var$getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
}
var $5c00e1cb1faeed50$var$isInputEventSupported = !1;
if ($5c00e1cb1faeed50$var$canUseDOM) {
    var $5c00e1cb1faeed50$var$JSCompiler_inline_result$jscomp$318;
    if ($5c00e1cb1faeed50$var$canUseDOM) {
        var $5c00e1cb1faeed50$var$isSupported$jscomp$inline_474 = "oninput" in document;
        if (!$5c00e1cb1faeed50$var$isSupported$jscomp$inline_474) {
            var $5c00e1cb1faeed50$var$element$jscomp$inline_475 = document.createElement("div");
            $5c00e1cb1faeed50$var$element$jscomp$inline_475.setAttribute("oninput", "return;");
            $5c00e1cb1faeed50$var$isSupported$jscomp$inline_474 = "function" === typeof $5c00e1cb1faeed50$var$element$jscomp$inline_475.oninput;
        }
        $5c00e1cb1faeed50$var$JSCompiler_inline_result$jscomp$318 = $5c00e1cb1faeed50$var$isSupported$jscomp$inline_474;
    } else $5c00e1cb1faeed50$var$JSCompiler_inline_result$jscomp$318 = !1;
    $5c00e1cb1faeed50$var$isInputEventSupported = $5c00e1cb1faeed50$var$JSCompiler_inline_result$jscomp$318 && (!document.documentMode || 9 < document.documentMode);
}
function $5c00e1cb1faeed50$var$stopWatchingForValueChange() {
    $5c00e1cb1faeed50$var$activeElement$1 && ($5c00e1cb1faeed50$var$activeElement$1.detachEvent("onpropertychange", $5c00e1cb1faeed50$var$handlePropertyChange), $5c00e1cb1faeed50$var$activeElementInst$1 = $5c00e1cb1faeed50$var$activeElement$1 = null);
}
function $5c00e1cb1faeed50$var$handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && $5c00e1cb1faeed50$var$getInstIfValueChanged($5c00e1cb1faeed50$var$activeElementInst$1)) {
        var dispatchQueue = [];
        $5c00e1cb1faeed50$var$createAndAccumulateChangeEvent(dispatchQueue, $5c00e1cb1faeed50$var$activeElementInst$1, nativeEvent, $5c00e1cb1faeed50$var$getEventTarget(nativeEvent));
        $5c00e1cb1faeed50$var$batchedUpdates$1($5c00e1cb1faeed50$var$runEventInBatch, dispatchQueue);
    }
}
function $5c00e1cb1faeed50$var$handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? ($5c00e1cb1faeed50$var$stopWatchingForValueChange(), $5c00e1cb1faeed50$var$activeElement$1 = target, $5c00e1cb1faeed50$var$activeElementInst$1 = targetInst, $5c00e1cb1faeed50$var$activeElement$1.attachEvent("onpropertychange", $5c00e1cb1faeed50$var$handlePropertyChange)) : "focusout" === domEventName && $5c00e1cb1faeed50$var$stopWatchingForValueChange();
}
function $5c00e1cb1faeed50$var$getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName) return $5c00e1cb1faeed50$var$getInstIfValueChanged($5c00e1cb1faeed50$var$activeElementInst$1);
}
function $5c00e1cb1faeed50$var$getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return $5c00e1cb1faeed50$var$getInstIfValueChanged(targetInst);
}
function $5c00e1cb1faeed50$var$getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName) return $5c00e1cb1faeed50$var$getInstIfValueChanged(targetInst);
}
function $5c00e1cb1faeed50$var$is(x, y) {
    return x === y && (0 !== x || 1 / x === 1 / y) || x !== x && y !== y;
}
var $5c00e1cb1faeed50$var$objectIs = "function" === typeof Object.is ? Object.is : $5c00e1cb1faeed50$var$is;
function $5c00e1cb1faeed50$var$shallowEqual(objA, objB) {
    if ($5c00e1cb1faeed50$var$objectIs(objA, objB)) return !0;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB) return !1;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return !1;
    for(keysB = 0; keysB < keysA.length; keysB++){
        var currentKey = keysA[keysB];
        if (!$5c00e1cb1faeed50$var$hasOwnProperty.call(objB, currentKey) || !$5c00e1cb1faeed50$var$objectIs(objA[currentKey], objB[currentKey])) return !1;
    }
    return !0;
}
function $5c00e1cb1faeed50$var$getActiveElement(doc) {
    doc = doc || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc) return null;
    try {
        return doc.activeElement || doc.body;
    } catch (e$20) {
        return doc.body;
    }
}
function $5c00e1cb1faeed50$var$getLeafNode(node) {
    for(; node && node.firstChild;)node = node.firstChild;
    return node;
}
function $5c00e1cb1faeed50$var$getNodeForCharacterOffset(root, offset) {
    var node = $5c00e1cb1faeed50$var$getLeafNode(root);
    root = 0;
    for(var nodeEnd; node;){
        if (3 === node.nodeType) {
            nodeEnd = root + node.textContent.length;
            if (root <= offset && nodeEnd >= offset) return {
                node: node,
                offset: offset - root
            };
            root = nodeEnd;
        }
        a: {
            for(; node;){
                if (node.nextSibling) {
                    node = node.nextSibling;
                    break a;
                }
                node = node.parentNode;
            }
            node = void 0;
        }
        node = $5c00e1cb1faeed50$var$getLeafNode(node);
    }
}
function $5c00e1cb1faeed50$var$containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? !0 : outerNode && 3 === outerNode.nodeType ? !1 : innerNode && 3 === innerNode.nodeType ? $5c00e1cb1faeed50$var$containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : !1 : !1;
}
function $5c00e1cb1faeed50$var$getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for(var element = $5c00e1cb1faeed50$var$getActiveElement(containerInfo.document); element instanceof containerInfo.HTMLIFrameElement;){
        try {
            var JSCompiler_inline_result = "string" === typeof element.contentWindow.location.href;
        } catch (err) {
            JSCompiler_inline_result = !1;
        }
        if (JSCompiler_inline_result) containerInfo = element.contentWindow;
        else break;
        element = $5c00e1cb1faeed50$var$getActiveElement(containerInfo.document);
    }
    return element;
}
function $5c00e1cb1faeed50$var$hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
}
var $5c00e1cb1faeed50$var$skipSelectionChangeEvent = $5c00e1cb1faeed50$var$canUseDOM && "documentMode" in document && 11 >= document.documentMode, $5c00e1cb1faeed50$var$activeElement = null, $5c00e1cb1faeed50$var$activeElementInst = null, $5c00e1cb1faeed50$var$lastSelection = null, $5c00e1cb1faeed50$var$mouseDown = !1;
function $5c00e1cb1faeed50$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    $5c00e1cb1faeed50$var$mouseDown || null == $5c00e1cb1faeed50$var$activeElement || $5c00e1cb1faeed50$var$activeElement !== $5c00e1cb1faeed50$var$getActiveElement(doc) || (doc = $5c00e1cb1faeed50$var$activeElement, "selectionStart" in doc && $5c00e1cb1faeed50$var$hasSelectionCapabilities(doc) ? doc = {
        start: doc.selectionStart,
        end: doc.selectionEnd
    } : (doc = (doc.ownerDocument && doc.ownerDocument.defaultView || window).getSelection(), doc = {
        anchorNode: doc.anchorNode,
        anchorOffset: doc.anchorOffset,
        focusNode: doc.focusNode,
        focusOffset: doc.focusOffset
    }), $5c00e1cb1faeed50$var$lastSelection && $5c00e1cb1faeed50$var$shallowEqual($5c00e1cb1faeed50$var$lastSelection, doc) || ($5c00e1cb1faeed50$var$lastSelection = doc, doc = $5c00e1cb1faeed50$var$accumulateTwoPhaseListeners($5c00e1cb1faeed50$var$activeElementInst, "onSelect"), 0 < doc.length && (nativeEvent = new $5c00e1cb1faeed50$var$SyntheticEvent("onSelect", "select", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
        event: nativeEvent,
        listeners: doc
    }), nativeEvent.target = $5c00e1cb1faeed50$var$activeElement)));
}
function $5c00e1cb1faeed50$var$makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
}
var $5c00e1cb1faeed50$var$vendorPrefixes = {
    animationend: $5c00e1cb1faeed50$var$makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: $5c00e1cb1faeed50$var$makePrefixMap("Animation", "AnimationIteration"),
    animationstart: $5c00e1cb1faeed50$var$makePrefixMap("Animation", "AnimationStart"),
    transitionrun: $5c00e1cb1faeed50$var$makePrefixMap("Transition", "TransitionRun"),
    transitionstart: $5c00e1cb1faeed50$var$makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: $5c00e1cb1faeed50$var$makePrefixMap("Transition", "TransitionCancel"),
    transitionend: $5c00e1cb1faeed50$var$makePrefixMap("Transition", "TransitionEnd")
}, $5c00e1cb1faeed50$var$prefixedEventNames = {}, $5c00e1cb1faeed50$var$style = {};
$5c00e1cb1faeed50$var$canUseDOM && ($5c00e1cb1faeed50$var$style = document.createElement("div").style, "AnimationEvent" in window || (delete $5c00e1cb1faeed50$var$vendorPrefixes.animationend.animation, delete $5c00e1cb1faeed50$var$vendorPrefixes.animationiteration.animation, delete $5c00e1cb1faeed50$var$vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete $5c00e1cb1faeed50$var$vendorPrefixes.transitionend.transition);
function $5c00e1cb1faeed50$var$getVendorPrefixedEventName(eventName) {
    if ($5c00e1cb1faeed50$var$prefixedEventNames[eventName]) return $5c00e1cb1faeed50$var$prefixedEventNames[eventName];
    if (!$5c00e1cb1faeed50$var$vendorPrefixes[eventName]) return eventName;
    var prefixMap = $5c00e1cb1faeed50$var$vendorPrefixes[eventName], styleProp;
    for(styleProp in prefixMap)if (prefixMap.hasOwnProperty(styleProp) && styleProp in $5c00e1cb1faeed50$var$style) return $5c00e1cb1faeed50$var$prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
}
var $5c00e1cb1faeed50$var$ANIMATION_END = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("animationend"), $5c00e1cb1faeed50$var$ANIMATION_ITERATION = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("animationiteration"), $5c00e1cb1faeed50$var$ANIMATION_START = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("animationstart"), $5c00e1cb1faeed50$var$TRANSITION_RUN = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("transitionrun"), $5c00e1cb1faeed50$var$TRANSITION_START = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("transitionstart"), $5c00e1cb1faeed50$var$TRANSITION_CANCEL = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("transitioncancel"), $5c00e1cb1faeed50$var$TRANSITION_END = $5c00e1cb1faeed50$var$getVendorPrefixedEventName("transitionend"), $5c00e1cb1faeed50$var$topLevelEventsToReactNames = new Map(), $5c00e1cb1faeed50$var$simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error fullscreenChange fullscreenError gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(" ");
$5c00e1cb1faeed50$var$simpleEventPluginEvents.push("scrollEnd");
function $5c00e1cb1faeed50$var$registerSimpleEvent(domEventName, reactName) {
    $5c00e1cb1faeed50$var$topLevelEventsToReactNames.set(domEventName, reactName);
    $5c00e1cb1faeed50$var$registerTwoPhaseEvent(reactName, [
        domEventName
    ]);
}
var $5c00e1cb1faeed50$var$globalClientIdCounter$1 = 0;
function $5c00e1cb1faeed50$var$getViewTransitionName(props, instance) {
    if (null != props.name && "auto" !== props.name) return props.name;
    if (null !== instance.autoName) return instance.autoName;
    props = $5c00e1cb1faeed50$var$pendingEffectsRoot.identifierPrefix;
    var globalClientId = $5c00e1cb1faeed50$var$globalClientIdCounter$1++;
    props = "_" + props + "t_" + globalClientId.toString(32) + "_";
    return instance.autoName = props;
}
function $5c00e1cb1faeed50$var$getClassNameByType(classByType) {
    if (null == classByType || "string" === typeof classByType) return classByType;
    var className = null, activeTypes = $5c00e1cb1faeed50$var$pendingTransitionTypes;
    if (null !== activeTypes) for(var i = 0; i < activeTypes.length; i++){
        var match = classByType[activeTypes[i]];
        if (null != match) {
            if ("none" === match) return "none";
            className = null == className ? match : className + (" " + match);
        }
    }
    return null == className ? classByType.default : className;
}
function $5c00e1cb1faeed50$var$getViewTransitionClassName(defaultClass, eventClass) {
    defaultClass = $5c00e1cb1faeed50$var$getClassNameByType(defaultClass);
    eventClass = $5c00e1cb1faeed50$var$getClassNameByType(eventClass);
    return null == eventClass ? "auto" === defaultClass ? null : defaultClass : "auto" === eventClass ? null : eventClass;
}
var $5c00e1cb1faeed50$var$reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
            bubbles: !0,
            cancelable: !0,
            message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
            error: error
        });
        if (!window.dispatchEvent(event)) return;
    }
    console.error(error);
}, $5c00e1cb1faeed50$var$concurrentQueues = [], $5c00e1cb1faeed50$var$concurrentQueuesIndex = 0, $5c00e1cb1faeed50$var$concurrentlyUpdatedLanes = 0;
function $5c00e1cb1faeed50$var$finishQueueingConcurrentUpdates() {
    for(var endIndex = $5c00e1cb1faeed50$var$concurrentQueuesIndex, i = $5c00e1cb1faeed50$var$concurrentlyUpdatedLanes = $5c00e1cb1faeed50$var$concurrentQueuesIndex = 0; i < endIndex;){
        var fiber = $5c00e1cb1faeed50$var$concurrentQueues[i];
        $5c00e1cb1faeed50$var$concurrentQueues[i++] = null;
        var queue = $5c00e1cb1faeed50$var$concurrentQueues[i];
        $5c00e1cb1faeed50$var$concurrentQueues[i++] = null;
        var update = $5c00e1cb1faeed50$var$concurrentQueues[i];
        $5c00e1cb1faeed50$var$concurrentQueues[i++] = null;
        var lane = $5c00e1cb1faeed50$var$concurrentQueues[i];
        $5c00e1cb1faeed50$var$concurrentQueues[i++] = null;
        if (null !== queue && null !== update) {
            var pending = queue.pending;
            null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
            queue.pending = update;
        }
        0 !== lane && $5c00e1cb1faeed50$var$markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
}
function $5c00e1cb1faeed50$var$enqueueUpdate$1(fiber, queue, update, lane) {
    $5c00e1cb1faeed50$var$concurrentQueues[$5c00e1cb1faeed50$var$concurrentQueuesIndex++] = fiber;
    $5c00e1cb1faeed50$var$concurrentQueues[$5c00e1cb1faeed50$var$concurrentQueuesIndex++] = queue;
    $5c00e1cb1faeed50$var$concurrentQueues[$5c00e1cb1faeed50$var$concurrentQueuesIndex++] = update;
    $5c00e1cb1faeed50$var$concurrentQueues[$5c00e1cb1faeed50$var$concurrentQueuesIndex++] = lane;
    $5c00e1cb1faeed50$var$concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
}
function $5c00e1cb1faeed50$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    $5c00e1cb1faeed50$var$enqueueUpdate$1(fiber, queue, update, lane);
    return $5c00e1cb1faeed50$var$getRootForUpdatedFiber(fiber);
}
function $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(fiber, lane) {
    $5c00e1cb1faeed50$var$enqueueUpdate$1(fiber, null, null, lane);
    return $5c00e1cb1faeed50$var$getRootForUpdatedFiber(fiber);
}
function $5c00e1cb1faeed50$var$markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for(var isHidden = !1, parent = sourceFiber.return; null !== parent;)parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden = !0)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden && null !== update && (isHidden = 31 - $5c00e1cb1faeed50$var$clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden], null === alternate ? sourceFiber[isHidden] = [
        update
    ] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
}
function $5c00e1cb1faeed50$var$getRootForUpdatedFiber(sourceFiber) {
    if (50 < $5c00e1cb1faeed50$var$nestedUpdateCount) throw $5c00e1cb1faeed50$var$nestedUpdateCount = 0, $5c00e1cb1faeed50$var$rootWithNestedUpdates = null, Error($5c00e1cb1faeed50$var$formatProdErrorMessage(185));
    for(var parent = sourceFiber.return; null !== parent;)sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
}
var $5c00e1cb1faeed50$var$emptyContextObject = {};
function $5c00e1cb1faeed50$var$FiberNode(tag, pendingProps, key, mode) {
    this.tag = tag;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
}
function $5c00e1cb1faeed50$var$createFiberImplClass(tag, pendingProps, key, mode) {
    return new $5c00e1cb1faeed50$var$FiberNode(tag, pendingProps, key, mode);
}
function $5c00e1cb1faeed50$var$shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
}
function $5c00e1cb1faeed50$var$createWorkInProgress(current, pendingProps) {
    var workInProgress = current.alternate;
    null === workInProgress ? (workInProgress = $5c00e1cb1faeed50$var$createFiberImplClass(current.tag, pendingProps, current.key, current.mode), workInProgress.elementType = current.elementType, workInProgress.type = current.type, workInProgress.stateNode = current.stateNode, workInProgress.alternate = current, current.alternate = workInProgress) : (workInProgress.pendingProps = pendingProps, workInProgress.type = current.type, workInProgress.flags = 0, workInProgress.subtreeFlags = 0, workInProgress.deletions = null);
    workInProgress.flags = current.flags & 1206910976;
    workInProgress.childLanes = current.childLanes;
    workInProgress.lanes = current.lanes;
    workInProgress.child = current.child;
    workInProgress.memoizedProps = current.memoizedProps;
    workInProgress.memoizedState = current.memoizedState;
    workInProgress.updateQueue = current.updateQueue;
    pendingProps = current.dependencies;
    workInProgress.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext
    };
    workInProgress.sibling = current.sibling;
    workInProgress.index = current.index;
    workInProgress.ref = current.ref;
    workInProgress.refCleanup = current.refCleanup;
    return workInProgress;
}
function $5c00e1cb1faeed50$var$resetWorkInProgress(workInProgress, renderLanes) {
    workInProgress.flags &= 1206910978;
    var current = workInProgress.alternate;
    null === current ? (workInProgress.childLanes = 0, workInProgress.lanes = renderLanes, workInProgress.child = null, workInProgress.subtreeFlags = 0, workInProgress.memoizedProps = null, workInProgress.memoizedState = null, workInProgress.updateQueue = null, workInProgress.dependencies = null, workInProgress.stateNode = null) : (workInProgress.childLanes = current.childLanes, workInProgress.lanes = current.lanes, workInProgress.child = current.child, workInProgress.subtreeFlags = 0, workInProgress.deletions = null, workInProgress.memoizedProps = current.memoizedProps, workInProgress.memoizedState = current.memoizedState, workInProgress.updateQueue = current.updateQueue, workInProgress.type = current.type, renderLanes = current.dependencies, workInProgress.dependencies = null === renderLanes ? null : {
        lanes: renderLanes.lanes,
        firstContext: renderLanes.firstContext
    });
    return workInProgress;
}
function $5c00e1cb1faeed50$var$createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof owner) $5c00e1cb1faeed50$var$shouldConstruct(owner) && (fiberTag = 1);
    else if ("string" === typeof owner) fiberTag = $5c00e1cb1faeed50$var$isHostHoistableType(type, pendingProps, $5c00e1cb1faeed50$var$contextStackCursor.current) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else a: switch(owner){
        case $5c00e1cb1faeed50$var$REACT_ACTIVITY_TYPE:
            return type = $5c00e1cb1faeed50$var$createFiberImplClass(31, pendingProps, key, mode), type.elementType = $5c00e1cb1faeed50$var$REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE:
            return $5c00e1cb1faeed50$var$createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case $5c00e1cb1faeed50$var$REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= 24;
            break;
        case $5c00e1cb1faeed50$var$REACT_PROFILER_TYPE:
            return type = $5c00e1cb1faeed50$var$createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = $5c00e1cb1faeed50$var$REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case $5c00e1cb1faeed50$var$REACT_SUSPENSE_TYPE:
            return type = $5c00e1cb1faeed50$var$createFiberImplClass(13, pendingProps, key, mode), type.elementType = $5c00e1cb1faeed50$var$REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case $5c00e1cb1faeed50$var$REACT_SUSPENSE_LIST_TYPE:
            return type = $5c00e1cb1faeed50$var$createFiberImplClass(19, pendingProps, key, mode), type.elementType = $5c00e1cb1faeed50$var$REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        case $5c00e1cb1faeed50$var$REACT_LEGACY_HIDDEN_TYPE:
        case $5c00e1cb1faeed50$var$REACT_VIEW_TRANSITION_TYPE:
            return type = mode | 32, type = $5c00e1cb1faeed50$var$createFiberImplClass(30, pendingProps, key, type), type.elementType = $5c00e1cb1faeed50$var$REACT_VIEW_TRANSITION_TYPE, type.lanes = lanes, type.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }, type;
        default:
            if ("object" === typeof owner && null !== owner) switch(owner.$$typeof){
                case $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE:
                    fiberTag = 10;
                    break a;
                case $5c00e1cb1faeed50$var$REACT_CONSUMER_TYPE:
                    fiberTag = 9;
                    break a;
                case $5c00e1cb1faeed50$var$REACT_FORWARD_REF_TYPE:
                    fiberTag = 11;
                    break a;
                case $5c00e1cb1faeed50$var$REACT_MEMO_TYPE:
                    fiberTag = 14;
                    break a;
                case $5c00e1cb1faeed50$var$REACT_LAZY_TYPE:
                    fiberTag = 16;
                    owner = null;
                    break a;
            }
            fiberTag = 29;
            pendingProps = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(130, null === type ? "null" : typeof type, ""));
            owner = null;
    }
    key = $5c00e1cb1faeed50$var$createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
}
function $5c00e1cb1faeed50$var$createFiberFromFragment(elements, mode, lanes, key) {
    elements = $5c00e1cb1faeed50$var$createFiberImplClass(7, elements, key, mode);
    elements.lanes = lanes;
    return elements;
}
function $5c00e1cb1faeed50$var$createFiberFromText(content, mode, lanes) {
    content = $5c00e1cb1faeed50$var$createFiberImplClass(6, content, null, mode);
    content.lanes = lanes;
    return content;
}
function $5c00e1cb1faeed50$var$createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = $5c00e1cb1faeed50$var$createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
}
function $5c00e1cb1faeed50$var$createFiberFromPortal(portal, mode, lanes) {
    mode = $5c00e1cb1faeed50$var$createFiberImplClass(4, null !== portal.children ? portal.children : [], portal.key, mode);
    mode.lanes = lanes;
    mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
    };
    return mode;
}
var $5c00e1cb1faeed50$var$CapturedStacks = new WeakMap();
function $5c00e1cb1faeed50$var$createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
        var existing = $5c00e1cb1faeed50$var$CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
            value: value,
            source: source,
            stack: $5c00e1cb1faeed50$var$getStackByFiberInDevAndProd(source)
        };
        $5c00e1cb1faeed50$var$CapturedStacks.set(value, source);
        return source;
    }
    return {
        value: value,
        source: source,
        stack: $5c00e1cb1faeed50$var$getStackByFiberInDevAndProd(source)
    };
}
var $5c00e1cb1faeed50$var$forkStack = [], $5c00e1cb1faeed50$var$forkStackIndex = 0, $5c00e1cb1faeed50$var$treeForkProvider = null, $5c00e1cb1faeed50$var$treeForkCount = 0, $5c00e1cb1faeed50$var$idStack = [], $5c00e1cb1faeed50$var$idStackIndex = 0, $5c00e1cb1faeed50$var$treeContextProvider = null, $5c00e1cb1faeed50$var$treeContextId = 1, $5c00e1cb1faeed50$var$treeContextOverflow = "";
function $5c00e1cb1faeed50$var$pushTreeFork(workInProgress, totalChildren) {
    $5c00e1cb1faeed50$var$forkStack[$5c00e1cb1faeed50$var$forkStackIndex++] = $5c00e1cb1faeed50$var$treeForkCount;
    $5c00e1cb1faeed50$var$forkStack[$5c00e1cb1faeed50$var$forkStackIndex++] = $5c00e1cb1faeed50$var$treeForkProvider;
    $5c00e1cb1faeed50$var$treeForkProvider = workInProgress;
    $5c00e1cb1faeed50$var$treeForkCount = totalChildren;
}
function $5c00e1cb1faeed50$var$pushTreeId(workInProgress, totalChildren, index) {
    $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex++] = $5c00e1cb1faeed50$var$treeContextId;
    $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex++] = $5c00e1cb1faeed50$var$treeContextOverflow;
    $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex++] = $5c00e1cb1faeed50$var$treeContextProvider;
    $5c00e1cb1faeed50$var$treeContextProvider = workInProgress;
    var baseIdWithLeadingBit = $5c00e1cb1faeed50$var$treeContextId;
    workInProgress = $5c00e1cb1faeed50$var$treeContextOverflow;
    var baseLength = 32 - $5c00e1cb1faeed50$var$clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index += 1;
    var length = 32 - $5c00e1cb1faeed50$var$clz32(totalChildren) + baseLength;
    if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        $5c00e1cb1faeed50$var$treeContextId = 1 << 32 - $5c00e1cb1faeed50$var$clz32(totalChildren) + baseLength | index << baseLength | baseIdWithLeadingBit;
        $5c00e1cb1faeed50$var$treeContextOverflow = length + workInProgress;
    } else $5c00e1cb1faeed50$var$treeContextId = 1 << length | index << baseLength | baseIdWithLeadingBit, $5c00e1cb1faeed50$var$treeContextOverflow = workInProgress;
}
function $5c00e1cb1faeed50$var$pushMaterializedTreeId(workInProgress) {
    null !== workInProgress.return && ($5c00e1cb1faeed50$var$pushTreeFork(workInProgress, 1), $5c00e1cb1faeed50$var$pushTreeId(workInProgress, 1, 0));
}
function $5c00e1cb1faeed50$var$popTreeContext(workInProgress) {
    for(; workInProgress === $5c00e1cb1faeed50$var$treeForkProvider;)$5c00e1cb1faeed50$var$treeForkProvider = $5c00e1cb1faeed50$var$forkStack[--$5c00e1cb1faeed50$var$forkStackIndex], $5c00e1cb1faeed50$var$forkStack[$5c00e1cb1faeed50$var$forkStackIndex] = null, $5c00e1cb1faeed50$var$treeForkCount = $5c00e1cb1faeed50$var$forkStack[--$5c00e1cb1faeed50$var$forkStackIndex], $5c00e1cb1faeed50$var$forkStack[$5c00e1cb1faeed50$var$forkStackIndex] = null;
    for(; workInProgress === $5c00e1cb1faeed50$var$treeContextProvider;)$5c00e1cb1faeed50$var$treeContextProvider = $5c00e1cb1faeed50$var$idStack[--$5c00e1cb1faeed50$var$idStackIndex], $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex] = null, $5c00e1cb1faeed50$var$treeContextOverflow = $5c00e1cb1faeed50$var$idStack[--$5c00e1cb1faeed50$var$idStackIndex], $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex] = null, $5c00e1cb1faeed50$var$treeContextId = $5c00e1cb1faeed50$var$idStack[--$5c00e1cb1faeed50$var$idStackIndex], $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex] = null;
}
function $5c00e1cb1faeed50$var$restoreSuspendedTreeContext(workInProgress, suspendedContext) {
    $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex++] = $5c00e1cb1faeed50$var$treeContextId;
    $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex++] = $5c00e1cb1faeed50$var$treeContextOverflow;
    $5c00e1cb1faeed50$var$idStack[$5c00e1cb1faeed50$var$idStackIndex++] = $5c00e1cb1faeed50$var$treeContextProvider;
    $5c00e1cb1faeed50$var$treeContextId = suspendedContext.id;
    $5c00e1cb1faeed50$var$treeContextOverflow = suspendedContext.overflow;
    $5c00e1cb1faeed50$var$treeContextProvider = workInProgress;
}
var $5c00e1cb1faeed50$var$hydrationParentFiber = null, $5c00e1cb1faeed50$var$nextHydratableInstance = null, $5c00e1cb1faeed50$var$isHydrating = !1, $5c00e1cb1faeed50$var$hydrationErrors = null, $5c00e1cb1faeed50$var$rootOrSingletonContext = !1, $5c00e1cb1faeed50$var$HydrationMismatchException = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(519));
function $5c00e1cb1faeed50$var$throwOnHydrationMismatch(fiber) {
    var error = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(418, 1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML", ""));
    $5c00e1cb1faeed50$var$queueHydrationError($5c00e1cb1faeed50$var$createCapturedValueAtFiber(error, fiber));
    throw $5c00e1cb1faeed50$var$HydrationMismatchException;
}
function $5c00e1cb1faeed50$var$prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props = fiber.memoizedProps;
    instance[$5c00e1cb1faeed50$var$internalInstanceKey] = fiber;
    instance[$5c00e1cb1faeed50$var$internalPropsKey] = props;
    switch(type){
        case "dialog":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("cancel", instance);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("close", instance);
            break;
        case "iframe":
        case "object":
        case "embed":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "video":
        case "audio":
            for(type = 0; type < $5c00e1cb1faeed50$var$mediaEventTypes.length; type++)$5c00e1cb1faeed50$var$listenToNonDelegatedEvent($5c00e1cb1faeed50$var$mediaEventTypes[type], instance);
            break;
        case "source":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("error", instance);
            break;
        case "img":
        case "image":
        case "link":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("error", instance);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("load", instance);
            break;
        case "details":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("toggle", instance);
            break;
        case "input":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("invalid", instance);
            $5c00e1cb1faeed50$var$initInput(instance, props.value, props.defaultValue, props.checked, props.defaultChecked, props.type, props.name, !0);
            break;
        case "select":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("invalid", instance);
            break;
        case "textarea":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("invalid", instance), $5c00e1cb1faeed50$var$initTextarea(instance, props.value, props.defaultValue, props.children);
    }
    type = props.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || !0 === props.suppressHydrationWarning || $5c00e1cb1faeed50$var$checkForUnmatchedText(instance.textContent, type) ? (null != props.popover && ($5c00e1cb1faeed50$var$listenToNonDelegatedEvent("beforetoggle", instance), $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("toggle", instance)), null != props.onScroll && $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("scroll", instance), null != props.onScrollEnd && $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("scrollend", instance), null != props.onClick && (instance.onclick = $5c00e1cb1faeed50$var$noop$1), instance = !0) : instance = !1;
    instance || $5c00e1cb1faeed50$var$throwOnHydrationMismatch(fiber, !0);
}
function $5c00e1cb1faeed50$var$popToNextHostParent(fiber) {
    for($5c00e1cb1faeed50$var$hydrationParentFiber = fiber.return; $5c00e1cb1faeed50$var$hydrationParentFiber;)switch($5c00e1cb1faeed50$var$hydrationParentFiber.tag){
        case 5:
        case 31:
        case 13:
            $5c00e1cb1faeed50$var$rootOrSingletonContext = !1;
            return;
        case 27:
        case 3:
            $5c00e1cb1faeed50$var$rootOrSingletonContext = !0;
            return;
        default:
            $5c00e1cb1faeed50$var$hydrationParentFiber = $5c00e1cb1faeed50$var$hydrationParentFiber.return;
    }
}
function $5c00e1cb1faeed50$var$popHydrationState(fiber) {
    if (fiber !== $5c00e1cb1faeed50$var$hydrationParentFiber) return !1;
    if (!$5c00e1cb1faeed50$var$isHydrating) return $5c00e1cb1faeed50$var$popToNextHostParent(fiber), $5c00e1cb1faeed50$var$isHydrating = !0, !1;
    var tag = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag && 27 !== tag) {
        if (JSCompiler_temp = 5 === tag) JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || $5c00e1cb1faeed50$var$shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && $5c00e1cb1faeed50$var$nextHydratableInstance && $5c00e1cb1faeed50$var$throwOnHydrationMismatch(fiber);
    $5c00e1cb1faeed50$var$popToNextHostParent(fiber);
    if (13 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(317));
        $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(317));
        $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else 27 === tag ? (tag = $5c00e1cb1faeed50$var$nextHydratableInstance, $5c00e1cb1faeed50$var$isSingletonScope(fiber.type) ? (fiber = $5c00e1cb1faeed50$var$previousHydratableOnEnteringScopedSingleton, $5c00e1cb1faeed50$var$previousHydratableOnEnteringScopedSingleton = null, $5c00e1cb1faeed50$var$nextHydratableInstance = fiber) : $5c00e1cb1faeed50$var$nextHydratableInstance = tag) : $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$hydrationParentFiber ? $5c00e1cb1faeed50$var$getNextHydratable(fiber.stateNode.nextSibling) : null;
    return !0;
}
function $5c00e1cb1faeed50$var$resetHydrationState() {
    $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$hydrationParentFiber = null;
    $5c00e1cb1faeed50$var$isHydrating = !1;
}
function $5c00e1cb1faeed50$var$upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = $5c00e1cb1faeed50$var$hydrationErrors;
    null !== queuedErrors && (null === $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors ? $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors = queuedErrors : $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors.push.apply($5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors, queuedErrors), $5c00e1cb1faeed50$var$hydrationErrors = null);
    return queuedErrors;
}
function $5c00e1cb1faeed50$var$queueHydrationError(error) {
    null === $5c00e1cb1faeed50$var$hydrationErrors ? $5c00e1cb1faeed50$var$hydrationErrors = [
        error
    ] : $5c00e1cb1faeed50$var$hydrationErrors.push(error);
}
var $5c00e1cb1faeed50$var$valueCursor = $5c00e1cb1faeed50$var$createCursor(null), $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 = null, $5c00e1cb1faeed50$var$lastContextDependency = null;
function $5c00e1cb1faeed50$var$pushProvider(providerFiber, context, nextValue) {
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$valueCursor, context._currentValue);
    context._currentValue = nextValue;
}
function $5c00e1cb1faeed50$var$popProvider(context) {
    context._currentValue = $5c00e1cb1faeed50$var$valueCursor.current;
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$valueCursor);
}
function $5c00e1cb1faeed50$var$scheduleContextWorkOnParentPath(parent, renderLanes, propagationRoot) {
    for(; null !== parent;){
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes) !== renderLanes ? (parent.childLanes |= renderLanes, null !== alternate && (alternate.childLanes |= renderLanes)) : null !== alternate && (alternate.childLanes & renderLanes) !== renderLanes && (alternate.childLanes |= renderLanes);
        if (parent === propagationRoot) break;
        parent = parent.return;
    }
}
function $5c00e1cb1faeed50$var$propagateContextChanges(workInProgress, contexts, renderLanes, forcePropagateEntireTree) {
    var fiber = workInProgress.child;
    null !== fiber && (fiber.return = workInProgress);
    for(; null !== fiber;){
        var list = fiber.dependencies;
        if (null !== list) {
            var nextFiber = fiber.child;
            list = list.firstContext;
            a: for(; null !== list;){
                var dependency = list;
                list = fiber;
                for(var i = 0; i < contexts.length; i++)if (dependency.context === contexts[i]) {
                    list.lanes |= renderLanes;
                    dependency = list.alternate;
                    null !== dependency && (dependency.lanes |= renderLanes);
                    $5c00e1cb1faeed50$var$scheduleContextWorkOnParentPath(list.return, renderLanes, workInProgress);
                    forcePropagateEntireTree || (nextFiber = null);
                    break a;
                }
                list = dependency.next;
            }
        } else if (18 === fiber.tag) {
            nextFiber = fiber.return;
            if (null === nextFiber) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(341));
            nextFiber.lanes |= renderLanes;
            list = nextFiber.alternate;
            null !== list && (list.lanes |= renderLanes);
            $5c00e1cb1faeed50$var$scheduleContextWorkOnParentPath(nextFiber, renderLanes, workInProgress);
            nextFiber = null;
        } else 13 === fiber.tag && null !== fiber.memoizedState && null === fiber.memoizedState.dehydrated ? (fiber.lanes |= renderLanes, nextFiber = fiber.alternate, null !== nextFiber && (nextFiber.lanes |= renderLanes), $5c00e1cb1faeed50$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, workInProgress), nextFiber = fiber.child, nextFiber = null !== nextFiber ? nextFiber.sibling : null) : nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else for(nextFiber = fiber; null !== nextFiber;){
            if (nextFiber === workInProgress) {
                nextFiber = null;
                break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
                fiber.return = nextFiber.return;
                nextFiber = fiber;
                break;
            }
            nextFiber = nextFiber.return;
        }
        fiber = nextFiber;
    }
}
function $5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, forcePropagateEntireTree) {
    current = null;
    for(var parent = workInProgress, isInsidePropagationBailout = !1; null !== parent;){
        if (!isInsidePropagationBailout) {
            if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = !0;
            else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
            var currentParent = parent.alternate;
            if (null === currentParent) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(387));
            currentParent = currentParent.memoizedProps;
            if (null !== currentParent) {
                var context = parent.type;
                $5c00e1cb1faeed50$var$objectIs(parent.pendingProps.value, currentParent.value) || (null !== current ? current.push(context) : current = [
                    context
                ]);
            }
        } else if (parent === $5c00e1cb1faeed50$var$hostTransitionProviderCursor.current) {
            currentParent = parent.alternate;
            if (null === currentParent) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(387));
            currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current ? current.push($5c00e1cb1faeed50$var$HostTransitionContext) : current = [
                $5c00e1cb1faeed50$var$HostTransitionContext
            ]);
        }
        parent = parent.return;
    }
    null !== current && $5c00e1cb1faeed50$var$propagateContextChanges(workInProgress, current, renderLanes, forcePropagateEntireTree);
    workInProgress.flags |= 262144;
    return null !== current;
}
function $5c00e1cb1faeed50$var$checkIfContextChanged(currentDependencies) {
    for(currentDependencies = currentDependencies.firstContext; null !== currentDependencies;){
        if (!$5c00e1cb1faeed50$var$objectIs(currentDependencies.context._currentValue, currentDependencies.memoizedValue)) return !0;
        currentDependencies = currentDependencies.next;
    }
    return !1;
}
function $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress) {
    $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 = workInProgress;
    $5c00e1cb1faeed50$var$lastContextDependency = null;
    workInProgress = workInProgress.dependencies;
    null !== workInProgress && (workInProgress.firstContext = null);
}
function $5c00e1cb1faeed50$var$readContext(context) {
    return $5c00e1cb1faeed50$var$readContextForConsumer($5c00e1cb1faeed50$var$currentlyRenderingFiber$1, context);
}
function $5c00e1cb1faeed50$var$readContextDuringReconciliation(consumer, context) {
    null === $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 && $5c00e1cb1faeed50$var$prepareToReadContext(consumer);
    return $5c00e1cb1faeed50$var$readContextForConsumer(consumer, context);
}
function $5c00e1cb1faeed50$var$readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = {
        context: context,
        memoizedValue: value,
        next: null
    };
    if (null === $5c00e1cb1faeed50$var$lastContextDependency) {
        if (null === consumer) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(308));
        $5c00e1cb1faeed50$var$lastContextDependency = context;
        consumer.dependencies = {
            lanes: 0,
            firstContext: context
        };
        consumer.flags |= 524288;
    } else $5c00e1cb1faeed50$var$lastContextDependency = $5c00e1cb1faeed50$var$lastContextDependency.next = context;
    return value;
}
var $5c00e1cb1faeed50$var$AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
        aborted: !1,
        addEventListener: function(type, listener) {
            listeners.push(listener);
        }
    };
    this.abort = function() {
        signal.aborted = !0;
        listeners.forEach(function(listener) {
            return listener();
        });
    };
}, $5c00e1cb1faeed50$var$scheduleCallback$2 = $1wkuA.unstable_scheduleCallback, $5c00e1cb1faeed50$var$NormalPriority = $1wkuA.unstable_NormalPriority, $5c00e1cb1faeed50$var$CacheContext = {
    $$typeof: $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
};
function $5c00e1cb1faeed50$var$createCache() {
    return {
        controller: new $5c00e1cb1faeed50$var$AbortControllerLocal(),
        data: new Map(),
        refCount: 0
    };
}
function $5c00e1cb1faeed50$var$releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && $5c00e1cb1faeed50$var$scheduleCallback$2($5c00e1cb1faeed50$var$NormalPriority, function() {
        cache.controller.abort();
    });
}
function $5c00e1cb1faeed50$var$queueTransitionTypes(root, transitionTypes) {
    if (0 !== (root.pendingLanes & 4194048)) {
        var queued = root.transitionTypes;
        null === queued && (queued = root.transitionTypes = []);
        for(root = 0; root < transitionTypes.length; root++){
            var transitionType = transitionTypes[root];
            -1 === queued.indexOf(transitionType) && queued.push(transitionType);
        }
    }
}
var $5c00e1cb1faeed50$var$entangledTransitionTypes = null;
function $5c00e1cb1faeed50$var$claimQueuedTransitionTypes(root) {
    var claimed = root.transitionTypes;
    root.transitionTypes = null;
    return claimed;
}
var $5c00e1cb1faeed50$var$currentEntangledListeners = null, $5c00e1cb1faeed50$var$currentEntangledPendingCount = 0, $5c00e1cb1faeed50$var$currentEntangledLane = 0, $5c00e1cb1faeed50$var$currentEntangledActionThenable = null;
function $5c00e1cb1faeed50$var$entangleAsyncAction(transition, thenable) {
    if (null === $5c00e1cb1faeed50$var$currentEntangledListeners) {
        var entangledListeners = $5c00e1cb1faeed50$var$currentEntangledListeners = [];
        $5c00e1cb1faeed50$var$currentEntangledPendingCount = 0;
        $5c00e1cb1faeed50$var$currentEntangledLane = $5c00e1cb1faeed50$var$requestTransitionLane();
        $5c00e1cb1faeed50$var$currentEntangledActionThenable = {
            status: "pending",
            value: void 0,
            then: function(resolve) {
                entangledListeners.push(resolve);
            }
        };
    }
    $5c00e1cb1faeed50$var$currentEntangledPendingCount++;
    thenable.then($5c00e1cb1faeed50$var$pingEngtangledActionScope, $5c00e1cb1faeed50$var$pingEngtangledActionScope);
    return thenable;
}
function $5c00e1cb1faeed50$var$pingEngtangledActionScope() {
    if (0 === --$5c00e1cb1faeed50$var$currentEntangledPendingCount && ($5c00e1cb1faeed50$var$entangledTransitionTypes = null, null !== $5c00e1cb1faeed50$var$currentEntangledListeners)) {
        null !== $5c00e1cb1faeed50$var$currentEntangledActionThenable && ($5c00e1cb1faeed50$var$currentEntangledActionThenable.status = "fulfilled");
        var listeners = $5c00e1cb1faeed50$var$currentEntangledListeners;
        $5c00e1cb1faeed50$var$currentEntangledListeners = null;
        $5c00e1cb1faeed50$var$currentEntangledLane = 0;
        $5c00e1cb1faeed50$var$currentEntangledActionThenable = null;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])();
    }
}
function $5c00e1cb1faeed50$var$chainThenableValue(thenable, result) {
    var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
            listeners.push(resolve);
        }
    };
    thenable.then(function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result;
        for(var i = 0; i < listeners.length; i++)(0, listeners[i])(result);
    }, function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for(error = 0; error < listeners.length; error++)(0, listeners[error])(void 0);
    });
    return thenableWithOverride;
}
var $5c00e1cb1faeed50$var$prevOnStartTransitionFinish = $5c00e1cb1faeed50$var$ReactSharedInternals.S;
$5c00e1cb1faeed50$var$ReactSharedInternals.S = function(transition, returnValue) {
    $5c00e1cb1faeed50$var$globalMostRecentTransitionTime = $5c00e1cb1faeed50$var$now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && $5c00e1cb1faeed50$var$entangleAsyncAction(transition, returnValue);
    if (null !== $5c00e1cb1faeed50$var$entangledTransitionTypes) for(var root$28 = $5c00e1cb1faeed50$var$firstScheduledRoot; null !== root$28;)$5c00e1cb1faeed50$var$queueTransitionTypes(root$28, $5c00e1cb1faeed50$var$entangledTransitionTypes), root$28 = root$28.next;
    root$28 = transition.types;
    if (null !== root$28) {
        for(var root$29 = $5c00e1cb1faeed50$var$firstScheduledRoot; null !== root$29;)$5c00e1cb1faeed50$var$queueTransitionTypes(root$29, root$28), root$29 = root$29.next;
        if (0 !== $5c00e1cb1faeed50$var$currentEntangledLane) {
            root$29 = $5c00e1cb1faeed50$var$entangledTransitionTypes;
            null === root$29 && (root$29 = $5c00e1cb1faeed50$var$entangledTransitionTypes = []);
            for(var i = 0; i < root$28.length; i++){
                var transitionType = root$28[i];
                -1 === root$29.indexOf(transitionType) && root$29.push(transitionType);
            }
        }
    }
    null !== $5c00e1cb1faeed50$var$prevOnStartTransitionFinish && $5c00e1cb1faeed50$var$prevOnStartTransitionFinish(transition, returnValue);
};
var $5c00e1cb1faeed50$var$resumedCache = $5c00e1cb1faeed50$var$createCursor(null);
function $5c00e1cb1faeed50$var$peekCacheFromPool() {
    var cacheResumedFromPreviousRender = $5c00e1cb1faeed50$var$resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : $5c00e1cb1faeed50$var$workInProgressRoot.pooledCache;
}
function $5c00e1cb1faeed50$var$pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$resumedCache, $5c00e1cb1faeed50$var$resumedCache.current) : $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$resumedCache, prevCachePool.pool);
}
function $5c00e1cb1faeed50$var$getSuspendedCache() {
    var cacheFromPool = $5c00e1cb1faeed50$var$peekCacheFromPool();
    return null === cacheFromPool ? null : {
        parent: $5c00e1cb1faeed50$var$CacheContext._currentValue,
        pool: cacheFromPool
    };
}
var $5c00e1cb1faeed50$var$SuspenseException = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(460)), $5c00e1cb1faeed50$var$SuspenseyCommitException = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(474)), $5c00e1cb1faeed50$var$SuspenseActionException = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(542)), $5c00e1cb1faeed50$var$noopSuspenseyCommitThenable = {
    then: function() {}
};
function $5c00e1cb1faeed50$var$isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
}
function $5c00e1cb1faeed50$var$trackUsedThenable(thenableState, thenable, index) {
    index = thenableState[index];
    void 0 === index ? thenableState.push(thenable) : index !== thenable && (thenable.then($5c00e1cb1faeed50$var$noop$1, $5c00e1cb1faeed50$var$noop$1), thenable = index);
    switch(thenable.status){
        case "fulfilled":
            return thenable.value;
        case "rejected":
            thenableState = thenable.reason;
            $5c00e1cb1faeed50$var$checkIfUseWrappedInAsyncCatch(thenableState);
            if (void 0 === thenableState && !("reason" in thenable)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(600));
            throw thenableState;
        default:
            if ("string" === typeof thenable.status) thenable.then($5c00e1cb1faeed50$var$noop$1, $5c00e1cb1faeed50$var$noop$1);
            else {
                thenableState = $5c00e1cb1faeed50$var$workInProgressRoot;
                if (null !== thenableState && 100 < thenableState.shellSuspendCounter) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(482));
                thenableState = thenable;
                thenableState.status = "pending";
                thenableState.then(function(fulfilledValue) {
                    if ("pending" === thenable.status) {
                        var fulfilledThenable = thenable;
                        fulfilledThenable.status = "fulfilled";
                        fulfilledThenable.value = fulfilledValue;
                    }
                }, function(error) {
                    if ("pending" === thenable.status) {
                        var rejectedThenable = thenable;
                        rejectedThenable.status = "rejected";
                        rejectedThenable.reason = error;
                    }
                });
            }
            switch(thenable.status){
                case "fulfilled":
                    return thenable.value;
                case "rejected":
                    throw thenableState = thenable.reason, $5c00e1cb1faeed50$var$checkIfUseWrappedInAsyncCatch(thenableState), thenableState;
            }
            $5c00e1cb1faeed50$var$suspendedThenable = thenable;
            throw $5c00e1cb1faeed50$var$SuspenseException;
    }
}
function $5c00e1cb1faeed50$var$resolveLazy(lazyType) {
    try {
        var init = lazyType._init;
        return init(lazyType._payload);
    } catch (x) {
        if (null !== x && "object" === typeof x && "function" === typeof x.then) throw $5c00e1cb1faeed50$var$suspendedThenable = x, $5c00e1cb1faeed50$var$SuspenseException;
        throw x;
    }
}
var $5c00e1cb1faeed50$var$suspendedThenable = null;
function $5c00e1cb1faeed50$var$getSuspendedThenable() {
    if (null === $5c00e1cb1faeed50$var$suspendedThenable) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(459));
    var thenable = $5c00e1cb1faeed50$var$suspendedThenable;
    $5c00e1cb1faeed50$var$suspendedThenable = null;
    return thenable;
}
function $5c00e1cb1faeed50$var$checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === $5c00e1cb1faeed50$var$SuspenseException || rejectedReason === $5c00e1cb1faeed50$var$SuspenseActionException) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(483));
}
var $5c00e1cb1faeed50$var$thenableState$1 = null, $5c00e1cb1faeed50$var$thenableIndexCounter$1 = 0;
function $5c00e1cb1faeed50$var$unwrapThenable(thenable) {
    var index = $5c00e1cb1faeed50$var$thenableIndexCounter$1;
    $5c00e1cb1faeed50$var$thenableIndexCounter$1 += 1;
    null === $5c00e1cb1faeed50$var$thenableState$1 && ($5c00e1cb1faeed50$var$thenableState$1 = []);
    return $5c00e1cb1faeed50$var$trackUsedThenable($5c00e1cb1faeed50$var$thenableState$1, thenable, index);
}
function $5c00e1cb1faeed50$var$coerceRef(workInProgress, element) {
    element = element.props.ref;
    workInProgress.ref = void 0 !== element ? element : null;
}
function $5c00e1cb1faeed50$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === $5c00e1cb1faeed50$var$REACT_LEGACY_ELEMENT_TYPE) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(31, "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber));
}
function $5c00e1cb1faeed50$var$createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
            var deletions = returnFiber.deletions;
            null === deletions ? (returnFiber.deletions = [
                childToDelete
            ], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for(; null !== currentFirstChild;)deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
    }
    function mapRemainingChildren(currentFirstChild) {
        for(var existingChildren = new Map(); null !== currentFirstChild;)null === currentFirstChild.key ? existingChildren.set(currentFirstChild.index, currentFirstChild) : existingChildren.set(currentFirstChild.key, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
        fiber = $5c00e1cb1faeed50$var$createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects) return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex) return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 2, lastPlacedIndex) : newIndex;
        newFiber.flags |= 134217730;
        return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 134217730);
        return newFiber;
    }
    function updateTextNode(returnFiber, current, textContent, lanes) {
        if (null === current || 6 !== current.tag) return current = $5c00e1cb1faeed50$var$createFiberFromText(textContent, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, textContent);
        current.return = returnFiber;
        return current;
    }
    function updateElement(returnFiber, current, element, lanes) {
        var elementType = element.type;
        if (elementType === $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE) return returnFiber = updateFragment(returnFiber, current, element.props.children, lanes, element.key), $5c00e1cb1faeed50$var$coerceRef(returnFiber, element), returnFiber;
        if (null !== current && (current.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === $5c00e1cb1faeed50$var$REACT_LAZY_TYPE && $5c00e1cb1faeed50$var$resolveLazy(elementType) === current.type)) return current = useFiber(current, element.props), $5c00e1cb1faeed50$var$coerceRef(current, element), current.return = returnFiber, current;
        current = $5c00e1cb1faeed50$var$createFiberFromTypeAndProps(element.type, element.key, element.props, null, returnFiber.mode, lanes);
        $5c00e1cb1faeed50$var$coerceRef(current, element);
        current.return = returnFiber;
        return current;
    }
    function updatePortal(returnFiber, current, portal, lanes) {
        if (null === current || 4 !== current.tag || current.stateNode.containerInfo !== portal.containerInfo || current.stateNode.implementation !== portal.implementation) return current = $5c00e1cb1faeed50$var$createFiberFromPortal(portal, returnFiber.mode, lanes), current.return = returnFiber, current;
        current = useFiber(current, portal.children || []);
        current.return = returnFiber;
        return current;
    }
    function updateFragment(returnFiber, current, fragment, lanes, key) {
        if (null === current || 7 !== current.tag) return current = $5c00e1cb1faeed50$var$createFiberFromFragment(fragment, returnFiber.mode, lanes, key), current.return = returnFiber, current;
        current = useFiber(current, fragment);
        current.return = returnFiber;
        return current;
    }
    function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return newChild = $5c00e1cb1faeed50$var$createFiberFromText("" + newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5c00e1cb1faeed50$var$REACT_ELEMENT_TYPE:
                    return lanes = $5c00e1cb1faeed50$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $5c00e1cb1faeed50$var$coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
                case $5c00e1cb1faeed50$var$REACT_PORTAL_TYPE:
                    return newChild = $5c00e1cb1faeed50$var$createFiberFromPortal(newChild, returnFiber.mode, lanes), newChild.return = returnFiber, newChild;
                case $5c00e1cb1faeed50$var$REACT_LAZY_TYPE:
                    return newChild = $5c00e1cb1faeed50$var$resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
            }
            if ($5c00e1cb1faeed50$var$isArrayImpl(newChild) || $5c00e1cb1faeed50$var$getIteratorFn(newChild)) return newChild = $5c00e1cb1faeed50$var$createFiberFromFragment(newChild, returnFiber.mode, lanes, null), newChild.return = returnFiber, newChild;
            if ("function" === typeof newChild.then) return createChild(returnFiber, $5c00e1cb1faeed50$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE) return createChild(returnFiber, $5c00e1cb1faeed50$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5c00e1cb1faeed50$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5c00e1cb1faeed50$var$REACT_ELEMENT_TYPE:
                    return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
                case $5c00e1cb1faeed50$var$REACT_PORTAL_TYPE:
                    return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
                case $5c00e1cb1faeed50$var$REACT_LAZY_TYPE:
                    return newChild = $5c00e1cb1faeed50$var$resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
            }
            if ($5c00e1cb1faeed50$var$isArrayImpl(newChild) || $5c00e1cb1faeed50$var$getIteratorFn(newChild)) return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateSlot(returnFiber, oldFiber, $5c00e1cb1faeed50$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE) return updateSlot(returnFiber, oldFiber, $5c00e1cb1faeed50$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5c00e1cb1faeed50$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild) return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5c00e1cb1faeed50$var$REACT_ELEMENT_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
                case $5c00e1cb1faeed50$var$REACT_PORTAL_TYPE:
                    return existingChildren = existingChildren.get(null === newChild.key ? newIdx : newChild.key) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
                case $5c00e1cb1faeed50$var$REACT_LAZY_TYPE:
                    return newChild = $5c00e1cb1faeed50$var$resolveLazy(newChild), updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes);
            }
            if ($5c00e1cb1faeed50$var$isArrayImpl(newChild) || $5c00e1cb1faeed50$var$getIteratorFn(newChild)) return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
            if ("function" === typeof newChild.then) return updateFromMap(existingChildren, returnFiber, newIdx, $5c00e1cb1faeed50$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE) return updateFromMap(existingChildren, returnFiber, newIdx, $5c00e1cb1faeed50$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5c00e1cb1faeed50$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, newChildren[newIdx], lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length) return deleteRemainingChildren(returnFiber, oldFiber), $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; newIdx < newChildren.length; newIdx++)oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(oldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
            $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)nextOldFiber = updateFromMap(oldFiber, returnFiber, newIdx, newChildren[newIdx], lanes), null !== nextOldFiber && (shouldTrackSideEffects && (newFiber = nextOldFiber.alternate, null !== newFiber && oldFiber.delete(null === newFiber.key ? newIdx : newFiber.key)), currentFirstChild = placeChild(nextOldFiber, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(151));
        for(var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()){
            oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
            var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
            if (null === newFiber) {
                null === oldFiber && (oldFiber = nextOldFiber);
                break;
            }
            shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
            currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
            null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
            previousNewFiber = newFiber;
            oldFiber = nextOldFiber;
        }
        if (step.done) return deleteRemainingChildren(returnFiber, oldFiber), $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
            for(; !step.done; newIdx++, step = newChildren.next())step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
            $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(returnFiber, newIdx);
            return resultingFirstChild;
        }
        for(oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && (nextOldFiber = step.alternate, null !== nextOldFiber && oldFiber.delete(null === nextOldFiber.key ? newIdx : nextOldFiber.key)), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
            return deleteChild(returnFiber, child);
        });
        $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE && null === newChild.key && void 0 === newChild.props.ref && (newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
            switch(newChild.$$typeof){
                case $5c00e1cb1faeed50$var$REACT_ELEMENT_TYPE:
                    a: {
                        for(var key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                key = newChild.type;
                                if (key === $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE) {
                                    if (7 === currentFirstChild.tag) {
                                        deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                        lanes = useFiber(currentFirstChild, newChild.props.children);
                                        $5c00e1cb1faeed50$var$coerceRef(lanes, newChild);
                                        lanes.return = returnFiber;
                                        returnFiber = lanes;
                                        break a;
                                    }
                                } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === $5c00e1cb1faeed50$var$REACT_LAZY_TYPE && $5c00e1cb1faeed50$var$resolveLazy(key) === currentFirstChild.type) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.props);
                                    $5c00e1cb1faeed50$var$coerceRef(lanes, newChild);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                }
                                deleteRemainingChildren(returnFiber, currentFirstChild);
                                break;
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        newChild.type === $5c00e1cb1faeed50$var$REACT_FRAGMENT_TYPE ? (lanes = $5c00e1cb1faeed50$var$createFiberFromFragment(newChild.props.children, returnFiber.mode, lanes, newChild.key), $5c00e1cb1faeed50$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes) : (lanes = $5c00e1cb1faeed50$var$createFiberFromTypeAndProps(newChild.type, newChild.key, newChild.props, null, returnFiber.mode, lanes), $5c00e1cb1faeed50$var$coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
                    }
                    return placeSingleChild(returnFiber);
                case $5c00e1cb1faeed50$var$REACT_PORTAL_TYPE:
                    a: {
                        for(key = newChild.key; null !== currentFirstChild;){
                            if (currentFirstChild.key === key) {
                                if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                                    deleteRemainingChildren(returnFiber, currentFirstChild.sibling);
                                    lanes = useFiber(currentFirstChild, newChild.children || []);
                                    lanes.return = returnFiber;
                                    returnFiber = lanes;
                                    break a;
                                } else {
                                    deleteRemainingChildren(returnFiber, currentFirstChild);
                                    break;
                                }
                            } else deleteChild(returnFiber, currentFirstChild);
                            currentFirstChild = currentFirstChild.sibling;
                        }
                        lanes = $5c00e1cb1faeed50$var$createFiberFromPortal(newChild, returnFiber.mode, lanes);
                        lanes.return = returnFiber;
                        returnFiber = lanes;
                    }
                    return placeSingleChild(returnFiber);
                case $5c00e1cb1faeed50$var$REACT_LAZY_TYPE:
                    return newChild = $5c00e1cb1faeed50$var$resolveLazy(newChild), reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ($5c00e1cb1faeed50$var$isArrayImpl(newChild)) return reconcileChildrenArray(returnFiber, currentFirstChild, newChild, lanes);
            if ($5c00e1cb1faeed50$var$getIteratorFn(newChild)) {
                key = $5c00e1cb1faeed50$var$getIteratorFn(newChild);
                if ("function" !== typeof key) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(150));
                newChild = key.call(newChild);
                return reconcileChildrenIterator(returnFiber, currentFirstChild, newChild, lanes);
            }
            if ("function" === typeof newChild.then) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $5c00e1cb1faeed50$var$unwrapThenable(newChild), lanes);
            if (newChild.$$typeof === $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE) return reconcileChildFibersImpl(returnFiber, currentFirstChild, $5c00e1cb1faeed50$var$readContextDuringReconciliation(returnFiber, newChild), lanes);
            $5c00e1cb1faeed50$var$throwOnInvalidObjectTypeImpl(returnFiber, newChild);
        }
        return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = $5c00e1cb1faeed50$var$createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
        try {
            $5c00e1cb1faeed50$var$thenableIndexCounter$1 = 0;
            var firstChildFiber = reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes);
            $5c00e1cb1faeed50$var$thenableState$1 = null;
            return firstChildFiber;
        } catch (x) {
            if (x === $5c00e1cb1faeed50$var$SuspenseException || x === $5c00e1cb1faeed50$var$SuspenseActionException) throw x;
            var fiber = $5c00e1cb1faeed50$var$createFiberImplClass(29, x, null, returnFiber.mode);
            fiber.lanes = lanes;
            fiber.return = returnFiber;
            return fiber;
        } finally{}
    };
}
var $5c00e1cb1faeed50$var$reconcileChildFibers = $5c00e1cb1faeed50$var$createChildReconciler(!0), $5c00e1cb1faeed50$var$mountChildFibers = $5c00e1cb1faeed50$var$createChildReconciler(!1), $5c00e1cb1faeed50$var$hasForceUpdate = !1;
function $5c00e1cb1faeed50$var$initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: {
            pending: null,
            lanes: 0,
            hiddenCallbacks: null
        },
        callbacks: null
    };
}
function $5c00e1cb1faeed50$var$cloneUpdateQueue(current, workInProgress) {
    current = current.updateQueue;
    workInProgress.updateQueue === current && (workInProgress.updateQueue = {
        baseState: current.baseState,
        firstBaseUpdate: current.firstBaseUpdate,
        lastBaseUpdate: current.lastBaseUpdate,
        shared: current.shared,
        callbacks: null
    });
}
function $5c00e1cb1faeed50$var$createUpdate(lane) {
    return {
        lane: lane,
        tag: 0,
        payload: null,
        callback: null,
        next: null
    };
}
function $5c00e1cb1faeed50$var$enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== ($5c00e1cb1faeed50$var$executionContext & 2)) {
        var pending = updateQueue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        updateQueue.pending = update;
        update = $5c00e1cb1faeed50$var$getRootForUpdatedFiber(fiber);
        $5c00e1cb1faeed50$var$markUpdateLaneFromFiberToRoot(fiber, null, lane);
        return update;
    }
    $5c00e1cb1faeed50$var$enqueueUpdate$1(fiber, updateQueue, update, lane);
    return $5c00e1cb1faeed50$var$getRootForUpdatedFiber(fiber);
}
function $5c00e1cb1faeed50$var$entangleTransitions(root, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        $5c00e1cb1faeed50$var$markRootEntangled(root, lane);
    }
}
function $5c00e1cb1faeed50$var$enqueueCapturedUpdate(workInProgress, capturedUpdate) {
    var queue = workInProgress.updateQueue, current = workInProgress.alternate;
    if (null !== current && (current = current.updateQueue, queue === current)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
            do {
                var clone = {
                    lane: queue.lane,
                    tag: queue.tag,
                    payload: queue.payload,
                    callback: null,
                    next: null
                };
                null === newLast ? newFirst = newLast = clone : newLast = newLast.next = clone;
                queue = queue.next;
            }while (null !== queue);
            null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
            baseState: current.baseState,
            firstBaseUpdate: newFirst,
            lastBaseUpdate: newLast,
            shared: current.shared,
            callbacks: current.callbacks
        };
        workInProgress.updateQueue = queue;
        return;
    }
    workInProgress = queue.lastBaseUpdate;
    null === workInProgress ? queue.firstBaseUpdate = capturedUpdate : workInProgress.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
}
var $5c00e1cb1faeed50$var$didReadFromEntangledAsyncAction = !1;
function $5c00e1cb1faeed50$var$suspendIfUpdateReadFromEntangledAsyncAction() {
    if ($5c00e1cb1faeed50$var$didReadFromEntangledAsyncAction) {
        var entangledActionThenable = $5c00e1cb1faeed50$var$currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
    }
}
function $5c00e1cb1faeed50$var$processUpdateQueue(workInProgress$jscomp$0, props, instance$jscomp$0, renderLanes) {
    $5c00e1cb1faeed50$var$didReadFromEntangledAsyncAction = !1;
    var queue = workInProgress$jscomp$0.updateQueue;
    $5c00e1cb1faeed50$var$hasForceUpdate = !1;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current = workInProgress$jscomp$0.alternate;
        null !== current && (current = current.updateQueue, pendingQueue = current.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
            var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
            if (isHiddenUpdate ? ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
                0 !== updateLane && updateLane === $5c00e1cb1faeed50$var$currentEntangledLane && ($5c00e1cb1faeed50$var$didReadFromEntangledAsyncAction = !0);
                null !== current && (current = current.next = {
                    lane: 0,
                    tag: pendingQueue.tag,
                    payload: pendingQueue.payload,
                    callback: null,
                    next: null
                });
                a: {
                    var workInProgress = workInProgress$jscomp$0, update = pendingQueue;
                    updateLane = props;
                    var instance = instance$jscomp$0;
                    switch(update.tag){
                        case 1:
                            workInProgress = update.payload;
                            if ("function" === typeof workInProgress) {
                                newState = workInProgress.call(instance, newState, updateLane);
                                break a;
                            }
                            newState = workInProgress;
                            break a;
                        case 3:
                            workInProgress.flags = workInProgress.flags & -65537 | 128;
                        case 0:
                            workInProgress = update.payload;
                            updateLane = "function" === typeof workInProgress ? workInProgress.call(instance, newState, updateLane) : workInProgress;
                            if (null === updateLane || void 0 === updateLane) break a;
                            newState = $5c00e1cb1faeed50$var$assign({}, newState, updateLane);
                            break a;
                        case 2:
                            $5c00e1cb1faeed50$var$hasForceUpdate = !0;
                    }
                }
                updateLane = pendingQueue.callback;
                null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [
                    updateLane
                ] : isHiddenUpdate.push(updateLane));
            } else isHiddenUpdate = {
                lane: updateLane,
                tag: pendingQueue.tag,
                payload: pendingQueue.payload,
                callback: pendingQueue.callback,
                next: null
            }, null === current ? (firstPendingUpdate = current = isHiddenUpdate, lastPendingUpdate = newState) : current = current.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
            pendingQueue = pendingQueue.next;
            if (null === pendingQueue) {
                if (pendingQueue = queue.shared.pending, null === pendingQueue) break;
                else isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
            }
        }while (1);
        null === current && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress$jscomp$0.lanes = lastBaseUpdate;
        workInProgress$jscomp$0.memoizedState = newState;
    }
}
function $5c00e1cb1faeed50$var$callCallback(callback, context) {
    if ("function" !== typeof callback) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(191, callback));
    callback.call(context);
}
function $5c00e1cb1faeed50$var$commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks) for(updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)$5c00e1cb1faeed50$var$callCallback(callbacks[updateQueue], context);
}
var $5c00e1cb1faeed50$var$currentTreeHiddenStackCursor = $5c00e1cb1faeed50$var$createCursor(null), $5c00e1cb1faeed50$var$prevEntangledRenderLanesCursor = $5c00e1cb1faeed50$var$createCursor(0);
function $5c00e1cb1faeed50$var$pushHiddenContext(fiber, context) {
    fiber = $5c00e1cb1faeed50$var$entangledRenderLanes;
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$prevEntangledRenderLanesCursor, fiber);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$currentTreeHiddenStackCursor, context);
    $5c00e1cb1faeed50$var$entangledRenderLanes = fiber | context.baseLanes;
}
function $5c00e1cb1faeed50$var$reuseHiddenContextOnStack() {
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$prevEntangledRenderLanesCursor, $5c00e1cb1faeed50$var$entangledRenderLanes);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$currentTreeHiddenStackCursor, $5c00e1cb1faeed50$var$currentTreeHiddenStackCursor.current);
}
function $5c00e1cb1faeed50$var$popHiddenContext() {
    $5c00e1cb1faeed50$var$entangledRenderLanes = $5c00e1cb1faeed50$var$prevEntangledRenderLanesCursor.current;
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$currentTreeHiddenStackCursor);
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$prevEntangledRenderLanesCursor);
}
var $5c00e1cb1faeed50$var$suspenseHandlerStackCursor = $5c00e1cb1faeed50$var$createCursor(null), $5c00e1cb1faeed50$var$shellBoundary = null;
function $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(handler) {
    var current = handler.alternate;
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseStackCursor, $5c00e1cb1faeed50$var$suspenseStackCursor.current & 1);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseHandlerStackCursor, handler);
    null === $5c00e1cb1faeed50$var$shellBoundary && (null === current || null !== $5c00e1cb1faeed50$var$currentTreeHiddenStackCursor.current ? $5c00e1cb1faeed50$var$shellBoundary = handler : null !== current.memoizedState && ($5c00e1cb1faeed50$var$shellBoundary = handler));
}
function $5c00e1cb1faeed50$var$pushDehydratedActivitySuspenseHandler(fiber) {
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseStackCursor, $5c00e1cb1faeed50$var$suspenseStackCursor.current);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseHandlerStackCursor, fiber);
    null === $5c00e1cb1faeed50$var$shellBoundary && ($5c00e1cb1faeed50$var$shellBoundary = fiber);
}
function $5c00e1cb1faeed50$var$pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? ($5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseStackCursor, $5c00e1cb1faeed50$var$suspenseStackCursor.current), $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseHandlerStackCursor, fiber), null === $5c00e1cb1faeed50$var$shellBoundary && ($5c00e1cb1faeed50$var$shellBoundary = fiber)) : $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack();
}
function $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack() {
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseStackCursor, $5c00e1cb1faeed50$var$suspenseStackCursor.current);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseHandlerStackCursor, $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current);
}
function $5c00e1cb1faeed50$var$popSuspenseHandler(fiber) {
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$suspenseHandlerStackCursor);
    $5c00e1cb1faeed50$var$shellBoundary === fiber && ($5c00e1cb1faeed50$var$shellBoundary = null);
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$suspenseStackCursor);
}
var $5c00e1cb1faeed50$var$suspenseStackCursor = $5c00e1cb1faeed50$var$createCursor(0);
function $5c00e1cb1faeed50$var$pushSuspenseListContext(fiber, newContext) {
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseHandlerStackCursor, $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current);
    $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseStackCursor, newContext);
}
function $5c00e1cb1faeed50$var$popSuspenseListContext(fiber) {
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$suspenseStackCursor);
    $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$suspenseHandlerStackCursor);
    $5c00e1cb1faeed50$var$shellBoundary === fiber && ($5c00e1cb1faeed50$var$shellBoundary = null);
}
function $5c00e1cb1faeed50$var$findFirstSuspended(row) {
    for(var node = row; null !== node;){
        if (13 === node.tag) {
            var state = node.memoizedState;
            if (null !== state && (state = state.dehydrated, null === state || $5c00e1cb1faeed50$var$isSuspenseInstancePending(state) || $5c00e1cb1faeed50$var$isSuspenseInstanceFallback(state))) return node;
        } else if (19 === node.tag && "independent" !== node.memoizedProps.revealOrder) {
            if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
            node.child.return = node;
            node = node.child;
            continue;
        }
        if (node === row) break;
        for(; null === node.sibling;){
            if (null === node.return || node.return === row) return null;
            node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
    }
    return null;
}
var $5c00e1cb1faeed50$var$renderLanes = 0, $5c00e1cb1faeed50$var$currentlyRenderingFiber = null, $5c00e1cb1faeed50$var$currentHook = null, $5c00e1cb1faeed50$var$workInProgressHook = null, $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdate = !1, $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass = !1, $5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV = !1, $5c00e1cb1faeed50$var$localIdCounter = 0, $5c00e1cb1faeed50$var$thenableIndexCounter = 0, $5c00e1cb1faeed50$var$thenableState = null, $5c00e1cb1faeed50$var$globalClientIdCounter = 0;
function $5c00e1cb1faeed50$var$throwInvalidHookError() {
    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(321));
}
function $5c00e1cb1faeed50$var$areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return !1;
    for(var i = 0; i < prevDeps.length && i < nextDeps.length; i++)if (!$5c00e1cb1faeed50$var$objectIs(nextDeps[i], prevDeps[i])) return !1;
    return !0;
}
function $5c00e1cb1faeed50$var$renderWithHooks(current, workInProgress, Component, props, secondArg, nextRenderLanes) {
    $5c00e1cb1faeed50$var$renderLanes = nextRenderLanes;
    $5c00e1cb1faeed50$var$currentlyRenderingFiber = workInProgress;
    workInProgress.memoizedState = null;
    workInProgress.updateQueue = null;
    workInProgress.lanes = 0;
    $5c00e1cb1faeed50$var$ReactSharedInternals.H = null === current || null === current.memoizedState ? $5c00e1cb1faeed50$var$HooksDispatcherOnMount : $5c00e1cb1faeed50$var$HooksDispatcherOnUpdate;
    $5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    nextRenderLanes = Component(props, secondArg);
    $5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV = !1;
    $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = $5c00e1cb1faeed50$var$renderWithHooksAgain(workInProgress, Component, props, secondArg));
    $5c00e1cb1faeed50$var$finishRenderingHooks(current);
    return nextRenderLanes;
}
function $5c00e1cb1faeed50$var$finishRenderingHooks(current) {
    $5c00e1cb1faeed50$var$ReactSharedInternals.H = $5c00e1cb1faeed50$var$ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== $5c00e1cb1faeed50$var$currentHook && null !== $5c00e1cb1faeed50$var$currentHook.next;
    $5c00e1cb1faeed50$var$renderLanes = 0;
    $5c00e1cb1faeed50$var$workInProgressHook = $5c00e1cb1faeed50$var$currentHook = $5c00e1cb1faeed50$var$currentlyRenderingFiber = null;
    $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdate = !1;
    $5c00e1cb1faeed50$var$thenableIndexCounter = 0;
    $5c00e1cb1faeed50$var$thenableState = null;
    if (didRenderTooFewHooks) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(300));
    null === current || $5c00e1cb1faeed50$var$didReceiveUpdate || (current = current.dependencies, null !== current && $5c00e1cb1faeed50$var$checkIfContextChanged(current) && ($5c00e1cb1faeed50$var$didReceiveUpdate = !0));
}
function $5c00e1cb1faeed50$var$renderWithHooksAgain(workInProgress, Component, props, secondArg) {
    $5c00e1cb1faeed50$var$currentlyRenderingFiber = workInProgress;
    var numberOfReRenders = 0;
    do {
        $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass && ($5c00e1cb1faeed50$var$thenableState = null);
        $5c00e1cb1faeed50$var$thenableIndexCounter = 0;
        $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
        if (25 <= numberOfReRenders) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(301));
        numberOfReRenders += 1;
        $5c00e1cb1faeed50$var$workInProgressHook = $5c00e1cb1faeed50$var$currentHook = null;
        if (null != workInProgress.updateQueue) {
            var children = workInProgress.updateQueue;
            children.lastEffect = null;
            children.events = null;
            children.stores = null;
            null != children.memoCache && (children.memoCache.index = 0);
        }
        $5c00e1cb1faeed50$var$ReactSharedInternals.H = $5c00e1cb1faeed50$var$HooksDispatcherOnRerender;
        children = Component(props, secondArg);
    }while ($5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
}
function $5c00e1cb1faeed50$var$TransitionAwareHostComponent() {
    var dispatcher = $5c00e1cb1faeed50$var$ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? $5c00e1cb1faeed50$var$useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== $5c00e1cb1faeed50$var$currentHook ? $5c00e1cb1faeed50$var$currentHook.memoizedState : null) !== dispatcher && ($5c00e1cb1faeed50$var$currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
}
function $5c00e1cb1faeed50$var$checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== $5c00e1cb1faeed50$var$localIdCounter;
    $5c00e1cb1faeed50$var$localIdCounter = 0;
    return didRenderIdHook;
}
function $5c00e1cb1faeed50$var$bailoutHooks(current, workInProgress, lanes) {
    workInProgress.updateQueue = current.updateQueue;
    workInProgress.flags &= -2053;
    current.lanes &= ~lanes;
}
function $5c00e1cb1faeed50$var$resetHooksOnUnwind(workInProgress) {
    if ($5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdate) {
        for(workInProgress = workInProgress.memoizedState; null !== workInProgress;){
            var queue = workInProgress.queue;
            null !== queue && (queue.pending = null);
            workInProgress = workInProgress.next;
        }
        $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdate = !1;
    }
    $5c00e1cb1faeed50$var$renderLanes = 0;
    $5c00e1cb1faeed50$var$workInProgressHook = $5c00e1cb1faeed50$var$currentHook = $5c00e1cb1faeed50$var$currentlyRenderingFiber = null;
    $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass = !1;
    $5c00e1cb1faeed50$var$thenableIndexCounter = $5c00e1cb1faeed50$var$localIdCounter = 0;
    $5c00e1cb1faeed50$var$thenableState = null;
}
function $5c00e1cb1faeed50$var$mountWorkInProgressHook() {
    var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
    };
    null === $5c00e1cb1faeed50$var$workInProgressHook ? $5c00e1cb1faeed50$var$currentlyRenderingFiber.memoizedState = $5c00e1cb1faeed50$var$workInProgressHook = hook : $5c00e1cb1faeed50$var$workInProgressHook = $5c00e1cb1faeed50$var$workInProgressHook.next = hook;
    return $5c00e1cb1faeed50$var$workInProgressHook;
}
function $5c00e1cb1faeed50$var$updateWorkInProgressHook() {
    if (null === $5c00e1cb1faeed50$var$currentHook) {
        var nextCurrentHook = $5c00e1cb1faeed50$var$currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = $5c00e1cb1faeed50$var$currentHook.next;
    var nextWorkInProgressHook = null === $5c00e1cb1faeed50$var$workInProgressHook ? $5c00e1cb1faeed50$var$currentlyRenderingFiber.memoizedState : $5c00e1cb1faeed50$var$workInProgressHook.next;
    if (null !== nextWorkInProgressHook) $5c00e1cb1faeed50$var$workInProgressHook = nextWorkInProgressHook, $5c00e1cb1faeed50$var$currentHook = nextCurrentHook;
    else {
        if (null === nextCurrentHook) {
            if (null === $5c00e1cb1faeed50$var$currentlyRenderingFiber.alternate) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(467));
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(310));
        }
        $5c00e1cb1faeed50$var$currentHook = nextCurrentHook;
        nextCurrentHook = {
            memoizedState: $5c00e1cb1faeed50$var$currentHook.memoizedState,
            baseState: $5c00e1cb1faeed50$var$currentHook.baseState,
            baseQueue: $5c00e1cb1faeed50$var$currentHook.baseQueue,
            queue: $5c00e1cb1faeed50$var$currentHook.queue,
            next: null
        };
        null === $5c00e1cb1faeed50$var$workInProgressHook ? $5c00e1cb1faeed50$var$currentlyRenderingFiber.memoizedState = $5c00e1cb1faeed50$var$workInProgressHook = nextCurrentHook : $5c00e1cb1faeed50$var$workInProgressHook = $5c00e1cb1faeed50$var$workInProgressHook.next = nextCurrentHook;
    }
    return $5c00e1cb1faeed50$var$workInProgressHook;
}
function $5c00e1cb1faeed50$var$createFunctionComponentUpdateQueue() {
    return {
        lastEffect: null,
        events: null,
        stores: null,
        memoCache: null
    };
}
function $5c00e1cb1faeed50$var$useThenable(thenable) {
    var index = $5c00e1cb1faeed50$var$thenableIndexCounter;
    $5c00e1cb1faeed50$var$thenableIndexCounter += 1;
    null === $5c00e1cb1faeed50$var$thenableState && ($5c00e1cb1faeed50$var$thenableState = []);
    thenable = $5c00e1cb1faeed50$var$trackUsedThenable($5c00e1cb1faeed50$var$thenableState, thenable, index);
    index = $5c00e1cb1faeed50$var$currentlyRenderingFiber;
    null === (null === $5c00e1cb1faeed50$var$workInProgressHook ? index.memoizedState : $5c00e1cb1faeed50$var$workInProgressHook.next) && (index = index.alternate, $5c00e1cb1faeed50$var$ReactSharedInternals.H = null === index || null === index.memoizedState ? $5c00e1cb1faeed50$var$HooksDispatcherOnMount : $5c00e1cb1faeed50$var$HooksDispatcherOnUpdate);
    return thenable;
}
function $5c00e1cb1faeed50$var$use(usable) {
    if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return $5c00e1cb1faeed50$var$useThenable(usable);
        if (usable.$$typeof === $5c00e1cb1faeed50$var$REACT_RECOVERABLE_TYPE) return;
        if (usable.$$typeof === $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE) return $5c00e1cb1faeed50$var$readContext(usable);
    }
    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(438, String(usable)));
}
function $5c00e1cb1faeed50$var$useMemoCache(size) {
    var memoCache = null, updateQueue = $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
        var current = $5c00e1cb1faeed50$var$currentlyRenderingFiber.alternate;
        null !== current && (current = current.updateQueue, null !== current && (current = current.memoCache, null != current && (memoCache = {
            data: current.data.map(function(array) {
                return array.slice();
            }),
            index: 0
        })));
    }
    null == memoCache && (memoCache = {
        data: [],
        index: 0
    });
    null === updateQueue && (updateQueue = $5c00e1cb1faeed50$var$createFunctionComponentUpdateQueue(), $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue) for(updateQueue = memoCache.data[memoCache.index] = Array(size), current = 0; current < size; current++)updateQueue[current] = $5c00e1cb1faeed50$var$REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
}
function $5c00e1cb1faeed50$var$basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
}
function $5c00e1cb1faeed50$var$updateReducer(reducer) {
    var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    return $5c00e1cb1faeed50$var$updateReducerImpl(hook, $5c00e1cb1faeed50$var$currentHook, reducer);
}
function $5c00e1cb1faeed50$var$updateReducerImpl(hook, current, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
        if (null !== baseQueue) {
            var baseFirst = baseQueue.next;
            baseQueue.next = pendingQueue.next;
            pendingQueue.next = baseFirst;
        }
        current.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
        current = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current, didReadFromEntangledAsyncAction$64 = !1;
        do {
            var updateLane = update.lane & -536870913;
            if (updateLane !== update.lane ? ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & updateLane) === updateLane : ($5c00e1cb1faeed50$var$renderLanes & updateLane) === updateLane) {
                var revertLane = update.revertLane;
                if (0 === revertLane) null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                    lane: 0,
                    revertLane: 0,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }), updateLane === $5c00e1cb1faeed50$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                else if (($5c00e1cb1faeed50$var$renderLanes & revertLane) === revertLane) {
                    update = update.next;
                    revertLane === $5c00e1cb1faeed50$var$currentEntangledLane && (didReadFromEntangledAsyncAction$64 = !0);
                    continue;
                } else updateLane = {
                    lane: 0,
                    revertLane: update.revertLane,
                    gesture: null,
                    action: update.action,
                    hasEagerState: update.hasEagerState,
                    eagerState: update.eagerState,
                    next: null
                }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, $5c00e1cb1faeed50$var$currentlyRenderingFiber.lanes |= revertLane, $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes |= revertLane;
                updateLane = update.action;
                $5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
                pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
            } else revertLane = {
                lane: updateLane,
                revertLane: update.revertLane,
                gesture: update.gesture,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, $5c00e1cb1faeed50$var$currentlyRenderingFiber.lanes |= updateLane, $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes |= updateLane;
            update = update.next;
        }while (null !== update && update !== current);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!$5c00e1cb1faeed50$var$objectIs(pendingQueue, hook.memoizedState) && ($5c00e1cb1faeed50$var$didReceiveUpdate = !0, didReadFromEntangledAsyncAction$64 && (reducer = $5c00e1cb1faeed50$var$currentEntangledActionThenable, null !== reducer))) throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [
        hook.memoizedState,
        queue.dispatch
    ];
}
function $5c00e1cb1faeed50$var$rerenderReducer(reducer) {
    var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        $5c00e1cb1faeed50$var$objectIs(newState, hook.memoizedState) || ($5c00e1cb1faeed50$var$didReceiveUpdate = !0);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
    }
    return [
        newState,
        dispatch
    ];
}
function $5c00e1cb1faeed50$var$updateSyncExternalStore(subscribe, getSnapshot, getServerSnapshot) {
    var fiber = $5c00e1cb1faeed50$var$currentlyRenderingFiber, hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook(), isHydrating$jscomp$0 = $5c00e1cb1faeed50$var$isHydrating;
    if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(407));
        getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !$5c00e1cb1faeed50$var$objectIs(($5c00e1cb1faeed50$var$currentHook || hook).memoizedState, getServerSnapshot);
    snapshotChanged && (hook.memoizedState = getServerSnapshot, $5c00e1cb1faeed50$var$didReceiveUpdate = !0);
    hook = hook.queue;
    $5c00e1cb1faeed50$var$updateEffect($5c00e1cb1faeed50$var$subscribeToStore.bind(null, fiber, hook, subscribe), [
        subscribe
    ]);
    subscribe = hook.getSnapshot !== getSnapshot || snapshotChanged || null !== $5c00e1cb1faeed50$var$workInProgressHook && 0 !== ($5c00e1cb1faeed50$var$workInProgressHook.memoizedState.tag & 1);
    $5c00e1cb1faeed50$var$pushSimpleEffect(subscribe ? 9 : 8, {
        destroy: void 0
    }, $5c00e1cb1faeed50$var$updateStoreInstance.bind(null, fiber, hook, getServerSnapshot, getSnapshot), null);
    if (subscribe) {
        fiber.flags |= 2048;
        if (null === $5c00e1cb1faeed50$var$workInProgressRoot) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(349));
        isHydrating$jscomp$0 || 0 !== ($5c00e1cb1faeed50$var$renderLanes & 127) || $5c00e1cb1faeed50$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
}
function $5c00e1cb1faeed50$var$pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = {
        getSnapshot: getSnapshot,
        value: renderedSnapshot
    };
    getSnapshot = $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = $5c00e1cb1faeed50$var$createFunctionComponentUpdateQueue(), $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [
        fiber
    ]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [
        fiber
    ] : renderedSnapshot.push(fiber));
}
function $5c00e1cb1faeed50$var$updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    $5c00e1cb1faeed50$var$checkIfSnapshotChanged(inst) && $5c00e1cb1faeed50$var$forceStoreRerender(fiber);
}
function $5c00e1cb1faeed50$var$subscribeToStore(fiber, inst, subscribe) {
    return subscribe(function() {
        $5c00e1cb1faeed50$var$checkIfSnapshotChanged(inst) && $5c00e1cb1faeed50$var$forceStoreRerender(fiber);
    });
}
function $5c00e1cb1faeed50$var$checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
        var nextValue = latestGetSnapshot();
        return !$5c00e1cb1faeed50$var$objectIs(inst, nextValue);
    } catch (error) {
        return !0;
    }
}
function $5c00e1cb1faeed50$var$forceStoreRerender(fiber) {
    var root = $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(fiber, 2);
    null !== root && $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(root, fiber, 2);
}
function $5c00e1cb1faeed50$var$mountStateImpl(initialState) {
    var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
    if ("function" === typeof initialState) {
        var initialStateInitializer = initialState;
        initialState = initialStateInitializer();
        if ($5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!0);
            try {
                initialStateInitializer();
            } finally{
                $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!1);
            }
        }
    }
    hook.memoizedState = hook.baseState = initialState;
    hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5c00e1cb1faeed50$var$basicStateReducer,
        lastRenderedState: initialState
    };
    return hook;
}
function $5c00e1cb1faeed50$var$updateOptimisticImpl(hook, current, passthrough, reducer) {
    hook.baseState = passthrough;
    return $5c00e1cb1faeed50$var$updateReducerImpl(hook, $5c00e1cb1faeed50$var$currentHook, "function" === typeof reducer ? reducer : $5c00e1cb1faeed50$var$basicStateReducer);
}
function $5c00e1cb1faeed50$var$dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if ($5c00e1cb1faeed50$var$isRenderPhaseUpdate(fiber)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
        var actionNode = {
            payload: payload,
            action: fiber,
            next: null,
            isTransition: !0,
            status: "pending",
            value: null,
            reason: null,
            listeners: [],
            then: function(listener) {
                actionNode.listeners.push(listener);
            }
        };
        null !== $5c00e1cb1faeed50$var$ReactSharedInternals.T ? setPendingState(!0) : actionNode.isTransition = !1;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, $5c00e1cb1faeed50$var$runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
}
function $5c00e1cb1faeed50$var$runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
        var prevTransition = $5c00e1cb1faeed50$var$ReactSharedInternals.T, currentTransition = {};
        currentTransition.types = null !== prevTransition ? prevTransition.types : null;
        $5c00e1cb1faeed50$var$ReactSharedInternals.T = currentTransition;
        try {
            var returnValue = action(prevState, payload), onStartTransitionFinish = $5c00e1cb1faeed50$var$ReactSharedInternals.S;
            null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
            $5c00e1cb1faeed50$var$handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
            $5c00e1cb1faeed50$var$onActionError(actionQueue, node, error);
        } finally{
            null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5c00e1cb1faeed50$var$ReactSharedInternals.T = prevTransition;
        }
    } else try {
        prevTransition = action(prevState, payload), $5c00e1cb1faeed50$var$handleActionReturnValue(actionQueue, node, prevTransition);
    } catch (error$70) {
        $5c00e1cb1faeed50$var$onActionError(actionQueue, node, error$70);
    }
}
function $5c00e1cb1faeed50$var$handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(function(nextState) {
        $5c00e1cb1faeed50$var$onActionSuccess(actionQueue, node, nextState);
    }, function(error) {
        return $5c00e1cb1faeed50$var$onActionError(actionQueue, node, error);
    }) : $5c00e1cb1faeed50$var$onActionSuccess(actionQueue, node, returnValue);
}
function $5c00e1cb1faeed50$var$onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    $5c00e1cb1faeed50$var$notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, $5c00e1cb1faeed50$var$runActionStateAction(actionQueue, nextState)));
}
function $5c00e1cb1faeed50$var$onActionError(actionQueue, actionNode, error) {
    var last = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last) {
        last = last.next;
        do actionNode.status = "rejected", actionNode.reason = error, $5c00e1cb1faeed50$var$notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last);
    }
    actionQueue.action = null;
}
function $5c00e1cb1faeed50$var$notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for(var i = 0; i < actionNode.length; i++)(0, actionNode[i])();
}
function $5c00e1cb1faeed50$var$actionStateReducer(oldState, newState) {
    return newState;
}
function $5c00e1cb1faeed50$var$mountActionState(action, initialStateProp) {
    if ($5c00e1cb1faeed50$var$isHydrating) {
        var ssrFormState = $5c00e1cb1faeed50$var$workInProgressRoot.formState;
        if (null !== ssrFormState) {
            a: {
                var JSCompiler_inline_result = $5c00e1cb1faeed50$var$currentlyRenderingFiber;
                if ($5c00e1cb1faeed50$var$isHydrating) {
                    if ($5c00e1cb1faeed50$var$nextHydratableInstance) {
                        b: {
                            var JSCompiler_inline_result$jscomp$0 = $5c00e1cb1faeed50$var$nextHydratableInstance;
                            for(var inRootOrSingleton = $5c00e1cb1faeed50$var$rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType;){
                                if (!inRootOrSingleton) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                                JSCompiler_inline_result$jscomp$0 = $5c00e1cb1faeed50$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                                if (null === JSCompiler_inline_result$jscomp$0) {
                                    JSCompiler_inline_result$jscomp$0 = null;
                                    break b;
                                }
                            }
                            inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                            JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
                        }
                        if (JSCompiler_inline_result$jscomp$0) {
                            $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratable(JSCompiler_inline_result$jscomp$0.nextSibling);
                            JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                            break a;
                        }
                    }
                    $5c00e1cb1faeed50$var$throwOnHydrationMismatch(JSCompiler_inline_result);
                }
                JSCompiler_inline_result = !1;
            }
            JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
        }
    }
    ssrFormState = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: $5c00e1cb1faeed50$var$actionStateReducer,
        lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = $5c00e1cb1faeed50$var$dispatchSetState.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, JSCompiler_inline_result);
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = $5c00e1cb1faeed50$var$mountStateImpl(!1);
    inRootOrSingleton = $5c00e1cb1faeed50$var$dispatchOptimisticSetState.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, !1, JSCompiler_inline_result.queue);
    JSCompiler_inline_result = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
        state: initialStateProp,
        dispatch: null,
        action: action,
        pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = $5c00e1cb1faeed50$var$dispatchActionState.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, JSCompiler_inline_result$jscomp$0, inRootOrSingleton, ssrFormState);
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [
        initialStateProp,
        ssrFormState,
        !1
    ];
}
function $5c00e1cb1faeed50$var$updateActionState(action) {
    var stateHook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    return $5c00e1cb1faeed50$var$updateActionStateImpl(stateHook, $5c00e1cb1faeed50$var$currentHook, action);
}
function $5c00e1cb1faeed50$var$updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = $5c00e1cb1faeed50$var$updateReducerImpl(stateHook, currentStateHook, $5c00e1cb1faeed50$var$actionStateReducer)[0];
    stateHook = $5c00e1cb1faeed50$var$updateReducer($5c00e1cb1faeed50$var$basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then) try {
        var state = $5c00e1cb1faeed50$var$useThenable(currentStateHook);
    } catch (x) {
        if (x === $5c00e1cb1faeed50$var$SuspenseException) throw $5c00e1cb1faeed50$var$SuspenseActionException;
        throw x;
    }
    else state = currentStateHook;
    currentStateHook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && ($5c00e1cb1faeed50$var$currentlyRenderingFiber.flags |= 2048, $5c00e1cb1faeed50$var$pushSimpleEffect(9, {
        destroy: void 0
    }, $5c00e1cb1faeed50$var$actionStateActionEffect.bind(null, actionQueue, action), null));
    return [
        state,
        dispatch,
        stateHook
    ];
}
function $5c00e1cb1faeed50$var$actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
}
function $5c00e1cb1faeed50$var$rerenderActionState(action) {
    var stateHook = $5c00e1cb1faeed50$var$updateWorkInProgressHook(), currentStateHook = $5c00e1cb1faeed50$var$currentHook;
    if (null !== currentStateHook) return $5c00e1cb1faeed50$var$updateActionStateImpl(stateHook, currentStateHook, action);
    $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [
        stateHook,
        dispatch,
        !1
    ];
}
function $5c00e1cb1faeed50$var$pushSimpleEffect(tag, inst, create, deps) {
    tag = {
        tag: tag,
        create: create,
        deps: deps,
        inst: inst,
        next: null
    };
    inst = $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue;
    null === inst && (inst = $5c00e1cb1faeed50$var$createFunctionComponentUpdateQueue(), $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue = inst);
    create = inst.lastEffect;
    null === create ? inst.lastEffect = tag.next = tag : (deps = create.next, create.next = tag, tag.next = deps, inst.lastEffect = tag);
    return tag;
}
function $5c00e1cb1faeed50$var$updateRef() {
    return $5c00e1cb1faeed50$var$updateWorkInProgressHook().memoizedState;
}
function $5c00e1cb1faeed50$var$mountEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
    $5c00e1cb1faeed50$var$currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = $5c00e1cb1faeed50$var$pushSimpleEffect(1 | hookFlags, {
        destroy: void 0
    }, create, void 0 === deps ? null : deps);
}
function $5c00e1cb1faeed50$var$updateEffectImpl(fiberFlags, hookFlags, create, deps) {
    var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== $5c00e1cb1faeed50$var$currentHook && null !== deps && $5c00e1cb1faeed50$var$areHookInputsEqual(deps, $5c00e1cb1faeed50$var$currentHook.memoizedState.deps) ? hook.memoizedState = $5c00e1cb1faeed50$var$pushSimpleEffect(hookFlags, inst, create, deps) : ($5c00e1cb1faeed50$var$currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = $5c00e1cb1faeed50$var$pushSimpleEffect(1 | hookFlags, inst, create, deps));
}
function $5c00e1cb1faeed50$var$mountEffect(create, deps) {
    $5c00e1cb1faeed50$var$mountEffectImpl(8390656, 8, create, deps);
}
function $5c00e1cb1faeed50$var$updateEffect(create, deps) {
    $5c00e1cb1faeed50$var$updateEffectImpl(2048, 8, create, deps);
}
function $5c00e1cb1faeed50$var$useEffectEventImpl(payload) {
    $5c00e1cb1faeed50$var$currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue) componentUpdateQueue = $5c00e1cb1faeed50$var$createFunctionComponentUpdateQueue(), $5c00e1cb1faeed50$var$currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [
        payload
    ];
    else {
        var events = componentUpdateQueue.events;
        null === events ? componentUpdateQueue.events = [
            payload
        ] : events.push(payload);
    }
}
function $5c00e1cb1faeed50$var$updateEvent(callback) {
    var ref = $5c00e1cb1faeed50$var$updateWorkInProgressHook().memoizedState;
    $5c00e1cb1faeed50$var$useEffectEventImpl({
        ref: ref,
        nextImpl: callback
    });
    return function() {
        if (0 !== ($5c00e1cb1faeed50$var$executionContext & 2)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(440));
        return ref.impl.apply(void 0, arguments);
    };
}
function $5c00e1cb1faeed50$var$updateInsertionEffect(create, deps) {
    return $5c00e1cb1faeed50$var$updateEffectImpl(4, 2, create, deps);
}
function $5c00e1cb1faeed50$var$updateLayoutEffect(create, deps) {
    return $5c00e1cb1faeed50$var$updateEffectImpl(4, 4, create, deps);
}
function $5c00e1cb1faeed50$var$imperativeHandleEffect(create, ref) {
    if ("function" === typeof ref) {
        create = create();
        var refCleanup = ref(create);
        return function() {
            "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
    }
    if (null !== ref && void 0 !== ref) return create = create(), ref.current = create, function() {
        ref.current = null;
    };
}
function $5c00e1cb1faeed50$var$updateImperativeHandle(ref, create, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([
        ref
    ]) : null;
    $5c00e1cb1faeed50$var$updateEffectImpl(4, 4, $5c00e1cb1faeed50$var$imperativeHandleEffect.bind(null, create, ref), deps);
}
function $5c00e1cb1faeed50$var$mountDebugValue() {}
function $5c00e1cb1faeed50$var$updateCallback(callback, deps) {
    var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $5c00e1cb1faeed50$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    hook.memoizedState = [
        callback,
        deps
    ];
    return callback;
}
function $5c00e1cb1faeed50$var$updateMemo(nextCreate, deps) {
    var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && $5c00e1cb1faeed50$var$areHookInputsEqual(deps, prevState[1])) return prevState[0];
    prevState = nextCreate();
    if ($5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV) {
        $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!0);
        try {
            nextCreate();
        } finally{
            $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!1);
        }
    }
    hook.memoizedState = [
        prevState,
        deps
    ];
    return prevState;
}
function $5c00e1cb1faeed50$var$mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== ($5c00e1cb1faeed50$var$renderLanes & 1073741824) && 0 === ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 261930)) return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = $5c00e1cb1faeed50$var$requestDeferredLane();
    $5c00e1cb1faeed50$var$currentlyRenderingFiber.lanes |= hook;
    $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes |= hook;
    return initialValue;
}
function $5c00e1cb1faeed50$var$updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if ($5c00e1cb1faeed50$var$objectIs(value, prevValue)) return value;
    if (null !== $5c00e1cb1faeed50$var$currentTreeHiddenStackCursor.current) return hook = $5c00e1cb1faeed50$var$mountDeferredValueImpl(hook, value, initialValue), $5c00e1cb1faeed50$var$objectIs(hook, prevValue) || ($5c00e1cb1faeed50$var$didReceiveUpdate = !0), hook;
    if (0 === ($5c00e1cb1faeed50$var$renderLanes & 106) || 0 !== ($5c00e1cb1faeed50$var$renderLanes & 1073741824) && 0 === ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 261930)) return $5c00e1cb1faeed50$var$didReceiveUpdate = !0, hook.memoizedState = value;
    hook = $5c00e1cb1faeed50$var$requestDeferredLane();
    $5c00e1cb1faeed50$var$currentlyRenderingFiber.lanes |= hook;
    $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes |= hook;
    return prevValue;
}
function $5c00e1cb1faeed50$var$startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
    $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = $5c00e1cb1faeed50$var$ReactSharedInternals.T, currentTransition = {};
    currentTransition.types = null !== prevTransition ? prevTransition.types : null;
    $5c00e1cb1faeed50$var$ReactSharedInternals.T = currentTransition;
    $5c00e1cb1faeed50$var$dispatchOptimisticSetState(fiber, !1, queue, pendingState);
    try {
        var returnValue = callback(), onStartTransitionFinish = $5c00e1cb1faeed50$var$ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
            var thenableForFinishedState = $5c00e1cb1faeed50$var$chainThenableValue(returnValue, finishedState);
            $5c00e1cb1faeed50$var$dispatchSetStateInternal(fiber, queue, thenableForFinishedState, $5c00e1cb1faeed50$var$requestUpdateLane(fiber));
        } else $5c00e1cb1faeed50$var$dispatchSetStateInternal(fiber, queue, finishedState, $5c00e1cb1faeed50$var$requestUpdateLane(fiber));
    } catch (error) {
        $5c00e1cb1faeed50$var$dispatchSetStateInternal(fiber, queue, {
            then: function() {},
            status: "rejected",
            reason: error
        }, $5c00e1cb1faeed50$var$requestUpdateLane());
    } finally{
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), $5c00e1cb1faeed50$var$ReactSharedInternals.T = prevTransition;
    }
}
function $5c00e1cb1faeed50$var$noop() {}
function $5c00e1cb1faeed50$var$startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(476));
    var queue = $5c00e1cb1faeed50$var$ensureFormComponentIsStateful(formFiber).queue;
    $5c00e1cb1faeed50$var$startTransition(formFiber, queue, pendingState, $5c00e1cb1faeed50$var$sharedNotPendingObject, null === action ? $5c00e1cb1faeed50$var$noop : function() {
        $5c00e1cb1faeed50$var$requestFormReset$1(formFiber);
        return action(formData);
    });
}
function $5c00e1cb1faeed50$var$ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
        memoizedState: $5c00e1cb1faeed50$var$sharedNotPendingObject,
        baseState: $5c00e1cb1faeed50$var$sharedNotPendingObject,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $5c00e1cb1faeed50$var$basicStateReducer,
            lastRenderedState: $5c00e1cb1faeed50$var$sharedNotPendingObject
        },
        next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: $5c00e1cb1faeed50$var$basicStateReducer,
            lastRenderedState: initialResetState
        },
        next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
}
function $5c00e1cb1faeed50$var$requestFormReset$1(formFiber) {
    var stateHook = $5c00e1cb1faeed50$var$ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    $5c00e1cb1faeed50$var$dispatchSetStateInternal(formFiber, stateHook.next.queue, {}, $5c00e1cb1faeed50$var$requestUpdateLane());
}
function $5c00e1cb1faeed50$var$useHostTransitionStatus() {
    return $5c00e1cb1faeed50$var$readContext($5c00e1cb1faeed50$var$HostTransitionContext);
}
function $5c00e1cb1faeed50$var$updateId() {
    return $5c00e1cb1faeed50$var$updateWorkInProgressHook().memoizedState;
}
function $5c00e1cb1faeed50$var$updateRefresh() {
    return $5c00e1cb1faeed50$var$updateWorkInProgressHook().memoizedState;
}
function $5c00e1cb1faeed50$var$refreshCache(fiber) {
    for(var provider = fiber.return; null !== provider;){
        switch(provider.tag){
            case 24:
            case 3:
                var lane = $5c00e1cb1faeed50$var$requestUpdateLane();
                fiber = $5c00e1cb1faeed50$var$createUpdate(lane);
                var root$73 = $5c00e1cb1faeed50$var$enqueueUpdate(provider, fiber, lane);
                null !== root$73 && ($5c00e1cb1faeed50$var$scheduleUpdateOnFiber(root$73, provider, lane), $5c00e1cb1faeed50$var$entangleTransitions(root$73, provider, lane));
                provider = {
                    cache: $5c00e1cb1faeed50$var$createCache()
                };
                fiber.payload = provider;
                return;
        }
        provider = provider.return;
    }
}
function $5c00e1cb1faeed50$var$dispatchReducerAction(fiber, queue, action) {
    var lane = $5c00e1cb1faeed50$var$requestUpdateLane();
    action = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    $5c00e1cb1faeed50$var$isRenderPhaseUpdate(fiber) ? $5c00e1cb1faeed50$var$enqueueRenderPhaseUpdate(queue, action) : (action = $5c00e1cb1faeed50$var$enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && ($5c00e1cb1faeed50$var$scheduleUpdateOnFiber(action, fiber, lane), $5c00e1cb1faeed50$var$entangleTransitionUpdate(action, queue, lane)));
}
function $5c00e1cb1faeed50$var$dispatchSetState(fiber, queue, action) {
    var lane = $5c00e1cb1faeed50$var$requestUpdateLane();
    $5c00e1cb1faeed50$var$dispatchSetStateInternal(fiber, queue, action, lane);
}
function $5c00e1cb1faeed50$var$dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
        lane: lane,
        revertLane: 0,
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5c00e1cb1faeed50$var$isRenderPhaseUpdate(fiber)) $5c00e1cb1faeed50$var$enqueueRenderPhaseUpdate(queue, update);
    else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = !0;
            update.eagerState = eagerState;
            if ($5c00e1cb1faeed50$var$objectIs(eagerState, currentState)) return $5c00e1cb1faeed50$var$enqueueUpdate$1(fiber, queue, update, 0), null === $5c00e1cb1faeed50$var$workInProgressRoot && $5c00e1cb1faeed50$var$finishQueueingConcurrentUpdates(), !1;
        } catch (error) {} finally{}
        action = $5c00e1cb1faeed50$var$enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action) return $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(action, fiber, lane), $5c00e1cb1faeed50$var$entangleTransitionUpdate(action, queue, lane), !0;
    }
    return !1;
}
function $5c00e1cb1faeed50$var$dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
        lane: 2,
        revertLane: $5c00e1cb1faeed50$var$requestTransitionLane(),
        gesture: null,
        action: action,
        hasEagerState: !1,
        eagerState: null,
        next: null
    };
    if ($5c00e1cb1faeed50$var$isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(479));
    } else throwIfDuringRender = $5c00e1cb1faeed50$var$enqueueConcurrentHookUpdate(fiber, queue, action, 2), null !== throwIfDuringRender && $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
}
function $5c00e1cb1faeed50$var$isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === $5c00e1cb1faeed50$var$currentlyRenderingFiber || null !== alternate && alternate === $5c00e1cb1faeed50$var$currentlyRenderingFiber;
}
function $5c00e1cb1faeed50$var$enqueueRenderPhaseUpdate(queue, update) {
    $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdateDuringThisPass = $5c00e1cb1faeed50$var$didScheduleRenderPhaseUpdate = !0;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
}
function $5c00e1cb1faeed50$var$entangleTransitionUpdate(root, queue, lane) {
    if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        $5c00e1cb1faeed50$var$markRootEntangled(root, lane);
    }
}
var $5c00e1cb1faeed50$var$ContextOnlyDispatcher = {
    readContext: $5c00e1cb1faeed50$var$readContext,
    use: $5c00e1cb1faeed50$var$use,
    useCallback: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useContext: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useEffect: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useImperativeHandle: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useLayoutEffect: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useInsertionEffect: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useMemo: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useReducer: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useRef: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useState: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useDebugValue: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useDeferredValue: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useTransition: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useSyncExternalStore: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useId: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useHostTransitionStatus: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useFormState: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useActionState: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useOptimistic: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useMemoCache: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useCacheRefresh: $5c00e1cb1faeed50$var$throwInvalidHookError,
    useEffectEvent: $5c00e1cb1faeed50$var$throwInvalidHookError
}, $5c00e1cb1faeed50$var$HooksDispatcherOnMount = {
    readContext: $5c00e1cb1faeed50$var$readContext,
    use: $5c00e1cb1faeed50$var$use,
    useCallback: function(callback, deps) {
        $5c00e1cb1faeed50$var$mountWorkInProgressHook().memoizedState = [
            callback,
            void 0 === deps ? null : deps
        ];
        return callback;
    },
    useContext: $5c00e1cb1faeed50$var$readContext,
    useEffect: $5c00e1cb1faeed50$var$mountEffect,
    useImperativeHandle: function(ref, create, deps) {
        deps = null !== deps && void 0 !== deps ? deps.concat([
            ref
        ]) : null;
        $5c00e1cb1faeed50$var$mountEffectImpl(4194308, 4, $5c00e1cb1faeed50$var$imperativeHandleEffect.bind(null, create, ref), deps);
    },
    useLayoutEffect: function(create, deps) {
        return $5c00e1cb1faeed50$var$mountEffectImpl(4194308, 4, create, deps);
    },
    useInsertionEffect: function(create, deps) {
        $5c00e1cb1faeed50$var$mountEffectImpl(4, 2, create, deps);
    },
    useMemo: function(nextCreate, deps) {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
        deps = void 0 === deps ? null : deps;
        var nextValue = nextCreate();
        if ($5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV) {
            $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!0);
            try {
                nextCreate();
            } finally{
                $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!1);
            }
        }
        hook.memoizedState = [
            nextValue,
            deps
        ];
        return nextValue;
    },
    useReducer: function(reducer, initialArg, init) {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
        if (void 0 !== init) {
            var initialState = init(initialArg);
            if ($5c00e1cb1faeed50$var$shouldDoubleInvokeUserFnsInHooksDEV) {
                $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!0);
                try {
                    init(initialArg);
                } finally{
                    $5c00e1cb1faeed50$var$setIsStrictModeForDevtools(!1);
                }
            }
        } else initialState = initialArg;
        hook.memoizedState = hook.baseState = initialState;
        reducer = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: reducer,
            lastRenderedState: initialState
        };
        hook.queue = reducer;
        reducer = reducer.dispatch = $5c00e1cb1faeed50$var$dispatchReducerAction.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, reducer);
        return [
            hook.memoizedState,
            reducer
        ];
    },
    useRef: function(initialValue) {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
        initialValue = {
            current: initialValue
        };
        return hook.memoizedState = initialValue;
    },
    useState: function(initialState) {
        initialState = $5c00e1cb1faeed50$var$mountStateImpl(initialState);
        var queue = initialState.queue, dispatch = $5c00e1cb1faeed50$var$dispatchSetState.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, queue);
        queue.dispatch = dispatch;
        return [
            initialState.memoizedState,
            dispatch
        ];
    },
    useDebugValue: $5c00e1cb1faeed50$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
        return $5c00e1cb1faeed50$var$mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
        var stateHook = $5c00e1cb1faeed50$var$mountStateImpl(!1);
        stateHook = $5c00e1cb1faeed50$var$startTransition.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, stateHook.queue, !0, !1);
        $5c00e1cb1faeed50$var$mountWorkInProgressHook().memoizedState = stateHook;
        return [
            !1,
            stateHook
        ];
    },
    useSyncExternalStore: function(subscribe, getSnapshot, getServerSnapshot) {
        var fiber = $5c00e1cb1faeed50$var$currentlyRenderingFiber, hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
        if ($5c00e1cb1faeed50$var$isHydrating) {
            if (void 0 === getServerSnapshot) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(407));
            getServerSnapshot = getServerSnapshot();
        } else {
            getServerSnapshot = getSnapshot();
            if (null === $5c00e1cb1faeed50$var$workInProgressRoot) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(349));
            0 !== ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 127) || $5c00e1cb1faeed50$var$pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
        }
        hook.memoizedState = getServerSnapshot;
        var inst = {
            value: getServerSnapshot,
            getSnapshot: getSnapshot
        };
        hook.queue = inst;
        $5c00e1cb1faeed50$var$mountEffect($5c00e1cb1faeed50$var$subscribeToStore.bind(null, fiber, inst, subscribe), [
            subscribe
        ]);
        fiber.flags |= 2048;
        $5c00e1cb1faeed50$var$pushSimpleEffect(9, {
            destroy: void 0
        }, $5c00e1cb1faeed50$var$updateStoreInstance.bind(null, fiber, inst, getServerSnapshot, getSnapshot), null);
        return getServerSnapshot;
    },
    useId: function() {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook(), identifierPrefix = $5c00e1cb1faeed50$var$workInProgressRoot.identifierPrefix;
        if ($5c00e1cb1faeed50$var$isHydrating) {
            var JSCompiler_inline_result = $5c00e1cb1faeed50$var$treeContextOverflow;
            var idWithLeadingBit = $5c00e1cb1faeed50$var$treeContextId;
            JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - $5c00e1cb1faeed50$var$clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
            identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
            JSCompiler_inline_result = $5c00e1cb1faeed50$var$localIdCounter++;
            0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
            identifierPrefix += "_";
        } else JSCompiler_inline_result = $5c00e1cb1faeed50$var$globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
        return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus: $5c00e1cb1faeed50$var$useHostTransitionStatus,
    useFormState: $5c00e1cb1faeed50$var$mountActionState,
    useActionState: $5c00e1cb1faeed50$var$mountActionState,
    useOptimistic: function(passthrough) {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook();
        hook.memoizedState = hook.baseState = passthrough;
        var queue = {
            pending: null,
            lanes: 0,
            dispatch: null,
            lastRenderedReducer: null,
            lastRenderedState: null
        };
        hook.queue = queue;
        hook = $5c00e1cb1faeed50$var$dispatchOptimisticSetState.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber, !0, queue);
        queue.dispatch = hook;
        return [
            passthrough,
            hook
        ];
    },
    useMemoCache: $5c00e1cb1faeed50$var$useMemoCache,
    useCacheRefresh: function() {
        return $5c00e1cb1faeed50$var$mountWorkInProgressHook().memoizedState = $5c00e1cb1faeed50$var$refreshCache.bind(null, $5c00e1cb1faeed50$var$currentlyRenderingFiber);
    },
    useEffectEvent: function(callback) {
        var hook = $5c00e1cb1faeed50$var$mountWorkInProgressHook(), ref = {
            impl: callback
        };
        hook.memoizedState = ref;
        return function() {
            if (0 !== ($5c00e1cb1faeed50$var$executionContext & 2)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(440));
            return ref.impl.apply(void 0, arguments);
        };
    }
}, $5c00e1cb1faeed50$var$HooksDispatcherOnUpdate = {
    readContext: $5c00e1cb1faeed50$var$readContext,
    use: $5c00e1cb1faeed50$var$use,
    useCallback: $5c00e1cb1faeed50$var$updateCallback,
    useContext: $5c00e1cb1faeed50$var$readContext,
    useEffect: $5c00e1cb1faeed50$var$updateEffect,
    useImperativeHandle: $5c00e1cb1faeed50$var$updateImperativeHandle,
    useInsertionEffect: $5c00e1cb1faeed50$var$updateInsertionEffect,
    useLayoutEffect: $5c00e1cb1faeed50$var$updateLayoutEffect,
    useMemo: $5c00e1cb1faeed50$var$updateMemo,
    useReducer: $5c00e1cb1faeed50$var$updateReducer,
    useRef: $5c00e1cb1faeed50$var$updateRef,
    useState: function() {
        return $5c00e1cb1faeed50$var$updateReducer($5c00e1cb1faeed50$var$basicStateReducer);
    },
    useDebugValue: $5c00e1cb1faeed50$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
        return $5c00e1cb1faeed50$var$updateDeferredValueImpl(hook, $5c00e1cb1faeed50$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $5c00e1cb1faeed50$var$updateReducer($5c00e1cb1faeed50$var$basicStateReducer)[0], start = $5c00e1cb1faeed50$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $5c00e1cb1faeed50$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $5c00e1cb1faeed50$var$updateSyncExternalStore,
    useId: $5c00e1cb1faeed50$var$updateId,
    useHostTransitionStatus: $5c00e1cb1faeed50$var$useHostTransitionStatus,
    useFormState: $5c00e1cb1faeed50$var$updateActionState,
    useActionState: $5c00e1cb1faeed50$var$updateActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
        return $5c00e1cb1faeed50$var$updateOptimisticImpl(hook, $5c00e1cb1faeed50$var$currentHook, passthrough, reducer);
    },
    useMemoCache: $5c00e1cb1faeed50$var$useMemoCache,
    useCacheRefresh: $5c00e1cb1faeed50$var$updateRefresh,
    useEffectEvent: $5c00e1cb1faeed50$var$updateEvent
}, $5c00e1cb1faeed50$var$HooksDispatcherOnRerender = {
    readContext: $5c00e1cb1faeed50$var$readContext,
    use: $5c00e1cb1faeed50$var$use,
    useCallback: $5c00e1cb1faeed50$var$updateCallback,
    useContext: $5c00e1cb1faeed50$var$readContext,
    useEffect: $5c00e1cb1faeed50$var$updateEffect,
    useImperativeHandle: $5c00e1cb1faeed50$var$updateImperativeHandle,
    useInsertionEffect: $5c00e1cb1faeed50$var$updateInsertionEffect,
    useLayoutEffect: $5c00e1cb1faeed50$var$updateLayoutEffect,
    useMemo: $5c00e1cb1faeed50$var$updateMemo,
    useReducer: $5c00e1cb1faeed50$var$rerenderReducer,
    useRef: $5c00e1cb1faeed50$var$updateRef,
    useState: function() {
        return $5c00e1cb1faeed50$var$rerenderReducer($5c00e1cb1faeed50$var$basicStateReducer);
    },
    useDebugValue: $5c00e1cb1faeed50$var$mountDebugValue,
    useDeferredValue: function(value, initialValue) {
        var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
        return null === $5c00e1cb1faeed50$var$currentHook ? $5c00e1cb1faeed50$var$mountDeferredValueImpl(hook, value, initialValue) : $5c00e1cb1faeed50$var$updateDeferredValueImpl(hook, $5c00e1cb1faeed50$var$currentHook.memoizedState, value, initialValue);
    },
    useTransition: function() {
        var booleanOrThenable = $5c00e1cb1faeed50$var$rerenderReducer($5c00e1cb1faeed50$var$basicStateReducer)[0], start = $5c00e1cb1faeed50$var$updateWorkInProgressHook().memoizedState;
        return [
            "boolean" === typeof booleanOrThenable ? booleanOrThenable : $5c00e1cb1faeed50$var$useThenable(booleanOrThenable),
            start
        ];
    },
    useSyncExternalStore: $5c00e1cb1faeed50$var$updateSyncExternalStore,
    useId: $5c00e1cb1faeed50$var$updateId,
    useHostTransitionStatus: $5c00e1cb1faeed50$var$useHostTransitionStatus,
    useFormState: $5c00e1cb1faeed50$var$rerenderActionState,
    useActionState: $5c00e1cb1faeed50$var$rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
        var hook = $5c00e1cb1faeed50$var$updateWorkInProgressHook();
        if (null !== $5c00e1cb1faeed50$var$currentHook) return $5c00e1cb1faeed50$var$updateOptimisticImpl(hook, $5c00e1cb1faeed50$var$currentHook, passthrough, reducer);
        hook.baseState = passthrough;
        return [
            passthrough,
            hook.queue.dispatch
        ];
    },
    useMemoCache: $5c00e1cb1faeed50$var$useMemoCache,
    useCacheRefresh: $5c00e1cb1faeed50$var$updateRefresh,
    useEffectEvent: $5c00e1cb1faeed50$var$updateEvent
};
function $5c00e1cb1faeed50$var$applyDerivedStateFromProps(workInProgress, ctor, getDerivedStateFromProps, nextProps) {
    ctor = workInProgress.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor : $5c00e1cb1faeed50$var$assign({}, ctor, getDerivedStateFromProps);
    workInProgress.memoizedState = getDerivedStateFromProps;
    0 === workInProgress.lanes && (workInProgress.updateQueue.baseState = getDerivedStateFromProps);
}
var $5c00e1cb1faeed50$var$classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $5c00e1cb1faeed50$var$requestUpdateLane(), update = $5c00e1cb1faeed50$var$createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $5c00e1cb1faeed50$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($5c00e1cb1faeed50$var$scheduleUpdateOnFiber(payload, inst, lane), $5c00e1cb1faeed50$var$entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = $5c00e1cb1faeed50$var$requestUpdateLane(), update = $5c00e1cb1faeed50$var$createUpdate(lane);
        update.tag = 1;
        update.payload = payload;
        void 0 !== callback && null !== callback && (update.callback = callback);
        payload = $5c00e1cb1faeed50$var$enqueueUpdate(inst, update, lane);
        null !== payload && ($5c00e1cb1faeed50$var$scheduleUpdateOnFiber(payload, inst, lane), $5c00e1cb1faeed50$var$entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = $5c00e1cb1faeed50$var$requestUpdateLane(), update = $5c00e1cb1faeed50$var$createUpdate(lane);
        update.tag = 2;
        void 0 !== callback && null !== callback && (update.callback = callback);
        callback = $5c00e1cb1faeed50$var$enqueueUpdate(inst, update, lane);
        null !== callback && ($5c00e1cb1faeed50$var$scheduleUpdateOnFiber(callback, inst, lane), $5c00e1cb1faeed50$var$entangleTransitions(callback, inst, lane));
    }
};
function $5c00e1cb1faeed50$var$checkShouldComponentUpdate(workInProgress, ctor, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress = workInProgress.stateNode;
    return "function" === typeof workInProgress.shouldComponentUpdate ? workInProgress.shouldComponentUpdate(newProps, newState, nextContext) : ctor.prototype && ctor.prototype.isPureReactComponent ? !$5c00e1cb1faeed50$var$shallowEqual(oldProps, newProps) || !$5c00e1cb1faeed50$var$shallowEqual(oldState, newState) : !0;
}
function $5c00e1cb1faeed50$var$callComponentWillReceiveProps(workInProgress, instance, newProps, nextContext) {
    workInProgress = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress && $5c00e1cb1faeed50$var$classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
}
function $5c00e1cb1faeed50$var$resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
        newProps = {};
        for(var propName in baseProps)"ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = $5c00e1cb1faeed50$var$assign({}, newProps));
        for(var propName$77 in Component)void 0 === newProps[propName$77] && (newProps[propName$77] = Component[propName$77]);
    }
    return newProps;
}
function $5c00e1cb1faeed50$var$defaultOnUncaughtError(error) {
    $5c00e1cb1faeed50$var$reportGlobalError(error);
}
function $5c00e1cb1faeed50$var$defaultOnCaughtError(error) {
    console.error(error);
}
function $5c00e1cb1faeed50$var$defaultOnRecoverableError(error) {
    $5c00e1cb1faeed50$var$reportGlobalError(error);
}
function $5c00e1cb1faeed50$var$logUncaughtError(root, errorInfo) {
    try {
        var onUncaughtError = root.onUncaughtError;
        onUncaughtError(errorInfo.value, {
            componentStack: errorInfo.stack
        });
    } catch (e$78) {
        setTimeout(function() {
            throw e$78;
        });
    }
}
function $5c00e1cb1faeed50$var$logCaughtError(root, boundary, errorInfo) {
    try {
        var onCaughtError = root.onCaughtError;
        onCaughtError(errorInfo.value, {
            componentStack: errorInfo.stack,
            errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
    } catch (e$79) {
        setTimeout(function() {
            throw e$79;
        });
    }
}
function $5c00e1cb1faeed50$var$createRootErrorUpdate(root, errorInfo, lane) {
    lane = $5c00e1cb1faeed50$var$createUpdate(lane);
    lane.tag = 3;
    lane.payload = {
        element: null
    };
    lane.callback = function() {
        $5c00e1cb1faeed50$var$logUncaughtError(root, errorInfo);
    };
    return lane;
}
function $5c00e1cb1faeed50$var$createClassErrorUpdate(lane) {
    lane = $5c00e1cb1faeed50$var$createUpdate(lane);
    lane.tag = 3;
    return lane;
}
function $5c00e1cb1faeed50$var$initializeClassErrorUpdate(update, root, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
            return getDerivedStateFromError(error);
        };
        update.callback = function() {
            $5c00e1cb1faeed50$var$logCaughtError(root, fiber, errorInfo);
        };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        $5c00e1cb1faeed50$var$logCaughtError(root, fiber, errorInfo);
        "function" !== typeof getDerivedStateFromError && (null === $5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed ? $5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed = new Set([
            this
        ]) : $5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed.add(this));
        var stack = errorInfo.stack;
        this.componentDidCatch(errorInfo.value, {
            componentStack: null !== stack ? stack : ""
        });
    });
}
function $5c00e1cb1faeed50$var$throwException(root, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && $5c00e1cb1faeed50$var$propagateParentContextChanges(returnFiber, sourceFiber, rootRenderLanes, !0);
        sourceFiber = $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
            switch(sourceFiber.tag){
                case 31:
                case 13:
                case 19:
                    return null === $5c00e1cb1faeed50$var$shellBoundary ? $5c00e1cb1faeed50$var$renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === $5c00e1cb1faeed50$var$workInProgressRootExitStatus && ($5c00e1cb1faeed50$var$workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === $5c00e1cb1faeed50$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = new Set([
                        value
                    ]) : returnFiber.add(value), $5c00e1cb1faeed50$var$attachPingListener(root, value, rootRenderLanes)), !1;
                case 22:
                    return sourceFiber.flags |= 65536, value === $5c00e1cb1faeed50$var$noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                        transitions: null,
                        markerInstances: null,
                        retryQueue: new Set([
                            value
                        ])
                    }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = new Set([
                        value
                    ]) : sourceFiber.add(value)), $5c00e1cb1faeed50$var$attachPingListener(root, value, rootRenderLanes)), !1;
            }
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(435, sourceFiber.tag));
        }
        $5c00e1cb1faeed50$var$attachPingListener(root, value, rootRenderLanes);
        $5c00e1cb1faeed50$var$renderDidSuspendDelayIfPossible();
        return !1;
    }
    if ($5c00e1cb1faeed50$var$isHydrating) return returnFiber = $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== $5c00e1cb1faeed50$var$HydrationMismatchException && (root = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(422), {
        cause: value
    }), $5c00e1cb1faeed50$var$queueHydrationError($5c00e1cb1faeed50$var$createCapturedValueAtFiber(root, sourceFiber)))) : (value !== $5c00e1cb1faeed50$var$HydrationMismatchException && (returnFiber = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(423), {
        cause: value
    }), $5c00e1cb1faeed50$var$queueHydrationError($5c00e1cb1faeed50$var$createCapturedValueAtFiber(returnFiber, sourceFiber))), root = root.current.alternate, root.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root.lanes |= rootRenderLanes, value = $5c00e1cb1faeed50$var$createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = $5c00e1cb1faeed50$var$createRootErrorUpdate(root.stateNode, value, rootRenderLanes), $5c00e1cb1faeed50$var$enqueueCapturedUpdate(root, rootRenderLanes), 4 !== $5c00e1cb1faeed50$var$workInProgressRootExitStatus && ($5c00e1cb1faeed50$var$workInProgressRootExitStatus = 2)), !1;
    var wrapperError = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(520), {
        cause: value
    });
    wrapperError = $5c00e1cb1faeed50$var$createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === $5c00e1cb1faeed50$var$workInProgressRootConcurrentErrors ? $5c00e1cb1faeed50$var$workInProgressRootConcurrentErrors = [
        wrapperError
    ] : $5c00e1cb1faeed50$var$workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== $5c00e1cb1faeed50$var$workInProgressRootExitStatus && ($5c00e1cb1faeed50$var$workInProgressRootExitStatus = 2);
    if (null === returnFiber) return !0;
    value = $5c00e1cb1faeed50$var$createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
        switch(sourceFiber.tag){
            case 3:
                return sourceFiber.flags |= 65536, root = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root, root = $5c00e1cb1faeed50$var$createRootErrorUpdate(sourceFiber.stateNode, value, root), $5c00e1cb1faeed50$var$enqueueCapturedUpdate(sourceFiber, root), !1;
            case 1:
                returnFiber = sourceFiber.type;
                wrapperError = sourceFiber.stateNode;
                if (0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === $5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed || !$5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed.has(wrapperError)))) return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = $5c00e1cb1faeed50$var$createClassErrorUpdate(rootRenderLanes), $5c00e1cb1faeed50$var$initializeClassErrorUpdate(rootRenderLanes, root, sourceFiber, value), $5c00e1cb1faeed50$var$enqueueCapturedUpdate(sourceFiber, rootRenderLanes), !1;
                break;
            case 22:
                if (null !== sourceFiber.memoizedState) return sourceFiber.flags |= 65536, !1;
        }
        sourceFiber = sourceFiber.return;
    }while (null !== sourceFiber);
    return !1;
}
var $5c00e1cb1faeed50$var$SelectiveHydrationException = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(461)), $5c00e1cb1faeed50$var$didReceiveUpdate = !1;
function $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes) {
    workInProgress.child = null === current ? $5c00e1cb1faeed50$var$mountChildFibers(workInProgress, null, nextChildren, renderLanes) : $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, current.child, nextChildren, renderLanes);
}
function $5c00e1cb1faeed50$var$updateForwardRef(current, workInProgress, Component, nextProps, renderLanes) {
    Component = Component.render;
    var ref = workInProgress.ref;
    if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for(var key in nextProps)"ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress);
    nextProps = $5c00e1cb1faeed50$var$renderWithHooks(current, workInProgress, Component, propsWithoutRef, ref, renderLanes);
    key = $5c00e1cb1faeed50$var$checkDidRenderIdHook();
    if (null !== current && !$5c00e1cb1faeed50$var$didReceiveUpdate) return $5c00e1cb1faeed50$var$bailoutHooks(current, workInProgress, renderLanes), $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $5c00e1cb1faeed50$var$isHydrating && key && $5c00e1cb1faeed50$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$updateMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null === current) {
        var type = Component.type;
        if ("function" === typeof type && !$5c00e1cb1faeed50$var$shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare) return workInProgress.tag = 15, workInProgress.type = type, $5c00e1cb1faeed50$var$updateSimpleMemoComponent(current, workInProgress, type, nextProps, renderLanes);
        current = $5c00e1cb1faeed50$var$createFiberFromTypeAndProps(Component.type, null, nextProps, workInProgress, workInProgress.mode, renderLanes);
        current.ref = workInProgress.ref;
        current.return = workInProgress;
        return workInProgress.child = current;
    }
    type = current.child;
    if (!$5c00e1cb1faeed50$var$checkScheduledUpdateOrContext(current, renderLanes)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : $5c00e1cb1faeed50$var$shallowEqual;
        if (Component(prevProps, nextProps) && current.ref === workInProgress.ref) return $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    }
    workInProgress.flags |= 1;
    current = $5c00e1cb1faeed50$var$createWorkInProgress(type, nextProps);
    current.ref = workInProgress.ref;
    current.return = workInProgress;
    return workInProgress.child = current;
}
function $5c00e1cb1faeed50$var$updateSimpleMemoComponent(current, workInProgress, Component, nextProps, renderLanes) {
    if (null !== current) {
        var prevProps = current.memoizedProps;
        if ($5c00e1cb1faeed50$var$shallowEqual(prevProps, nextProps) && current.ref === workInProgress.ref) {
            if ($5c00e1cb1faeed50$var$didReceiveUpdate = !1, workInProgress.pendingProps = nextProps = prevProps, $5c00e1cb1faeed50$var$checkScheduledUpdateOrContext(current, renderLanes)) 0 !== (current.flags & 131072) && ($5c00e1cb1faeed50$var$didReceiveUpdate = !0);
            else return workInProgress.lanes = current.lanes, $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
        }
    }
    return $5c00e1cb1faeed50$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes);
}
function $5c00e1cb1faeed50$var$updateOffscreenComponent(current, workInProgress, renderLanes, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current ? current.memoizedState : null;
    null === current && null === workInProgress.stateNode && (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress.flags & 128)) {
            prevState = null !== prevState ? prevState.baseLanes | renderLanes : renderLanes;
            if (null !== current) {
                nextProps = workInProgress.child = current.child;
                for(nextChildren = 0; null !== nextProps;)nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
                nextProps = nextChildren & ~prevState;
            } else nextProps = 0, workInProgress.child = null;
            return $5c00e1cb1faeed50$var$deferHiddenOffscreenComponent(current, workInProgress, prevState, renderLanes, nextProps);
        }
        if (0 !== (renderLanes & 536870912)) workInProgress.memoizedState = {
            baseLanes: 0,
            cachePool: null
        }, null !== current && $5c00e1cb1faeed50$var$pushTransition(workInProgress, null !== prevState ? prevState.cachePool : null), null !== prevState ? $5c00e1cb1faeed50$var$pushHiddenContext(workInProgress, prevState) : $5c00e1cb1faeed50$var$reuseHiddenContextOnStack(), $5c00e1cb1faeed50$var$pushOffscreenSuspenseHandler(workInProgress);
        else return nextProps = workInProgress.lanes = 536870912, $5c00e1cb1faeed50$var$deferHiddenOffscreenComponent(current, workInProgress, null !== prevState ? prevState.baseLanes | renderLanes : renderLanes, renderLanes, nextProps);
    } else null !== prevState ? ($5c00e1cb1faeed50$var$pushTransition(workInProgress, prevState.cachePool), $5c00e1cb1faeed50$var$pushHiddenContext(workInProgress, prevState), $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack(), workInProgress.memoizedState = null) : (null !== current && $5c00e1cb1faeed50$var$pushTransition(workInProgress, null), $5c00e1cb1faeed50$var$reuseHiddenContextOnStack(), $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack());
    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$bailoutOffscreenComponent(current, workInProgress) {
    null !== current && 22 === current.tag || null !== workInProgress.stateNode || (workInProgress.stateNode = {
        _visibility: 1,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
    });
    return workInProgress.sibling;
}
function $5c00e1cb1faeed50$var$deferHiddenOffscreenComponent(current, workInProgress, nextBaseLanes, renderLanes, remainingChildLanes) {
    var JSCompiler_inline_result = $5c00e1cb1faeed50$var$peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: $5c00e1cb1faeed50$var$CacheContext._currentValue,
        pool: JSCompiler_inline_result
    };
    workInProgress.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
    };
    null !== current && $5c00e1cb1faeed50$var$pushTransition(workInProgress, null);
    $5c00e1cb1faeed50$var$reuseHiddenContextOnStack();
    $5c00e1cb1faeed50$var$pushOffscreenSuspenseHandler(workInProgress);
    null !== current && $5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, !0);
    workInProgress.childLanes = remainingChildLanes;
    return null;
}
function $5c00e1cb1faeed50$var$mountActivityChildren(workInProgress, nextProps) {
    nextProps = $5c00e1cb1faeed50$var$mountWorkInProgressOffscreenFiber({
        mode: nextProps.mode,
        children: nextProps.children
    }, workInProgress.mode);
    nextProps.ref = workInProgress.ref;
    workInProgress.child = nextProps;
    nextProps.return = workInProgress;
    return nextProps;
}
function $5c00e1cb1faeed50$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $5c00e1cb1faeed50$var$mountActivityChildren(workInProgress, workInProgress.pendingProps);
    current.flags |= 2;
    $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress);
    workInProgress.memoizedState = null;
    return current;
}
function $5c00e1cb1faeed50$var$updateActivityComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, didSuspend = 0 !== (workInProgress.flags & 128);
    workInProgress.flags &= -129;
    if (null === current) {
        if ($5c00e1cb1faeed50$var$isHydrating) {
            if ("hidden" === nextProps.mode) return current = $5c00e1cb1faeed50$var$mountActivityChildren(workInProgress, nextProps), workInProgress.lanes = 536870912, current.memoizedState = {
                baseLanes: 0,
                cachePool: null
            }, $5c00e1cb1faeed50$var$bailoutOffscreenComponent(null, current);
            $5c00e1cb1faeed50$var$pushDehydratedActivitySuspenseHandler(workInProgress);
            (current = $5c00e1cb1faeed50$var$nextHydratableInstance) ? (current = $5c00e1cb1faeed50$var$canHydrateHydrationBoundary(current, $5c00e1cb1faeed50$var$rootOrSingletonContext), current = null !== current && "&" === current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $5c00e1cb1faeed50$var$treeContextProvider ? {
                    id: $5c00e1cb1faeed50$var$treeContextId,
                    overflow: $5c00e1cb1faeed50$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $5c00e1cb1faeed50$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress, $5c00e1cb1faeed50$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $5c00e1cb1faeed50$var$throwOnHydrationMismatch(workInProgress);
            workInProgress.lanes = 536870912;
            return null;
        }
        return $5c00e1cb1faeed50$var$mountActivityChildren(workInProgress, nextProps);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated = prevState.dehydrated;
        $5c00e1cb1faeed50$var$pushDehydratedActivitySuspenseHandler(workInProgress);
        if (didSuspend) {
            if (workInProgress.flags & 256) workInProgress.flags &= -257, workInProgress = $5c00e1cb1faeed50$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
            else if (null !== workInProgress.memoizedState) workInProgress.child = current.child, workInProgress.flags |= 128, workInProgress = null;
            else throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(558));
        } else if ($5c00e1cb1faeed50$var$didReceiveUpdate || $5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), didSuspend = 0 !== (renderLanes & current.childLanes), $5c00e1cb1faeed50$var$didReceiveUpdate || didSuspend) {
            if (null === $5c00e1cb1faeed50$var$currentTreeHiddenStackCursor.current) {
                nextProps = $5c00e1cb1faeed50$var$workInProgressRoot;
                if (null !== nextProps && (dehydrated = $5c00e1cb1faeed50$var$getBumpedLaneForHydration(nextProps, renderLanes), 0 !== dehydrated && dehydrated !== prevState.retryLane)) throw prevState.retryLane = dehydrated, $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(current, dehydrated), $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(nextProps, current, dehydrated), $5c00e1cb1faeed50$var$SelectiveHydrationException;
                $5c00e1cb1faeed50$var$renderDidSuspendDelayIfPossible();
            }
            workInProgress = $5c00e1cb1faeed50$var$retryActivityComponentWithoutHydrating(current, workInProgress, renderLanes);
        } else current = prevState.treeContext, $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratable(dehydrated.nextSibling), $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress, $5c00e1cb1faeed50$var$isHydrating = !0, $5c00e1cb1faeed50$var$hydrationErrors = null, $5c00e1cb1faeed50$var$rootOrSingletonContext = !1, null !== current && $5c00e1cb1faeed50$var$restoreSuspendedTreeContext(workInProgress, current), workInProgress = $5c00e1cb1faeed50$var$mountActivityChildren(workInProgress, nextProps), workInProgress.flags |= 134221824;
        return workInProgress;
    }
    current = $5c00e1cb1faeed50$var$createWorkInProgress(current.child, {
        mode: nextProps.mode,
        children: nextProps.children
    });
    current.ref = workInProgress.ref;
    workInProgress.child = current;
    current.return = workInProgress;
    return current;
}
function $5c00e1cb1faeed50$var$markRef(current, workInProgress) {
    var ref = workInProgress.ref;
    if (null === ref) null !== current && null !== current.ref && (workInProgress.flags |= 4194816);
    else {
        if ("function" !== typeof ref && "object" !== typeof ref) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(284));
        if (null === current || current.ref !== ref) workInProgress.flags |= 4194816;
    }
}
function $5c00e1cb1faeed50$var$updateFunctionComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress);
    Component = $5c00e1cb1faeed50$var$renderWithHooks(current, workInProgress, Component, nextProps, void 0, renderLanes);
    nextProps = $5c00e1cb1faeed50$var$checkDidRenderIdHook();
    if (null !== current && !$5c00e1cb1faeed50$var$didReceiveUpdate) return $5c00e1cb1faeed50$var$bailoutHooks(current, workInProgress, renderLanes), $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $5c00e1cb1faeed50$var$isHydrating && nextProps && $5c00e1cb1faeed50$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, Component, renderLanes);
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$replayFunctionComponent(current, workInProgress, nextProps, Component, secondArg, renderLanes) {
    $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress);
    workInProgress.updateQueue = null;
    nextProps = $5c00e1cb1faeed50$var$renderWithHooksAgain(workInProgress, Component, nextProps, secondArg);
    $5c00e1cb1faeed50$var$finishRenderingHooks(current);
    Component = $5c00e1cb1faeed50$var$checkDidRenderIdHook();
    if (null !== current && !$5c00e1cb1faeed50$var$didReceiveUpdate) return $5c00e1cb1faeed50$var$bailoutHooks(current, workInProgress, renderLanes), $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    $5c00e1cb1faeed50$var$isHydrating && Component && $5c00e1cb1faeed50$var$pushMaterializedTreeId(workInProgress);
    workInProgress.flags |= 1;
    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$updateClassComponent(current, workInProgress, Component, nextProps, renderLanes) {
    $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress);
    if (null === workInProgress.stateNode) {
        var context = $5c00e1cb1faeed50$var$emptyContextObject, contextType = Component.contextType;
        "object" === typeof contextType && null !== contextType && (context = $5c00e1cb1faeed50$var$readContext(contextType));
        context = new Component(nextProps, context);
        workInProgress.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
        context.updater = $5c00e1cb1faeed50$var$classComponentUpdater;
        workInProgress.stateNode = context;
        context._reactInternals = workInProgress;
        context = workInProgress.stateNode;
        context.props = nextProps;
        context.state = workInProgress.memoizedState;
        context.refs = {};
        $5c00e1cb1faeed50$var$initializeUpdateQueue(workInProgress);
        contextType = Component.contextType;
        context.context = "object" === typeof contextType && null !== contextType ? $5c00e1cb1faeed50$var$readContext(contextType) : $5c00e1cb1faeed50$var$emptyContextObject;
        context.state = workInProgress.memoizedState;
        contextType = Component.getDerivedStateFromProps;
        "function" === typeof contextType && ($5c00e1cb1faeed50$var$applyDerivedStateFromProps(workInProgress, Component, contextType, nextProps), context.state = workInProgress.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && $5c00e1cb1faeed50$var$classComponentUpdater.enqueueReplaceState(context, context.state, null), $5c00e1cb1faeed50$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes), $5c00e1cb1faeed50$var$suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress.memoizedState);
        "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308);
        nextProps = !0;
    } else if (null === current) {
        context = workInProgress.stateNode;
        var unresolvedOldProps = workInProgress.memoizedProps, oldProps = $5c00e1cb1faeed50$var$resolveClassComponentProps(Component, unresolvedOldProps);
        context.props = oldProps;
        var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
        contextType = $5c00e1cb1faeed50$var$emptyContextObject;
        "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = $5c00e1cb1faeed50$var$readContext(contextType$jscomp$0));
        var getDerivedStateFromProps = Component.getDerivedStateFromProps;
        contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress.pendingProps !== unresolvedOldProps;
        contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && $5c00e1cb1faeed50$var$callComponentWillReceiveProps(workInProgress, context, nextProps, contextType);
        $5c00e1cb1faeed50$var$hasForceUpdate = !1;
        var oldState = workInProgress.memoizedState;
        context.state = oldState;
        $5c00e1cb1faeed50$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $5c00e1cb1faeed50$var$suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress.memoizedState;
        unresolvedOldProps || oldState !== oldContext || $5c00e1cb1faeed50$var$hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && ($5c00e1cb1faeed50$var$applyDerivedStateFromProps(workInProgress, Component, getDerivedStateFromProps, nextProps), oldContext = workInProgress.memoizedState), (oldProps = $5c00e1cb1faeed50$var$hasForceUpdate || $5c00e1cb1faeed50$var$checkShouldComponentUpdate(workInProgress, Component, oldProps, nextProps, oldState, oldContext, contextType)) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress.flags |= 4194308), nextProps = !1);
    } else {
        context = workInProgress.stateNode;
        $5c00e1cb1faeed50$var$cloneUpdateQueue(current, workInProgress);
        contextType = workInProgress.memoizedProps;
        contextType$jscomp$0 = $5c00e1cb1faeed50$var$resolveClassComponentProps(Component, contextType);
        context.props = contextType$jscomp$0;
        getDerivedStateFromProps = workInProgress.pendingProps;
        oldState = context.context;
        oldContext = Component.contextType;
        oldProps = $5c00e1cb1faeed50$var$emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (oldProps = $5c00e1cb1faeed50$var$readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && $5c00e1cb1faeed50$var$callComponentWillReceiveProps(workInProgress, context, nextProps, oldProps);
        $5c00e1cb1faeed50$var$hasForceUpdate = !1;
        oldState = workInProgress.memoizedState;
        context.state = oldState;
        $5c00e1cb1faeed50$var$processUpdateQueue(workInProgress, nextProps, context, renderLanes);
        $5c00e1cb1faeed50$var$suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress.memoizedState;
        contextType !== getDerivedStateFromProps || oldState !== newState || $5c00e1cb1faeed50$var$hasForceUpdate || null !== current && null !== current.dependencies && $5c00e1cb1faeed50$var$checkIfContextChanged(current.dependencies) ? ("function" === typeof unresolvedOldProps && ($5c00e1cb1faeed50$var$applyDerivedStateFromProps(workInProgress, Component, unresolvedOldProps, nextProps), newState = workInProgress.memoizedState), (contextType$jscomp$0 = $5c00e1cb1faeed50$var$hasForceUpdate || $5c00e1cb1faeed50$var$checkShouldComponentUpdate(workInProgress, Component, contextType$jscomp$0, nextProps, oldState, newState, oldProps) || null !== current && null !== current.dependencies && $5c00e1cb1faeed50$var$checkIfContextChanged(current.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(nextProps, newState, oldProps)), "function" === typeof context.componentDidUpdate && (workInProgress.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), workInProgress.memoizedProps = nextProps, workInProgress.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current.memoizedProps && oldState === current.memoizedState || (workInProgress.flags |= 1024), nextProps = !1);
    }
    context = nextProps;
    $5c00e1cb1faeed50$var$markRef(current, workInProgress);
    nextProps = 0 !== (workInProgress.flags & 128);
    context || nextProps ? (context = workInProgress.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress.flags |= 1, null !== current && nextProps ? (workInProgress.child = $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes), workInProgress.child = $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, null, Component, renderLanes)) : $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, Component, renderLanes), workInProgress.memoizedState = context.state, current = workInProgress.child) : current = $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
    return current;
}
function $5c00e1cb1faeed50$var$mountHostRootWithoutHydrating(current, workInProgress, nextChildren, renderLanes) {
    $5c00e1cb1faeed50$var$resetHydrationState();
    workInProgress.flags |= 256;
    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextChildren, renderLanes);
    return workInProgress.child;
}
var $5c00e1cb1faeed50$var$SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
};
function $5c00e1cb1faeed50$var$mountSuspenseOffscreenState(renderLanes) {
    return {
        baseLanes: renderLanes,
        cachePool: $5c00e1cb1faeed50$var$getSuspendedCache()
    };
}
function $5c00e1cb1faeed50$var$getRemainingWorkInPrimaryTree(current, primaryTreeDidDefer, renderLanes) {
    current = null !== current ? current.childLanes & ~renderLanes : 0;
    primaryTreeDidDefer && (current |= $5c00e1cb1faeed50$var$workInProgressDeferredLane);
    return current;
}
function $5c00e1cb1faeed50$var$updateSuspenseComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, showFallback = !1, didSuspend = 0 !== (workInProgress.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current && null === current.memoizedState ? !1 : 0 !== ($5c00e1cb1faeed50$var$suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = !0, workInProgress.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress.flags & 32);
    workInProgress.flags &= -33;
    if (null === current) {
        if ($5c00e1cb1faeed50$var$isHydrating) {
            showFallback ? $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress) : $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack();
            (current = $5c00e1cb1faeed50$var$nextHydratableInstance) ? (current = $5c00e1cb1faeed50$var$canHydrateHydrationBoundary(current, $5c00e1cb1faeed50$var$rootOrSingletonContext), current = null !== current && "&" !== current.data ? current : null, null !== current && (workInProgress.memoizedState = {
                dehydrated: current,
                treeContext: null !== $5c00e1cb1faeed50$var$treeContextProvider ? {
                    id: $5c00e1cb1faeed50$var$treeContextId,
                    overflow: $5c00e1cb1faeed50$var$treeContextOverflow
                } : null,
                retryLane: 536870912,
                hydrationErrors: null
            }, renderLanes = $5c00e1cb1faeed50$var$createFiberFromDehydratedFragment(current), renderLanes.return = workInProgress, workInProgress.child = renderLanes, $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress, $5c00e1cb1faeed50$var$nextHydratableInstance = null)) : current = null;
            if (null === current) throw $5c00e1cb1faeed50$var$throwOnHydrationMismatch(workInProgress);
            $5c00e1cb1faeed50$var$isSuspenseInstanceFallback(current) ? workInProgress.lanes = 32 : workInProgress.lanes = 536870912;
            return null;
        }
        didSuspend = nextProps.children;
        nextProps = nextProps.fallback;
        if (showFallback) return $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack(), showFallback = workInProgress.mode, didSuspend = $5c00e1cb1faeed50$var$mountWorkInProgressOffscreenFiber({
            mode: "hidden",
            children: didSuspend
        }, showFallback), nextProps = $5c00e1cb1faeed50$var$createFiberFromFragment(nextProps, showFallback, renderLanes, null), didSuspend.return = workInProgress, nextProps.return = workInProgress, didSuspend.sibling = nextProps, workInProgress.child = didSuspend, nextProps = workInProgress.child, nextProps.memoizedState = $5c00e1cb1faeed50$var$mountSuspenseOffscreenState(renderLanes), nextProps.childLanes = $5c00e1cb1faeed50$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $5c00e1cb1faeed50$var$SUSPENDED_MARKER, $5c00e1cb1faeed50$var$bailoutOffscreenComponent(null, nextProps);
        $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress);
        return $5c00e1cb1faeed50$var$mountSuspensePrimaryChildren(workInProgress, didSuspend);
    }
    var prevState = current.memoizedState;
    if (null !== prevState) {
        var dehydrated$96 = prevState.dehydrated;
        if (null !== dehydrated$96) return $5c00e1cb1faeed50$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, JSCompiler_temp, nextProps, dehydrated$96, prevState, renderLanes);
    }
    if (showFallback) return $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack(), showFallback = nextProps.fallback, didSuspend = workInProgress.mode, prevState = current.child, dehydrated$96 = prevState.sibling, nextProps = $5c00e1cb1faeed50$var$createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
    }), nextProps.subtreeFlags = prevState.subtreeFlags & 1206910976, null !== dehydrated$96 ? showFallback = $5c00e1cb1faeed50$var$createWorkInProgress(dehydrated$96, showFallback) : (showFallback = $5c00e1cb1faeed50$var$createFiberFromFragment(showFallback, didSuspend, renderLanes, null), showFallback.flags |= 2), showFallback.return = workInProgress, nextProps.return = workInProgress, nextProps.sibling = showFallback, workInProgress.child = nextProps, $5c00e1cb1faeed50$var$bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress.child, showFallback = current.child.memoizedState, null === showFallback ? showFallback = $5c00e1cb1faeed50$var$mountSuspenseOffscreenState(renderLanes) : (didSuspend = showFallback.cachePool, null !== didSuspend ? (prevState = $5c00e1cb1faeed50$var$CacheContext._currentValue, didSuspend = didSuspend.parent !== prevState ? {
        parent: prevState,
        pool: prevState
    } : didSuspend) : didSuspend = $5c00e1cb1faeed50$var$getSuspendedCache(), showFallback = {
        baseLanes: showFallback.baseLanes | renderLanes,
        cachePool: didSuspend
    }), nextProps.memoizedState = showFallback, nextProps.childLanes = $5c00e1cb1faeed50$var$getRemainingWorkInPrimaryTree(current, JSCompiler_temp, renderLanes), workInProgress.memoizedState = $5c00e1cb1faeed50$var$SUSPENDED_MARKER, $5c00e1cb1faeed50$var$bailoutOffscreenComponent(current.child, nextProps);
    $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    renderLanes = current.child;
    current = renderLanes.sibling;
    renderLanes = $5c00e1cb1faeed50$var$createWorkInProgress(renderLanes, {
        mode: "visible",
        children: nextProps.children
    });
    renderLanes.return = workInProgress;
    renderLanes.sibling = null;
    null !== current && (JSCompiler_temp = workInProgress.deletions, null === JSCompiler_temp ? (workInProgress.deletions = [
        current
    ], workInProgress.flags |= 16) : JSCompiler_temp.push(current));
    workInProgress.child = renderLanes;
    workInProgress.memoizedState = null;
    return renderLanes;
}
function $5c00e1cb1faeed50$var$mountSuspensePrimaryChildren(workInProgress, primaryChildren) {
    primaryChildren = $5c00e1cb1faeed50$var$mountWorkInProgressOffscreenFiber({
        mode: "visible",
        children: primaryChildren
    }, workInProgress.mode);
    primaryChildren.return = workInProgress;
    return workInProgress.child = primaryChildren;
}
function $5c00e1cb1faeed50$var$mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = $5c00e1cb1faeed50$var$createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
}
function $5c00e1cb1faeed50$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes) {
    $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
    current = $5c00e1cb1faeed50$var$mountSuspensePrimaryChildren(workInProgress, workInProgress.pendingProps.children);
    current.flags |= 2;
    workInProgress.memoizedState = null;
    return current;
}
function $5c00e1cb1faeed50$var$updateDehydratedSuspenseComponent(current, workInProgress, didSuspend, didPrimaryChildrenDefer, nextProps, suspenseInstance, suspenseState, renderLanes) {
    if (didSuspend) {
        if (workInProgress.flags & 256) return $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags &= -257, $5c00e1cb1faeed50$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        if (null !== workInProgress.memoizedState) return $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack(), workInProgress.child = current.child, workInProgress.flags |= 128, null;
        $5c00e1cb1faeed50$var$reuseSuspenseHandlerOnStack();
        suspenseInstance = nextProps.fallback;
        suspenseState = workInProgress.mode;
        nextProps = $5c00e1cb1faeed50$var$mountWorkInProgressOffscreenFiber({
            mode: "visible",
            children: nextProps.children
        }, suspenseState);
        suspenseInstance = $5c00e1cb1faeed50$var$createFiberFromFragment(suspenseInstance, suspenseState, renderLanes, null);
        suspenseInstance.flags |= 2;
        nextProps.return = workInProgress;
        suspenseInstance.return = workInProgress;
        nextProps.sibling = suspenseInstance;
        workInProgress.child = nextProps;
        $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, current.child, null, renderLanes);
        nextProps = workInProgress.child;
        nextProps.memoizedState = $5c00e1cb1faeed50$var$mountSuspenseOffscreenState(renderLanes);
        nextProps.childLanes = $5c00e1cb1faeed50$var$getRemainingWorkInPrimaryTree(current, didPrimaryChildrenDefer, renderLanes);
        workInProgress.memoizedState = $5c00e1cb1faeed50$var$SUSPENDED_MARKER;
        return $5c00e1cb1faeed50$var$bailoutOffscreenComponent(null, nextProps);
    }
    $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress);
    if ($5c00e1cb1faeed50$var$isSuspenseInstanceFallback(suspenseInstance)) {
        didPrimaryChildrenDefer = suspenseInstance.nextSibling && suspenseInstance.nextSibling.dataset;
        if (didPrimaryChildrenDefer) var digest = didPrimaryChildrenDefer.dgst;
        didPrimaryChildrenDefer = digest;
        "" !== didPrimaryChildrenDefer && (nextProps = Error($5c00e1cb1faeed50$var$formatProdErrorMessage(419)), nextProps.stack = "", nextProps.digest = didPrimaryChildrenDefer, $5c00e1cb1faeed50$var$queueHydrationError({
            value: nextProps,
            source: null,
            stack: null
        }));
        return $5c00e1cb1faeed50$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    $5c00e1cb1faeed50$var$didReceiveUpdate || $5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
    didPrimaryChildrenDefer = 0 !== (renderLanes & current.childLanes);
    if ($5c00e1cb1faeed50$var$didReceiveUpdate || didPrimaryChildrenDefer) {
        if (null !== $5c00e1cb1faeed50$var$currentTreeHiddenStackCursor.current) return $5c00e1cb1faeed50$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
        didPrimaryChildrenDefer = $5c00e1cb1faeed50$var$workInProgressRoot;
        if (null !== didPrimaryChildrenDefer && (nextProps = $5c00e1cb1faeed50$var$getBumpedLaneForHydration(didPrimaryChildrenDefer, renderLanes), 0 !== nextProps && nextProps !== suspenseState.retryLane)) throw suspenseState.retryLane = nextProps, $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(current, nextProps), $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(didPrimaryChildrenDefer, current, nextProps), $5c00e1cb1faeed50$var$SelectiveHydrationException;
        $5c00e1cb1faeed50$var$isSuspenseInstancePending(suspenseInstance) || $5c00e1cb1faeed50$var$renderDidSuspendDelayIfPossible();
        return $5c00e1cb1faeed50$var$retrySuspenseComponentWithoutHydrating(current, workInProgress, renderLanes);
    }
    if ($5c00e1cb1faeed50$var$isSuspenseInstancePending(suspenseInstance)) return workInProgress.flags |= 192, workInProgress.child = current.child, null;
    current = suspenseState.treeContext;
    $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratable(suspenseInstance.nextSibling);
    $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress;
    $5c00e1cb1faeed50$var$isHydrating = !0;
    $5c00e1cb1faeed50$var$hydrationErrors = null;
    $5c00e1cb1faeed50$var$rootOrSingletonContext = !1;
    null !== current && $5c00e1cb1faeed50$var$restoreSuspendedTreeContext(workInProgress, current);
    workInProgress = $5c00e1cb1faeed50$var$mountSuspensePrimaryChildren(workInProgress, nextProps.children);
    workInProgress.flags |= 134221824;
    return workInProgress;
}
function $5c00e1cb1faeed50$var$scheduleSuspenseWorkOnFiber(fiber, renderLanes, propagationRoot) {
    fiber.lanes |= renderLanes;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes);
    $5c00e1cb1faeed50$var$scheduleContextWorkOnParentPath(fiber.return, renderLanes, propagationRoot);
}
function $5c00e1cb1faeed50$var$findLastContentRow(firstChild) {
    for(var lastContentRow = null; null !== firstChild;){
        var currentRow = firstChild.alternate;
        null !== currentRow && null === $5c00e1cb1faeed50$var$findFirstSuspended(currentRow) && (lastContentRow = firstChild);
        firstChild = firstChild.sibling;
    }
    return lastContentRow;
}
function $5c00e1cb1faeed50$var$initSuspenseListRenderState(workInProgress, isBackwards, tail, lastContentRow, tailMode, treeForkCount) {
    var renderState = workInProgress.memoizedState;
    null === renderState ? workInProgress.memoizedState = {
        isBackwards: isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail: tail,
        tailMode: tailMode,
        treeForkCount: treeForkCount
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount);
}
function $5c00e1cb1faeed50$var$reverseChildren(fiber) {
    var row = fiber.child;
    for(fiber.child = null; null !== row;){
        var nextRow = row.sibling;
        row.sibling = fiber.child;
        fiber.child = row;
        row = nextRow;
    }
}
function $5c00e1cb1faeed50$var$updateSuspenseListComponent(current, workInProgress, renderLanes) {
    var nextProps = workInProgress.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = $5c00e1cb1faeed50$var$suspenseStackCursor.current;
    if (workInProgress.flags & 128) return $5c00e1cb1faeed50$var$pushSuspenseListContext(workInProgress, suspenseContext), null;
    var shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress.flags |= 128) : suspenseContext &= 1;
    $5c00e1cb1faeed50$var$pushSuspenseListContext(workInProgress, suspenseContext);
    "backwards" === revealOrder && null !== current ? ($5c00e1cb1faeed50$var$reverseChildren(current), $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextProps, renderLanes), $5c00e1cb1faeed50$var$reverseChildren(current)) : $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, nextProps, renderLanes);
    nextProps = $5c00e1cb1faeed50$var$isHydrating ? $5c00e1cb1faeed50$var$treeForkCount : 0;
    if (!shouldForceFallback && null !== current && 0 !== (current.flags & 128)) a: for(current = workInProgress.child; null !== current;){
        if (13 === current.tag) null !== current.memoizedState && $5c00e1cb1faeed50$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (19 === current.tag) $5c00e1cb1faeed50$var$scheduleSuspenseWorkOnFiber(current, renderLanes, workInProgress);
        else if (null !== current.child) {
            current.child.return = current;
            current = current.child;
            continue;
        }
        if (current === workInProgress) break a;
        for(; null === current.sibling;){
            if (null === current.return || current.return === workInProgress) break a;
            current = current.return;
        }
        current.sibling.return = current.return;
        current = current.sibling;
    }
    switch(revealOrder){
        case "backwards":
            renderLanes = $5c00e1cb1faeed50$var$findLastContentRow(workInProgress.child);
            null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null, $5c00e1cb1faeed50$var$reverseChildren(workInProgress));
            $5c00e1cb1faeed50$var$initSuspenseListRenderState(workInProgress, !0, revealOrder, null, tailMode, nextProps);
            break;
        case "unstable_legacy-backwards":
            renderLanes = null;
            revealOrder = workInProgress.child;
            for(workInProgress.child = null; null !== revealOrder;){
                current = revealOrder.alternate;
                if (null !== current && null === $5c00e1cb1faeed50$var$findFirstSuspended(current)) {
                    workInProgress.child = revealOrder;
                    break;
                }
                current = revealOrder.sibling;
                revealOrder.sibling = renderLanes;
                renderLanes = revealOrder;
                revealOrder = current;
            }
            $5c00e1cb1faeed50$var$initSuspenseListRenderState(workInProgress, !0, renderLanes, null, tailMode, nextProps);
            break;
        case "together":
            $5c00e1cb1faeed50$var$initSuspenseListRenderState(workInProgress, !1, null, null, void 0, nextProps);
            break;
        case "independent":
            workInProgress.memoizedState = null;
            break;
        default:
            renderLanes = $5c00e1cb1faeed50$var$findLastContentRow(workInProgress.child), null === renderLanes ? (revealOrder = workInProgress.child, workInProgress.child = null) : (revealOrder = renderLanes.sibling, renderLanes.sibling = null), $5c00e1cb1faeed50$var$initSuspenseListRenderState(workInProgress, !1, revealOrder, renderLanes, tailMode, nextProps);
    }
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$updateContextProvider(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $5c00e1cb1faeed50$var$pushProvider(workInProgress, workInProgress.type, newProps.value);
    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, newProps.children, renderLanes);
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes) {
    null !== current && (workInProgress.dependencies = current.dependencies);
    $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes |= workInProgress.lanes;
    if (0 === (renderLanes & workInProgress.childLanes)) {
        if (null !== current) {
            if ($5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), 0 === (renderLanes & workInProgress.childLanes)) return null;
        } else return null;
    }
    if (null !== current && workInProgress.child !== current.child) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(153));
    if (null !== workInProgress.child) {
        current = workInProgress.child;
        renderLanes = $5c00e1cb1faeed50$var$createWorkInProgress(current, current.pendingProps);
        workInProgress.child = renderLanes;
        for(renderLanes.return = workInProgress; null !== current.sibling;)current = current.sibling, renderLanes = renderLanes.sibling = $5c00e1cb1faeed50$var$createWorkInProgress(current, current.pendingProps), renderLanes.return = workInProgress;
        renderLanes.sibling = null;
    }
    return workInProgress.child;
}
function $5c00e1cb1faeed50$var$checkScheduledUpdateOrContext(current, renderLanes) {
    if (0 !== (current.lanes & renderLanes)) return !0;
    current = current.dependencies;
    return null !== current && $5c00e1cb1faeed50$var$checkIfContextChanged(current) ? !0 : !1;
}
function $5c00e1cb1faeed50$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes) {
    switch(workInProgress.tag){
        case 3:
            $5c00e1cb1faeed50$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            $5c00e1cb1faeed50$var$pushProvider(workInProgress, $5c00e1cb1faeed50$var$CacheContext, current.memoizedState.cache);
            $5c00e1cb1faeed50$var$resetHydrationState();
            break;
        case 27:
        case 5:
            $5c00e1cb1faeed50$var$pushHostContext(workInProgress);
            break;
        case 4:
            $5c00e1cb1faeed50$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
            break;
        case 10:
            $5c00e1cb1faeed50$var$pushProvider(workInProgress, workInProgress.type, workInProgress.memoizedProps.value);
            break;
        case 31:
            if (null !== workInProgress.memoizedState) return workInProgress.flags |= 128, $5c00e1cb1faeed50$var$pushDehydratedActivitySuspenseHandler(workInProgress), null;
            break;
        case 13:
            var state$108 = workInProgress.memoizedState;
            if (null !== state$108) {
                if (null !== state$108.dehydrated) return $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress), workInProgress.flags |= 128, null;
                state$108 = $5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1);
                var primaryChildLanes = workInProgress.child.childLanes;
                if (state$108 || 0 !== (renderLanes & primaryChildLanes)) return $5c00e1cb1faeed50$var$updateSuspenseComponent(current, workInProgress, renderLanes);
                $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress);
                current = $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                return null !== current ? current.sibling : null;
            }
            $5c00e1cb1faeed50$var$pushPrimaryTreeSuspenseHandler(workInProgress);
            break;
        case 19:
            if (workInProgress.flags & 128) return $5c00e1cb1faeed50$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
            primaryChildLanes = 0 !== (current.flags & 128);
            state$108 = 0 !== (renderLanes & workInProgress.childLanes);
            state$108 || ($5c00e1cb1faeed50$var$propagateParentContextChanges(current, workInProgress, renderLanes, !1), state$108 = 0 !== (renderLanes & workInProgress.childLanes));
            if (primaryChildLanes) {
                if (state$108) return $5c00e1cb1faeed50$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
                workInProgress.flags |= 128;
            }
            primaryChildLanes = workInProgress.memoizedState;
            null !== primaryChildLanes && (primaryChildLanes.rendering = null, primaryChildLanes.tail = null, primaryChildLanes.lastEffect = null);
            $5c00e1cb1faeed50$var$pushSuspenseListContext(workInProgress, $5c00e1cb1faeed50$var$suspenseStackCursor.current);
            if (state$108) break;
            else return null;
        case 22:
            return workInProgress.lanes = 0, $5c00e1cb1faeed50$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            $5c00e1cb1faeed50$var$pushProvider(workInProgress, $5c00e1cb1faeed50$var$CacheContext, current.memoizedState.cache);
    }
    return $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
}
function $5c00e1cb1faeed50$var$beginWork(current, workInProgress, renderLanes) {
    if (null !== current) {
        if (current.memoizedProps !== workInProgress.pendingProps) $5c00e1cb1faeed50$var$didReceiveUpdate = !0;
        else {
            if (!$5c00e1cb1faeed50$var$checkScheduledUpdateOrContext(current, renderLanes) && 0 === (workInProgress.flags & 128)) return $5c00e1cb1faeed50$var$didReceiveUpdate = !1, $5c00e1cb1faeed50$var$attemptEarlyBailoutIfNoScheduledUpdate(current, workInProgress, renderLanes);
            $5c00e1cb1faeed50$var$didReceiveUpdate = 0 !== (current.flags & 131072) ? !0 : !1;
        }
    } else $5c00e1cb1faeed50$var$didReceiveUpdate = !1, $5c00e1cb1faeed50$var$isHydrating && 0 !== (workInProgress.flags & 1048576) && $5c00e1cb1faeed50$var$pushTreeId(workInProgress, $5c00e1cb1faeed50$var$treeForkCount, workInProgress.index);
    workInProgress.lanes = 0;
    switch(workInProgress.tag){
        case 16:
            a: {
                var props = workInProgress.pendingProps;
                current = $5c00e1cb1faeed50$var$resolveLazy(workInProgress.elementType);
                workInProgress.type = current;
                if ("function" === typeof current) $5c00e1cb1faeed50$var$shouldConstruct(current) ? (props = $5c00e1cb1faeed50$var$resolveClassComponentProps(current, props), workInProgress.tag = 1, workInProgress = $5c00e1cb1faeed50$var$updateClassComponent(null, workInProgress, current, props, renderLanes)) : (workInProgress.tag = 0, workInProgress = $5c00e1cb1faeed50$var$updateFunctionComponent(null, workInProgress, current, props, renderLanes));
                else {
                    if (void 0 !== current && null !== current) {
                        var $$typeof = current.$$typeof;
                        if ($$typeof === $5c00e1cb1faeed50$var$REACT_FORWARD_REF_TYPE) {
                            workInProgress.tag = 11;
                            workInProgress = $5c00e1cb1faeed50$var$updateForwardRef(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $5c00e1cb1faeed50$var$REACT_MEMO_TYPE) {
                            workInProgress.tag = 14;
                            workInProgress = $5c00e1cb1faeed50$var$updateMemoComponent(null, workInProgress, current, props, renderLanes);
                            break a;
                        } else if ($$typeof === $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE) {
                            workInProgress.tag = 10;
                            workInProgress.type = current;
                            workInProgress = $5c00e1cb1faeed50$var$updateContextProvider(null, workInProgress, renderLanes);
                            break a;
                        }
                    }
                    workInProgress = $5c00e1cb1faeed50$var$getComponentNameFromType(current) || current;
                    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(306, workInProgress, ""));
                }
            }
            return workInProgress;
        case 0:
            return $5c00e1cb1faeed50$var$updateFunctionComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 1:
            return props = workInProgress.type, $$typeof = $5c00e1cb1faeed50$var$resolveClassComponentProps(props, workInProgress.pendingProps), $5c00e1cb1faeed50$var$updateClassComponent(current, workInProgress, props, $$typeof, renderLanes);
        case 3:
            a: {
                $5c00e1cb1faeed50$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo);
                if (null === current) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(387));
                props = workInProgress.pendingProps;
                var prevState = workInProgress.memoizedState;
                $$typeof = prevState.element;
                $5c00e1cb1faeed50$var$cloneUpdateQueue(current, workInProgress);
                $5c00e1cb1faeed50$var$processUpdateQueue(workInProgress, props, null, renderLanes);
                var nextState = workInProgress.memoizedState;
                props = nextState.cache;
                $5c00e1cb1faeed50$var$pushProvider(workInProgress, $5c00e1cb1faeed50$var$CacheContext, props);
                props !== prevState.cache && $5c00e1cb1faeed50$var$propagateContextChanges(workInProgress, [
                    $5c00e1cb1faeed50$var$CacheContext
                ], renderLanes, !0);
                $5c00e1cb1faeed50$var$suspendIfUpdateReadFromEntangledAsyncAction();
                props = nextState.element;
                if (prevState.isDehydrated) {
                    if (prevState = {
                        element: props,
                        isDehydrated: !1,
                        cache: nextState.cache
                    }, workInProgress.updateQueue.baseState = prevState, workInProgress.memoizedState = prevState, workInProgress.flags & 256) {
                        workInProgress = $5c00e1cb1faeed50$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else if (props !== $$typeof) {
                        $$typeof = $5c00e1cb1faeed50$var$createCapturedValueAtFiber(Error($5c00e1cb1faeed50$var$formatProdErrorMessage(424)), workInProgress);
                        $5c00e1cb1faeed50$var$queueHydrationError($$typeof);
                        workInProgress = $5c00e1cb1faeed50$var$mountHostRootWithoutHydrating(current, workInProgress, props, renderLanes);
                        break a;
                    } else {
                        current = workInProgress.stateNode.containerInfo;
                        switch(current.nodeType){
                            case 9:
                                current = current.body;
                                break;
                            default:
                                current = "HTML" === current.nodeName ? current.ownerDocument.body : current;
                        }
                        $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratable(current.firstChild);
                        $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress;
                        $5c00e1cb1faeed50$var$isHydrating = !0;
                        $5c00e1cb1faeed50$var$hydrationErrors = null;
                        $5c00e1cb1faeed50$var$rootOrSingletonContext = !0;
                        renderLanes = $5c00e1cb1faeed50$var$mountChildFibers(workInProgress, null, props, renderLanes);
                        for(workInProgress.child = renderLanes; renderLanes;)renderLanes.flags = renderLanes.flags & -3 | 134221824, renderLanes = renderLanes.sibling;
                    }
                } else {
                    $5c00e1cb1faeed50$var$resetHydrationState();
                    if (props === $$typeof) {
                        workInProgress = $5c00e1cb1faeed50$var$bailoutOnAlreadyFinishedWork(current, workInProgress, renderLanes);
                        break a;
                    }
                    $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, props, renderLanes);
                }
                workInProgress = workInProgress.child;
            }
            return workInProgress;
        case 26:
            return $5c00e1cb1faeed50$var$markRef(current, workInProgress), null === current ? (renderLanes = $5c00e1cb1faeed50$var$getResource(workInProgress.type, null, workInProgress.pendingProps, null)) ? workInProgress.memoizedState = renderLanes : $5c00e1cb1faeed50$var$isHydrating || (workInProgress.stateNode = $5c00e1cb1faeed50$var$createHoistableInstance(workInProgress.type, workInProgress.pendingProps, $5c00e1cb1faeed50$var$rootInstanceStackCursor.current, workInProgress)) : workInProgress.memoizedState = $5c00e1cb1faeed50$var$getResource(workInProgress.type, current.memoizedProps, workInProgress.pendingProps, current.memoizedState), null;
        case 27:
            return $5c00e1cb1faeed50$var$pushHostContext(workInProgress), null === current && $5c00e1cb1faeed50$var$isHydrating && (props = workInProgress.stateNode = $5c00e1cb1faeed50$var$resolveSingletonInstance(workInProgress.type, workInProgress.pendingProps, $5c00e1cb1faeed50$var$rootInstanceStackCursor.current), $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress, $5c00e1cb1faeed50$var$rootOrSingletonContext = !0, $$typeof = $5c00e1cb1faeed50$var$nextHydratableInstance, $5c00e1cb1faeed50$var$isSingletonScope(workInProgress.type) ? ($5c00e1cb1faeed50$var$previousHydratableOnEnteringScopedSingleton = $$typeof, $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratable(props.firstChild)) : $5c00e1cb1faeed50$var$nextHydratableInstance = $$typeof), $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), $5c00e1cb1faeed50$var$markRef(current, workInProgress), null === current && (workInProgress.flags |= 4194304), workInProgress.child;
        case 5:
            if (null === current && $5c00e1cb1faeed50$var$isHydrating) {
                if ($$typeof = props = $5c00e1cb1faeed50$var$nextHydratableInstance) props = $5c00e1cb1faeed50$var$canHydrateInstance(props, workInProgress.type, workInProgress.pendingProps, $5c00e1cb1faeed50$var$rootOrSingletonContext), null !== props ? (workInProgress.stateNode = props, $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress, $5c00e1cb1faeed50$var$nextHydratableInstance = $5c00e1cb1faeed50$var$getNextHydratable(props.firstChild), $5c00e1cb1faeed50$var$rootOrSingletonContext = !1, $$typeof = !0) : $$typeof = !1;
                $$typeof || $5c00e1cb1faeed50$var$throwOnHydrationMismatch(workInProgress);
            }
            $5c00e1cb1faeed50$var$pushHostContext(workInProgress);
            $$typeof = workInProgress.type;
            prevState = workInProgress.pendingProps;
            nextState = null !== current ? current.memoizedProps : null;
            props = prevState.children;
            $5c00e1cb1faeed50$var$shouldSetTextContent($$typeof, prevState) ? props = null : null !== nextState && $5c00e1cb1faeed50$var$shouldSetTextContent($$typeof, nextState) && (workInProgress.flags |= 32);
            null !== workInProgress.memoizedState && ($$typeof = $5c00e1cb1faeed50$var$renderWithHooks(current, workInProgress, $5c00e1cb1faeed50$var$TransitionAwareHostComponent, null, null, renderLanes), $5c00e1cb1faeed50$var$HostTransitionContext._currentValue = $$typeof);
            $5c00e1cb1faeed50$var$markRef(current, workInProgress);
            $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, props, renderLanes);
            return workInProgress.child;
        case 6:
            if (null === current && $5c00e1cb1faeed50$var$isHydrating) {
                if (current = renderLanes = $5c00e1cb1faeed50$var$nextHydratableInstance) renderLanes = $5c00e1cb1faeed50$var$canHydrateTextInstance(renderLanes, workInProgress.pendingProps, $5c00e1cb1faeed50$var$rootOrSingletonContext), null !== renderLanes ? (workInProgress.stateNode = renderLanes, $5c00e1cb1faeed50$var$hydrationParentFiber = workInProgress, $5c00e1cb1faeed50$var$nextHydratableInstance = null, current = !0) : current = !1;
                current || $5c00e1cb1faeed50$var$throwOnHydrationMismatch(workInProgress);
            }
            return null;
        case 13:
            return $5c00e1cb1faeed50$var$updateSuspenseComponent(current, workInProgress, renderLanes);
        case 4:
            return $5c00e1cb1faeed50$var$pushHostContainer(workInProgress, workInProgress.stateNode.containerInfo), props = workInProgress.pendingProps, null === current ? workInProgress.child = $5c00e1cb1faeed50$var$reconcileChildFibers(workInProgress, null, props, renderLanes) : $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 11:
            return $5c00e1cb1faeed50$var$updateForwardRef(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 7:
            return props = workInProgress.pendingProps, $5c00e1cb1faeed50$var$markRef(current, workInProgress), $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 8:
            return $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 12:
            return $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 10:
            return $5c00e1cb1faeed50$var$updateContextProvider(current, workInProgress, renderLanes);
        case 9:
            return $$typeof = workInProgress.type._context, props = workInProgress.pendingProps.children, $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress), $$typeof = $5c00e1cb1faeed50$var$readContext($$typeof), props = props($$typeof), workInProgress.flags |= 1, $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, props, renderLanes), workInProgress.child;
        case 14:
            return $5c00e1cb1faeed50$var$updateMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 15:
            return $5c00e1cb1faeed50$var$updateSimpleMemoComponent(current, workInProgress, workInProgress.type, workInProgress.pendingProps, renderLanes);
        case 19:
            return $5c00e1cb1faeed50$var$updateSuspenseListComponent(current, workInProgress, renderLanes);
        case 31:
            return $5c00e1cb1faeed50$var$updateActivityComponent(current, workInProgress, renderLanes);
        case 22:
            return $5c00e1cb1faeed50$var$updateOffscreenComponent(current, workInProgress, renderLanes, workInProgress.pendingProps);
        case 24:
            return $5c00e1cb1faeed50$var$prepareToReadContext(workInProgress), props = $5c00e1cb1faeed50$var$readContext($5c00e1cb1faeed50$var$CacheContext), null === current ? ($$typeof = $5c00e1cb1faeed50$var$peekCacheFromPool(), null === $$typeof && ($$typeof = $5c00e1cb1faeed50$var$workInProgressRoot, prevState = $5c00e1cb1faeed50$var$createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes), $$typeof = prevState), workInProgress.memoizedState = {
                parent: props,
                cache: $$typeof
            }, $5c00e1cb1faeed50$var$initializeUpdateQueue(workInProgress), $5c00e1cb1faeed50$var$pushProvider(workInProgress, $5c00e1cb1faeed50$var$CacheContext, $$typeof)) : (0 !== (current.lanes & renderLanes) && ($5c00e1cb1faeed50$var$cloneUpdateQueue(current, workInProgress), $5c00e1cb1faeed50$var$processUpdateQueue(workInProgress, null, null, renderLanes), $5c00e1cb1faeed50$var$suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current.memoizedState, prevState = workInProgress.memoizedState, $$typeof.parent !== props ? ($$typeof = {
                parent: props,
                cache: props
            }, workInProgress.memoizedState = $$typeof, 0 === workInProgress.lanes && (workInProgress.memoizedState = workInProgress.updateQueue.baseState = $$typeof), $5c00e1cb1faeed50$var$pushProvider(workInProgress, $5c00e1cb1faeed50$var$CacheContext, props)) : (props = prevState.cache, $5c00e1cb1faeed50$var$pushProvider(workInProgress, $5c00e1cb1faeed50$var$CacheContext, props), props !== $$typeof.cache && $5c00e1cb1faeed50$var$propagateContextChanges(workInProgress, [
                $5c00e1cb1faeed50$var$CacheContext
            ], renderLanes, !0))), $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, workInProgress.pendingProps.children, renderLanes), workInProgress.child;
        case 30:
            return null === workInProgress.stateNode && (workInProgress.stateNode = {
                autoName: null,
                paired: null,
                clones: null,
                ref: null
            }), props = workInProgress.pendingProps, null != props.name && "auto" !== props.name ? workInProgress.flags |= null === current ? 18882560 : 18874368 : $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushMaterializedTreeId(workInProgress), null !== current && current.memoizedProps.name !== props.name ? workInProgress.flags |= 4194816 : $5c00e1cb1faeed50$var$markRef(current, workInProgress), $5c00e1cb1faeed50$var$reconcileChildren(current, workInProgress, props.children, renderLanes), workInProgress.child;
        case 29:
            throw workInProgress.pendingProps;
    }
    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $5c00e1cb1faeed50$var$markUpdate(workInProgress) {
    workInProgress.flags |= 4;
}
function $5c00e1cb1faeed50$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, oldProps, newProps, renderLanes) {
    var JSCompiler_temp;
    if (JSCompiler_temp = 0 !== (workInProgress.mode & 32)) JSCompiler_temp = null === oldProps ? $5c00e1cb1faeed50$var$maySuspendCommit(type, newProps) : $5c00e1cb1faeed50$var$maySuspendCommit(type, newProps) && (newProps.src !== oldProps.src || newProps.srcSet !== oldProps.srcSet);
    if (JSCompiler_temp) {
        if (workInProgress.flags |= 16777216, (renderLanes & 335544128) === renderLanes) {
            if (workInProgress.stateNode.complete) workInProgress.flags |= 8192;
            else if ($5c00e1cb1faeed50$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
            else throw $5c00e1cb1faeed50$var$suspendedThenable = $5c00e1cb1faeed50$var$noopSuspenseyCommitThenable, $5c00e1cb1faeed50$var$SuspenseyCommitException;
        }
    } else workInProgress.flags &= -16777217;
}
function $5c00e1cb1faeed50$var$preloadResourceAndSuspendIfNeeded(workInProgress, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4)) workInProgress.flags &= -16777217;
    else if (workInProgress.flags |= 16777216, !$5c00e1cb1faeed50$var$preloadResource(resource)) {
        if ($5c00e1cb1faeed50$var$shouldRemainOnPreviousScreen()) workInProgress.flags |= 8192;
        else throw $5c00e1cb1faeed50$var$suspendedThenable = $5c00e1cb1faeed50$var$noopSuspenseyCommitThenable, $5c00e1cb1faeed50$var$SuspenseyCommitException;
    }
}
function $5c00e1cb1faeed50$var$scheduleRetryEffect(workInProgress, retryQueue) {
    null !== retryQueue && (workInProgress.flags |= 4);
    workInProgress.flags & 16384 && (retryQueue = 22 !== workInProgress.tag ? $5c00e1cb1faeed50$var$claimNextRetryLane() : 536870912, workInProgress.lanes |= retryQueue, $5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes |= retryQueue);
}
function $5c00e1cb1faeed50$var$cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!$5c00e1cb1faeed50$var$isHydrating) switch(renderState.tailMode){
        case "visible":
            break;
        case "collapsed":
            for(var tailNode = renderState.tail, lastTailNode = null; null !== tailNode;)null !== tailNode.alternate && (lastTailNode = tailNode), tailNode = tailNode.sibling;
            null === lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode.sibling = null;
            break;
        default:
            hasRenderedATailFallback = renderState.tail;
            for(tailNode = null; null !== hasRenderedATailFallback;)null !== hasRenderedATailFallback.alternate && (tailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === tailNode ? renderState.tail = null : tailNode.sibling = null;
    }
}
function $5c00e1cb1faeed50$var$bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout) for(var child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags & 1206910976, subtreeFlags |= child$113.flags & 1206910976, child$113.return = completedWork, child$113 = child$113.sibling;
    else for(child$113 = completedWork.child; null !== child$113;)newChildLanes |= child$113.lanes | child$113.childLanes, subtreeFlags |= child$113.subtreeFlags, subtreeFlags |= child$113.flags, child$113.return = completedWork, child$113 = child$113.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
}
function $5c00e1cb1faeed50$var$completeWork(current, workInProgress, renderLanes) {
    var newProps = workInProgress.pendingProps;
    $5c00e1cb1faeed50$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
            return $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
        case 1:
            return $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
        case 3:
            renderLanes = workInProgress.stateNode;
            newProps = null;
            null !== current && (newProps = current.memoizedState.cache);
            workInProgress.memoizedState.cache !== newProps && (workInProgress.flags |= 2048);
            $5c00e1cb1faeed50$var$popProvider($5c00e1cb1faeed50$var$CacheContext);
            $5c00e1cb1faeed50$var$popHostContainer();
            renderLanes.pendingContext && (renderLanes.context = renderLanes.pendingContext, renderLanes.pendingContext = null);
            if (null === current || null === current.child) $5c00e1cb1faeed50$var$popHydrationState(workInProgress) ? $5c00e1cb1faeed50$var$markUpdate(workInProgress) : null === current || current.memoizedState.isDehydrated && 0 === (workInProgress.flags & 256) || (workInProgress.flags |= 1024, $5c00e1cb1faeed50$var$upgradeHydrationErrorsToRecoverable());
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            return null;
        case 26:
            var type = workInProgress.type, nextResource = workInProgress.memoizedState;
            null === current ? ($5c00e1cb1faeed50$var$markUpdate(workInProgress), null !== nextResource ? ($5c00e1cb1faeed50$var$bubbleProperties(workInProgress), $5c00e1cb1faeed50$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($5c00e1cb1faeed50$var$bubbleProperties(workInProgress), $5c00e1cb1faeed50$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, null, newProps, renderLanes))) : nextResource ? nextResource !== current.memoizedState ? ($5c00e1cb1faeed50$var$markUpdate(workInProgress), $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), $5c00e1cb1faeed50$var$preloadResourceAndSuspendIfNeeded(workInProgress, nextResource)) : ($5c00e1cb1faeed50$var$bubbleProperties(workInProgress), workInProgress.flags &= -16777217) : (current = current.memoizedProps, current !== newProps && $5c00e1cb1faeed50$var$markUpdate(workInProgress), $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), $5c00e1cb1faeed50$var$preloadInstanceAndSuspendIfNeeded(workInProgress, type, current, newProps, renderLanes));
            return null;
        case 27:
            $5c00e1cb1faeed50$var$popHostContext(workInProgress);
            renderLanes = $5c00e1cb1faeed50$var$rootInstanceStackCursor.current;
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $5c00e1cb1faeed50$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(166));
                    $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                current = $5c00e1cb1faeed50$var$contextStackCursor.current;
                $5c00e1cb1faeed50$var$popHydrationState(workInProgress) ? $5c00e1cb1faeed50$var$prepareToHydrateHostInstance(workInProgress, current) : (current = $5c00e1cb1faeed50$var$resolveSingletonInstance(type, newProps, renderLanes), workInProgress.stateNode = current, $5c00e1cb1faeed50$var$markUpdate(workInProgress));
            }
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            return null;
        case 5:
            $5c00e1cb1faeed50$var$popHostContext(workInProgress);
            type = workInProgress.type;
            if (null !== current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $5c00e1cb1faeed50$var$markUpdate(workInProgress);
            else {
                if (!newProps) {
                    if (null === workInProgress.stateNode) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(166));
                    $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
                    workInProgress.subtreeFlags &= -33554433;
                    return null;
                }
                nextResource = $5c00e1cb1faeed50$var$contextStackCursor.current;
                if ($5c00e1cb1faeed50$var$popHydrationState(workInProgress)) $5c00e1cb1faeed50$var$prepareToHydrateHostInstance(workInProgress, nextResource);
                else {
                    var ownerDocument = $5c00e1cb1faeed50$var$getOwnerDocumentFromRootContainer($5c00e1cb1faeed50$var$rootInstanceStackCursor.current);
                    switch(nextResource){
                        case 1:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                            break;
                        case 2:
                            nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                            break;
                        default:
                            switch(type){
                                case "svg":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/2000/svg", type);
                                    break;
                                case "math":
                                    nextResource = ownerDocument.createElementNS("http://www.w3.org/1998/Math/MathML", type);
                                    break;
                                case "script":
                                    nextResource = ownerDocument.createElement("div");
                                    nextResource.innerHTML = "<script>\x3c/script>";
                                    nextResource = nextResource.removeChild(nextResource.firstChild);
                                    break;
                                case "select":
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                                        is: newProps.is
                                    }) : ownerDocument.createElement("select");
                                    newProps.multiple ? nextResource.multiple = !0 : newProps.size && (nextResource.size = newProps.size);
                                    break;
                                default:
                                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, {
                                        is: newProps.is
                                    }) : ownerDocument.createElement(type);
                            }
                    }
                    nextResource[$5c00e1cb1faeed50$var$internalInstanceKey] = workInProgress;
                    nextResource[$5c00e1cb1faeed50$var$internalPropsKey] = newProps;
                    a: for(ownerDocument = workInProgress.child; null !== ownerDocument;){
                        if (5 === ownerDocument.tag || 6 === ownerDocument.tag) nextResource.appendChild(ownerDocument.stateNode);
                        else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                            ownerDocument.child.return = ownerDocument;
                            ownerDocument = ownerDocument.child;
                            continue;
                        }
                        if (ownerDocument === workInProgress) break a;
                        for(; null === ownerDocument.sibling;){
                            if (null === ownerDocument.return || ownerDocument.return === workInProgress) break a;
                            ownerDocument = ownerDocument.return;
                        }
                        ownerDocument.sibling.return = ownerDocument.return;
                        ownerDocument = ownerDocument.sibling;
                    }
                    workInProgress.stateNode = nextResource;
                    a: switch($5c00e1cb1faeed50$var$setInitialProperties(nextResource, type, newProps), type){
                        case "button":
                        case "input":
                        case "select":
                        case "textarea":
                            newProps = !!newProps.autoFocus;
                            break a;
                        case "img":
                            newProps = !0;
                            break a;
                        default:
                            newProps = !1;
                    }
                    newProps && $5c00e1cb1faeed50$var$markUpdate(workInProgress);
                }
            }
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            workInProgress.subtreeFlags &= -33554433;
            $5c00e1cb1faeed50$var$preloadInstanceAndSuspendIfNeeded(workInProgress, workInProgress.type, null === current ? null : current.memoizedProps, workInProgress.pendingProps, renderLanes);
            return null;
        case 6:
            if (current && null != workInProgress.stateNode) current.memoizedProps !== newProps && $5c00e1cb1faeed50$var$markUpdate(workInProgress);
            else {
                if ("string" !== typeof newProps && null === workInProgress.stateNode) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(166));
                current = $5c00e1cb1faeed50$var$rootInstanceStackCursor.current;
                if ($5c00e1cb1faeed50$var$popHydrationState(workInProgress)) {
                    current = workInProgress.stateNode;
                    renderLanes = workInProgress.memoizedProps;
                    newProps = null;
                    type = $5c00e1cb1faeed50$var$hydrationParentFiber;
                    if (null !== type) switch(type.tag){
                        case 27:
                        case 5:
                            newProps = type.memoizedProps;
                    }
                    current[$5c00e1cb1faeed50$var$internalInstanceKey] = workInProgress;
                    current = current.nodeValue === renderLanes || null !== newProps && !0 === newProps.suppressHydrationWarning || $5c00e1cb1faeed50$var$checkForUnmatchedText(current.nodeValue, renderLanes) ? !0 : !1;
                    current || $5c00e1cb1faeed50$var$throwOnHydrationMismatch(workInProgress, !0);
                } else current = $5c00e1cb1faeed50$var$getOwnerDocumentFromRootContainer(current).createTextNode(newProps), current[$5c00e1cb1faeed50$var$internalInstanceKey] = workInProgress, workInProgress.stateNode = current;
            }
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            return null;
        case 31:
            renderLanes = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState) {
                newProps = $5c00e1cb1faeed50$var$popHydrationState(workInProgress);
                if (null !== renderLanes) {
                    if (null === current) {
                        if (!newProps) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(318));
                        current = workInProgress.memoizedState;
                        current = null !== current ? current.dehydrated : null;
                        if (!current) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(557));
                        current[$5c00e1cb1faeed50$var$internalInstanceKey] = workInProgress;
                    } else $5c00e1cb1faeed50$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
                    current = !1;
                } else renderLanes = $5c00e1cb1faeed50$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = renderLanes), current = !0;
                if (!current) {
                    if (workInProgress.flags & 256) return $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress), workInProgress;
                    $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress);
                    return null;
                }
                if (0 !== (workInProgress.flags & 128)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(558));
            }
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            return null;
        case 13:
            newProps = workInProgress.memoizedState;
            if (null === current || null !== current.memoizedState && null !== current.memoizedState.dehydrated) {
                type = $5c00e1cb1faeed50$var$popHydrationState(workInProgress);
                if (null !== newProps && null !== newProps.dehydrated) {
                    if (null === current) {
                        if (!type) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(318));
                        type = workInProgress.memoizedState;
                        type = null !== type ? type.dehydrated : null;
                        if (!type) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(317));
                        type[$5c00e1cb1faeed50$var$internalInstanceKey] = workInProgress;
                    } else $5c00e1cb1faeed50$var$resetHydrationState(), 0 === (workInProgress.flags & 128) && (workInProgress.memoizedState = null), workInProgress.flags |= 4;
                    $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
                    type = !1;
                } else type = $5c00e1cb1faeed50$var$upgradeHydrationErrorsToRecoverable(), null !== current && null !== current.memoizedState && (current.memoizedState.hydrationErrors = type), type = !0;
                if (!type) {
                    if (workInProgress.flags & 256) return $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress), workInProgress;
                    $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress);
                    return null;
                }
            }
            $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress);
            if (0 !== (workInProgress.flags & 128)) return workInProgress.lanes = renderLanes, workInProgress;
            renderLanes = null !== newProps;
            current = null !== current && null !== current.memoizedState;
            renderLanes && (newProps = workInProgress.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
            renderLanes !== current && renderLanes && (workInProgress.child.flags |= 8192);
            $5c00e1cb1faeed50$var$scheduleRetryEffect(workInProgress, workInProgress.updateQueue);
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            return null;
        case 4:
            return $5c00e1cb1faeed50$var$popHostContainer(), null === current && $5c00e1cb1faeed50$var$listenToAllSupportedEvents(workInProgress.stateNode.containerInfo), workInProgress.flags |= 67108864, $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
        case 10:
            return $5c00e1cb1faeed50$var$popProvider(workInProgress.type), $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
        case 19:
            $5c00e1cb1faeed50$var$popSuspenseListContext(workInProgress);
            newProps = workInProgress.memoizedState;
            if (null === newProps) return $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
            type = 0 !== (workInProgress.flags & 128);
            nextResource = newProps.rendering;
            if (null === nextResource) {
                if (type) $5c00e1cb1faeed50$var$cutOffTailIfNeeded(newProps, !1);
                else {
                    if (0 !== $5c00e1cb1faeed50$var$workInProgressRootExitStatus || null !== current && 0 !== (current.flags & 128)) for(current = workInProgress.child; null !== current;){
                        nextResource = $5c00e1cb1faeed50$var$findFirstSuspended(current);
                        if (null !== nextResource) {
                            workInProgress.flags |= 128;
                            $5c00e1cb1faeed50$var$cutOffTailIfNeeded(newProps, !1);
                            current = nextResource.updateQueue;
                            workInProgress.updateQueue = current;
                            $5c00e1cb1faeed50$var$scheduleRetryEffect(workInProgress, current);
                            workInProgress.subtreeFlags = 0;
                            current = renderLanes;
                            for(renderLanes = workInProgress.child; null !== renderLanes;)$5c00e1cb1faeed50$var$resetWorkInProgress(renderLanes, current), renderLanes = renderLanes.sibling;
                            $5c00e1cb1faeed50$var$pushSuspenseListContext(workInProgress, $5c00e1cb1faeed50$var$suspenseStackCursor.current & 1 | 2);
                            $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                            return workInProgress.child;
                        }
                        current = current.sibling;
                    }
                    null !== newProps.tail && $5c00e1cb1faeed50$var$now() > $5c00e1cb1faeed50$var$workInProgressRootRenderTargetTime && (workInProgress.flags |= 128, type = !0, $5c00e1cb1faeed50$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
            } else {
                if (!type) {
                    if (current = $5c00e1cb1faeed50$var$findFirstSuspended(nextResource), null !== current) {
                        if (workInProgress.flags |= 128, type = !0, current = current.updateQueue, workInProgress.updateQueue = current, $5c00e1cb1faeed50$var$scheduleRetryEffect(workInProgress, current), $5c00e1cb1faeed50$var$cutOffTailIfNeeded(newProps, !0), null === newProps.tail && "collapsed" !== newProps.tailMode && "visible" !== newProps.tailMode && !nextResource.alternate && !$5c00e1cb1faeed50$var$isHydrating) return $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
                    } else 2 * $5c00e1cb1faeed50$var$now() - newProps.renderingStartTime > $5c00e1cb1faeed50$var$workInProgressRootRenderTargetTime && 536870912 !== renderLanes && (workInProgress.flags |= 128, type = !0, $5c00e1cb1faeed50$var$cutOffTailIfNeeded(newProps, !1), workInProgress.lanes = 4194304);
                }
                newProps.isBackwards ? (nextResource.sibling = workInProgress.child, workInProgress.child = nextResource) : (current = newProps.last, null !== current ? current.sibling = nextResource : workInProgress.child = nextResource, newProps.last = nextResource);
            }
            if (null !== newProps.tail) {
                current = newProps.tail;
                a: {
                    for(renderLanes = current; null !== renderLanes;){
                        if (null !== renderLanes.alternate) {
                            renderLanes = !1;
                            break a;
                        }
                        renderLanes = renderLanes.sibling;
                    }
                    renderLanes = !0;
                }
                newProps.rendering = current;
                newProps.tail = current.sibling;
                newProps.renderingStartTime = $5c00e1cb1faeed50$var$now();
                current.sibling = null;
                nextResource = $5c00e1cb1faeed50$var$suspenseStackCursor.current;
                nextResource = type ? nextResource & 1 | 2 : nextResource & 1;
                "visible" === newProps.tailMode || "collapsed" === newProps.tailMode || !renderLanes || $5c00e1cb1faeed50$var$isHydrating ? $5c00e1cb1faeed50$var$pushSuspenseListContext(workInProgress, nextResource) : (renderLanes = nextResource, $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseHandlerStackCursor, workInProgress), $5c00e1cb1faeed50$var$push($5c00e1cb1faeed50$var$suspenseStackCursor, renderLanes), null === $5c00e1cb1faeed50$var$shellBoundary && ($5c00e1cb1faeed50$var$shellBoundary = workInProgress));
                $5c00e1cb1faeed50$var$isHydrating && $5c00e1cb1faeed50$var$pushTreeFork(workInProgress, newProps.treeForkCount);
                return current;
            }
            $5c00e1cb1faeed50$var$bubbleProperties(workInProgress);
            return null;
        case 22:
        case 23:
            return $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress), $5c00e1cb1faeed50$var$popHiddenContext(), newProps = null !== workInProgress.memoizedState, null !== current ? null !== current.memoizedState !== newProps && (workInProgress.flags |= 8192) : newProps && (workInProgress.flags |= 8192), newProps ? 0 !== (renderLanes & 536870912) && 0 === (workInProgress.flags & 128) && ($5c00e1cb1faeed50$var$bubbleProperties(workInProgress), workInProgress.subtreeFlags & 6 && (workInProgress.flags |= 8192)) : $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), renderLanes = workInProgress.updateQueue, null !== renderLanes && $5c00e1cb1faeed50$var$scheduleRetryEffect(workInProgress, renderLanes.retryQueue), renderLanes = null, null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (renderLanes = current.memoizedState.cachePool.pool), newProps = null, null !== workInProgress.memoizedState && null !== workInProgress.memoizedState.cachePool && (newProps = workInProgress.memoizedState.cachePool.pool), newProps !== renderLanes && (workInProgress.flags |= 2048), null !== current && $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$resumedCache), null;
        case 24:
            return renderLanes = null, null !== current && (renderLanes = current.memoizedState.cache), workInProgress.memoizedState.cache !== renderLanes && (workInProgress.flags |= 2048), $5c00e1cb1faeed50$var$popProvider($5c00e1cb1faeed50$var$CacheContext), $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
        case 25:
            return null;
        case 30:
            return workInProgress.flags |= 33554432, $5c00e1cb1faeed50$var$bubbleProperties(workInProgress), null;
    }
    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(156, workInProgress.tag));
}
function $5c00e1cb1faeed50$var$unwindWork(current, workInProgress) {
    $5c00e1cb1faeed50$var$popTreeContext(workInProgress);
    switch(workInProgress.tag){
        case 1:
            return current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 3:
            return $5c00e1cb1faeed50$var$popProvider($5c00e1cb1faeed50$var$CacheContext), $5c00e1cb1faeed50$var$popHostContainer(), current = workInProgress.flags, 0 !== (current & 65536) && 0 === (current & 128) ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 26:
        case 27:
        case 5:
            return $5c00e1cb1faeed50$var$popHostContext(workInProgress), null;
        case 31:
            if (null !== workInProgress.memoizedState) {
                $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress);
                if (null === workInProgress.alternate) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(340));
                $5c00e1cb1faeed50$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 13:
            $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress);
            current = workInProgress.memoizedState;
            if (null !== current && null !== current.dehydrated) {
                if (null === workInProgress.alternate) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(340));
                $5c00e1cb1faeed50$var$resetHydrationState();
            }
            current = workInProgress.flags;
            return current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 19:
            return $5c00e1cb1faeed50$var$popSuspenseListContext(workInProgress), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, current = workInProgress.memoizedState, null !== current && (current.rendering = null, current.tail = null), workInProgress.flags |= 4, workInProgress) : null;
        case 4:
            return $5c00e1cb1faeed50$var$popHostContainer(), null;
        case 10:
            return $5c00e1cb1faeed50$var$popProvider(workInProgress.type), null;
        case 22:
        case 23:
            return $5c00e1cb1faeed50$var$popSuspenseHandler(workInProgress), $5c00e1cb1faeed50$var$popHiddenContext(), null !== current && $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$resumedCache), current = workInProgress.flags, current & 65536 ? (workInProgress.flags = current & -65537 | 128, workInProgress) : null;
        case 24:
            return $5c00e1cb1faeed50$var$popProvider($5c00e1cb1faeed50$var$CacheContext), null;
        case 25:
            return null;
        default:
            return null;
    }
}
function $5c00e1cb1faeed50$var$unwindInterruptedWork(current, interruptedWork) {
    $5c00e1cb1faeed50$var$popTreeContext(interruptedWork);
    switch(interruptedWork.tag){
        case 3:
            $5c00e1cb1faeed50$var$popProvider($5c00e1cb1faeed50$var$CacheContext);
            $5c00e1cb1faeed50$var$popHostContainer();
            break;
        case 26:
        case 27:
        case 5:
            $5c00e1cb1faeed50$var$popHostContext(interruptedWork);
            break;
        case 4:
            $5c00e1cb1faeed50$var$popHostContainer();
            break;
        case 31:
            null !== interruptedWork.memoizedState && $5c00e1cb1faeed50$var$popSuspenseHandler(interruptedWork);
            break;
        case 13:
            $5c00e1cb1faeed50$var$popSuspenseHandler(interruptedWork);
            break;
        case 19:
            $5c00e1cb1faeed50$var$popSuspenseListContext(interruptedWork);
            break;
        case 10:
            $5c00e1cb1faeed50$var$popProvider(interruptedWork.type);
            break;
        case 22:
        case 23:
            $5c00e1cb1faeed50$var$popSuspenseHandler(interruptedWork);
            $5c00e1cb1faeed50$var$popHiddenContext();
            null !== current && $5c00e1cb1faeed50$var$pop($5c00e1cb1faeed50$var$resumedCache);
            break;
        case 24:
            $5c00e1cb1faeed50$var$popProvider($5c00e1cb1faeed50$var$CacheContext);
    }
}
function $5c00e1cb1faeed50$var$commitHookEffectListMount(flags, finishedWork) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    lastEffect = void 0;
                    var create = updateQueue.create, inst = updateQueue.inst;
                    lastEffect = create();
                    inst.destroy = lastEffect;
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5c00e1cb1faeed50$var$commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
            var firstEffect = lastEffect.next;
            updateQueue = firstEffect;
            do {
                if ((updateQueue.tag & flags) === flags) {
                    var inst = updateQueue.inst, destroy = inst.destroy;
                    if (void 0 !== destroy) {
                        inst.destroy = void 0;
                        lastEffect = finishedWork;
                        var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
                        try {
                            destroy_();
                        } catch (error) {
                            $5c00e1cb1faeed50$var$captureCommitPhaseError(lastEffect, nearestMountedAncestor, error);
                        }
                    }
                }
                updateQueue = updateQueue.next;
            }while (updateQueue !== firstEffect);
        }
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5c00e1cb1faeed50$var$commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        try {
            $5c00e1cb1faeed50$var$commitCallbacks(updateQueue, instance);
        } catch (error) {
            $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $5c00e1cb1faeed50$var$safelyCallComponentWillUnmount(current, nearestMountedAncestor, instance) {
    instance.props = $5c00e1cb1faeed50$var$resolveClassComponentProps(current.type, current.memoizedProps);
    instance.state = current.memoizedState;
    try {
        instance.componentWillUnmount();
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $5c00e1cb1faeed50$var$safelyAttachRef(current, nearestMountedAncestor) {
    try {
        var ref = current.ref;
        if (null !== ref) {
            switch(current.tag){
                case 26:
                case 27:
                case 5:
                    var instanceToUse = current.stateNode;
                    break;
                case 30:
                    var instance = current.stateNode, name = $5c00e1cb1faeed50$var$getViewTransitionName(current.memoizedProps, instance);
                    if (null === instance.ref || instance.ref.name !== name) instance.ref = $5c00e1cb1faeed50$var$createViewTransitionInstance(name);
                    instanceToUse = instance.ref;
                    break;
                case 7:
                    if (null === current.stateNode) {
                        var fragmentInstance = new $5c00e1cb1faeed50$var$FragmentInstance(current);
                        $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(current.child, !1, $5c00e1cb1faeed50$var$addFragmentHandleToFiber, fragmentInstance, void 0, void 0);
                        current.stateNode = fragmentInstance;
                    }
                    instanceToUse = current.stateNode;
                    break;
                default:
                    instanceToUse = current.stateNode;
            }
            "function" === typeof ref ? current.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
        }
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
    }
}
function $5c00e1cb1faeed50$var$safelyDetachRef(current, nearestMountedAncestor) {
    var ref = current.ref, refCleanup = current.refCleanup;
    if (null !== ref) {
        if ("function" === typeof refCleanup) try {
            refCleanup();
        } catch (error) {
            $5c00e1cb1faeed50$var$captureCommitPhaseError(current, nearestMountedAncestor, error);
        } finally{
            current.refCleanup = null, current = current.alternate, null != current && (current.refCleanup = null);
        }
        else if ("function" === typeof ref) try {
            ref(null);
        } catch (error$148) {
            $5c00e1cb1faeed50$var$captureCommitPhaseError(current, nearestMountedAncestor, error$148);
        }
        else ref.current = null;
    }
}
function $5c00e1cb1faeed50$var$commitNewChildToFragmentInstances(fiber, parentFragmentInstances) {
    if ((5 === fiber.tag || 27 === fiber.tag || 6 === fiber.tag) && null === fiber.alternate && null !== parentFragmentInstances) for(var i = 0; i < parentFragmentInstances.length; i++)$5c00e1cb1faeed50$var$commitNewChildToFragmentInstance(fiber.stateNode, parentFragmentInstances[i]);
}
function $5c00e1cb1faeed50$var$commitFragmentInstanceInsertionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $5c00e1cb1faeed50$var$isFragmentInstanceParent(parent) && $5c00e1cb1faeed50$var$commitNewChildToFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($5c00e1cb1faeed50$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $5c00e1cb1faeed50$var$commitFragmentInstanceDeletionEffects(fiber) {
    for(var parent = fiber.return; null !== parent;){
        $5c00e1cb1faeed50$var$isFragmentInstanceParent(parent) && $5c00e1cb1faeed50$var$deleteChildFromFragmentInstance(fiber.stateNode, parent.stateNode);
        if ($5c00e1cb1faeed50$var$isFragmentInstanceHostBoundary(parent)) break;
        parent = parent.return;
    }
}
function $5c00e1cb1faeed50$var$isFragmentInstanceHostBoundary(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 27 === fiber.tag;
}
function $5c00e1cb1faeed50$var$isFragmentInstanceParent(fiber) {
    return fiber && 7 === fiber.tag && null !== fiber.stateNode;
}
function $5c00e1cb1faeed50$var$commitHostMount(finishedWork) {
    var type = finishedWork.type, props = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
        a: switch(type){
            case "button":
            case "input":
            case "select":
            case "textarea":
                props.autoFocus && instance.focus();
                break a;
            case "img":
                props.src ? instance.src = props.src : props.srcSet && (instance.srcset = props.srcSet);
        }
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5c00e1cb1faeed50$var$commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
        var domElement = finishedWork.stateNode;
        $5c00e1cb1faeed50$var$updateProperties(domElement, finishedWork.type, oldProps, newProps);
        domElement[$5c00e1cb1faeed50$var$internalPropsKey] = newProps;
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5c00e1cb1faeed50$var$isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && $5c00e1cb1faeed50$var$isSingletonScope(fiber.type) || 4 === fiber.tag;
}
function $5c00e1cb1faeed50$var$getHostSibling(fiber) {
    a: for(;;){
        for(; null === fiber.sibling;){
            if (null === fiber.return || $5c00e1cb1faeed50$var$isHostParent(fiber.return)) return null;
            fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for(fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag;){
            if (27 === fiber.tag && $5c00e1cb1faeed50$var$isSingletonScope(fiber.type)) continue a;
            if (fiber.flags & 2) continue a;
            if (null === fiber.child || 4 === fiber.tag) continue a;
            else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
    }
}
function $5c00e1cb1faeed50$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(tag, before) : (before = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before.appendChild(tag), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before.onclick || (before.onclick = $5c00e1cb1faeed50$var$noop$1)), $5c00e1cb1faeed50$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($5c00e1cb1faeed50$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $5c00e1cb1faeed50$var$isSingletonScope(node.type) && (parent = node.stateNode, before = null)), node = node.child, null !== node)) for($5c00e1cb1faeed50$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$5c00e1cb1faeed50$var$insertOrAppendPlacementNodeIntoContainer(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $5c00e1cb1faeed50$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances) {
    var tag = node.tag;
    if (5 === tag || 6 === tag) tag = node.stateNode, before ? parent.insertBefore(tag, before) : parent.appendChild(tag), $5c00e1cb1faeed50$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
    else if (4 !== tag && (27 === tag && ($5c00e1cb1faeed50$var$commitNewChildToFragmentInstances(node, parentFragmentInstances), parentFragmentInstances = null, $5c00e1cb1faeed50$var$isSingletonScope(node.type) && (parent = node.stateNode)), node = node.child, null !== node)) for($5c00e1cb1faeed50$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling; null !== node;)$5c00e1cb1faeed50$var$insertOrAppendPlacementNode(node, before, parent, parentFragmentInstances), node = node.sibling;
}
function $5c00e1cb1faeed50$var$commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props = finishedWork.memoizedProps;
    try {
        for(var type = finishedWork.type, attributes = singleton.attributes; attributes.length;)singleton.removeAttributeNode(attributes[0]);
        $5c00e1cb1faeed50$var$setInitialProperties(singleton, type, props);
        singleton[$5c00e1cb1faeed50$var$internalInstanceKey] = finishedWork;
        singleton[$5c00e1cb1faeed50$var$internalPropsKey] = props;
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
var $5c00e1cb1faeed50$var$shouldStartViewTransition = !1, $5c00e1cb1faeed50$var$appearingViewTransitions = null;
function $5c00e1cb1faeed50$var$trackEnterViewTransitions(placement) {
    if (30 === placement.tag || 0 !== (placement.subtreeFlags & 33554432)) $5c00e1cb1faeed50$var$shouldStartViewTransition = !0;
}
var $5c00e1cb1faeed50$var$viewTransitionCancelableChildren = null;
function $5c00e1cb1faeed50$var$pushViewTransitionCancelableScope() {
    var prevChildren = $5c00e1cb1faeed50$var$viewTransitionCancelableChildren;
    $5c00e1cb1faeed50$var$viewTransitionCancelableChildren = null;
    return prevChildren;
}
var $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx = 0;
function $5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(fiber, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx = 0;
    return $5c00e1cb1faeed50$var$applyViewTransitionToHostInstancesRecursive(fiber.child, name, className, collectMeasurements, stopAtNestedViewTransitions);
}
function $5c00e1cb1faeed50$var$applyViewTransitionToHostInstancesRecursive(child, name, className, collectMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== collectMeasurements) {
                var measurement = $5c00e1cb1faeed50$var$measureInstance(instance);
                collectMeasurements.push(measurement);
                measurement.view && (inViewport = !0);
            } else inViewport || $5c00e1cb1faeed50$var$measureInstance(instance).view && (inViewport = !0);
            $5c00e1cb1faeed50$var$shouldStartViewTransition = !0;
            $5c00e1cb1faeed50$var$applyViewTransitionName(instance, 0 === $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx ? name : name + "_" + $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx, className);
            $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $5c00e1cb1faeed50$var$applyViewTransitionToHostInstancesRecursive(child.child, name, className, collectMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(child, stopAtNestedViewTransitions) {
    for(; null !== child;){
        if (5 === child.tag) $5c00e1cb1faeed50$var$restoreViewTransitionName(child.stateNode, child.memoizedProps);
        else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions || $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(child.child, stopAtNestedViewTransitions);
        child = child.sibling;
    }
}
function $5c00e1cb1faeed50$var$commitAppearingPairViewTransitions(placement) {
    if (0 !== (placement.subtreeFlags & 18874368)) for(placement = placement.child; null !== placement;){
        if (22 !== placement.tag || null === placement.memoizedState) {
            if ($5c00e1cb1faeed50$var$commitAppearingPairViewTransitions(placement), 30 === placement.tag && 0 !== (placement.flags & 18874368) && placement.stateNode.paired) {
                var props = placement.memoizedProps;
                if (null == props.name || "auto" === props.name) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(544));
                var name = props.name;
                props = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, props.share);
                "none" !== props && ($5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(placement, name, props, null, !1) || $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(placement.child, !1));
            }
        }
        placement = placement.sibling;
    }
}
function $5c00e1cb1faeed50$var$commitEnterViewTransitions(placement, gesture) {
    if (30 === placement.tag) {
        var state = placement.stateNode, props = placement.memoizedProps, name = $5c00e1cb1faeed50$var$getViewTransitionName(props, state), className = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, state.paired ? props.share : props.enter);
        "none" !== className ? $5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(placement, name, className, null, !1) ? ($5c00e1cb1faeed50$var$commitAppearingPairViewTransitions(placement), state.paired || gesture || $5c00e1cb1faeed50$var$scheduleViewTransitionEvent(placement, props.onEnter)) : $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(placement.child, !1) : $5c00e1cb1faeed50$var$commitAppearingPairViewTransitions(placement);
    } else if (0 !== (placement.subtreeFlags & 33554432)) for(placement = placement.child; null !== placement;)$5c00e1cb1faeed50$var$commitEnterViewTransitions(placement, gesture), placement = placement.sibling;
    else $5c00e1cb1faeed50$var$commitAppearingPairViewTransitions(placement);
}
function $5c00e1cb1faeed50$var$commitDeletedPairViewTransitions(deletion) {
    if (null !== $5c00e1cb1faeed50$var$appearingViewTransitions && 0 !== $5c00e1cb1faeed50$var$appearingViewTransitions.size) {
        var pairs = $5c00e1cb1faeed50$var$appearingViewTransitions;
        if (0 !== (deletion.subtreeFlags & 18874368)) for(deletion = deletion.child; null !== deletion;){
            if (22 !== deletion.tag || null === deletion.memoizedState) {
                if (30 === deletion.tag && 0 !== (deletion.flags & 18874368)) {
                    var props = deletion.memoizedProps, name = props.name;
                    if (null != name && "auto" !== name) {
                        var pair = pairs.get(name);
                        if (void 0 !== pair) {
                            var className = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, props.share);
                            "none" !== className && ($5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $5c00e1cb1faeed50$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
                            pairs.delete(name);
                            if (0 === pairs.size) break;
                        }
                    }
                }
                $5c00e1cb1faeed50$var$commitDeletedPairViewTransitions(deletion);
            }
            deletion = deletion.sibling;
        }
    }
}
function $5c00e1cb1faeed50$var$commitExitViewTransitions(deletion) {
    if (30 === deletion.tag) {
        var props = deletion.memoizedProps, name = $5c00e1cb1faeed50$var$getViewTransitionName(props, deletion.stateNode), pair = null !== $5c00e1cb1faeed50$var$appearingViewTransitions ? $5c00e1cb1faeed50$var$appearingViewTransitions.get(name) : void 0, className = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, void 0 !== pair ? props.share : props.exit);
        "none" !== className && ($5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(deletion, name, className, null, !1) ? void 0 !== pair ? (className = deletion.stateNode, pair.paired = className, className.paired = pair, $5c00e1cb1faeed50$var$appearingViewTransitions.delete(name), $5c00e1cb1faeed50$var$scheduleViewTransitionEvent(deletion, props.onShare)) : $5c00e1cb1faeed50$var$scheduleViewTransitionEvent(deletion, props.onExit) : $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(deletion.child, !1));
        null !== $5c00e1cb1faeed50$var$appearingViewTransitions && $5c00e1cb1faeed50$var$commitDeletedPairViewTransitions(deletion);
    } else if (0 !== (deletion.subtreeFlags & 33554432)) for(deletion = deletion.child; null !== deletion;)$5c00e1cb1faeed50$var$commitExitViewTransitions(deletion), deletion = deletion.sibling;
    else null !== $5c00e1cb1faeed50$var$appearingViewTransitions && $5c00e1cb1faeed50$var$commitDeletedPairViewTransitions(deletion);
}
function $5c00e1cb1faeed50$var$commitNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, name = $5c00e1cb1faeed50$var$getViewTransitionName(props, changedParent.stateNode);
            props = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, props.update);
            changedParent.flags &= -5;
            "none" !== props && $5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(changedParent, name, props, changedParent.memoizedState = [], !1);
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $5c00e1cb1faeed50$var$commitNestedViewTransitions(changedParent);
        changedParent = changedParent.sibling;
    }
}
function $5c00e1cb1faeed50$var$restorePairedViewTransitions(parent) {
    if (0 !== (parent.subtreeFlags & 18874368)) for(parent = parent.child; null !== parent;){
        if (22 !== parent.tag || null === parent.memoizedState) {
            if (30 === parent.tag && 0 !== (parent.flags & 18874368)) {
                var instance = parent.stateNode;
                null !== instance.paired && (instance.paired = null, $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(parent.child, !1));
            }
            $5c00e1cb1faeed50$var$restorePairedViewTransitions(parent);
        }
        parent = parent.sibling;
    }
}
function $5c00e1cb1faeed50$var$restoreEnterOrExitViewTransitions(fiber) {
    if (30 === fiber.tag) fiber.stateNode.paired = null, $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(fiber.child, !1), $5c00e1cb1faeed50$var$restorePairedViewTransitions(fiber);
    else if (0 !== (fiber.subtreeFlags & 33554432)) for(fiber = fiber.child; null !== fiber;)$5c00e1cb1faeed50$var$restoreEnterOrExitViewTransitions(fiber), fiber = fiber.sibling;
    else $5c00e1cb1faeed50$var$restorePairedViewTransitions(fiber);
}
function $5c00e1cb1faeed50$var$restoreNestedViewTransitions(changedParent) {
    for(changedParent = changedParent.child; null !== changedParent;)30 === changedParent.tag ? $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(changedParent.child, !1) : 0 !== (changedParent.subtreeFlags & 33554432) && $5c00e1cb1faeed50$var$restoreNestedViewTransitions(changedParent), changedParent = changedParent.sibling;
}
function $5c00e1cb1faeed50$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) {
    for(var inViewport = !1; null !== child;){
        if (5 === child.tag) {
            var instance = child.stateNode;
            if (null !== previousMeasurements && $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx < previousMeasurements.length) {
                var previousMeasurement = previousMeasurements[$5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx], nextMeasurement = $5c00e1cb1faeed50$var$measureInstance(instance);
                if (previousMeasurement.view || nextMeasurement.view) inViewport = !0;
                var JSCompiler_temp;
                if (JSCompiler_temp = 0 === (parentViewTransition.flags & 4)) {
                    if (nextMeasurement.clip) JSCompiler_temp = !0;
                    else {
                        JSCompiler_temp = previousMeasurement.rect;
                        var newRect = nextMeasurement.rect;
                        JSCompiler_temp = JSCompiler_temp.y !== newRect.y || JSCompiler_temp.x !== newRect.x || JSCompiler_temp.height !== newRect.height || JSCompiler_temp.width !== newRect.width;
                    }
                }
                JSCompiler_temp && (parentViewTransition.flags |= 4);
                nextMeasurement.abs ? nextMeasurement = !previousMeasurement.abs : (previousMeasurement = previousMeasurement.rect, nextMeasurement = nextMeasurement.rect, nextMeasurement = previousMeasurement.height !== nextMeasurement.height || previousMeasurement.width !== nextMeasurement.width);
                nextMeasurement && (parentViewTransition.flags |= 32);
            } else parentViewTransition.flags |= 32;
            0 !== (parentViewTransition.flags & 4) && $5c00e1cb1faeed50$var$applyViewTransitionName(instance, 0 === $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx ? newName : newName + "_" + $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx, className);
            inViewport && 0 !== (parentViewTransition.flags & 4) || (null === $5c00e1cb1faeed50$var$viewTransitionCancelableChildren && ($5c00e1cb1faeed50$var$viewTransitionCancelableChildren = []), $5c00e1cb1faeed50$var$viewTransitionCancelableChildren.push(instance, 0 === $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx ? oldName : oldName + "_" + $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx, child.memoizedProps));
            $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx++;
        } else if (22 !== child.tag || null === child.memoizedState) 30 === child.tag && stopAtNestedViewTransitions ? parentViewTransition.flags |= child.flags & 32 : $5c00e1cb1faeed50$var$measureViewTransitionHostInstancesRecursive(parentViewTransition, child.child, newName, oldName, className, previousMeasurements, stopAtNestedViewTransitions) && (inViewport = !0);
        child = child.sibling;
    }
    return inViewport;
}
function $5c00e1cb1faeed50$var$measureNestedViewTransitions(changedParent, gesture) {
    for(changedParent = changedParent.child; null !== changedParent;){
        if (30 === changedParent.tag) {
            var props = changedParent.memoizedProps, state = changedParent.stateNode, name = $5c00e1cb1faeed50$var$getViewTransitionName(props, state), className = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, props.update);
            if (gesture) {
                state = state.clones;
                var previousMeasurements = null === state ? null : state.map($5c00e1cb1faeed50$var$measureClonedInstance);
            } else previousMeasurements = changedParent.memoizedState, changedParent.memoizedState = null;
            state = changedParent;
            var child = changedParent.child;
            $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx = 0;
            name = $5c00e1cb1faeed50$var$measureViewTransitionHostInstancesRecursive(state, child, name, name, className, previousMeasurements, !1);
            0 !== (changedParent.flags & 4) && name && (gesture || $5c00e1cb1faeed50$var$scheduleViewTransitionEvent(changedParent, props.onUpdate));
        } else 0 !== (changedParent.subtreeFlags & 33554432) && $5c00e1cb1faeed50$var$measureNestedViewTransitions(changedParent, gesture);
        changedParent = changedParent.sibling;
    }
}
var $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = !1, $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = !1, $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = !1, $5c00e1cb1faeed50$var$needsFormReset = !1, $5c00e1cb1faeed50$var$PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, $5c00e1cb1faeed50$var$nextEffect = null, $5c00e1cb1faeed50$var$viewTransitionContextChanged = !1, $5c00e1cb1faeed50$var$inUpdateViewTransition = !1, $5c00e1cb1faeed50$var$rootViewTransitionAffected = !1, $5c00e1cb1faeed50$var$rootViewTransitionNameCanceled = !1;
function $5c00e1cb1faeed50$var$commitBeforeMutationEffects(root, firstChild, committedLanes) {
    root = root.containerInfo;
    $5c00e1cb1faeed50$var$eventsEnabled = $5c00e1cb1faeed50$var$_enabled;
    root = $5c00e1cb1faeed50$var$getActiveElementDeep(root);
    if ($5c00e1cb1faeed50$var$hasSelectionCapabilities(root)) {
        if ("selectionStart" in root) var JSCompiler_temp = {
            start: root.selectionStart,
            end: root.selectionEnd
        };
        else a: {
            JSCompiler_temp = (JSCompiler_temp = root.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection && 0 !== selection.rangeCount) {
                JSCompiler_temp = selection.anchorNode;
                var anchorOffset = selection.anchorOffset, focusNode = selection.focusNode;
                selection = selection.focusOffset;
                try {
                    JSCompiler_temp.nodeType, focusNode.nodeType;
                } catch (e$21) {
                    JSCompiler_temp = null;
                    break a;
                }
                var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root, parentNode = null;
                b: for(;;){
                    for(var next;;){
                        node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                        node !== focusNode || 0 !== selection && 3 !== node.nodeType || (end = length + selection);
                        3 === node.nodeType && (length += node.nodeValue.length);
                        if (null === (next = node.firstChild)) break;
                        parentNode = node;
                        node = next;
                    }
                    for(;;){
                        if (node === root) break b;
                        parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                        parentNode === focusNode && ++indexWithinFocus === selection && (end = length);
                        if (null !== (next = node.nextSibling)) break;
                        node = parentNode;
                        parentNode = node.parentNode;
                    }
                    node = next;
                }
                JSCompiler_temp = -1 === start || -1 === end ? null : {
                    start: start,
                    end: end
                };
            } else JSCompiler_temp = null;
        }
        JSCompiler_temp = JSCompiler_temp || {
            start: 0,
            end: 0
        };
    } else JSCompiler_temp = null;
    $5c00e1cb1faeed50$var$selectionInformation = {
        focusedElem: root,
        selectionRange: JSCompiler_temp
    };
    $5c00e1cb1faeed50$var$_enabled = !1;
    committedLanes = (committedLanes & 335544064) === committedLanes;
    $5c00e1cb1faeed50$var$nextEffect = firstChild;
    for(firstChild = committedLanes ? 9270 : 1024; null !== $5c00e1cb1faeed50$var$nextEffect;){
        root = $5c00e1cb1faeed50$var$nextEffect;
        if (committedLanes && (JSCompiler_temp = root.deletions, null !== JSCompiler_temp)) for(anchorOffset = 0; anchorOffset < JSCompiler_temp.length; anchorOffset++)committedLanes && $5c00e1cb1faeed50$var$commitExitViewTransitions(JSCompiler_temp[anchorOffset]);
        if (null === root.alternate && 0 !== (root.flags & 2)) committedLanes && $5c00e1cb1faeed50$var$trackEnterViewTransitions(root), $5c00e1cb1faeed50$var$commitBeforeMutationEffects_complete(committedLanes);
        else {
            if (22 === root.tag) {
                if (JSCompiler_temp = root.alternate, null !== root.memoizedState) {
                    null !== JSCompiler_temp && null === JSCompiler_temp.memoizedState && committedLanes && $5c00e1cb1faeed50$var$commitExitViewTransitions(JSCompiler_temp);
                    $5c00e1cb1faeed50$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                } else if (null !== JSCompiler_temp && null !== JSCompiler_temp.memoizedState) {
                    committedLanes && $5c00e1cb1faeed50$var$trackEnterViewTransitions(root);
                    $5c00e1cb1faeed50$var$commitBeforeMutationEffects_complete(committedLanes);
                    continue;
                }
            }
            JSCompiler_temp = root.child;
            0 !== (root.subtreeFlags & firstChild) && null !== JSCompiler_temp ? (JSCompiler_temp.return = root, $5c00e1cb1faeed50$var$nextEffect = JSCompiler_temp) : (committedLanes && $5c00e1cb1faeed50$var$commitNestedViewTransitions(root), $5c00e1cb1faeed50$var$commitBeforeMutationEffects_complete(committedLanes));
        }
    }
    $5c00e1cb1faeed50$var$appearingViewTransitions = null;
}
function $5c00e1cb1faeed50$var$commitBeforeMutationEffects_complete(isViewTransitionEligible$jscomp$0) {
    for(; null !== $5c00e1cb1faeed50$var$nextEffect;){
        var fiber = $5c00e1cb1faeed50$var$nextEffect, isViewTransitionEligible = isViewTransitionEligible$jscomp$0, current = fiber.alternate, flags = fiber.flags;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                break;
            case 1:
                if (0 !== (flags & 1024) && null !== current) {
                    isViewTransitionEligible = void 0;
                    flags = current.memoizedProps;
                    current = current.memoizedState;
                    var instance = fiber.stateNode;
                    try {
                        var resolvedPrevProps = $5c00e1cb1faeed50$var$resolveClassComponentProps(fiber.type, flags);
                        isViewTransitionEligible = instance.getSnapshotBeforeUpdate(resolvedPrevProps, current);
                        instance.__reactInternalSnapshotBeforeUpdate = isViewTransitionEligible;
                    } catch (error) {
                        $5c00e1cb1faeed50$var$captureCommitPhaseError(fiber, fiber.return, error);
                    }
                }
                break;
            case 3:
                if (0 !== (flags & 1024)) {
                    if (current = fiber.stateNode.containerInfo, isViewTransitionEligible = current.nodeType, 9 === isViewTransitionEligible) $5c00e1cb1faeed50$var$clearContainerSparingly(current);
                    else if (1 === isViewTransitionEligible) switch(current.nodeName){
                        case "HEAD":
                        case "HTML":
                        case "BODY":
                            $5c00e1cb1faeed50$var$clearContainerSparingly(current);
                            break;
                        default:
                            current.textContent = "";
                    }
                }
                break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
                break;
            case 30:
                isViewTransitionEligible && null !== current && (isViewTransitionEligible = $5c00e1cb1faeed50$var$getViewTransitionName(current.memoizedProps, current.stateNode), flags = fiber.memoizedProps, flags = $5c00e1cb1faeed50$var$getViewTransitionClassName(flags.default, flags.update), "none" !== flags && $5c00e1cb1faeed50$var$applyViewTransitionToHostInstances(current, isViewTransitionEligible, flags, current.memoizedState = [], !0));
                break;
            default:
                if (0 !== (flags & 1024)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(163));
        }
        current = fiber.sibling;
        if (null !== current) {
            current.return = fiber.return;
            $5c00e1cb1faeed50$var$nextEffect = current;
            break;
        }
        $5c00e1cb1faeed50$var$nextEffect = fiber.return;
    }
}
function $5c00e1cb1faeed50$var$commitLayoutEffectOnFiber(finishedRoot, current, finishedWork) {
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $5c00e1cb1faeed50$var$commitHookEffectListMount(5, finishedWork);
            break;
        case 1:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 4) {
                if (finishedRoot = finishedWork.stateNode, null === current) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
                else {
                    var prevProps = $5c00e1cb1faeed50$var$resolveClassComponentProps(finishedWork.type, current.memoizedProps);
                    current = current.memoizedState;
                    try {
                        finishedRoot.componentDidUpdate(prevProps, current, finishedRoot.__reactInternalSnapshotBeforeUpdate);
                    } catch (error$146) {
                        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error$146);
                    }
                }
            }
            flags & 64 && $5c00e1cb1faeed50$var$commitClassCallbacks(finishedWork);
            flags & 512 && $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 3:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
                current = null;
                if (null !== finishedWork.child) switch(finishedWork.child.tag){
                    case 27:
                    case 5:
                        current = finishedWork.child.stateNode;
                        break;
                    case 1:
                        current = finishedWork.child.stateNode;
                }
                try {
                    $5c00e1cb1faeed50$var$commitCallbacks(finishedRoot, current);
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 27:
            null === current && flags & 4 && $5c00e1cb1faeed50$var$commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            null === current && flags & 4 && $5c00e1cb1faeed50$var$commitHostMount(finishedWork);
            flags & 512 && $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 12:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            break;
        case 31:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $5c00e1cb1faeed50$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
            break;
        case 13:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 4 && $5c00e1cb1faeed50$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
            flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = $5c00e1cb1faeed50$var$retryDehydratedSuspenseBoundary.bind(null, finishedWork), $5c00e1cb1faeed50$var$registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
            break;
        case 22:
            flags = null !== finishedWork.memoizedState || $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden;
            if (!flags) {
                var newOffscreenSubtreeWasHidden = null !== current && null !== current.memoizedState || $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden;
                current = $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden;
                prevProps = $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden;
                $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = flags;
                ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = newOffscreenSubtreeWasHidden) && !prevProps ? (flags = 2, 0 !== (finishedWork.subtreeFlags & 8772) && (flags |= 1), $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, flags)) : $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
                $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = current;
                $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = prevProps;
            }
            break;
        case 30:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            flags & 512 && $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
            break;
        case 7:
            flags & 512 && $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
        default:
            $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
}
function $5c00e1cb1faeed50$var$hideOrUnhideAllChildren(parentFiber, isHidden) {
    for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$hideOrUnhideAllChildrenOnFiber(parentFiber, isHidden), parentFiber = parentFiber.sibling;
}
function $5c00e1cb1faeed50$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden) {
    switch(fiber.tag){
        case 5:
        case 26:
            try {
                var instance = fiber.stateNode;
                if (isHidden) {
                    var style = instance.style;
                    "function" === typeof style.setProperty ? style.setProperty("display", "none", "important") : style.display = "none";
                } else {
                    var instance$jscomp$0 = fiber.stateNode, styleProp = fiber.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    instance$jscomp$0.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                }
            } catch (error) {
                $5c00e1cb1faeed50$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            $5c00e1cb1faeed50$var$hideOrUnhideNearestPortals(fiber, isHidden);
            break;
        case 6:
            try {
                fiber.stateNode.nodeValue = isHidden ? "" : fiber.memoizedProps, $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
            } catch (error) {
                $5c00e1cb1faeed50$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 18:
            try {
                var instance$jscomp$1 = fiber.stateNode;
                isHidden ? $5c00e1cb1faeed50$var$hideOrUnhideDehydratedBoundary(instance$jscomp$1, !0) : $5c00e1cb1faeed50$var$hideOrUnhideDehydratedBoundary(fiber.stateNode, !1);
            } catch (error) {
                $5c00e1cb1faeed50$var$captureCommitPhaseError(fiber, fiber.return, error);
            }
            break;
        case 22:
        case 23:
            null === fiber.memoizedState && $5c00e1cb1faeed50$var$hideOrUnhideAllChildren(fiber, isHidden);
            break;
        default:
            $5c00e1cb1faeed50$var$hideOrUnhideAllChildren(fiber, isHidden);
    }
}
function $5c00e1cb1faeed50$var$hideOrUnhideNearestPortals(parentFiber, isHidden$jscomp$0) {
    if (parentFiber.subtreeFlags & 67108864) for(parentFiber = parentFiber.child; null !== parentFiber;){
        a: {
            var fiber = parentFiber, isHidden = isHidden$jscomp$0;
            switch(fiber.tag){
                case 4:
                    $5c00e1cb1faeed50$var$hideOrUnhideAllChildrenOnFiber(fiber, isHidden);
                    break a;
                case 22:
                    null === fiber.memoizedState && $5c00e1cb1faeed50$var$hideOrUnhideNearestPortals(fiber, isHidden);
                    break a;
                default:
                    $5c00e1cb1faeed50$var$hideOrUnhideNearestPortals(fiber, isHidden);
            }
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5c00e1cb1faeed50$var$detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, $5c00e1cb1faeed50$var$detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && $5c00e1cb1faeed50$var$detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
}
var $5c00e1cb1faeed50$var$hostParent = null, $5c00e1cb1faeed50$var$hostParentIsContainer = !1;
function $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for(parent = parent.child; null !== parent;)$5c00e1cb1faeed50$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
}
function $5c00e1cb1faeed50$var$commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if ($5c00e1cb1faeed50$var$injectedHook && "function" === typeof $5c00e1cb1faeed50$var$injectedHook.onCommitFiberUnmount) try {
        $5c00e1cb1faeed50$var$injectedHook.onCommitFiberUnmount($5c00e1cb1faeed50$var$rendererID, deletedFiber);
    } catch (err) {}
    switch(deletedFiber.tag){
        case 26:
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || $5c00e1cb1faeed50$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && !$5c00e1cb1faeed50$var$offscreenSubtreeWasHidden && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
            break;
        case 27:
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || $5c00e1cb1faeed50$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $5c00e1cb1faeed50$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            var prevHostParent = $5c00e1cb1faeed50$var$hostParent, prevHostParentIsContainer = $5c00e1cb1faeed50$var$hostParentIsContainer;
            $5c00e1cb1faeed50$var$isSingletonScope(deletedFiber.type) && ($5c00e1cb1faeed50$var$hostParent = deletedFiber.stateNode, $5c00e1cb1faeed50$var$hostParentIsContainer = !1);
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5c00e1cb1faeed50$var$releaseSingletonInstance(deletedFiber.stateNode, deletedFiber.type, deletedFiber.memoizedProps);
            $5c00e1cb1faeed50$var$hostParent = prevHostParent;
            $5c00e1cb1faeed50$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 5:
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || $5c00e1cb1faeed50$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), $5c00e1cb1faeed50$var$commitFragmentInstanceDeletionEffects(deletedFiber);
        case 6:
            6 === deletedFiber.tag && $5c00e1cb1faeed50$var$commitFragmentInstanceDeletionEffects(deletedFiber);
            prevHostParent = $5c00e1cb1faeed50$var$hostParent;
            prevHostParentIsContainer = $5c00e1cb1faeed50$var$hostParentIsContainer;
            $5c00e1cb1faeed50$var$hostParent = null;
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5c00e1cb1faeed50$var$hostParent = prevHostParent;
            $5c00e1cb1faeed50$var$hostParentIsContainer = prevHostParentIsContainer;
            if (null !== $5c00e1cb1faeed50$var$hostParent) {
                if ($5c00e1cb1faeed50$var$hostParentIsContainer) try {
                    (9 === $5c00e1cb1faeed50$var$hostParent.nodeType ? $5c00e1cb1faeed50$var$hostParent.body : "HTML" === $5c00e1cb1faeed50$var$hostParent.nodeName ? $5c00e1cb1faeed50$var$hostParent.ownerDocument.body : $5c00e1cb1faeed50$var$hostParent).removeChild(deletedFiber.stateNode), $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
                else try {
                    $5c00e1cb1faeed50$var$hostParent.removeChild(deletedFiber.stateNode), $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(deletedFiber, nearestMountedAncestor, error);
                }
            }
            break;
        case 18:
            null !== $5c00e1cb1faeed50$var$hostParent && ($5c00e1cb1faeed50$var$hostParentIsContainer ? (finishedRoot = $5c00e1cb1faeed50$var$hostParent, $5c00e1cb1faeed50$var$clearHydrationBoundary(9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, deletedFiber.stateNode), $5c00e1cb1faeed50$var$retryIfBlockedOn(finishedRoot)) : $5c00e1cb1faeed50$var$clearHydrationBoundary($5c00e1cb1faeed50$var$hostParent, deletedFiber.stateNode));
            break;
        case 4:
            prevHostParent = $5c00e1cb1faeed50$var$hostParent;
            prevHostParentIsContainer = $5c00e1cb1faeed50$var$hostParentIsContainer;
            $5c00e1cb1faeed50$var$hostParent = deletedFiber.stateNode.containerInfo;
            $5c00e1cb1faeed50$var$hostParentIsContainer = !0;
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5c00e1cb1faeed50$var$hostParent = prevHostParent;
            $5c00e1cb1faeed50$var$hostParentIsContainer = prevHostParentIsContainer;
            break;
        case 0:
        case 11:
        case 14:
        case 15:
            $5c00e1cb1faeed50$var$commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || $5c00e1cb1faeed50$var$commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 1:
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || ($5c00e1cb1faeed50$var$safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && $5c00e1cb1faeed50$var$safelyCallComponentWillUnmount(deletedFiber, nearestMountedAncestor, prevHostParent));
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 21:
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 22:
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = (prevHostParent = $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = prevHostParent;
            break;
        case 30:
            $5c00e1cb1faeed50$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        case 7:
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || $5c00e1cb1faeed50$var$safelyDetachRef(deletedFiber, nearestMountedAncestor);
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
            break;
        default:
            $5c00e1cb1faeed50$var$recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, deletedFiber);
    }
}
function $5c00e1cb1faeed50$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
            $5c00e1cb1faeed50$var$retryIfBlockedOn(finishedRoot);
        } catch (error) {
            $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
}
function $5c00e1cb1faeed50$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot)))) try {
        $5c00e1cb1faeed50$var$retryIfBlockedOn(finishedRoot);
    } catch (error) {
        $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
}
function $5c00e1cb1faeed50$var$getRetryCache(finishedWork) {
    switch(finishedWork.tag){
        case 31:
        case 13:
        case 19:
            var retryCache = finishedWork.stateNode;
            null === retryCache && (retryCache = finishedWork.stateNode = new $5c00e1cb1faeed50$var$PossiblyWeakSet());
            return retryCache;
        case 22:
            return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new $5c00e1cb1faeed50$var$PossiblyWeakSet()), retryCache;
        default:
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(435, finishedWork.tag));
    }
}
function $5c00e1cb1faeed50$var$attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = $5c00e1cb1faeed50$var$getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
            retryCache.add(wakeable);
            var retry = $5c00e1cb1faeed50$var$resolveRetryWakeable.bind(null, finishedWork, wakeable);
            wakeable.then(retry, retry);
        }
    });
}
function $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber, lanes) {
    var deletions = parentFiber.deletions;
    if (null !== deletions) for(var i = 0; i < deletions.length; i++){
        var childToDelete = deletions[i], root = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for(; null !== parent;){
            switch(parent.tag){
                case 27:
                    if ($5c00e1cb1faeed50$var$isSingletonScope(parent.type)) {
                        $5c00e1cb1faeed50$var$hostParent = parent.stateNode;
                        $5c00e1cb1faeed50$var$hostParentIsContainer = !1;
                        break a;
                    }
                    break;
                case 5:
                    $5c00e1cb1faeed50$var$hostParent = parent.stateNode;
                    $5c00e1cb1faeed50$var$hostParentIsContainer = !1;
                    break a;
                case 3:
                case 4:
                    $5c00e1cb1faeed50$var$hostParent = parent.stateNode.containerInfo;
                    $5c00e1cb1faeed50$var$hostParentIsContainer = !0;
                    break a;
            }
            parent = parent.return;
        }
        if (null === $5c00e1cb1faeed50$var$hostParent) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(160));
        $5c00e1cb1faeed50$var$commitDeletionEffectsOnFiber(root, returnFiber, childToDelete);
        $5c00e1cb1faeed50$var$hostParent = null;
        $5c00e1cb1faeed50$var$hostParentIsContainer = !1;
        root = childToDelete.alternate;
        null !== root && (root.return = null);
        childToDelete.return = null;
    }
    if (parentFiber.subtreeFlags & 13886) for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$commitMutationEffectsOnFiber(parentFiber, root$jscomp$0, lanes), parentFiber = parentFiber.sibling;
}
var $5c00e1cb1faeed50$var$currentHoistableRoot = null;
function $5c00e1cb1faeed50$var$commitMutationEffectsOnFiber(finishedWork, root, lanes) {
    var current = finishedWork.alternate, flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 14:
        case 15:
            if (flags & 4 && (current = finishedWork.updateQueue, current = null !== current ? current.events : null, null !== current)) for(var ii = 0; ii < current.length; ii++){
                var _eventPayloads$ii2 = current[ii];
                _eventPayloads$ii2.ref.impl = _eventPayloads$ii2.nextImpl;
            }
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 4 && ($5c00e1cb1faeed50$var$commitHookEffectListUnmount(3, finishedWork, finishedWork.return), $5c00e1cb1faeed50$var$commitHookEffectListMount(3, finishedWork), $5c00e1cb1faeed50$var$commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
            break;
        case 1:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || null === current || $5c00e1cb1faeed50$var$safelyDetachRef(current, current.return));
            flags & 64 && $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (root = finishedWork.callbacks, null !== root && (lanes = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === lanes ? root : lanes.concat(root))));
            break;
        case 26:
            ii = $5c00e1cb1faeed50$var$currentHoistableRoot;
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || null === current || $5c00e1cb1faeed50$var$safelyDetachRef(current, current.return));
            if (flags & 4) {
                if (flags = null !== current ? current.memoizedState : null, lanes = finishedWork.memoizedState, null === current) {
                    if (null === lanes) {
                        if (null === finishedWork.stateNode) {
                            if ($5c00e1cb1faeed50$var$offscreenSubtreeIsHidden) finishedWork.stateNode = $5c00e1cb1faeed50$var$createHoistableInstance(finishedWork.type, finishedWork.memoizedProps, root.containerInfo, finishedWork);
                            else {
                                a: {
                                    root = finishedWork.type;
                                    lanes = finishedWork.memoizedProps;
                                    flags = ii.ownerDocument || ii;
                                    b: switch(root){
                                        case "title":
                                            current = flags.getElementsByTagName("title")[0];
                                            if (!current || current[$5c00e1cb1faeed50$var$internalHoistableMarker] || current[$5c00e1cb1faeed50$var$internalInstanceKey] || "http://www.w3.org/2000/svg" === current.namespaceURI || current.hasAttribute("itemprop")) current = flags.createElement(root), flags.head.insertBefore(current, flags.querySelector("head > title"));
                                            $5c00e1cb1faeed50$var$setInitialProperties(current, root, lanes);
                                            current[$5c00e1cb1faeed50$var$internalInstanceKey] = finishedWork;
                                            $5c00e1cb1faeed50$var$markNodeAsHoistable(current);
                                            root = current;
                                            break a;
                                        case "link":
                                            if (ii = $5c00e1cb1faeed50$var$getHydratableHoistableCache("link", "href", flags).get(root + (lanes.href || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("href") === (null == lanes.href || "" === lanes.href ? null : lanes.href) && current.getAttribute("rel") === (null == lanes.rel ? null : lanes.rel) && current.getAttribute("title") === (null == lanes.title ? null : lanes.title) && current.getAttribute("crossorigin") === (null == lanes.crossOrigin ? null : lanes.crossOrigin)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $5c00e1cb1faeed50$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        case "meta":
                                            if (ii = $5c00e1cb1faeed50$var$getHydratableHoistableCache("meta", "content", flags).get(root + (lanes.content || ""))) {
                                                for(_eventPayloads$ii2 = 0; _eventPayloads$ii2 < ii.length; _eventPayloads$ii2++)if (current = ii[_eventPayloads$ii2], current.getAttribute("content") === (null == lanes.content ? null : "" + lanes.content) && current.getAttribute("name") === (null == lanes.name ? null : lanes.name) && current.getAttribute("property") === (null == lanes.property ? null : lanes.property) && current.getAttribute("http-equiv") === (null == lanes.httpEquiv ? null : lanes.httpEquiv) && current.getAttribute("charset") === (null == lanes.charSet ? null : lanes.charSet)) {
                                                    ii.splice(_eventPayloads$ii2, 1);
                                                    break b;
                                                }
                                            }
                                            current = flags.createElement(root);
                                            $5c00e1cb1faeed50$var$setInitialProperties(current, root, lanes);
                                            flags.head.appendChild(current);
                                            break;
                                        default:
                                            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(468, root));
                                    }
                                    current[$5c00e1cb1faeed50$var$internalInstanceKey] = finishedWork;
                                    $5c00e1cb1faeed50$var$markNodeAsHoistable(current);
                                    root = current;
                                }
                                finishedWork.stateNode = root;
                            }
                        } else $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden || $5c00e1cb1faeed50$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode);
                    } else finishedWork.stateNode = $5c00e1cb1faeed50$var$acquireResource(ii, lanes, finishedWork.memoizedProps);
                } else flags !== lanes ? (null === flags ? (root = current.stateNode, null === root || $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || root.parentNode.removeChild(root)) : flags.count--, null === lanes ? $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden || $5c00e1cb1faeed50$var$mountHoistable(ii, finishedWork.type, finishedWork.stateNode) : $5c00e1cb1faeed50$var$acquireResource(ii, lanes, finishedWork.memoizedProps)) : null === lanes && null !== finishedWork.stateNode && $5c00e1cb1faeed50$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            }
            break;
        case 27:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || null === current || $5c00e1cb1faeed50$var$safelyDetachRef(current, current.return));
            null !== current && flags & 4 && $5c00e1cb1faeed50$var$commitHostUpdate(finishedWork, finishedWork.memoizedProps, current.memoizedProps);
            break;
        case 5:
            ii = $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden;
            $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = !1;
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = ii;
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 512 && ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || null === current || $5c00e1cb1faeed50$var$safelyDetachRef(current, current.return));
            if (finishedWork.flags & 32) {
                root = finishedWork.stateNode;
                try {
                    $5c00e1cb1faeed50$var$setTextContent(root, ""), $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            flags & 4 && null != finishedWork.stateNode && (root = finishedWork.memoizedProps, $5c00e1cb1faeed50$var$commitHostUpdate(finishedWork, root, null !== current ? current.memoizedProps : root));
            flags & 1024 && ($5c00e1cb1faeed50$var$needsFormReset = !0);
            break;
        case 6:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            if (flags & 4) {
                if (null === finishedWork.stateNode) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(162));
                root = finishedWork.memoizedProps;
                lanes = finishedWork.stateNode;
                try {
                    lanes.nodeValue = root, $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            }
            break;
        case 3:
            $5c00e1cb1faeed50$var$viewTransitionMutationContext = !1;
            $5c00e1cb1faeed50$var$tagCaches = null;
            ii = $5c00e1cb1faeed50$var$currentHoistableRoot;
            $5c00e1cb1faeed50$var$currentHoistableRoot = $5c00e1cb1faeed50$var$getHoistableRoot(root.containerInfo);
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$currentHoistableRoot = ii;
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            if (flags & 4 && null !== current && current.memoizedState.isDehydrated) try {
                $5c00e1cb1faeed50$var$retryIfBlockedOn(root.containerInfo);
            } catch (error) {
                $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
            $5c00e1cb1faeed50$var$needsFormReset && ($5c00e1cb1faeed50$var$needsFormReset = !1, $5c00e1cb1faeed50$var$recursivelyResetForms(finishedWork));
            $5c00e1cb1faeed50$var$viewTransitionMutationContext = !1;
            break;
        case 4:
            flags = $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden;
            $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden;
            current = $5c00e1cb1faeed50$var$pushMutationContext();
            ii = $5c00e1cb1faeed50$var$currentHoistableRoot;
            $5c00e1cb1faeed50$var$currentHoistableRoot = $5c00e1cb1faeed50$var$getHoistableRoot(finishedWork.stateNode.containerInfo);
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            $5c00e1cb1faeed50$var$currentHoistableRoot = ii;
            $5c00e1cb1faeed50$var$viewTransitionMutationContext && $5c00e1cb1faeed50$var$inUpdateViewTransition && ($5c00e1cb1faeed50$var$rootViewTransitionAffected = !0);
            $5c00e1cb1faeed50$var$viewTransitionMutationContext = current;
            $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = flags;
            break;
        case 12:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            break;
        case 31:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $5c00e1cb1faeed50$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 13:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current && null !== current.memoizedState) && ($5c00e1cb1faeed50$var$globalMostRecentFallbackTime = $5c00e1cb1faeed50$var$now());
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $5c00e1cb1faeed50$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 22:
            ii = null !== finishedWork.memoizedState;
            _eventPayloads$ii2 = null !== current && null !== current.memoizedState;
            var prevOffscreenSubtreeIsHidden = $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden, prevOffscreenDirectParentIsHidden$166 = $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden;
            $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || ii;
            $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166 || ii;
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || _eventPayloads$ii2;
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
            $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden = prevOffscreenDirectParentIsHidden$166;
            $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 8192 && (root = finishedWork.stateNode, root._visibility = ii ? root._visibility & -2 : root._visibility | 1, !ii || null === current || _eventPayloads$ii2 || $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden || $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || (root = _eventPayloads$ii2 || $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden, lanes = $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden, current = $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden, $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = ii || $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden, $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = root, $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, 2), $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden = lanes, $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden = current), !ii && $5c00e1cb1faeed50$var$offscreenDirectParentIsHidden || $5c00e1cb1faeed50$var$hideOrUnhideAllChildren(finishedWork, ii));
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (lanes = root.retryQueue, null !== lanes && (root.retryQueue = null, $5c00e1cb1faeed50$var$attachSuspenseRetryListeners(finishedWork, lanes))));
            break;
        case 19:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            flags & 4 && (root = finishedWork.updateQueue, null !== root && (finishedWork.updateQueue = null, $5c00e1cb1faeed50$var$attachSuspenseRetryListeners(finishedWork, root)));
            break;
        case 30:
            flags & 512 && ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || null === current || $5c00e1cb1faeed50$var$safelyDetachRef(current, current.return));
            flags = $5c00e1cb1faeed50$var$pushMutationContext();
            ii = $5c00e1cb1faeed50$var$inUpdateViewTransition;
            _eventPayloads$ii2 = (lanes & 335544064) === lanes;
            prevOffscreenSubtreeIsHidden = finishedWork.memoizedProps;
            $5c00e1cb1faeed50$var$inUpdateViewTransition = _eventPayloads$ii2 && "none" !== $5c00e1cb1faeed50$var$getViewTransitionClassName(prevOffscreenSubtreeIsHidden.default, prevOffscreenSubtreeIsHidden.update);
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes);
            $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
            _eventPayloads$ii2 && null !== current && $5c00e1cb1faeed50$var$viewTransitionMutationContext && (finishedWork.flags |= 4);
            $5c00e1cb1faeed50$var$inUpdateViewTransition = ii;
            $5c00e1cb1faeed50$var$viewTransitionMutationContext = flags;
            break;
        case 21:
            break;
        case 7:
            flags & 512 && ($5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || null === current || $5c00e1cb1faeed50$var$safelyDetachRef(current, current.return)), current && null !== current.stateNode && (current.stateNode._fragmentFiber = finishedWork);
        default:
            $5c00e1cb1faeed50$var$recursivelyTraverseMutationEffects(root, finishedWork, lanes), $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork);
    }
}
function $5c00e1cb1faeed50$var$commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
        try {
            for(var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber;){
                if ($5c00e1cb1faeed50$var$isHostParent(parentFiber)) {
                    hostParentFiber = parentFiber;
                    break;
                }
                parentFiber = parentFiber.return;
            }
            parentFiber = null;
            for(var parent = finishedWork.return; null !== parent;){
                if ($5c00e1cb1faeed50$var$isFragmentInstanceParent(parent)) {
                    var fragmentInstance = parent.stateNode;
                    null === parentFiber ? parentFiber = [
                        fragmentInstance
                    ] : parentFiber.push(fragmentInstance);
                }
                if ($5c00e1cb1faeed50$var$isFragmentInstanceHostBoundary(parent)) break;
                parent = parent.return;
            }
            var JSCompiler_inline_result = parentFiber;
            if (null == hostParentFiber) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(160));
            switch(hostParentFiber.tag){
                case 27:
                    var parent$jscomp$0 = hostParentFiber.stateNode, before = $5c00e1cb1faeed50$var$getHostSibling(finishedWork);
                    $5c00e1cb1faeed50$var$insertOrAppendPlacementNode(finishedWork, before, parent$jscomp$0, JSCompiler_inline_result);
                    break;
                case 5:
                    var parent$149 = hostParentFiber.stateNode;
                    hostParentFiber.flags & 32 && ($5c00e1cb1faeed50$var$setTextContent(parent$149, ""), hostParentFiber.flags &= -33);
                    var before$150 = $5c00e1cb1faeed50$var$getHostSibling(finishedWork);
                    $5c00e1cb1faeed50$var$insertOrAppendPlacementNode(finishedWork, before$150, parent$149, JSCompiler_inline_result);
                    break;
                case 3:
                case 4:
                    var parent$151 = hostParentFiber.stateNode.containerInfo, before$152 = $5c00e1cb1faeed50$var$getHostSibling(finishedWork);
                    $5c00e1cb1faeed50$var$insertOrAppendPlacementNodeIntoContainer(finishedWork, before$152, parent$151, JSCompiler_inline_result);
                    break;
                default:
                    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(161));
            }
        } catch (error) {
            $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
}
function $5c00e1cb1faeed50$var$recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var fiber = parentFiber;
        $5c00e1cb1faeed50$var$recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && (fiber = fiber.stateNode, $5c00e1cb1faeed50$var$_enabled = !0, fiber.reset(), $5c00e1cb1faeed50$var$_enabled = !1);
        parentFiber = parentFiber.sibling;
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 9270) for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$commitAfterMutationEffectsOnFiber(parentFiber, root), parentFiber = parentFiber.sibling;
    else $5c00e1cb1faeed50$var$measureNestedViewTransitions(parentFiber, !1);
}
function $5c00e1cb1faeed50$var$commitAfterMutationEffectsOnFiber(finishedWork, root) {
    var current = finishedWork.alternate;
    if (null === current) $5c00e1cb1faeed50$var$commitEnterViewTransitions(finishedWork, !1);
    else switch(finishedWork.tag){
        case 3:
            $5c00e1cb1faeed50$var$rootViewTransitionNameCanceled = $5c00e1cb1faeed50$var$viewTransitionContextChanged = !1;
            $5c00e1cb1faeed50$var$pushViewTransitionCancelableScope();
            $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            if (!$5c00e1cb1faeed50$var$viewTransitionContextChanged && !$5c00e1cb1faeed50$var$rootViewTransitionAffected) {
                finishedWork = $5c00e1cb1faeed50$var$viewTransitionCancelableChildren;
                if (null !== finishedWork) for(var i = 0; i < finishedWork.length; i += 3){
                    current = finishedWork[i];
                    var oldName = finishedWork[i + 1];
                    $5c00e1cb1faeed50$var$restoreViewTransitionName(current, finishedWork[i + 2]);
                    current = current.ownerDocument.documentElement;
                    null !== current && current.animate({
                        opacity: [
                            0,
                            0
                        ],
                        pointerEvents: [
                            "none",
                            "none"
                        ]
                    }, {
                        duration: 0,
                        fill: "forwards",
                        pseudoElement: "::view-transition-group(" + oldName + ")"
                    });
                }
                finishedWork = root.containerInfo;
                finishedWork = 9 === finishedWork.nodeType ? finishedWork.documentElement : finishedWork.ownerDocument.documentElement;
                null !== finishedWork && "" === finishedWork.style.viewTransitionName && (finishedWork.style.viewTransitionName = "none", finishedWork.animate({
                    opacity: [
                        0,
                        0
                    ],
                    pointerEvents: [
                        "none",
                        "none"
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition-group(root)"
                }), finishedWork.animate({
                    width: [
                        0,
                        0
                    ],
                    height: [
                        0,
                        0
                    ]
                }, {
                    duration: 0,
                    fill: "forwards",
                    pseudoElement: "::view-transition"
                }));
                $5c00e1cb1faeed50$var$rootViewTransitionNameCanceled = !0;
            }
            $5c00e1cb1faeed50$var$viewTransitionCancelableChildren = null;
            break;
        case 5:
            $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            break;
        case 4:
            i = $5c00e1cb1faeed50$var$viewTransitionContextChanged;
            $5c00e1cb1faeed50$var$viewTransitionContextChanged = !1;
            $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $5c00e1cb1faeed50$var$viewTransitionContextChanged && ($5c00e1cb1faeed50$var$rootViewTransitionAffected = !0);
            $5c00e1cb1faeed50$var$viewTransitionContextChanged = i;
            break;
        case 22:
            null === finishedWork.memoizedState && (null !== current.memoizedState ? $5c00e1cb1faeed50$var$commitEnterViewTransitions(finishedWork, !1) : $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, finishedWork));
            break;
        case 30:
            i = $5c00e1cb1faeed50$var$viewTransitionContextChanged;
            oldName = $5c00e1cb1faeed50$var$pushViewTransitionCancelableScope();
            $5c00e1cb1faeed50$var$viewTransitionContextChanged = !1;
            $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
            $5c00e1cb1faeed50$var$viewTransitionContextChanged && (finishedWork.flags |= 4);
            var props = finishedWork.memoizedProps, state = finishedWork.stateNode;
            root = $5c00e1cb1faeed50$var$getViewTransitionName(props, state);
            state = $5c00e1cb1faeed50$var$getViewTransitionName(current.memoizedProps, state);
            var className = $5c00e1cb1faeed50$var$getViewTransitionClassName(props.default, props.update);
            "none" === className ? root = !1 : (props = current.memoizedState, current.memoizedState = null, current = finishedWork.child, $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx = 0, root = $5c00e1cb1faeed50$var$measureViewTransitionHostInstancesRecursive(finishedWork, current, root, state, className, props, !0), $5c00e1cb1faeed50$var$viewTransitionHostInstanceIdx !== (null === props ? 0 : props.length) && (finishedWork.flags |= 32));
            0 !== (finishedWork.flags & 4) && root ? ($5c00e1cb1faeed50$var$scheduleViewTransitionEvent(finishedWork, finishedWork.memoizedProps.onUpdate), $5c00e1cb1faeed50$var$viewTransitionCancelableChildren = oldName) : null !== oldName && (oldName.push.apply(oldName, $5c00e1cb1faeed50$var$viewTransitionCancelableChildren), $5c00e1cb1faeed50$var$viewTransitionCancelableChildren = oldName);
            $5c00e1cb1faeed50$var$viewTransitionContextChanged = 0 !== (finishedWork.flags & 32) ? !0 : i;
            break;
        default:
            $5c00e1cb1faeed50$var$recursivelyTraverseAfterMutationEffects(root, finishedWork);
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraverseLayoutEffects(root, parentFiber) {
    if (parentFiber.subtreeFlags & 8772) for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$commitLayoutEffectOnFiber(root, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
}
function $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(parentFiber, layoutEffectTraversalFlags$jscomp$0) {
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedWork = parentFiber, layoutEffectTraversalFlags = layoutEffectTraversalFlags$jscomp$0;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 14:
            case 15:
                $5c00e1cb1faeed50$var$commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
                $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 1:
                $5c00e1cb1faeed50$var$safelyDetachRef(finishedWork, finishedWork.return);
                var instance = finishedWork.stateNode;
                "function" === typeof instance.componentWillUnmount && $5c00e1cb1faeed50$var$safelyCallComponentWillUnmount(finishedWork, finishedWork.return, instance);
                $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $5c00e1cb1faeed50$var$releaseSingletonInstance(finishedWork.stateNode, finishedWork.type, finishedWork.memoizedProps);
            case 5:
                $5c00e1cb1faeed50$var$safelyDetachRef(finishedWork, finishedWork.return);
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $5c00e1cb1faeed50$var$commitFragmentInstanceDeletionEffects(finishedWork);
                $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 6:
                $5c00e1cb1faeed50$var$commitFragmentInstanceDeletionEffects(finishedWork);
                break;
            case 26:
                $5c00e1cb1faeed50$var$safelyDetachRef(finishedWork, finishedWork.return);
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $5c00e1cb1faeed50$var$offscreenSubtreeWasHidden || instance.parentNode.removeChild(instance);
                $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 22:
                null === finishedWork.memoizedState && $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 30:
                $5c00e1cb1faeed50$var$safelyDetachRef(finishedWork, finishedWork.return);
                $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
                break;
            case 7:
                $5c00e1cb1faeed50$var$safelyDetachRef(finishedWork, finishedWork.return);
            default:
                $5c00e1cb1faeed50$var$recursivelyTraverseDisappearLayoutEffects(finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, layoutEffectTraversalFlags) {
    layoutEffectTraversalFlags = 0 !== (parentFiber.subtreeFlags & 8772) ? layoutEffectTraversalFlags : layoutEffectTraversalFlags & -2;
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var current = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags, includeWorkInProgressEffects = 0 !== (layoutEffectTraversalFlags & 1);
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $5c00e1cb1faeed50$var$commitHookEffectListMount(4, finishedWork);
                break;
            case 1:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                current = finishedWork;
                finishedRoot = current.stateNode;
                if ("function" === typeof finishedRoot.componentDidMount) try {
                    finishedRoot.componentDidMount();
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(current, current.return, error);
                }
                current = finishedWork;
                finishedRoot = current.updateQueue;
                if (null !== finishedRoot) {
                    var instance = current.stateNode;
                    try {
                        var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
                        if (null !== hiddenCallbacks) for(finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)$5c00e1cb1faeed50$var$callCallback(hiddenCallbacks[finishedRoot], instance);
                    } catch (error) {
                        $5c00e1cb1faeed50$var$captureCommitPhaseError(current, current.return, error);
                    }
                }
                includeWorkInProgressEffects && flags & 64 && $5c00e1cb1faeed50$var$commitClassCallbacks(finishedWork);
                $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 27:
                0 !== (layoutEffectTraversalFlags & 2) && $5c00e1cb1faeed50$var$commitHostSingletonAcquisition(finishedWork);
            case 5:
                5 !== finishedWork.tag && 27 !== finishedWork.tag || $5c00e1cb1faeed50$var$commitFragmentInstanceInsertionEffects(finishedWork);
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $5c00e1cb1faeed50$var$commitHostMount(finishedWork);
                $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 6:
                $5c00e1cb1faeed50$var$commitFragmentInstanceInsertionEffects(finishedWork);
                break;
            case 26:
                instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState || null === instance || $5c00e1cb1faeed50$var$offscreenSubtreeIsHidden || $5c00e1cb1faeed50$var$mountHoistable($5c00e1cb1faeed50$var$getHoistableRoot(instance.ownerDocument), finishedWork.type, instance);
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && null === current && flags & 4 && $5c00e1cb1faeed50$var$commitHostMount(finishedWork);
                $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 12:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                break;
            case 31:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $5c00e1cb1faeed50$var$commitActivityHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 13:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                includeWorkInProgressEffects && flags & 4 && $5c00e1cb1faeed50$var$commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
                break;
            case 22:
                null === finishedWork.memoizedState && $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 30:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
                $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
                break;
            case 7:
                $5c00e1cb1faeed50$var$safelyAttachRef(finishedWork, finishedWork.return);
            default:
                $5c00e1cb1faeed50$var$recursivelyTraverseReappearLayoutEffects(finishedRoot, finishedWork, layoutEffectTraversalFlags);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5c00e1cb1faeed50$var$commitOffscreenPassiveMountEffects(current, finishedWork) {
    var previousCache = null;
    null !== current && null !== current.memoizedState && null !== current.memoizedState.cachePool && (previousCache = current.memoizedState.cachePool.pool);
    current = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current = finishedWork.memoizedState.cachePool.pool);
    current !== previousCache && (null != current && current.refCount++, null != previousCache && $5c00e1cb1faeed50$var$releaseCache(previousCache));
}
function $5c00e1cb1faeed50$var$commitCachePassiveMountEffect(current, finishedWork) {
    current = null;
    null !== finishedWork.alternate && (current = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current && (finishedWork.refCount++, null != current && $5c00e1cb1faeed50$var$releaseCache(current));
}
function $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(root, parentFiber, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    if (parentFiber.subtreeFlags & (isViewTransitionEligible ? 10262 : 10256)) for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$commitPassiveMountOnFiber(root, parentFiber, committedLanes, committedTransitions), parentFiber = parentFiber.sibling;
    else isViewTransitionEligible && $5c00e1cb1faeed50$var$restoreNestedViewTransitions(parentFiber);
}
function $5c00e1cb1faeed50$var$commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var isViewTransitionEligible = (committedLanes & 335544064) === committedLanes;
    isViewTransitionEligible && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && $5c00e1cb1faeed50$var$restoreEnterOrExitViewTransitions(finishedWork);
    var flags = finishedWork.flags;
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $5c00e1cb1faeed50$var$commitHookEffectListMount(9, finishedWork);
            break;
        case 1:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 3:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            isViewTransitionEligible && $5c00e1cb1faeed50$var$rootViewTransitionNameCanceled && (finishedRoot = finishedRoot.containerInfo, finishedRoot = 9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot, "root" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""), finishedRoot = finishedRoot.ownerDocument.documentElement, null !== finishedRoot && "none" === finishedRoot.style.viewTransitionName && (finishedRoot.style.viewTransitionName = ""));
            flags & 2048 && (flags = null, null !== finishedWork.alternate && (flags = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== flags && (finishedWork.refCount++, null != flags && $5c00e1cb1faeed50$var$releaseCache(flags)));
            break;
        case 12:
            if (flags & 2048) {
                $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
                flags = finishedWork.stateNode;
                try {
                    var _finishedWork$memoize2 = finishedWork.memoizedProps, id = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
                    "function" === typeof onPostCommit && onPostCommit(id, null === finishedWork.alternate ? "mount" : "update", flags.passiveEffectDuration, -0);
                } catch (error) {
                    $5c00e1cb1faeed50$var$captureCommitPhaseError(finishedWork, finishedWork.return, error);
                }
            } else $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 31:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 13:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        case 23:
            break;
        case 22:
            _finishedWork$memoize2 = finishedWork.stateNode;
            id = finishedWork.alternate;
            null !== finishedWork.memoizedState ? (isViewTransitionEligible && null !== id && null === id.memoizedState && $5c00e1cb1faeed50$var$restoreEnterOrExitViewTransitions(id), _finishedWork$memoize2._visibility & 2 ? $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : $5c00e1cb1faeed50$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork)) : (isViewTransitionEligible && null !== id && null !== id.memoizedState && $5c00e1cb1faeed50$var$restoreEnterOrExitViewTransitions(finishedWork), _finishedWork$memoize2._visibility & 2 ? $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions) : (_finishedWork$memoize2._visibility |= 2, $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, 0 !== (finishedWork.subtreeFlags & 10256) || !1)));
            flags & 2048 && $5c00e1cb1faeed50$var$commitOffscreenPassiveMountEffects(id, finishedWork);
            break;
        case 24:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            flags & 2048 && $5c00e1cb1faeed50$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
        case 30:
            isViewTransitionEligible && (flags = finishedWork.alternate, null !== flags && ($5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(flags.child, !0), $5c00e1cb1faeed50$var$restoreViewTransitionOnHostInstances(finishedWork.child, !0)));
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
            break;
        default:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveMountEffects(finishedRoot, finishedWork, committedLanes, committedTransitions);
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || !1);
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 0:
            case 11:
            case 15:
                $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                $5c00e1cb1faeed50$var$commitHookEffectListMount(8, finishedWork);
                break;
            case 23:
                break;
            case 22:
                var instance = finishedWork.stateNode;
                null !== finishedWork.memoizedState ? instance._visibility & 2 ? $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects) : $5c00e1cb1faeed50$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : (instance._visibility |= 2, $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects));
                includeWorkInProgressEffects && flags & 2048 && $5c00e1cb1faeed50$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
                includeWorkInProgressEffects && flags & 2048 && $5c00e1cb1faeed50$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $5c00e1cb1faeed50$var$recursivelyTraverseReconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;){
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch(finishedWork.tag){
            case 22:
                $5c00e1cb1faeed50$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $5c00e1cb1faeed50$var$commitOffscreenPassiveMountEffects(finishedWork.alternate, finishedWork);
                break;
            case 24:
                $5c00e1cb1faeed50$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
                flags & 2048 && $5c00e1cb1faeed50$var$commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
                break;
            default:
                $5c00e1cb1faeed50$var$recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
    }
}
var $5c00e1cb1faeed50$var$suspenseyCommitFlag = 8192;
function $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & $5c00e1cb1faeed50$var$suspenseyCommitFlag) for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$accumulateSuspenseyCommitOnFiber(parentFiber, committedLanes, suspendedState), parentFiber = parentFiber.sibling;
}
function $5c00e1cb1faeed50$var$accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch(fiber.tag){
        case 26:
            $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $5c00e1cb1faeed50$var$suspenseyCommitFlag && (null !== fiber.memoizedState ? $5c00e1cb1faeed50$var$suspendResource(suspendedState, $5c00e1cb1faeed50$var$currentHoistableRoot, fiber.memoizedState, fiber.memoizedProps) : (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $5c00e1cb1faeed50$var$suspendInstance(suspendedState, fiber)));
            break;
        case 5:
            $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            fiber.flags & $5c00e1cb1faeed50$var$suspenseyCommitFlag && (fiber = fiber.stateNode, (committedLanes & 335544128) === committedLanes && $5c00e1cb1faeed50$var$suspendInstance(suspendedState, fiber));
            break;
        case 3:
        case 4:
            var previousHoistableRoot = $5c00e1cb1faeed50$var$currentHoistableRoot;
            $5c00e1cb1faeed50$var$currentHoistableRoot = $5c00e1cb1faeed50$var$getHoistableRoot(fiber.stateNode.containerInfo);
            $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            $5c00e1cb1faeed50$var$currentHoistableRoot = previousHoistableRoot;
            break;
        case 22:
            null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = $5c00e1cb1faeed50$var$suspenseyCommitFlag, $5c00e1cb1faeed50$var$suspenseyCommitFlag = 16777216, $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState), $5c00e1cb1faeed50$var$suspenseyCommitFlag = previousHoistableRoot) : $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState));
            break;
        case 30:
            if (0 !== (fiber.flags & $5c00e1cb1faeed50$var$suspenseyCommitFlag) && (previousHoistableRoot = fiber.memoizedProps.name, null != previousHoistableRoot && "auto" !== previousHoistableRoot)) {
                var state = fiber.stateNode;
                state.paired = null;
                null === $5c00e1cb1faeed50$var$appearingViewTransitions && ($5c00e1cb1faeed50$var$appearingViewTransitions = new Map());
                $5c00e1cb1faeed50$var$appearingViewTransitions.set(previousHoistableRoot, state);
            }
            $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
            break;
        default:
            $5c00e1cb1faeed50$var$recursivelyAccumulateSuspenseyCommit(fiber, committedLanes, suspendedState);
    }
}
function $5c00e1cb1faeed50$var$detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $5c00e1cb1faeed50$var$nextEffect = childToDelete;
            $5c00e1cb1faeed50$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $5c00e1cb1faeed50$var$detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256) for(parentFiber = parentFiber.child; null !== parentFiber;)$5c00e1cb1faeed50$var$commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
}
function $5c00e1cb1faeed50$var$commitPassiveUnmountOnFiber(finishedWork) {
    switch(finishedWork.tag){
        case 0:
        case 11:
        case 15:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            finishedWork.flags & 2048 && $5c00e1cb1faeed50$var$commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
            break;
        case 3:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 12:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        case 22:
            var instance = finishedWork.stateNode;
            null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, $5c00e1cb1faeed50$var$recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : $5c00e1cb1faeed50$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
            break;
        default:
            $5c00e1cb1faeed50$var$recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
}
function $5c00e1cb1faeed50$var$recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions) for(var i = 0; i < deletions.length; i++){
            var childToDelete = deletions[i];
            $5c00e1cb1faeed50$var$nextEffect = childToDelete;
            $5c00e1cb1faeed50$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(childToDelete, parentFiber);
        }
        $5c00e1cb1faeed50$var$detachAlternateSiblings(parentFiber);
    }
    for(parentFiber = parentFiber.child; null !== parentFiber;){
        deletions = parentFiber;
        switch(deletions.tag){
            case 0:
            case 11:
            case 15:
                $5c00e1cb1faeed50$var$commitHookEffectListUnmount(8, deletions, deletions.return);
                $5c00e1cb1faeed50$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
                break;
            case 22:
                i = deletions.stateNode;
                i._visibility & 2 && (i._visibility &= -3, $5c00e1cb1faeed50$var$recursivelyTraverseDisconnectPassiveEffects(deletions));
                break;
            default:
                $5c00e1cb1faeed50$var$recursivelyTraverseDisconnectPassiveEffects(deletions);
        }
        parentFiber = parentFiber.sibling;
    }
}
function $5c00e1cb1faeed50$var$commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for(; null !== $5c00e1cb1faeed50$var$nextEffect;){
        var fiber = $5c00e1cb1faeed50$var$nextEffect;
        switch(fiber.tag){
            case 0:
            case 11:
            case 15:
                $5c00e1cb1faeed50$var$commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
                break;
            case 23:
            case 22:
                if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
                    var cache = fiber.memoizedState.cachePool.pool;
                    null != cache && cache.refCount++;
                }
                break;
            case 24:
                $5c00e1cb1faeed50$var$releaseCache(fiber.memoizedState.cache);
        }
        cache = fiber.child;
        if (null !== cache) cache.return = fiber, $5c00e1cb1faeed50$var$nextEffect = cache;
        else a: for(fiber = deletedSubtreeRoot; null !== $5c00e1cb1faeed50$var$nextEffect;){
            cache = $5c00e1cb1faeed50$var$nextEffect;
            var sibling = cache.sibling, returnFiber = cache.return;
            $5c00e1cb1faeed50$var$detachFiberAfterEffects(cache);
            if (cache === fiber) {
                $5c00e1cb1faeed50$var$nextEffect = null;
                break a;
            }
            if (null !== sibling) {
                sibling.return = returnFiber;
                $5c00e1cb1faeed50$var$nextEffect = sibling;
                break a;
            }
            $5c00e1cb1faeed50$var$nextEffect = returnFiber;
        }
    }
}
var $5c00e1cb1faeed50$var$DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
        var cache = $5c00e1cb1faeed50$var$readContext($5c00e1cb1faeed50$var$CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
    },
    cacheSignal: function() {
        return $5c00e1cb1faeed50$var$readContext($5c00e1cb1faeed50$var$CacheContext).controller.signal;
    }
}, $5c00e1cb1faeed50$var$PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, $5c00e1cb1faeed50$var$executionContext = 0, $5c00e1cb1faeed50$var$workInProgressRoot = null, $5c00e1cb1faeed50$var$workInProgress = null, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes = 0, $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0, $5c00e1cb1faeed50$var$workInProgressThrownValue = null, $5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings = !1, $5c00e1cb1faeed50$var$workInProgressRootIsPrerendering = !1, $5c00e1cb1faeed50$var$workInProgressRootDidAttachPingListener = !1, $5c00e1cb1faeed50$var$entangledRenderLanes = 0, $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 0, $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes = 0, $5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes = 0, $5c00e1cb1faeed50$var$workInProgressRootPingedLanes = 0, $5c00e1cb1faeed50$var$workInProgressDeferredLane = 0, $5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes = 0, $5c00e1cb1faeed50$var$workInProgressRootConcurrentErrors = null, $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors = null, $5c00e1cb1faeed50$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1, $5c00e1cb1faeed50$var$globalMostRecentFallbackTime = 0, $5c00e1cb1faeed50$var$globalMostRecentTransitionTime = 0, $5c00e1cb1faeed50$var$workInProgressRootRenderTargetTime = Infinity, $5c00e1cb1faeed50$var$workInProgressTransitions = null, $5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed = null, $5c00e1cb1faeed50$var$pendingEffectsStatus = 0, $5c00e1cb1faeed50$var$pendingEffectsRoot = null, $5c00e1cb1faeed50$var$pendingFinishedWork = null, $5c00e1cb1faeed50$var$pendingEffectsLanes = 0, $5c00e1cb1faeed50$var$pendingEffectsRemainingLanes = 0, $5c00e1cb1faeed50$var$pendingPassiveTransitions = null, $5c00e1cb1faeed50$var$pendingRecoverableErrors = null, $5c00e1cb1faeed50$var$pendingViewTransition = null, $5c00e1cb1faeed50$var$pendingViewTransitionEvents = null, $5c00e1cb1faeed50$var$pendingTransitionTypes = null, $5c00e1cb1faeed50$var$nestedUpdateCount = 0, $5c00e1cb1faeed50$var$rootWithNestedUpdates = null;
function $5c00e1cb1faeed50$var$requestUpdateLane() {
    return 0 !== ($5c00e1cb1faeed50$var$executionContext & 2) && 0 !== $5c00e1cb1faeed50$var$workInProgressRootRenderLanes ? $5c00e1cb1faeed50$var$workInProgressRootRenderLanes & -$5c00e1cb1faeed50$var$workInProgressRootRenderLanes : null !== $5c00e1cb1faeed50$var$ReactSharedInternals.T ? $5c00e1cb1faeed50$var$requestTransitionLane() : $5c00e1cb1faeed50$var$resolveUpdatePriority();
}
function $5c00e1cb1faeed50$var$requestDeferredLane() {
    if (0 === $5c00e1cb1faeed50$var$workInProgressDeferredLane) {
        if (0 === ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 536870912) || $5c00e1cb1faeed50$var$isHydrating) {
            var lane = $5c00e1cb1faeed50$var$nextTransitionDeferredLane;
            $5c00e1cb1faeed50$var$nextTransitionDeferredLane <<= 1;
            0 === ($5c00e1cb1faeed50$var$nextTransitionDeferredLane & 3932160) && ($5c00e1cb1faeed50$var$nextTransitionDeferredLane = 262144);
            $5c00e1cb1faeed50$var$workInProgressDeferredLane = lane;
        } else $5c00e1cb1faeed50$var$workInProgressDeferredLane = 536870912;
    }
    lane = $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return $5c00e1cb1faeed50$var$workInProgressDeferredLane;
}
function $5c00e1cb1faeed50$var$scheduleViewTransitionEvent(fiber, callback) {
    if (null != callback) {
        var state = fiber.stateNode, instance = state.ref;
        null === instance && (instance = state.ref = $5c00e1cb1faeed50$var$createViewTransitionInstance($5c00e1cb1faeed50$var$getViewTransitionName(fiber.memoizedProps, state)));
        null === $5c00e1cb1faeed50$var$pendingViewTransitionEvents && ($5c00e1cb1faeed50$var$pendingViewTransitionEvents = []);
        $5c00e1cb1faeed50$var$pendingViewTransitionEvents.push(callback.bind(null, instance));
    }
}
function $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(root, fiber, lane) {
    if (root === $5c00e1cb1faeed50$var$workInProgressRoot && (2 === $5c00e1cb1faeed50$var$workInProgressSuspendedReason || 9 === $5c00e1cb1faeed50$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) $5c00e1cb1faeed50$var$prepareFreshStack(root, 0), $5c00e1cb1faeed50$var$markRootSuspended(root, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, !1);
    $5c00e1cb1faeed50$var$markRootUpdated$1(root, lane);
    if (0 === ($5c00e1cb1faeed50$var$executionContext & 2) || root !== $5c00e1cb1faeed50$var$workInProgressRoot) root === $5c00e1cb1faeed50$var$workInProgressRoot && (0 === ($5c00e1cb1faeed50$var$executionContext & 2) && ($5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes |= lane), 4 === $5c00e1cb1faeed50$var$workInProgressRootExitStatus && $5c00e1cb1faeed50$var$markRootSuspended(root, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, !1)), $5c00e1cb1faeed50$var$ensureRootIsScheduled(root);
}
function $5c00e1cb1faeed50$var$performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== ($5c00e1cb1faeed50$var$executionContext & 6)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || $5c00e1cb1faeed50$var$checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? $5c00e1cb1faeed50$var$renderRootConcurrent(root$jscomp$0, lanes) : $5c00e1cb1faeed50$var$renderRootSync(root$jscomp$0, lanes, !0), renderWasConcurrent = shouldTimeSlice;
    do {
        if (0 === exitStatus) {
            $5c00e1cb1faeed50$var$workInProgressRootIsPrerendering && !shouldTimeSlice && $5c00e1cb1faeed50$var$markRootSuspended(root$jscomp$0, lanes, 0, !1);
            break;
        } else {
            forceSync = root$jscomp$0.current.alternate;
            if (renderWasConcurrent && !$5c00e1cb1faeed50$var$isRenderConsistentWithExternalStores(forceSync)) {
                exitStatus = $5c00e1cb1faeed50$var$renderRootSync(root$jscomp$0, lanes, !1);
                renderWasConcurrent = !1;
                continue;
            }
            if (2 === exitStatus) {
                renderWasConcurrent = lanes;
                if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent) var JSCompiler_inline_result = 0;
                else JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
                if (0 !== JSCompiler_inline_result) {
                    lanes = JSCompiler_inline_result;
                    a: {
                        var root = root$jscomp$0;
                        exitStatus = $5c00e1cb1faeed50$var$workInProgressRootConcurrentErrors;
                        var wasRootDehydrated = root.current.memoizedState.isDehydrated;
                        wasRootDehydrated && ($5c00e1cb1faeed50$var$prepareFreshStack(root, JSCompiler_inline_result).flags |= 256);
                        JSCompiler_inline_result = $5c00e1cb1faeed50$var$renderRootSync(root, JSCompiler_inline_result, !1);
                        if (2 !== JSCompiler_inline_result && 6 !== JSCompiler_inline_result) {
                            if ($5c00e1cb1faeed50$var$workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                                root.errorRecoveryDisabledLanes |= renderWasConcurrent;
                                $5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                                exitStatus = 4;
                                break a;
                            }
                            renderWasConcurrent = $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors;
                            $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors = exitStatus;
                            null !== renderWasConcurrent && (null === $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors ? $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors = renderWasConcurrent : $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors.push.apply($5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors, renderWasConcurrent));
                        }
                        exitStatus = JSCompiler_inline_result;
                    }
                    renderWasConcurrent = !1;
                    if (2 !== exitStatus) continue;
                }
            }
            if (1 === exitStatus) {
                $5c00e1cb1faeed50$var$prepareFreshStack(root$jscomp$0, 0);
                $5c00e1cb1faeed50$var$markRootSuspended(root$jscomp$0, lanes, 0, !0);
                break;
            }
            a: {
                shouldTimeSlice = root$jscomp$0;
                renderWasConcurrent = exitStatus;
                switch(renderWasConcurrent){
                    case 0:
                    case 1:
                        throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(345));
                    case 4:
                        if ((lanes & 4194048) !== lanes && (lanes & 62914560) !== lanes) break;
                    case 6:
                        $5c00e1cb1faeed50$var$markRootSuspended(shouldTimeSlice, lanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, !$5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings);
                        break a;
                    case 2:
                        $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors = null;
                        break;
                    case 3:
                    case 5:
                        break;
                    default:
                        throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(329));
                }
                if ((lanes & 62914560) === lanes && (exitStatus = $5c00e1cb1faeed50$var$globalMostRecentFallbackTime + 300 - $5c00e1cb1faeed50$var$now(), 10 < exitStatus)) {
                    $5c00e1cb1faeed50$var$markRootSuspended(shouldTimeSlice, lanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, !$5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings);
                    if (0 !== $5c00e1cb1faeed50$var$getNextLanes(shouldTimeSlice, 0, !0)) break a;
                    $5c00e1cb1faeed50$var$pendingEffectsLanes = lanes;
                    shouldTimeSlice.timeoutHandle = $5c00e1cb1faeed50$var$scheduleTimeout($5c00e1cb1faeed50$var$completeRootWhenReady.bind(null, shouldTimeSlice, forceSync, $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors, $5c00e1cb1faeed50$var$workInProgressTransitions, $5c00e1cb1faeed50$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, $5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes, $5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes, $5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, "Throttled", -0, 0), exitStatus);
                    break a;
                }
                $5c00e1cb1faeed50$var$completeRootWhenReady(shouldTimeSlice, forceSync, $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors, $5c00e1cb1faeed50$var$workInProgressTransitions, $5c00e1cb1faeed50$var$workInProgressRootDidIncludeRecursiveRenderUpdate, lanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, $5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes, $5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes, $5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings, renderWasConcurrent, null, -0, 0);
            }
        }
        break;
    }while (1);
    $5c00e1cb1faeed50$var$ensureRootIsScheduled(root$jscomp$0);
}
function $5c00e1cb1faeed50$var$completeRootWhenReady(root, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root.timeoutHandle = -1;
    var subtreeFlags = finishedWork.subtreeFlags, isViewTransitionEligible = (lanes & 335544064) === lanes;
    suspendedCommitReason = null;
    if (isViewTransitionEligible || subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedCommitReason = {
            stylesheets: null,
            count: 0,
            imgCount: 0,
            imgBytes: 0,
            suspenseyImages: [],
            waitingForImages: !0,
            waitingForViewTransition: !1,
            unsuspend: $5c00e1cb1faeed50$var$noop$1
        }, $5c00e1cb1faeed50$var$appearingViewTransitions = null, $5c00e1cb1faeed50$var$accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedCommitReason), isViewTransitionEligible && (subtreeFlags = suspendedCommitReason, isViewTransitionEligible = root.containerInfo, isViewTransitionEligible = (9 === isViewTransitionEligible.nodeType ? isViewTransitionEligible : isViewTransitionEligible.ownerDocument).__reactViewTransition, null != isViewTransitionEligible && (subtreeFlags.count++, subtreeFlags.waitingForViewTransition = !0, subtreeFlags = $5c00e1cb1faeed50$var$onUnsuspend.bind(subtreeFlags), isViewTransitionEligible.finished.then(subtreeFlags, subtreeFlags))), subtreeFlags = (lanes & 62914560) === lanes ? $5c00e1cb1faeed50$var$globalMostRecentFallbackTime - $5c00e1cb1faeed50$var$now() : (lanes & 4194048) === lanes ? $5c00e1cb1faeed50$var$globalMostRecentTransitionTime - $5c00e1cb1faeed50$var$now() : 0, subtreeFlags = $5c00e1cb1faeed50$var$waitForCommitToBeReady(suspendedCommitReason, subtreeFlags), null !== subtreeFlags) {
            $5c00e1cb1faeed50$var$pendingEffectsLanes = lanes;
            root.cancelPendingCommit = subtreeFlags($5c00e1cb1faeed50$var$completeRoot.bind(null, root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, null, completedRenderStartTime, completedRenderEndTime));
            $5c00e1cb1faeed50$var$markRootSuspended(root, lanes, spawnedLane, !didSkipSuspendedSiblings);
            return;
        }
    }
    $5c00e1cb1faeed50$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason);
}
function $5c00e1cb1faeed50$var$isRenderConsistentWithExternalStores(finishedWork) {
    for(var node = finishedWork;;){
        var tag = node.tag;
        if ((0 === tag || 11 === tag || 15 === tag) && node.flags & 16384 && (tag = node.updateQueue, null !== tag && (tag = tag.stores, null !== tag))) for(var i = 0; i < tag.length; i++){
            var check = tag[i], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
                if (!$5c00e1cb1faeed50$var$objectIs(getSnapshot(), check)) return !1;
            } catch (error) {
                return !1;
            }
        }
        tag = node.child;
        if (node.subtreeFlags & 16384 && null !== tag) tag.return = node, node = tag;
        else {
            if (node === finishedWork) break;
            for(; null === node.sibling;){
                if (null === node.return || node.return === finishedWork) return !0;
                node = node.return;
            }
            node.sibling.return = node.return;
            node = node.sibling;
        }
    }
    return !0;
}
function $5c00e1cb1faeed50$var$markRootSuspended(root, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes = $5c00e1cb1faeed50$var$getEntangledLanes(root, suspendedLanes);
    suspendedLanes &= ~$5c00e1cb1faeed50$var$workInProgressRootPingedLanes;
    suspendedLanes &= ~$5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes;
    root.suspendedLanes |= suspendedLanes;
    root.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root.expirationTimes;
    for(var lanes = suspendedLanes; 0 < lanes;){
        var index$6 = 31 - $5c00e1cb1faeed50$var$clz32(lanes), lane = 1 << index$6;
        didAttemptEntireTree[index$6] = -1;
        lanes &= ~lane;
    }
    0 !== spawnedLane && $5c00e1cb1faeed50$var$markSpawnedDeferredLane(root, spawnedLane, suspendedLanes);
}
function $5c00e1cb1faeed50$var$flushSyncWork$1() {
    return 0 === ($5c00e1cb1faeed50$var$executionContext & 6) ? ($5c00e1cb1faeed50$var$flushSyncWorkAcrossRoots_impl(0, !1), !1) : !0;
}
function $5c00e1cb1faeed50$var$resetWorkInProgressStack() {
    if (null !== $5c00e1cb1faeed50$var$workInProgress) {
        if (0 === $5c00e1cb1faeed50$var$workInProgressSuspendedReason) var interruptedWork = $5c00e1cb1faeed50$var$workInProgress.return;
        else interruptedWork = $5c00e1cb1faeed50$var$workInProgress, $5c00e1cb1faeed50$var$lastContextDependency = $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 = null, $5c00e1cb1faeed50$var$resetHooksOnUnwind(interruptedWork), $5c00e1cb1faeed50$var$thenableState$1 = null, $5c00e1cb1faeed50$var$thenableIndexCounter$1 = 0, interruptedWork = $5c00e1cb1faeed50$var$workInProgress;
        for(; null !== interruptedWork;)$5c00e1cb1faeed50$var$unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        $5c00e1cb1faeed50$var$workInProgress = null;
    }
}
function $5c00e1cb1faeed50$var$prepareFreshStack(root, lanes) {
    var timeoutHandle = root.timeoutHandle;
    -1 !== timeoutHandle && (root.timeoutHandle = -1, $5c00e1cb1faeed50$var$cancelTimeout(timeoutHandle));
    timeoutHandle = root.cancelPendingCommit;
    null !== timeoutHandle && (root.cancelPendingCommit = null, timeoutHandle());
    $5c00e1cb1faeed50$var$pendingEffectsLanes = 0;
    $5c00e1cb1faeed50$var$resetWorkInProgressStack();
    $5c00e1cb1faeed50$var$workInProgressRoot = root;
    $5c00e1cb1faeed50$var$workInProgress = timeoutHandle = $5c00e1cb1faeed50$var$createWorkInProgress(root.current, null);
    $5c00e1cb1faeed50$var$workInProgressRootRenderLanes = lanes;
    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
    $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
    $5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings = !1;
    $5c00e1cb1faeed50$var$workInProgressRootIsPrerendering = $5c00e1cb1faeed50$var$checkIfRootIsPrerendering(root, lanes);
    $5c00e1cb1faeed50$var$workInProgressRootDidAttachPingListener = !1;
    $5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes = $5c00e1cb1faeed50$var$workInProgressDeferredLane = $5c00e1cb1faeed50$var$workInProgressRootPingedLanes = $5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes = $5c00e1cb1faeed50$var$workInProgressRootSkippedLanes = $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 0;
    $5c00e1cb1faeed50$var$workInProgressRootRecoverableErrors = $5c00e1cb1faeed50$var$workInProgressRootConcurrentErrors = null;
    $5c00e1cb1faeed50$var$workInProgressRootDidIncludeRecursiveRenderUpdate = !1;
    $5c00e1cb1faeed50$var$entangledRenderLanes = $5c00e1cb1faeed50$var$getEntangledLanes(root, lanes);
    $5c00e1cb1faeed50$var$finishQueueingConcurrentUpdates();
    return timeoutHandle;
}
function $5c00e1cb1faeed50$var$handleThrow(root, thrownValue) {
    $5c00e1cb1faeed50$var$currentlyRenderingFiber = null;
    $5c00e1cb1faeed50$var$ReactSharedInternals.H = $5c00e1cb1faeed50$var$ContextOnlyDispatcher;
    thrownValue === $5c00e1cb1faeed50$var$SuspenseException || thrownValue === $5c00e1cb1faeed50$var$SuspenseActionException ? (thrownValue = $5c00e1cb1faeed50$var$getSuspendedThenable(), $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 3) : thrownValue === $5c00e1cb1faeed50$var$SuspenseyCommitException ? (thrownValue = $5c00e1cb1faeed50$var$getSuspendedThenable(), $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 4) : $5c00e1cb1faeed50$var$workInProgressSuspendedReason = thrownValue === $5c00e1cb1faeed50$var$SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    $5c00e1cb1faeed50$var$workInProgressThrownValue = thrownValue;
    null === $5c00e1cb1faeed50$var$workInProgress && ($5c00e1cb1faeed50$var$workInProgressRootExitStatus = 1, $5c00e1cb1faeed50$var$logUncaughtError(root, $5c00e1cb1faeed50$var$createCapturedValueAtFiber(thrownValue, root.current)));
}
function $5c00e1cb1faeed50$var$shouldRemainOnPreviousScreen() {
    var handler = $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current;
    return null === handler ? !0 : ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 4194048) === $5c00e1cb1faeed50$var$workInProgressRootRenderLanes ? null === $5c00e1cb1faeed50$var$shellBoundary ? !0 : !1 : ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 62914560) === $5c00e1cb1faeed50$var$workInProgressRootRenderLanes || 0 !== ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 536870912) ? handler === $5c00e1cb1faeed50$var$shellBoundary : !1;
}
function $5c00e1cb1faeed50$var$pushDispatcher() {
    var prevDispatcher = $5c00e1cb1faeed50$var$ReactSharedInternals.H;
    $5c00e1cb1faeed50$var$ReactSharedInternals.H = $5c00e1cb1faeed50$var$ContextOnlyDispatcher;
    return null === prevDispatcher ? $5c00e1cb1faeed50$var$ContextOnlyDispatcher : prevDispatcher;
}
function $5c00e1cb1faeed50$var$pushAsyncDispatcher() {
    var prevAsyncDispatcher = $5c00e1cb1faeed50$var$ReactSharedInternals.A;
    $5c00e1cb1faeed50$var$ReactSharedInternals.A = $5c00e1cb1faeed50$var$DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
}
function $5c00e1cb1faeed50$var$renderDidSuspendDelayIfPossible() {
    $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 4;
    $5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings || ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 4194048) !== $5c00e1cb1faeed50$var$workInProgressRootRenderLanes && null !== $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current || ($5c00e1cb1faeed50$var$workInProgressRootIsPrerendering = !0);
    0 === ($5c00e1cb1faeed50$var$workInProgressRootSkippedLanes & 134217727) && 0 === ($5c00e1cb1faeed50$var$workInProgressRootInterleavedUpdatedLanes & 134217727) || null === $5c00e1cb1faeed50$var$workInProgressRoot || $5c00e1cb1faeed50$var$markRootSuspended($5c00e1cb1faeed50$var$workInProgressRoot, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes, $5c00e1cb1faeed50$var$workInProgressDeferredLane, !1);
}
function $5c00e1cb1faeed50$var$renderRootSync(root, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = $5c00e1cb1faeed50$var$executionContext;
    $5c00e1cb1faeed50$var$executionContext |= 2;
    var prevDispatcher = $5c00e1cb1faeed50$var$pushDispatcher(), prevAsyncDispatcher = $5c00e1cb1faeed50$var$pushAsyncDispatcher();
    if ($5c00e1cb1faeed50$var$workInProgressRoot !== root || $5c00e1cb1faeed50$var$workInProgressRootRenderLanes !== lanes) $5c00e1cb1faeed50$var$workInProgressTransitions = null, $5c00e1cb1faeed50$var$prepareFreshStack(root, lanes);
    lanes = !1;
    var exitStatus = $5c00e1cb1faeed50$var$workInProgressRootExitStatus;
    a: do try {
        if (0 !== $5c00e1cb1faeed50$var$workInProgressSuspendedReason && null !== $5c00e1cb1faeed50$var$workInProgress) {
            var unitOfWork = $5c00e1cb1faeed50$var$workInProgress, thrownValue = $5c00e1cb1faeed50$var$workInProgressThrownValue;
            switch($5c00e1cb1faeed50$var$workInProgressSuspendedReason){
                case 8:
                    $5c00e1cb1faeed50$var$resetWorkInProgressStack();
                    exitStatus = 6;
                    break a;
                case 3:
                case 2:
                case 9:
                case 6:
                    null === $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current && (lanes = !0);
                    var reason = $5c00e1cb1faeed50$var$workInProgressSuspendedReason;
                    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
                    $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
                    $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
                    if (shouldYieldForPrerendering && $5c00e1cb1faeed50$var$workInProgressRootIsPrerendering) {
                        exitStatus = 0;
                        break a;
                    }
                    break;
                default:
                    reason = $5c00e1cb1faeed50$var$workInProgressSuspendedReason, $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0, $5c00e1cb1faeed50$var$workInProgressThrownValue = null, $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, reason);
            }
        }
        $5c00e1cb1faeed50$var$workLoopSync();
        exitStatus = $5c00e1cb1faeed50$var$workInProgressRootExitStatus;
        break;
    } catch (thrownValue$184) {
        $5c00e1cb1faeed50$var$handleThrow(root, thrownValue$184);
    }
    while (1);
    lanes && root.shellSuspendCounter++;
    $5c00e1cb1faeed50$var$lastContextDependency = $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 = null;
    $5c00e1cb1faeed50$var$executionContext = prevExecutionContext;
    $5c00e1cb1faeed50$var$ReactSharedInternals.H = prevDispatcher;
    $5c00e1cb1faeed50$var$ReactSharedInternals.A = prevAsyncDispatcher;
    null === $5c00e1cb1faeed50$var$workInProgress && ($5c00e1cb1faeed50$var$workInProgressRoot = null, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes = 0, $5c00e1cb1faeed50$var$finishQueueingConcurrentUpdates());
    return exitStatus;
}
function $5c00e1cb1faeed50$var$workLoopSync() {
    for(; null !== $5c00e1cb1faeed50$var$workInProgress;)$5c00e1cb1faeed50$var$performUnitOfWork($5c00e1cb1faeed50$var$workInProgress);
}
function $5c00e1cb1faeed50$var$renderRootConcurrent(root, lanes) {
    var prevExecutionContext = $5c00e1cb1faeed50$var$executionContext;
    $5c00e1cb1faeed50$var$executionContext |= 2;
    var prevDispatcher = $5c00e1cb1faeed50$var$pushDispatcher(), prevAsyncDispatcher = $5c00e1cb1faeed50$var$pushAsyncDispatcher();
    $5c00e1cb1faeed50$var$workInProgressRoot !== root || $5c00e1cb1faeed50$var$workInProgressRootRenderLanes !== lanes ? ($5c00e1cb1faeed50$var$workInProgressTransitions = null, $5c00e1cb1faeed50$var$workInProgressRootRenderTargetTime = $5c00e1cb1faeed50$var$now() + 500, $5c00e1cb1faeed50$var$prepareFreshStack(root, lanes)) : $5c00e1cb1faeed50$var$workInProgressRootIsPrerendering = $5c00e1cb1faeed50$var$checkIfRootIsPrerendering(root, lanes);
    a: do try {
        if (0 !== $5c00e1cb1faeed50$var$workInProgressSuspendedReason && null !== $5c00e1cb1faeed50$var$workInProgress) {
            lanes = $5c00e1cb1faeed50$var$workInProgress;
            var thrownValue = $5c00e1cb1faeed50$var$workInProgressThrownValue;
            b: switch($5c00e1cb1faeed50$var$workInProgressSuspendedReason){
                case 1:
                    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
                    $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
                    $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 1);
                    break;
                case 2:
                case 9:
                    if ($5c00e1cb1faeed50$var$isThenableResolved(thrownValue)) {
                        $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
                        $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
                        $5c00e1cb1faeed50$var$replaySuspendedUnitOfWork(lanes);
                        break;
                    }
                    lanes = function() {
                        2 !== $5c00e1cb1faeed50$var$workInProgressSuspendedReason && 9 !== $5c00e1cb1faeed50$var$workInProgressSuspendedReason || $5c00e1cb1faeed50$var$workInProgressRoot !== root || ($5c00e1cb1faeed50$var$workInProgressSuspendedReason = 7);
                        $5c00e1cb1faeed50$var$ensureRootIsScheduled(root);
                    };
                    thrownValue.then(lanes, lanes);
                    break a;
                case 3:
                    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 7;
                    break a;
                case 4:
                    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 5;
                    break a;
                case 7:
                    $5c00e1cb1faeed50$var$isThenableResolved(thrownValue) ? ($5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0, $5c00e1cb1faeed50$var$workInProgressThrownValue = null, $5c00e1cb1faeed50$var$replaySuspendedUnitOfWork(lanes)) : ($5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0, $5c00e1cb1faeed50$var$workInProgressThrownValue = null, $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 7));
                    break;
                case 5:
                    var resource = null;
                    switch($5c00e1cb1faeed50$var$workInProgress.tag){
                        case 26:
                            resource = $5c00e1cb1faeed50$var$workInProgress.memoizedState;
                        case 5:
                        case 27:
                            var hostFiber = $5c00e1cb1faeed50$var$workInProgress;
                            if (resource ? $5c00e1cb1faeed50$var$preloadResource(resource) : hostFiber.stateNode.complete) {
                                $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
                                $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
                                var sibling = hostFiber.sibling;
                                if (null !== sibling) $5c00e1cb1faeed50$var$workInProgress = sibling;
                                else {
                                    var returnFiber = hostFiber.return;
                                    null !== returnFiber ? ($5c00e1cb1faeed50$var$workInProgress = returnFiber, $5c00e1cb1faeed50$var$completeUnitOfWork(returnFiber)) : $5c00e1cb1faeed50$var$workInProgress = null;
                                }
                                break b;
                            }
                    }
                    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
                    $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
                    $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 5);
                    break;
                case 6:
                    $5c00e1cb1faeed50$var$workInProgressSuspendedReason = 0;
                    $5c00e1cb1faeed50$var$workInProgressThrownValue = null;
                    $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, lanes, thrownValue, 6);
                    break;
                case 8:
                    $5c00e1cb1faeed50$var$resetWorkInProgressStack();
                    $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 6;
                    break a;
                default:
                    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(462));
            }
        }
        $5c00e1cb1faeed50$var$workLoopConcurrentByScheduler();
        break;
    } catch (thrownValue$186) {
        $5c00e1cb1faeed50$var$handleThrow(root, thrownValue$186);
    }
    while (1);
    $5c00e1cb1faeed50$var$lastContextDependency = $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 = null;
    $5c00e1cb1faeed50$var$ReactSharedInternals.H = prevDispatcher;
    $5c00e1cb1faeed50$var$ReactSharedInternals.A = prevAsyncDispatcher;
    $5c00e1cb1faeed50$var$executionContext = prevExecutionContext;
    if (null !== $5c00e1cb1faeed50$var$workInProgress) return 0;
    $5c00e1cb1faeed50$var$workInProgressRoot = null;
    $5c00e1cb1faeed50$var$workInProgressRootRenderLanes = 0;
    $5c00e1cb1faeed50$var$finishQueueingConcurrentUpdates();
    return $5c00e1cb1faeed50$var$workInProgressRootExitStatus;
}
function $5c00e1cb1faeed50$var$workLoopConcurrentByScheduler() {
    for(; null !== $5c00e1cb1faeed50$var$workInProgress && !$5c00e1cb1faeed50$var$shouldYield();)$5c00e1cb1faeed50$var$performUnitOfWork($5c00e1cb1faeed50$var$workInProgress);
}
function $5c00e1cb1faeed50$var$performUnitOfWork(unitOfWork) {
    var next = $5c00e1cb1faeed50$var$beginWork(unitOfWork.alternate, unitOfWork, $5c00e1cb1faeed50$var$entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $5c00e1cb1faeed50$var$completeUnitOfWork(unitOfWork) : $5c00e1cb1faeed50$var$workInProgress = next;
}
function $5c00e1cb1faeed50$var$replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current = next.alternate;
    switch(next.tag){
        case 15:
        case 0:
            next = $5c00e1cb1faeed50$var$replayFunctionComponent(current, next, next.pendingProps, next.type, void 0, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes);
            break;
        case 11:
            next = $5c00e1cb1faeed50$var$replayFunctionComponent(current, next, next.pendingProps, next.type.render, next.ref, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes);
            break;
        case 5:
            $5c00e1cb1faeed50$var$resetHooksOnUnwind(next);
            var fiber = next;
            fiber === $5c00e1cb1faeed50$var$hydrationParentFiber && ($5c00e1cb1faeed50$var$isHydrating ? ($5c00e1cb1faeed50$var$popToNextHostParent(fiber), 5 === fiber.tag && null != fiber.stateNode && ($5c00e1cb1faeed50$var$nextHydratableInstance = fiber.stateNode)) : ($5c00e1cb1faeed50$var$popToNextHostParent(fiber), $5c00e1cb1faeed50$var$isHydrating = !0));
        default:
            $5c00e1cb1faeed50$var$unwindInterruptedWork(current, next), next = $5c00e1cb1faeed50$var$workInProgress = $5c00e1cb1faeed50$var$resetWorkInProgress(next, $5c00e1cb1faeed50$var$entangledRenderLanes), next = $5c00e1cb1faeed50$var$beginWork(current, next, $5c00e1cb1faeed50$var$entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? $5c00e1cb1faeed50$var$completeUnitOfWork(unitOfWork) : $5c00e1cb1faeed50$var$workInProgress = next;
}
function $5c00e1cb1faeed50$var$throwAndUnwindWorkLoop(root, unitOfWork, thrownValue, suspendedReason) {
    $5c00e1cb1faeed50$var$lastContextDependency = $5c00e1cb1faeed50$var$currentlyRenderingFiber$1 = null;
    $5c00e1cb1faeed50$var$resetHooksOnUnwind(unitOfWork);
    $5c00e1cb1faeed50$var$thenableState$1 = null;
    $5c00e1cb1faeed50$var$thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
        if ($5c00e1cb1faeed50$var$throwException(root, returnFiber, unitOfWork, thrownValue, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes)) {
            $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 1;
            $5c00e1cb1faeed50$var$logUncaughtError(root, $5c00e1cb1faeed50$var$createCapturedValueAtFiber(thrownValue, root.current));
            $5c00e1cb1faeed50$var$workInProgress = null;
            return;
        }
    } catch (error) {
        if (null !== returnFiber) throw $5c00e1cb1faeed50$var$workInProgress = returnFiber, error;
        $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 1;
        $5c00e1cb1faeed50$var$logUncaughtError(root, $5c00e1cb1faeed50$var$createCapturedValueAtFiber(thrownValue, root.current));
        $5c00e1cb1faeed50$var$workInProgress = null;
        return;
    }
    if (unitOfWork.flags & 32768) {
        if ($5c00e1cb1faeed50$var$isHydrating || 1 === suspendedReason) root = !0;
        else if ($5c00e1cb1faeed50$var$workInProgressRootIsPrerendering || 0 !== ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 536870912)) root = !1;
        else if ($5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings = root = !0, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason) suspendedReason = $5c00e1cb1faeed50$var$suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        $5c00e1cb1faeed50$var$unwindUnitOfWork(unitOfWork, root);
    } else $5c00e1cb1faeed50$var$completeUnitOfWork(unitOfWork);
}
function $5c00e1cb1faeed50$var$completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
        if (0 !== (completedWork.flags & 32768)) {
            $5c00e1cb1faeed50$var$unwindUnitOfWork(completedWork, $5c00e1cb1faeed50$var$workInProgressRootDidSkipSuspendedSiblings);
            return;
        }
        unitOfWork = completedWork.return;
        var next = $5c00e1cb1faeed50$var$completeWork(completedWork.alternate, completedWork, $5c00e1cb1faeed50$var$entangledRenderLanes);
        if (null !== next) {
            $5c00e1cb1faeed50$var$workInProgress = next;
            return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
            $5c00e1cb1faeed50$var$workInProgress = completedWork;
            return;
        }
        $5c00e1cb1faeed50$var$workInProgress = completedWork = unitOfWork;
    }while (null !== completedWork);
    0 === $5c00e1cb1faeed50$var$workInProgressRootExitStatus && ($5c00e1cb1faeed50$var$workInProgressRootExitStatus = 5);
}
function $5c00e1cb1faeed50$var$unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
        var next = $5c00e1cb1faeed50$var$unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
            next.flags &= 32767;
            $5c00e1cb1faeed50$var$workInProgress = next;
            return;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
            $5c00e1cb1faeed50$var$workInProgress = unitOfWork;
            return;
        }
        $5c00e1cb1faeed50$var$workInProgress = unitOfWork = next;
    }while (null !== unitOfWork);
    $5c00e1cb1faeed50$var$workInProgressRootExitStatus = 6;
    $5c00e1cb1faeed50$var$workInProgress = null;
}
function $5c00e1cb1faeed50$var$completeRoot(root, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedState) {
    root.cancelPendingCommit = null;
    do $5c00e1cb1faeed50$var$flushPendingEffects();
    while (0 !== $5c00e1cb1faeed50$var$pendingEffectsStatus);
    if (0 !== ($5c00e1cb1faeed50$var$executionContext & 6)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(327));
    if (null !== finishedWork) {
        if (finishedWork === root.current) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(177));
        root === $5c00e1cb1faeed50$var$workInProgressRoot && ($5c00e1cb1faeed50$var$workInProgress = $5c00e1cb1faeed50$var$workInProgressRoot = null, $5c00e1cb1faeed50$var$workInProgressRootRenderLanes = 0);
        $5c00e1cb1faeed50$var$pendingFinishedWork = finishedWork;
        $5c00e1cb1faeed50$var$pendingEffectsRoot = root;
        $5c00e1cb1faeed50$var$pendingEffectsLanes = lanes;
        $5c00e1cb1faeed50$var$pendingPassiveTransitions = transitions;
        $5c00e1cb1faeed50$var$pendingRecoverableErrors = recoverableErrors;
        $5c00e1cb1faeed50$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState);
    }
}
function $5c00e1cb1faeed50$var$commitRoot(root, finishedWork, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, suspendedState) {
    var remainingLanes = finishedWork.lanes | finishedWork.childLanes;
    $5c00e1cb1faeed50$var$pendingEffectsRemainingLanes = remainingLanes;
    remainingLanes |= $5c00e1cb1faeed50$var$concurrentlyUpdatedLanes;
    $5c00e1cb1faeed50$var$markRootFinished(root, lanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes);
    $5c00e1cb1faeed50$var$pendingViewTransitionEvents = null;
    (lanes & 335544064) === lanes ? ($5c00e1cb1faeed50$var$pendingTransitionTypes = $5c00e1cb1faeed50$var$claimQueuedTransitionTypes(root), spawnedLane = 10262) : ($5c00e1cb1faeed50$var$pendingTransitionTypes = null, spawnedLane = 10256);
    0 !== (finishedWork.subtreeFlags & spawnedLane) || 0 !== (finishedWork.flags & spawnedLane) ? (root.callbackNode = null, root.callbackPriority = 0, $5c00e1cb1faeed50$var$scheduleCallback$1($5c00e1cb1faeed50$var$NormalPriority$1, function() {
        $5c00e1cb1faeed50$var$flushPassiveEffects();
        return null;
    })) : (root.callbackNode = null, root.callbackPriority = 0);
    $5c00e1cb1faeed50$var$shouldStartViewTransition = !1;
    spawnedLane = 0 !== (finishedWork.flags & 13878);
    if (0 !== (finishedWork.subtreeFlags & 13878) || spawnedLane) {
        spawnedLane = $5c00e1cb1faeed50$var$ReactSharedInternals.T;
        $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
        updatedLanes = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 2;
        suspendedRetryLanes = $5c00e1cb1faeed50$var$executionContext;
        $5c00e1cb1faeed50$var$executionContext |= 4;
        try {
            $5c00e1cb1faeed50$var$commitBeforeMutationEffects(root, finishedWork, lanes);
        } finally{
            $5c00e1cb1faeed50$var$executionContext = suspendedRetryLanes, $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = updatedLanes, $5c00e1cb1faeed50$var$ReactSharedInternals.T = spawnedLane;
        }
    }
    $5c00e1cb1faeed50$var$pendingEffectsStatus = 1;
    $5c00e1cb1faeed50$var$shouldStartViewTransition ? $5c00e1cb1faeed50$var$pendingViewTransition = $5c00e1cb1faeed50$var$startViewTransition(suspendedState, root.containerInfo, $5c00e1cb1faeed50$var$pendingTransitionTypes, $5c00e1cb1faeed50$var$flushMutationEffects, $5c00e1cb1faeed50$var$flushLayoutEffects, $5c00e1cb1faeed50$var$flushAfterMutationEffects, $5c00e1cb1faeed50$var$flushSpawnedWork, $5c00e1cb1faeed50$var$flushPassiveEffects, $5c00e1cb1faeed50$var$reportViewTransitionError, null, null) : ($5c00e1cb1faeed50$var$flushMutationEffects(), $5c00e1cb1faeed50$var$flushLayoutEffects(), $5c00e1cb1faeed50$var$flushSpawnedWork());
}
function $5c00e1cb1faeed50$var$reportViewTransitionError(error) {
    if (0 !== $5c00e1cb1faeed50$var$pendingEffectsStatus) {
        var onRecoverableError = $5c00e1cb1faeed50$var$pendingEffectsRoot.onRecoverableError;
        onRecoverableError(error, {
            componentStack: null
        });
    }
}
function $5c00e1cb1faeed50$var$flushAfterMutationEffects() {
    3 === $5c00e1cb1faeed50$var$pendingEffectsStatus && ($5c00e1cb1faeed50$var$pendingEffectsStatus = 0, $5c00e1cb1faeed50$var$commitAfterMutationEffectsOnFiber($5c00e1cb1faeed50$var$pendingFinishedWork, $5c00e1cb1faeed50$var$pendingEffectsRoot), $5c00e1cb1faeed50$var$pendingEffectsStatus = 4);
}
function $5c00e1cb1faeed50$var$flushMutationEffects() {
    if (1 === $5c00e1cb1faeed50$var$pendingEffectsStatus) {
        $5c00e1cb1faeed50$var$pendingEffectsStatus = 0;
        var root = $5c00e1cb1faeed50$var$pendingEffectsRoot, finishedWork = $5c00e1cb1faeed50$var$pendingFinishedWork, lanes = $5c00e1cb1faeed50$var$pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
            rootMutationHasEffect = $5c00e1cb1faeed50$var$ReactSharedInternals.T;
            $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
            var previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
            $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $5c00e1cb1faeed50$var$executionContext;
            $5c00e1cb1faeed50$var$executionContext |= 4;
            try {
                $5c00e1cb1faeed50$var$inUpdateViewTransition = $5c00e1cb1faeed50$var$rootViewTransitionAffected = !1;
                $5c00e1cb1faeed50$var$commitMutationEffectsOnFiber(finishedWork, root, lanes);
                lanes = $5c00e1cb1faeed50$var$selectionInformation;
                var curFocusedElem = $5c00e1cb1faeed50$var$getActiveElementDeep(root.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
                if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && $5c00e1cb1faeed50$var$containsNode(priorFocusedElem.ownerDocument.documentElement, priorFocusedElem)) {
                    if (null !== priorSelectionRange && $5c00e1cb1faeed50$var$hasSelectionCapabilities(priorFocusedElem)) {
                        var start = priorSelectionRange.start, end = priorSelectionRange.end;
                        void 0 === end && (end = start);
                        if ("selectionStart" in priorFocusedElem) priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(end, priorFocusedElem.value.length);
                        else {
                            var doc = priorFocusedElem.ownerDocument || document, win = doc && doc.defaultView || window;
                            if (win.getSelection) {
                                var selection = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                                !selection.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                                var startMarker = $5c00e1cb1faeed50$var$getNodeForCharacterOffset(priorFocusedElem, start$jscomp$0), endMarker = $5c00e1cb1faeed50$var$getNodeForCharacterOffset(priorFocusedElem, end$jscomp$0);
                                if (startMarker && endMarker && (1 !== selection.rangeCount || selection.anchorNode !== startMarker.node || selection.anchorOffset !== startMarker.offset || selection.focusNode !== endMarker.node || selection.focusOffset !== endMarker.offset)) {
                                    var range = doc.createRange();
                                    range.setStart(startMarker.node, startMarker.offset);
                                    selection.removeAllRanges();
                                    start$jscomp$0 > end$jscomp$0 ? (selection.addRange(range), selection.extend(endMarker.node, endMarker.offset)) : (range.setEnd(endMarker.node, endMarker.offset), selection.addRange(range));
                                }
                            }
                        }
                    }
                    doc = [];
                    for(selection = priorFocusedElem; selection = selection.parentNode;)1 === selection.nodeType && doc.push({
                        element: selection,
                        left: selection.scrollLeft,
                        top: selection.scrollTop
                    });
                    "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
                    for(priorFocusedElem = 0; priorFocusedElem < doc.length; priorFocusedElem++){
                        var info = doc[priorFocusedElem];
                        info.element.scrollLeft = info.left;
                        info.element.scrollTop = info.top;
                    }
                }
                $5c00e1cb1faeed50$var$_enabled = !!$5c00e1cb1faeed50$var$eventsEnabled;
                $5c00e1cb1faeed50$var$selectionInformation = $5c00e1cb1faeed50$var$eventsEnabled = null;
            } finally{
                $5c00e1cb1faeed50$var$executionContext = prevExecutionContext, $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority, $5c00e1cb1faeed50$var$ReactSharedInternals.T = rootMutationHasEffect;
            }
        }
        root.current = finishedWork;
        $5c00e1cb1faeed50$var$pendingEffectsStatus = 2;
    }
}
function $5c00e1cb1faeed50$var$flushLayoutEffects() {
    if (2 === $5c00e1cb1faeed50$var$pendingEffectsStatus) {
        $5c00e1cb1faeed50$var$pendingEffectsStatus = 0;
        var root = $5c00e1cb1faeed50$var$pendingEffectsRoot, finishedWork = $5c00e1cb1faeed50$var$pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
        if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
            rootHasLayoutEffect = $5c00e1cb1faeed50$var$ReactSharedInternals.T;
            $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
            var previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
            $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 2;
            var prevExecutionContext = $5c00e1cb1faeed50$var$executionContext;
            $5c00e1cb1faeed50$var$executionContext |= 4;
            try {
                $5c00e1cb1faeed50$var$commitLayoutEffectOnFiber(root, finishedWork.alternate, finishedWork);
            } finally{
                $5c00e1cb1faeed50$var$executionContext = prevExecutionContext, $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority, $5c00e1cb1faeed50$var$ReactSharedInternals.T = rootHasLayoutEffect;
            }
        }
        $5c00e1cb1faeed50$var$pendingEffectsStatus = 3;
    }
}
function $5c00e1cb1faeed50$var$flushSpawnedWork() {
    if (4 === $5c00e1cb1faeed50$var$pendingEffectsStatus || 3 === $5c00e1cb1faeed50$var$pendingEffectsStatus) {
        $5c00e1cb1faeed50$var$pendingEffectsStatus = 0;
        var committedViewTransition = $5c00e1cb1faeed50$var$pendingViewTransition;
        $5c00e1cb1faeed50$var$pendingViewTransition = null;
        $5c00e1cb1faeed50$var$requestPaint();
        var root = $5c00e1cb1faeed50$var$pendingEffectsRoot, finishedWork = $5c00e1cb1faeed50$var$pendingFinishedWork, lanes = $5c00e1cb1faeed50$var$pendingEffectsLanes, recoverableErrors = $5c00e1cb1faeed50$var$pendingRecoverableErrors, passiveSubtreeMask = (lanes & 335544064) === lanes ? 10262 : 10256;
        0 !== (finishedWork.subtreeFlags & passiveSubtreeMask) || 0 !== (finishedWork.flags & passiveSubtreeMask) ? $5c00e1cb1faeed50$var$pendingEffectsStatus = 5 : ($5c00e1cb1faeed50$var$pendingEffectsStatus = 0, $5c00e1cb1faeed50$var$pendingFinishedWork = $5c00e1cb1faeed50$var$pendingEffectsRoot = null, $5c00e1cb1faeed50$var$releaseRootPooledCache(root, root.pendingLanes));
        passiveSubtreeMask = root.pendingLanes;
        0 === passiveSubtreeMask && ($5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed = null);
        $5c00e1cb1faeed50$var$lanesToEventPriority(lanes);
        finishedWork = finishedWork.stateNode;
        if ($5c00e1cb1faeed50$var$injectedHook && "function" === typeof $5c00e1cb1faeed50$var$injectedHook.onCommitFiberRoot) try {
            $5c00e1cb1faeed50$var$injectedHook.onCommitFiberRoot($5c00e1cb1faeed50$var$rendererID, finishedWork, void 0, 128 === (finishedWork.current.flags & 128));
        } catch (err) {}
        if (null !== recoverableErrors) {
            finishedWork = $5c00e1cb1faeed50$var$ReactSharedInternals.T;
            passiveSubtreeMask = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
            $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 2;
            $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
            try {
                for(var onRecoverableError = root.onRecoverableError, i = 0; i < recoverableErrors.length; i++){
                    var recoverableError = recoverableErrors[i];
                    onRecoverableError(recoverableError.value, {
                        componentStack: recoverableError.stack
                    });
                }
            } finally{
                $5c00e1cb1faeed50$var$ReactSharedInternals.T = finishedWork, $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = passiveSubtreeMask;
            }
        }
        recoverableErrors = $5c00e1cb1faeed50$var$pendingViewTransitionEvents;
        onRecoverableError = $5c00e1cb1faeed50$var$pendingTransitionTypes;
        $5c00e1cb1faeed50$var$pendingTransitionTypes = null;
        if (null !== recoverableErrors && ($5c00e1cb1faeed50$var$pendingViewTransitionEvents = null, null === onRecoverableError && (onRecoverableError = []), null !== committedViewTransition)) for(recoverableError = 0; recoverableError < recoverableErrors.length; recoverableError++)finishedWork = (0, recoverableErrors[recoverableError])(onRecoverableError), void 0 !== finishedWork && committedViewTransition.finished.finally(finishedWork);
        0 !== ($5c00e1cb1faeed50$var$pendingEffectsLanes & 3) && $5c00e1cb1faeed50$var$flushPendingEffects();
        $5c00e1cb1faeed50$var$ensureRootIsScheduled(root);
        passiveSubtreeMask = root.pendingLanes;
        0 !== (lanes & 261930) && 0 !== (passiveSubtreeMask & 42) ? root === $5c00e1cb1faeed50$var$rootWithNestedUpdates ? $5c00e1cb1faeed50$var$nestedUpdateCount++ : ($5c00e1cb1faeed50$var$nestedUpdateCount = 0, $5c00e1cb1faeed50$var$rootWithNestedUpdates = root) : ($5c00e1cb1faeed50$var$nestedUpdateCount = 0, $5c00e1cb1faeed50$var$rootWithNestedUpdates = null);
        $5c00e1cb1faeed50$var$flushSyncWorkAcrossRoots_impl(0, !1);
    }
}
function $5c00e1cb1faeed50$var$releaseRootPooledCache(root, remainingLanes) {
    0 === (root.pooledCacheLanes &= remainingLanes) && (remainingLanes = root.pooledCache, null != remainingLanes && (root.pooledCache = null, $5c00e1cb1faeed50$var$releaseCache(remainingLanes)));
}
function $5c00e1cb1faeed50$var$flushPendingEffects() {
    null !== $5c00e1cb1faeed50$var$pendingViewTransition && ($5c00e1cb1faeed50$var$pendingViewTransition.skipTransition(), $5c00e1cb1faeed50$var$pendingViewTransition = null);
    $5c00e1cb1faeed50$var$flushMutationEffects();
    $5c00e1cb1faeed50$var$flushLayoutEffects();
    $5c00e1cb1faeed50$var$flushSpawnedWork();
    return $5c00e1cb1faeed50$var$flushPassiveEffects();
}
function $5c00e1cb1faeed50$var$flushPassiveEffects() {
    if (5 !== $5c00e1cb1faeed50$var$pendingEffectsStatus) return !1;
    var root = $5c00e1cb1faeed50$var$pendingEffectsRoot, remainingLanes = $5c00e1cb1faeed50$var$pendingEffectsRemainingLanes;
    $5c00e1cb1faeed50$var$pendingEffectsRemainingLanes = 0;
    var renderPriority = $5c00e1cb1faeed50$var$lanesToEventPriority($5c00e1cb1faeed50$var$pendingEffectsLanes), prevTransition = $5c00e1cb1faeed50$var$ReactSharedInternals.T, previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
    try {
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
        $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
        renderPriority = $5c00e1cb1faeed50$var$pendingPassiveTransitions;
        $5c00e1cb1faeed50$var$pendingPassiveTransitions = null;
        var root$jscomp$0 = $5c00e1cb1faeed50$var$pendingEffectsRoot, lanes = $5c00e1cb1faeed50$var$pendingEffectsLanes;
        $5c00e1cb1faeed50$var$pendingEffectsStatus = 0;
        $5c00e1cb1faeed50$var$pendingFinishedWork = $5c00e1cb1faeed50$var$pendingEffectsRoot = null;
        $5c00e1cb1faeed50$var$pendingEffectsLanes = 0;
        if (0 !== ($5c00e1cb1faeed50$var$executionContext & 6)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(331));
        var prevExecutionContext = $5c00e1cb1faeed50$var$executionContext;
        $5c00e1cb1faeed50$var$executionContext |= 4;
        $5c00e1cb1faeed50$var$commitPassiveUnmountOnFiber(root$jscomp$0.current);
        $5c00e1cb1faeed50$var$commitPassiveMountOnFiber(root$jscomp$0, root$jscomp$0.current, lanes, renderPriority);
        $5c00e1cb1faeed50$var$executionContext = prevExecutionContext;
        $5c00e1cb1faeed50$var$flushSyncWorkAcrossRoots_impl(0, !1);
        if ($5c00e1cb1faeed50$var$injectedHook && "function" === typeof $5c00e1cb1faeed50$var$injectedHook.onPostCommitFiberRoot) try {
            $5c00e1cb1faeed50$var$injectedHook.onPostCommitFiberRoot($5c00e1cb1faeed50$var$rendererID, root$jscomp$0);
        } catch (err) {}
        return !0;
    } finally{
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority, $5c00e1cb1faeed50$var$ReactSharedInternals.T = prevTransition, $5c00e1cb1faeed50$var$releaseRootPooledCache(root, remainingLanes);
    }
}
function $5c00e1cb1faeed50$var$captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = $5c00e1cb1faeed50$var$createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = $5c00e1cb1faeed50$var$createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = $5c00e1cb1faeed50$var$enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && ($5c00e1cb1faeed50$var$markRootUpdated$1(rootFiber, 2), $5c00e1cb1faeed50$var$ensureRootIsScheduled(rootFiber));
}
function $5c00e1cb1faeed50$var$captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag) $5c00e1cb1faeed50$var$captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else for(; null !== nearestMountedAncestor;){
        if (3 === nearestMountedAncestor.tag) {
            $5c00e1cb1faeed50$var$captureCommitPhaseErrorOnRoot(nearestMountedAncestor, sourceFiber, error);
            break;
        } else if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === $5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed || !$5c00e1cb1faeed50$var$legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
                sourceFiber = $5c00e1cb1faeed50$var$createCapturedValueAtFiber(error, sourceFiber);
                error = $5c00e1cb1faeed50$var$createClassErrorUpdate(2);
                instance = $5c00e1cb1faeed50$var$enqueueUpdate(nearestMountedAncestor, error, 2);
                null !== instance && ($5c00e1cb1faeed50$var$initializeClassErrorUpdate(error, instance, nearestMountedAncestor, sourceFiber), $5c00e1cb1faeed50$var$markRootUpdated$1(instance, 2), $5c00e1cb1faeed50$var$ensureRootIsScheduled(instance));
                break;
            }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
    }
}
function $5c00e1cb1faeed50$var$attachPingListener(root, wakeable, lanes) {
    var pingCache = root.pingCache;
    if (null === pingCache) {
        pingCache = root.pingCache = new $5c00e1cb1faeed50$var$PossiblyWeakMap();
        var threadIDs = new Set();
        pingCache.set(wakeable, threadIDs);
    } else threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || ($5c00e1cb1faeed50$var$workInProgressRootDidAttachPingListener = !0, threadIDs.add(lanes), root = $5c00e1cb1faeed50$var$pingSuspendedRoot.bind(null, root, wakeable, lanes), wakeable.then(root, root));
}
function $5c00e1cb1faeed50$var$pingSuspendedRoot(root, wakeable, pingedLanes) {
    var pingCache = root.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root.pingedLanes |= root.suspendedLanes & pingedLanes;
    root.warmLanes &= ~pingedLanes;
    $5c00e1cb1faeed50$var$workInProgressRoot === root && ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === $5c00e1cb1faeed50$var$workInProgressRootExitStatus || 3 === $5c00e1cb1faeed50$var$workInProgressRootExitStatus && ($5c00e1cb1faeed50$var$workInProgressRootRenderLanes & 62914560) === $5c00e1cb1faeed50$var$workInProgressRootRenderLanes && 300 > $5c00e1cb1faeed50$var$now() - $5c00e1cb1faeed50$var$globalMostRecentFallbackTime ? 0 === ($5c00e1cb1faeed50$var$executionContext & 2) ? $5c00e1cb1faeed50$var$prepareFreshStack(root, 0) : $5c00e1cb1faeed50$var$workInProgressRootPingedLanes |= pingedLanes : $5c00e1cb1faeed50$var$workInProgressRootPingedLanes |= pingedLanes, $5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes === $5c00e1cb1faeed50$var$workInProgressRootRenderLanes && ($5c00e1cb1faeed50$var$workInProgressSuspendedRetryLanes = 0));
    $5c00e1cb1faeed50$var$ensureRootIsScheduled(root);
}
function $5c00e1cb1faeed50$var$retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = $5c00e1cb1faeed50$var$claimNextRetryLane());
    boundaryFiber = $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && ($5c00e1cb1faeed50$var$markRootUpdated$1(boundaryFiber, retryLane), $5c00e1cb1faeed50$var$ensureRootIsScheduled(boundaryFiber));
}
function $5c00e1cb1faeed50$var$retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    $5c00e1cb1faeed50$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $5c00e1cb1faeed50$var$resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch(boundaryFiber.tag){
        case 31:
        case 13:
            var retryCache = boundaryFiber.stateNode;
            var suspenseState = boundaryFiber.memoizedState;
            null !== suspenseState && (retryLane = suspenseState.retryLane);
            break;
        case 19:
            retryCache = boundaryFiber.stateNode;
            break;
        case 22:
            retryCache = boundaryFiber.stateNode._retryCache;
            break;
        default:
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    $5c00e1cb1faeed50$var$retryTimedOutBoundary(boundaryFiber, retryLane);
}
function $5c00e1cb1faeed50$var$scheduleCallback$1(priorityLevel, callback) {
    return $5c00e1cb1faeed50$var$scheduleCallback$3(priorityLevel, callback);
}
var $5c00e1cb1faeed50$var$firstScheduledRoot = null, $5c00e1cb1faeed50$var$lastScheduledRoot = null, $5c00e1cb1faeed50$var$didScheduleMicrotask = !1, $5c00e1cb1faeed50$var$mightHavePendingSyncWork = !1, $5c00e1cb1faeed50$var$isFlushingWork = !1, $5c00e1cb1faeed50$var$currentEventTransitionLane = 0;
function $5c00e1cb1faeed50$var$ensureRootIsScheduled(root) {
    root !== $5c00e1cb1faeed50$var$lastScheduledRoot && null === root.next && (null === $5c00e1cb1faeed50$var$lastScheduledRoot ? $5c00e1cb1faeed50$var$firstScheduledRoot = $5c00e1cb1faeed50$var$lastScheduledRoot = root : $5c00e1cb1faeed50$var$lastScheduledRoot = $5c00e1cb1faeed50$var$lastScheduledRoot.next = root);
    $5c00e1cb1faeed50$var$mightHavePendingSyncWork = !0;
    $5c00e1cb1faeed50$var$didScheduleMicrotask || ($5c00e1cb1faeed50$var$didScheduleMicrotask = !0, $5c00e1cb1faeed50$var$scheduleImmediateRootScheduleTask());
}
function $5c00e1cb1faeed50$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!$5c00e1cb1faeed50$var$isFlushingWork && $5c00e1cb1faeed50$var$mightHavePendingSyncWork) {
        $5c00e1cb1faeed50$var$isFlushingWork = !0;
        do {
            var didPerformSomeWork = !1;
            for(var root$190 = $5c00e1cb1faeed50$var$firstScheduledRoot; null !== root$190;){
                if (!onlyLegacy) {
                    if (0 !== syncTransitionLanes) {
                        var pendingLanes = root$190.pendingLanes;
                        if (0 === pendingLanes) var JSCompiler_inline_result = 0;
                        else {
                            var suspendedLanes = root$190.suspendedLanes, pingedLanes = root$190.pingedLanes;
                            JSCompiler_inline_result = (1 << 31 - $5c00e1cb1faeed50$var$clz32(42 | syncTransitionLanes) + 1) - 1;
                            JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                            JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
                        }
                        0 !== JSCompiler_inline_result && (didPerformSomeWork = !0, $5c00e1cb1faeed50$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                    } else JSCompiler_inline_result = $5c00e1cb1faeed50$var$workInProgressRootRenderLanes, JSCompiler_inline_result = $5c00e1cb1faeed50$var$getNextLanes(root$190, root$190 === $5c00e1cb1faeed50$var$workInProgressRoot ? JSCompiler_inline_result : 0, null !== root$190.cancelPendingCommit || -1 !== root$190.timeoutHandle), 0 === (JSCompiler_inline_result & 3) || $5c00e1cb1faeed50$var$checkIfRootIsPrerendering(root$190, JSCompiler_inline_result) || (didPerformSomeWork = !0, $5c00e1cb1faeed50$var$performSyncWorkOnRoot(root$190, JSCompiler_inline_result));
                }
                root$190 = root$190.next;
            }
        }while (didPerformSomeWork);
        $5c00e1cb1faeed50$var$isFlushingWork = !1;
    }
}
function $5c00e1cb1faeed50$var$processRootScheduleInImmediateTask() {
    $5c00e1cb1faeed50$var$processRootScheduleInMicrotask();
}
function $5c00e1cb1faeed50$var$processRootScheduleInMicrotask() {
    $5c00e1cb1faeed50$var$mightHavePendingSyncWork = $5c00e1cb1faeed50$var$didScheduleMicrotask = !1;
    var syncTransitionLanes = 0;
    0 !== $5c00e1cb1faeed50$var$currentEventTransitionLane && $5c00e1cb1faeed50$var$shouldAttemptEagerTransition() && (syncTransitionLanes = $5c00e1cb1faeed50$var$currentEventTransitionLane);
    for(var currentTime = $5c00e1cb1faeed50$var$now(), prev = null, root = $5c00e1cb1faeed50$var$firstScheduledRoot; null !== root;){
        var next = root.next, nextLanes = $5c00e1cb1faeed50$var$scheduleTaskForRootDuringMicrotask(root, currentTime);
        if (0 === nextLanes) root.next = null, null === prev ? $5c00e1cb1faeed50$var$firstScheduledRoot = next : prev.next = next, null === next && ($5c00e1cb1faeed50$var$lastScheduledRoot = prev);
        else if (prev = root, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3)) $5c00e1cb1faeed50$var$mightHavePendingSyncWork = !0;
        root = next;
    }
    0 !== $5c00e1cb1faeed50$var$pendingEffectsStatus && 5 !== $5c00e1cb1faeed50$var$pendingEffectsStatus || $5c00e1cb1faeed50$var$flushSyncWorkAcrossRoots_impl(syncTransitionLanes, !1);
    0 !== $5c00e1cb1faeed50$var$currentEventTransitionLane && ($5c00e1cb1faeed50$var$currentEventTransitionLane = 0);
}
function $5c00e1cb1faeed50$var$scheduleTaskForRootDuringMicrotask(root, currentTime) {
    for(var suspendedLanes = root.suspendedLanes, pingedLanes = root.pingedLanes, expirationTimes = root.expirationTimes, lanes = root.pendingLanes & -62914561; 0 < lanes;){
        var index$5 = 31 - $5c00e1cb1faeed50$var$clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
        if (-1 === expirationTime) {
            if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes)) expirationTimes[index$5] = $5c00e1cb1faeed50$var$computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root.expiredLanes |= lane);
        lanes &= ~lane;
    }
    currentTime = $5c00e1cb1faeed50$var$workInProgressRoot;
    suspendedLanes = $5c00e1cb1faeed50$var$workInProgressRootRenderLanes;
    suspendedLanes = $5c00e1cb1faeed50$var$getNextLanes(root, root === currentTime ? suspendedLanes : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    pingedLanes = root.callbackNode;
    if (0 === suspendedLanes || root === currentTime && (2 === $5c00e1cb1faeed50$var$workInProgressSuspendedReason || 9 === $5c00e1cb1faeed50$var$workInProgressSuspendedReason) || null !== root.cancelPendingCommit) return null !== pingedLanes && null !== pingedLanes && $5c00e1cb1faeed50$var$cancelCallback$1(pingedLanes), root.callbackNode = null, root.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || $5c00e1cb1faeed50$var$checkIfRootIsPrerendering(root, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime === root.callbackPriority) return currentTime;
        null !== pingedLanes && $5c00e1cb1faeed50$var$cancelCallback$1(pingedLanes);
        switch($5c00e1cb1faeed50$var$lanesToEventPriority(suspendedLanes)){
            case 2:
            case 8:
                suspendedLanes = $5c00e1cb1faeed50$var$UserBlockingPriority;
                break;
            case 32:
                suspendedLanes = $5c00e1cb1faeed50$var$NormalPriority$1;
                break;
            case 268435456:
                suspendedLanes = $5c00e1cb1faeed50$var$IdlePriority;
                break;
            default:
                suspendedLanes = $5c00e1cb1faeed50$var$NormalPriority$1;
        }
        pingedLanes = $5c00e1cb1faeed50$var$performWorkOnRootViaSchedulerTask.bind(null, root);
        suspendedLanes = $5c00e1cb1faeed50$var$scheduleCallback$3(suspendedLanes, pingedLanes);
        root.callbackPriority = currentTime;
        root.callbackNode = suspendedLanes;
        return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && $5c00e1cb1faeed50$var$cancelCallback$1(pingedLanes);
    root.callbackPriority = 2;
    root.callbackNode = null;
    return 2;
}
function $5c00e1cb1faeed50$var$performWorkOnRootViaSchedulerTask(root, didTimeout) {
    if (0 !== $5c00e1cb1faeed50$var$pendingEffectsStatus && 5 !== $5c00e1cb1faeed50$var$pendingEffectsStatus) return root.callbackNode = null, root.callbackPriority = 0, null;
    var originalCallbackNode = root.callbackNode;
    if ($5c00e1cb1faeed50$var$flushPendingEffects() && root.callbackNode !== originalCallbackNode) return null;
    var workInProgressRootRenderLanes$jscomp$0 = $5c00e1cb1faeed50$var$workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = $5c00e1cb1faeed50$var$getNextLanes(root, root === $5c00e1cb1faeed50$var$workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0, null !== root.cancelPendingCommit || -1 !== root.timeoutHandle);
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    $5c00e1cb1faeed50$var$performWorkOnRoot(root, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    $5c00e1cb1faeed50$var$scheduleTaskForRootDuringMicrotask(root, $5c00e1cb1faeed50$var$now());
    return null != root.callbackNode && root.callbackNode === originalCallbackNode ? $5c00e1cb1faeed50$var$performWorkOnRootViaSchedulerTask.bind(null, root) : null;
}
function $5c00e1cb1faeed50$var$performSyncWorkOnRoot(root, lanes) {
    if ($5c00e1cb1faeed50$var$flushPendingEffects()) return null;
    $5c00e1cb1faeed50$var$performWorkOnRoot(root, lanes, !0);
}
function $5c00e1cb1faeed50$var$scheduleImmediateRootScheduleTask() {
    $5c00e1cb1faeed50$var$scheduleMicrotask(function() {
        0 !== ($5c00e1cb1faeed50$var$executionContext & 6) ? $5c00e1cb1faeed50$var$scheduleCallback$3($5c00e1cb1faeed50$var$ImmediatePriority, $5c00e1cb1faeed50$var$processRootScheduleInImmediateTask) : $5c00e1cb1faeed50$var$processRootScheduleInMicrotask();
    });
}
function $5c00e1cb1faeed50$var$requestTransitionLane() {
    if (0 === $5c00e1cb1faeed50$var$currentEventTransitionLane) {
        var actionScopeLane = $5c00e1cb1faeed50$var$currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = $5c00e1cb1faeed50$var$nextTransitionUpdateLane, $5c00e1cb1faeed50$var$nextTransitionUpdateLane <<= 1, 0 === ($5c00e1cb1faeed50$var$nextTransitionUpdateLane & 261888) && ($5c00e1cb1faeed50$var$nextTransitionUpdateLane = 256));
        $5c00e1cb1faeed50$var$currentEventTransitionLane = actionScopeLane;
    }
    return $5c00e1cb1faeed50$var$currentEventTransitionLane;
}
function $5c00e1cb1faeed50$var$coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : $5c00e1cb1faeed50$var$sanitizeURL(actionProp);
}
function $5c00e1cb1faeed50$var$extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = $5c00e1cb1faeed50$var$coerceFormActionProp((nativeEventTarget[$5c00e1cb1faeed50$var$internalPropsKey] || null).action), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[$5c00e1cb1faeed50$var$internalPropsKey] || null) ? $5c00e1cb1faeed50$var$coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new $5c00e1cb1faeed50$var$SyntheticEvent("action", "action", null, nativeEvent, nativeEventTarget);
        dispatchQueue.push({
            event: event,
            listeners: [
                {
                    instance: null,
                    listener: function() {
                        if (nativeEvent.defaultPrevented) {
                            if (0 !== $5c00e1cb1faeed50$var$currentEventTransitionLane) {
                                var formData = new FormData(nativeEventTarget, submitter);
                                $5c00e1cb1faeed50$var$startHostTransition(maybeTargetInst, {
                                    pending: !0,
                                    data: formData,
                                    method: nativeEventTarget.method,
                                    action: action
                                }, null, formData);
                            }
                        } else "function" === typeof action && (event.preventDefault(), formData = new FormData(nativeEventTarget, submitter), $5c00e1cb1faeed50$var$startHostTransition(maybeTargetInst, {
                            pending: !0,
                            data: formData,
                            method: nativeEventTarget.method,
                            action: action
                        }, action, formData));
                    },
                    currentTarget: nativeEventTarget
                }
            ]
        });
    }
}
for(var $5c00e1cb1faeed50$var$i$jscomp$inline_1667 = 0; $5c00e1cb1faeed50$var$i$jscomp$inline_1667 < $5c00e1cb1faeed50$var$simpleEventPluginEvents.length; $5c00e1cb1faeed50$var$i$jscomp$inline_1667++){
    var $5c00e1cb1faeed50$var$eventName$jscomp$inline_1668 = $5c00e1cb1faeed50$var$simpleEventPluginEvents[$5c00e1cb1faeed50$var$i$jscomp$inline_1667], $5c00e1cb1faeed50$var$domEventName$jscomp$inline_1669 = $5c00e1cb1faeed50$var$eventName$jscomp$inline_1668.toLowerCase(), $5c00e1cb1faeed50$var$capitalizedEvent$jscomp$inline_1670 = $5c00e1cb1faeed50$var$eventName$jscomp$inline_1668[0].toUpperCase() + $5c00e1cb1faeed50$var$eventName$jscomp$inline_1668.slice(1);
    $5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$domEventName$jscomp$inline_1669, "on" + $5c00e1cb1faeed50$var$capitalizedEvent$jscomp$inline_1670);
}
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$ANIMATION_END, "onAnimationEnd");
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$ANIMATION_ITERATION, "onAnimationIteration");
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$ANIMATION_START, "onAnimationStart");
$5c00e1cb1faeed50$var$registerSimpleEvent("dblclick", "onDoubleClick");
$5c00e1cb1faeed50$var$registerSimpleEvent("focusin", "onFocus");
$5c00e1cb1faeed50$var$registerSimpleEvent("focusout", "onBlur");
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$TRANSITION_RUN, "onTransitionRun");
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$TRANSITION_START, "onTransitionStart");
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$TRANSITION_CANCEL, "onTransitionCancel");
$5c00e1cb1faeed50$var$registerSimpleEvent($5c00e1cb1faeed50$var$TRANSITION_END, "onTransitionEnd");
$5c00e1cb1faeed50$var$registerDirectEvent("onMouseEnter", [
    "mouseout",
    "mouseover"
]);
$5c00e1cb1faeed50$var$registerDirectEvent("onMouseLeave", [
    "mouseout",
    "mouseover"
]);
$5c00e1cb1faeed50$var$registerDirectEvent("onPointerEnter", [
    "pointerout",
    "pointerover"
]);
$5c00e1cb1faeed50$var$registerDirectEvent("onPointerLeave", [
    "pointerout",
    "pointerover"
]);
$5c00e1cb1faeed50$var$registerTwoPhaseEvent("onChange", "change click focusin focusout input keydown keyup selectionchange".split(" "));
$5c00e1cb1faeed50$var$registerTwoPhaseEvent("onSelect", "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(" "));
$5c00e1cb1faeed50$var$registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
]);
$5c00e1cb1faeed50$var$registerTwoPhaseEvent("onCompositionEnd", "compositionend focusout keydown keypress keyup mousedown".split(" "));
$5c00e1cb1faeed50$var$registerTwoPhaseEvent("onCompositionStart", "compositionstart focusout keydown keypress keyup mousedown".split(" "));
$5c00e1cb1faeed50$var$registerTwoPhaseEvent("onCompositionUpdate", "compositionupdate focusout keydown keypress keyup mousedown".split(" "));
var $5c00e1cb1faeed50$var$mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(" "), $5c00e1cb1faeed50$var$nonDelegatedEvents = new Set("beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat($5c00e1cb1faeed50$var$mediaEventTypes));
function $5c00e1cb1faeed50$var$processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for(var i = 0; i < dispatchQueue.length; i++){
        var _dispatchQueue$i = dispatchQueue[i], event = _dispatchQueue$i.event;
        _dispatchQueue$i = _dispatchQueue$i.listeners;
        a: {
            var previousInstance = void 0;
            if (eventSystemFlags) for(var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--){
                var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $5c00e1cb1faeed50$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
            else for(i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++){
                _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
                instance = _dispatchListeners$i.instance;
                currentTarget = _dispatchListeners$i.currentTarget;
                _dispatchListeners$i = _dispatchListeners$i.listener;
                if (instance !== previousInstance && event.isPropagationStopped()) break a;
                previousInstance = _dispatchListeners$i;
                event.currentTarget = currentTarget;
                try {
                    previousInstance(event);
                } catch (error) {
                    $5c00e1cb1faeed50$var$reportGlobalError(error);
                }
                event.currentTarget = null;
                previousInstance = instance;
            }
        }
    }
}
function $5c00e1cb1faeed50$var$listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[$5c00e1cb1faeed50$var$internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[$5c00e1cb1faeed50$var$internalEventHandlersKey] = new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || ($5c00e1cb1faeed50$var$addTrappedEventListener(targetElement, domEventName, 2, !1), JSCompiler_inline_result.add(listenerSetKey));
}
function $5c00e1cb1faeed50$var$listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    $5c00e1cb1faeed50$var$addTrappedEventListener(target, domEventName, eventSystemFlags, isCapturePhaseListener);
}
var $5c00e1cb1faeed50$var$listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
function $5c00e1cb1faeed50$var$listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[$5c00e1cb1faeed50$var$listeningMarker]) {
        rootContainerElement[$5c00e1cb1faeed50$var$listeningMarker] = !0;
        $5c00e1cb1faeed50$var$allNativeEvents.forEach(function(domEventName) {
            "selectionchange" !== domEventName && ($5c00e1cb1faeed50$var$nonDelegatedEvents.has(domEventName) || $5c00e1cb1faeed50$var$listenToNativeEvent(domEventName, !1, rootContainerElement), $5c00e1cb1faeed50$var$listenToNativeEvent(domEventName, !0, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[$5c00e1cb1faeed50$var$listeningMarker] || (ownerDocument[$5c00e1cb1faeed50$var$listeningMarker] = !0, $5c00e1cb1faeed50$var$listenToNativeEvent("selectionchange", !1, ownerDocument));
    }
}
function $5c00e1cb1faeed50$var$addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch($5c00e1cb1faeed50$var$getEventPriority(domEventName)){
        case 2:
            var listenerWrapper = $5c00e1cb1faeed50$var$dispatchDiscreteEvent;
            break;
        case 8:
            listenerWrapper = $5c00e1cb1faeed50$var$dispatchContinuousEvent;
            break;
        default:
            listenerWrapper = $5c00e1cb1faeed50$var$dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(null, domEventName, eventSystemFlags, targetContainer);
    listenerWrapper = void 0;
    !$5c00e1cb1faeed50$var$passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = !0);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: !0,
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !0) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, !1);
}
function $5c00e1cb1faeed50$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0) a: for(;;){
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag) for(nodeTag = targetInst$jscomp$0.return; null !== nodeTag;){
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer) return;
                nodeTag = nodeTag.return;
            }
            for(; null !== container;){
                nodeTag = $5c00e1cb1faeed50$var$getClosestInstanceFromNode(container);
                if (null === nodeTag) return;
                grandTag = nodeTag.tag;
                if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                    targetInst$jscomp$0 = ancestorInst = nodeTag;
                    continue a;
                }
                container = container.parentNode;
            }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
    }
    $5c00e1cb1faeed50$var$batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = $5c00e1cb1faeed50$var$getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
            var reactName = $5c00e1cb1faeed50$var$topLevelEventsToReactNames.get(domEventName);
            if (void 0 !== reactName) {
                var SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticEvent, reactEventType = domEventName;
                switch(domEventName){
                    case "keypress":
                        if (0 === $5c00e1cb1faeed50$var$getEventCharCode(nativeEvent)) break a;
                    case "keydown":
                    case "keyup":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticKeyboardEvent;
                        break;
                    case "focusin":
                        reactEventType = "focus";
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticFocusEvent;
                        break;
                    case "focusout":
                        reactEventType = "blur";
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticFocusEvent;
                        break;
                    case "beforeblur":
                    case "afterblur":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticFocusEvent;
                        break;
                    case "click":
                        if (2 === nativeEvent.button) break a;
                    case "auxclick":
                    case "dblclick":
                    case "mousedown":
                    case "mousemove":
                    case "mouseup":
                    case "mouseout":
                    case "mouseover":
                    case "contextmenu":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticMouseEvent;
                        break;
                    case "drag":
                    case "dragend":
                    case "dragenter":
                    case "dragexit":
                    case "dragleave":
                    case "dragover":
                    case "dragstart":
                    case "drop":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticDragEvent;
                        break;
                    case "touchcancel":
                    case "touchend":
                    case "touchmove":
                    case "touchstart":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticTouchEvent;
                        break;
                    case $5c00e1cb1faeed50$var$ANIMATION_END:
                    case $5c00e1cb1faeed50$var$ANIMATION_ITERATION:
                    case $5c00e1cb1faeed50$var$ANIMATION_START:
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticAnimationEvent;
                        break;
                    case $5c00e1cb1faeed50$var$TRANSITION_END:
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticTransitionEvent;
                        break;
                    case "scroll":
                    case "scrollend":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticUIEvent;
                        break;
                    case "wheel":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticWheelEvent;
                        break;
                    case "copy":
                    case "cut":
                    case "paste":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticClipboardEvent;
                        break;
                    case "gotpointercapture":
                    case "lostpointercapture":
                    case "pointercancel":
                    case "pointerdown":
                    case "pointermove":
                    case "pointerout":
                    case "pointerover":
                    case "pointerup":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticPointerEvent;
                        break;
                    case "submit":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticSubmitEvent;
                        break;
                    case "toggle":
                    case "beforetoggle":
                        SyntheticEventCtor = $5c00e1cb1faeed50$var$SyntheticToggleEvent;
                }
                var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
                inCapturePhase = [];
                for(var instance = targetInst, lastHostComponent; null !== instance;){
                    var _instance = instance;
                    lastHostComponent = _instance.stateNode;
                    _instance = _instance.tag;
                    5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = $5c00e1cb1faeed50$var$getListener(instance, reactEventName), null != _instance && inCapturePhase.push($5c00e1cb1faeed50$var$createDispatchListener(instance, _instance, lastHostComponent)));
                    if (accumulateTargetOnly) break;
                    instance = instance.return;
                }
                0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(reactName, reactEventType, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                    event: reactName,
                    listeners: inCapturePhase
                }));
            }
        }
        if (0 === (eventSystemFlags & 7)) {
            a: {
                SyntheticEventCtor = "mouseover" === domEventName || "pointerover" === domEventName;
                reactName = "mouseout" === domEventName || "pointerout" === domEventName;
                if (SyntheticEventCtor && nativeEvent !== $5c00e1cb1faeed50$var$currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && ($5c00e1cb1faeed50$var$getClosestInstanceFromNode(reactEventType) || reactEventType[$5c00e1cb1faeed50$var$internalContainerInstanceKey])) break a;
                if (reactName || SyntheticEventCtor) {
                    reactEventType = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (SyntheticEventCtor = nativeEventTarget.ownerDocument) ? SyntheticEventCtor.defaultView || SyntheticEventCtor.parentWindow : window;
                    if (reactName) {
                        if (SyntheticEventCtor = nativeEvent.relatedTarget || nativeEvent.toElement, reactName = targetInst, SyntheticEventCtor = SyntheticEventCtor ? $5c00e1cb1faeed50$var$getClosestInstanceFromNode(SyntheticEventCtor) : null, null !== SyntheticEventCtor && (accumulateTargetOnly = $5c00e1cb1faeed50$var$getNearestMountedFiber(SyntheticEventCtor), inCapturePhase = SyntheticEventCtor.tag, SyntheticEventCtor !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase)) SyntheticEventCtor = null;
                    } else reactName = null, SyntheticEventCtor = targetInst;
                    if (reactName !== SyntheticEventCtor) {
                        inCapturePhase = $5c00e1cb1faeed50$var$SyntheticMouseEvent;
                        _instance = "onMouseLeave";
                        reactEventName = "onMouseEnter";
                        instance = "mouse";
                        if ("pointerout" === domEventName || "pointerover" === domEventName) inCapturePhase = $5c00e1cb1faeed50$var$SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                        accumulateTargetOnly = null == reactName ? reactEventType : $5c00e1cb1faeed50$var$getNodeFromInstance(reactName);
                        lastHostComponent = null == SyntheticEventCtor ? reactEventType : $5c00e1cb1faeed50$var$getNodeFromInstance(SyntheticEventCtor);
                        reactEventType = new inCapturePhase(_instance, instance + "leave", reactName, nativeEvent, nativeEventTarget);
                        reactEventType.target = accumulateTargetOnly;
                        reactEventType.relatedTarget = lastHostComponent;
                        _instance = null;
                        $5c00e1cb1faeed50$var$getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(reactEventName, instance + "enter", SyntheticEventCtor, nativeEvent, nativeEventTarget), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
                        accumulateTargetOnly = _instance;
                        inCapturePhase = reactName && SyntheticEventCtor ? $5c00e1cb1faeed50$var$getLowestCommonAncestor(reactName, SyntheticEventCtor, $5c00e1cb1faeed50$var$getParent) : null;
                        null !== reactName && $5c00e1cb1faeed50$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, reactEventType, reactName, inCapturePhase, !1);
                        null !== SyntheticEventCtor && null !== accumulateTargetOnly && $5c00e1cb1faeed50$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, accumulateTargetOnly, SyntheticEventCtor, inCapturePhase, !0);
                    }
                }
            }
            a: {
                reactName = targetInst ? $5c00e1cb1faeed50$var$getNodeFromInstance(targetInst) : window;
                SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
                if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type) var getTargetInstFunc = $5c00e1cb1faeed50$var$getTargetInstForChangeEvent;
                else if ($5c00e1cb1faeed50$var$isTextInputElement(reactName)) {
                    if ($5c00e1cb1faeed50$var$isInputEventSupported) getTargetInstFunc = $5c00e1cb1faeed50$var$getTargetInstForInputOrChangeEvent;
                    else {
                        getTargetInstFunc = $5c00e1cb1faeed50$var$getTargetInstForInputEventPolyfill;
                        var handleEventFunc = $5c00e1cb1faeed50$var$handleEventsForInputEventPolyfill;
                    }
                } else SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && $5c00e1cb1faeed50$var$isCustomElement(targetInst.elementType) && (getTargetInstFunc = $5c00e1cb1faeed50$var$getTargetInstForChangeEvent) : getTargetInstFunc = $5c00e1cb1faeed50$var$getTargetInstForClickEvent;
                if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
                    $5c00e1cb1faeed50$var$createAndAccumulateChangeEvent(dispatchQueue, getTargetInstFunc, nativeEvent, nativeEventTarget);
                    break a;
                }
                handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            }
            handleEventFunc = targetInst ? $5c00e1cb1faeed50$var$getNodeFromInstance(targetInst) : window;
            switch(domEventName){
                case "focusin":
                    if ($5c00e1cb1faeed50$var$isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable) $5c00e1cb1faeed50$var$activeElement = handleEventFunc, $5c00e1cb1faeed50$var$activeElementInst = targetInst, $5c00e1cb1faeed50$var$lastSelection = null;
                    break;
                case "focusout":
                    $5c00e1cb1faeed50$var$lastSelection = $5c00e1cb1faeed50$var$activeElementInst = $5c00e1cb1faeed50$var$activeElement = null;
                    break;
                case "mousedown":
                    $5c00e1cb1faeed50$var$mouseDown = !0;
                    break;
                case "contextmenu":
                case "mouseup":
                case "dragend":
                    $5c00e1cb1faeed50$var$mouseDown = !1;
                    $5c00e1cb1faeed50$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
                    break;
                case "selectionchange":
                    if ($5c00e1cb1faeed50$var$skipSelectionChangeEvent) break;
                case "keydown":
                case "keyup":
                    $5c00e1cb1faeed50$var$constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            }
            var fallbackData;
            if ($5c00e1cb1faeed50$var$canUseCompositionEvent) b: {
                switch(domEventName){
                    case "compositionstart":
                        var eventType = "onCompositionStart";
                        break b;
                    case "compositionend":
                        eventType = "onCompositionEnd";
                        break b;
                    case "compositionupdate":
                        eventType = "onCompositionUpdate";
                        break b;
                }
                eventType = void 0;
            }
            else $5c00e1cb1faeed50$var$isComposing ? $5c00e1cb1faeed50$var$isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
            eventType && ($5c00e1cb1faeed50$var$useFallbackCompositionData && "ko" !== nativeEvent.locale && ($5c00e1cb1faeed50$var$isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && $5c00e1cb1faeed50$var$isComposing && (fallbackData = $5c00e1cb1faeed50$var$getData()) : ($5c00e1cb1faeed50$var$root = nativeEventTarget, $5c00e1cb1faeed50$var$startText = "value" in $5c00e1cb1faeed50$var$root ? $5c00e1cb1faeed50$var$root.value : $5c00e1cb1faeed50$var$root.textContent, $5c00e1cb1faeed50$var$isComposing = !0)), handleEventFunc = $5c00e1cb1faeed50$var$accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new $5c00e1cb1faeed50$var$SyntheticCompositionEvent(eventType, domEventName, null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: eventType,
                listeners: handleEventFunc
            }), fallbackData ? eventType.data = fallbackData : (fallbackData = $5c00e1cb1faeed50$var$getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
            if (fallbackData = $5c00e1cb1faeed50$var$canUseTextInputEvent ? $5c00e1cb1faeed50$var$getNativeBeforeInputChars(domEventName, nativeEvent) : $5c00e1cb1faeed50$var$getFallbackBeforeInputChars(domEventName, nativeEvent)) eventType = $5c00e1cb1faeed50$var$accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new $5c00e1cb1faeed50$var$SyntheticCompositionEvent("onBeforeInput", "beforeinput", null, nativeEvent, nativeEventTarget), dispatchQueue.push({
                event: handleEventFunc,
                listeners: eventType
            }), handleEventFunc.data = fallbackData);
            $5c00e1cb1faeed50$var$extractEvents$1(dispatchQueue, domEventName, targetInst, nativeEvent, nativeEventTarget);
        }
        $5c00e1cb1faeed50$var$processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
}
function $5c00e1cb1faeed50$var$createDispatchListener(instance, listener, currentTarget) {
    return {
        instance: instance,
        listener: listener,
        currentTarget: currentTarget
    };
}
function $5c00e1cb1faeed50$var$accumulateTwoPhaseListeners(targetFiber, reactName) {
    for(var captureName = reactName + "Capture", listeners = []; null !== targetFiber;){
        var _instance2 = targetFiber, stateNode = _instance2.stateNode;
        _instance2 = _instance2.tag;
        5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = $5c00e1cb1faeed50$var$getListener(targetFiber, captureName), null != _instance2 && listeners.unshift($5c00e1cb1faeed50$var$createDispatchListener(targetFiber, _instance2, stateNode)), _instance2 = $5c00e1cb1faeed50$var$getListener(targetFiber, reactName), null != _instance2 && listeners.push($5c00e1cb1faeed50$var$createDispatchListener(targetFiber, _instance2, stateNode)));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
    }
    return [];
}
function $5c00e1cb1faeed50$var$getParent(inst) {
    if (null === inst) return null;
    do inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
}
function $5c00e1cb1faeed50$var$accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for(var registrationName = event._reactName, listeners = []; null !== target && target !== common;){
        var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = $5c00e1cb1faeed50$var$getListener(target, registrationName), null != stateNode && listeners.unshift($5c00e1cb1faeed50$var$createDispatchListener(target, stateNode, alternate))) : inCapturePhase || (stateNode = $5c00e1cb1faeed50$var$getListener(target, registrationName), null != stateNode && listeners.push($5c00e1cb1faeed50$var$createDispatchListener(target, stateNode, alternate))));
        target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({
        event: event,
        listeners: listeners
    });
}
var $5c00e1cb1faeed50$var$NORMALIZE_NEWLINES_REGEX = /\r\n?/g, $5c00e1cb1faeed50$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
function $5c00e1cb1faeed50$var$normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace($5c00e1cb1faeed50$var$NORMALIZE_NEWLINES_REGEX, "\n").replace($5c00e1cb1faeed50$var$NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
}
function $5c00e1cb1faeed50$var$checkForUnmatchedText(serverText, clientText) {
    clientText = $5c00e1cb1faeed50$var$normalizeMarkupForTextOrAttribute(clientText);
    return $5c00e1cb1faeed50$var$normalizeMarkupForTextOrAttribute(serverText) === clientText ? !0 : !1;
}
function $5c00e1cb1faeed50$var$setProp(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "children":
            if ("string" === typeof value) "body" === tag || "textarea" === tag && "" === value || $5c00e1cb1faeed50$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) "body" !== tag && $5c00e1cb1faeed50$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "className":
            $5c00e1cb1faeed50$var$setValueForKnownAttribute(domElement, "class", value);
            break;
        case "tabIndex":
            $5c00e1cb1faeed50$var$setValueForKnownAttribute(domElement, "tabindex", value);
            break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
            $5c00e1cb1faeed50$var$setValueForKnownAttribute(domElement, key, value);
            break;
        case "style":
            $5c00e1cb1faeed50$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "data":
            if ("object" !== tag) {
                $5c00e1cb1faeed50$var$setValueForKnownAttribute(domElement, "data", value);
                break;
            }
        case "src":
        case "href":
            if ("" === value && ("a" !== tag || "href" !== key)) {
                domElement.removeAttribute(key);
                break;
            }
            if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $5c00e1cb1faeed50$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "action":
        case "formAction":
            if ("function" === typeof value) {
                domElement.setAttribute(key, "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')");
                break;
            } else "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag && $5c00e1cb1faeed50$var$setProp(domElement, tag, "name", props.name, props, null), $5c00e1cb1faeed50$var$setProp(domElement, tag, "formEncType", props.formEncType, props, null), $5c00e1cb1faeed50$var$setProp(domElement, tag, "formMethod", props.formMethod, props, null), $5c00e1cb1faeed50$var$setProp(domElement, tag, "formTarget", props.formTarget, props, null)) : ($5c00e1cb1faeed50$var$setProp(domElement, tag, "encType", props.encType, props, null), $5c00e1cb1faeed50$var$setProp(domElement, tag, "method", props.method, props, null), $5c00e1cb1faeed50$var$setProp(domElement, tag, "target", props.target, props, null)));
            if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
                domElement.removeAttribute(key);
                break;
            }
            value = $5c00e1cb1faeed50$var$sanitizeURL(value);
            domElement.setAttribute(key, value);
            break;
        case "onClick":
            null != value && (domElement.onclick = $5c00e1cb1faeed50$var$noop$1);
            return;
        case "onScroll":
            null != value && $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "multiple":
            domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "muted":
            domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
            break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
            break;
        case "autoFocus":
            break;
        case "xlinkHref":
            if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
                domElement.removeAttribute("xlink:href");
                break;
            }
            key = $5c00e1cb1faeed50$var$sanitizeURL(value);
            domElement.setAttributeNS("http://www.w3.org/1999/xlink", "xlink:href", key);
            break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
            null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "inert":
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "credentialless":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
            value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
            break;
        case "capture":
        case "download":
            !0 === value ? domElement.setAttribute(key, "") : !1 !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "cols":
        case "rows":
        case "size":
        case "span":
            null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
            break;
        case "rowSpan":
        case "start":
            null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
            break;
        case "popover":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("toggle", domElement);
            $5c00e1cb1faeed50$var$setValueForAttribute(domElement, "popover", value);
            break;
        case "xlinkActuate":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:actuate", value);
            break;
        case "xlinkArcrole":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:arcrole", value);
            break;
        case "xlinkRole":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:role", value);
            break;
        case "xlinkShow":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:show", value);
            break;
        case "xlinkTitle":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:title", value);
            break;
        case "xlinkType":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/1999/xlink", "xlink:type", value);
            break;
        case "xmlBase":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:base", value);
            break;
        case "xmlLang":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:lang", value);
            break;
        case "xmlSpace":
            $5c00e1cb1faeed50$var$setValueForNamespacedAttribute(domElement, "http://www.w3.org/XML/1998/namespace", "xml:space", value);
            break;
        case "is":
            $5c00e1cb1faeed50$var$setValueForAttribute(domElement, "is", value);
            break;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1]) key = $5c00e1cb1faeed50$var$aliases.get(key) || key, $5c00e1cb1faeed50$var$setValueForAttribute(domElement, key, value);
            else return;
    }
    $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
}
function $5c00e1cb1faeed50$var$setPropOnCustomElement(domElement, tag, key, value, props, prevValue) {
    switch(key){
        case "style":
            $5c00e1cb1faeed50$var$setValueForStyles(domElement, value, prevValue);
            return;
        case "dangerouslySetInnerHTML":
            if (null != value) {
                if ("object" !== typeof value || !("__html" in value)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(61));
                key = value.__html;
                if (null != key) {
                    if (null != props.children) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(60));
                    (null != prevValue ? prevValue.__html : void 0) !== key && (domElement.innerHTML = key);
                }
            }
            break;
        case "children":
            if ("string" === typeof value) $5c00e1cb1faeed50$var$setTextContent(domElement, value);
            else if ("number" === typeof value || "bigint" === typeof value) $5c00e1cb1faeed50$var$setTextContent(domElement, "" + value);
            else return;
            break;
        case "onScroll":
            null != value && $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("scroll", domElement);
            return;
        case "onScrollEnd":
            null != value && $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("scrollend", domElement);
            return;
        case "onClick":
            null != value && (domElement.onclick = $5c00e1cb1faeed50$var$noop$1);
            return;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
            return;
        case "innerText":
        case "textContent":
            return;
        default:
            if (!$5c00e1cb1faeed50$var$registrationNameDependencies.hasOwnProperty(key)) a: {
                if ("o" === key[0] && "n" === key[1] && (props = key.endsWith("Capture"), prevValue = key.slice(2, props ? key.length - 7 : void 0), tag = domElement[$5c00e1cb1faeed50$var$internalPropsKey] || null, tag = null != tag ? tag[key] : null, "function" === typeof tag && domElement.removeEventListener(prevValue, tag, props), "function" === typeof value)) {
                    "function" !== typeof tag && null !== tag && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                    domElement.addEventListener(prevValue, value, props);
                    break a;
                }
                $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
                key in domElement ? domElement[key] = value : !0 === value ? domElement.setAttribute(key, "") : $5c00e1cb1faeed50$var$setValueForAttribute(domElement, key, value);
            }
            return;
    }
    $5c00e1cb1faeed50$var$viewTransitionMutationContext = !0;
}
function $5c00e1cb1faeed50$var$setInitialProperties(domElement, tag, props) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "img":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("error", domElement);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("load", domElement);
            var hasSrc = !1, hasSrcSet = !1, propKey;
            for(propKey in props)if (props.hasOwnProperty(propKey)) {
                var propValue = props[propKey];
                if (null != propValue) switch(propKey){
                    case "src":
                        hasSrc = !0;
                        break;
                    case "srcSet":
                        hasSrcSet = !0;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(137, tag));
                    default:
                        $5c00e1cb1faeed50$var$setProp(domElement, tag, propKey, propValue, props, null);
                }
            }
            hasSrcSet && $5c00e1cb1faeed50$var$setProp(domElement, tag, "srcSet", props.srcSet, props, null);
            hasSrc && $5c00e1cb1faeed50$var$setProp(domElement, tag, "src", props.src, props, null);
            return;
        case "input":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("invalid", domElement);
            var defaultValue = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
            for(hasSrc in props)if (props.hasOwnProperty(hasSrc)) {
                var propValue$204 = props[hasSrc];
                if (null != propValue$204) switch(hasSrc){
                    case "name":
                        hasSrcSet = propValue$204;
                        break;
                    case "type":
                        propValue = propValue$204;
                        break;
                    case "checked":
                        checked = propValue$204;
                        break;
                    case "defaultChecked":
                        defaultChecked = propValue$204;
                        break;
                    case "value":
                        propKey = propValue$204;
                        break;
                    case "defaultValue":
                        defaultValue = propValue$204;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propValue$204) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        $5c00e1cb1faeed50$var$setProp(domElement, tag, hasSrc, propValue$204, props, null);
                }
            }
            $5c00e1cb1faeed50$var$initInput(domElement, propKey, defaultValue, checked, defaultChecked, propValue, hasSrcSet, !1);
            return;
        case "select":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("invalid", domElement);
            hasSrc = propValue = propKey = null;
            for(hasSrcSet in props)if (props.hasOwnProperty(hasSrcSet) && (defaultValue = props[hasSrcSet], null != defaultValue)) switch(hasSrcSet){
                case "value":
                    propKey = defaultValue;
                    break;
                case "defaultValue":
                    propValue = defaultValue;
                    break;
                case "multiple":
                    hasSrc = defaultValue;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, hasSrcSet, defaultValue, props, null);
            }
            tag = propKey;
            props = propValue;
            domElement.multiple = !!hasSrc;
            null != tag ? $5c00e1cb1faeed50$var$updateOptions(domElement, !!hasSrc, tag, !1) : null != props && $5c00e1cb1faeed50$var$updateOptions(domElement, !!hasSrc, props, !0);
            return;
        case "textarea":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("invalid", domElement);
            propKey = hasSrcSet = hasSrc = null;
            for(propValue in props)if (props.hasOwnProperty(propValue) && (defaultValue = props[propValue], null != defaultValue)) switch(propValue){
                case "value":
                    hasSrc = defaultValue;
                    break;
                case "defaultValue":
                    hasSrcSet = defaultValue;
                    break;
                case "children":
                    propKey = defaultValue;
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != defaultValue) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(91));
                    break;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, propValue, defaultValue, props, null);
            }
            $5c00e1cb1faeed50$var$initTextarea(domElement, hasSrc, hasSrcSet, propKey);
            return;
        case "option":
            for(checked in props)if (props.hasOwnProperty(checked) && (hasSrc = props[checked], null != hasSrc)) switch(checked){
                case "selected":
                    domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                    break;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, checked, hasSrc, props, null);
            }
            return;
        case "dialog":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("beforetoggle", domElement);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("toggle", domElement);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("cancel", domElement);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("close", domElement);
            break;
        case "iframe":
        case "object":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "video":
        case "audio":
            for(hasSrc = 0; hasSrc < $5c00e1cb1faeed50$var$mediaEventTypes.length; hasSrc++)$5c00e1cb1faeed50$var$listenToNonDelegatedEvent($5c00e1cb1faeed50$var$mediaEventTypes[hasSrc], domElement);
            break;
        case "image":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("error", domElement);
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("load", domElement);
            break;
        case "details":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("toggle", domElement);
            break;
        case "embed":
        case "source":
        case "link":
            $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("error", domElement), $5c00e1cb1faeed50$var$listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
            for(defaultChecked in props)if (props.hasOwnProperty(defaultChecked) && (hasSrc = props[defaultChecked], null != hasSrc)) switch(defaultChecked){
                case "children":
                case "dangerouslySetInnerHTML":
                    throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(137, tag));
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, defaultChecked, hasSrc, props, null);
            }
            return;
        default:
            if ($5c00e1cb1faeed50$var$isCustomElement(tag)) {
                for(propValue$204 in props)props.hasOwnProperty(propValue$204) && (hasSrc = props[propValue$204], void 0 !== hasSrc && $5c00e1cb1faeed50$var$setPropOnCustomElement(domElement, tag, propValue$204, hasSrc, props, void 0));
                return;
            }
    }
    for(defaultValue in props)props.hasOwnProperty(defaultValue) && (hasSrc = props[defaultValue], null != hasSrc && $5c00e1cb1faeed50$var$setProp(domElement, tag, defaultValue, hasSrc, props, null));
}
var $5c00e1cb1faeed50$var$emptyProps = {};
function $5c00e1cb1faeed50$var$updateProperties(domElement, tag, lastProps, nextProps) {
    switch(tag){
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
            break;
        case "input":
            var name = null, type = null, value = null, defaultValue = null, lastDefaultValue = null, checked = null, defaultChecked = null;
            for(propKey in lastProps){
                var lastProp = lastProps[propKey];
                if (lastProps.hasOwnProperty(propKey) && null != lastProp) switch(propKey){
                    case "checked":
                        break;
                    case "value":
                        break;
                    case "defaultValue":
                        lastDefaultValue = lastProp;
                    default:
                        nextProps.hasOwnProperty(propKey) || $5c00e1cb1faeed50$var$setProp(domElement, tag, propKey, null, nextProps, lastProp);
                }
            }
            for(var propKey$221 in nextProps){
                var propKey = nextProps[propKey$221];
                lastProp = lastProps[propKey$221];
                if (nextProps.hasOwnProperty(propKey$221) && (null != propKey || null != lastProp)) switch(propKey$221){
                    case "type":
                        propKey !== lastProp && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                        type = propKey;
                        break;
                    case "name":
                        propKey !== lastProp && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                        name = propKey;
                        break;
                    case "checked":
                        propKey !== lastProp && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                        checked = propKey;
                        break;
                    case "defaultChecked":
                        propKey !== lastProp && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                        defaultChecked = propKey;
                        break;
                    case "value":
                        propKey !== lastProp && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                        value = propKey;
                        break;
                    case "defaultValue":
                        propKey !== lastProp && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                        defaultValue = propKey;
                        break;
                    case "children":
                    case "dangerouslySetInnerHTML":
                        if (null != propKey) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(137, tag));
                        break;
                    default:
                        propKey !== lastProp && $5c00e1cb1faeed50$var$setProp(domElement, tag, propKey$221, propKey, nextProps, lastProp);
                }
            }
            $5c00e1cb1faeed50$var$updateInput(domElement, value, defaultValue, lastDefaultValue, checked, defaultChecked, type, name);
            return;
        case "select":
            propKey = value = defaultValue = propKey$221 = null;
            for(type in lastProps)if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue) switch(type){
                case "value":
                    break;
                case "multiple":
                    propKey = lastDefaultValue;
                default:
                    nextProps.hasOwnProperty(type) || $5c00e1cb1faeed50$var$setProp(domElement, tag, type, null, nextProps, lastDefaultValue);
            }
            for(name in nextProps)if (type = nextProps[name], lastDefaultValue = lastProps[name], nextProps.hasOwnProperty(name) && (null != type || null != lastDefaultValue)) switch(name){
                case "value":
                    type !== lastDefaultValue && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                    propKey$221 = type;
                    break;
                case "defaultValue":
                    type !== lastDefaultValue && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                    defaultValue = type;
                    break;
                case "multiple":
                    type !== lastDefaultValue && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0), value = type;
                default:
                    type !== lastDefaultValue && $5c00e1cb1faeed50$var$setProp(domElement, tag, name, type, nextProps, lastDefaultValue);
            }
            tag = defaultValue;
            lastProps = value;
            nextProps = propKey;
            null != propKey$221 ? $5c00e1cb1faeed50$var$updateOptions(domElement, !!lastProps, propKey$221, !1) : !!nextProps !== !!lastProps && (null != tag ? $5c00e1cb1faeed50$var$updateOptions(domElement, !!lastProps, tag, !0) : $5c00e1cb1faeed50$var$updateOptions(domElement, !!lastProps, lastProps ? [] : "", !1));
            return;
        case "textarea":
            propKey = propKey$221 = null;
            for(defaultValue in lastProps)if (name = lastProps[defaultValue], lastProps.hasOwnProperty(defaultValue) && null != name && !nextProps.hasOwnProperty(defaultValue)) switch(defaultValue){
                case "value":
                    break;
                case "children":
                    break;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, defaultValue, null, nextProps, name);
            }
            for(value in nextProps)if (name = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name || null != type)) switch(value){
                case "value":
                    name !== type && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                    propKey$221 = name;
                    break;
                case "defaultValue":
                    name !== type && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                    propKey = name;
                    break;
                case "children":
                    break;
                case "dangerouslySetInnerHTML":
                    if (null != name) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(91));
                    break;
                default:
                    name !== type && $5c00e1cb1faeed50$var$setProp(domElement, tag, value, name, nextProps, type);
            }
            $5c00e1cb1faeed50$var$updateTextarea(domElement, propKey$221, propKey);
            return;
        case "option":
            for(var propKey$237 in lastProps)if (propKey$221 = lastProps[propKey$237], lastProps.hasOwnProperty(propKey$237) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$237)) switch(propKey$237){
                case "selected":
                    domElement.selected = !1;
                    break;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, propKey$237, null, nextProps, propKey$221);
            }
            for(lastDefaultValue in nextProps)if (propKey$221 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(lastDefaultValue){
                case "selected":
                    propKey$221 !== propKey && ($5c00e1cb1faeed50$var$viewTransitionMutationContext = !0);
                    domElement.selected = propKey$221 && "function" !== typeof propKey$221 && "symbol" !== typeof propKey$221;
                    break;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, lastDefaultValue, propKey$221, nextProps, propKey);
            }
            return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
            for(var propKey$242 in lastProps)propKey$221 = lastProps[propKey$242], lastProps.hasOwnProperty(propKey$242) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$242) && $5c00e1cb1faeed50$var$setProp(domElement, tag, propKey$242, null, nextProps, propKey$221);
            for(checked in nextProps)if (propKey$221 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$221 !== propKey && (null != propKey$221 || null != propKey)) switch(checked){
                case "children":
                case "dangerouslySetInnerHTML":
                    if (null != propKey$221) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(137, tag));
                    break;
                default:
                    $5c00e1cb1faeed50$var$setProp(domElement, tag, checked, propKey$221, nextProps, propKey);
            }
            return;
        default:
            if ($5c00e1cb1faeed50$var$isCustomElement(tag)) {
                for(var propKey$247 in lastProps)propKey$221 = lastProps[propKey$247], lastProps.hasOwnProperty(propKey$247) && void 0 !== propKey$221 && !nextProps.hasOwnProperty(propKey$247) && $5c00e1cb1faeed50$var$setPropOnCustomElement(domElement, tag, propKey$247, void 0, nextProps, propKey$221);
                for(defaultChecked in nextProps)propKey$221 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$221 === propKey || void 0 === propKey$221 && void 0 === propKey || $5c00e1cb1faeed50$var$setPropOnCustomElement(domElement, tag, defaultChecked, propKey$221, nextProps, propKey);
                return;
            }
    }
    for(var propKey$252 in lastProps)propKey$221 = lastProps[propKey$252], lastProps.hasOwnProperty(propKey$252) && null != propKey$221 && !nextProps.hasOwnProperty(propKey$252) && $5c00e1cb1faeed50$var$setProp(domElement, tag, propKey$252, null, nextProps, propKey$221);
    for(lastProp in nextProps)propKey$221 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$221 === propKey || null == propKey$221 && null == propKey || $5c00e1cb1faeed50$var$setProp(domElement, tag, lastProp, propKey$221, nextProps, propKey);
}
function $5c00e1cb1faeed50$var$isLikelyStaticResource(initiatorType) {
    switch(initiatorType){
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
            return !0;
        default:
            return !1;
    }
}
function $5c00e1cb1faeed50$var$estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
        for(var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i = 0; i < resourceEntries.length; i++){
            var entry = resourceEntries[i], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
            if (transferSize && duration && $5c00e1cb1faeed50$var$isLikelyStaticResource(initiatorType)) {
                initiatorType = 0;
                duration = entry.responseEnd;
                for(i += 1; i < resourceEntries.length; i++){
                    var overlapEntry = resourceEntries[i], overlapStartTime = overlapEntry.startTime;
                    if (overlapStartTime > duration) break;
                    var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
                    overlapTransferSize && $5c00e1cb1faeed50$var$isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
                }
                --i;
                bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
                count++;
                if (10 < count) break;
            }
        }
        if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
}
var $5c00e1cb1faeed50$var$eventsEnabled = null, $5c00e1cb1faeed50$var$selectionInformation = null;
function $5c00e1cb1faeed50$var$getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
}
function $5c00e1cb1faeed50$var$getOwnHostContext(namespaceURI) {
    switch(namespaceURI){
        case "http://www.w3.org/2000/svg":
            return 1;
        case "http://www.w3.org/1998/Math/MathML":
            return 2;
        default:
            return 0;
    }
}
function $5c00e1cb1faeed50$var$getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace) switch(type){
        case "svg":
            return 1;
        case "math":
            return 2;
        default:
            return 0;
    }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
}
function $5c00e1cb1faeed50$var$createHoistableInstance(type, props, rootContainerInstance, internalInstanceHandle) {
    rootContainerInstance = $5c00e1cb1faeed50$var$getOwnerDocumentFromRootContainer(rootContainerInstance).createElement(type);
    rootContainerInstance[$5c00e1cb1faeed50$var$internalInstanceKey] = internalInstanceHandle;
    rootContainerInstance[$5c00e1cb1faeed50$var$internalPropsKey] = props;
    $5c00e1cb1faeed50$var$setInitialProperties(rootContainerInstance, type, props);
    $5c00e1cb1faeed50$var$markNodeAsHoistable(rootContainerInstance);
    return rootContainerInstance;
}
function $5c00e1cb1faeed50$var$shouldSetTextContent(type, props) {
    return "textarea" === type || "noscript" === type || "string" === typeof props.children || "number" === typeof props.children || "bigint" === typeof props.children || "object" === typeof props.dangerouslySetInnerHTML && null !== props.dangerouslySetInnerHTML && null != props.dangerouslySetInnerHTML.__html;
}
var $5c00e1cb1faeed50$var$currentPopstateTransitionEvent = null;
function $5c00e1cb1faeed50$var$shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
        if (event === $5c00e1cb1faeed50$var$currentPopstateTransitionEvent) return !1;
        $5c00e1cb1faeed50$var$currentPopstateTransitionEvent = event;
        return !0;
    }
    $5c00e1cb1faeed50$var$currentPopstateTransitionEvent = null;
    return !1;
}
var $5c00e1cb1faeed50$var$scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, $5c00e1cb1faeed50$var$cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, $5c00e1cb1faeed50$var$localPromise = "function" === typeof Promise ? Promise : void 0, $5c00e1cb1faeed50$var$localRequestAnimationFrame = "function" === typeof requestAnimationFrame ? requestAnimationFrame : $5c00e1cb1faeed50$var$scheduleTimeout, $5c00e1cb1faeed50$var$scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof $5c00e1cb1faeed50$var$localPromise ? function(callback) {
    return $5c00e1cb1faeed50$var$localPromise.resolve(null).then(callback).catch($5c00e1cb1faeed50$var$handleErrorInNextTick);
} : $5c00e1cb1faeed50$var$scheduleTimeout;
function $5c00e1cb1faeed50$var$handleErrorInNextTick(error) {
    setTimeout(function() {
        throw error;
    });
}
function $5c00e1cb1faeed50$var$isSingletonScope(type) {
    return "head" === type;
}
function $5c00e1cb1faeed50$var$clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node || "/&" === node) {
                if (0 === depth) {
                    parentInstance.removeChild(nextNode);
                    $5c00e1cb1faeed50$var$retryIfBlockedOn(hydrationInstance);
                    return;
                }
                depth--;
            } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node) depth++;
            else if ("html" === node) $5c00e1cb1faeed50$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.documentElement);
            else if ("head" === node) {
                node = parentInstance.ownerDocument.head;
                $5c00e1cb1faeed50$var$clearSingletonPreambleContribution(node);
                for(var node$jscomp$0 = node.firstChild; node$jscomp$0;){
                    var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
                    node$jscomp$0[$5c00e1cb1faeed50$var$internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
                    node$jscomp$0 = nextNode$jscomp$0;
                }
            } else "body" === node && $5c00e1cb1faeed50$var$clearSingletonPreambleContribution(parentInstance.ownerDocument.body);
        }
        node = nextNode;
    }while (node);
    $5c00e1cb1faeed50$var$retryIfBlockedOn(hydrationInstance);
}
function $5c00e1cb1faeed50$var$hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType) {
            if (node = nextNode.data, "/$" === node) {
                if (0 === suspenseInstance) break;
                else suspenseInstance--;
            } else "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
        }
        node = nextNode;
    }while (node);
}
function $5c00e1cb1faeed50$var$applyViewTransitionName(instance, name, className) {
    name = CSS.escape(name) !== name ? "r-" + btoa(name).replace(/=/g, "") : name;
    instance.style.viewTransitionName = name;
    null != className && (instance.style.viewTransitionClass = className);
    className = getComputedStyle(instance);
    if ("inline" === className.display) {
        name = instance.getClientRects();
        if (1 === name.length) var JSCompiler_inline_result = 1;
        else for(var i = JSCompiler_inline_result = 0; i < name.length; i++){
            var rect = name[i];
            0 < rect.width && 0 < rect.height && JSCompiler_inline_result++;
        }
        1 === JSCompiler_inline_result && (instance = instance.style, instance.display = 1 === name.length ? "inline-block" : "block", instance.marginTop = "-" + className.paddingTop, instance.marginBottom = "-" + className.paddingBottom);
    }
}
function $5c00e1cb1faeed50$var$restoreViewTransitionName(instance, props) {
    instance = instance.style;
    props = props.style;
    var viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionName") ? props.viewTransitionName : props.hasOwnProperty("view-transition-name") ? props["view-transition-name"] : null : null;
    instance.viewTransitionName = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    viewTransitionName = null != props ? props.hasOwnProperty("viewTransitionClass") ? props.viewTransitionClass : props.hasOwnProperty("view-transition-class") ? props["view-transition-class"] : null : null;
    instance.viewTransitionClass = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : ("" + viewTransitionName).trim();
    "inline-block" === instance.display && (null == props ? instance.display = instance.margin = "" : (viewTransitionName = props.display, instance.display = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, viewTransitionName = props.margin, null != viewTransitionName ? instance.margin = viewTransitionName : (viewTransitionName = props.hasOwnProperty("marginTop") ? props.marginTop : props["margin-top"], instance.marginTop = null == viewTransitionName || "boolean" === typeof viewTransitionName ? "" : viewTransitionName, props = props.hasOwnProperty("marginBottom") ? props.marginBottom : props["margin-bottom"], instance.marginBottom = null == props || "boolean" === typeof props ? "" : props)));
}
function $5c00e1cb1faeed50$var$createMeasurement(rect, computedStyle, element) {
    element = element.ownerDocument.defaultView;
    return {
        rect: rect,
        abs: "absolute" === computedStyle.position || "fixed" === computedStyle.position,
        clip: "none" !== computedStyle.clipPath || "visible" !== computedStyle.overflow || "none" !== computedStyle.filter || "none" !== computedStyle.mask || "none" !== computedStyle.mask || "0px" !== computedStyle.borderRadius,
        view: 0 <= rect.bottom && 0 <= rect.right && rect.top <= element.innerHeight && rect.left <= element.innerWidth
    };
}
function $5c00e1cb1faeed50$var$measureInstance(instance) {
    var rect = instance.getBoundingClientRect(), computedStyle = getComputedStyle(instance);
    return $5c00e1cb1faeed50$var$createMeasurement(rect, computedStyle, instance);
}
function $5c00e1cb1faeed50$var$measureClonedInstance(instance) {
    var measuredRect = instance.getBoundingClientRect();
    measuredRect = new DOMRect(measuredRect.x + 2e4, measuredRect.y + 2e4, measuredRect.width, measuredRect.height);
    var computedStyle = getComputedStyle(instance);
    return $5c00e1cb1faeed50$var$createMeasurement(measuredRect, computedStyle, instance);
}
function $5c00e1cb1faeed50$var$forceLayout(ownerDocument) {
    return ownerDocument.documentElement.clientHeight;
}
function $5c00e1cb1faeed50$var$waitForImageToLoad(resolve) {
    this.addEventListener("load", resolve);
    this.addEventListener("error", resolve);
}
function $5c00e1cb1faeed50$var$startViewTransition(suspendedState, rootContainer, transitionTypes, mutationCallback, layoutCallback, afterMutationCallback, spawnedWorkCallback, passiveCallback, errorCallback) {
    var ownerDocument = 9 === rootContainer.nodeType ? rootContainer : rootContainer.ownerDocument;
    try {
        var transition = ownerDocument.startViewTransition({
            update: function() {
                var ownerWindow = ownerDocument.defaultView, pendingNavigation = ownerWindow.navigation && ownerWindow.navigation.transition, previousFontLoadingStatus = ownerDocument.fonts.status;
                mutationCallback();
                var blockingPromises = [];
                "loaded" === previousFontLoadingStatus && ($5c00e1cb1faeed50$var$forceLayout(ownerDocument), "loading" === ownerDocument.fonts.status && blockingPromises.push(ownerDocument.fonts.ready));
                previousFontLoadingStatus = blockingPromises.length;
                if (null !== suspendedState) for(var suspenseyImages = suspendedState.suspenseyImages, imgBytes = 0, i = 0; i < suspenseyImages.length; i++){
                    var suspenseyImage = suspenseyImages[i];
                    if (!suspenseyImage.complete) {
                        var rect = suspenseyImage.getBoundingClientRect();
                        if (0 < rect.bottom && 0 < rect.right && rect.top < ownerWindow.innerHeight && rect.left < ownerWindow.innerWidth) {
                            imgBytes += $5c00e1cb1faeed50$var$estimateImageBytes(suspenseyImage);
                            if (imgBytes > $5c00e1cb1faeed50$var$estimatedBytesWithinLimit) {
                                blockingPromises.length = previousFontLoadingStatus;
                                break;
                            }
                            suspenseyImage = new Promise($5c00e1cb1faeed50$var$waitForImageToLoad.bind(suspenseyImage));
                            blockingPromises.push(suspenseyImage);
                        }
                    }
                }
                if (0 < blockingPromises.length) return ownerWindow = Promise.race([
                    Promise.all(blockingPromises),
                    new Promise(function(resolve) {
                        return setTimeout(resolve, 500);
                    })
                ]).then(layoutCallback, layoutCallback), (pendingNavigation ? Promise.allSettled([
                    pendingNavigation.finished,
                    ownerWindow
                ]) : ownerWindow).then(afterMutationCallback, afterMutationCallback);
                layoutCallback();
                if (pendingNavigation) return pendingNavigation.finished.then(afterMutationCallback, afterMutationCallback);
                afterMutationCallback();
            },
            types: transitionTypes
        });
        ownerDocument.__reactViewTransition = transition;
        var viewTransitionAnimations = [];
        transition.ready.then(function() {
            for(var animations = ownerDocument.documentElement.getAnimations({
                subtree: !0
            }), i = 0; i < animations.length; i++){
                var animation = animations[i], effect = animation.effect, pseudoElement = effect.pseudoElement;
                if (null != pseudoElement && pseudoElement.startsWith("::view-transition")) {
                    viewTransitionAnimations.push(animation);
                    animation = effect.getKeyframes();
                    for(var height = pseudoElement = void 0, unchangedDimensions = !0, j = 0; j < animation.length; j++){
                        var keyframe = animation[j], w = keyframe.width;
                        if (void 0 === pseudoElement) pseudoElement = w;
                        else if (pseudoElement !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        w = keyframe.height;
                        if (void 0 === height) height = w;
                        else if (height !== w) {
                            unchangedDimensions = !1;
                            break;
                        }
                        delete keyframe.width;
                        delete keyframe.height;
                        "none" === keyframe.transform && delete keyframe.transform;
                    }
                    unchangedDimensions && void 0 !== pseudoElement && void 0 !== height && (effect.setKeyframes(animation), unchangedDimensions = getComputedStyle(effect.target, effect.pseudoElement), unchangedDimensions.width !== pseudoElement || unchangedDimensions.height !== height) && (unchangedDimensions = animation[0], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, unchangedDimensions = animation[animation.length - 1], unchangedDimensions.width = pseudoElement, unchangedDimensions.height = height, effect.setKeyframes(animation));
                }
            }
            spawnedWorkCallback();
        }, function(error) {
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            try {
                if ("object" === typeof error && null !== error) switch(error.name){
                    case "InvalidStateError":
                        if ("View transition was skipped because document visibility state is hidden." === error.message || "Skipping view transition because document visibility state has become hidden." === error.message || "Skipping view transition because viewport size changed." === error.message || "Transition was aborted because of invalid state" === error.message) error = null;
                }
                null !== error && errorCallback(error);
            } finally{
                mutationCallback(), layoutCallback(), spawnedWorkCallback();
            }
        });
        transition.finished.finally(function() {
            for(var i = 0; i < viewTransitionAnimations.length; i++)viewTransitionAnimations[i].cancel();
            ownerDocument.__reactViewTransition === transition && (ownerDocument.__reactViewTransition = null);
            passiveCallback();
        });
        return transition;
    } catch (x) {
        return mutationCallback(), layoutCallback(), spawnedWorkCallback(), null;
    }
}
function $5c00e1cb1faeed50$var$ViewTransitionPseudoElement(pseudo, name) {
    this._scope = document.documentElement;
    this._selector = "::view-transition-" + pseudo + "(" + name + ")";
}
$5c00e1cb1faeed50$var$ViewTransitionPseudoElement.prototype.animate = function(keyframes, options) {
    options = "number" === typeof options ? {
        duration: options
    } : $5c00e1cb1faeed50$var$assign({}, options);
    options.pseudoElement = this._selector;
    return this._scope.animate(keyframes, options);
};
$5c00e1cb1faeed50$var$ViewTransitionPseudoElement.prototype.getAnimations = function() {
    for(var scope = this._scope, selector = this._selector, animations = scope.getAnimations({
        subtree: !0
    }), result = [], i = 0; i < animations.length; i++){
        var effect = animations[i].effect;
        null !== effect && effect.target === scope && effect.pseudoElement === selector && result.push(animations[i]);
    }
    return result;
};
$5c00e1cb1faeed50$var$ViewTransitionPseudoElement.prototype.getComputedStyle = function() {
    return getComputedStyle(this._scope, this._selector);
};
function $5c00e1cb1faeed50$var$createViewTransitionInstance(name) {
    return {
        name: name,
        group: new $5c00e1cb1faeed50$var$ViewTransitionPseudoElement("group", name),
        imagePair: new $5c00e1cb1faeed50$var$ViewTransitionPseudoElement("image-pair", name),
        old: new $5c00e1cb1faeed50$var$ViewTransitionPseudoElement("old", name),
        new: new $5c00e1cb1faeed50$var$ViewTransitionPseudoElement("new", name)
    };
}
function $5c00e1cb1faeed50$var$FragmentInstance(fragmentFiber) {
    this._fragmentFiber = fragmentFiber;
    this._observers = this._eventListeners = null;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.addEventListener = function(type, listener, optionsOrUseCapture) {
    var signal = null, cleanup = null;
    if (null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && (signal = optionsOrUseCapture.signal || null, null !== signal && signal.aborted)) return;
    null === this._eventListeners && (this._eventListeners = []);
    var listeners = this._eventListeners;
    if (-1 === $5c00e1cb1faeed50$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture)) {
        var fragmentInstance = this, attachedListener = listener;
        null != optionsOrUseCapture && "boolean" !== typeof optionsOrUseCapture && !0 === optionsOrUseCapture.once && (attachedListener = function(event) {
            fragmentInstance.removeEventListener(type, listener, optionsOrUseCapture);
            "function" === typeof listener ? listener.call(this, event) : listener.handleEvent(event);
        });
        null !== signal && (cleanup = fragmentInstance.removeEventListener.bind(fragmentInstance, type, listener, optionsOrUseCapture), signal.addEventListener("abort", cleanup, {
            once: !0
        }), cleanup = signal.removeEventListener.bind(signal, "abort", cleanup));
        signal = $5c00e1cb1faeed50$var$getAttachOptions(optionsOrUseCapture);
        listeners.push({
            type: type,
            listener: listener,
            optionsOrUseCapture: optionsOrUseCapture,
            attachedListener: attachedListener,
            cleanup: cleanup
        });
        $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$addEventListenerToChild, type, attachedListener, signal);
    }
    this._eventListeners = listeners;
};
function $5c00e1cb1faeed50$var$addEventListenerToChild(child, type, listener, optionsOrUseCapture) {
    $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child).addEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.removeEventListener = function(type, listener, optionsOrUseCapture) {
    var listeners = this._eventListeners;
    if (null !== listeners && (listener = $5c00e1cb1faeed50$var$indexOfEventListener(listeners, type, listener, optionsOrUseCapture), -1 !== listener)) {
        var _listeners$index = listeners[listener];
        optionsOrUseCapture = _listeners$index.attachedListener;
        var cleanup = _listeners$index.cleanup;
        _listeners$index = $5c00e1cb1faeed50$var$getAttachOptions(_listeners$index.optionsOrUseCapture);
        $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$removeEventListenerFromChild, type, optionsOrUseCapture, _listeners$index);
        listeners.splice(listener, 1);
        null !== cleanup && cleanup();
    }
};
function $5c00e1cb1faeed50$var$removeEventListenerFromChild(child, type, listener, optionsOrUseCapture) {
    $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child).removeEventListener(type, listener, optionsOrUseCapture);
    return !1;
}
function $5c00e1cb1faeed50$var$getAttachOptions(opts) {
    return null != opts && "boolean" !== typeof opts && (!0 === opts.once || opts.signal instanceof AbortSignal) ? {
        capture: opts.capture,
        passive: opts.passive
    } : opts;
}
function $5c00e1cb1faeed50$var$normalizeListenerOptions(opts) {
    return null == opts ? "c=0" : "boolean" === typeof opts ? "c=" + (opts ? "1" : "0") : "c=" + (opts.capture ? "1" : "0");
}
function $5c00e1cb1faeed50$var$indexOfEventListener(eventListeners, type, listener, optionsOrUseCapture) {
    if (0 === eventListeners.length) return -1;
    optionsOrUseCapture = $5c00e1cb1faeed50$var$normalizeListenerOptions(optionsOrUseCapture);
    for(var i = 0; i < eventListeners.length; i++){
        var item = eventListeners[i];
        if (item.type === type && item.listener === listener && $5c00e1cb1faeed50$var$normalizeListenerOptions(item.optionsOrUseCapture) === optionsOrUseCapture) return i;
    }
    return -1;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.dispatchEvent = function(event) {
    var parentHostFiber = $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return !0;
    parentHostFiber = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(parentHostFiber);
    var eventListeners = this._eventListeners;
    if (null !== eventListeners && 0 < eventListeners.length || !event.bubbles) {
        var temp = 9 === parentHostFiber.nodeType ? parentHostFiber.createComment("") : document.createTextNode("");
        if (eventListeners) for(var i = 0; i < eventListeners.length; i++){
            var _eventListeners$i = eventListeners[i];
            temp.addEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $5c00e1cb1faeed50$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        }
        parentHostFiber.appendChild(temp);
        event = temp.dispatchEvent(event);
        if (eventListeners) for(i = 0; i < eventListeners.length; i++)_eventListeners$i = eventListeners[i], temp.removeEventListener(_eventListeners$i.type, _eventListeners$i.attachedListener, $5c00e1cb1faeed50$var$getAttachOptions(_eventListeners$i.optionsOrUseCapture));
        parentHostFiber.removeChild(temp);
        return event;
    }
    return parentHostFiber.dispatchEvent(event);
};
$5c00e1cb1faeed50$var$FragmentInstance.prototype.focus = function(focusOptions) {
    $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $5c00e1cb1faeed50$var$setFocusOnFiberIfFocusable, focusOptions, void 0, void 0);
};
function $5c00e1cb1faeed50$var$setFocusOnFiberIfFocusable(fiber, focusOptions) {
    if (6 === fiber.tag) return !1;
    fiber = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(fiber);
    return $5c00e1cb1faeed50$var$setFocusIfFocusable(fiber, focusOptions);
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.focusLast = function(focusOptions) {
    var children = [];
    $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !0, $5c00e1cb1faeed50$var$collectChildren, children, void 0, void 0);
    for(var i = children.length - 1; 0 <= i && !$5c00e1cb1faeed50$var$setFocusOnFiberIfFocusable(children[i], focusOptions); i--);
};
function $5c00e1cb1faeed50$var$collectChildren(child, collection) {
    collection.push(child);
    return !1;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.blur = function() {
    var parentHostFiber = $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    null !== parentHostFiber && (parentHostFiber = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(parentHostFiber), parentHostFiber = $5c00e1cb1faeed50$var$getOwnerDocumentFromRootContainer(parentHostFiber).activeElement, null !== parentHostFiber && $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$blurActiveElementWithinFragment, parentHostFiber, void 0, void 0));
};
function $5c00e1cb1faeed50$var$blurActiveElementWithinFragment(child, activeElement) {
    if (6 === child.tag) return !1;
    child = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child);
    return child === activeElement || child.contains(activeElement) ? (activeElement.blur(), !0) : !1;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.observeUsing = function(observer) {
    null === this._observers && (this._observers = new Set());
    this._observers.add(observer);
    $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$observeChild, observer, void 0, void 0);
};
function $5c00e1cb1faeed50$var$observeChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child);
    observer.observe(child);
    return !1;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.unobserveUsing = function(observer) {
    var observers = this._observers;
    if (null !== observers && observers.has(observer)) {
        observers.delete(observer);
        $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$unobserveChild, observer, void 0, void 0);
        for(var i = observers = 0; i < $5c00e1cb1faeed50$var$pendingIntersectionUnobserves.length; i++){
            var pending = $5c00e1cb1faeed50$var$pendingIntersectionUnobserves[i];
            pending.fragmentInstance === this && pending.observer === observer ? observer.unobserve(pending.instance) : $5c00e1cb1faeed50$var$pendingIntersectionUnobserves[observers++] = pending;
        }
        $5c00e1cb1faeed50$var$pendingIntersectionUnobserves.length = observers;
    }
};
function $5c00e1cb1faeed50$var$unobserveChild(child, observer) {
    if (6 === child.tag) return !1;
    child = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child);
    observer.unobserve(child);
    return !1;
}
var $5c00e1cb1faeed50$var$pendingIntersectionUnobserves = [], $5c00e1cb1faeed50$var$intersectionUnobserveScheduled = !1;
function $5c00e1cb1faeed50$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, instance) {
    $5c00e1cb1faeed50$var$pendingIntersectionUnobserves.push({
        fragmentInstance: fragmentInstance,
        observer: observer,
        instance: instance
    });
    $5c00e1cb1faeed50$var$intersectionUnobserveScheduled || ($5c00e1cb1faeed50$var$intersectionUnobserveScheduled = !0, $5c00e1cb1faeed50$var$requestPostPaintCallback(function() {
        $5c00e1cb1faeed50$var$intersectionUnobserveScheduled = !1;
        var pending = $5c00e1cb1faeed50$var$pendingIntersectionUnobserves;
        $5c00e1cb1faeed50$var$pendingIntersectionUnobserves = [];
        for(var i = 0; i < pending.length; i++){
            var item = pending[i];
            item.observer.unobserve(item.instance);
        }
    }));
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.getClientRects = function() {
    var rects = [];
    $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$collectClientRects, rects, void 0, void 0);
    return rects;
};
function $5c00e1cb1faeed50$var$collectClientRects(child, rects) {
    if (6 === child.tag) {
        child = child.stateNode;
        var range = child.ownerDocument.createRange();
        range.selectNodeContents(child);
        rects.push.apply(rects, range.getClientRects());
    } else child = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child), rects.push.apply(rects, child.getClientRects());
    return !1;
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.getRootNode = function(getRootNodeOptions) {
    var parentHostFiber = $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    return null === parentHostFiber ? this : $5c00e1cb1faeed50$var$getInstanceFromHostFiber(parentHostFiber).getRootNode(getRootNodeOptions);
};
$5c00e1cb1faeed50$var$FragmentInstance.prototype.compareDocumentPosition = function(otherNode) {
    var parentHostFiber = $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber);
    if (null === parentHostFiber) return Node.DOCUMENT_POSITION_DISCONNECTED;
    var children = [];
    $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$collectChildren, children, void 0, void 0);
    var parentHostInstance = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(parentHostFiber);
    if (0 === children.length) {
        children = parentHostInstance;
        if ($5c00e1cb1faeed50$var$fiberIsPortaledIntoHost(this._fragmentFiber)) {
            a: {
                for(parentHostFiber = this._fragmentFiber.return; null !== parentHostFiber;){
                    if (4 === parentHostFiber.tag) {
                        parentHostFiber = parentHostFiber.stateNode.containerInfo;
                        break a;
                    }
                    if (3 === parentHostFiber.tag || 5 === parentHostFiber.tag || 27 === parentHostFiber.tag) break;
                    parentHostFiber = parentHostFiber.return;
                }
                parentHostFiber = null;
            }
            null != parentHostFiber && (children = parentHostFiber);
        }
        parentHostFiber = this._fragmentFiber;
        var result = parentHostInstance = children.compareDocumentPosition(otherNode);
        children === otherNode ? result = Node.DOCUMENT_POSITION_CONTAINS : parentHostInstance & Node.DOCUMENT_POSITION_CONTAINED_BY && (children = $5c00e1cb1faeed50$var$getFragmentInstanceOrTextInstanceSiblings(parentHostFiber)[1], null === children ? result = Node.DOCUMENT_POSITION_PRECEDING : (otherNode = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(children).compareDocumentPosition(otherNode), result = 0 === otherNode || otherNode & Node.DOCUMENT_POSITION_FOLLOWING ? Node.DOCUMENT_POSITION_FOLLOWING : Node.DOCUMENT_POSITION_PRECEDING));
        return result |= Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
    }
    parentHostFiber = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(children[0]);
    result = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(children[children.length - 1]);
    var parentHostInstanceFromDOM = $5c00e1cb1faeed50$var$fiberIsPortaledIntoHost(this._fragmentFiber) ? parentHostFiber.parentElement : parentHostInstance;
    if (null == parentHostInstanceFromDOM) return Node.DOCUMENT_POSITION_DISCONNECTED;
    parentHostInstance = parentHostInstanceFromDOM.compareDocumentPosition(parentHostFiber) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    parentHostInstanceFromDOM = parentHostInstanceFromDOM.compareDocumentPosition(result) & Node.DOCUMENT_POSITION_CONTAINED_BY;
    var firstResult = parentHostFiber.compareDocumentPosition(otherNode), lastResult = result.compareDocumentPosition(otherNode), otherNodeIsWithinFirstOrLastChild = firstResult & Node.DOCUMENT_POSITION_CONTAINED_BY || lastResult & Node.DOCUMENT_POSITION_CONTAINED_BY;
    lastResult = parentHostInstance && parentHostInstanceFromDOM && firstResult & Node.DOCUMENT_POSITION_FOLLOWING && lastResult & Node.DOCUMENT_POSITION_PRECEDING;
    parentHostFiber = parentHostInstance && parentHostFiber === otherNode || parentHostInstanceFromDOM && result === otherNode || otherNodeIsWithinFirstOrLastChild || lastResult ? Node.DOCUMENT_POSITION_CONTAINED_BY : !parentHostInstance && parentHostFiber === otherNode || !parentHostInstanceFromDOM && result === otherNode ? Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC : firstResult;
    return parentHostFiber & Node.DOCUMENT_POSITION_DISCONNECTED || parentHostFiber & Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC || $5c00e1cb1faeed50$var$validateDocumentPositionWithFiberTree(parentHostFiber, this._fragmentFiber, children[0], children[children.length - 1], otherNode) ? parentHostFiber : Node.DOCUMENT_POSITION_IMPLEMENTATION_SPECIFIC;
};
function $5c00e1cb1faeed50$var$validateDocumentPositionWithFiberTree(documentPosition, fragmentFiber, precedingBoundaryFiber, followingBoundaryFiber, otherNode) {
    var otherFiber = $5c00e1cb1faeed50$var$getClosestInstanceFromNode(otherNode);
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINED_BY) {
        if (precedingBoundaryFiber = !!otherFiber) a: {
            for(; null !== otherFiber;){
                if (7 === otherFiber.tag && (otherFiber === fragmentFiber || otherFiber.alternate === fragmentFiber)) {
                    precedingBoundaryFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            precedingBoundaryFiber = !1;
        }
        return precedingBoundaryFiber;
    }
    if (documentPosition & Node.DOCUMENT_POSITION_CONTAINS) {
        if (null === otherFiber) return otherFiber = otherNode.ownerDocument, otherNode === otherFiber || otherNode === otherFiber.documentElement || otherNode === otherFiber.body;
        a: {
            otherFiber = fragmentFiber;
            for(fragmentFiber = $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(fragmentFiber); null !== otherFiber;){
                if (!(5 !== otherFiber.tag && 3 !== otherFiber.tag && 27 !== otherFiber.tag || otherFiber !== fragmentFiber && otherFiber.alternate !== fragmentFiber)) {
                    otherFiber = !0;
                    break a;
                }
                otherFiber = otherFiber.return;
            }
            otherFiber = !1;
        }
        return otherFiber;
    }
    return documentPosition & Node.DOCUMENT_POSITION_PRECEDING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === precedingBoundaryFiber) && (fragmentFiber = $5c00e1cb1faeed50$var$getLowestCommonAncestor(precedingBoundaryFiber, otherFiber, $5c00e1cb1faeed50$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $5c00e1cb1faeed50$var$isFiberPrecedingCheck, otherFiber, precedingBoundaryFiber), otherFiber = $5c00e1cb1faeed50$var$searchTarget, $5c00e1cb1faeed50$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : documentPosition & Node.DOCUMENT_POSITION_FOLLOWING ? ((fragmentFiber = !!otherFiber) && !(fragmentFiber = otherFiber === followingBoundaryFiber) && (fragmentFiber = $5c00e1cb1faeed50$var$getLowestCommonAncestor(followingBoundaryFiber, otherFiber, $5c00e1cb1faeed50$var$getParentForFragmentAncestors), null === fragmentFiber ? fragmentFiber = !1 : ($5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(fragmentFiber, !0, $5c00e1cb1faeed50$var$isFiberFollowingCheck, otherFiber, followingBoundaryFiber), otherFiber = $5c00e1cb1faeed50$var$searchTarget, $5c00e1cb1faeed50$var$searchBoundary = $5c00e1cb1faeed50$var$searchTarget = null, fragmentFiber = null !== otherFiber)), fragmentFiber) : !1;
}
function $5c00e1cb1faeed50$var$scrollTextNodeIntoView(textNode, resolvedAlignToTop) {
    var range = textNode.ownerDocument.createRange();
    range.selectNodeContents(textNode);
    textNode = range.getBoundingClientRect();
    window.scrollTo(window.scrollX + textNode.left, resolvedAlignToTop ? window.scrollY + textNode.top : window.scrollY + textNode.bottom - window.innerHeight);
}
$5c00e1cb1faeed50$var$FragmentInstance.prototype.scrollIntoView = function(alignToTop) {
    if ("object" === typeof alignToTop) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(566));
    var children = [];
    $5c00e1cb1faeed50$var$traverseVisibleInstancesAndTextInstances(this._fragmentFiber.child, !1, $5c00e1cb1faeed50$var$collectChildren, children, void 0, void 0);
    var resolvedAlignToTop = !1 !== alignToTop;
    if (0 === children.length) {
        var hostSiblings = $5c00e1cb1faeed50$var$getFragmentInstanceOrTextInstanceSiblings(this._fragmentFiber);
        hostSiblings = resolvedAlignToTop ? hostSiblings[1] || hostSiblings[0] || $5c00e1cb1faeed50$var$getFragmentParentInstanceOrContainerFiber(this._fragmentFiber) : hostSiblings[0] || hostSiblings[1];
        if (null === hostSiblings) return;
        if (6 === hostSiblings.tag) {
            alignToTop = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(hostSiblings);
            $5c00e1cb1faeed50$var$scrollTextNodeIntoView(alignToTop, resolvedAlignToTop);
            return;
        }
        hostSiblings = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(hostSiblings);
        if (9 !== hostSiblings.nodeType) {
            if (11 === hostSiblings.nodeType) {
                resolvedAlignToTop = "host" in hostSiblings ? hostSiblings.host : null;
                null !== resolvedAlignToTop && resolvedAlignToTop.scrollIntoView(alignToTop);
                return;
            }
            hostSiblings.scrollIntoView(alignToTop);
        }
    }
    for(hostSiblings = resolvedAlignToTop ? children.length - 1 : 0; hostSiblings !== (resolvedAlignToTop ? -1 : children.length);){
        var child = children[hostSiblings];
        6 === child.tag ? (child = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child), $5c00e1cb1faeed50$var$scrollTextNodeIntoView(child, resolvedAlignToTop)) : $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child).scrollIntoView(alignToTop);
        hostSiblings += resolvedAlignToTop ? -1 : 1;
    }
};
function $5c00e1cb1faeed50$var$addFragmentHandleToFiber(child, fragmentInstance) {
    child = $5c00e1cb1faeed50$var$getInstanceFromHostFiber(child);
    $5c00e1cb1faeed50$var$addFragmentHandleToInstance(child, fragmentInstance);
    return !1;
}
function $5c00e1cb1faeed50$var$addFragmentHandleToInstance(instance, fragmentInstance) {
    null == instance.reactFragments && (instance.reactFragments = new Set());
    instance.reactFragments.add(fragmentInstance);
}
function $5c00e1cb1faeed50$var$commitNewChildToFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i$jscomp$0 = 0; i$jscomp$0 < eventListeners.length; i$jscomp$0++){
        var _eventListeners$i3 = eventListeners[i$jscomp$0];
        childInstance.addEventListener(_eventListeners$i3.type, _eventListeners$i3.attachedListener, $5c00e1cb1faeed50$var$getAttachOptions(_eventListeners$i3.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        for(var writeIdx = 0, i = 0; i < $5c00e1cb1faeed50$var$pendingIntersectionUnobserves.length; i++){
            var pending = $5c00e1cb1faeed50$var$pendingIntersectionUnobserves[i];
            if (pending.fragmentInstance !== fragmentInstance || pending.observer !== observer || pending.instance !== childInstance) $5c00e1cb1faeed50$var$pendingIntersectionUnobserves[writeIdx++] = pending;
        }
        $5c00e1cb1faeed50$var$pendingIntersectionUnobserves.length = writeIdx;
        observer.observe(childInstance);
    }), $5c00e1cb1faeed50$var$addFragmentHandleToInstance(childInstance, fragmentInstance));
}
function $5c00e1cb1faeed50$var$deleteChildFromFragmentInstance(childInstance, fragmentInstance) {
    var eventListeners = fragmentInstance._eventListeners;
    if (null !== eventListeners) for(var i = 0; i < eventListeners.length; i++){
        var _eventListeners$i4 = eventListeners[i];
        childInstance.removeEventListener(_eventListeners$i4.type, _eventListeners$i4.attachedListener, $5c00e1cb1faeed50$var$getAttachOptions(_eventListeners$i4.optionsOrUseCapture));
    }
    3 !== childInstance.nodeType && (eventListeners = fragmentInstance._observers, null !== eventListeners && eventListeners.forEach(function(observer) {
        "string" === typeof observer.rootMargin ? $5c00e1cb1faeed50$var$schedulePendingIntersectionUnobserve(fragmentInstance, observer, childInstance) : observer.unobserve(childInstance);
    }), null != childInstance.reactFragments && childInstance.reactFragments.delete(fragmentInstance));
}
function $5c00e1cb1faeed50$var$clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for(; nextNode;){
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch(node.nodeName){
            case "HTML":
            case "HEAD":
            case "BODY":
                $5c00e1cb1faeed50$var$clearContainerSparingly(node);
                $5c00e1cb1faeed50$var$detachDeletedInstance(node);
                continue;
            case "SCRIPT":
            case "STYLE":
                continue;
            case "LINK":
                if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
    }
}
function $5c00e1cb1faeed50$var$canHydrateInstance(instance, type, props, inRootOrSingleton) {
    for(; 1 === instance.nodeType;){
        var anyProps = props;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
            if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type)) break;
        } else if (!inRootOrSingleton) {
            if ("input" === type && "hidden" === instance.type) {
                var name = null == anyProps.name ? null : "" + anyProps.name;
                if ("hidden" === anyProps.type && instance.getAttribute("name") === name) return instance;
            } else return instance;
        } else if (!instance[$5c00e1cb1faeed50$var$internalHoistableMarker]) switch(type){
            case "meta":
                if (!instance.hasAttribute("itemprop")) break;
                return instance;
            case "link":
                name = instance.getAttribute("rel");
                if ("stylesheet" === name && instance.hasAttribute("data-precedence")) break;
                else if (name !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title)) break;
                return instance;
            case "style":
                if (instance.hasAttribute("data-precedence")) break;
                return instance;
            case "script":
                name = instance.getAttribute("src");
                if ((name !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name && instance.hasAttribute("async") && !instance.hasAttribute("itemprop")) break;
                return instance;
            default:
                return instance;
        }
        instance = $5c00e1cb1faeed50$var$getNextHydratable(instance.nextSibling);
        if (null === instance) break;
    }
    return null;
}
function $5c00e1cb1faeed50$var$canHydrateTextInstance(instance, text, inRootOrSingleton) {
    if ("" === text) return null;
    for(; 3 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $5c00e1cb1faeed50$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $5c00e1cb1faeed50$var$canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for(; 8 !== instance.nodeType;){
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton) return null;
        instance = $5c00e1cb1faeed50$var$getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
    }
    return instance;
}
function $5c00e1cb1faeed50$var$isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
}
function $5c00e1cb1faeed50$var$isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
}
function $5c00e1cb1faeed50$var$registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState) callback();
    else {
        var listener = function() {
            callback();
            ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
    }
}
function $5c00e1cb1faeed50$var$getNextHydratable(node) {
    for(; null != node; node = node.nextSibling){
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
            nodeType = node.data;
            if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType) break;
            if ("/$" === nodeType || "/&" === nodeType) return null;
        }
    }
    return node;
}
var $5c00e1cb1faeed50$var$previousHydratableOnEnteringScopedSingleton = null;
function $5c00e1cb1faeed50$var$getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for(var depth = 0; hydrationInstance;){
        if (8 === hydrationInstance.nodeType) {
            var data = hydrationInstance.data;
            if ("/$" === data || "/&" === data) {
                if (0 === depth) return $5c00e1cb1faeed50$var$getNextHydratable(hydrationInstance.nextSibling);
                depth--;
            } else "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
}
function $5c00e1cb1faeed50$var$getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for(var depth = 0; targetInstance;){
        if (8 === targetInstance.nodeType) {
            var data = targetInstance.data;
            if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
                if (0 === depth) return targetInstance;
                depth--;
            } else "/$" !== data && "/&" !== data || depth++;
        }
        targetInstance = targetInstance.previousSibling;
    }
    return null;
}
function $5c00e1cb1faeed50$var$setFocusIfFocusable(node, focusOptions) {
    function handleFocus() {
        didFocus = !0;
    }
    if (node.ownerDocument.activeElement === node) return !0;
    var didFocus = !1;
    try {
        node.ownerDocument.addEventListener("focus", handleFocus, !0), (node.focus || HTMLElement.prototype.focus).call(node, focusOptions);
    } finally{
        node.ownerDocument.removeEventListener("focus", handleFocus, !0);
    }
    return didFocus;
}
function $5c00e1cb1faeed50$var$requestPostPaintCallback(callback) {
    $5c00e1cb1faeed50$var$localRequestAnimationFrame(function() {
        $5c00e1cb1faeed50$var$localRequestAnimationFrame(function(time) {
            return callback(time);
        });
    });
}
function $5c00e1cb1faeed50$var$resolveSingletonInstance(type, props, rootContainerInstance) {
    props = $5c00e1cb1faeed50$var$getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch(type){
        case "html":
            type = props.documentElement;
            if (!type) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(452));
            return type;
        case "head":
            type = props.head;
            if (!type) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(453));
            return type;
        case "body":
            type = props.body;
            if (!type) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(454));
            return type;
        default:
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(451));
    }
}
function $5c00e1cb1faeed50$var$releaseSingletonInstance(instance, type, props) {
    for(var propKey in props){
        var propValue = props[propKey];
        props.hasOwnProperty(propKey) && null != propValue && $5c00e1cb1faeed50$var$setProp(instance, type, propKey, null, $5c00e1cb1faeed50$var$emptyProps, propValue);
    }
    null != props.dangerouslySetInnerHTML && (instance.textContent = "");
    instance.onclick === $5c00e1cb1faeed50$var$noop$1 && (instance.onclick = null);
    $5c00e1cb1faeed50$var$detachDeletedInstance(instance);
}
function $5c00e1cb1faeed50$var$clearSingletonPreambleContribution(instance) {
    for(var attributes = instance.attributes; attributes.length;)instance.removeAttributeNode(attributes[0]);
    $5c00e1cb1faeed50$var$detachDeletedInstance(instance);
}
var $5c00e1cb1faeed50$var$preloadPropsMap = new Map(), $5c00e1cb1faeed50$var$preconnectsSet = new Set();
function $5c00e1cb1faeed50$var$getHoistableRoot(container) {
    if ("function" === typeof container.getRootNode) {
        var rootNode = container.getRootNode();
        if (9 === rootNode.nodeType || 11 === rootNode.nodeType) return rootNode;
    }
    return 9 === container.nodeType ? container : container.ownerDocument;
}
var $5c00e1cb1faeed50$var$previousDispatcher = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.d;
$5c00e1cb1faeed50$var$ReactDOMSharedInternals.d = {
    f: $5c00e1cb1faeed50$var$flushSyncWork,
    r: $5c00e1cb1faeed50$var$requestFormReset,
    D: $5c00e1cb1faeed50$var$prefetchDNS,
    C: $5c00e1cb1faeed50$var$preconnect,
    L: $5c00e1cb1faeed50$var$preload,
    m: $5c00e1cb1faeed50$var$preloadModule,
    X: $5c00e1cb1faeed50$var$preinitScript,
    S: $5c00e1cb1faeed50$var$preinitStyle,
    M: $5c00e1cb1faeed50$var$preinitModuleScript
};
function $5c00e1cb1faeed50$var$flushSyncWork() {
    var previousWasRendering = $5c00e1cb1faeed50$var$previousDispatcher.f(), wasRendering = $5c00e1cb1faeed50$var$flushSyncWork$1();
    return previousWasRendering || wasRendering;
}
function $5c00e1cb1faeed50$var$requestFormReset(form) {
    var formInst = $5c00e1cb1faeed50$var$getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? $5c00e1cb1faeed50$var$requestFormReset$1(formInst) : $5c00e1cb1faeed50$var$previousDispatcher.r(form);
}
var $5c00e1cb1faeed50$var$globalDocument = "undefined" === typeof document ? null : document;
function $5c00e1cb1faeed50$var$preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = $5c00e1cb1faeed50$var$globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        $5c00e1cb1faeed50$var$preconnectsSet.has(limitedEscapedHref) || ($5c00e1cb1faeed50$var$preconnectsSet.add(limitedEscapedHref), rel = {
            rel: rel,
            crossOrigin: crossOrigin,
            href: href
        }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), $5c00e1cb1faeed50$var$setInitialProperties(href, "link", rel), $5c00e1cb1faeed50$var$markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
}
function $5c00e1cb1faeed50$var$prefetchDNS(href) {
    $5c00e1cb1faeed50$var$previousDispatcher.D(href);
    $5c00e1cb1faeed50$var$preconnectAs("dns-prefetch", href, null);
}
function $5c00e1cb1faeed50$var$preconnect(href, crossOrigin) {
    $5c00e1cb1faeed50$var$previousDispatcher.C(href, crossOrigin);
    $5c00e1cb1faeed50$var$preconnectAs("preconnect", href, crossOrigin);
}
function $5c00e1cb1faeed50$var$preload(href, as, options) {
    $5c00e1cb1faeed50$var$previousDispatcher.L(href, as, options);
    var ownerDocument = $5c00e1cb1faeed50$var$globalDocument;
    if (ownerDocument && href && as) {
        var preloadSelector = 'link[rel="preload"][as="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
        "image" === as ? options && options.imageSrcSet ? (preloadSelector += '[imagesrcset="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSrcSet) + '"]', "string" === typeof options.imageSizes && (preloadSelector += '[imagesizes="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(options.imageSizes) + '"]')) : preloadSelector += '[href="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
        var key = preloadSelector;
        switch(as){
            case "style":
                key = $5c00e1cb1faeed50$var$getStyleKey(href);
                break;
            case "script":
                key = $5c00e1cb1faeed50$var$getScriptKey(href);
        }
        if (!($5c00e1cb1faeed50$var$preloadPropsMap.has(key) || (href = $5c00e1cb1faeed50$var$assign({
            rel: "preload",
            href: "image" === as && options && options.imageSrcSet ? void 0 : href,
            as: as
        }, options), $5c00e1cb1faeed50$var$preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector($5c00e1cb1faeed50$var$getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector($5c00e1cb1faeed50$var$getScriptSelectorFromKey(key))))) {
            var instance = ownerDocument.createElement("link");
            $5c00e1cb1faeed50$var$setInitialProperties(instance, "link", href);
            "style" === as && (instance[$5c00e1cb1faeed50$var$internalLoadPendingKey] = !0, instance.onload = instance.onerror = function() {
                $5c00e1cb1faeed50$var$clearPendingLoadOnNode(instance);
            });
            $5c00e1cb1faeed50$var$markNodeAsHoistable(instance);
            ownerDocument.head.appendChild(instance);
        }
    }
}
function $5c00e1cb1faeed50$var$preloadModule(href, options) {
    $5c00e1cb1faeed50$var$previousDispatcher.m(href, options);
    var ownerDocument = $5c00e1cb1faeed50$var$globalDocument;
    if (ownerDocument && href) {
        var as = options && "string" === typeof options.as ? options.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
        switch(as){
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
                key = $5c00e1cb1faeed50$var$getScriptKey(href);
        }
        if (!$5c00e1cb1faeed50$var$preloadPropsMap.has(key) && (href = $5c00e1cb1faeed50$var$assign({
            rel: "modulepreload",
            href: href
        }, options), $5c00e1cb1faeed50$var$preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch(as){
                case "audioworklet":
                case "paintworklet":
                case "serviceworker":
                case "sharedworker":
                case "worker":
                case "script":
                    if (ownerDocument.querySelector($5c00e1cb1faeed50$var$getScriptSelectorFromKey(key))) return;
            }
            as = ownerDocument.createElement("link");
            $5c00e1cb1faeed50$var$setInitialProperties(as, "link", href);
            $5c00e1cb1faeed50$var$markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
        }
    }
}
function $5c00e1cb1faeed50$var$preinitStyle(href, precedence, options) {
    $5c00e1cb1faeed50$var$previousDispatcher.S(href, precedence, options);
    var ownerDocument = $5c00e1cb1faeed50$var$globalDocument;
    if (ownerDocument && href) {
        var styles = $5c00e1cb1faeed50$var$getResourcesFromRoot(ownerDocument).hoistableStyles, key = $5c00e1cb1faeed50$var$getStyleKey(href);
        precedence = precedence || "default";
        var resource = styles.get(key);
        if (!resource) {
            var state = {
                loading: 0,
                preload: null
            };
            if (resource = ownerDocument.querySelector($5c00e1cb1faeed50$var$getStylesheetSelectorFromKey(key))) state.loading = 5;
            else {
                href = $5c00e1cb1faeed50$var$assign({
                    rel: "stylesheet",
                    href: href,
                    "data-precedence": precedence
                }, options);
                (options = $5c00e1cb1faeed50$var$preloadPropsMap.get(key)) && $5c00e1cb1faeed50$var$adoptPreloadPropsForStylesheet(href, options);
                var link = resource = ownerDocument.createElement("link");
                $5c00e1cb1faeed50$var$markNodeAsHoistable(link);
                $5c00e1cb1faeed50$var$setInitialProperties(link, "link", href);
                link._p = new Promise(function(resolve, reject) {
                    link.onload = resolve;
                    link.onerror = reject;
                });
                link.addEventListener("load", function() {
                    state.loading |= 1;
                });
                link.addEventListener("error", function() {
                    state.loading |= 2;
                });
                state.loading |= 4;
                $5c00e1cb1faeed50$var$insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
                type: "stylesheet",
                instance: resource,
                count: 1,
                state: state
            };
            styles.set(key, resource);
        }
    }
}
function $5c00e1cb1faeed50$var$preinitScript(src, options) {
    $5c00e1cb1faeed50$var$previousDispatcher.X(src, options);
    var ownerDocument = $5c00e1cb1faeed50$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $5c00e1cb1faeed50$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $5c00e1cb1faeed50$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($5c00e1cb1faeed50$var$getScriptSelectorFromKey(key)), resource || (src = $5c00e1cb1faeed50$var$assign({
            src: src,
            async: !0
        }, options), (options = $5c00e1cb1faeed50$var$preloadPropsMap.get(key)) && $5c00e1cb1faeed50$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $5c00e1cb1faeed50$var$markNodeAsHoistable(resource), $5c00e1cb1faeed50$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $5c00e1cb1faeed50$var$preinitModuleScript(src, options) {
    $5c00e1cb1faeed50$var$previousDispatcher.M(src, options);
    var ownerDocument = $5c00e1cb1faeed50$var$globalDocument;
    if (ownerDocument && src) {
        var scripts = $5c00e1cb1faeed50$var$getResourcesFromRoot(ownerDocument).hoistableScripts, key = $5c00e1cb1faeed50$var$getScriptKey(src), resource = scripts.get(key);
        resource || (resource = ownerDocument.querySelector($5c00e1cb1faeed50$var$getScriptSelectorFromKey(key)), resource || (src = $5c00e1cb1faeed50$var$assign({
            src: src,
            async: !0,
            type: "module"
        }, options), (options = $5c00e1cb1faeed50$var$preloadPropsMap.get(key)) && $5c00e1cb1faeed50$var$adoptPreloadPropsForScript(src, options), resource = ownerDocument.createElement("script"), $5c00e1cb1faeed50$var$markNodeAsHoistable(resource), $5c00e1cb1faeed50$var$setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
        }, scripts.set(key, resource));
    }
}
function $5c00e1cb1faeed50$var$getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = $5c00e1cb1faeed50$var$rootInstanceStackCursor.current) ? $5c00e1cb1faeed50$var$getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(446));
    switch(type){
        case "meta":
        case "title":
            return null;
        case "style":
            return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = $5c00e1cb1faeed50$var$getStyleKey(pendingProps.href), currentProps = $5c00e1cb1faeed50$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "style",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        case "link":
            if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
                type = $5c00e1cb1faeed50$var$getStyleKey(pendingProps.href);
                var styles$268 = $5c00e1cb1faeed50$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableStyles, resource$269 = styles$268.get(type);
                resource$269 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$269 = {
                    type: "stylesheet",
                    instance: null,
                    count: 0,
                    state: {
                        loading: 0,
                        preload: null
                    }
                }, styles$268.set(type, resource$269), (styles$268 = JSCompiler_inline_result.querySelector($5c00e1cb1faeed50$var$getStylesheetSelectorFromKey(type))) ? styles$268._p || (resource$269.instance = styles$268, resource$269.state.loading = 5) : (styles$268 = $5c00e1cb1faeed50$var$preloadPropsMap.get(type), styles$268 || (styles$268 = {
                    rel: "preload",
                    as: "style",
                    href: pendingProps.href,
                    crossOrigin: pendingProps.crossOrigin,
                    integrity: pendingProps.integrity,
                    media: pendingProps.media,
                    hrefLang: pendingProps.hrefLang,
                    referrerPolicy: pendingProps.referrerPolicy
                }, $5c00e1cb1faeed50$var$preloadPropsMap.set(type, styles$268)), $5c00e1cb1faeed50$var$preloadStylesheet(JSCompiler_inline_result, type, styles$268, resource$269.state)));
                if (currentProps && null === currentResource) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(528, ""));
                return resource$269;
            }
            if (currentProps && null !== currentResource) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(529, ""));
            return null;
        case "script":
            return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = $5c00e1cb1faeed50$var$getScriptKey(pendingProps), currentProps = $5c00e1cb1faeed50$var$getResourcesFromRoot(JSCompiler_inline_result).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
                type: "script",
                instance: null,
                count: 0,
                state: null
            }, currentProps.set(pendingProps, currentResource)), currentResource) : {
                type: "void",
                instance: null,
                count: 0,
                state: null
            };
        default:
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(444, type));
    }
}
function $5c00e1cb1faeed50$var$getStyleKey(href) {
    return 'href="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
}
function $5c00e1cb1faeed50$var$getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
}
function $5c00e1cb1faeed50$var$stylesheetPropsFromRawProps(rawProps) {
    return $5c00e1cb1faeed50$var$assign({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
    });
}
function $5c00e1cb1faeed50$var$preloadStylesheet(ownerDocument, key, preloadProps, state) {
    if (key = ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]")) {
        if (!0 !== key[$5c00e1cb1faeed50$var$internalLoadPendingKey]) {
            state.loading = 1;
            return;
        }
    } else key = ownerDocument.createElement("link"), key[$5c00e1cb1faeed50$var$internalLoadPendingKey] = !0, key.onload = key.onerror = $5c00e1cb1faeed50$var$clearPendingLoadOnNode.bind(null, key), $5c00e1cb1faeed50$var$setInitialProperties(key, "link", preloadProps), $5c00e1cb1faeed50$var$markNodeAsHoistable(key), ownerDocument.head.appendChild(key);
    state.preload = key;
    key.addEventListener("load", function() {
        return state.loading |= 1;
    });
    key.addEventListener("error", function() {
        return state.loading |= 2;
    });
}
function $5c00e1cb1faeed50$var$getScriptKey(src) {
    return '[src="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
}
function $5c00e1cb1faeed50$var$getScriptSelectorFromKey(key) {
    return "script[async]" + key;
}
function $5c00e1cb1faeed50$var$acquireResource(hoistableRoot, resource, props) {
    resource.count++;
    if (null === resource.instance) switch(resource.type){
        case "style":
            var instance = hoistableRoot.querySelector('style[data-href~="' + $5c00e1cb1faeed50$var$escapeSelectorAttributeValueInsideDoubleQuotes(props.href) + '"]');
            if (instance) return resource.instance = instance, $5c00e1cb1faeed50$var$markNodeAsHoistable(instance), instance;
            var styleProps = $5c00e1cb1faeed50$var$assign({}, props, {
                "data-href": props.href,
                "data-precedence": props.precedence,
                href: null,
                precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            $5c00e1cb1faeed50$var$markNodeAsHoistable(instance);
            $5c00e1cb1faeed50$var$setInitialProperties(instance, "style", styleProps);
            $5c00e1cb1faeed50$var$insertStylesheet(instance, props.precedence, hoistableRoot);
            return resource.instance = instance;
        case "stylesheet":
            styleProps = $5c00e1cb1faeed50$var$getStyleKey(props.href);
            var instance$274 = hoistableRoot.querySelector($5c00e1cb1faeed50$var$getStylesheetSelectorFromKey(styleProps));
            if (instance$274) return resource.state.loading |= 4, resource.instance = instance$274, $5c00e1cb1faeed50$var$markNodeAsHoistable(instance$274), instance$274;
            instance = $5c00e1cb1faeed50$var$stylesheetPropsFromRawProps(props);
            (styleProps = $5c00e1cb1faeed50$var$preloadPropsMap.get(styleProps)) && $5c00e1cb1faeed50$var$adoptPreloadPropsForStylesheet(instance, styleProps);
            instance$274 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            $5c00e1cb1faeed50$var$markNodeAsHoistable(instance$274);
            var linkInstance = instance$274;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $5c00e1cb1faeed50$var$setInitialProperties(instance$274, "link", instance);
            resource.state.loading |= 4;
            $5c00e1cb1faeed50$var$insertStylesheet(instance$274, props.precedence, hoistableRoot);
            return resource.instance = instance$274;
        case "script":
            instance$274 = $5c00e1cb1faeed50$var$getScriptKey(props.src);
            if (styleProps = hoistableRoot.querySelector($5c00e1cb1faeed50$var$getScriptSelectorFromKey(instance$274))) return resource.instance = styleProps, $5c00e1cb1faeed50$var$markNodeAsHoistable(styleProps), styleProps;
            instance = props;
            if (styleProps = $5c00e1cb1faeed50$var$preloadPropsMap.get(instance$274)) instance = $5c00e1cb1faeed50$var$assign({}, props), $5c00e1cb1faeed50$var$adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            $5c00e1cb1faeed50$var$markNodeAsHoistable(styleProps);
            $5c00e1cb1faeed50$var$setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
        case "void":
            return null;
        default:
            throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(443, resource.type));
    }
    else "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, $5c00e1cb1faeed50$var$insertStylesheet(instance, props.precedence, hoistableRoot));
    return resource.instance;
}
function $5c00e1cb1faeed50$var$insertStylesheet(instance, precedence, root) {
    for(var nodes = root.querySelectorAll('link[rel="stylesheet"][data-precedence],style[data-precedence]'), last = nodes.length ? nodes[nodes.length - 1] : null, prior = last, i = 0; i < nodes.length; i++){
        var node = nodes[i];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root.nodeType ? root.head : root, precedence.insertBefore(instance, precedence.firstChild));
}
function $5c00e1cb1faeed50$var$adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
}
function $5c00e1cb1faeed50$var$adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
}
var $5c00e1cb1faeed50$var$tagCaches = null;
function $5c00e1cb1faeed50$var$getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === $5c00e1cb1faeed50$var$tagCaches) {
        var cache = new Map();
        var caches = $5c00e1cb1faeed50$var$tagCaches = new Map();
        caches.set(ownerDocument, cache);
    } else caches = $5c00e1cb1faeed50$var$tagCaches, cache = caches.get(ownerDocument), cache || (cache = new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for(caches = 0; caches < ownerDocument.length; caches++){
        var node = ownerDocument[caches];
        if (!(node[$5c00e1cb1faeed50$var$internalHoistableMarker] || node[$5c00e1cb1faeed50$var$internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
            var nodeKey = node.getAttribute(keyAttribute) || "";
            nodeKey = type + nodeKey;
            var existing = cache.get(nodeKey);
            existing ? existing.push(node) : cache.set(nodeKey, [
                node
            ]);
        }
    }
    return cache;
}
function $5c00e1cb1faeed50$var$mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(instance, "title" === type ? hoistableRoot.querySelector("head > title") : null);
}
function $5c00e1cb1faeed50$var$isHostHoistableType(type, props, hostContext) {
    if (1 === hostContext || null != props.itemProp) return !1;
    switch(type){
        case "meta":
        case "title":
            return !0;
        case "style":
            if ("string" !== typeof props.precedence || "string" !== typeof props.href || "" === props.href) break;
            return !0;
        case "link":
            if ("string" !== typeof props.rel || "string" !== typeof props.href || "" === props.href || props.onLoad || props.onError) break;
            switch(props.rel){
                case "stylesheet":
                    return type = props.disabled, "string" === typeof props.precedence && null == type;
                default:
                    return !0;
            }
        case "script":
            if (props.async && "function" !== typeof props.async && "symbol" !== typeof props.async && !props.onLoad && !props.onError && props.src && "string" === typeof props.src) return !0;
    }
    return !1;
}
function $5c00e1cb1faeed50$var$maySuspendCommit(type, props) {
    return "img" === type && null != props.src && "" !== props.src && null == props.onLoad && "lazy" !== props.loading;
}
function $5c00e1cb1faeed50$var$preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? !1 : !0;
}
function $5c00e1cb1faeed50$var$estimateImageBytes(instance) {
    return (instance.width || 100) * (instance.height || 100) * ("number" === typeof devicePixelRatio ? devicePixelRatio : 1) * 0.25;
}
function $5c00e1cb1faeed50$var$suspendInstance(state, instance) {
    "function" === typeof instance.decode && (state.imgCount++, instance.complete || (state.imgBytes += $5c00e1cb1faeed50$var$estimateImageBytes(instance), state.suspenseyImages.push(instance)), state = $5c00e1cb1faeed50$var$onUnsuspendImg.bind(state), instance.decode().then(state, state));
}
function $5c00e1cb1faeed50$var$suspendResource(state, hoistableRoot, resource, props) {
    if ("stylesheet" === resource.type && ("string" !== typeof props.media || !1 !== matchMedia(props.media).matches) && 0 === (resource.state.loading & 4)) {
        if (null === resource.instance) {
            var key = $5c00e1cb1faeed50$var$getStyleKey(props.href), instance = hoistableRoot.querySelector($5c00e1cb1faeed50$var$getStylesheetSelectorFromKey(key));
            if (instance) {
                hoistableRoot = instance._p;
                null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = $5c00e1cb1faeed50$var$onUnsuspend.bind(state), hoistableRoot.then(state, state));
                resource.state.loading |= 4;
                resource.instance = instance;
                $5c00e1cb1faeed50$var$markNodeAsHoistable(instance);
                return;
            }
            instance = hoistableRoot.ownerDocument || hoistableRoot;
            props = $5c00e1cb1faeed50$var$stylesheetPropsFromRawProps(props);
            (key = $5c00e1cb1faeed50$var$preloadPropsMap.get(key)) && $5c00e1cb1faeed50$var$adoptPreloadPropsForStylesheet(props, key);
            instance = instance.createElement("link");
            $5c00e1cb1faeed50$var$markNodeAsHoistable(instance);
            var linkInstance = instance;
            linkInstance._p = new Promise(function(resolve, reject) {
                linkInstance.onload = resolve;
                linkInstance.onerror = reject;
            });
            $5c00e1cb1faeed50$var$setInitialProperties(instance, "link", props);
            resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = $5c00e1cb1faeed50$var$onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
}
var $5c00e1cb1faeed50$var$estimatedBytesWithinLimit = 0;
function $5c00e1cb1faeed50$var$waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && $5c00e1cb1faeed50$var$insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
            state.stylesheets && $5c00e1cb1faeed50$var$insertSuspendedStylesheets(state, state.stylesheets);
            if (state.unsuspend) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, 6e4 + timeoutOffset);
        0 < state.imgBytes && 0 === $5c00e1cb1faeed50$var$estimatedBytesWithinLimit && ($5c00e1cb1faeed50$var$estimatedBytesWithinLimit = 62500 * $5c00e1cb1faeed50$var$estimateBandwidth());
        var imgTimer = setTimeout(function() {
            state.waitingForImages = !1;
            if (0 === state.count && (state.stylesheets && $5c00e1cb1faeed50$var$insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
                var unsuspend = state.unsuspend;
                state.unsuspend = null;
                unsuspend();
            }
        }, (state.imgBytes > $5c00e1cb1faeed50$var$estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset);
        state.unsuspend = commit;
        return function() {
            state.unsuspend = null;
            clearTimeout(stylesheetTimer);
            clearTimeout(imgTimer);
        };
    } : null;
}
function $5c00e1cb1faeed50$var$checkIfFullyUnsuspended(state) {
    if (0 === state.count && (0 === state.imgCount || !state.waitingForImages)) {
        if (state.stylesheets) $5c00e1cb1faeed50$var$insertSuspendedStylesheets(state, state.stylesheets);
        else if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
        }
    }
}
function $5c00e1cb1faeed50$var$onUnsuspend() {
    this.count--;
    $5c00e1cb1faeed50$var$checkIfFullyUnsuspended(this);
}
function $5c00e1cb1faeed50$var$onUnsuspendImg() {
    this.imgCount--;
    $5c00e1cb1faeed50$var$checkIfFullyUnsuspended(this);
}
var $5c00e1cb1faeed50$var$precedencesByRoot = null;
function $5c00e1cb1faeed50$var$insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, $5c00e1cb1faeed50$var$precedencesByRoot = new Map(), resources.forEach($5c00e1cb1faeed50$var$insertStylesheetIntoRoot, state), $5c00e1cb1faeed50$var$precedencesByRoot = null, $5c00e1cb1faeed50$var$onUnsuspend.call(state));
}
function $5c00e1cb1faeed50$var$insertStylesheetIntoRoot(root, resource) {
    if (!(resource.state.loading & 4)) {
        var precedences = $5c00e1cb1faeed50$var$precedencesByRoot.get(root);
        if (precedences) var last = precedences.get(null);
        else {
            precedences = new Map();
            $5c00e1cb1faeed50$var$precedencesByRoot.set(root, precedences);
            for(var nodes = root.querySelectorAll("link[data-precedence],style[data-precedence]"), i = 0; i < nodes.length; i++){
                var node = nodes[i];
                if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media")) precedences.set(node.dataset.precedence, node), last = node;
            }
            last && precedences.set(null, last);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i = precedences.get(node) || last;
        i === last && precedences.set(null, nodes);
        precedences.set(node, nodes);
        this.count++;
        last = $5c00e1cb1faeed50$var$onUnsuspend.bind(this);
        nodes.addEventListener("load", last);
        nodes.addEventListener("error", last);
        i ? i.parentNode.insertBefore(nodes, i.nextSibling) : (root = 9 === root.nodeType ? root.head : root, root.insertBefore(nodes, root.firstChild));
        resource.state.loading |= 4;
    }
}
var $5c00e1cb1faeed50$var$HostTransitionContext = {
    $$typeof: $5c00e1cb1faeed50$var$REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: $5c00e1cb1faeed50$var$sharedNotPendingObject,
    _currentValue2: $5c00e1cb1faeed50$var$sharedNotPendingObject,
    _threadCount: 0
};
function $5c00e1cb1faeed50$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = $5c00e1cb1faeed50$var$createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = $5c00e1cb1faeed50$var$createLaneMap(0);
    this.hiddenUpdates = $5c00e1cb1faeed50$var$createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.transitionTypes = null;
    this.incompleteTransitions = new Map();
}
function $5c00e1cb1faeed50$var$createFiberRoot(containerInfo, tag, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new $5c00e1cb1faeed50$var$FiberRootNode(containerInfo, tag, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState);
    tag = 1;
    !0 === isStrictMode && (tag |= 24);
    isStrictMode = $5c00e1cb1faeed50$var$createFiberImplClass(3, null, null, tag);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag = $5c00e1cb1faeed50$var$createCache();
    tag.refCount++;
    containerInfo.pooledCache = tag;
    tag.refCount++;
    isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag
    };
    $5c00e1cb1faeed50$var$initializeUpdateQueue(isStrictMode);
    return containerInfo;
}
function $5c00e1cb1faeed50$var$getContextForSubtree(parentComponent) {
    if (!parentComponent) return $5c00e1cb1faeed50$var$emptyContextObject;
    parentComponent = $5c00e1cb1faeed50$var$emptyContextObject;
    return parentComponent;
}
function $5c00e1cb1faeed50$var$updateContainerImpl(rootFiber, lane, element, container, parentComponent, callback) {
    parentComponent = $5c00e1cb1faeed50$var$getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = $5c00e1cb1faeed50$var$createUpdate(lane);
    container.payload = {
        element: element
    };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element = $5c00e1cb1faeed50$var$enqueueUpdate(rootFiber, container, lane);
    null !== element && ($5c00e1cb1faeed50$var$scheduleUpdateOnFiber(element, rootFiber, lane), $5c00e1cb1faeed50$var$entangleTransitions(element, rootFiber, lane));
}
function $5c00e1cb1faeed50$var$markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
        var a = fiber.retryLane;
        fiber.retryLane = 0 !== a && a < retryLane ? a : retryLane;
    }
}
function $5c00e1cb1faeed50$var$markRetryLaneIfNotHydrated(fiber, retryLane) {
    $5c00e1cb1faeed50$var$markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && $5c00e1cb1faeed50$var$markRetryLaneImpl(fiber, retryLane);
}
function $5c00e1cb1faeed50$var$attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var root = $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root && $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(root, fiber, 67108864);
        $5c00e1cb1faeed50$var$markRetryLaneIfNotHydrated(fiber, 67108864);
    }
}
function $5c00e1cb1faeed50$var$attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = $5c00e1cb1faeed50$var$requestUpdateLane();
        lane = $5c00e1cb1faeed50$var$getBumpedLaneForHydrationByLane(lane);
        var root = $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(fiber, lane);
        null !== root && $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(root, fiber, lane);
        $5c00e1cb1faeed50$var$markRetryLaneIfNotHydrated(fiber, lane);
    }
}
var $5c00e1cb1faeed50$var$_enabled = !0;
function $5c00e1cb1faeed50$var$dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $5c00e1cb1faeed50$var$ReactSharedInternals.T;
    $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
    var previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
    try {
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 2, $5c00e1cb1faeed50$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority, $5c00e1cb1faeed50$var$ReactSharedInternals.T = prevTransition;
    }
}
function $5c00e1cb1faeed50$var$dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = $5c00e1cb1faeed50$var$ReactSharedInternals.T;
    $5c00e1cb1faeed50$var$ReactSharedInternals.T = null;
    var previousPriority = $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p;
    try {
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = 8, $5c00e1cb1faeed50$var$dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally{
        $5c00e1cb1faeed50$var$ReactDOMSharedInternals.p = previousPriority, $5c00e1cb1faeed50$var$ReactSharedInternals.T = prevTransition;
    }
}
function $5c00e1cb1faeed50$var$dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if ($5c00e1cb1faeed50$var$_enabled) {
        var blockedOn = $5c00e1cb1faeed50$var$findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn) $5c00e1cb1faeed50$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $5c00e1cb1faeed50$var$return_targetInst, targetContainer), $5c00e1cb1faeed50$var$clearIfContinuousEvent(domEventName, nativeEvent);
        else if ($5c00e1cb1faeed50$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)) nativeEvent.stopPropagation();
        else if ($5c00e1cb1faeed50$var$clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < $5c00e1cb1faeed50$var$discreteReplayableEvents.indexOf(domEventName)) {
            for(; null !== blockedOn;){
                var fiber = $5c00e1cb1faeed50$var$getInstanceFromNode(blockedOn);
                if (null !== fiber) switch(fiber.tag){
                    case 3:
                        fiber = fiber.stateNode;
                        if (fiber.current.memoizedState.isDehydrated) {
                            var lanes = $5c00e1cb1faeed50$var$getHighestPriorityLanes(fiber.pendingLanes);
                            if (0 !== lanes) {
                                var root = fiber;
                                root.pendingLanes |= 2;
                                for(root.entangledLanes |= 2; lanes;){
                                    var lane = 1 << 31 - $5c00e1cb1faeed50$var$clz32(lanes);
                                    root.entanglements[1] |= lane;
                                    lanes &= ~lane;
                                }
                                $5c00e1cb1faeed50$var$ensureRootIsScheduled(fiber);
                                0 === ($5c00e1cb1faeed50$var$executionContext & 6) && ($5c00e1cb1faeed50$var$workInProgressRootRenderTargetTime = $5c00e1cb1faeed50$var$now() + 500, $5c00e1cb1faeed50$var$flushSyncWorkAcrossRoots_impl(0, !1));
                            }
                        }
                        break;
                    case 31:
                    case 13:
                        root = $5c00e1cb1faeed50$var$enqueueConcurrentRenderForLane(fiber, 2), null !== root && $5c00e1cb1faeed50$var$scheduleUpdateOnFiber(root, fiber, 2), $5c00e1cb1faeed50$var$flushSyncWork$1(), $5c00e1cb1faeed50$var$markRetryLaneIfNotHydrated(fiber, 2);
                }
                fiber = $5c00e1cb1faeed50$var$findInstanceBlockingEvent(nativeEvent);
                null === fiber && $5c00e1cb1faeed50$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, $5c00e1cb1faeed50$var$return_targetInst, targetContainer);
                if (fiber === blockedOn) break;
                blockedOn = fiber;
            }
            null !== blockedOn && nativeEvent.stopPropagation();
        } else $5c00e1cb1faeed50$var$dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, null, targetContainer);
    }
}
function $5c00e1cb1faeed50$var$findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = $5c00e1cb1faeed50$var$getEventTarget(nativeEvent);
    return $5c00e1cb1faeed50$var$findInstanceBlockingTarget(nativeEvent);
}
var $5c00e1cb1faeed50$var$return_targetInst = null;
function $5c00e1cb1faeed50$var$findInstanceBlockingTarget(targetNode) {
    $5c00e1cb1faeed50$var$return_targetInst = null;
    targetNode = $5c00e1cb1faeed50$var$getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
        var nearestMounted = $5c00e1cb1faeed50$var$getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
            var tag = nearestMounted.tag;
            if (13 === tag) {
                targetNode = $5c00e1cb1faeed50$var$getSuspenseInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (31 === tag) {
                targetNode = $5c00e1cb1faeed50$var$getActivityInstanceFromFiber(nearestMounted);
                if (null !== targetNode) return targetNode;
                targetNode = null;
            } else if (3 === tag) {
                if (nearestMounted.stateNode.current.memoizedState.isDehydrated) return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                targetNode = null;
            } else nearestMounted !== targetNode && (targetNode = null);
        }
    }
    $5c00e1cb1faeed50$var$return_targetInst = targetNode;
    return null;
}
function $5c00e1cb1faeed50$var$getEventPriority(domEventName) {
    switch(domEventName){
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "fullscreenerror":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
            return 2;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "resize":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
            return 8;
        case "message":
            switch($5c00e1cb1faeed50$var$getCurrentPriorityLevel()){
                case $5c00e1cb1faeed50$var$ImmediatePriority:
                    return 2;
                case $5c00e1cb1faeed50$var$UserBlockingPriority:
                    return 8;
                case $5c00e1cb1faeed50$var$NormalPriority$1:
                case $5c00e1cb1faeed50$var$LowPriority:
                    return 32;
                case $5c00e1cb1faeed50$var$IdlePriority:
                    return 268435456;
                default:
                    return 32;
            }
        default:
            return 32;
    }
}
var $5c00e1cb1faeed50$var$hasScheduledReplayAttempt = !1, $5c00e1cb1faeed50$var$queuedFocus = null, $5c00e1cb1faeed50$var$queuedDrag = null, $5c00e1cb1faeed50$var$queuedMouse = null, $5c00e1cb1faeed50$var$queuedPointers = new Map(), $5c00e1cb1faeed50$var$queuedPointerCaptures = new Map(), $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets = [], $5c00e1cb1faeed50$var$discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(" ");
function $5c00e1cb1faeed50$var$clearIfContinuousEvent(domEventName, nativeEvent) {
    switch(domEventName){
        case "focusin":
        case "focusout":
            $5c00e1cb1faeed50$var$queuedFocus = null;
            break;
        case "dragenter":
        case "dragleave":
            $5c00e1cb1faeed50$var$queuedDrag = null;
            break;
        case "mouseover":
        case "mouseout":
            $5c00e1cb1faeed50$var$queuedMouse = null;
            break;
        case "pointerover":
        case "pointerout":
            $5c00e1cb1faeed50$var$queuedPointers.delete(nativeEvent.pointerId);
            break;
        case "gotpointercapture":
        case "lostpointercapture":
            $5c00e1cb1faeed50$var$queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
}
function $5c00e1cb1faeed50$var$accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent) return existingQueuedEvent = {
        blockedOn: blockedOn,
        domEventName: domEventName,
        eventSystemFlags: eventSystemFlags,
        nativeEvent: nativeEvent,
        targetContainers: [
            targetContainer
        ]
    }, null !== blockedOn && (blockedOn = $5c00e1cb1faeed50$var$getInstanceFromNode(blockedOn), null !== blockedOn && $5c00e1cb1faeed50$var$attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
}
function $5c00e1cb1faeed50$var$queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch(domEventName){
        case "focusin":
            return $5c00e1cb1faeed50$var$queuedFocus = $5c00e1cb1faeed50$var$accumulateOrCreateContinuousQueuedReplayableEvent($5c00e1cb1faeed50$var$queuedFocus, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "dragenter":
            return $5c00e1cb1faeed50$var$queuedDrag = $5c00e1cb1faeed50$var$accumulateOrCreateContinuousQueuedReplayableEvent($5c00e1cb1faeed50$var$queuedDrag, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "mouseover":
            return $5c00e1cb1faeed50$var$queuedMouse = $5c00e1cb1faeed50$var$accumulateOrCreateContinuousQueuedReplayableEvent($5c00e1cb1faeed50$var$queuedMouse, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent), !0;
        case "pointerover":
            var pointerId = nativeEvent.pointerId;
            $5c00e1cb1faeed50$var$queuedPointers.set(pointerId, $5c00e1cb1faeed50$var$accumulateOrCreateContinuousQueuedReplayableEvent($5c00e1cb1faeed50$var$queuedPointers.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent));
            return !0;
        case "gotpointercapture":
            return pointerId = nativeEvent.pointerId, $5c00e1cb1faeed50$var$queuedPointerCaptures.set(pointerId, $5c00e1cb1faeed50$var$accumulateOrCreateContinuousQueuedReplayableEvent($5c00e1cb1faeed50$var$queuedPointerCaptures.get(pointerId) || null, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent)), !0;
    }
    return !1;
}
function $5c00e1cb1faeed50$var$attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = $5c00e1cb1faeed50$var$getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
        var nearestMounted = $5c00e1cb1faeed50$var$getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
            if (targetInst = nearestMounted.tag, 13 === targetInst) {
                if (targetInst = $5c00e1cb1faeed50$var$getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $5c00e1cb1faeed50$var$runWithPriority(queuedTarget.priority, function() {
                        $5c00e1cb1faeed50$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (31 === targetInst) {
                if (targetInst = $5c00e1cb1faeed50$var$getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
                    queuedTarget.blockedOn = targetInst;
                    $5c00e1cb1faeed50$var$runWithPriority(queuedTarget.priority, function() {
                        $5c00e1cb1faeed50$var$attemptHydrationAtCurrentPriority(nearestMounted);
                    });
                    return;
                }
            } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
                queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
                return;
            }
        }
    }
    queuedTarget.blockedOn = null;
}
function $5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return !1;
    for(var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length;){
        var nextBlockedOn = $5c00e1cb1faeed50$var$findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
            nextBlockedOn = queuedEvent.nativeEvent;
            var nativeEventClone = new nextBlockedOn.constructor(nextBlockedOn.type, nextBlockedOn);
            $5c00e1cb1faeed50$var$currentReplayingEvent = nativeEventClone;
            nextBlockedOn.target.dispatchEvent(nativeEventClone);
            $5c00e1cb1faeed50$var$currentReplayingEvent = null;
        } else return targetContainers = $5c00e1cb1faeed50$var$getInstanceFromNode(nextBlockedOn), null !== targetContainers && $5c00e1cb1faeed50$var$attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, !1;
        targetContainers.shift();
    }
    return !0;
}
function $5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map) {
    $5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEvent(queuedEvent) && map.delete(key);
}
function $5c00e1cb1faeed50$var$replayUnblockedEvents() {
    $5c00e1cb1faeed50$var$hasScheduledReplayAttempt = !1;
    null !== $5c00e1cb1faeed50$var$queuedFocus && $5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEvent($5c00e1cb1faeed50$var$queuedFocus) && ($5c00e1cb1faeed50$var$queuedFocus = null);
    null !== $5c00e1cb1faeed50$var$queuedDrag && $5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEvent($5c00e1cb1faeed50$var$queuedDrag) && ($5c00e1cb1faeed50$var$queuedDrag = null);
    null !== $5c00e1cb1faeed50$var$queuedMouse && $5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEvent($5c00e1cb1faeed50$var$queuedMouse) && ($5c00e1cb1faeed50$var$queuedMouse = null);
    $5c00e1cb1faeed50$var$queuedPointers.forEach($5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEventInMap);
    $5c00e1cb1faeed50$var$queuedPointerCaptures.forEach($5c00e1cb1faeed50$var$attemptReplayContinuousQueuedEventInMap);
}
function $5c00e1cb1faeed50$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, $5c00e1cb1faeed50$var$hasScheduledReplayAttempt || ($5c00e1cb1faeed50$var$hasScheduledReplayAttempt = !0, $1wkuA.unstable_scheduleCallback($1wkuA.unstable_NormalPriority, $5c00e1cb1faeed50$var$replayUnblockedEvents)));
}
var $5c00e1cb1faeed50$var$lastScheduledReplayQueue = null;
function $5c00e1cb1faeed50$var$scheduleReplayQueueIfNeeded(formReplayingQueue) {
    $5c00e1cb1faeed50$var$lastScheduledReplayQueue !== formReplayingQueue && ($5c00e1cb1faeed50$var$lastScheduledReplayQueue = formReplayingQueue, $1wkuA.unstable_scheduleCallback($1wkuA.unstable_NormalPriority, function() {
        $5c00e1cb1faeed50$var$lastScheduledReplayQueue === formReplayingQueue && ($5c00e1cb1faeed50$var$lastScheduledReplayQueue = null);
        for(var i = 0; i < formReplayingQueue.length; i += 3){
            var form = formReplayingQueue[i], submitterOrAction = formReplayingQueue[i + 1], formData = formReplayingQueue[i + 2];
            if ("function" !== typeof submitterOrAction) {
                if (null === $5c00e1cb1faeed50$var$findInstanceBlockingTarget(submitterOrAction || form)) continue;
                else break;
            }
            var formInst = $5c00e1cb1faeed50$var$getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i, 3), i -= 3, $5c00e1cb1faeed50$var$startHostTransition(formInst, {
                pending: !0,
                data: formData,
                method: form.method,
                action: submitterOrAction
            }, submitterOrAction, formData));
        }
    }));
}
function $5c00e1cb1faeed50$var$retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
        return $5c00e1cb1faeed50$var$scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== $5c00e1cb1faeed50$var$queuedFocus && $5c00e1cb1faeed50$var$scheduleCallbackIfUnblocked($5c00e1cb1faeed50$var$queuedFocus, unblocked);
    null !== $5c00e1cb1faeed50$var$queuedDrag && $5c00e1cb1faeed50$var$scheduleCallbackIfUnblocked($5c00e1cb1faeed50$var$queuedDrag, unblocked);
    null !== $5c00e1cb1faeed50$var$queuedMouse && $5c00e1cb1faeed50$var$scheduleCallbackIfUnblocked($5c00e1cb1faeed50$var$queuedMouse, unblocked);
    $5c00e1cb1faeed50$var$queuedPointers.forEach(unblock);
    $5c00e1cb1faeed50$var$queuedPointerCaptures.forEach(unblock);
    for(var i = 0; i < $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets.length; i++){
        var queuedTarget = $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets[i];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for(; 0 < $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets.length && (i = $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets[0], null === i.blockedOn);)$5c00e1cb1faeed50$var$attemptExplicitHydrationTarget(i), null === i.blockedOn && $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets.shift();
    i = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i) for(queuedTarget = 0; queuedTarget < i.length; queuedTarget += 3){
        var form = i[queuedTarget], submitterOrAction = i[queuedTarget + 1], formProps = form[$5c00e1cb1faeed50$var$internalPropsKey] || null;
        if ("function" === typeof submitterOrAction) formProps || $5c00e1cb1faeed50$var$scheduleReplayQueueIfNeeded(i);
        else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction")) {
                if (form = submitterOrAction, formProps = submitterOrAction[$5c00e1cb1faeed50$var$internalPropsKey] || null) action = formProps.formAction;
                else {
                    if (null !== $5c00e1cb1faeed50$var$findInstanceBlockingTarget(form)) continue;
                }
            } else action = formProps.action;
            "function" === typeof action ? i[queuedTarget + 1] = action : (i.splice(queuedTarget, 3), queuedTarget -= 3);
            $5c00e1cb1faeed50$var$scheduleReplayQueueIfNeeded(i);
        }
    }
}
function $5c00e1cb1faeed50$var$defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
            handler: function() {
                return new Promise(function(resolve) {
                    return pendingResolve = resolve;
                });
            },
            focusReset: "manual",
            scroll: "manual"
        });
    }
    function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
            var currentEntry = navigation.currentEntry;
            currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
                state: currentEntry.getState(),
                info: "react-transition",
                history: "replace"
            });
        }
    }
    if ("object" === typeof navigation) {
        var isCancelled = !1, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
            isCancelled = !0;
            navigation.removeEventListener("navigate", handleNavigate);
            navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
            navigation.removeEventListener("navigateerror", handleNavigateComplete);
            null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
    }
}
function $5c00e1cb1faeed50$var$ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$5c00e1cb1faeed50$var$ReactDOMHydrationRoot.prototype.render = $5c00e1cb1faeed50$var$ReactDOMRoot.prototype.render = function(children) {
    var root = this._internalRoot;
    if (null === root) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(409));
    var current = root.current, lane = $5c00e1cb1faeed50$var$requestUpdateLane();
    $5c00e1cb1faeed50$var$updateContainerImpl(current, lane, children, root, null, null);
};
$5c00e1cb1faeed50$var$ReactDOMHydrationRoot.prototype.unmount = $5c00e1cb1faeed50$var$ReactDOMRoot.prototype.unmount = function() {
    var root = this._internalRoot;
    if (null !== root) {
        this._internalRoot = null;
        var container = root.containerInfo;
        $5c00e1cb1faeed50$var$updateContainerImpl(root.current, 2, null, root, null, null);
        $5c00e1cb1faeed50$var$flushSyncWork$1();
        container[$5c00e1cb1faeed50$var$internalContainerInstanceKey] = null;
    }
};
function $5c00e1cb1faeed50$var$ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
}
$5c00e1cb1faeed50$var$ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
        var updatePriority = $5c00e1cb1faeed50$var$resolveUpdatePriority();
        target = {
            blockedOn: null,
            target: target,
            priority: updatePriority
        };
        for(var i = 0; i < $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets[i].priority; i++);
        $5c00e1cb1faeed50$var$queuedExplicitHydrationTargets.splice(i, 0, target);
        0 === i && $5c00e1cb1faeed50$var$attemptExplicitHydrationTarget(target);
    }
};
var $5c00e1cb1faeed50$var$isomorphicReactPackageVersion$jscomp$inline_2043 = $aZSru.version;
if ("19.3.0" !== $5c00e1cb1faeed50$var$isomorphicReactPackageVersion$jscomp$inline_2043) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(527, $5c00e1cb1faeed50$var$isomorphicReactPackageVersion$jscomp$inline_2043, "19.3.0"));
$5c00e1cb1faeed50$var$ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(188));
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(268, componentOrElement));
    }
    componentOrElement = $5c00e1cb1faeed50$var$findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? $5c00e1cb1faeed50$var$findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
};
var $5c00e1cb1faeed50$var$internals$jscomp$inline_2586 = {
    bundleType: 0,
    version: "19.3.0",
    rendererPackageName: "react-dom",
    currentDispatcherRef: $5c00e1cb1faeed50$var$ReactSharedInternals,
    reconcilerVersion: "19.3.0"
};
if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var $5c00e1cb1faeed50$var$hook$jscomp$inline_2587 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!$5c00e1cb1faeed50$var$hook$jscomp$inline_2587.isDisabled && $5c00e1cb1faeed50$var$hook$jscomp$inline_2587.supportsFiber) try {
        $5c00e1cb1faeed50$var$rendererID = $5c00e1cb1faeed50$var$hook$jscomp$inline_2587.inject($5c00e1cb1faeed50$var$internals$jscomp$inline_2586), $5c00e1cb1faeed50$var$injectedHook = $5c00e1cb1faeed50$var$hook$jscomp$inline_2587;
    } catch (err) {}
}
$5c00e1cb1faeed50$export$882461b6382ed46c = function(container, options) {
    if (!$5c00e1cb1faeed50$var$isValidContainer(container)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $5c00e1cb1faeed50$var$defaultOnUncaughtError, onCaughtError = $5c00e1cb1faeed50$var$defaultOnCaughtError, onRecoverableError = $5c00e1cb1faeed50$var$defaultOnRecoverableError;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError));
    options = $5c00e1cb1faeed50$var$createFiberRoot(container, 1, !1, null, null, isStrictMode, identifierPrefix, null, onUncaughtError, onCaughtError, onRecoverableError, $5c00e1cb1faeed50$var$defaultOnDefaultTransitionIndicator);
    container[$5c00e1cb1faeed50$var$internalContainerInstanceKey] = options.current;
    $5c00e1cb1faeed50$var$listenToAllSupportedEvents(container);
    return new $5c00e1cb1faeed50$var$ReactDOMRoot(options);
};
$5c00e1cb1faeed50$export$757ceba2d55c277e = function(container, initialChildren, options) {
    if (!$5c00e1cb1faeed50$var$isValidContainer(container)) throw Error($5c00e1cb1faeed50$var$formatProdErrorMessage(299));
    var isStrictMode = !1, identifierPrefix = "", onUncaughtError = $5c00e1cb1faeed50$var$defaultOnUncaughtError, onCaughtError = $5c00e1cb1faeed50$var$defaultOnCaughtError, onRecoverableError = $5c00e1cb1faeed50$var$defaultOnRecoverableError, formState = null;
    null !== options && void 0 !== options && (!0 === options.unstable_strictMode && (isStrictMode = !0), void 0 !== options.identifierPrefix && (identifierPrefix = options.identifierPrefix), void 0 !== options.onUncaughtError && (onUncaughtError = options.onUncaughtError), void 0 !== options.onCaughtError && (onCaughtError = options.onCaughtError), void 0 !== options.onRecoverableError && (onRecoverableError = options.onRecoverableError), void 0 !== options.formState && (formState = options.formState));
    initialChildren = $5c00e1cb1faeed50$var$createFiberRoot(container, 1, !0, initialChildren, null != options ? options : null, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, $5c00e1cb1faeed50$var$defaultOnDefaultTransitionIndicator);
    initialChildren.context = $5c00e1cb1faeed50$var$getContextForSubtree(null);
    options = initialChildren.current;
    isStrictMode = $5c00e1cb1faeed50$var$requestUpdateLane();
    isStrictMode = $5c00e1cb1faeed50$var$getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = $5c00e1cb1faeed50$var$createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    $5c00e1cb1faeed50$var$enqueueUpdate(options, identifierPrefix, isStrictMode);
    options = isStrictMode;
    initialChildren.current.lanes = options;
    $5c00e1cb1faeed50$var$markRootUpdated$1(initialChildren, options);
    $5c00e1cb1faeed50$var$ensureRootIsScheduled(initialChildren);
    container[$5c00e1cb1faeed50$var$internalContainerInstanceKey] = initialChildren.current;
    $5c00e1cb1faeed50$var$listenToAllSupportedEvents(container);
    return new $5c00e1cb1faeed50$var$ReactDOMHydrationRoot(initialChildren);
};
$5c00e1cb1faeed50$export$83d89fbfd8236492 = "19.3.0";

});
parcelRegister("1wkuA", function(module, exports) {
'use strict';

module.exports = (parcelRequire("1EH04"));

});
parcelRegister("1EH04", function(module, exports) {

$parcel$export(module.exports, "unstable_now", () => $134ae1c85c6d0116$export$c4744153514ff05d, (v) => $134ae1c85c6d0116$export$c4744153514ff05d = v);
$parcel$export(module.exports, "unstable_IdlePriority", () => $134ae1c85c6d0116$export$3e506c1ccc9cc1a7, (v) => $134ae1c85c6d0116$export$3e506c1ccc9cc1a7 = v);
$parcel$export(module.exports, "unstable_ImmediatePriority", () => $134ae1c85c6d0116$export$e26fe2ed2fa76875, (v) => $134ae1c85c6d0116$export$e26fe2ed2fa76875 = v);
$parcel$export(module.exports, "unstable_LowPriority", () => $134ae1c85c6d0116$export$502329bbf4b505b1, (v) => $134ae1c85c6d0116$export$502329bbf4b505b1 = v);
$parcel$export(module.exports, "unstable_NormalPriority", () => $134ae1c85c6d0116$export$6e3807111c4874c4, (v) => $134ae1c85c6d0116$export$6e3807111c4874c4 = v);
$parcel$export(module.exports, "unstable_Profiling", () => $134ae1c85c6d0116$export$c27134553091fb3a, (v) => $134ae1c85c6d0116$export$c27134553091fb3a = v);
$parcel$export(module.exports, "unstable_UserBlockingPriority", () => $134ae1c85c6d0116$export$33ee1acdc04fd2a2, (v) => $134ae1c85c6d0116$export$33ee1acdc04fd2a2 = v);
$parcel$export(module.exports, "unstable_cancelCallback", () => $134ae1c85c6d0116$export$b00a404bbd5edef2, (v) => $134ae1c85c6d0116$export$b00a404bbd5edef2 = v);
$parcel$export(module.exports, "unstable_forceFrameRate", () => $134ae1c85c6d0116$export$d66a1c1c77bd778b, (v) => $134ae1c85c6d0116$export$d66a1c1c77bd778b = v);
$parcel$export(module.exports, "unstable_getCurrentPriorityLevel", () => $134ae1c85c6d0116$export$d3dfb8e4810cb555, (v) => $134ae1c85c6d0116$export$d3dfb8e4810cb555 = v);
$parcel$export(module.exports, "unstable_next", () => $134ae1c85c6d0116$export$72fdf0e06517287b, (v) => $134ae1c85c6d0116$export$72fdf0e06517287b = v);
$parcel$export(module.exports, "unstable_requestPaint", () => $134ae1c85c6d0116$export$816d2913ae6b83b1, (v) => $134ae1c85c6d0116$export$816d2913ae6b83b1 = v);
$parcel$export(module.exports, "unstable_runWithPriority", () => $134ae1c85c6d0116$export$61bcfe829111a1d0, (v) => $134ae1c85c6d0116$export$61bcfe829111a1d0 = v);
$parcel$export(module.exports, "unstable_scheduleCallback", () => $134ae1c85c6d0116$export$7ee8c9beb337bc3f, (v) => $134ae1c85c6d0116$export$7ee8c9beb337bc3f = v);
$parcel$export(module.exports, "unstable_shouldYield", () => $134ae1c85c6d0116$export$b5836b71941fa3ed, (v) => $134ae1c85c6d0116$export$b5836b71941fa3ed = v);
$parcel$export(module.exports, "unstable_wrapCallback", () => $134ae1c85c6d0116$export$cf845f2c119da08a, (v) => $134ae1c85c6d0116$export$cf845f2c119da08a = v);
/**
 * @license React
 * scheduler.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $134ae1c85c6d0116$export$c4744153514ff05d;
var $134ae1c85c6d0116$export$3e506c1ccc9cc1a7;
var $134ae1c85c6d0116$export$e26fe2ed2fa76875;
var $134ae1c85c6d0116$export$502329bbf4b505b1;
var $134ae1c85c6d0116$export$6e3807111c4874c4;
var $134ae1c85c6d0116$export$c27134553091fb3a;
var $134ae1c85c6d0116$export$33ee1acdc04fd2a2;
var $134ae1c85c6d0116$export$b00a404bbd5edef2;
var $134ae1c85c6d0116$export$d66a1c1c77bd778b;
var $134ae1c85c6d0116$export$d3dfb8e4810cb555;
var $134ae1c85c6d0116$export$72fdf0e06517287b;
var $134ae1c85c6d0116$export$816d2913ae6b83b1;
var $134ae1c85c6d0116$export$61bcfe829111a1d0;
var $134ae1c85c6d0116$export$7ee8c9beb337bc3f;
var $134ae1c85c6d0116$export$b5836b71941fa3ed;
var $134ae1c85c6d0116$export$cf845f2c119da08a;
"use strict";
function $134ae1c85c6d0116$var$push(heap, node) {
    var index = heap.length;
    heap.push(node);
    a: for(; 0 < index;){
        var parentIndex = index - 1 >>> 1, parent = heap[parentIndex];
        if (0 < $134ae1c85c6d0116$var$compare(parent, node)) heap[parentIndex] = node, heap[index] = parent, index = parentIndex;
        else break a;
    }
}
function $134ae1c85c6d0116$var$peek(heap) {
    return 0 === heap.length ? null : heap[0];
}
function $134ae1c85c6d0116$var$pop(heap) {
    if (0 === heap.length) return null;
    var first = heap[0], last = heap.pop();
    if (last !== first) {
        heap[0] = last;
        a: for(var index = 0, length = heap.length, halfLength = length >>> 1; index < halfLength;){
            var leftIndex = 2 * (index + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > $134ae1c85c6d0116$var$compare(left, last)) rightIndex < length && 0 > $134ae1c85c6d0116$var$compare(right, left) ? (heap[index] = right, heap[rightIndex] = last, index = rightIndex) : (heap[index] = left, heap[leftIndex] = last, index = leftIndex);
            else if (rightIndex < length && 0 > $134ae1c85c6d0116$var$compare(right, last)) heap[index] = right, heap[rightIndex] = last, index = rightIndex;
            else break a;
        }
    }
    return first;
}
function $134ae1c85c6d0116$var$compare(a, b) {
    var diff = a.sortIndex - b.sortIndex;
    return 0 !== diff ? diff : a.id - b.id;
}
$134ae1c85c6d0116$export$c4744153514ff05d = void 0;
if ("object" === typeof performance && "function" === typeof performance.now) {
    var $134ae1c85c6d0116$var$localPerformance = performance;
    $134ae1c85c6d0116$export$c4744153514ff05d = function() {
        return $134ae1c85c6d0116$var$localPerformance.now();
    };
} else {
    var $134ae1c85c6d0116$var$localDate = Date, $134ae1c85c6d0116$var$initialTime = $134ae1c85c6d0116$var$localDate.now();
    $134ae1c85c6d0116$export$c4744153514ff05d = function() {
        return $134ae1c85c6d0116$var$localDate.now() - $134ae1c85c6d0116$var$initialTime;
    };
}
var $134ae1c85c6d0116$var$taskQueue = [], $134ae1c85c6d0116$var$timerQueue = [], $134ae1c85c6d0116$var$taskIdCounter = 1, $134ae1c85c6d0116$var$currentTask = null, $134ae1c85c6d0116$var$currentPriorityLevel = 3, $134ae1c85c6d0116$var$isPerformingWork = !1, $134ae1c85c6d0116$var$isHostCallbackScheduled = !1, $134ae1c85c6d0116$var$isHostTimeoutScheduled = !1, $134ae1c85c6d0116$var$needsPaint = !1, $134ae1c85c6d0116$var$localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, $134ae1c85c6d0116$var$localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, $134ae1c85c6d0116$var$localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
function $134ae1c85c6d0116$var$advanceTimers(currentTime) {
    for(var timer = $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$timerQueue); null !== timer;){
        if (null === timer.callback) $134ae1c85c6d0116$var$pop($134ae1c85c6d0116$var$timerQueue);
        else if (timer.startTime <= currentTime) $134ae1c85c6d0116$var$pop($134ae1c85c6d0116$var$timerQueue), timer.sortIndex = timer.expirationTime, $134ae1c85c6d0116$var$push($134ae1c85c6d0116$var$taskQueue, timer);
        else break;
        timer = $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$timerQueue);
    }
}
function $134ae1c85c6d0116$var$handleTimeout(currentTime) {
    $134ae1c85c6d0116$var$isHostTimeoutScheduled = !1;
    $134ae1c85c6d0116$var$advanceTimers(currentTime);
    if (!$134ae1c85c6d0116$var$isHostCallbackScheduled) {
        if (null !== $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$taskQueue)) $134ae1c85c6d0116$var$isHostCallbackScheduled = !0, $134ae1c85c6d0116$var$isMessageLoopRunning || ($134ae1c85c6d0116$var$isMessageLoopRunning = !0, $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline());
        else {
            var firstTimer = $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$timerQueue);
            null !== firstTimer && $134ae1c85c6d0116$var$requestHostTimeout($134ae1c85c6d0116$var$handleTimeout, firstTimer.startTime - currentTime);
        }
    }
}
var $134ae1c85c6d0116$var$isMessageLoopRunning = !1, $134ae1c85c6d0116$var$taskTimeoutID = -1, $134ae1c85c6d0116$var$frameInterval = 5, $134ae1c85c6d0116$var$startTime = -1;
function $134ae1c85c6d0116$var$shouldYieldToHost() {
    return $134ae1c85c6d0116$var$needsPaint ? !0 : $134ae1c85c6d0116$export$c4744153514ff05d() - $134ae1c85c6d0116$var$startTime < $134ae1c85c6d0116$var$frameInterval ? !1 : !0;
}
function $134ae1c85c6d0116$var$performWorkUntilDeadline() {
    $134ae1c85c6d0116$var$needsPaint = !1;
    if ($134ae1c85c6d0116$var$isMessageLoopRunning) {
        var currentTime = $134ae1c85c6d0116$export$c4744153514ff05d();
        $134ae1c85c6d0116$var$startTime = currentTime;
        var hasMoreWork = !0;
        try {
            a: {
                $134ae1c85c6d0116$var$isHostCallbackScheduled = !1;
                $134ae1c85c6d0116$var$isHostTimeoutScheduled && ($134ae1c85c6d0116$var$isHostTimeoutScheduled = !1, $134ae1c85c6d0116$var$localClearTimeout($134ae1c85c6d0116$var$taskTimeoutID), $134ae1c85c6d0116$var$taskTimeoutID = -1);
                $134ae1c85c6d0116$var$isPerformingWork = !0;
                var previousPriorityLevel = $134ae1c85c6d0116$var$currentPriorityLevel;
                try {
                    b: {
                        $134ae1c85c6d0116$var$advanceTimers(currentTime);
                        for($134ae1c85c6d0116$var$currentTask = $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$taskQueue); null !== $134ae1c85c6d0116$var$currentTask && !($134ae1c85c6d0116$var$currentTask.expirationTime > currentTime && $134ae1c85c6d0116$var$shouldYieldToHost());){
                            var callback = $134ae1c85c6d0116$var$currentTask.callback;
                            if ("function" === typeof callback) {
                                $134ae1c85c6d0116$var$currentTask.callback = null;
                                $134ae1c85c6d0116$var$currentPriorityLevel = $134ae1c85c6d0116$var$currentTask.priorityLevel;
                                var continuationCallback = callback($134ae1c85c6d0116$var$currentTask.expirationTime <= currentTime);
                                currentTime = $134ae1c85c6d0116$export$c4744153514ff05d();
                                if ("function" === typeof continuationCallback) {
                                    $134ae1c85c6d0116$var$currentTask.callback = continuationCallback;
                                    $134ae1c85c6d0116$var$advanceTimers(currentTime);
                                    hasMoreWork = !0;
                                    break b;
                                }
                                $134ae1c85c6d0116$var$currentTask === $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$taskQueue) && $134ae1c85c6d0116$var$pop($134ae1c85c6d0116$var$taskQueue);
                                $134ae1c85c6d0116$var$advanceTimers(currentTime);
                            } else $134ae1c85c6d0116$var$pop($134ae1c85c6d0116$var$taskQueue);
                            $134ae1c85c6d0116$var$currentTask = $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$taskQueue);
                        }
                        if (null !== $134ae1c85c6d0116$var$currentTask) hasMoreWork = !0;
                        else {
                            var firstTimer = $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$timerQueue);
                            null !== firstTimer && $134ae1c85c6d0116$var$requestHostTimeout($134ae1c85c6d0116$var$handleTimeout, firstTimer.startTime - currentTime);
                            hasMoreWork = !1;
                        }
                    }
                    break a;
                } finally{
                    $134ae1c85c6d0116$var$currentTask = null, $134ae1c85c6d0116$var$currentPriorityLevel = previousPriorityLevel, $134ae1c85c6d0116$var$isPerformingWork = !1;
                }
                hasMoreWork = void 0;
            }
        } finally{
            hasMoreWork ? $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline() : $134ae1c85c6d0116$var$isMessageLoopRunning = !1;
        }
    }
}
var $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline;
if ("function" === typeof $134ae1c85c6d0116$var$localSetImmediate) $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline = function() {
    $134ae1c85c6d0116$var$localSetImmediate($134ae1c85c6d0116$var$performWorkUntilDeadline);
};
else if ("undefined" !== typeof MessageChannel) {
    var $134ae1c85c6d0116$var$channel = new MessageChannel(), $134ae1c85c6d0116$var$port = $134ae1c85c6d0116$var$channel.port2;
    $134ae1c85c6d0116$var$channel.port1.onmessage = $134ae1c85c6d0116$var$performWorkUntilDeadline;
    $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline = function() {
        $134ae1c85c6d0116$var$port.postMessage(null);
    };
} else $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline = function() {
    $134ae1c85c6d0116$var$localSetTimeout($134ae1c85c6d0116$var$performWorkUntilDeadline, 0);
};
function $134ae1c85c6d0116$var$requestHostTimeout(callback, ms) {
    $134ae1c85c6d0116$var$taskTimeoutID = $134ae1c85c6d0116$var$localSetTimeout(function() {
        callback($134ae1c85c6d0116$export$c4744153514ff05d());
    }, ms);
}
$134ae1c85c6d0116$export$3e506c1ccc9cc1a7 = 5;
$134ae1c85c6d0116$export$e26fe2ed2fa76875 = 1;
$134ae1c85c6d0116$export$502329bbf4b505b1 = 4;
$134ae1c85c6d0116$export$6e3807111c4874c4 = 3;
$134ae1c85c6d0116$export$c27134553091fb3a = null;
$134ae1c85c6d0116$export$33ee1acdc04fd2a2 = 2;
$134ae1c85c6d0116$export$b00a404bbd5edef2 = function(task) {
    task.callback = null;
};
$134ae1c85c6d0116$export$d66a1c1c77bd778b = function(fps) {
    0 > fps || 125 < fps ? console.error("forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported") : $134ae1c85c6d0116$var$frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
};
$134ae1c85c6d0116$export$d3dfb8e4810cb555 = function() {
    return $134ae1c85c6d0116$var$currentPriorityLevel;
};
$134ae1c85c6d0116$export$72fdf0e06517287b = function(eventHandler) {
    switch($134ae1c85c6d0116$var$currentPriorityLevel){
        case 1:
        case 2:
        case 3:
            var priorityLevel = 3;
            break;
        default:
            priorityLevel = $134ae1c85c6d0116$var$currentPriorityLevel;
    }
    var previousPriorityLevel = $134ae1c85c6d0116$var$currentPriorityLevel;
    $134ae1c85c6d0116$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $134ae1c85c6d0116$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$134ae1c85c6d0116$export$816d2913ae6b83b1 = function() {
    $134ae1c85c6d0116$var$needsPaint = !0;
};
$134ae1c85c6d0116$export$61bcfe829111a1d0 = function(priorityLevel, eventHandler) {
    switch(priorityLevel){
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
            break;
        default:
            priorityLevel = 3;
    }
    var previousPriorityLevel = $134ae1c85c6d0116$var$currentPriorityLevel;
    $134ae1c85c6d0116$var$currentPriorityLevel = priorityLevel;
    try {
        return eventHandler();
    } finally{
        $134ae1c85c6d0116$var$currentPriorityLevel = previousPriorityLevel;
    }
};
$134ae1c85c6d0116$export$7ee8c9beb337bc3f = function(priorityLevel, callback, options) {
    var currentTime = $134ae1c85c6d0116$export$c4744153514ff05d();
    "object" === typeof options && null !== options ? (options = options.delay, options = "number" === typeof options && 0 < options ? currentTime + options : currentTime) : options = currentTime;
    switch(priorityLevel){
        case 1:
            var timeout = -1;
            break;
        case 2:
            timeout = 250;
            break;
        case 5:
            timeout = 1073741823;
            break;
        case 4:
            timeout = 1e4;
            break;
        default:
            timeout = 5e3;
    }
    timeout = options + timeout;
    priorityLevel = {
        id: $134ae1c85c6d0116$var$taskIdCounter++,
        callback: callback,
        priorityLevel: priorityLevel,
        startTime: options,
        expirationTime: timeout,
        sortIndex: -1
    };
    options > currentTime ? (priorityLevel.sortIndex = options, $134ae1c85c6d0116$var$push($134ae1c85c6d0116$var$timerQueue, priorityLevel), null === $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$taskQueue) && priorityLevel === $134ae1c85c6d0116$var$peek($134ae1c85c6d0116$var$timerQueue) && ($134ae1c85c6d0116$var$isHostTimeoutScheduled ? ($134ae1c85c6d0116$var$localClearTimeout($134ae1c85c6d0116$var$taskTimeoutID), $134ae1c85c6d0116$var$taskTimeoutID = -1) : $134ae1c85c6d0116$var$isHostTimeoutScheduled = !0, $134ae1c85c6d0116$var$requestHostTimeout($134ae1c85c6d0116$var$handleTimeout, options - currentTime))) : (priorityLevel.sortIndex = timeout, $134ae1c85c6d0116$var$push($134ae1c85c6d0116$var$taskQueue, priorityLevel), $134ae1c85c6d0116$var$isHostCallbackScheduled || $134ae1c85c6d0116$var$isPerformingWork || ($134ae1c85c6d0116$var$isHostCallbackScheduled = !0, $134ae1c85c6d0116$var$isMessageLoopRunning || ($134ae1c85c6d0116$var$isMessageLoopRunning = !0, $134ae1c85c6d0116$var$schedulePerformWorkUntilDeadline())));
    return priorityLevel;
};
$134ae1c85c6d0116$export$b5836b71941fa3ed = $134ae1c85c6d0116$var$shouldYieldToHost;
$134ae1c85c6d0116$export$cf845f2c119da08a = function(callback) {
    var parentPriorityLevel = $134ae1c85c6d0116$var$currentPriorityLevel;
    return function() {
        var previousPriorityLevel = $134ae1c85c6d0116$var$currentPriorityLevel;
        $134ae1c85c6d0116$var$currentPriorityLevel = parentPriorityLevel;
        try {
            return callback.apply(this, arguments);
        } finally{
            $134ae1c85c6d0116$var$currentPriorityLevel = previousPriorityLevel;
        }
    };
};

});


parcelRegister("4lOAY", function(module, exports) {
'use strict';
function $32b05ec6bb180397$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($32b05ec6bb180397$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$32b05ec6bb180397$var$checkDCE();

module.exports = (parcelRequire("cQLRU"));

});
parcelRegister("cQLRU", function(module, exports) {

$parcel$export(module.exports, "__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE", () => $95af7912bca1e174$export$69ce8ef3fe5cead0, (v) => $95af7912bca1e174$export$69ce8ef3fe5cead0 = v);
$parcel$export(module.exports, "browser", () => $95af7912bca1e174$export$3f2684e5d7cb1006, (v) => $95af7912bca1e174$export$3f2684e5d7cb1006 = v);
$parcel$export(module.exports, "createPortal", () => $95af7912bca1e174$export$d39a5bbd09211389, (v) => $95af7912bca1e174$export$d39a5bbd09211389 = v);
$parcel$export(module.exports, "flushSync", () => $95af7912bca1e174$export$cd75ccfd720a3cd4, (v) => $95af7912bca1e174$export$cd75ccfd720a3cd4 = v);
$parcel$export(module.exports, "preconnect", () => $95af7912bca1e174$export$a0816fa17a9e79be, (v) => $95af7912bca1e174$export$a0816fa17a9e79be = v);
$parcel$export(module.exports, "prefetchDNS", () => $95af7912bca1e174$export$7292efcadded39f3, (v) => $95af7912bca1e174$export$7292efcadded39f3 = v);
$parcel$export(module.exports, "preinit", () => $95af7912bca1e174$export$da407abadb9b8f86, (v) => $95af7912bca1e174$export$da407abadb9b8f86 = v);
$parcel$export(module.exports, "preinitModule", () => $95af7912bca1e174$export$314cfea32580671c, (v) => $95af7912bca1e174$export$314cfea32580671c = v);
$parcel$export(module.exports, "preload", () => $95af7912bca1e174$export$513ccb98c53b8039, (v) => $95af7912bca1e174$export$513ccb98c53b8039 = v);
$parcel$export(module.exports, "preloadModule", () => $95af7912bca1e174$export$dbca993bc2d264a, (v) => $95af7912bca1e174$export$dbca993bc2d264a = v);
$parcel$export(module.exports, "requestFormReset", () => $95af7912bca1e174$export$4797a8006f0655d0, (v) => $95af7912bca1e174$export$4797a8006f0655d0 = v);
$parcel$export(module.exports, "unstable_batchedUpdates", () => $95af7912bca1e174$export$c78a37762a8d58e1, (v) => $95af7912bca1e174$export$c78a37762a8d58e1 = v);
$parcel$export(module.exports, "useFormState", () => $95af7912bca1e174$export$606f11b2eb45ecc6, (v) => $95af7912bca1e174$export$606f11b2eb45ecc6 = v);
$parcel$export(module.exports, "useFormStatus", () => $95af7912bca1e174$export$f7e8a0bf92324b1e, (v) => $95af7912bca1e174$export$f7e8a0bf92324b1e = v);
$parcel$export(module.exports, "version", () => $95af7912bca1e174$export$83d89fbfd8236492, (v) => $95af7912bca1e174$export$83d89fbfd8236492 = v);
/**
 * @license React
 * react-dom.production.js
 *
 * Copyright (c) Meta Platforms, Inc. and affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $95af7912bca1e174$export$69ce8ef3fe5cead0;
var $95af7912bca1e174$export$3f2684e5d7cb1006;
var $95af7912bca1e174$export$d39a5bbd09211389;
var $95af7912bca1e174$export$cd75ccfd720a3cd4;
var $95af7912bca1e174$export$a0816fa17a9e79be;
var $95af7912bca1e174$export$7292efcadded39f3;
var $95af7912bca1e174$export$da407abadb9b8f86;
var $95af7912bca1e174$export$314cfea32580671c;
var $95af7912bca1e174$export$513ccb98c53b8039;
var $95af7912bca1e174$export$dbca993bc2d264a;
var $95af7912bca1e174$export$4797a8006f0655d0;
var $95af7912bca1e174$export$c78a37762a8d58e1;
var $95af7912bca1e174$export$606f11b2eb45ecc6;
var $95af7912bca1e174$export$f7e8a0bf92324b1e;
var $95af7912bca1e174$export$83d89fbfd8236492;
"use strict";

var $aZSru = parcelRequire("aZSru");
function $95af7912bca1e174$var$formatProdErrorMessage(code) {
    var url = "https://react.dev/errors/" + code;
    if (1 < arguments.length) {
        url += "?args[]=" + encodeURIComponent(arguments[1]);
        for(var i = 2; i < arguments.length; i++)url += "&args[]=" + encodeURIComponent(arguments[i]);
    }
    return "Minified React error #" + code + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
}
function $95af7912bca1e174$var$noop() {}
var $95af7912bca1e174$var$Internals = {
    d: {
        f: $95af7912bca1e174$var$noop,
        r: function() {
            throw Error($95af7912bca1e174$var$formatProdErrorMessage(522));
        },
        D: $95af7912bca1e174$var$noop,
        C: $95af7912bca1e174$var$noop,
        L: $95af7912bca1e174$var$noop,
        m: $95af7912bca1e174$var$noop,
        X: $95af7912bca1e174$var$noop,
        S: $95af7912bca1e174$var$noop,
        M: $95af7912bca1e174$var$noop
    },
    p: 0,
    findDOMNode: null
}, $95af7912bca1e174$var$REACT_PORTAL_TYPE = Symbol.for("react.portal"), $95af7912bca1e174$var$REACT_RECOVERABLE_TYPE = Symbol.for("react.recoverable"), $95af7912bca1e174$var$REACT_OPTIMISTIC_KEY = Symbol.for("react.optimistic_key");
function $95af7912bca1e174$var$createPortal$1(children, containerInfo, implementation) {
    var key = 3 < arguments.length && void 0 !== arguments[3] ? arguments[3] : null;
    return {
        $$typeof: $95af7912bca1e174$var$REACT_PORTAL_TYPE,
        key: null == key ? null : key === $95af7912bca1e174$var$REACT_OPTIMISTIC_KEY ? $95af7912bca1e174$var$REACT_OPTIMISTIC_KEY : "" + key,
        children: children,
        containerInfo: containerInfo,
        implementation: implementation
    };
}
var $95af7912bca1e174$var$ReactSharedInternals = $aZSru.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE;
function $95af7912bca1e174$var$getCrossOriginStringAs(as, input) {
    if ("font" === as) return "";
    if ("string" === typeof input) return "use-credentials" === input ? input : "";
}
$95af7912bca1e174$export$69ce8ef3fe5cead0 = $95af7912bca1e174$var$Internals;
$95af7912bca1e174$export$3f2684e5d7cb1006 = function(reason) {
    return {
        $$typeof: $95af7912bca1e174$var$REACT_RECOVERABLE_TYPE,
        _reason: reason
    };
};
$95af7912bca1e174$export$d39a5bbd09211389 = function(children, container) {
    var key = 2 < arguments.length && void 0 !== arguments[2] ? arguments[2] : null;
    if (!container || 1 !== container.nodeType && 9 !== container.nodeType && 11 !== container.nodeType) throw Error($95af7912bca1e174$var$formatProdErrorMessage(299));
    return $95af7912bca1e174$var$createPortal$1(children, container, null, key);
};
$95af7912bca1e174$export$cd75ccfd720a3cd4 = function(fn) {
    var previousTransition = $95af7912bca1e174$var$ReactSharedInternals.T, previousUpdatePriority = $95af7912bca1e174$var$Internals.p;
    try {
        if ($95af7912bca1e174$var$ReactSharedInternals.T = null, $95af7912bca1e174$var$Internals.p = 2, fn) return fn();
    } finally{
        $95af7912bca1e174$var$ReactSharedInternals.T = previousTransition, $95af7912bca1e174$var$Internals.p = previousUpdatePriority, $95af7912bca1e174$var$Internals.d.f();
    }
};
$95af7912bca1e174$export$a0816fa17a9e79be = function(href, options) {
    "string" === typeof href && (options ? (options = options.crossOrigin, options = "string" === typeof options ? "use-credentials" === options ? options : "" : void 0) : options = null, $95af7912bca1e174$var$Internals.d.C(href, options));
};
$95af7912bca1e174$export$7292efcadded39f3 = function(href) {
    "string" === typeof href && $95af7912bca1e174$var$Internals.d.D(href);
};
$95af7912bca1e174$export$da407abadb9b8f86 = function(href, options) {
    if ("string" === typeof href && options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $95af7912bca1e174$var$getCrossOriginStringAs(as, options.crossOrigin), integrity = "string" === typeof options.integrity ? options.integrity : void 0, fetchPriority = "string" === typeof options.fetchPriority ? options.fetchPriority : void 0;
        "style" === as ? $95af7912bca1e174$var$Internals.d.S(href, "string" === typeof options.precedence ? options.precedence : void 0, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority
        }) : "script" === as && $95af7912bca1e174$var$Internals.d.X(href, {
            crossOrigin: crossOrigin,
            integrity: integrity,
            fetchPriority: fetchPriority,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0
        });
    }
};
$95af7912bca1e174$export$314cfea32580671c = function(href, options) {
    if ("string" === typeof href) {
        if ("object" === typeof options && null !== options) {
            if (null == options.as || "script" === options.as) {
                var crossOrigin = $95af7912bca1e174$var$getCrossOriginStringAs(options.as, options.crossOrigin);
                $95af7912bca1e174$var$Internals.d.M(href, {
                    crossOrigin: crossOrigin,
                    integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                    nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                    fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
                });
            }
        } else null == options && $95af7912bca1e174$var$Internals.d.M(href);
    }
};
$95af7912bca1e174$export$513ccb98c53b8039 = function(href, options) {
    if ("string" === typeof href && "object" === typeof options && null !== options && "string" === typeof options.as) {
        var as = options.as, crossOrigin = $95af7912bca1e174$var$getCrossOriginStringAs(as, options.crossOrigin);
        $95af7912bca1e174$var$Internals.d.L(href, as, {
            crossOrigin: crossOrigin,
            integrity: "string" === typeof options.integrity ? options.integrity : void 0,
            nonce: "string" === typeof options.nonce ? options.nonce : void 0,
            type: "string" === typeof options.type ? options.type : void 0,
            fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0,
            referrerPolicy: "string" === typeof options.referrerPolicy ? options.referrerPolicy : void 0,
            imageSrcSet: "string" === typeof options.imageSrcSet ? options.imageSrcSet : void 0,
            imageSizes: "string" === typeof options.imageSizes ? options.imageSizes : void 0,
            media: "string" === typeof options.media ? options.media : void 0
        });
    }
};
$95af7912bca1e174$export$dbca993bc2d264a = function(href, options) {
    if ("string" === typeof href) {
        if (options) {
            var crossOrigin = $95af7912bca1e174$var$getCrossOriginStringAs(options.as, options.crossOrigin);
            $95af7912bca1e174$var$Internals.d.m(href, {
                as: "string" === typeof options.as && "script" !== options.as ? options.as : void 0,
                crossOrigin: crossOrigin,
                integrity: "string" === typeof options.integrity ? options.integrity : void 0,
                nonce: "string" === typeof options.nonce ? options.nonce : void 0,
                fetchPriority: "string" === typeof options.fetchPriority ? options.fetchPriority : void 0
            });
        } else $95af7912bca1e174$var$Internals.d.m(href);
    }
};
$95af7912bca1e174$export$4797a8006f0655d0 = function(form) {
    $95af7912bca1e174$var$Internals.d.r(form);
};
$95af7912bca1e174$export$c78a37762a8d58e1 = function(fn, a) {
    return fn(a);
};
$95af7912bca1e174$export$606f11b2eb45ecc6 = function(action, initialState, permalink) {
    return $95af7912bca1e174$var$ReactSharedInternals.H.useFormState(action, initialState, permalink);
};
$95af7912bca1e174$export$f7e8a0bf92324b1e = function() {
    return $95af7912bca1e174$var$ReactSharedInternals.H.useHostTransitionStatus();
};
$95af7912bca1e174$export$83d89fbfd8236492 = "19.3.0";

});



parcelRegister("bNXdN", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';

var $2v9cr = parcelRequire("2v9cr");
function $8982357cbbdafb2d$var$emptyFunction() {}
function $8982357cbbdafb2d$var$emptyFunctionWithReset() {}
$8982357cbbdafb2d$var$emptyFunctionWithReset.resetWarningCache = $8982357cbbdafb2d$var$emptyFunction;
module.exports = function() {
    function shim(props, propName, componentName, location, propFullName, secret) {
        if (secret === $2v9cr) // It is still safe when called from React.
        return;
        var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
        err.name = 'Invariant Violation';
        throw err;
    }
    shim.isRequired = shim;
    function getShim() {
        return shim;
    }
    // Important!
    // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
    var ReactPropTypes = {
        array: shim,
        bigint: shim,
        bool: shim,
        func: shim,
        number: shim,
        object: shim,
        string: shim,
        symbol: shim,
        any: shim,
        arrayOf: getShim,
        element: shim,
        elementType: shim,
        instanceOf: getShim,
        node: shim,
        objectOf: getShim,
        oneOf: getShim,
        oneOfType: getShim,
        shape: getShim,
        exact: getShim,
        checkPropTypes: $8982357cbbdafb2d$var$emptyFunctionWithReset,
        resetWarningCache: $8982357cbbdafb2d$var$emptyFunction
    };
    ReactPropTypes.PropTypes = ReactPropTypes;
    return ReactPropTypes;
};

});
parcelRegister("2v9cr", function(module, exports) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
var $1d259ce1abdcd363$var$ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
module.exports = $1d259ce1abdcd363$var$ReactPropTypesSecret;

});


parcelRegister("94eCw", function(module, exports) {
//! moment.js
//! version : 2.31.0
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com
(function(global, factory) {
    module.exports = factory();
})(this, function() {
    'use strict';
    var hookCallback;
    function hooks() {
        return hookCallback.apply(null, arguments);
    }
    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }
    function isArray(input) {
        return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
    }
    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return input != null && Object.prototype.toString.call(input) === '[object Object]';
    }
    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }
    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) return Object.getOwnPropertyNames(obj).length === 0;
        else {
            var k;
            for(k in obj){
                if (hasOwnProp(obj, k)) return false;
            }
            return true;
        }
    }
    function isUndefined(input) {
        return input === void 0;
    }
    function isNumber(input) {
        return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
    }
    function isDate(input) {
        return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
    }
    function map(arr, fn) {
        var res = [], i, arrLen = arr.length;
        for(i = 0; i < arrLen; ++i)res.push(fn(arr[i], i));
        return res;
    }
    function extend(a, b) {
        for(var i in b)if (hasOwnProp(b, i)) a[i] = b[i];
        if (hasOwnProp(b, 'toString')) a.toString = b.toString;
        if (hasOwnProp(b, 'valueOf')) a.valueOf = b.valueOf;
        return a;
    }
    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }
    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidOffset: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false
        };
    }
    function getParsingFlags(m) {
        if (m._pf == null) m._pf = defaultParsingFlags();
        return m._pf;
    }
    var some;
    if (Array.prototype.some) some = Array.prototype.some;
    else some = function(fun) {
        var t = Object(this), len = t.length >>> 0, i;
        for(i = 0; i < len; i++){
            if (i in t && fun.call(this, t[i], i, t)) return true;
        }
        return false;
    };
    function isValid$2(m) {
        var flags = null, parsedParts = false, isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function(i) {
                return i != null;
            });
            isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidOffset && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
            if (m._strict) isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) m._isValid = isNowValid;
        else return isNowValid;
        return m._isValid;
    }
    function createInvalid$1(flags) {
        var m = createUTC(NaN);
        if (flags != null) extend(getParsingFlags(m), flags);
        else getParsingFlags(m).userInvalidated = true;
        return m;
    }
    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = hooks.momentProperties = [], updateInProgress = false;
    function copyConfig(to, from) {
        var i, prop, val, momentPropertiesLen = momentProperties.length;
        if (!isUndefined(from._isAMomentObject)) to._isAMomentObject = from._isAMomentObject;
        if (!isUndefined(from._i)) to._i = from._i;
        if (!isUndefined(from._f)) to._f = from._f;
        if (!isUndefined(from._l)) to._l = from._l;
        if (!isUndefined(from._strict)) to._strict = from._strict;
        if (!isUndefined(from._tzm)) to._tzm = from._tzm;
        if (!isUndefined(from._isUTC)) to._isUTC = from._isUTC;
        if (!isUndefined(from._offset)) to._offset = from._offset;
        if (!isUndefined(from._pf)) to._pf = getParsingFlags(from);
        if (!isUndefined(from._locale)) to._locale = from._locale;
        if (momentPropertiesLen > 0) for(i = 0; i < momentPropertiesLen; i++){
            prop = momentProperties[i];
            val = from[prop];
            if (!isUndefined(val)) to[prop] = val;
        }
        return to;
    }
    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) this._d = new Date(NaN);
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }
    function isMoment(obj) {
        return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
    }
    function warn(msg) {
        if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) console.warn('Deprecation warning: ' + msg);
    }
    function deprecate(msg, fn) {
        var firstTime = true;
        return extend(function() {
            if (hooks.deprecationHandler != null) hooks.deprecationHandler(null, msg);
            if (firstTime) {
                var args = [], arg, i, key, argLen = arguments.length;
                for(i = 0; i < argLen; i++){
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for(key in arguments[0])if (hasOwnProp(arguments[0], key)) arg += key + ': ' + arguments[0][key] + ', ';
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else arg = arguments[i];
                    args.push(arg);
                }
                warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }
    var deprecations = {};
    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) hooks.deprecationHandler(name, msg);
        if (!deprecations[name]) {
            warn(msg + '\n' + new Error().stack);
            deprecations[name] = true;
        }
    }
    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;
    function isFunction(input) {
        return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
    }
    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year'
    };
    function normalizeUnits(units) {
        return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
    }
    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {}, normalizedProp, prop;
        for(prop in inputObject)if (hasOwnProp(inputObject, prop)) {
            normalizedProp = normalizeUnits(prop);
            if (normalizedProp) normalizedInput[normalizedProp] = inputObject[prop];
        }
        return normalizedInput;
    }
    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1
    };
    function getPrioritizedUnits(unitsObj) {
        var units = [], u;
        for(u in unitsObj)if (hasOwnProp(unitsObj, u)) units.push({
            unit: u,
            priority: priorities[u]
        });
        units.sort(function(a, b) {
            return a.priority - b.priority;
        });
        return units;
    }
    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number), zerosToFill = targetLength - absNumber.length, sign = number >= 0;
        return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
    }
    var formattingTokens = /(\[[^\[]*\])|(\\e)|(\\)?(eHHmm|[Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g, localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g, formatFunctions = {}, formatTokenFunctions = {};
    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') func = function() {
            return this[callback]();
        };
        if (token) formatTokenFunctions[token] = func;
        if (padded) formatTokenFunctions[padded[0]] = function() {
            return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
        };
        if (ordinal) formatTokenFunctions[ordinal] = function() {
            return this.localeData().ordinal(func.apply(this, arguments), token);
        };
    }
    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) return input.replace(/^\[|\]$/g, '');
        return input.replace(/\\/g, '');
    }
    function makeFormatFunction(format) {
        var array = format.match(formattingTokens), i, length;
        for(i = 0, length = array.length; i < length; i++)if (formatTokenFunctions[array[i]]) array[i] = formatTokenFunctions[array[i]];
        else array[i] = removeFormattingTokens(array[i]);
        return function(mom) {
            var output = '', i;
            for(i = 0; i < length; i++)output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
            return output;
        };
    }
    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) return m.localeData().invalidDate();
        format = expandFormat(format, m.localeData());
        var cacheKey = '$' + format;
        if (!hasOwnProp(formatFunctions, cacheKey)) formatFunctions[cacheKey] = makeFormatFunction(format);
        return formatFunctions[cacheKey](m);
    }
    function expandFormat(format, locale) {
        var i = 5;
        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }
        localFormattingTokens.lastIndex = 0;
        while(i >= 0 && localFormattingTokens.test(format)){
            format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }
        return format;
    }
    var match1 = /\d/, match2 = /\d\d/, match3 = /\d{3}/, match4 = /\d{4}/, match6 = /[+-]?\d{6}/, match1to2 = /\d\d?/, match3to4 = /\d\d\d\d?/, match5to6 = /\d\d\d\d\d\d?/, match1to3 = /\d{1,3}/, match1to4 = /\d{1,4}/, match1to6 = /[+-]?\d{1,6}/, matchUnsigned = /\d+/, matchSigned = /[+-]?\d+/, matchOffset = /Z|[+-]\d\d:?\d\d/gi, matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i, match1to2NoLeadingZero = /^[1-9]\d?/, match1to2HasZero = /^([1-9]\d|\d)/, regexes;
    regexes = {};
    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex) ? regex : function(isStrict, localeData) {
            return isStrict && strictRegex ? strictRegex : regex;
        };
    }
    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) return new RegExp(unescapeFormat(token));
        return regexes[token](config._strict, config._locale);
    }
    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function(matched, p1, p2, p3, p4) {
            return p1 || p2 || p3 || p4;
        }));
    }
    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }
    function absFloor(number) {
        if (number < 0) // -0 -> 0
        return Math.ceil(number) || 0;
        else return Math.floor(number);
    }
    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion, value = 0;
        if (coercedNumber !== 0 && isFinite(coercedNumber)) value = absFloor(coercedNumber);
        return value;
    }
    var tokens = {};
    function addParseToken(token, callback) {
        var i, func = callback, tokenLen;
        if (typeof token === 'string') token = [
            token
        ];
        if (isNumber(callback)) func = function(input, array) {
            array[callback] = toInt(input);
        };
        tokenLen = token.length;
        for(i = 0; i < tokenLen; i++)tokens[token[i]] = func;
    }
    function addWeekParseToken(token, callback) {
        addParseToken(token, function(input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }
    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) tokens[token](input, config._a, config, token);
    }
    function isLeapYear(year) {
        return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
    }
    var YEAR = 0, MONTH = 1, DATE = 2, HOUR = 3, MINUTE = 4, SECOND = 5, MILLISECOND = 6, WEEK = 7, WEEKDAY = 8;
    // FORMATTING
    addFormatToken('Y', 0, 0, function() {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });
    addFormatToken(0, [
        'YY',
        2
    ], 0, function() {
        return this.year() % 100;
    });
    addFormatToken(0, [
        'YYYY',
        4
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYY',
        5
    ], 0, 'year');
    addFormatToken(0, [
        'YYYYYY',
        6,
        true
    ], 0, 'year');
    // PARSING
    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);
    addParseToken([
        'YYYYY',
        'YYYYYY'
    ], YEAR);
    addParseToken('YYYY', function(input, array) {
        array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function(input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function(input, array) {
        array[YEAR] = parseInt(input, 10);
    });
    // HELPERS
    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }
    // HOOKS
    hooks.parseTwoDigitYear = function(input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };
    // MOMENTS
    var getSetYear = makeGetSet('FullYear', true);
    function getIsLeapYear() {
        return isLeapYear(this.year());
    }
    function makeGetSet(unit, keepTime) {
        return function(value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else return get$2(this, unit);
        };
    }
    function get$2(mom, unit) {
        if (!mom.isValid()) return NaN;
        var d = mom._d, isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }
    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;
        if (!mom.isValid() || isNaN(value)) return;
        d = mom._d;
        isUTC = mom._isUTC;
        switch(unit){
            case 'Milliseconds':
                return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }
        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date);
    }
    // MOMENTS
    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) return this[units]();
        return this;
    }
    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units), i, prioritizedLen = prioritized.length;
            for(i = 0; i < prioritizedLen; i++)this[prioritized[i].unit](units[prioritized[i].unit]);
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) return this[units](value);
        }
        return this;
    }
    function mod$1(n, x) {
        return (n % x + x) % x;
    }
    var indexOf;
    if (Array.prototype.indexOf) indexOf = Array.prototype.indexOf;
    else indexOf = function(o) {
        // I know
        var i;
        for(i = 0; i < this.length; ++i){
            if (this[i] === o) return i;
        }
        return -1;
    };
    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) return NaN;
        var modMonth = mod$1(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
    }
    // FORMATTING
    addFormatToken('M', [
        'MM',
        2
    ], 'Mo', function() {
        return this.month() + 1;
    });
    addFormatToken('MMM', 0, 0, function(format) {
        return this.localeData().monthsShort(this, format);
    });
    addFormatToken('MMMM', 0, 0, function(format) {
        return this.localeData().months(this, format);
    });
    // PARSING
    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function(isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function(isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });
    addParseToken([
        'M',
        'MM'
    ], function(input, array) {
        array[MONTH] = toInt(input) - 1;
    });
    addParseToken([
        'MMM',
        'MMMM'
    ], function(input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) array[MONTH] = month;
        else getParsingFlags(config).invalidMonth = input;
    });
    // LOCALES
    var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'), defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'), MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/, defaultMonthsShortRegex = matchWord, defaultMonthsRegex = matchWord, monthsParseProperties = [
        'monthsParse',
        'longMonthsParse',
        'shortMonthsParse',
        'monthsRegex',
        'monthsShortRegex',
        'monthsStrictRegex',
        'monthsShortStrictRegex'
    ];
    function clearMonthsParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < monthsParseProperties.length; i++){
            prop = monthsParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeMonths(m, format) {
        if (!m) return isArray(this._months) ? this._months : this._months['standalone'];
        return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
    }
    function localeMonthsShort(m, format) {
        if (!m) return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
        return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
    }
    function handleStrictParse$1(monthName, format, strict) {
        var i, ii, mom, llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for(i = 0; i < 12; ++i){
                mom = createUTC([
                    2000,
                    i
                ]);
                this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else if (format === 'MMM') {
            ii = indexOf.call(this._shortMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._longMonthsParse, llc);
            return ii !== -1 ? ii : null;
        } else {
            ii = indexOf.call(this._longMonthsParse, llc);
            if (ii !== -1) return ii;
            ii = indexOf.call(this._shortMonthsParse, llc);
            return ii !== -1 ? ii : null;
        }
    }
    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;
        if (this._monthsParseExact) return handleStrictParse$1.call(this, monthName, format, strict);
        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }
        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
                this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
            }
            if (!strict && !this._monthsParse[i]) {
                regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) return i;
            else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) return i;
            else if (!strict && this._monthsParse[i].test(monthName)) return i;
        }
    }
    // MOMENTS
    function setMonth(mom, value) {
        if (!mom.isValid()) // No op
        return mom;
        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) value = toInt(value);
            else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) return mom;
            }
        }
        var month = value, date = mom.date();
        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date);
        return mom;
    }
    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else return get$2(this, 'Month');
    }
    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }
    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsShortStrictRegex;
            else return this._monthsShortRegex;
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) this._monthsShortRegex = defaultMonthsShortRegex;
            return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
        }
    }
    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) computeMonthsParse.call(this);
            if (isStrict) return this._monthsStrictRegex;
            else return this._monthsRegex;
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) this._monthsRegex = defaultMonthsRegex;
            return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
        }
    }
    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var shortPieces = [], longPieces = [], mixedPieces = [], i, mom, shortP, longP;
        for(i = 0; i < 12; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                i
            ]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken('d', 0, 'do', 'day');
    addFormatToken('dd', 0, 0, function(format) {
        return this.localeData().weekdaysMin(this, format);
    });
    addFormatToken('ddd', 0, 0, function(format) {
        return this.localeData().weekdaysShort(this, format);
    });
    addFormatToken('dddd', 0, 0, function(format) {
        return this.localeData().weekdays(this, format);
    });
    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');
    addFormatToken('eHHmm', 0, 0, function() {
        return '' + this.weekday() + zeroFill(this.hours(), 2) + zeroFill(this.minutes(), 2);
    });
    // PARSING
    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('eHHmm', match5to6);
    addRegexToken('dd', function(isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function(isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function(isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });
    addWeekParseToken([
        'dd',
        'ddd',
        'dddd'
    ], function(input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) week.d = weekday;
        else getParsingFlags(config).invalidWeekday = input;
    });
    addWeekParseToken([
        'd',
        'e',
        'E'
    ], function(input, week, config, token) {
        week[token] = toInt(input);
    });
    addWeekParseToken('eHHmm', function(input, week, config) {
        var weekdayEnd = input.length - 4;
        week.e = toInt(input.substr(0, weekdayEnd));
        config._a[HOUR] = toInt(input.substr(weekdayEnd, 2));
        config._a[MINUTE] = toInt(input.substr(weekdayEnd + 2));
    });
    // HELPERS
    function parseWeekday(input, locale) {
        if (typeof input !== 'string') return input;
        if (!isNaN(input)) return parseInt(input, 10);
        input = locale.weekdaysParse(input);
        if (typeof input === 'number') return input;
        return null;
    }
    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') return locale.weekdaysParse(input) % 7 || 7;
        return isNaN(input) ? null : input;
    }
    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }
    var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'), defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'), defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'), defaultWeekdaysRegex = matchWord, defaultWeekdaysShortRegex = matchWord, defaultWeekdaysMinRegex = matchWord, weekdaysParseProperties = [
        'weekdaysParse',
        'fullWeekdaysParse',
        'shortWeekdaysParse',
        'minWeekdaysParse',
        'weekdaysRegex',
        'weekdaysShortRegex',
        'weekdaysMinRegex',
        'weekdaysStrictRegex',
        'weekdaysShortStrictRegex',
        'weekdaysMinStrictRegex'
    ];
    function clearWeekdaysParseCache(locale, config) {
        var i, prop;
        for(i = 0; i < weekdaysParseProperties.length; i++){
            prop = weekdaysParseProperties[i];
            if (!hasOwnProp(config, prop)) delete locale['_' + prop];
        }
    }
    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
        return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
    }
    function localeWeekdaysShort(m) {
        return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
    }
    function localeWeekdaysMin(m) {
        return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
    }
    function handleStrictParse(weekdayName, format, strict) {
        var i, ii, mom, llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];
            for(i = 0; i < 7; ++i){
                mom = createUTC([
                    2000,
                    1
                ]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }
        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) return ii;
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }
    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;
        if (this._weekdaysParseExact) return handleStrictParse.call(this, weekdayName, format, strict);
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
                this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
                this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
            }
            if (!this._weekdaysParse[i]) {
                regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) return i;
            else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) return i;
            else if (!strict && this._weekdaysParse[i].test(weekdayName)) return i;
        }
    }
    // MOMENTS
    function getSetDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var day = get$2(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else return day;
    }
    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }
    function getSetISODayOfWeek(input) {
        if (!this.isValid()) return input != null ? this : NaN;
        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.
        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else return this.day() || 7;
    }
    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysStrictRegex;
            else return this._weekdaysRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) this._weekdaysRegex = defaultWeekdaysRegex;
            return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
        }
    }
    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysShortStrictRegex;
            else return this._weekdaysShortRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
        }
    }
    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) computeWeekdaysParse.call(this);
            if (isStrict) return this._weekdaysMinStrictRegex;
            else return this._weekdaysMinRegex;
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
        }
    }
    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }
        var minPieces = [], shortPieces = [], longPieces = [], mixedPieces = [], i, mom, minp, shortp, longp;
        for(i = 0; i < 7; i++){
            // make the regex if we don't have it already
            mom = createUTC([
                2000,
                1
            ]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);
        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;
        this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
        this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
        this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
    }
    function set(config) {
        var prop, i;
        clearMonthsParseCache(this, config);
        clearWeekdaysParseCache(this, config);
        for(i in config)if (hasOwnProp(config, i)) {
            prop = config[i];
            if (isFunction(prop)) this[i] = prop;
            else this['_' + i] = prop;
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
    }
    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig), prop;
        for(prop in childConfig)if (hasOwnProp(childConfig, prop)) {
            if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                res[prop] = {};
                extend(res[prop], parentConfig[prop]);
                extend(res[prop], childConfig[prop]);
            } else if (childConfig[prop] != null) res[prop] = childConfig[prop];
            else delete res[prop];
        }
        for(prop in parentConfig)if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
        return res;
    }
    function Locale(config) {
        if (config != null) this.set(config);
    }
    var keys;
    if (Object.keys) keys = Object.keys;
    else keys = function(obj) {
        var i, res = [];
        for(i in obj)if (hasOwnProp(obj, i)) res.push(i);
        return res;
    };
    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L'
    };
    function calendar$1(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }
    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A'
    };
    function longDateFormat(key) {
        var format = this._longDateFormat[key], formatUpper = this._longDateFormat[key.toUpperCase()], formatCache = this._longDateFormatCache;
        if (format || !formatUpper) return format;
        if (formatCache && formatCache[key] && formatCache[key].formatUpper === formatUpper) return formatCache[key].format;
        format = formatUpper.match(formattingTokens).map(function(tok) {
            if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') return tok.slice(1);
            return tok;
        }).join('');
        if (!formatCache) formatCache = this._longDateFormatCache = {};
        formatCache[key] = {
            formatUpper: formatUpper,
            format: format
        };
        return format;
    }
    var defaultInvalidDate = 'Invalid date';
    function invalidDate() {
        return this._invalidDate;
    }
    var defaultOrdinal = '%d', defaultDayOfMonthOrdinalParse = /\d{1,2}/;
    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }
    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years'
    };
    function relativeTimeWithoutPostformat(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
    }
    function relativeTime$1(number, withoutSuffix, string, isFuture) {
        return this.postformat(relativeTimeWithoutPostformat.call(this, number, withoutSuffix, string, isFuture));
    }
    function pastFutureWithoutPostformat(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }
    function pastFuture(diff, output) {
        return this.postformat(pastFutureWithoutPostformat.call(this, diff, output));
    }
    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) date.setFullYear(y);
        } else date = new Date(y, m, d, h, M, s, ms);
        return date;
    }
    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) date.setUTCFullYear(y);
        } else date = new Date(Date.UTC.apply(null, arguments));
        return date;
    }
    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var fwd = 7 + dow - doy, // first-week day local weekday -- which local weekday is fwd
        fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
        return -fwdlw + fwd - 1;
    }
    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7, weekOffset = firstWeekOffset(year, dow, doy), dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset, resYear, resDayOfYear;
        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }
        return {
            year: resYear,
            dayOfYear: resDayOfYear
        };
    }
    function weekOfYearFromDayOfYear(year, dayOfYear, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), week = Math.floor((dayOfYear - weekOffset - 1) / 7) + 1, resWeek, resYear;
        if (week < 1) {
            resYear = year - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(year, dow, doy)) {
            resWeek = week - weeksInYear(year, dow, doy);
            resYear = year + 1;
        } else {
            resYear = year;
            resWeek = week;
        }
        return {
            week: resWeek,
            year: resYear
        };
    }
    function weekOfYear(mom, dow, doy) {
        return weekOfYearFromDayOfYear(mom.year(), mom.dayOfYear(), dow, doy);
    }
    function weekOfYearFromDate(year, month, date, dow, doy) {
        var dayOfYear = Math.round((createUTCDate(year, month, date) - createUTCDate(year, 0, 1)) / 864e5) + 1;
        return weekOfYearFromDayOfYear(year, dayOfYear, dow, doy);
    }
    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy), weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }
    // FORMATTING
    addFormatToken('w', [
        'ww',
        2
    ], 'wo', 'week');
    addFormatToken('W', [
        'WW',
        2
    ], 'Wo', 'isoWeek');
    // PARSING
    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);
    addWeekParseToken([
        'w',
        'ww',
        'W',
        'WW'
    ], function(input, week, config, token) {
        week[token.substr(0, 1)] = toInt(input);
    });
    // HELPERS
    // LOCALES
    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }
    var defaultLocaleWeek = {
        dow: 0,
        doy: 6
    };
    function localeFirstDayOfWeek() {
        return this._week.dow;
    }
    function localeFirstDayOfYear() {
        return this._week.doy;
    }
    // MOMENTS
    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }
    // FORMATTING
    function hFormat() {
        return this.hours() % 12 || 12;
    }
    function kFormat() {
        return this.hours() || 24;
    }
    addFormatToken('H', [
        'HH',
        2
    ], 0, 'hour');
    addFormatToken('h', [
        'hh',
        2
    ], 0, hFormat);
    addFormatToken('k', [
        'kk',
        2
    ], 0, kFormat);
    addFormatToken('hmm', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });
    addFormatToken('hmmss', 0, 0, function() {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    addFormatToken('Hmm', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });
    addFormatToken('Hmmss', 0, 0, function() {
        return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
    });
    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function() {
            return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
        });
    }
    meridiem('a', true);
    meridiem('A', false);
    // PARSING
    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }
    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);
    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);
    addParseToken([
        'H',
        'HH'
    ], HOUR);
    addParseToken([
        'k',
        'kk'
    ], function(input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken([
        'a',
        'A'
    ], function(input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken([
        'h',
        'hh'
    ], function(input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function(input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function(input, array, config) {
        var pos1 = input.length - 4, pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });
    // LOCALES
    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }
    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i, // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) return isLower ? 'pm' : 'PM';
        else return isLower ? 'am' : 'AM';
    }
    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,
        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,
        week: defaultLocaleWeek,
        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,
        meridiemParse: defaultLocaleMeridiemParse
    };
    // internal storage for locale config files
    var locales = {}, localeFamilies = {}, globalLocale;
    function commonPrefix(arr1, arr2) {
        var i, minl = Math.min(arr1.length, arr2.length);
        for(i = 0; i < minl; i += 1){
            if (arr1[i] !== arr2[i]) return i;
        }
        return minl;
    }
    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }
    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0, j, next, locale, split;
        while(i < names.length){
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while(j > 0){
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) return locale;
                if (next && next.length >= j && commonPrefix(split, next) >= j - 1) break;
                j--;
            }
            i++;
        }
        return globalLocale;
    }
    function isLocaleNameSane(name) {
        // Only canonical locale module names are safe to append to the require path.
        return typeof name === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(name);
    }
    function loadLocale(name) {
        var oldLocale = null, aliasedRequire, normalizedName;
        // Preserve exact custom locale names before trying the canonical built-in name.
        // Use hasOwnProp rather than a plain lookup so that names like "__proto__",
        // "constructor", or "prototype" can't resolve to an inherited Object.prototype
        // property instead of a real (or missing) locale entry.
        if (hasOwnProp(locales, name)) return locales[name];
        normalizedName = normalizeLocale(name);
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
        // TODO: Find a better way to register and load all the locales in Node
        if (module && module.exports && isLocaleNameSane(normalizedName)) try {
            oldLocale = globalLocale._abbr;
            aliasedRequire = undefined;
            aliasedRequire('./locale/' + normalizedName);
            getSetGlobalLocale(oldLocale);
        } catch (e) {
            // mark as not found to avoid repeating expensive file require call causing high CPU
            // when trying to find en-US, en_US, en-us for every format call
            locales[normalizedName] = null; // null means not found
        }
        if (hasOwnProp(locales, normalizedName)) return locales[normalizedName];
    }
    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) data = getLocale(key);
            else data = defineLocale(key, values);
            if (data) // moment.duration._locale = moment._locale = data;
            globalLocale = data;
            else if (typeof console !== 'undefined' && console.warn) //warn user if arguments are passed but the locale could not be set
            console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
        return globalLocale._abbr;
    }
    function defineLocale(name, config) {
        if (config !== null) {
            var locale, parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple('defineLocaleOverride', "use moment.updateLocale(localeName, config) to change an existing locale. moment.defineLocale(localeName, config) should only be used for creating a new locale See http://momentjs.com/guides/#/warnings/define-locale/ for more info.");
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) parentConfig = locales[config.parentLocale]._config;
                else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) parentConfig = locale._config;
                    else {
                        if (!localeFamilies[config.parentLocale]) localeFamilies[config.parentLocale] = [];
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));
            if (localeFamilies[name]) localeFamilies[name].forEach(function(x) {
                defineLocale(x.name, x.config);
            });
            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);
            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }
    function updateLocale(name, config) {
        var locale, tmpLocale = loadLocale(name), parentConfig = baseConfig;
        if (tmpLocale != null) name = tmpLocale._abbr;
        if (config != null) {
            if (locales[name] != null && locales[name].parentLocale != null) // Update existing child locale in-place to avoid memory-leaks
            locales[name].set(mergeConfigs(locales[name]._config, config));
            else {
                // MERGE
                if (tmpLocale != null) parentConfig = tmpLocale._config;
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) // updateLocale is called for creating a new locale
                // Set abbr so it will have a name (getters return
                // undefined otherwise).
                config.abbr = name;
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }
            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else // pass null for config to unupdate, useful for tests
        if (locales[name] != null) {
            if (locales[name].parentLocale != null) {
                locales[name] = locales[name].parentLocale;
                if (name === getSetGlobalLocale()) getSetGlobalLocale(name);
            } else if (locales[name] != null) delete locales[name];
        }
        return locales[name];
    }
    // returns locale data
    function getLocale(key) {
        var locale;
        if (key && key._locale && key._locale._abbr) key = key._locale._abbr;
        if (!key) return globalLocale;
        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) return locale;
            key = [
                key
            ];
        }
        return chooseLocale(key);
    }
    function listLocales() {
        return keys(locales);
    }
    function checkOverflow(m) {
        var overflow, a = m._a;
        if (a && getParsingFlags(m).overflow === -2) {
            overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
            if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) overflow = DATE;
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) overflow = WEEK;
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) overflow = WEEKDAY;
            getParsingFlags(m).overflow = overflow;
        }
        return m;
    }
    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/, tzRegex = /Z|[+-]\d\d(?::?\d\d)?/, isoDates = [
        [
            'YYYYYY-MM-DD',
            /[+-]\d{6}-\d\d-\d\d/
        ],
        [
            'YYYY-MM-DD',
            /\d{4}-\d\d-\d\d/
        ],
        [
            'GGGG-[W]WW-E',
            /\d{4}-W\d\d-\d/
        ],
        [
            'GGGG-[W]WW',
            /\d{4}-W\d\d/,
            false
        ],
        [
            'YYYY-DDD',
            /\d{4}-\d{3}/
        ],
        [
            'YYYY-MM',
            /\d{4}-\d\d/,
            false
        ],
        [
            'YYYYYYMMDD',
            /[+-]\d{10}/
        ],
        [
            'YYYYMMDD',
            /\d{8}/
        ],
        [
            'GGGG[W]WWE',
            /\d{4}W\d{3}/
        ],
        [
            'GGGG[W]WW',
            /\d{4}W\d{2}/,
            false
        ],
        [
            'YYYYDDD',
            /\d{7}/
        ],
        [
            'YYYYMM',
            /\d{6}/,
            false
        ],
        [
            'YYYY',
            /\d{4}/,
            false
        ]
    ], // iso time formats and regexes
    isoTimes = [
        [
            'HH:mm:ss.SSSS',
            /\d\d:\d\d:\d\d\.\d+/
        ],
        [
            'HH:mm:ss,SSSS',
            /\d\d:\d\d:\d\d,\d+/
        ],
        [
            'HH:mm:ss',
            /\d\d:\d\d:\d\d/
        ],
        [
            'HH:mm',
            /\d\d:\d\d/
        ],
        [
            'HHmmss.SSSS',
            /\d\d\d\d\d\d\.\d+/
        ],
        [
            'HHmmss,SSSS',
            /\d\d\d\d\d\d,\d+/
        ],
        [
            'HHmmss',
            /\d\d\d\d\d\d/
        ],
        [
            'HHmm',
            /\d\d\d\d/
        ],
        [
            'HH',
            /\d\d/
        ]
    ], aspNetJsonRegex = /^\/?Date\((-?\d+)/i, // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/, obsOffsets = {
        UT: 0,
        GMT: 0,
        EDT: -240,
        EST: -300,
        CDT: -300,
        CST: -360,
        MDT: -360,
        MST: -420,
        PDT: -420,
        PST: -480
    };
    // date from iso format
    function configFromISO(config) {
        var i, l, string = config._i, match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string), allowTime, dateFormat, timeFormat, tzFormat, isoDatesLen = isoDates.length, isoTimesLen = isoTimes.length;
        if (match) {
            getParsingFlags(config).iso = true;
            for(i = 0, l = isoDatesLen; i < l; i++)if (isoDates[i][1].exec(match[1])) {
                dateFormat = isoDates[i][0];
                allowTime = isoDates[i][2] !== false;
                break;
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for(i = 0, l = isoTimesLen; i < l; i++)if (isoTimes[i][1].exec(match[3])) {
                    // match[2] should be 'T' or space
                    timeFormat = (match[2] || ' ') + isoTimes[i][0];
                    break;
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) tzFormat = 'Z';
                else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else config._isValid = false;
    }
    function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10)
        ];
        if (secondStr) result.push(parseInt(secondStr, 10));
        return result;
    }
    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) return 2000 + year;
        else if (year <= 999) return 1900 + year;
        return year;
    }
    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
    }
    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr), weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }
    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) return obsOffsets[obsOffset];
        else if (militaryOffset) // the only allowed military tz is Z
        return 0;
        else {
            var hm = parseInt(numOffset, 10), m = hm % 100, h = (hm - m) / 100;
            return h * 60 + m;
        }
    }
    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)), parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
            if (!checkWeekday(match[1], parsedArray, config)) return;
            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);
            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
            getParsingFlags(config).rfc2822 = true;
        } else config._isValid = false;
    }
    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }
        configFromISO(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        configFromRFC2822(config);
        if (config._isValid === false) delete config._isValid;
        else return;
        if (config._strict) config._isValid = false;
        else // Final attempt, use Input Fallback
        hooks.createFromInputFallback(config);
    }
    hooks.createFromInputFallback = deprecate("value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.", function(config) {
        config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
    });
    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) return a;
        if (b != null) return b;
        return c;
    }
    function currentDateArray(config, now, forWeek) {
        var hadWeekContext = Object.prototype.hasOwnProperty.call(config, '_isDefaultDatePartsForWeek'), weekContext = config._isDefaultDatePartsForWeek;
        // hooks is actually the exported moment object
        config._isDefaultDatePartsForWeek = !!forWeek;
        try {
            return hooks._getDefaultDateParts(config, now, forWeek);
        } finally{
            if (hadWeekContext) config._isDefaultDatePartsForWeek = weekContext;
            else delete config._isDefaultDatePartsForWeek;
        }
    }
    function currentDateNow(config) {
        var now = config._defaultDatePartsNow;
        if (!now) return hooks.now();
        if (!now.hasValue) {
            now.value = hooks.now();
            now.hasValue = true;
        }
        return now.value;
    }
    // Internal hook for extensions that supply omitted calendar fields.
    function getDefaultDateParts(config, now, forWeek) {
        var useWeekDefaults = forWeek || config._isDefaultDatePartsForWeek, nowValue = useWeekDefaults ? createLocal(now) : new Date(now);
        if (useWeekDefaults) return [
            nowValue.year(),
            nowValue.month(),
            nowValue.date()
        ];
        if (config._useUTC) return [
            nowValue.getUTCFullYear(),
            nowValue.getUTCMonth(),
            nowValue.getUTCDate()
        ];
        return [
            nowValue.getFullYear(),
            nowValue.getMonth(),
            nowValue.getDate()
        ];
    }
    hooks._getDefaultDateParts = getDefaultDateParts;
    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i, date, input = [], now, currentDate, expectedWeekday, yearToUse, dateIsDefaulted;
        if (config._d) return;
        if (config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null) {
            now = currentDateNow(config);
            currentDate = currentDateArray(config, now);
        }
        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) dayOfYearFromWeekInfo(config, currentDateArray(config, now, true));
        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = config._a[YEAR] != null ? config._a[YEAR] : currentDate[YEAR];
            if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) getParsingFlags(config)._overflowDayOfYear = true;
            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }
        dateIsDefaulted = config._a[YEAR] == null || config._a[MONTH] == null || config._a[DATE] == null;
        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for(i = 0; i < 3 && config._a[i] == null; ++i)config._a[i] = input[i] = currentDate[i];
        // Zero out whatever was not defaulted, including time
        for(; i < 7; i++)config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
        // Check for 24:00:00.000
        if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }
        config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
        expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();
        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        if (config._nextDay) config._a[HOUR] = 24;
        // check for mismatching day of week
        if (config._w && typeof config._w.d !== 'undefined' && !dateIsDefaulted && config._w.d !== expectedWeekday) getParsingFlags(config).weekdayMismatch = true;
    }
    function dayOfYearFromWeekInfo(config, currentDate) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;
            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(w.GG, config._a[YEAR], weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], 1, 4).year);
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) weekdayOverflow = true;
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;
            curWeek = weekOfYearFromDate(currentDate[YEAR], currentDate[MONTH], currentDate[DATE], dow, doy);
            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);
            // Default to current week.
            week = defaults(w.w, curWeek.week);
            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) weekdayOverflow = true;
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) weekdayOverflow = true;
            } else // default to beginning of week
            weekday = dow;
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) getParsingFlags(config)._overflowWeeks = true;
        else if (weekdayOverflow != null) getParsingFlags(config)._overflowWeekday = true;
        else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }
    // constant that refers to the ISO standard
    hooks.ISO_8601 = function() {};
    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function() {};
    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;
        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i, i, parsedInput, tokens, token, skipped, stringLength = string.length, totalParsedInputLength = 0, era, tokenLen;
        tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for(i = 0; i < tokenLen; i++){
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) getParsingFlags(config).unusedInput.push(skipped);
                string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) getParsingFlags(config).empty = false;
                else getParsingFlags(config).unusedTokens.push(token);
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) getParsingFlags(config).unusedTokens.push(token);
        }
        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
        if (string.length > 0) getParsingFlags(config).unusedInput.push(string);
        // clear _12h flag if hour is <= 12
        if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) getParsingFlags(config).bigHour = undefined;
        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);
        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        configFromArray(config);
        checkOverflow(config);
    }
    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;
        if (meridiem == null) // nothing to do
        return hour;
        if (locale.meridiemHour != null) return locale.meridiemHour(hour, meridiem);
        else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) hour += 12;
            if (!isPm && hour === 12) hour = 0;
            return hour;
        } else // this is not supposed to happen
        return hour;
    }
    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig, bestMoment, scoreToBeat, i, currentScore, validFormatFound, bestFormatIsValid = false, defaultDatePartsNow = {}, configfLen = config._f.length;
        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }
        for(i = 0; i < configfLen; i++){
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) tempConfig._useUTC = config._useUTC;
            tempConfig._defaultDatePartsNow = defaultDatePartsNow;
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);
            if (isValid$2(tempConfig)) validFormatFound = true;
            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;
            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
            getParsingFlags(tempConfig).score = currentScore;
            if (!bestFormatIsValid) {
                if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) bestFormatIsValid = true;
                }
            } else if (currentScore < scoreToBeat) {
                scoreToBeat = currentScore;
                bestMoment = tempConfig;
            }
        }
        extend(config, bestMoment || tempConfig);
    }
    function configFromObject(config) {
        if (config._d) return;
        var i = normalizeObjectUnits(config._i), dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map([
            i.year,
            i.month,
            dayOrDate,
            i.hour,
            i.minute,
            i.second,
            i.millisecond
        ], function(obj) {
            return obj && parseInt(obj, 10);
        });
        configFromArray(config);
    }
    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }
        return res;
    }
    function prepareConfig(config) {
        var input = config._i, format = config._f;
        config._locale = config._locale || getLocale(config._l);
        if (input === null || format === undefined && input === '') return createInvalid$1({
            nullInput: true
        });
        if (typeof input === 'string') config._i = input = config._locale.preparse(input);
        if (isMoment(input)) return new Moment(checkOverflow(input));
        else if (isDate(input)) config._d = input;
        else if (isArray(format)) configFromStringAndArray(config);
        else if (format) configFromStringAndFormat(config);
        else configFromInput(config);
        if (!isValid$2(config)) config._d = null;
        return config;
    }
    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) config._d = new Date(hooks.now());
        else if (isDate(input)) config._d = new Date(input.valueOf());
        else if (typeof input === 'string') configFromString(config);
        else if (isArray(input)) {
            config._a = map(input.slice(0), function(obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) configFromObject(config);
        else if (isNumber(input)) // from milliseconds
        config._d = new Date(input);
        else hooks.createFromInputFallback(config);
    }
    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};
        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }
        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }
        if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) input = undefined;
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;
        return createFromConfig(c);
    }
    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }
    var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other < this ? this : other;
        else return createInvalid$1();
    }), prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function() {
        var other = createLocal.apply(null, arguments);
        if (this.isValid() && other.isValid()) return other > this ? this : other;
        else return createInvalid$1();
    });
    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) moments = moments[0];
        if (!moments.length) return createLocal();
        for(i = 0; i < moments.length; ++i)if (isMoment(moments[i])) {
            res = moments[i];
            break;
        }
        if (!res) return createInvalid$1();
        for(++i; i < moments.length; ++i)if (isMoment(moments[i]) && (!moments[i].isValid() || moments[i][fn](res))) res = moments[i];
        return res;
    }
    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isBefore', args);
    }
    function max() {
        var args = [].slice.call(arguments, 0);
        return pickBy('isAfter', args);
    }
    var now = function() {
        return Date.now ? Date.now() : +new Date();
    };
    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond'
    ];
    function isDurationValid(m) {
        var key, unitHasDecimal = false, i, orderLen = ordering.length;
        for(key in m){
            if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) return false;
        }
        for(i = 0; i < orderLen; ++i)if (m[ordering[i]]) {
            if (unitHasDecimal) return false; // only allow non-integers for smallest unit
            if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) unitHasDecimal = true;
        }
        return true;
    }
    function isValid$1() {
        return this._isValid;
    }
    function createInvalid() {
        return createDuration(NaN);
    }
    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration), years = normalizedInput.year || 0, quarters = normalizedInput.quarter || 0, months = normalizedInput.month || 0, weeks = normalizedInput.week || normalizedInput.isoWeek || 0, days = normalizedInput.day || 0, hours = normalizedInput.hour || 0, minutes = normalizedInput.minute || 0, seconds = normalizedInput.second || 0, milliseconds = normalizedInput.millisecond || 0;
        this._isValid = isDurationValid(normalizedInput);
        // representation for dateAddRemove
        this._milliseconds = +milliseconds + seconds * 1e3 + // 1000
        minutes * 6e4 + // 1000 * 60
        hours * 3600000; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;
        this._data = {};
        this._locale = getLocale();
        this._bubble();
    }
    function isDuration(obj) {
        return obj instanceof Duration;
    }
    function absRound(number) {
        if (number < 0) return Math.round(-1 * number) * -1;
        else return Math.round(number);
    }
    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length), lengthDiff = Math.abs(array1.length - array2.length), diffs = 0, i;
        for(i = 0; i < len; i++)if (toInt(array1[i]) !== toInt(array2[i])) diffs++;
        return diffs + lengthDiff;
    }
    // FORMATTING
    function offset(token, separator) {
        addFormatToken(token, 0, 0, function() {
            var offset = this.utcOffset(), sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
        });
    }
    offset('Z', ':');
    offset('ZZ', '');
    // PARSING
    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken([
        'Z',
        'ZZ'
    ], function(input, array, config) {
        var offset = offsetFromString(matchShortOffset, input);
        config._useUTC = true;
        config._tzm = offset;
        if (offset === null) getParsingFlags(config).invalidOffset = input;
    });
    // HELPERS
    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;
    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher), chunk, parts, minutes;
        if (matches === null) return null;
        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || [
            '-',
            0,
            0
        ];
        minutes = +(parts[1] * 60) + toInt(parts[2]);
        if (toInt(parts[2]) > 59 || (parts[0] === '+' ? minutes > 840 : minutes > 720)) return null;
        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }
    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else return createLocal(input).local();
    }
    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }
    // HOOKS
    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function() {};
    // MOMENTS
    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0, localAdjust;
        if (!this.isValid()) return input != null ? this : NaN;
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) return this;
            } else if (Math.abs(input) < 16 && !keepMinutes) input = input * 60;
            if (!this._isUTC && keepLocalTime) localAdjust = getDateOffset(this);
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) this.add(localAdjust, 'm');
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) addSubtract$1(this, createDuration(input - offset, 'm'), 1, false);
                else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else return this._isUTC ? offset : getDateOffset(this);
    }
    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') input = -input;
            this.utcOffset(input, keepLocalTime);
            return this;
        } else return -this.utcOffset();
    }
    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }
    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;
            if (keepLocalTime) this.subtract(getDateOffset(this), 'm');
        }
        return this;
    }
    function setOffsetToParsedOffset() {
        if (this._tzm != null) this.utcOffset(this._tzm, false, true);
        else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) this.utcOffset(tZone);
            else this.utcOffset(0, true);
        }
        return this;
    }
    function hasAlignedHourOffset(input) {
        if (!this.isValid()) return false;
        input = input ? createLocal(input).utcOffset() : 0;
        return (this.utcOffset() - input) % 60 === 0;
    }
    function isDaylightSavingTime() {
        return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
    }
    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) return this._isDSTShifted;
        var c = {}, other;
        copyConfig(c, this);
        c = prepareConfig(c);
        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else this._isDSTShifted = false;
        return this._isDSTShifted;
    }
    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }
    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }
    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }
    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/, // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
    function createDuration(input, key) {
        var duration = input, // matching against regexp is expensive, do it on demand
        match = null, sign, ret, diffRes;
        if (isDuration(input)) duration = {
            ms: input._milliseconds,
            d: input._days,
            M: input._months
        };
        else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) duration[key] = +input;
            else duration.milliseconds = +input;
        } else if (match = aspNetRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign
            };
        } else if (match = isoRegex.exec(input)) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign)
            };
        } else if (duration == null) // checks for null or undefined
        duration = {};
        else if (typeof duration === 'object' && ('from' in duration || 'to' in duration)) {
            diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }
        ret = new Duration(duration);
        if (isDuration(input) && hasOwnProp(input, '_locale')) ret._locale = input._locale;
        if (isDuration(input) && hasOwnProp(input, '_isValid')) ret._isValid = input._isValid;
        return ret;
    }
    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid;
    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }
    function positiveMomentsDifference(base, other) {
        var res = {};
        res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) --res.months;
        res.milliseconds = +other - +base.clone().add(res.months, 'M');
        return res;
    }
    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) return {
            milliseconds: 0,
            months: 0
        };
        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) res = positiveMomentsDifference(base, other);
        else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }
        return res;
    }
    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function(val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
                tmp = val;
                val = period;
                period = tmp;
            }
            dur = createDuration(val, period);
            addSubtract$1(this, dur, direction);
            return this;
        };
    }
    function addSubtract$1(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds, days = absRound(duration._days), months = absRound(duration._months);
        if (!mom.isValid()) // No op
        return;
        updateOffset = updateOffset == null ? true : updateOffset;
        if (months) setMonth(mom, get$2(mom, 'Month') + months * isAdding);
        if (days) set$1(mom, 'Date', get$2(mom, 'Date') + days * isAdding);
        if (milliseconds) mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        if (updateOffset) hooks.updateOffset(mom, days || months);
    }
    var add$1 = createAdder(1, 'add'), subtract$1 = createAdder(-1, 'subtract');
    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }
    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
    }
    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'years',
            'year',
            'y',
            'months',
            'month',
            'M',
            'days',
            'day',
            'd',
            'dates',
            'date',
            'D',
            'hours',
            'hour',
            'h',
            'minutes',
            'minute',
            'm',
            'seconds',
            'second',
            's',
            'milliseconds',
            'millisecond',
            'ms'
        ], i, property, propertyLen = properties.length;
        for(i = 0; i < propertyLen; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input), dataTypeTest = false;
        if (arrayTest) dataTypeTest = input.filter(function(item) {
            return !isNumber(item) && isString(input);
        }).length === 0;
        return arrayTest && dataTypeTest;
    }
    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input), propertyTest = false, properties = [
            'sameDay',
            'nextDay',
            'lastDay',
            'nextWeek',
            'lastWeek',
            'sameElse'
        ], i, property;
        for(i = 0; i < properties.length; i += 1){
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }
        return objectTest && propertyTest;
    }
    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
    }
    function calendar(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(), sod = cloneWithOffset(now, this).startOf('day'), format = hooks.calendarFormat(this, sod) || 'sameElse', output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
        return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
    }
    function clone$1() {
        return new Moment(this);
    }
    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() > localInput.valueOf();
        else return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() < localInput.valueOf();
        else return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from), localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) return false;
        inclusivity = inclusivity || '()';
        return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
    }
    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input), inputMs;
        if (!(this.isValid() && localInput.isValid())) return false;
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') return this.valueOf() === localInput.valueOf();
        else {
            inputMs = localInput.valueOf();
            return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
        }
    }
    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }
    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }
    function diff(input, units, asFloat) {
        var that, zoneDelta, output;
        if (!this.isValid()) return NaN;
        that = cloneWithOffset(input, this);
        if (!that.isValid()) return NaN;
        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
        units = normalizeUnits(units);
        switch(units){
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }
        return asFloat ? output : absFloor(output);
    }
    function monthDiff(a, b) {
        if (a.date() < b.date()) // end-of-month calculations work correct when the start month has more
        // days than the end month.
        return -monthDiff(b, a);
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()), // b is in (anchor - 1 month, anchor + 1 month)
        anchor = a.clone().add(wholeMonthDiff, 'months'), anchor2, adjust;
        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }
        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }
    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }
    function toISOString$1(keepOffset) {
        if (!this.isValid()) return null;
        var utc = keepOffset !== true, m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) return this.toDate().toISOString();
            else return new Date(this.valueOf() + this.utcOffset() * 60000).toISOString().replace('Z', formatMoment(m, 'Z'));
        }
        return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */ function inspect() {
        if (!this.isValid()) return 'moment.invalid(/* ' + this._i + ' */)';
        var func = 'moment', zone = '', prefix, year, datetime, suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';
        return this.format(prefix + year + datetime + suffix);
    }
    function format(inputString) {
        if (!inputString) inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }
    function from(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            to: this,
            from: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }
    function to(time, withoutSuffix) {
        if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) return createDuration({
            from: this,
            to: time
        }).locale(this.locale()).humanize(!withoutSuffix);
        else return this.localeData().invalidDate();
    }
    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }
    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;
        if (key === undefined) return this._locale._abbr;
        else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) this._locale = newLocaleData;
            return this;
        }
    }
    var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function(key) {
        if (key === undefined) return this.localeData();
        else return this.locale(key);
    });
    function localeData() {
        return this._locale;
    }
    var MS_PER_SECOND = 1000, MS_PER_MINUTE = 60 * MS_PER_SECOND, MS_PER_HOUR = 60 * MS_PER_MINUTE, MS_PER_400_YEARS = 3506328 * MS_PER_HOUR;
    // actual modulo - handles negative numbers (for dates before 1970):
    function mod(dividend, divisor) {
        return (dividend % divisor + divisor) % divisor;
    }
    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        else return new Date(y, m, d).valueOf();
    }
    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) // preserve leap years using a full 400 year cycle, then reset
        return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        else return Date.UTC(y, m, d);
    }
    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod(time, MS_PER_SECOND);
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) return this;
        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
        switch(units){
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
                break;
            case 'isoWeek':
                time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time += MS_PER_HOUR - mod(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod(time, MS_PER_SECOND) - 1;
                break;
        }
        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }
    function valueOf$1() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }
    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }
    function toDate() {
        return new Date(this.valueOf());
    }
    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond()
        ];
    }
    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds()
        };
    }
    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }
    function isValid() {
        return isValid$2(this);
    }
    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }
    function invalidAt() {
        return getParsingFlags(this).overflow;
    }
    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict
        };
    }
    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');
    addFormatToken('y', [
        'y',
        1
    ], 'yo', 'eraYear');
    addFormatToken('y', [
        'yy',
        2
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyy',
        3
    ], 0, 'eraYear');
    addFormatToken('y', [
        'yyyy',
        4
    ], 0, 'eraYear');
    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);
    addParseToken([
        'N',
        'NN',
        'NNN',
        'NNNN',
        'NNNNN'
    ], function(input, array, config, token) {
        var era = config._locale.erasParse(input, token, config._strict);
        if (era) getParsingFlags(config).era = era;
        else getParsingFlags(config).invalidEra = input;
    });
    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);
    addParseToken([
        'y',
        'yy',
        'yyy',
        'yyyy'
    ], YEAR);
    addParseToken([
        'yo'
    ], function(input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) match = input.match(config._locale._eraYearOrdinalRegex);
        if (config._locale.eraYearOrdinalParse) array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        else array[YEAR] = parseInt(input, 10);
    });
    function localeEras(m, format) {
        var i, l, date, eras = this._eras || getLocale('en')._eras;
        for(i = 0, l = eras.length; i < l; ++i){
            switch(typeof eras[i].since){
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }
            switch(typeof eras[i].until){
                case 'undefined':
                    eras[i].until = Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }
    function localeErasParse(eraName, format, strict) {
        var i, l, eras = this.eras(), name, abbr, narrow;
        eraName = eraName.toUpperCase();
        for(i = 0, l = eras.length; i < l; ++i){
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();
            if (strict) switch(format){
                case 'N':
                case 'NN':
                case 'NNN':
                    if (abbr === eraName) return eras[i];
                    break;
                case 'NNNN':
                    if (name === eraName) return eras[i];
                    break;
                case 'NNNNN':
                    if (narrow === eraName) return eras[i];
                    break;
            }
            else if ([
                name,
                abbr,
                narrow
            ].indexOf(eraName) >= 0) return eras[i];
        }
    }
    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? 1 : -1;
        if (year === undefined) return hooks(era.since).year();
        else return hooks(era.since).year() + (year - era.offset) * dir;
    }
    function getEraName() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].name;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].name;
        }
        return '';
    }
    function getEraNarrow() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].narrow;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].narrow;
        }
        return '';
    }
    function getEraAbbr() {
        var i, l, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until) return eras[i].abbr;
            if (eras[i].until <= val && val <= eras[i].since) return eras[i].abbr;
        }
        return '';
    }
    function getEraYear() {
        var i, l, dir, val, eras = this.localeData().eras();
        for(i = 0, l = eras.length; i < l; ++i){
            dir = eras[i].since <= eras[i].until ? 1 : -1;
            // truncate time
            val = this.clone().startOf('day').valueOf();
            if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
        }
        return this.year();
    }
    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }
    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) computeErasParse.call(this);
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }
    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) computeErasParse.call(this);
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }
    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }
    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }
    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }
    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }
    function computeErasParse() {
        var abbrPieces = [], namePieces = [], narrowPieces = [], mixedPieces = [], i, l, erasName, erasAbbr, erasNarrow, eras = this.eras();
        for(i = 0, l = eras.length; i < l; ++i){
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);
            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }
        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
    }
    // FORMATTING
    addFormatToken(0, [
        'gg',
        2
    ], 0, function() {
        return this.weekYear() % 100;
    });
    addFormatToken(0, [
        'GG',
        2
    ], 0, function() {
        return this.isoWeekYear() % 100;
    });
    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [
            token,
            token.length
        ], 0, getter);
    }
    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');
    // ALIASES
    // PARSING
    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);
    addWeekParseToken([
        'gggg',
        'ggggg',
        'GGGG',
        'GGGGG'
    ], function(input, week, config, token) {
        week[token.substr(0, 2)] = toInt(input);
    });
    addWeekParseToken([
        'gg',
        'GG'
    ], function(input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });
    // MOMENTS
    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
    }
    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
    }
    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }
    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }
    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }
    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }
    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) return weekOfYear(this, dow, doy).year;
        else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) week = weeksTarget;
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }
    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy), date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }
    // FORMATTING
    addFormatToken('Q', 0, 'Qo', 'quarter');
    // PARSING
    addRegexToken('Q', match1);
    addParseToken('Q', function(input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });
    // MOMENTS
    function getSetQuarter(input) {
        return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
    }
    // FORMATTING
    addFormatToken('D', [
        'DD',
        2
    ], 'Do', 'date');
    // PARSING
    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function(isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
    });
    addParseToken([
        'D',
        'DD'
    ], DATE);
    addParseToken('Do', function(input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });
    // MOMENTS
    var getSetDayOfMonth = makeGetSet('Date', true);
    // FORMATTING
    addFormatToken('DDD', [
        'DDDD',
        3
    ], 'DDDo', 'dayOfYear');
    // PARSING
    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken([
        'DDD',
        'DDDD'
    ], function(input, array, config) {
        config._dayOfYear = toInt(input);
    });
    // HELPERS
    // MOMENTS
    function getSetDayOfYear(input) {
        var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }
    // FORMATTING
    addFormatToken('m', [
        'mm',
        2
    ], 0, 'minute');
    // PARSING
    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken([
        'm',
        'mm'
    ], MINUTE);
    // MOMENTS
    var getSetMinute = makeGetSet('Minutes', false);
    // FORMATTING
    addFormatToken('s', [
        'ss',
        2
    ], 0, 'second');
    // PARSING
    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken([
        's',
        'ss'
    ], SECOND);
    // MOMENTS
    var getSetSecond = makeGetSet('Seconds', false);
    // FORMATTING
    addFormatToken('S', 0, 0, function() {
        return ~~(this.millisecond() / 100);
    });
    addFormatToken(0, [
        'SS',
        2
    ], 0, function() {
        return ~~(this.millisecond() / 10);
    });
    addFormatToken(0, [
        'SSS',
        3
    ], 0, 'millisecond');
    addFormatToken(0, [
        'SSSS',
        4
    ], 0, function() {
        return this.millisecond() * 10;
    });
    addFormatToken(0, [
        'SSSSS',
        5
    ], 0, function() {
        return this.millisecond() * 100;
    });
    addFormatToken(0, [
        'SSSSSS',
        6
    ], 0, function() {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, [
        'SSSSSSS',
        7
    ], 0, function() {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, [
        'SSSSSSSS',
        8
    ], 0, function() {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, [
        'SSSSSSSSS',
        9
    ], 0, function() {
        return this.millisecond() * 1000000;
    });
    // PARSING
    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);
    var token, getSetMillisecond;
    for(token = 'SSSS'; token.length <= 9; token += 'S')addRegexToken(token, matchUnsigned);
    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }
    for(token = 'S'; token.length <= 9; token += 'S')addParseToken(token, parseMs);
    getSetMillisecond = makeGetSet('Milliseconds', false);
    // FORMATTING
    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');
    // MOMENTS
    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }
    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }
    var proto$2 = Moment.prototype;
    proto$2.add = add$1;
    proto$2.calendar = calendar;
    proto$2.clone = clone$1;
    proto$2.diff = diff;
    proto$2.endOf = endOf;
    proto$2.format = format;
    proto$2.from = from;
    proto$2.fromNow = fromNow;
    proto$2.to = to;
    proto$2.toNow = toNow;
    proto$2.get = stringGet;
    proto$2.invalidAt = invalidAt;
    proto$2.isAfter = isAfter;
    proto$2.isBefore = isBefore;
    proto$2.isBetween = isBetween;
    proto$2.isSame = isSame;
    proto$2.isSameOrAfter = isSameOrAfter;
    proto$2.isSameOrBefore = isSameOrBefore;
    proto$2.isValid = isValid;
    proto$2.lang = lang;
    proto$2.locale = locale;
    proto$2.localeData = localeData;
    proto$2.max = prototypeMax;
    proto$2.min = prototypeMin;
    proto$2.parsingFlags = parsingFlags;
    proto$2.set = stringSet;
    proto$2.startOf = startOf;
    proto$2.subtract = subtract$1;
    proto$2.toArray = toArray;
    proto$2.toObject = toObject;
    proto$2.toDate = toDate;
    proto$2.toISOString = toISOString$1;
    proto$2.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) proto$2[Symbol.for('nodejs.util.inspect.custom')] = function() {
        return 'Moment<' + this.format() + '>';
    };
    proto$2.toJSON = toJSON;
    proto$2.toString = toString;
    proto$2.unix = unix;
    proto$2.valueOf = valueOf$1;
    proto$2.creationData = creationData;
    proto$2.eraName = getEraName;
    proto$2.eraNarrow = getEraNarrow;
    proto$2.eraAbbr = getEraAbbr;
    proto$2.eraYear = getEraYear;
    proto$2.year = getSetYear;
    proto$2.isLeapYear = getIsLeapYear;
    proto$2.weekYear = getSetWeekYear;
    proto$2.isoWeekYear = getSetISOWeekYear;
    proto$2.quarter = proto$2.quarters = getSetQuarter;
    proto$2.month = getSetMonth;
    proto$2.daysInMonth = getDaysInMonth;
    proto$2.week = proto$2.weeks = getSetWeek;
    proto$2.isoWeek = proto$2.isoWeeks = getSetISOWeek;
    proto$2.weeksInYear = getWeeksInYear;
    proto$2.weeksInWeekYear = getWeeksInWeekYear;
    proto$2.isoWeeksInYear = getISOWeeksInYear;
    proto$2.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto$2.date = getSetDayOfMonth;
    proto$2.day = proto$2.days = getSetDayOfWeek;
    proto$2.weekday = getSetLocaleDayOfWeek;
    proto$2.isoWeekday = getSetISODayOfWeek;
    proto$2.dayOfYear = getSetDayOfYear;
    proto$2.hour = proto$2.hours = getSetHour;
    proto$2.minute = proto$2.minutes = getSetMinute;
    proto$2.second = proto$2.seconds = getSetSecond;
    proto$2.millisecond = proto$2.milliseconds = getSetMillisecond;
    proto$2.utcOffset = getSetOffset;
    proto$2.utc = setOffsetToUTC;
    proto$2.local = setOffsetToLocal;
    proto$2.parseZone = setOffsetToParsedOffset;
    proto$2.hasAlignedHourOffset = hasAlignedHourOffset;
    proto$2.isDST = isDaylightSavingTime;
    proto$2.isLocal = isLocal;
    proto$2.isUtcOffset = isUtcOffset;
    proto$2.isUtc = isUtc;
    proto$2.isUTC = isUtc;
    proto$2.zoneAbbr = getZoneAbbr;
    proto$2.zoneName = getZoneName;
    proto$2.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
    proto$2.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
    proto$2.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
    proto$2.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
    proto$2.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
    function createUnix(input) {
        return createLocal(input * 1000);
    }
    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }
    function preParsePostFormat(string) {
        return string;
    }
    var proto$1 = Locale.prototype;
    proto$1.calendar = calendar$1;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime$1;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;
    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;
    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;
    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;
    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;
    function get$1(format, index, field, setter) {
        var locale = getLocale(), utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }
    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }
        format = format || '';
        if (index != null) return get$1(format, index, field, 'month');
        var i, out = [];
        for(i = 0; i < 12; i++)out[i] = get$1(format, i, field, 'month');
        return out;
    }
    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }
            format = format || '';
        }
        var locale = getLocale(), shift = localeSorted ? locale._week.dow : 0, i, out = [];
        if (index != null) return get$1(format, (index + shift) % 7, field, 'day');
        for(i = 0; i < 7; i++)out[i] = get$1(format, (i + shift) % 7, field, 'day');
        return out;
    }
    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }
    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }
    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }
    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }
    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }
    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD'
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC'
            }
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function(number) {
            var b = number % 10, output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
            return number + output;
        }
    });
    // Side effect imports
    hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
    hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
    var mathAbs = Math.abs;
    function abs$1() {
        var data = this._data;
        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);
        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);
        return this;
    }
    function addSubtract(duration, input, value, direction) {
        var other = createDuration(input, value);
        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;
        return duration._bubble();
    }
    // supports only 2.0-style add(1, 's') or add(duration)
    function add(input, value) {
        return addSubtract(this, input, value, 1);
    }
    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract(input, value) {
        return addSubtract(this, input, value, -1);
    }
    function absCeil(number) {
        if (number < 0) return Math.floor(number);
        else return Math.ceil(number);
    }
    function bubble() {
        var milliseconds = this._milliseconds, days = this._days, months = this._months, data = this._data, seconds, minutes, hours, years, monthsFromDays;
        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }
        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;
        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;
        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;
        hours = absFloor(minutes / 60);
        data.hours = hours % 24;
        days += absFloor(hours / 24);
        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        data.days = days;
        data.months = months;
        data.years = years;
        return this;
    }
    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return days * 4800 / 146097;
    }
    function monthsToDays(months) {
        // the reverse of daysToMonths
        return months * 146097 / 4800;
    }
    function as(units) {
        if (!this.isValid()) return NaN;
        var days, months, milliseconds = this._milliseconds;
        units = normalizeUnits(units);
        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch(units){
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch(units){
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }
    function makeAs(alias) {
        return function() {
            return this.as(alias);
        };
    }
    var asMilliseconds = makeAs('ms'), asSeconds = makeAs('s'), asMinutes = makeAs('m'), asHours = makeAs('h'), asDays = makeAs('d'), asWeeks = makeAs('w'), asMonths = makeAs('M'), asQuarters = makeAs('Q'), asYears = makeAs('y'), valueOf = asMilliseconds;
    function clone() {
        return createDuration(this);
    }
    function get(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }
    function makeGetter(name) {
        return function() {
            return this.isValid() ? this._data[name] : NaN;
        };
    }
    var milliseconds = makeGetter('milliseconds'), seconds = makeGetter('seconds'), minutes = makeGetter('minutes'), hours = makeGetter('hours'), days = makeGetter('days'), months = makeGetter('months'), years = makeGetter('years');
    function weeks() {
        return absFloor(this.days() / 7);
    }
    var round = Math.round, thresholds = {
        ss: 44,
        s: 45,
        m: 45,
        h: 22,
        d: 26,
        w: null,
        M: 11
    };
    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return relativeTimeWithoutPostformat.call(locale, number || 1, !!withoutSuffix, string, isFuture);
    }
    function relativeTime(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(), seconds = round(duration.as('s')), minutes = round(duration.as('m')), hours = round(duration.as('h')), days = round(duration.as('d')), months = round(duration.as('M')), weeks = round(duration.as('w')), years = round(duration.as('y')), a = seconds <= thresholds.ss && [
            's',
            seconds
        ] || seconds < thresholds.s && [
            'ss',
            seconds
        ] || minutes <= 1 && [
            'm'
        ] || minutes < thresholds.m && [
            'mm',
            minutes
        ] || hours <= 1 && [
            'h'
        ] || hours < thresholds.h && [
            'hh',
            hours
        ] || days <= 1 && [
            'd'
        ] || days < thresholds.d && [
            'dd',
            days
        ];
        if (thresholds.w != null) a = a || weeks <= 1 && [
            'w'
        ] || weeks < thresholds.w && [
            'ww',
            weeks
        ];
        a = a || months <= 1 && [
            'M'
        ] || months < thresholds.M && [
            'MM',
            months
        ] || years <= 1 && [
            'y'
        ] || [
            'yy',
            years
        ];
        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }
    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) return round;
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }
    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) return false;
        if (limit === undefined) return thresholds[threshold];
        thresholds[threshold] = limit;
        if (threshold === 's') thresholds.ss = limit - 1;
        return true;
    }
    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) return this.localeData().invalidDate();
        var withSuffix = false, th = thresholds, locale, output;
        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') withSuffix = argWithSuffix;
        if (typeof argThresholds === 'object') {
            th = extend(extend({}, thresholds), argThresholds || {});
            if (argThresholds.s != null && argThresholds.ss == null) th.ss = argThresholds.s - 1;
        }
        locale = this.localeData();
        output = relativeTime(this, !withSuffix, th, locale);
        if (withSuffix) output = pastFutureWithoutPostformat.call(locale, +this, output);
        return locale.postformat(output);
    }
    var abs = Math.abs;
    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }
    function toISOString() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) return this.localeData().invalidDate();
        var seconds = abs(this._milliseconds) / 1000, days = abs(this._days), months = abs(this._months), minutes, hours, years, s, total = this.asSeconds(), totalSign, ymSign, daysSign, hmsSign;
        if (!total) // this is the same as C#'s (Noda) and python (isodate)...
        // but not other JS (goog.date)
        return 'P0D';
        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;
        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;
        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
        return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
    }
    var proto = Duration.prototype;
    proto.isValid = isValid$1;
    proto.abs = abs$1;
    proto.add = add;
    proto.subtract = subtract;
    proto.as = as;
    proto.asMilliseconds = asMilliseconds;
    proto.asSeconds = asSeconds;
    proto.asMinutes = asMinutes;
    proto.asHours = asHours;
    proto.asDays = asDays;
    proto.asWeeks = asWeeks;
    proto.asMonths = asMonths;
    proto.asQuarters = asQuarters;
    proto.asYears = asYears;
    proto.valueOf = valueOf;
    proto._bubble = bubble;
    proto.clone = clone;
    proto.get = get;
    proto.milliseconds = milliseconds;
    proto.seconds = seconds;
    proto.minutes = minutes;
    proto.hours = hours;
    proto.days = days;
    proto.weeks = weeks;
    proto.months = months;
    proto.years = years;
    proto.humanize = humanize;
    proto.toISOString = toISOString;
    proto.toString = toISOString;
    proto.toJSON = toISOString;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString);
    proto.lang = lang;
    // FORMATTING
    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');
    // PARSING
    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function(input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function(input, array, config) {
        config._d = new Date(toInt(input));
    });
    //! moment.js
    hooks.version = '2.31.0';
    setHookCallback(createLocal);
    hooks.fn = proto$2;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid$1;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto$2;
    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
        DATE: 'YYYY-MM-DD',
        TIME: 'HH:mm',
        TIME_SECONDS: 'HH:mm:ss',
        TIME_MS: 'HH:mm:ss.SSS',
        WEEK: 'GGGG-[W]WW',
        MONTH: 'YYYY-MM'
    };
    return hooks;
});

});

var $d2795fd092250e43$exports = {};
'use strict';

$d2795fd092250e43$exports = (parcelRequire("iEsO5"));



parcelRequire("aZSru");
var $63bf094b1c1499a1$exports = {};
'use strict';
function $63bf094b1c1499a1$var$checkDCE() {
    /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */ if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function') return;
    try {
        // Verify that the code above has been dead code eliminated (DCE'd).
        __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE($63bf094b1c1499a1$var$checkDCE);
    } catch (err) {
        // DevTools shouldn't crash React, no matter what.
        // We should still report in case we break this code.
        console.error(err);
    }
}
// DCE check should happen before ReactDOM bundle executes so that
// DevTools can report bad minification during injection.
$63bf094b1c1499a1$var$checkDCE();

$63bf094b1c1499a1$exports = (parcelRequire("7TJov"));



var $aZSru = parcelRequire("aZSru");
function $ff1fe7435e7c9214$export$46c1952d522542d7(error) {
    let message = error.toString();
    if (typeof error === "string") message = error;
    else if (error.message) message = error.message;
    return message;
}
const $ff1fe7435e7c9214$export$cefb40c9962541b5 = (count, singular, plural)=>count === 1 ? singular : plural;
function $ff1fe7435e7c9214$export$906815c308550252(val) {
    return val ? val : undefined;
}
function $ff1fe7435e7c9214$export$dbf350e5966cf602(...classes) {
    return classes.filter((c)=>!!c).join(" ");
}
function $ff1fe7435e7c9214$export$569b44dc40350ca0(e, navigate) {
    const path = e.target.getAttribute("href");
    // only respond to unmodified left button clicks
    if (!path || e.button !== 0 || e.ctrlKey || e.metaKey) return;
    e.preventDefault();
    navigate(path);
}
const $ff1fe7435e7c9214$var$componentCounts = {};
function $ff1fe7435e7c9214$export$bb389a67188b58a7(componentName) {
    const [i] = (0, $aZSru.useState)(()=>{
        if ($ff1fe7435e7c9214$var$componentCounts[componentName] === undefined) return $ff1fe7435e7c9214$var$componentCounts[componentName] = 1;
        else return ++$ff1fe7435e7c9214$var$componentCounts[componentName];
    });
    const instanceName = `${componentName}(${i})`;
    const renderCount = (0, $aZSru.useRef)(0);
    renderCount.current++;
    // useEffect(() => (() => console.log(`Removing ${instanceName}`)), []);
    // console.log(`Rendering ${instanceName} (${renderCount.current})`);
    return instanceName;
}
function $ff1fe7435e7c9214$export$1391212d75b2ee65(ms) {
    return new Promise((resolve)=>setTimeout(()=>resolve(), ms));
}
function $ff1fe7435e7c9214$export$d22a027dada4117a(a) {
    return function() {
        let t = a += 0x6d2b79f5;
        t = Math.imul(t ^ t >>> 15, t | 1);
        t ^= t + Math.imul(t ^ t >>> 7, t | 61);
        return ((t ^ t >>> 14) >>> 0) / 4294967296;
    };
}
function $ff1fe7435e7c9214$export$cd82543cd4c649f1(func, limit, resetTime) {
    let lastCall = 0;
    let lastReset = 0;
    let count = 0;
    return function(...args) {
        const now = Date.now();
        if (now - lastReset > resetTime) {
            count = 0;
            lastReset = now;
        }
        if (count >= limit) throw new Error("Rate limit exceeded");
        if (now - lastCall > resetTime) count = 0;
        lastCall = now;
        count++;
        return func.apply(this, args);
    };
}


class $aedc866c4cacb991$var$ObservableBase {
    notify(val) {
        if (this._notifying) throw new Error("Observable does not support recursive updates.");
        this._notifying = true;
        this._listeners.forEach((l)=>l(val));
        this._notifying = false;
        this._toUnsubscribe.forEach((l)=>this.unsubscribe(l));
        this._toUnsubscribe.splice(0);
    }
    subscribe(listener) {
        this._listeners.push(listener);
        return ()=>{
            this.unsubscribe(listener);
        };
    }
    unsubscribe(listener) {
        if (!this._notifying) {
            const index = this._listeners.indexOf(listener);
            if (index >= 0) this._listeners.splice(index, 1);
        } else this._toUnsubscribe.push(listener);
    }
    constructor(){
        this._listeners = [];
        this._notifying = false;
        this._toUnsubscribe = [];
    }
}
class $aedc866c4cacb991$export$77cea355fa80b5f4 extends $aedc866c4cacb991$var$ObservableBase {
    getValue() {
        return this._value;
    }
    setValue(val) {
        if (this._value !== val) {
            this._value = val;
            this.notify(val);
        }
    }
    constructor(initialValue){
        super();
        this._value = initialValue;
    }
}
class $aedc866c4cacb991$export$2b76b04f92326cd extends $aedc866c4cacb991$var$ObservableBase {
    getValue() {
        return this._value;
    }
    setValue(val) {
        this._value = [
            ...val
        ];
        this.notify(this._value);
    }
    push(...val) {
        this._value = [
            ...this._value,
            ...val
        ];
        this.notify(this._value);
    }
    clear() {
        this._value = [];
        this.notify(this._value);
    }
    constructor(initialValue){
        super();
        this._value = initialValue;
    }
}
class $aedc866c4cacb991$export$92e276f6c7932911 extends $aedc866c4cacb991$export$2b76b04f92326cd {
    constructor(...args){
        super(...args), this.loading = true;
    }
}
class $aedc866c4cacb991$export$46dc39d249bc63d6 extends $aedc866c4cacb991$var$ObservableBase {
    getValue() {
        return this._value;
    }
    setValue(val) {
        const setTime = Date.now();
        const delayMs = this._getDelay(val);
        (0, $ff1fe7435e7c9214$export$1391212d75b2ee65)(delayMs).then(()=>{
            if (setTime > this._lastSetTime) {
                this._lastSetTime = Date.now();
                if (this._value !== val) {
                    this._value = val;
                    this.notify(val);
                }
            }
        });
    }
    constructor(initialValue, getDelay){
        super();
        this._value = initialValue;
        this._lastSetTime = 0;
        this._getDelay = getDelay;
    }
}



async function $09f8b9d3461587fb$export$f261951912e85b8d(url) {
    try {
        const response = await fetch(url);
        if (response.ok) return await response.json();
        throw Error(response.statusText);
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        throw Error(ex.message || ex);
    }
}
async function $09f8b9d3461587fb$export$63551ada7ce593c9(url, value) {
    return $09f8b9d3461587fb$export$bf66ab79f00a8669("PATCH", url, value);
}
async function $09f8b9d3461587fb$export$f670e789619da3b3(url, value) {
    return $09f8b9d3461587fb$export$bf66ab79f00a8669("POST", url, value);
}
async function $09f8b9d3461587fb$export$6c249544e9d17d95(url, value) {
    return $09f8b9d3461587fb$export$bf66ab79f00a8669("DELETE", url, value);
}
async function $09f8b9d3461587fb$export$bf66ab79f00a8669(method, url, value) {
    try {
        const response = await fetch(url, {
            method: method,
            headers: {
                "Content-Type": "application/json"
            },
            body: value === undefined ? undefined : JSON.stringify(value)
        });
        if (response.ok) {
            if (response.status !== 204) return response.json();
            else return undefined;
        } else if (response.headers.get("Content-Type")?.startsWith("application/json")) {
            const json = await response.json();
            if (Array.isArray(json) && json.length > 0 && typeof json[0] === "string") return json;
        }
        return [
            `${response.status}: ${response.statusText}`
        ];
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        return [
            (0, $ff1fe7435e7c9214$export$46c1952d522542d7)(ex)
        ];
    }
}
class $09f8b9d3461587fb$export$d7df101172495fc extends (0, $aedc866c4cacb991$export$2b76b04f92326cd) {
    constructor(){
        super([]);
    }
}



class $aa1ba0dc266f72fa$export$94affb487e701bf2 {
    get(id, getter) {
        let o = this._cache[id];
        if (!o) {
            o = new (0, $aedc866c4cacb991$export$77cea355fa80b5f4)(undefined);
            this._cache[id] = o;
        }
        const observable = o;
        if (observable.getValue() === undefined && !this._getting[id]) {
            this._getting[id] = true;
            getter().then((v)=>{
                delete this._getting[id];
                observable.setValue(v);
            });
        }
        return observable;
    }
    /**
     * Returns the Observable for id if it exists, but does not fetch the item if it does not.
     */ getOptional(id) {
        return this._cache[id];
    }
    set(id, val) {
        const o = this._cache[id];
        if (o) {
            o.setValue(val);
            return o;
        } else return this._cache[id] = new (0, $aedc866c4cacb991$export$77cea355fa80b5f4)(val);
    }
    constructor(){
        this._cache = {};
        this._getting = {};
    }
} // export class CachedValue<T> {
 //     private _cache = new Cache<T>();
 //     public get(getter: Getter<T>): Observable<T | undefined> {
 //         return this._cache.get(0, getter);
 //     }
 //     public getOptional(): Observable<T | undefined> | undefined {
 //         return this._cache.getOptional(0);
 //     }
 //     public set(val: T): void {
 //         this._cache.set(0, val);
 //     }
 // }



let $81ca197868c8b74e$var$contextPromise;
function $81ca197868c8b74e$export$31553aaa555c1514() {
    if (!$81ca197868c8b74e$var$contextPromise) $81ca197868c8b74e$var$contextPromise = fetch("/api/user/context").then((res)=>{
        $81ca197868c8b74e$var$contextPromise = undefined;
        if (!res.ok) {
            if (res.status === 401) return null;
            throw Error(`Could not fetch context: ${res.status}: ${res.statusText}`);
        }
        return res.json();
    });
    return $81ca197868c8b74e$var$contextPromise;
}
async function $81ca197868c8b74e$export$a0973bcfe11b05c9() {
    const res = await fetch("/logout", {
        method: "POST"
    });
    return res.ok;
}
const $81ca197868c8b74e$var$userCache = new (0, $aa1ba0dc266f72fa$export$94affb487e701bf2)();
let $81ca197868c8b74e$var$getUserQueue = [];
let $81ca197868c8b74e$var$getUsersPromise;
function $81ca197868c8b74e$export$7cbf767827cd68ba(username, errorCollection) {
    return $81ca197868c8b74e$var$userCache.get(username, ()=>{
        const existing = $81ca197868c8b74e$var$getUserQueue.find((x)=>x.username === username);
        if (!existing) {
            let o;
            const p = new Promise((resolve, reject)=>{
                o = {
                    username: username,
                    resolve: resolve,
                    reject: reject
                };
            });
            o.promise = p;
            $81ca197868c8b74e$var$getUserQueue.push(o);
            if (!$81ca197868c8b74e$var$getUsersPromise) $81ca197868c8b74e$var$getUsersPromise = Promise.resolve().then($81ca197868c8b74e$var$getUsers);
            return o.promise;
        }
        return existing.promise;
    });
}
async function $81ca197868c8b74e$var$getUsers() {
    const currentQueue = $81ca197868c8b74e$var$getUserQueue;
    $81ca197868c8b74e$var$getUserQueue = [];
    $81ca197868c8b74e$var$getUsersPromise = undefined;
    const usernames = currentQueue.map((x)=>x.username);
    const result = await (0, $09f8b9d3461587fb$export$f261951912e85b8d)(`/api/user?ids=${usernames.join(",")}`);
    if (result.length !== usernames.length) {
        // eslint-disable-next-line no-console
        console.error(`Expected result with length ${usernames.length} from getUsers, got ${result.length} instead!`);
        return;
    }
    for(let i = 0; i < currentQueue.length; i++)if (result[i].username !== currentQueue[i].username) // eslint-disable-next-line no-console
    console.error(`Expected username ${currentQueue[i].username}, got ${result[i].username} instead!`);
    else currentQueue[i].resolve(result[i]);
}
// sorted array of InvitedUsers
const $81ca197868c8b74e$var$allUsers = new (0, $aedc866c4cacb991$export$92e276f6c7932911)([]);
function $81ca197868c8b74e$export$69093b9c569a5b5b() {
    $81ca197868c8b74e$var$allUsers.loading = true;
    $81ca197868c8b74e$var$fetchAllUsers();
    return $81ca197868c8b74e$var$allUsers;
}
async function $81ca197868c8b74e$var$fetchAllUsers() {
    // get users from server
    const users = await (0, $09f8b9d3461587fb$export$f261951912e85b8d)("/api/user/all");
    users.sort((a, b)=>a.username.localeCompare(b.username));
    const observables = users.map((u)=>$81ca197868c8b74e$var$userCache.set(u.username, u));
    $81ca197868c8b74e$var$allUsers.setValue(observables);
    $81ca197868c8b74e$var$allUsers.loading = false;
}
async function $81ca197868c8b74e$export$587d19d2809405b1(user, errorCollection) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)("/api/user/approve", {
        username: user.getValue().username
    });
    if (Array.isArray(result)) errorCollection.setValue(result);
    else if (result) user.setValue(result);
}
async function $81ca197868c8b74e$export$885bfdaa8d265eb5(user, errorCollection) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)("/api/user/disable", {
        username: user.getValue().username
    });
    if (Array.isArray(result)) errorCollection.setValue(result);
    else if (result) user.setValue(result);
}
async function $81ca197868c8b74e$export$2fae2261c6cf56cd(username) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)("/api/user/add", {
        username: username
    });
    if (result && !Array.isArray(result)) $81ca197868c8b74e$var$fetchAllUsers();
    return result;
}



var $aZSru = parcelRequire("aZSru");
const $2ecc252479907655$export$10b6fc071fe541e9 = (0, $aZSru.createContext)({
    currentUser: {},
    clientId: ""
});



parcelRequire("aZSru");
var $409581ffa1f40b0a$exports = {};
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/ /* global define */ (function() {
    'use strict';
    var hasOwn = {}.hasOwnProperty;
    function classNames() {
        var classes = '';
        for(var i = 0; i < arguments.length; i++){
            var arg = arguments[i];
            if (arg) classes = appendClass(classes, parseValue(arg));
        }
        return classes;
    }
    function parseValue(arg) {
        if (typeof arg === 'string' || typeof arg === 'number') return arg;
        if (typeof arg !== 'object') return '';
        if (Array.isArray(arg)) return classNames.apply(null, arg);
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) return arg.toString();
        var classes = '';
        for(var key in arg)if (hasOwn.call(arg, key) && arg[key]) classes = appendClass(classes, key);
        return classes;
    }
    function appendClass(value, newClass) {
        if (!newClass) return value;
        if (value) return value + ' ' + newClass;
        return value + newClass;
    }
    if ($409581ffa1f40b0a$exports) {
        classNames.default = classNames;
        $409581ffa1f40b0a$exports = classNames;
    } else if (typeof define === 'function' && typeof define.amd === 'object' && define.amd) // register as 'classnames', consistent with npm package name
    define('classnames', [], function() {
        return classNames;
    });
    else window.classNames = classNames;
})();



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");

"use client";
const $7c127cff4998859a$export$666ad80b5007f835 = [
    'xxl',
    'xl',
    'lg',
    'md',
    'sm',
    'xs'
];
const $7c127cff4998859a$export$ff817e17bad2e091 = 'xs';
const $7c127cff4998859a$var$ThemeContext = /*#__PURE__*/ $aZSru.createContext({
    prefixes: {},
    breakpoints: $7c127cff4998859a$export$666ad80b5007f835,
    minBreakpoint: $7c127cff4998859a$export$ff817e17bad2e091
});
const { Consumer: $7c127cff4998859a$export$b631efc24e9d5e2f, Provider: $7c127cff4998859a$var$Provider } = $7c127cff4998859a$var$ThemeContext;
function $7c127cff4998859a$var$ThemeProvider({ prefixes: prefixes = {}, breakpoints: breakpoints = $7c127cff4998859a$export$666ad80b5007f835, minBreakpoint: minBreakpoint = $7c127cff4998859a$export$ff817e17bad2e091, dir: dir, children: children }) {
    const contextValue = (0, $aZSru.useMemo)(()=>({
            prefixes: {
                ...prefixes
            },
            breakpoints: breakpoints,
            minBreakpoint: minBreakpoint,
            dir: dir
        }), [
        prefixes,
        breakpoints,
        minBreakpoint,
        dir
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($7c127cff4998859a$var$Provider, {
        value: contextValue,
        children: children
    });
}
function $7c127cff4998859a$export$7f387860ebffb32c(prefix, defaultPrefix) {
    const { prefixes: prefixes } = (0, $aZSru.useContext)($7c127cff4998859a$var$ThemeContext);
    return prefix || prefixes[defaultPrefix] || defaultPrefix;
}
function $7c127cff4998859a$export$8970c8db816a5863() {
    const { breakpoints: breakpoints } = (0, $aZSru.useContext)($7c127cff4998859a$var$ThemeContext);
    return breakpoints;
}
function $7c127cff4998859a$export$d926d6ef38f3fd32() {
    const { minBreakpoint: minBreakpoint } = (0, $aZSru.useContext)($7c127cff4998859a$var$ThemeContext);
    return minBreakpoint;
}
function $7c127cff4998859a$export$35e511eefa30ac5a() {
    const { dir: dir } = (0, $aZSru.useContext)($7c127cff4998859a$var$ThemeContext);
    return dir === 'rtl';
}
function $7c127cff4998859a$export$ce75053c20498f85(Component, opts) {
    if (typeof opts === 'string') opts = {
        prefix: opts
    };
    const isClassy = Component.prototype && Component.prototype.isReactComponent;
    // If it's a functional component make sure we don't break it with a ref
    const { prefix: prefix, forwardRefAs: forwardRefAs = isClassy ? 'ref' : 'innerRef' } = opts;
    const Wrapped = /*#__PURE__*/ $aZSru.forwardRef(({ ...props }, ref)=>{
        props[forwardRefAs] = ref;
        const bsPrefix = $7c127cff4998859a$export$7f387860ebffb32c(props.bsPrefix, prefix);
        return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
            ...props,
            bsPrefix: bsPrefix
        });
    });
    Wrapped.displayName = `Bootstrap(${Component.displayName || Component.name})`;
    return Wrapped;
}
var $7c127cff4998859a$export$2e2bcd8739ae039 = $7c127cff4998859a$var$ThemeProvider;



"use client";
const $de031b656976468f$var$Container = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, fluid: fluid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'container');
    const suffix = typeof fluid === 'string' ? `-${fluid}` : '-fluid';
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, fluid ? `${prefix}${suffix}` : prefix)
    });
});
$de031b656976468f$var$Container.displayName = 'Container';
var $de031b656976468f$export$2e2bcd8739ae039 = $de031b656976468f$var$Container;


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/url.ts
const $d4078e32874468f1$export$6c52c2011d568bd0 = /^(?:[a-z][a-z0-9+.-]*:|[\\/]{2})/i;
const $d4078e32874468f1$export$825a82322d91916e = /^[\\/]{2}/;
function $d4078e32874468f1$export$977999b735cd4f26(url, protocol) {
    return protocol + url.replace(/\\/g, "/");
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/router/history.ts
/**
* Actions represent the type of change to a location value.
*/ let $072a56029499ae6c$export$e19cd5f9376f8cee = /* @__PURE__ */ function(Action) {
    /**
	* A POP indicates a change to an arbitrary index in the history stack, such
	* as a back or forward navigation. It does not describe the direction of the
	* navigation, only that the current index changed.
	*
	* Note: This is the default action for newly created history objects.
	*/ Action["Pop"] = "POP";
    /**
	* A PUSH indicates a new entry being added to the history stack, such as when
	* a link is clicked and a new page loads. When this happens, all subsequent
	* entries in the stack are lost.
	*/ Action["Push"] = "PUSH";
    /**
	* A REPLACE indicates the entry at the current index in the history stack
	* being replaced by a new one.
	*/ Action["Replace"] = "REPLACE";
    return Action;
}({});
const $072a56029499ae6c$var$PopStateEventType = "popstate";
function $072a56029499ae6c$var$isLocation(obj) {
    return typeof obj === "object" && obj != null && "pathname" in obj && "search" in obj && "hash" in obj && "state" in obj && "key" in obj;
}
/**
* Memory history stores the current location in memory. It is designed for use
* in stateful non-browser environments like tests and React Native.
*/ function $072a56029499ae6c$export$2b76ad033c6e6d08(options = {}) {
    let { initialEntries: initialEntries = [
        "/"
    ], initialIndex: initialIndex, v5Compat: v5Compat = false } = options;
    let entries;
    entries = initialEntries.map((entry, index)=>createMemoryLocation(entry, typeof entry === "string" ? null : entry.state, index === 0 ? "default" : void 0, typeof entry === "string" ? void 0 : entry.mask));
    let index = clampIndex(initialIndex == null ? entries.length - 1 : initialIndex);
    let action = "POP";
    let listener = null;
    function clampIndex(n) {
        return Math.min(Math.max(n, 0), entries.length - 1);
    }
    function getCurrentLocation() {
        return entries[index];
    }
    function createMemoryLocation(to, state = null, key, mask) {
        let location = $072a56029499ae6c$export$90c043f1c57770b8(entries ? getCurrentLocation().pathname : "/", to, state, key, mask);
        $072a56029499ae6c$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in memory history: ${JSON.stringify(to)}`);
        return location;
    }
    function createHref(to) {
        return typeof to === "string" ? to : $072a56029499ae6c$export$fe53371bee54353d(to);
    }
    return {
        get index () {
            return index;
        },
        get action () {
            return action;
        },
        get location () {
            return getCurrentLocation();
        },
        createHref: createHref,
        createURL (to) {
            return new URL(createHref(to), "http://localhost");
        },
        encodeLocation (to) {
            let path = typeof to === "string" ? $072a56029499ae6c$export$8ccf933b0513f8d0(to) : to;
            return {
                pathname: path.pathname || "",
                search: path.search || "",
                hash: path.hash || ""
            };
        },
        push (to, state) {
            action = "PUSH";
            let nextLocation = $072a56029499ae6c$var$isLocation(to) ? to : createMemoryLocation(to, state);
            index += 1;
            entries.splice(index, entries.length, nextLocation);
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 1
            });
        },
        replace (to, state) {
            action = "REPLACE";
            let nextLocation = $072a56029499ae6c$var$isLocation(to) ? to : createMemoryLocation(to, state);
            entries[index] = nextLocation;
            if (v5Compat && listener) listener({
                action: action,
                location: nextLocation,
                delta: 0
            });
        },
        go (delta) {
            action = "POP";
            let nextIndex = clampIndex(index + delta);
            let nextLocation = entries[nextIndex];
            index = nextIndex;
            if (listener) listener({
                action: action,
                location: nextLocation,
                delta: delta
            });
        },
        listen (fn) {
            listener = fn;
            return ()=>{
                listener = null;
            };
        }
    };
}
/**
* Browser history stores the location in regular URLs. This is the standard for
* most web apps, but it requires some configuration on the server to ensure you
* serve the same app at multiple URLs.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createbrowserhistory
*/ function $072a56029499ae6c$export$719fc203c4e16dee(options = {}) {
    function createBrowserLocation(window, globalHistory) {
        let maskedLocation = globalHistory.state?.masked;
        let { pathname: pathname, search: search, hash: hash } = maskedLocation || window.location;
        return $072a56029499ae6c$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default", maskedLocation ? {
            pathname: window.location.pathname,
            search: window.location.search,
            hash: window.location.hash
        } : void 0);
    }
    function createBrowserHref(window, to) {
        return typeof to === "string" ? to : $072a56029499ae6c$export$fe53371bee54353d(to);
    }
    return $072a56029499ae6c$var$getUrlBasedHistory(createBrowserLocation, createBrowserHref, null, options);
}
/**
* Hash history stores the location in window.location.hash. This makes it ideal
* for situations where you don't want to send the location to the server for
* some reason, either because you do cannot configure it or the URL space is
* reserved for something else.
*
* @see https://github.com/remix-run/history/tree/main/docs/api-reference.md#createhashhistory
*/ function $072a56029499ae6c$export$b71fdd3798280242(options = {}) {
    function createHashLocation(window, globalHistory) {
        let { pathname: pathname = "/", search: search = "", hash: hash = "" } = $072a56029499ae6c$export$8ccf933b0513f8d0(window.location.hash.substring(1));
        if (!pathname.startsWith("/") && !pathname.startsWith(".")) pathname = "/" + pathname;
        return $072a56029499ae6c$export$90c043f1c57770b8("", {
            pathname: pathname,
            search: search,
            hash: hash
        }, globalHistory.state && globalHistory.state.usr || null, globalHistory.state && globalHistory.state.key || "default");
    }
    function createHashHref(window, to) {
        let base = window.document.querySelector("base");
        let href = "";
        if (base && base.getAttribute("href")) {
            let url = window.location.href;
            let hashIndex = url.indexOf("#");
            href = hashIndex === -1 ? url : url.slice(0, hashIndex);
        }
        return href + "#" + (typeof to === "string" ? to : $072a56029499ae6c$export$fe53371bee54353d(to));
    }
    function validateHashLocation(location, to) {
        $072a56029499ae6c$export$491112666e282270(location.pathname.charAt(0) === "/", `relative pathnames are not supported in hash history.push(${JSON.stringify(to)})`);
    }
    return $072a56029499ae6c$var$getUrlBasedHistory(createHashLocation, createHashHref, validateHashLocation, options);
}
function $072a56029499ae6c$export$f5708dca728d7177(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}
function $072a56029499ae6c$export$491112666e282270(cond, message) {
    if (!cond) {
        if (typeof console !== "undefined") console.warn(message);
        try {
            throw new Error(message);
        } catch  {}
    }
}
function $072a56029499ae6c$var$createKey() {
    return Math.random().toString(36).substring(2, 10);
}
/**
* For browser-based histories, we combine the state and key into an object
*/ function $072a56029499ae6c$var$getHistoryState(location, index) {
    return {
        usr: location.state,
        key: location.key,
        idx: index,
        masked: location.mask ? {
            pathname: location.pathname,
            search: location.search,
            hash: location.hash
        } : void 0
    };
}
/**
* Creates a Location object with a unique key from the given Path
*/ function $072a56029499ae6c$export$90c043f1c57770b8(current, to, state = null, key, mask) {
    return {
        pathname: typeof current === "string" ? current : current.pathname,
        search: "",
        hash: "",
        ...typeof to === "string" ? $072a56029499ae6c$export$8ccf933b0513f8d0(to) : to,
        state: state,
        key: to && to.key || key || $072a56029499ae6c$var$createKey(),
        mask: mask
    };
}
/**
* Creates a string URL path from the given pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The pathname, search, and hash components to combine.
* @returns The combined URL path.
*/ function $072a56029499ae6c$export$fe53371bee54353d({ pathname: pathname = "/", search: search = "", hash: hash = "" }) {
    if (search && search !== "?") pathname += search.charAt(0) === "?" ? search : "?" + search;
    if (hash && hash !== "#") pathname += hash.charAt(0) === "#" ? hash : "#" + hash;
    return pathname;
}
/**
* Parses a string URL path into its separate pathname, search, and hash components.
*
* @public
* @category Utils
* @param path The URL path to parse.
* @returns The parsed pathname, search, and hash components.
*/ function $072a56029499ae6c$export$8ccf933b0513f8d0(path) {
    let parsedPath = {};
    if (path) {
        let hashIndex = path.indexOf("#");
        if (hashIndex >= 0) {
            parsedPath.hash = path.substring(hashIndex);
            path = path.substring(0, hashIndex);
        }
        let searchIndex = path.indexOf("?");
        if (searchIndex >= 0) {
            parsedPath.search = path.substring(searchIndex);
            path = path.substring(0, searchIndex);
        }
        if (path) parsedPath.pathname = path;
    }
    return parsedPath;
}
function $072a56029499ae6c$var$getUrlBasedHistory(getLocation, createHref, validateLocation, options = {}) {
    let { window: window = document.defaultView, v5Compat: v5Compat = false } = options;
    let globalHistory = window.history;
    let action = "POP";
    let listener = null;
    let index = getIndex();
    if (index == null) {
        index = 0;
        globalHistory.replaceState({
            ...globalHistory.state,
            idx: index
        }, "");
    }
    function getIndex() {
        return (globalHistory.state || {
            idx: null
        }).idx;
    }
    function handlePop() {
        action = "POP";
        let nextIndex = getIndex();
        let delta = nextIndex == null ? null : nextIndex - index;
        index = nextIndex;
        if (listener) listener({
            action: action,
            location: history.location,
            delta: delta
        });
    }
    function push(to, state) {
        action = "PUSH";
        let location = $072a56029499ae6c$var$isLocation(to) ? to : $072a56029499ae6c$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex() + 1;
        let historyState = $072a56029499ae6c$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        try {
            globalHistory.pushState(historyState, "", url);
        } catch (error) {
            if (error instanceof DOMException && error.name === "DataCloneError") throw error;
            window.location.assign(url);
        }
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 1
        });
    }
    function replace(to, state) {
        action = "REPLACE";
        let location = $072a56029499ae6c$var$isLocation(to) ? to : $072a56029499ae6c$export$90c043f1c57770b8(history.location, to, state);
        if (validateLocation) validateLocation(location, to);
        index = getIndex();
        let historyState = $072a56029499ae6c$var$getHistoryState(location, index);
        let url = history.createHref(location.mask || location);
        globalHistory.replaceState(historyState, "", url);
        if (v5Compat && listener) listener({
            action: action,
            location: history.location,
            delta: 0
        });
    }
    function createURL(to) {
        return $072a56029499ae6c$export$e2450fce17852bf2(window, to);
    }
    let history = {
        get action () {
            return action;
        },
        get location () {
            return getLocation(window, globalHistory);
        },
        listen (fn) {
            if (listener) throw new Error("A history only accepts one active listener");
            window.addEventListener($072a56029499ae6c$var$PopStateEventType, handlePop);
            listener = fn;
            return ()=>{
                window.removeEventListener($072a56029499ae6c$var$PopStateEventType, handlePop);
                listener = null;
            };
        },
        createHref (to) {
            return createHref(window, to);
        },
        createURL: createURL,
        encodeLocation (to) {
            let url = createURL(to);
            return {
                pathname: url.pathname,
                search: url.search,
                hash: url.hash
            };
        },
        push: push,
        replace: replace,
        go (n) {
            return globalHistory.go(n);
        }
    };
    return history;
}
function $072a56029499ae6c$export$e2450fce17852bf2(windowImpl, to, isAbsolute = false) {
    let base = "http://localhost";
    if (windowImpl) base = windowImpl.location.origin !== "null" ? windowImpl.location.origin : windowImpl.location.href;
    $072a56029499ae6c$export$f5708dca728d7177(base, "No window.location.(origin|href) available to create URL");
    let href = typeof to === "string" ? to : $072a56029499ae6c$export$fe53371bee54353d(to);
    href = href.replace(/ $/, "%20");
    if (!isAbsolute && (0, $d4078e32874468f1$export$825a82322d91916e).test(href)) href = base + href;
    return new URL(href, base);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ function $9f000f172ecc0fea$export$71511d61b312f219(receiver, descriptor) {
    if (descriptor.get) return descriptor.get.call(receiver);
    return descriptor.value;
}


function $37860ab55d7a31e0$export$71511d61b312f219(receiver, privateMap, action) {
    if (!privateMap.has(receiver)) throw new TypeError("attempted to " + action + " private field on non-instance");
    return privateMap.get(receiver);
}


function $138bdba4f9532a1d$export$71511d61b312f219(receiver, privateMap) {
    var descriptor = (0, $37860ab55d7a31e0$export$71511d61b312f219)(receiver, privateMap, "get");
    return (0, $9f000f172ecc0fea$export$71511d61b312f219)(receiver, descriptor);
}


function $3cb643dd5411d589$export$71511d61b312f219(obj, privateCollection) {
    if (privateCollection.has(obj)) throw new TypeError("Cannot initialize the same private elements twice on an object");
}


function $385e6fada99f052b$export$71511d61b312f219(obj, privateMap, value) {
    (0, $3cb643dd5411d589$export$71511d61b312f219)(obj, privateMap);
    privateMap.set(obj, value);
}


function $b08ae6015a2ae0d0$export$71511d61b312f219(obj, key, value) {
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}





var $aZSru = parcelRequire("aZSru");
var $f1195701c85e5ce2$var$_map;
//#region lib/router/utils.ts
/**
* Creates a type-safe {@link RouterContext} object that can be used to
* store and retrieve arbitrary values in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
* Similar to React's [`createContext`](https://react.dev/reference/react/createContext),
* but specifically designed for React Router's request/response lifecycle.
*
* If a `defaultValue` is provided, it will be returned from `context.get()`
* when no value has been set for the context. Otherwise, reading this context
* when no value has been set will throw an error.
*
* ```tsx filename=app/context.ts
* import { createContext } from "react-router";
*
* // Create a context for user data
* export const userContext =
*   createContext<User | null>(null);
* ```
*
* ```tsx filename=app/middleware/auth.ts
* import { getUserFromSession } from "~/auth.server";
* import { userContext } from "~/context";
*
* export const authMiddleware = async ({
*   context,
*   request,
* }) => {
*   const user = await getUserFromSession(request);
*   context.set(userContext, user);
* };
* ```
*
* ```tsx filename=app/routes/profile.tsx
* import { userContext } from "~/context";
*
* export async function loader({
*   context,
* }: Route.LoaderArgs) {
*   const user = context.get(userContext);
*
*   if (!user) {
*     throw new Response("Unauthorized", { status: 401 });
*   }
*
*   return { user };
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param defaultValue An optional default value for the context. This value
* will be returned if no value has been set for this context.
* @returns A {@link RouterContext} object that can be used with
* `context.get()` and `context.set()` in [`action`](../../start/framework/route-module#action)s,
* [`loader`](../../start/framework/route-module#loader)s, and [middleware](../../how-to/middleware).
*/ function $f1195701c85e5ce2$export$fd42f52fd3ae1109(defaultValue) {
    return {
        defaultValue: defaultValue
    };
}
/**
* Provides methods for writing/reading values in application context in a
* type-safe way. Primarily for usage with [middleware](../../how-to/middleware).
*
* @example
* import {
*   createContext,
*   RouterContextProvider
* } from "react-router";
*
* const userContext = createContext<User | null>(null);
* const contextProvider = new RouterContextProvider();
* contextProvider.set(userContext, getUser());
* //                               ^ Type-safe
* const user = contextProvider.get(userContext);
* //    ^ User
*
* @public
* @category Utils
* @mode framework
* @mode data
*/ var $f1195701c85e5ce2$export$b8d3e69d4b3eff04 = ($f1195701c85e5ce2$var$_map = /*#__PURE__*/ new WeakMap(), class {
    /**
	* Access a value from the context. If no value has been set for the context,
	* it will return the context's `defaultValue` if provided, or throw an error
	* if no `defaultValue` was set.
	* @param context The context to get the value for
	* @returns The value for the context, or the context's `defaultValue` if no
	* value was set
	*/ get(context) {
        if ((0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $f1195701c85e5ce2$var$_map).has(context)) return (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $f1195701c85e5ce2$var$_map).get(context);
        if (context.defaultValue !== void 0) return context.defaultValue;
        throw new Error("No value found for context");
    }
    /**
	* Set a value for the context. If the context already has a value set, this
	* will overwrite it.
	*
	* @param context The context to set the value for
	* @param value The value to set for the context
	* @returns {void}
	*/ set(context, value) {
        (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $f1195701c85e5ce2$var$_map).set(context, value);
    }
    /**
	* Create a new `RouterContextProvider` instance
	* @param init An optional initial context map to populate the provider with
	*/ constructor(init){
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $f1195701c85e5ce2$var$_map, {
            writable: true,
            value: /* @__PURE__ */ new Map()
        });
        if (init) for (let [context, value] of init)this.set(context, value);
    }
});
const $f1195701c85e5ce2$var$unsupportedLazyRouteObjectKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "children",
    "unstable_validateParams"
]);
function $f1195701c85e5ce2$export$3e22299e33adeed1(key) {
    return $f1195701c85e5ce2$var$unsupportedLazyRouteObjectKeys.has(key);
}
const $f1195701c85e5ce2$var$unsupportedLazyRouteFunctionKeys = new Set([
    "lazy",
    "caseSensitive",
    "path",
    "id",
    "index",
    "middleware",
    "children",
    "unstable_validateParams"
]);
function $f1195701c85e5ce2$export$a89d811eaa209e85(key) {
    return $f1195701c85e5ce2$var$unsupportedLazyRouteFunctionKeys.has(key);
}
function $f1195701c85e5ce2$var$isIndexRoute(route) {
    return route.index === true;
}
function $f1195701c85e5ce2$export$6bc17138063be773(route) {
    let updates = {};
    if (route.Component) Object.assign(updates, {
        element: $aZSru.createElement(route.Component),
        Component: void 0
    });
    if (route.HydrateFallback) Object.assign(updates, {
        hydrateFallbackElement: $aZSru.createElement(route.HydrateFallback),
        HydrateFallback: void 0
    });
    if (route.ErrorBoundary) Object.assign(updates, {
        errorElement: $aZSru.createElement(route.ErrorBoundary),
        ErrorBoundary: void 0
    });
    return updates;
}
function $f1195701c85e5ce2$export$87cb1a9238dc3fba(routes, mapRouteProperties = $f1195701c85e5ce2$export$6bc17138063be773, parentPath = [], manifest = {}, allowInPlaceMutations = false) {
    return routes.map((route, index)=>{
        let treePath = [
            ...parentPath,
            String(index)
        ];
        let id = typeof route.id === "string" ? route.id : treePath.join("-");
        (0, $072a56029499ae6c$export$f5708dca728d7177)(route.index !== true || !route.children, `Cannot specify children on an index route`);
        (0, $072a56029499ae6c$export$f5708dca728d7177)(allowInPlaceMutations || !manifest[id], `Found a route id collision on id "${id}".  Route id's must be globally unique within Data Router usages`);
        if ($f1195701c85e5ce2$var$isIndexRoute(route)) {
            let indexRoute = {
                ...route,
                id: id
            };
            manifest[id] = $f1195701c85e5ce2$var$mergeRouteUpdates(indexRoute, mapRouteProperties(indexRoute));
            return indexRoute;
        } else {
            let pathOrLayoutRoute = {
                ...route,
                id: id,
                children: void 0
            };
            manifest[id] = $f1195701c85e5ce2$var$mergeRouteUpdates(pathOrLayoutRoute, mapRouteProperties(pathOrLayoutRoute));
            if (route.children) pathOrLayoutRoute.children = $f1195701c85e5ce2$export$87cb1a9238dc3fba(route.children, mapRouteProperties, treePath, manifest, allowInPlaceMutations);
            return pathOrLayoutRoute;
        }
    });
}
function $f1195701c85e5ce2$var$mergeRouteUpdates(route, updates) {
    return Object.assign(route, {
        ...updates,
        ...typeof updates.lazy === "object" && updates.lazy != null ? {
            lazy: {
                ...route.lazy,
                ...updates.lazy
            }
        } : {}
    });
}
/**
* Matches the given routes to a location and returns the match data.
*
* @example
* import { matchRoutes } from "react-router";
*
* let routes = [{
*   path: "/",
*   Component: Root,
*   children: [{
*     path: "dashboard",
*     Component: Dashboard,
*   }]
* }];
*
* matchRoutes(routes, "/dashboard"); // [rootMatch, dashboardMatch]
*
* @public
* @category Utils
* @param routes The array of route objects to match against.
* @param locationArg The location to match against, either a string path or a
* partial {@link Location} object
* @param basename Optional base path to strip from the location before matching.
* Defaults to `/`.
* @returns An array of matched routes, or `null` if no matches were found.
*/ function $f1195701c85e5ce2$export$2708184779ceb39d(routes, locationArg, basename = "/") {
    return $f1195701c85e5ce2$export$5c7b09132f833c25(routes, locationArg, basename, false);
}
function $f1195701c85e5ce2$export$5c7b09132f833c25(routes, locationArg, basename, allowPartial, precomputedBranches) {
    let pathname = $f1195701c85e5ce2$export$b69e3301ce081aa3((typeof locationArg === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", basename);
    if (pathname == null) return null;
    let branches = precomputedBranches ?? $f1195701c85e5ce2$export$e486c0390e42ccf6(routes);
    let matches = null;
    let decoded = $f1195701c85e5ce2$export$cd27bea214d030c2(pathname);
    for(let i = 0; matches == null && i < branches.length; ++i)matches = $f1195701c85e5ce2$var$matchRouteBranch(branches[i], decoded, allowPartial);
    return matches;
}
function $f1195701c85e5ce2$export$fcf533780bf49ee2(match, loaderData) {
    let { route: route, pathname: pathname, params: params } = match;
    return {
        id: route.id,
        pathname: pathname,
        params: params,
        loaderData: loaderData[route.id],
        handle: route.handle
    };
}
function $f1195701c85e5ce2$export$e486c0390e42ccf6(routes) {
    let branches = $f1195701c85e5ce2$var$flattenRoutes(routes);
    $f1195701c85e5ce2$var$rankRouteBranches(branches);
    return branches;
}
function $f1195701c85e5ce2$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "", _hasParentOptionalSegments = false) {
    let flattenRoute = (route, index, hasParentOptionalSegments = _hasParentOptionalSegments, relativePath)=>{
        let meta = {
            relativePath: relativePath === void 0 ? route.path || "" : relativePath,
            caseSensitive: route.caseSensitive === true,
            childrenIndex: index,
            route: route
        };
        if (meta.relativePath.startsWith("/")) {
            if (!meta.relativePath.startsWith(parentPath) && hasParentOptionalSegments) return;
            (0, $072a56029499ae6c$export$f5708dca728d7177)(meta.relativePath.startsWith(parentPath), `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPath.length);
        }
        let path = $f1195701c85e5ce2$export$86d9a7913e44197e([
            parentPath,
            meta.relativePath
        ]);
        let routesMeta = parentsMeta.concat(meta);
        if (route.children && route.children.length > 0) {
            (0, $072a56029499ae6c$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $f1195701c85e5ce2$var$flattenRoutes(route.children, branches, routesMeta, path, hasParentOptionalSegments);
        }
        if (route.path == null && !route.index) return;
        branches.push({
            path: path,
            score: $f1195701c85e5ce2$var$computeScore(path, route.index),
            routesMeta: routesMeta.map((meta, i)=>{
                let [matcher, params] = $f1195701c85e5ce2$export$d726f29eb2425705(meta.relativePath, meta.caseSensitive, i === routesMeta.length - 1);
                return {
                    ...meta,
                    matcher: matcher,
                    compiledParams: params
                };
            })
        });
    };
    routes.forEach((route, index)=>{
        if (route.path === "" || !route.path?.includes("?")) flattenRoute(route, index);
        else for (let exploded of $f1195701c85e5ce2$export$82472424e06ad5c9(route.path))flattenRoute(route, index, true, exploded);
    });
    return branches;
}
function $f1195701c85e5ce2$export$82472424e06ad5c9(path) {
    let segments = path.split("/");
    if (segments.length === 0) return [];
    let [first, ...rest] = segments;
    let isOptional = first.endsWith("?");
    let required = first.replace(/\?$/, "");
    if (rest.length === 0) return isOptional ? [
        required,
        ""
    ] : [
        required
    ];
    let restExploded = $f1195701c85e5ce2$export$82472424e06ad5c9(rest.join("/"));
    let result = [];
    result.push(...restExploded.map((subpath)=>subpath === "" ? required : [
            required,
            subpath
        ].join("/")));
    if (isOptional) result.push(...restExploded);
    return result.map((exploded)=>path.startsWith("/") && exploded === "" ? "/" : exploded);
}
function $f1195701c85e5ce2$var$rankRouteBranches(branches) {
    branches.sort((a, b)=>a.score !== b.score ? b.score - a.score : $f1195701c85e5ce2$var$compareIndexes(a.routesMeta.map((meta)=>meta.childrenIndex), b.routesMeta.map((meta)=>meta.childrenIndex)));
}
const $f1195701c85e5ce2$var$paramRe = /^:[\w-]+$/;
const $f1195701c85e5ce2$var$partialParamRe = /^:[\w-]+/;
const $f1195701c85e5ce2$var$partialDynamicSegmentValue = 3.5;
const $f1195701c85e5ce2$var$dynamicSegmentValue = 3;
const $f1195701c85e5ce2$var$indexRouteValue = 2;
const $f1195701c85e5ce2$var$emptySegmentValue = 1;
const $f1195701c85e5ce2$var$staticSegmentValue = 10;
const $f1195701c85e5ce2$var$splatPenalty = -2;
const $f1195701c85e5ce2$var$isSplat = (s)=>s === "*";
function $f1195701c85e5ce2$var$computeScore(path, index) {
    let segments = path.split("/");
    let initialScore = segments.length;
    if (segments.some($f1195701c85e5ce2$var$isSplat)) initialScore += $f1195701c85e5ce2$var$splatPenalty;
    if (index) initialScore += $f1195701c85e5ce2$var$indexRouteValue;
    return segments.filter((s)=>!$f1195701c85e5ce2$var$isSplat(s)).reduce((score, segment)=>score + ($f1195701c85e5ce2$var$paramRe.test(segment) ? $f1195701c85e5ce2$var$dynamicSegmentValue : $f1195701c85e5ce2$var$partialParamRe.test(segment) ? $f1195701c85e5ce2$var$partialDynamicSegmentValue : segment === "" ? $f1195701c85e5ce2$var$emptySegmentValue : $f1195701c85e5ce2$var$staticSegmentValue), initialScore);
}
function $f1195701c85e5ce2$var$compareIndexes(a, b) {
    return a.length === b.length && a.slice(0, -1).every((n, i)=>n === b[i]) ? a[a.length - 1] - b[b.length - 1] : 0;
}
function $f1195701c85e5ce2$var$matchRouteBranch(branch, pathname, allowPartial = false) {
    let { routesMeta: routesMeta } = branch;
    let matchedParams = {};
    let matchedPathname = "/";
    let matches = [];
    for(let i = 0; i < routesMeta.length; ++i){
        let meta = routesMeta[i];
        let end = i === routesMeta.length - 1;
        let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
        let pattern = {
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: end
        };
        let match = meta.matcher && meta.compiledParams ? $f1195701c85e5ce2$var$matchPathImpl(pattern, remainingPathname, meta.matcher, meta.compiledParams) : $f1195701c85e5ce2$export$81336c211d5ff295(pattern, remainingPathname);
        let route = meta.route;
        if (!match && end && allowPartial && !routesMeta[routesMeta.length - 1].route.index) match = $f1195701c85e5ce2$export$81336c211d5ff295({
            path: meta.relativePath,
            caseSensitive: meta.caseSensitive,
            end: false
        }, remainingPathname);
        if (!match) return null;
        Object.assign(matchedParams, match.params);
        matches.push({
            params: matchedParams,
            pathname: $f1195701c85e5ce2$export$86d9a7913e44197e([
                matchedPathname,
                match.pathname
            ]),
            pathnameBase: $f1195701c85e5ce2$export$a5c6d149b50c1d86($f1195701c85e5ce2$export$86d9a7913e44197e([
                matchedPathname,
                match.pathnameBase
            ])),
            route: route
        });
        if (match.pathnameBase !== "/") matchedPathname = $f1195701c85e5ce2$export$86d9a7913e44197e([
            matchedPathname,
            match.pathnameBase
        ]);
    }
    return matches;
}
/**
* Characters that `encodeURIComponent` escapes but that are valid literally in
* a URL path segment. Per RFC 3986 §3.3, a path segment is made of `pchar`:
*
* ```
* pchar = unreserved / pct-encoded / sub-delims / ":" / "@"
* sub-delims = "!" / "$" / "&" / "'" / "(" / ")" / "*" / "+" / "," / ";" / "="
* ```
*
* `encodeURIComponent` targets query-string values, where `$ & + , ; = : @`
* are delimiters and must be escaped — but in a path segment they carry no
* special meaning, and browsers keep them literal in `location.pathname`.
* (`! ' ( ) *` and the unreserved set are already left alone by
* `encodeURIComponent`, so they need no restoring.)
*/ const $f1195701c85e5ce2$var$PATH_PARAM_OVERESCAPED = {
    "%24": "$",
    "%26": "&",
    "%2B": "+",
    "%2C": ",",
    "%3A": ":",
    "%3B": ";",
    "%3D": "=",
    "%40": "@"
};
/**
* Encodes a param value for interpolation into a single URL path segment.
*
* Escapes characters that would break the path (`/ ? # %`, whitespace,
* non-ASCII, …) while leaving characters that RFC 3986 permits literally in a
* path segment untouched. Escaping those would needlessly rewrite URLs — e.g.
*  a semver build param `1.0.0+1` would become `1.0.0%2B1` even though browsers
* display and match the `+` literally in `location.pathname`.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3))
*
* @param value The param value to encode.
* @returns The encoded value, safe for use as a single path segment.
*/ function $f1195701c85e5ce2$export$1adf7db041bd81b8(value) {
    return encodeURIComponent(value).replace(/%(?:24|26|2B|2C|3A|3B|3D|40)/g, (match)=>$f1195701c85e5ce2$var$PATH_PARAM_OVERESCAPED[match]);
}
/**
* Returns a path with params interpolated.
*
* Param values are percent-encoded for use in a path segment: characters that
* would change the URL structure (`/`, `?`, `#`, `%`, whitespace, non-ASCII)
* are escaped, while characters that RFC 3986 allows literally in a path
* segment (`$ & + , ; = : @`) are kept as-is. Note this differs from query-string
* encoding (`encodeURIComponent`/`URLSearchParams`), where those characters are
* delimiters and must be escaped. Splat (`*`) values are encoded per segment,
* preserving `/` separators.
*
* See [RFC 3986 §3.3](https://datatracker.ietf.org/doc/html/rfc3986#section-3.3)
*
* @example
* import { generatePath } from "react-router";
*
* generatePath("/users/:id", { id: "123" }); // "/users/123"
* generatePath("/files/:name", { name: "a b" }); // "/files/a%20b"
* generatePath("/releases/:v", { v: "1.0.0+1" }); // "/releases/1.0.0+1"
*
* @public
* @category Utils
* @param originalPath The original path to generate.
* @param params The parameters to interpolate into the path.
* @returns The generated path with parameters interpolated.
*/ function $f1195701c85e5ce2$export$82476f982757e71e(originalPath, params = {}) {
    let path = originalPath;
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) {
        (0, $072a56029499ae6c$export$491112666e282270)(false, `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
        path = path.replace(/\*$/, "/*");
    }
    const prefix = path.startsWith("/") ? "/" : "";
    const stringify = (p)=>p == null ? "" : typeof p === "string" ? p : String(p);
    return prefix + path.split(/\/+/).map((segment, index, array)=>{
        if (index === array.length - 1 && segment === "*") return stringify(params["*"]);
        const keyMatch = segment.match(/^:([\w-]+)(\??)(.*)/);
        if (keyMatch) {
            const [, key, optional, suffix] = keyMatch;
            let param = params[key];
            (0, $072a56029499ae6c$export$f5708dca728d7177)(optional === "?" || param != null, `Missing ":${key}" param`);
            return $f1195701c85e5ce2$export$1adf7db041bd81b8(stringify(param)) + suffix;
        }
        return segment.replace(/\?$/g, "");
    }).filter((segment)=>!!segment).join("/");
}
/**
* Performs pattern matching on a URL pathname and returns information about
* the match.
*
* @public
* @category Utils
* @param pattern The pattern to match against the URL pathname. This can be a
* string or a {@link PathPattern} object. If a string is provided, it will be
* treated as a pattern with `caseSensitive` set to `false` and `end` set to
* `true`.
* @param pathname The URL pathname to match against the pattern.
* @returns A path match object if the pattern matches the pathname,
* or `null` if it does not match.
*/ function $f1195701c85e5ce2$export$81336c211d5ff295(pattern, pathname) {
    if (typeof pattern === "string") pattern = {
        path: pattern,
        caseSensitive: false,
        end: true
    };
    let [matcher, compiledParams] = $f1195701c85e5ce2$export$d726f29eb2425705(pattern.path, pattern.caseSensitive, pattern.end);
    return $f1195701c85e5ce2$var$matchPathImpl(pattern, pathname, matcher, compiledParams);
}
function $f1195701c85e5ce2$var$matchPathImpl(pattern, pathname, matcher, compiledParams) {
    let match = pathname.match(matcher);
    if (!match) return null;
    let matchedPathname = match[0];
    let pathnameBase = $f1195701c85e5ce2$export$b6d465111d914331(matchedPathname, 1);
    let captureGroups = match.slice(1);
    return {
        params: compiledParams.reduce((memo, { paramName: paramName, isOptional: isOptional }, index)=>{
            if (paramName === "*") {
                let splatValue = captureGroups[index] || "";
                pathnameBase = $f1195701c85e5ce2$export$b6d465111d914331(matchedPathname.slice(0, matchedPathname.length - splatValue.length), 1);
            }
            const value = captureGroups[index];
            if (isOptional && !value) memo[paramName] = void 0;
            else memo[paramName] = (value || "").replace(/%2F/g, "/");
            return memo;
        }, {}),
        pathname: matchedPathname,
        pathnameBase: pathnameBase,
        pattern: pattern
    };
}
function $f1195701c85e5ce2$export$d726f29eb2425705(path, caseSensitive = false, end = true) {
    (0, $072a56029499ae6c$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    let params = [];
    let regexpSource = "^" + path.replace(/\/*\*?$/, "").replace(/^\/*/, "/").replace(/[\\.*+^${}|()[\]]/g, "\\$&").replace(/\/:([\w-]+)(\?)?/g, (match, paramName, isOptional, index, str)=>{
        params.push({
            paramName: paramName,
            isOptional: isOptional != null
        });
        if (isOptional) {
            let nextChar = str.charAt(index + match.length);
            if (nextChar && nextChar !== "/") return "/([^\\/]*)";
            return "(?:/([^\\/]*))?";
        }
        return "/([^\\/]+)";
    }).replace(/\/([\w-]+)\?(?=\/|$|\()/g, "(?:/$1)?");
    if (path.endsWith("*")) {
        params.push({
            paramName: "*"
        });
        regexpSource += path === "*" || path === "/*" ? "(.*)$" : "(?:\\/(.+)|\\/*)$";
    } else if (end) regexpSource += "\\/*$";
    else if (path !== "" && path !== "/") regexpSource += "(?:(?=\\/|$))";
    return [
        new RegExp(regexpSource, caseSensitive ? void 0 : "i"),
        params
    ];
}
function $f1195701c85e5ce2$export$cd27bea214d030c2(value) {
    try {
        return value.split("/").map((v)=>decodeURIComponent(v).replace(/\//g, "%2F")).join("/");
    } catch (error) {
        (0, $072a56029499ae6c$export$491112666e282270)(false, `The URL path "${value}" could not be decoded because it is a malformed URL segment. This is probably due to a bad percent encoding (${error}).`);
        return value;
    }
}
function $f1195701c85e5ce2$export$b69e3301ce081aa3(pathname, basename) {
    if (basename === "/") return pathname;
    if (!pathname.toLowerCase().startsWith(basename.toLowerCase())) return null;
    let startIndex = basename.endsWith("/") ? basename.length - 1 : basename.length;
    let nextChar = pathname.charAt(startIndex);
    if (nextChar && nextChar !== "/") return null;
    return pathname.slice(startIndex) || "/";
}
function $f1195701c85e5ce2$export$e9a5bfadbc179142({ basename: basename, pathname: pathname }) {
    return pathname === "/" ? basename : $f1195701c85e5ce2$export$86d9a7913e44197e([
        basename,
        pathname
    ]);
}
const $f1195701c85e5ce2$export$a1cbf2de32a9fd1 = (url)=>(0, $d4078e32874468f1$export$6c52c2011d568bd0).test(url);
/**
* Returns a resolved {@link Path} object relative to the given pathname.
*
* @public
* @category Utils
* @param to The path to resolve, either a string or a partial {@link Path}
* object.
* @param fromPathname The pathname to resolve the path from. Defaults to `/`.
* @returns A {@link Path} object with the resolved pathname, search, and hash.
*/ function $f1195701c85e5ce2$export$b09f2ff0bbcb43c7(to, fromPathname = "/") {
    let { pathname: toPathname, search: search = "", hash: hash = "" } = typeof to === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(to) : to;
    let pathname;
    if (toPathname) {
        toPathname = $f1195701c85e5ce2$export$f857a07c5bd323b8(toPathname);
        if (toPathname.startsWith("/") || toPathname.startsWith("\\")) pathname = $f1195701c85e5ce2$var$resolvePathname(toPathname.substring(1), "/");
        else pathname = $f1195701c85e5ce2$var$resolvePathname(toPathname, fromPathname);
    } else pathname = fromPathname;
    return {
        pathname: pathname,
        search: $f1195701c85e5ce2$var$normalizeSearch(search),
        hash: $f1195701c85e5ce2$var$normalizeHash(hash)
    };
}
function $f1195701c85e5ce2$var$resolvePathname(relativePath, fromPathname) {
    let segments = $f1195701c85e5ce2$export$b6d465111d914331(fromPathname).split("/");
    relativePath.split("/").forEach((segment)=>{
        if (segment === "..") {
            if (segments.length > 1) segments.pop();
        } else if (segment !== ".") segments.push(segment);
    });
    return segments.length > 1 ? segments.join("/") : "/";
}
function $f1195701c85e5ce2$var$getInvalidPathError(char, field, dest, path) {
    return `Cannot include a '${char}' character in a manually specified \`to.${field}\` field [${JSON.stringify(path)}].  Please separate it out to the \`to.${dest}\` field. Alternatively you may provide the full path as a string in <Link to="..."> and the router will parse it for you.`;
}
function $f1195701c85e5ce2$export$b234c29a3bb68fc8(matches) {
    return matches.filter((match, index)=>index === 0 || match.route.path && match.route.path.length > 0);
}
function $f1195701c85e5ce2$export$fe6dbc5de95f53ab(matches) {
    let pathMatches = $f1195701c85e5ce2$export$b234c29a3bb68fc8(matches);
    return pathMatches.map((match, idx)=>idx === pathMatches.length - 1 ? match.pathname : match.pathnameBase);
}
function $f1195701c85e5ce2$export$cae722b0cc860f13(toArg, routePathnames, locationPathname, isPathRelative = false) {
    let to;
    if (typeof toArg === "string") to = (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(toArg);
    else {
        to = {
            ...toArg
        };
        (0, $072a56029499ae6c$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("?"), $f1195701c85e5ce2$var$getInvalidPathError("?", "pathname", "search", to));
        (0, $072a56029499ae6c$export$f5708dca728d7177)(!to.pathname || !to.pathname.includes("#"), $f1195701c85e5ce2$var$getInvalidPathError("#", "pathname", "hash", to));
        (0, $072a56029499ae6c$export$f5708dca728d7177)(!to.search || !to.search.includes("#"), $f1195701c85e5ce2$var$getInvalidPathError("#", "search", "hash", to));
    }
    let isEmptyPath = toArg === "" || to.pathname === "";
    let toPathname = isEmptyPath ? "/" : to.pathname;
    let from;
    if (toPathname == null) from = locationPathname;
    else {
        let routePathnameIndex = routePathnames.length - 1;
        if (!isPathRelative && toPathname.startsWith("..")) {
            let toSegments = toPathname.split("/");
            while(toSegments[0] === ".."){
                toSegments.shift();
                routePathnameIndex -= 1;
            }
            to.pathname = toSegments.join("/");
        }
        from = routePathnameIndex >= 0 ? routePathnames[routePathnameIndex] : "/";
    }
    let path = $f1195701c85e5ce2$export$b09f2ff0bbcb43c7(to, from);
    let hasExplicitTrailingSlash = toPathname && toPathname !== "/" && toPathname.endsWith("/");
    let hasCurrentTrailingSlash = (isEmptyPath || toPathname === ".") && locationPathname.endsWith("/");
    if (!path.pathname.endsWith("/") && (hasExplicitTrailingSlash || hasCurrentTrailingSlash)) path.pathname += "/";
    return path;
}
const $f1195701c85e5ce2$export$f857a07c5bd323b8 = (path)=>path.replace(/[\\/]{2,}/g, "/");
const $f1195701c85e5ce2$export$86d9a7913e44197e = (paths)=>$f1195701c85e5ce2$export$f857a07c5bd323b8(paths.join("/"));
function $f1195701c85e5ce2$export$b6d465111d914331(path, minLength = 0) {
    let end = path.length;
    while(end > minLength && path.charCodeAt(end - 1) === 47)end--;
    return end === path.length ? path : path.slice(0, end);
}
const $f1195701c85e5ce2$export$a5c6d149b50c1d86 = (pathname)=>$f1195701c85e5ce2$export$b6d465111d914331(pathname).replace(/^\/*/, "/");
const $f1195701c85e5ce2$var$normalizeSearch = (search)=>!search || search === "?" ? "" : search.startsWith("?") ? search : "?" + search;
const $f1195701c85e5ce2$var$normalizeHash = (hash)=>!hash || hash === "#" ? "" : hash.startsWith("#") ? hash : "#" + hash;
var $f1195701c85e5ce2$var$DataWithResponseInit = class {
    constructor(data, init){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "type", "DataWithResponseInit");
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "data", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "init", void 0);
        this.data = data;
        this.init = init || null;
    }
};
/**
* Create "responses" that contain `headers`/`status` without forcing
* serialization into an actual [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
*
* @example
* import { data } from "react-router";
*
* export async function action({ request }: Route.ActionArgs) {
*   let formData = await request.formData();
*   let item = await createItem(formData);
*   return data(item, {
*     headers: { "X-Custom-Header": "value" }
*     status: 201,
*   });
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param data The data to be included in the response.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A {@link DataWithResponseInit} instance containing the data and
* response init.
*/ function $f1195701c85e5ce2$export$4051a07651545597(data, init) {
    return new $f1195701c85e5ce2$var$DataWithResponseInit(data, typeof init === "number" ? {
        status: init
    } : init);
}
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response).
* Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* @example
* import { redirect } from "react-router";
*
* export async function loader({ request }: Route.LoaderArgs) {
*   if (!isLoggedIn(request))
*     throw redirect("/login");
*   }
*
*   // ...
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $f1195701c85e5ce2$export$89e12c5b50f7529d = (url, init = 302)=>{
    let responseInit = init;
    if (typeof responseInit === "number") responseInit = {
        status: responseInit
    };
    else if (typeof responseInit.status === "undefined") responseInit.status = 302;
    let headers = new Headers(responseInit.headers);
    headers.set("Location", url);
    return new Response(null, {
        ...responseInit,
        headers: headers
    });
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will force a document reload to the new location. Sets the status code
* and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* This utility accepts absolute URLs and can navigate to external domains, so
* the application should validate any user-supplied inputs to redirects.
*
* ```tsx filename=routes/logout.tsx
* import { redirectDocument } from "react-router";
*
* import { destroySession } from "../sessions.server";
*
* export async function action({ request }: Route.ActionArgs) {
*   let session = await getSession(request.headers.get("Cookie"));
*   return redirectDocument("/", {
*     headers: { "Set-Cookie": await destroySession(session) }
*   });
* }
* ```
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $f1195701c85e5ce2$export$a6cd19cd1951a23c = (url, init)=>{
    let response = $f1195701c85e5ce2$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Reload-Document", "true");
    return response;
};
/**
* A redirect [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* that will perform a [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState)
* instead of a [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* for client-side navigation redirects. Sets the status code and the [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header. Defaults to [`302 Found`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Status/302).
*
* @example
* import { replace } from "react-router";
*
* export async function loader() {
*   return replace("/new-location");
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param url The URL to redirect to.
* @param init The status code or a `ResponseInit` object to be included in the
* response.
* @returns A [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* object with the redirect status and [`Location`](https://developer.mozilla.org/en-US/docs/Web/HTTP/Headers/Location)
* header.
*/ const $f1195701c85e5ce2$export$77ad94ebf1c2b9ed = (url, init)=>{
    let response = $f1195701c85e5ce2$export$89e12c5b50f7529d(url, init);
    response.headers.set("X-Remix-Replace", "true");
    return response;
};
const $f1195701c85e5ce2$export$1a235bd2b33434e5 = [
    "EvalError",
    "RangeError",
    "ReferenceError",
    "SyntaxError",
    "TypeError",
    "URIError"
];
var $f1195701c85e5ce2$export$f2680fa305b734ca = class {
    constructor(status, statusText, data, internal = false){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "status", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "statusText", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "data", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "error", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "internal", void 0);
        this.status = status;
        this.statusText = statusText || "";
        this.internal = internal;
        if (data instanceof Error) {
            this.data = data.toString();
            this.error = data;
        } else this.data = data;
    }
};
/**
* Check if the given error is an {@link ErrorResponse} generated from a 4xx/5xx
* [`Response`](https://developer.mozilla.org/en-US/docs/Web/API/Response)
* thrown from an [`action`](../../start/framework/route-module#action) or
* [`loader`](../../start/framework/route-module#loader) function.
*
* @example
* import { isRouteErrorResponse } from "react-router";
*
* export function ErrorBoundary({ error }: Route.ErrorBoundaryProps) {
*   if (isRouteErrorResponse(error)) {
*     return (
*       <>
*         <p>Error: `${error.status}: ${error.statusText}`</p>
*         <p>{error.data}</p>
*       </>
*     );
*   }
*
*   return (
*     <p>Error: {error instanceof Error ? error.message : "Unknown Error"}</p>
*   );
* }
*
* @public
* @category Utils
* @mode framework
* @mode data
* @param error The error to check.
* @returns `true` if the error is an {@link ErrorResponse}, `false` otherwise.
*/ function $f1195701c85e5ce2$export$972111febbeef05b(error) {
    return error != null && typeof error.status === "number" && typeof error.statusText === "string" && typeof error.internal === "boolean" && "data" in error;
}
function $f1195701c85e5ce2$export$d738435097971c09(matches) {
    return $f1195701c85e5ce2$export$86d9a7913e44197e(matches.map((m)=>m.route.path).filter(Boolean)) || "/";
}
function $f1195701c85e5ce2$export$141d98e45b4b08e4(request, path) {
    let url = new URL(typeof request === "string" || request instanceof URL ? request : request.url);
    let parsed = typeof path === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(path) : path;
    url.pathname = parsed.pathname || "/";
    if (parsed.search) {
        let searchParams = new URLSearchParams(parsed.search);
        let indexValues = searchParams.getAll("index");
        searchParams.delete("index");
        for (let value of indexValues.filter(Boolean))searchParams.append("index", value);
        let search = searchParams.toString();
        url.search = search ? `?${search}` : "";
    } else url.search = "";
    url.hash = parsed.hash || "";
    return url;
}
const $f1195701c85e5ce2$export$4e09c449d6c407f7 = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
function $f1195701c85e5ce2$export$ac5aeb949e84fd96(_to, basename) {
    let to = _to;
    if (typeof to !== "string" || !(0, $d4078e32874468f1$export$6c52c2011d568bd0).test(to)) return {
        absoluteURL: void 0,
        isExternal: false,
        to: to
    };
    let absoluteURL = to;
    let isExternal = false;
    if ($f1195701c85e5ce2$export$4e09c449d6c407f7) try {
        let currentUrl = new URL(window.location.href);
        let targetUrl = (0, $d4078e32874468f1$export$825a82322d91916e).test(to) ? new URL((0, $d4078e32874468f1$export$977999b735cd4f26)(to, currentUrl.protocol)) : new URL(to);
        let path = $f1195701c85e5ce2$export$b69e3301ce081aa3(targetUrl.pathname, basename);
        if (targetUrl.origin === currentUrl.origin && path != null) to = path + targetUrl.search + targetUrl.hash;
        else isExternal = true;
    } catch  {
        (0, $072a56029499ae6c$export$491112666e282270)(false, `<Link to="${to}"> contains an invalid URL which will probably break when clicked - please update to a valid URL path.`);
    }
    return {
        absoluteURL: absoluteURL,
        isExternal: isExternal,
        to: to
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

function $52c7d6e235e2a936$export$71511d61b312f219(receiver, descriptor, value) {
    if (descriptor.set) descriptor.set.call(receiver, value);
    else {
        if (!descriptor.writable) // This should only throw in strict mode, but class bodies are
        // always strict and private fields can only be used inside
        // class bodies.
        throw new TypeError("attempted to set read only private field");
        descriptor.value = value;
    }
}



function $4e65168814c8101e$export$71511d61b312f219(receiver, privateMap, value) {
    var descriptor = (0, $37860ab55d7a31e0$export$71511d61b312f219)(receiver, privateMap, "set");
    (0, $52c7d6e235e2a936$export$71511d61b312f219)(receiver, descriptor, value);
    return value;
}





/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region lib/router/instrumentation.ts
const $faa62a10fd016f72$var$UninstrumentedSymbol = Symbol("Uninstrumented");
const $faa62a10fd016f72$export$b1aab28b8e9d7d25 = (0, $f1195701c85e5ce2$export$fd42f52fd3ae1109)();
let $faa62a10fd016f72$var$instrumentationClientResultMetaReceivers = /* @__PURE__ */ new WeakMap();
function $faa62a10fd016f72$export$3cb8f5f9ecc770ef(fns, route) {
    let aggregated = {
        lazy: [],
        "lazy.loader": [],
        "lazy.action": [],
        "lazy.middleware": [],
        middleware: [],
        loader: [],
        action: []
    };
    fns.forEach((fn)=>fn({
            id: route.id,
            index: route.index,
            path: route.path,
            instrument (i) {
                if (i.lazy != null) aggregated.lazy.push(i.lazy);
                if (i["lazy.loader"] != null) aggregated["lazy.loader"].push(i["lazy.loader"]);
                if (i["lazy.action"] != null) aggregated["lazy.action"].push(i["lazy.action"]);
                if (i["lazy.middleware"] != null) aggregated["lazy.middleware"].push(i["lazy.middleware"]);
                if (i.middleware != null) aggregated.middleware.push(i.middleware);
                if (i.loader != null) aggregated.loader.push(i.loader);
                if (i.action != null) aggregated.action.push(i.action);
            }
        }));
    let updates = {};
    if (typeof route.lazy === "function" && aggregated.lazy.length > 0) {
        let lazy = route.lazy;
        updates.lazy = async (...args)=>{
            return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.lazy, void 0, ()=>lazy(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
        };
    }
    if (typeof route.lazy === "object") {
        let lazyObject = route.lazy;
        if (typeof lazyObject.middleware === "function" && aggregated["lazy.middleware"].length > 0) {
            let middleware = lazyObject.middleware;
            updates.lazy = Object.assign(updates.lazy || {}, {
                middleware: async (...args)=>{
                    return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated["lazy.middleware"], void 0, ()=>middleware(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.loader === "function" && aggregated["lazy.loader"].length > 0) {
            let loader = lazyObject.loader;
            updates.lazy = Object.assign(updates.lazy || {}, {
                loader: async (...args)=>{
                    return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated["lazy.loader"], void 0, ()=>loader(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
                }
            });
        }
        if (typeof lazyObject.action === "function" && aggregated["lazy.action"].length > 0) {
            let action = lazyObject.action;
            updates.lazy = Object.assign(updates.lazy || {}, {
                action: async (...args)=>{
                    return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated["lazy.action"], void 0, ()=>action(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
                }
            });
        }
    }
    if (typeof route.loader === "function" && aggregated.loader.length > 0) {
        let original = $faa62a10fd016f72$var$getUninstrumentedHandler(route.loader);
        let instrumented = async (...args)=>{
            return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.loader, $faa62a10fd016f72$var$getHandlerInfo(args[0]), ()=>original(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
        };
        if (original.hydrate === true) instrumented.hydrate = true;
        $faa62a10fd016f72$var$setUninstrumentedHandler(instrumented, original);
        updates.loader = instrumented;
    }
    if (typeof route.action === "function" && aggregated.action.length > 0) {
        let original = $faa62a10fd016f72$var$getUninstrumentedHandler(route.action);
        let instrumented = async (...args)=>{
            return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.action, $faa62a10fd016f72$var$getHandlerInfo(args[0]), ()=>original(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
        };
        $faa62a10fd016f72$var$setUninstrumentedHandler(instrumented, original);
        updates.action = instrumented;
    }
    if (route.middleware && route.middleware.length > 0 && aggregated.middleware.length > 0) updates.middleware = route.middleware.map((middleware)=>{
        let original = $faa62a10fd016f72$var$getUninstrumentedHandler(middleware);
        let instrumented = async (...args)=>{
            return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.middleware, $faa62a10fd016f72$var$getHandlerInfo(args[0]), ()=>original(...args), $faa62a10fd016f72$var$getInstrumentationInnerResult));
        };
        $faa62a10fd016f72$var$setUninstrumentedHandler(instrumented, original);
        return instrumented;
    });
    return updates;
}
function $faa62a10fd016f72$export$ac4df491f31cbbfc(router, fns) {
    let aggregated = {
        navigate: [],
        fetch: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.navigate != null) aggregated.navigate.push(i.navigate);
                if (i.fetch != null) aggregated.fetch.push(i.fetch);
            }
        }));
    if (aggregated.navigate.length > 0) {
        let navigate = $faa62a10fd016f72$var$getUninstrumentedHandler(router.navigate);
        let instrumentedNavigate = async (...args)=>{
            let [to, opts] = args;
            let meta;
            let info = {
                to: typeof to === "number" || typeof to === "string" ? to : to ? (0, $072a56029499ae6c$export$fe53371bee54353d)(to) : ".",
                ...$faa62a10fd016f72$var$getRouterInfo(router, opts ?? {})
            };
            return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.navigate, info, async ()=>{
                if (typeof to === "number") return await navigate(...args);
                let cleanup = $faa62a10fd016f72$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await navigate(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$faa62a10fd016f72$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $faa62a10fd016f72$var$setUninstrumentedHandler(instrumentedNavigate, navigate);
        router.navigate = instrumentedNavigate;
    }
    if (aggregated.fetch.length > 0) {
        let fetch = $faa62a10fd016f72$var$getUninstrumentedHandler(router.fetch);
        let instrumentedFetch = async (...args)=>{
            let [key, _, href, opts] = args;
            let meta;
            return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.fetch, {
                href: href ?? ".",
                fetcherKey: key,
                ...$faa62a10fd016f72$var$getRouterInfo(router, opts ?? {})
            }, async ()=>{
                let cleanup = $faa62a10fd016f72$var$setInstrumentationClientResultMetaReceiver(router, (value)=>{
                    meta = value;
                });
                try {
                    return await fetch(...args);
                } finally{
                    cleanup();
                }
            }, (result)=>({
                    ...$faa62a10fd016f72$var$getInstrumentationInnerResult(result),
                    meta: meta
                })));
        };
        $faa62a10fd016f72$var$setUninstrumentedHandler(instrumentedFetch, fetch);
        router.fetch = instrumentedFetch;
    }
    return router;
}
function $faa62a10fd016f72$export$8f7a8e481272777(handler, fns) {
    let aggregated = {
        request: []
    };
    fns.forEach((fn)=>fn({
            instrument (i) {
                if (i.request != null) aggregated.request.push(i.request);
            }
        }));
    let instrumentedHandler = handler;
    if (aggregated.request.length > 0) instrumentedHandler = async (...args)=>{
        let [request, context] = args;
        let instrumentationContext = context ?? new (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04)();
        return $faa62a10fd016f72$var$throwOrReturnResult(await $faa62a10fd016f72$var$recurseRight(aggregated.request, {
            request: $faa62a10fd016f72$var$getReadonlyRequest(request),
            context: $faa62a10fd016f72$var$getReadonlyContext(instrumentationContext)
        }, ()=>handler(request, instrumentationContext), (result, info)=>{
            let meta;
            try {
                meta = info.context?.get($faa62a10fd016f72$export$b1aab28b8e9d7d25);
            } catch  {}
            (0, $072a56029499ae6c$export$f5708dca728d7177)(result.value instanceof Response, "Expected a Response from the request handler");
            return {
                ...$faa62a10fd016f72$var$getInstrumentationInnerResult(result),
                statusCode: result.value.status,
                meta: meta
            };
        }));
    };
    return instrumentedHandler;
}
function $faa62a10fd016f72$var$getUninstrumentedHandler(handler) {
    return handler[$faa62a10fd016f72$var$UninstrumentedSymbol] ?? handler;
}
function $faa62a10fd016f72$var$setUninstrumentedHandler(handler, uninstrumentedHandler) {
    handler[$faa62a10fd016f72$var$UninstrumentedSymbol] = uninstrumentedHandler;
}
function $faa62a10fd016f72$var$setInstrumentationClientResultMetaReceiver(router, receiver) {
    $faa62a10fd016f72$var$instrumentationClientResultMetaReceivers.set(router, receiver);
    return ()=>{
        if ($faa62a10fd016f72$var$instrumentationClientResultMetaReceivers.get(router) === receiver) $faa62a10fd016f72$var$instrumentationClientResultMetaReceivers.delete(router);
    };
}
function $faa62a10fd016f72$export$5579798e35f5560e(router) {
    let receiver = $faa62a10fd016f72$var$instrumentationClientResultMetaReceivers.get(router);
    $faa62a10fd016f72$var$instrumentationClientResultMetaReceivers.delete(router);
    return receiver;
}
function $faa62a10fd016f72$var$throwOrReturnResult(result) {
    if (result.type === "error") throw result.value;
    return result.value;
}
async function $faa62a10fd016f72$var$recurseRight(impls, info, handler, getInnerResult, state = {
    result: null,
    innerResult: null
}, index = impls.length - 1) {
    let impl = impls[index];
    if (!impl) {
        try {
            state.result = {
                type: "success",
                value: await handler()
            };
        } catch (e) {
            state.result = {
                type: "error",
                value: e
            };
        }
        state.innerResult = getInnerResult(state.result, info);
    } else {
        let handlerPromise = void 0;
        let callHandler = async ()=>{
            if (handlerPromise) console.error("You cannot call instrumented handlers more than once");
            else handlerPromise = $faa62a10fd016f72$var$recurseRight(impls, info, handler, getInnerResult, state, index - 1);
            await handlerPromise;
            (0, $072a56029499ae6c$export$f5708dca728d7177)(state.innerResult, "Expected an inner result");
            return state.innerResult;
        };
        try {
            await impl(callHandler, info);
        } catch (e) {
            console.error("An instrumentation function threw an error:", e);
        }
        if (!handlerPromise) await callHandler();
        await handlerPromise;
    }
    if (state.result) return state.result;
    state.result = {
        type: "error",
        value: /* @__PURE__ */ new Error("No result assigned in instrumentation chain.")
    };
    state.innerResult = getInnerResult(state.result, info);
    return state.result;
}
function $faa62a10fd016f72$var$getInstrumentationInnerResult(result) {
    if (result.type === "error" && result.value instanceof Error) return {
        status: "error",
        error: result.value
    };
    return {
        status: "success",
        error: void 0
    };
}
function $faa62a10fd016f72$var$getHandlerInfo(args) {
    let { request: request, context: context, params: params } = args;
    return {
        ...args,
        request: $faa62a10fd016f72$var$getReadonlyRequest(request),
        params: {
            ...params
        },
        context: $faa62a10fd016f72$var$getReadonlyContext(context)
    };
}
function $faa62a10fd016f72$var$getRouterInfo(router, opts) {
    return {
        currentUrl: (0, $072a56029499ae6c$export$fe53371bee54353d)(router.state.location),
        ..."formMethod" in opts ? {
            formMethod: opts.formMethod
        } : {},
        ..."formEncType" in opts ? {
            formEncType: opts.formEncType
        } : {},
        ..."formData" in opts ? {
            formData: opts.formData
        } : {},
        ..."body" in opts ? {
            body: opts.body
        } : {}
    };
}
function $faa62a10fd016f72$var$getReadonlyRequest(request) {
    return {
        method: request.method,
        url: request.url,
        headers: {
            get: (...args)=>request.headers.get(...args)
        }
    };
}
function $faa62a10fd016f72$var$getReadonlyContext(context) {
    return {
        get: (ctx)=>context.get(ctx)
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



var $63ab57b16d380f6c$var$_routes, $63ab57b16d380f6c$var$_branches, $63ab57b16d380f6c$var$_basename;
//#region lib/router/matcher.ts
var $63ab57b16d380f6c$export$92541312f2982378 = ($63ab57b16d380f6c$var$_routes = /*#__PURE__*/ new WeakMap(), $63ab57b16d380f6c$var$_branches = /*#__PURE__*/ new WeakMap(), $63ab57b16d380f6c$var$_basename = /*#__PURE__*/ new WeakMap(), class {
    update(routes) {
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_routes, routes);
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_branches, (0, $f1195701c85e5ce2$export$e486c0390e42ccf6)(routes));
    }
    match(locationArg, allowPartial = false) {
        return (0, $f1195701c85e5ce2$export$5c7b09132f833c25)((0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_routes), locationArg, (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_basename), allowPartial, (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_branches));
    }
    constructor(basename){
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_routes, {
            writable: true,
            value: []
        });
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_branches, {
            writable: true,
            value: []
        });
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_basename, {
            writable: true,
            value: void 0
        });
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $63ab57b16d380f6c$var$_basename, basename);
    }
});


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 










/**
 * Split a route pattern into protocol, hostname, port, pathname, and search
 * spans delimited as `protocol://hostname:port/pathname?search`.
 *
 * Delimiters are not included in the spans with the exception of the leading `/` for pathname.
 * Spans are [begin (inclusive), end (exclusive)].
 *
 * @param source the route pattern string to split
 * @returns an object containing spans for each URL component
 */ function $63052cd76764856d$export$65980d18b75784e2(source) {
    let result = {
        protocol: null,
        hostname: null,
        port: null,
        pathname: null,
        search: null
    };
    let questionMarkIndex = source.indexOf('?');
    if (questionMarkIndex !== -1) {
        result.search = $63052cd76764856d$var$span(questionMarkIndex + 1, source.length);
        source = source.slice(0, questionMarkIndex);
    }
    let solidusIndex = source.indexOf('://');
    if (solidusIndex === -1) {
        result.pathname = $63052cd76764856d$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    let slashIndex = source.indexOf('/');
    if (slashIndex === solidusIndex + 1) slashIndex = source.indexOf('/', solidusIndex + 3);
    if (slashIndex === -1) {
        result.protocol = $63052cd76764856d$var$span(0, solidusIndex);
        let host = $63052cd76764856d$var$span(solidusIndex + 3, source.length);
        if (host) {
            let { hostname: hostname, port: port } = $63052cd76764856d$var$hostSpans(source, host);
            result.hostname = hostname;
            result.port = port;
        }
        return result;
    }
    if (slashIndex < solidusIndex) {
        result.pathname = $63052cd76764856d$var$pathnameSpan(source, 0, source.length);
        return result;
    }
    result.protocol = $63052cd76764856d$var$span(0, solidusIndex);
    let host = $63052cd76764856d$var$span(solidusIndex + 3, slashIndex);
    if (host) {
        let { hostname: hostname, port: port } = $63052cd76764856d$var$hostSpans(source, host);
        result.hostname = hostname;
        result.port = port;
    }
    result.pathname = $63052cd76764856d$var$pathnameSpan(source, slashIndex, source.length);
    return result;
}
function $63052cd76764856d$var$span(start, end) {
    if (start === end) return null;
    return [
        start,
        end
    ];
}
function $63052cd76764856d$var$hostSpans(source, host) {
    let lastColonIndex = source.slice(0, host[1]).lastIndexOf(':');
    if (lastColonIndex === -1 || lastColonIndex < host[0]) return {
        hostname: host,
        port: null
    };
    if (source.slice(lastColonIndex + 1, host[1]).match(/^\d+$/)) return {
        hostname: $63052cd76764856d$var$span(host[0], lastColonIndex),
        port: $63052cd76764856d$var$span(lastColonIndex + 1, host[1])
    };
    return {
        hostname: host,
        port: null
    };
}
function $63052cd76764856d$var$pathnameSpan(source, begin, end) {
    if (source[begin] === '/') begin += 1;
    return $63052cd76764856d$var$span(begin, end);
}



const $a6dab0a9914312f3$var$IDENTIFIER_RE = /^[a-zA-Z_$][a-zA-Z_$0-9]*/;
function $a6dab0a9914312f3$export$e26190e3669abbfe(source) {
    let spans = (0, $63052cd76764856d$export$65980d18b75784e2)(source);
    return new (0, $2a0daba9d2562f69$export$2917961db0dd6e8b)({
        protocol: $a6dab0a9914312f3$var$parseProtocol(source, spans.protocol),
        hostname: $a6dab0a9914312f3$var$parseHostname(source, spans.hostname),
        port: spans.port ? source.slice(...spans.port) : null,
        pathname: spans.pathname ? $a6dab0a9914312f3$export$6681bda78b6b4cbd(source, {
            span: spans.pathname,
            type: 'pathname'
        }) : $a6dab0a9914312f3$export$6681bda78b6b4cbd('', {
            span: [
                0,
                0
            ],
            type: 'pathname'
        }),
        search: spans.search ? $a6dab0a9914312f3$var$parseSearch(source.slice(...spans.search)) : new Map()
    });
}
function $a6dab0a9914312f3$export$6681bda78b6b4cbd(source, options) {
    let span = options.span ?? [
        0,
        source.length
    ];
    let separator = options.type === 'hostname' ? '.' : '/';
    let tokens = [];
    let optionals = new Map();
    let appendText = (text)=>{
        let currentToken = tokens.at(-1);
        if (currentToken?.type === 'text') currentToken.text += text;
        else tokens.push({
            type: 'text',
            text: text
        });
    };
    let i = span[0];
    let optionalStack = [];
    while(i < span[1]){
        let char = source[i];
        if (char === '(') {
            optionalStack.push(tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ')') {
            let begin = optionalStack.pop();
            if (begin === undefined) throw new $a6dab0a9914312f3$export$f9c837a54db411d('unmatched )', source, i);
            optionals.set(begin, tokens.length);
            tokens.push({
                type: char
            });
            i += 1;
            continue;
        }
        if (char === ':') {
            i += 1;
            let name = $a6dab0a9914312f3$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            if (!name) throw new $a6dab0a9914312f3$export$f9c837a54db411d('missing variable name', source, i - 1);
            tokens.push({
                type: ':',
                name: name
            });
            i += name.length;
            continue;
        }
        if (char === '*') {
            i += 1;
            let name = $a6dab0a9914312f3$var$IDENTIFIER_RE.exec(source.slice(i, span[1]))?.[0];
            tokens.push({
                type: '*',
                name: name ?? '*'
            });
            i += name?.length ?? 0;
            continue;
        }
        if (char === separator) {
            tokens.push({
                type: 'separator'
            });
            i += 1;
            continue;
        }
        if (char === '\\') {
            if (i + 1 === span[1]) throw new $a6dab0a9914312f3$export$f9c837a54db411d('dangling escape', source, i);
            let text = source.slice(i + 1, i + 2);
            appendText(text);
            i += 2;
            continue;
        }
        appendText(char);
        i += 1;
    }
    if (optionalStack.length > 0) throw new $a6dab0a9914312f3$export$f9c837a54db411d('unmatched (', source, optionalStack.at(-1));
    return {
        tokens: tokens,
        optionals: optionals,
        type: options.type
    };
}
function $a6dab0a9914312f3$var$parseProtocol(source, span) {
    if (!span) return null;
    let protocol = source.slice(...span);
    if (protocol === '' || protocol === 'http' || protocol === 'https' || protocol === 'http(s)') return protocol === '' ? null : protocol;
    throw new $a6dab0a9914312f3$export$f9c837a54db411d('invalid protocol', source, span[0]);
}
function $a6dab0a9914312f3$var$parseHostname(source, span) {
    if (!span) return null;
    let part = $a6dab0a9914312f3$export$6681bda78b6b4cbd(source, {
        span: span,
        type: 'hostname'
    });
    if ($a6dab0a9914312f3$var$isNamelessWildcard(part)) return null;
    return part;
}
function $a6dab0a9914312f3$var$isNamelessWildcard(part) {
    if (part.tokens.length !== 1) return false;
    let token = part.tokens[0];
    if (token.type !== '*') return false;
    return token.name === '*';
}
function $a6dab0a9914312f3$var$parseSearch(source) {
    let constraints = new Map();
    let searchParams = new URLSearchParams(source);
    for (let [key, value] of searchParams){
        let requiredValues = constraints.get(key);
        if (!requiredValues) {
            requiredValues = new Set();
            constraints.set(key, requiredValues);
        }
        if (value === '') continue;
        requiredValues.add(value);
    }
    return constraints;
}
class $a6dab0a9914312f3$export$f9c837a54db411d extends Error {
    constructor(type, source, index){
        let underline = ' '.repeat(index) + '^';
        let message = `${type}\n\n${source}\n${underline}`;
        super(message), /** The parse failure category. */ (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "type", void 0), /** Original pattern source being parsed. */ (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "source", void 0), /** Character index where parsing failed. */ (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "index", void 0);
        this.name = 'ParseError';
        this.type = type;
        this.source = source;
        this.index = index;
    }
}


/**
 * An internal error that should never happen.
 *
 * @param value Typed as `never` to ensure exhaustiveness for discriminated unions.
 */ function $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4(value) {
    let message = value === undefined ? 'Unreachable' : `Unreachable: ${value}`;
    throw new Error(message);
}


function $7b8589807451483d$export$f54f830b0caf58b(pattern) {
    let protocol = $7b8589807451483d$export$f5782abab8870711(pattern);
    let hostname = $7b8589807451483d$export$191bef10f978d68f(pattern);
    let port = $7b8589807451483d$export$776a5d5828862b2f(pattern);
    let pathname = $7b8589807451483d$export$a2dfe5fa28b7cbe3(pattern);
    let search = $7b8589807451483d$export$3ba2b473bde2deb8(pattern);
    let result = '';
    if (protocol || hostname || port) result += `${protocol}://${hostname}${port === '' ? '' : `:${port}`}`;
    result += '/' + pathname;
    if (search) result += `?${search}`;
    return result;
}
function $7b8589807451483d$export$161f896add7aeb90(pattern) {
    return {
        protocol: $7b8589807451483d$export$f5782abab8870711(pattern),
        hostname: $7b8589807451483d$export$191bef10f978d68f(pattern),
        port: $7b8589807451483d$export$776a5d5828862b2f(pattern),
        pathname: $7b8589807451483d$export$a2dfe5fa28b7cbe3(pattern),
        search: $7b8589807451483d$export$3ba2b473bde2deb8(pattern)
    };
}
function $7b8589807451483d$export$f5782abab8870711(pattern) {
    return pattern.protocol ?? '';
}
function $7b8589807451483d$export$191bef10f978d68f(pattern) {
    return pattern.hostname ? $7b8589807451483d$export$4d98ccdba8645223(pattern.hostname) : '';
}
function $7b8589807451483d$export$776a5d5828862b2f(pattern) {
    return pattern.port ?? '';
}
function $7b8589807451483d$export$a2dfe5fa28b7cbe3(pattern) {
    return $7b8589807451483d$export$4d98ccdba8645223(pattern.pathname);
}
function $7b8589807451483d$export$3ba2b473bde2deb8(pattern) {
    if (pattern.search.size === 0) return '';
    let searchParams = new URLSearchParams();
    for (let [key, constraint] of pattern.search){
        if (constraint.size === 0) searchParams.append(key, '');
        else for (let value of constraint)searchParams.append(key, value);
    }
    return searchParams.toString();
}
function $7b8589807451483d$var$escapeText(text) {
    return text.replaceAll(/[:*()\\]/g, '\\$&');
}
function $7b8589807451483d$export$4d98ccdba8645223(part) {
    let separator = part.type === 'hostname' ? '.' : '/';
    let result = '';
    for (let token of part.tokens){
        if (token.type === '(' || token.type === ')') {
            result += token.type;
            continue;
        }
        if (token.type === 'text') {
            result += $7b8589807451483d$var$escapeText(token.text);
            continue;
        }
        if (token.type === ':' || token.type === '*') {
            let name = token.name === '*' ? '' : token.name;
            result += `${token.type}${name}`;
            continue;
        }
        if (token.type === 'separator') {
            result += separator;
            continue;
        }
        (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}


class $2a0daba9d2562f69$export$2917961db0dd6e8b {
    /**
     * Create a new `RoutePattern` by parsing a source string.
     *
     * @param source The route pattern source string.
     * @returns The parsed route pattern.
     */ static parse(source) {
        return (0, $a6dab0a9914312f3$export$e26190e3669abbfe)(source);
    }
    /** Normalized string representation of this pattern */ get source() {
        return (0, $7b8589807451483d$export$f54f830b0caf58b)(this);
    }
    /**
     * Returns a string representing this route pattern.
     *
     * @returns The same normalized pattern string as `RoutePattern.source`.
     */ toString() {
        return this.source;
    }
    /**
     * Returns a JSON-serializable object containing each serialized part of this route pattern.
     *
     * @returns The serialized protocol, hostname, port, pathname, and search.
     */ toJSON() {
        return (0, $7b8589807451483d$export$161f896add7aeb90)(this);
    }
    /**
     * Create a new `RoutePattern` from parsed parts of a route pattern.
     *
     * Useful for efficiently deriving new patterns from already parsed patterns.
     * Unless you know what you are doing, you probably want `RoutePattern.parse`.
     *
     * @param parsed Parsed route pattern parts.
     */ constructor(parsed){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "protocol", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "hostname", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "port", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "pathname", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "search", void 0);
        this.protocol = parsed.protocol;
        this.hostname = parsed.hostname;
        this.port = parsed.port;
        this.pathname = parsed.pathname;
        this.search = parsed.search;
    }
}







// Adapted from https://github.com/mathiasbynens/punycode.js/blob/9e1b2cda98d215d3a73fcbfe93c62e021f4ba768/punycode.js
/** Highest positive signed 32-bit float value */ const $9fa0064812d1b5a5$var$maxInt = 2147483647; // aka. 0x7FFFFFFF or 2^31-1
/** Bootstring parameters */ const $9fa0064812d1b5a5$var$base = 36;
const $9fa0064812d1b5a5$var$tMin = 1;
const $9fa0064812d1b5a5$var$tMax = 26;
const $9fa0064812d1b5a5$var$skew = 38;
const $9fa0064812d1b5a5$var$damp = 700;
const $9fa0064812d1b5a5$var$initialBias = 72;
const $9fa0064812d1b5a5$var$initialN = 128; // 0x80
const $9fa0064812d1b5a5$var$delimiter = '-'; // '\x2D'
/** Regular expressions */ const $9fa0064812d1b5a5$var$regexSeparators = /[\x2E\u3002\uFF0E\uFF61]/g; // RFC 3490 separators
/** Error messages */ const $9fa0064812d1b5a5$var$errors = {
    overflow: 'Overflow: input needs wider integers to process',
    'not-basic': 'Illegal input >= 0x80 (not a basic code point)',
    'invalid-input': 'Invalid input'
};
const $9fa0064812d1b5a5$var$baseMinusTMin = $9fa0064812d1b5a5$var$base - $9fa0064812d1b5a5$var$tMin;
/*--------------------------------------------------------------------------*/ /**
 * A generic error utility function.
 * @param type The error type.
 */ function $9fa0064812d1b5a5$var$error(type) {
    throw new RangeError($9fa0064812d1b5a5$var$errors[type]);
}
/**
 * A simple `Array#map`-like wrapper to work with domain name strings or email
 * addresses.
 * @param domain The domain name or email address.
 * @param callback The function that gets called for every character.
 * @returns A new string of characters returned by the callback function.
 */ function $9fa0064812d1b5a5$var$mapDomain(domain, callback) {
    let parts = domain.split('@');
    let result = '';
    if (parts.length > 1) {
        // In email addresses, only the domain name should be punycoded. Leave
        // the local part (i.e. everything up to `@`) intact.
        result = parts[0] + '@';
        domain = parts[1];
    }
    domain = domain.replace($9fa0064812d1b5a5$var$regexSeparators, '.');
    let labels = domain.split('.');
    let encoded = labels.map(callback).join('.');
    return result + encoded;
}
/**
 * Converts a basic code point into a digit/integer.
 * @see `digitToBasic()`
 * @param codePoint The basic numeric code point value.
 * @returns The numeric value of a basic code point in the range `0` to
 * `base - 1`, or `base` if the code point does not represent a value.
 */ function $9fa0064812d1b5a5$var$basicToDigit(codePoint) {
    if (codePoint >= 0x30 && codePoint < 0x3a) return 26 + (codePoint - 0x30);
    if (codePoint >= 0x41 && codePoint < 0x5b) return codePoint - 0x41;
    if (codePoint >= 0x61 && codePoint < 0x7b) return codePoint - 0x61;
    return $9fa0064812d1b5a5$var$base;
}
/**
 * Bias adaptation function as per section 3.4 of RFC 3492.
 * https://tools.ietf.org/html/rfc3492#section-3.4
 * @param delta The current delta.
 * @param numPoints The number of code points handled.
 * @param firstTime Whether this is the first adaptation.
 * @returns The adapted bias.
 */ function $9fa0064812d1b5a5$var$adapt(delta, numPoints, firstTime) {
    let k = 0;
    delta = firstTime ? Math.floor(delta / $9fa0064812d1b5a5$var$damp) : delta >> 1;
    delta += Math.floor(delta / numPoints);
    for(; delta > $9fa0064812d1b5a5$var$baseMinusTMin * $9fa0064812d1b5a5$var$tMax >> 1; k += $9fa0064812d1b5a5$var$base)delta = Math.floor(delta / $9fa0064812d1b5a5$var$baseMinusTMin);
    return Math.floor(k + ($9fa0064812d1b5a5$var$baseMinusTMin + 1) * delta / (delta + $9fa0064812d1b5a5$var$skew));
}
/**
 * Converts a Punycode string of ASCII-only symbols to a string of Unicode
 * symbols.
 * @param input The Punycode string of ASCII-only symbols.
 * @returns The resulting string of Unicode symbols.
 */ function $9fa0064812d1b5a5$var$decode(input) {
    // Don't use UCS-2.
    let output = [];
    let inputLength = input.length;
    let i = 0;
    let n = $9fa0064812d1b5a5$var$initialN;
    let bias = $9fa0064812d1b5a5$var$initialBias;
    // Handle the basic code points: let `basic` be the number of input code
    // points before the last delimiter, or `0` if there is none, then copy
    // the first basic code points to the output.
    let basic = input.lastIndexOf($9fa0064812d1b5a5$var$delimiter);
    if (basic < 0) basic = 0;
    for(let j = 0; j < basic; ++j){
        // if it's not a basic code point
        if (input.charCodeAt(j) >= 0x80) $9fa0064812d1b5a5$var$error('not-basic');
        output.push(input.charCodeAt(j));
    }
    // Main decoding loop: start just after the last delimiter if any basic code
    // points were copied; start at the beginning otherwise.
    for(let index = basic > 0 ? basic + 1 : 0; index < inputLength /* no final expression */ ;){
        // `index` is the index of the next character to be consumed.
        // Decode a generalized variable-length integer into `delta`,
        // which gets added to `i`. The overflow checking is easier
        // if we increase `i` as we go, then subtract off its starting
        // value at the end to obtain `delta`.
        let oldi = i;
        for(let w = 1, k = $9fa0064812d1b5a5$var$base /* no condition */ ;; k += $9fa0064812d1b5a5$var$base){
            if (index >= inputLength) $9fa0064812d1b5a5$var$error('invalid-input');
            let digit = $9fa0064812d1b5a5$var$basicToDigit(input.charCodeAt(index++));
            if (digit >= $9fa0064812d1b5a5$var$base) $9fa0064812d1b5a5$var$error('invalid-input');
            if (digit > Math.floor(($9fa0064812d1b5a5$var$maxInt - i) / w)) $9fa0064812d1b5a5$var$error('overflow');
            i += digit * w;
            let t = k <= bias ? $9fa0064812d1b5a5$var$tMin : k >= bias + $9fa0064812d1b5a5$var$tMax ? $9fa0064812d1b5a5$var$tMax : k - bias;
            if (digit < t) break;
            let baseMinusT = $9fa0064812d1b5a5$var$base - t;
            if (w > Math.floor($9fa0064812d1b5a5$var$maxInt / baseMinusT)) $9fa0064812d1b5a5$var$error('overflow');
            w *= baseMinusT;
        }
        let out = output.length + 1;
        bias = $9fa0064812d1b5a5$var$adapt(i - oldi, out, oldi === 0);
        // `i` was supposed to wrap around from `out` to `0`,
        // incrementing `n` each time, so we'll fix that now:
        if (Math.floor(i / out) > $9fa0064812d1b5a5$var$maxInt - n) $9fa0064812d1b5a5$var$error('overflow');
        n += Math.floor(i / out);
        i %= out;
        // Insert `n` at position `i` of the output.
        output.splice(i++, 0, n);
    }
    return String.fromCodePoint(...output);
}
const $9fa0064812d1b5a5$export$110c810e8727e62b = function(input) {
    // Optimization: skip if no punycode markers found
    if (!input.includes('xn--')) return input;
    return $9fa0064812d1b5a5$var$mapDomain(input, function(string) {
        return string.startsWith('xn--') ? $9fa0064812d1b5a5$var$decode(string.slice(4).toLowerCase()) : string;
    });
};





function $e7359da954dfa76b$export$4e7f196112fea3c5(text) {
    return text.replace(/[.*+?^${}()|[\]\\-]/g, '\\$&');
}
function $e7359da954dfa76b$export$238374f1b270e387(tokens, options) {
    let result = '';
    for (let token of tokens){
        if (token.type === 'text') {
            result += $e7359da954dfa76b$export$4e7f196112fea3c5(token.text);
            continue;
        }
        if (token.type === ':') {
            result += `([^${options.separator}]+?)`;
            continue;
        }
        if (token.type === '*') {
            result += `(.*)`;
            continue;
        }
        if (token.type === '(') {
            result += '(?:';
            continue;
        }
        if (token.type === ')') {
            result += ')?';
            continue;
        }
        if (token.type === 'separator') {
            result += $e7359da954dfa76b$export$4e7f196112fea3c5(options.separator);
            continue;
        }
        (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)(token.type);
    }
    let flags = 'd';
    if (options.ignoreCase) flags += 'i';
    return new RegExp(`^${result}$`, flags);
}



function $e6fe796cbf264e6b$export$9ac16898ad61bc17(pattern) {
    let result = [];
    for (let protocol of $e6fe796cbf264e6b$var$generateProtocolVariants(pattern.protocol)){
        let port = $e6fe796cbf264e6b$var$normalizePort(protocol, pattern.port);
        for (let hostname of $e6fe796cbf264e6b$var$generateHostnameVariants(pattern.hostname))for (let pathname of $e6fe796cbf264e6b$var$generatePathnameVariants(pattern.pathname))result.push({
            protocol: protocol,
            hostname: hostname,
            port: port,
            pathname: pathname
        });
    }
    return result;
}
function $e6fe796cbf264e6b$var$generateProtocolVariants(protocol) {
    if (protocol === null || protocol === 'http(s)') return [
        'http',
        'https'
    ];
    return [
        protocol
    ];
}
function $e6fe796cbf264e6b$var$normalizePort(protocol, port) {
    if (port === null) return '';
    if (protocol === 'http' && port === '80') return '';
    if (protocol === 'https' && port === '443') return '';
    return port;
}
function $e6fe796cbf264e6b$var$toParams(tokens) {
    let params = [];
    for (let token of tokens)if (token.type === ':' || token.type === '*') params.push(token);
    return params;
}
function $e6fe796cbf264e6b$var$generateHostnameVariants(hostname) {
    let result = [];
    if (hostname === null) return [
        {
            type: 'any'
        }
    ];
    for (let variant of $e6fe796cbf264e6b$export$57a1d23d0b7a46c(hostname)){
        let params = $e6fe796cbf264e6b$var$toParams(variant);
        if (params.length > 0) result.push({
            type: 'dynamic',
            params: params,
            regexp: (0, $e7359da954dfa76b$export$238374f1b270e387)(variant, {
                separator: '.',
                ignoreCase: false
            })
        });
        else result.push({
            type: 'static',
            value: $e6fe796cbf264e6b$var$stringifyStatic(variant, '.')
        });
    }
    return result;
}
function $e6fe796cbf264e6b$var$stringifyStatic(variant, separator) {
    let result = '';
    for (let token of variant){
        if (token.type === 'text') result += token.text;
        else if (token.type === 'separator') result += separator;
        else throw new Error(`expected static part variant, got token type '${token.type}'`);
    }
    return result;
}
function $e6fe796cbf264e6b$var$generatePathnameVariants(pathname, options) {
    let result = [];
    let ignoreCase = options?.ignoreCase ?? false;
    for (let tokens of $e6fe796cbf264e6b$export$57a1d23d0b7a46c(pathname)){
        let variant = [];
        let key = '';
        let reSource = '';
        let reFlags = ignoreCase ? 'di' : 'd';
        let type = 'static';
        let params = [];
        for (let token of tokens){
            if (token.type === 'separator') {
                if (type === 'static') {
                    variant.push({
                        type: 'static',
                        key: ignoreCase ? key.toLowerCase() : key
                    });
                    key = '';
                    reSource = '';
                    continue;
                }
                if (type === 'variable') {
                    variant.push({
                        type: 'variable',
                        key: key,
                        regexp: new RegExp(`^${reSource}$`, reFlags),
                        params: params
                    });
                    key = '';
                    reSource = '';
                    params = [];
                    type = 'static';
                    continue;
                }
                if (type === 'wildcard') {
                    key += '/';
                    reSource += (0, $e7359da954dfa76b$export$4e7f196112fea3c5)('/');
                    continue;
                }
                (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)(type);
            }
            if (token.type === 'text') {
                // Encode to comply with URL pathname normalization in trie matcher
                let text = encodeURIComponent(token.text);
                key += text;
                reSource += (0, $e7359da954dfa76b$export$4e7f196112fea3c5)(text);
                continue;
            }
            if (token.type === ':') {
                key += '{:}';
                reSource += `([^/]+)`;
                params.push(token);
                if (type === 'static') type = 'variable';
                continue;
            }
            if (token.type === '*') {
                key += '{*}';
                reSource += `(.*)`;
                params.push(token);
                type = 'wildcard';
                continue;
            }
            (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)(token.type);
        }
        if (type === 'static') variant.push({
            type: 'static',
            key: ignoreCase ? key.toLowerCase() : key
        });
        if (type === 'variable' || type === 'wildcard') variant.push({
            type: type,
            key: key,
            regexp: new RegExp(`^${reSource}$`, reFlags),
            params: params
        });
        result.push(variant);
    }
    return result;
}
function $e6fe796cbf264e6b$export$57a1d23d0b7a46c(part) {
    let result = [];
    let stack = [
        {
            index: 0,
            tokens: []
        }
    ];
    while(stack.length > 0){
        let { index: index, tokens: tokens } = stack.pop();
        if (index === part.tokens.length) {
            result.push(tokens);
            continue;
        }
        let token = part.tokens[index];
        if (token.type === '(') {
            stack.push({
                index: index + 1,
                tokens: tokens
            }, {
                index: part.optionals.get(index) + 1,
                tokens: tokens.slice()
            });
            continue;
        }
        if (token.type === ')') {
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        if (token.type === ':' || token.type === '*' || token.type === 'text' || token.type === 'separator') {
            tokens.push(token);
            stack.push({
                index: index + 1,
                tokens: tokens
            });
            continue;
        }
        (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)(token.type);
    }
    return result;
}



var $4a447d171004e9ab$var$_root = /*#__PURE__*/ new WeakMap();
class $4a447d171004e9ab$export$73571c50d0f2507e {
    insert(pattern, data) {
        for (let variant of (0, $e6fe796cbf264e6b$export$9ac16898ad61bc17)(pattern)){
            let hostnameNode = (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $4a447d171004e9ab$var$_root)[variant.protocol];
            let portNode;
            if (variant.hostname.type === 'any') portNode = hostnameNode.any;
            else if (variant.hostname.type === 'static') {
                let key = variant.hostname.value.toLowerCase();
                let existing = hostnameNode.static.get(key);
                if (existing === undefined) {
                    existing = new Map();
                    hostnameNode.static.set(key, existing);
                }
                portNode = existing;
            } else {
                portNode = new Map();
                hostnameNode.dynamic.push({
                    regexp: variant.hostname.regexp,
                    params: variant.hostname.params,
                    portNode: portNode
                });
            }
            let pathnameRoot = portNode.get(variant.port);
            if (pathnameRoot === undefined) {
                pathnameRoot = $4a447d171004e9ab$var$createPathnameNode();
                portNode.set(variant.port, pathnameRoot);
            }
            let pathnameNode = pathnameRoot;
            for (let segment of variant.pathname){
                if (segment.type === 'static') {
                    let key = this.ignoreCase ? segment.key.toLowerCase() : segment.key;
                    let next = pathnameNode.static.get(key);
                    if (next === undefined) {
                        next = $4a447d171004e9ab$var$createPathnameNode();
                        pathnameNode.static.set(key, next);
                    }
                    pathnameNode = next;
                    continue;
                }
                if (segment.type === 'variable') {
                    let next = pathnameNode.variable.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $4a447d171004e9ab$var$createPathnameNode()
                        };
                        pathnameNode.variable.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                if (segment.type === 'wildcard') {
                    let next = pathnameNode.wildcard.get(segment.key);
                    if (next === undefined) {
                        next = {
                            regexp: segment.regexp,
                            pathnameNode: $4a447d171004e9ab$var$createPathnameNode()
                        };
                        pathnameNode.wildcard.set(segment.key, next);
                    }
                    pathnameNode = next.pathnameNode;
                    continue;
                }
                (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)(segment);
            }
            let requiredParams = [];
            for (let segment of variant.pathname){
                if (segment.type === 'variable' || segment.type === 'wildcard') for (let param of segment.params)requiredParams.push(param);
            }
            let undefinedParams = [];
            for (let param of pattern.pathname.tokens){
                if (param.type !== ':' && param.type !== '*') continue;
                if (requiredParams.some((p)=>p.name === param.name)) continue;
                if (undefinedParams.some((p)=>p.name === param.name)) continue;
                undefinedParams.push(param);
            }
            pathnameNode.values.push({
                pattern: pattern,
                data: data,
                requiredParams: requiredParams,
                undefinedParams: undefinedParams
            });
        }
    }
    search(url) {
        let protocol = url.protocol.slice(0, -1);
        if (protocol !== 'http' && protocol !== 'https') return [];
        let hostnameNode = (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $4a447d171004e9ab$var$_root)[protocol];
        let decodedHostname = (0, $9fa0064812d1b5a5$export$110c810e8727e62b)(url.hostname);
        let origins = [];
        // any hostname (no port allowed -- empty-port key)
        let anyPathname = hostnameNode.any.get('');
        if (anyPathname) origins.push({
            hostnameMatch: [
                {
                    type: '*',
                    name: '*',
                    value: decodedHostname,
                    begin: 0,
                    end: decodedHostname.length
                }
            ],
            pathnameNode: anyPathname
        });
        // static hostname
        let staticPort = hostnameNode.static.get(decodedHostname.toLowerCase());
        if (staticPort) {
            let next = staticPort.get(url.port);
            if (next) origins.push({
                hostnameMatch: [],
                pathnameNode: next
            });
        }
        // dynamic hostnames
        for (let entry of hostnameNode.dynamic){
            let m = entry.regexp.exec(decodedHostname);
            if (!m) continue;
            let next = entry.portNode.get(url.port);
            if (!next) continue;
            let hostnameMatch = [];
            for(let i = 0; i < entry.params.length; i++){
                let param = entry.params[i];
                let span = m.indices?.[i + 1];
                if (span === undefined) continue;
                hostnameMatch.push({
                    type: param.type,
                    name: param.name,
                    value: m[i + 1],
                    begin: span[0],
                    end: span[1]
                });
            }
            origins.push({
                hostnameMatch: hostnameMatch,
                pathnameNode: next
            });
        }
        let results = [];
        let urlSegments = $4a447d171004e9ab$var$normalizePathname(url.pathname);
        if (urlSegments === null) return results;
        for (let origin of origins){
            let stack = [
                {
                    segmentIndex: 0,
                    pathnameNode: origin.pathnameNode,
                    charOffset: 0,
                    captures: []
                }
            ];
            while(stack.length > 0){
                let current = stack.pop();
                if (current.segmentIndex === urlSegments.length) {
                    for (let value of current.pathnameNode.values){
                        if (!$4a447d171004e9ab$var$matchSearch(url.searchParams, value.pattern.search)) continue;
                        let pathnameMatch = [];
                        for(let i = 0; i < value.requiredParams.length; i++){
                            let param = value.requiredParams[i];
                            let cap = current.captures[i];
                            pathnameMatch.push({
                                type: param.type,
                                name: param.name,
                                value: $4a447d171004e9ab$var$fastDecodeURIComponent(cap.value),
                                begin: cap.begin,
                                end: cap.end
                            });
                        }
                        let params = {};
                        for (let token of value.pattern.hostname?.tokens ?? [])if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let token of value.pattern.pathname.tokens)if ((token.type === ':' || token.type === '*') && token.name !== '*') params[token.name] = undefined;
                        for (let p of origin.hostnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        for (let p of pathnameMatch){
                            if (p.name === '*') continue;
                            params[p.name] = p.value;
                        }
                        results.push({
                            url: url,
                            pattern: value.pattern,
                            data: value.data,
                            params: params,
                            paramsMeta: {
                                hostname: origin.hostnameMatch,
                                pathname: pathnameMatch
                            }
                        });
                    }
                    continue;
                }
                let urlSegment = urlSegments[current.segmentIndex];
                let staticKey = this.ignoreCase ? urlSegment.toLowerCase() : urlSegment;
                let nextStatic = current.pathnameNode.static.get(staticKey);
                if (nextStatic) stack.push({
                    segmentIndex: current.segmentIndex + 1,
                    pathnameNode: nextStatic,
                    charOffset: current.charOffset + urlSegment.length + 1,
                    captures: current.captures
                });
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.variable.values()){
                    let m = regexp.exec(urlSegment);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) (0, $1e95703b2ce1bc93$export$565e9d9bd6b6e0d4)();
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: current.segmentIndex + 1,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + m.index + m[0].length + 1,
                        captures: captures
                    });
                }
                for (let { regexp: regexp, pathnameNode: pathnameNode } of current.pathnameNode.wildcard.values()){
                    let remaining = urlSegments.slice(current.segmentIndex).join('/');
                    let m = regexp.exec(remaining);
                    if (!m) continue;
                    let captures = current.captures.slice();
                    for(let i = 1; i < m.indices.length; i++){
                        let span = m.indices[i];
                        if (span === undefined) continue;
                        captures.push({
                            value: m[i],
                            begin: current.charOffset + span[0],
                            end: current.charOffset + span[1]
                        });
                    }
                    stack.push({
                        segmentIndex: urlSegments.length,
                        pathnameNode: pathnameNode,
                        charOffset: current.charOffset + remaining.length,
                        captures: captures
                    });
                }
            }
        }
        return results;
    }
    constructor(options){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "ignoreCase", void 0);
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $4a447d171004e9ab$var$_root, {
            writable: true,
            value: void 0
        });
        this.ignoreCase = options?.ignoreCase ?? false;
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $4a447d171004e9ab$var$_root, {
            http: $4a447d171004e9ab$var$createHostnameNode(),
            https: $4a447d171004e9ab$var$createHostnameNode()
        });
    }
}
// Pathname codec ----------------------------------------------------------------------------------
// Pathname matching uses canonical percent-encoded text. URL pathnames are split on structural
// "/" before normalization so encoded slashes like "%2F" remain data within a segment instead of
// becoming separators. Pattern static text is encoded the same way when variants are generated.
function $4a447d171004e9ab$var$normalizePathname(pathname) {
    let segments = [];
    for (let segment of pathname.slice(1).split('/')){
        let normalized = $4a447d171004e9ab$var$normalizePathnameText(segment);
        if (normalized === null) return null;
        segments.push(normalized);
    }
    return segments;
}
function $4a447d171004e9ab$var$normalizePathnameText(text) {
    let decoded = $4a447d171004e9ab$var$safeDecodeURIComponent(text);
    return decoded === null ? null : encodeURIComponent(decoded);
}
function $4a447d171004e9ab$var$fastDecodeURIComponent(text) {
    return text.includes('%') ? decodeURIComponent(text) : text;
}
function $4a447d171004e9ab$var$safeDecodeURIComponent(text) {
    try {
        return $4a447d171004e9ab$var$fastDecodeURIComponent(text);
    } catch (error) {
        if (error instanceof URIError) return null;
        throw error;
    }
}
// Search ------------------------------------------------------------------------------------------
function $4a447d171004e9ab$var$matchSearch(params, constraints) {
    for (let [name, requiredValues] of constraints){
        if (requiredValues.size === 0) {
            if (!params.has(name)) return false;
            continue;
        }
        let values = params.getAll(name);
        for (let requiredValue of requiredValues){
            if (!values.includes(requiredValue)) return false;
        }
    }
    return true;
}
function $4a447d171004e9ab$var$createHostnameNode() {
    return {
        static: new Map(),
        dynamic: [],
        any: new Map()
    };
}
function $4a447d171004e9ab$var$createPathnameNode() {
    return {
        static: new Map(),
        variable: new Map(),
        wildcard: new Map(),
        values: []
    };
}



function $c9540fb476674886$export$9b050841a3a1b328(a, b) {
    return $c9540fb476674886$export$398604a469f7de9a(a, b) === -1;
}
function $c9540fb476674886$export$f517ea36c68d4644(a, b) {
    return $c9540fb476674886$export$398604a469f7de9a(a, b) === 1;
}
function $c9540fb476674886$export$411ce8e5a71e3069(a, b) {
    return $c9540fb476674886$export$398604a469f7de9a(a, b) === 0;
}
const $c9540fb476674886$export$fcb633242ef15540 = (a, b)=>$c9540fb476674886$export$398604a469f7de9a(a, b);
const $c9540fb476674886$export$4fa3190a997c3d8f = (a, b)=>$c9540fb476674886$export$398604a469f7de9a(a, b) * -1;
function $c9540fb476674886$export$398604a469f7de9a(a, b) {
    if (a.url.href !== b.url.href) throw new Error(`Cannot compare matches for different URLs: ${a.url.href} vs ${b.url.href}`);
    let hostname = (0, $9fa0064812d1b5a5$export$110c810e8727e62b)(a.url.hostname);
    let hostnameResult = $c9540fb476674886$var$compareHostname(hostname, a.paramsMeta.hostname, b.paramsMeta.hostname);
    if (hostnameResult !== 0) return hostnameResult;
    let pathnameResult = $c9540fb476674886$var$comparePathname(a.paramsMeta.pathname, b.paramsMeta.pathname);
    if (pathnameResult !== 0) return pathnameResult;
    let searchResult = $c9540fb476674886$var$compareSearch(a.pattern.search, b.pattern.search);
    if (searchResult !== 0) return searchResult;
    return 0;
}
function $c9540fb476674886$var$compareHostname(hostname, a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    // Encoding of hostname chars: 0 = static, 1 = variable (:), 2 = wildcard (*)
    // Note: `Int8Array` defaults to 0 for all indices not explicitly set.
    let aEncoding = new Int8Array(hostname.length);
    for (let range of a)aEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    let bEncoding = new Int8Array(hostname.length);
    for (let range of b)bEncoding.fill(range.type === ':' ? 1 : 2, range.begin, range.end);
    // Build segments right-to-left: desc order by begin
    let segments = [];
    let end = hostname.length;
    for(let i = hostname.length - 1; i >= 0; i--)if (hostname[i] === '.') {
        segments.push({
            begin: i + 1,
            end: end
        });
        end = i;
    }
    segments.push({
        begin: 0,
        end: end
    }); // leftmost segment
    for (let segment of segments)for(let j = segment.begin; j < segment.end; j++){
        if (aEncoding[j] < bEncoding[j]) return 1; // a is more specific
        if (aEncoding[j] > bEncoding[j]) return -1; // b is more specific
    }
    return 0;
}
function $c9540fb476674886$var$comparePathname(a, b) {
    if (a.length === 0 && b.length === 0) return 0;
    if (a.length === 0 && b.length > 0) return 1;
    if (a.length > 0 && b.length === 0) return -1;
    let i = 0;
    let aIndex = 0;
    let bIndex = 0;
    while(aIndex < a.length || bIndex < b.length){
        let aRange = a[aIndex];
        let bRange = b[bIndex];
        if (aRange === undefined) return 1; // a is fully static from here
        if (bRange === undefined) return -1; // b is fully static from here
        // Skip to the minimum begin of the two current ranges
        i = Math.min(aRange.begin, bRange.begin);
        if (i < aRange.begin) return 1; // a has static content at i
        if (i < bRange.begin) return -1; // b has static content at i
        if (aRange.type === ':' && bRange.type === '*') return 1; // a is more specific
        if (aRange.type === '*' && bRange.type === ':') return -1; // b is more specific
        let minEnd = Math.min(aRange.end, bRange.end);
        i = minEnd;
        // Advance range indices if we've reached their ends
        if (i >= aRange.end) aIndex += 1;
        if (i >= bRange.end) bIndex += 1;
    }
    return 0;
}
function $c9540fb476674886$var$compareSearch(a, b) {
    let aSpecificity = $c9540fb476674886$var$searchSpecificity(a);
    let bSpecificity = $c9540fb476674886$var$searchSpecificity(b);
    if (aSpecificity.keyValue > bSpecificity.keyValue) return 1;
    if (aSpecificity.keyValue < bSpecificity.keyValue) return -1;
    if (aSpecificity.key > bSpecificity.key) return 1;
    if (aSpecificity.key < bSpecificity.key) return -1;
    return 0;
}
function $c9540fb476674886$var$searchSpecificity(constraints) {
    let specificity = {
        key: 0,
        keyValue: 0
    };
    for (let constraint of constraints.values()){
        if (constraint.size === 0) {
            specificity.key += 1;
            continue;
        }
        specificity.keyValue += constraint.size;
    }
    return specificity;
}


function $43eb887d2e10caea$export$1d94974cf1366deb(pattern, options) {
    pattern = typeof pattern === 'string' ? (0, $2a0daba9d2562f69$export$2917961db0dd6e8b).parse(pattern) : pattern;
    let matcher = $43eb887d2e10caea$export$cf760d085d57ec27(options);
    matcher.add(pattern, undefined);
    return {
        match (url) {
            return matcher.match(url);
        }
    };
}
function $43eb887d2e10caea$export$cf760d085d57ec27(options) {
    return new $43eb887d2e10caea$var$TrieMatcher(options);
}
var $43eb887d2e10caea$var$_trie = /*#__PURE__*/ new WeakMap();
class $43eb887d2e10caea$var$TrieMatcher {
    add(pattern, data) {
        pattern = typeof pattern === 'string' ? (0, $a6dab0a9914312f3$export$e26190e3669abbfe)(pattern) : pattern;
        (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $43eb887d2e10caea$var$_trie).insert(pattern, data);
    }
    match(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let best = null;
        for (let match of (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $43eb887d2e10caea$var$_trie).search(parsedUrl))if (best === null || $c9540fb476674886$export$f517ea36c68d4644(match, best)) best = match;
        return best;
    }
    matchAll(url) {
        let parsedUrl = typeof url === 'string' ? new URL(url) : url;
        let matches = [];
        for (let match of (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $43eb887d2e10caea$var$_trie).search(parsedUrl))matches.push(match);
        return matches.sort($c9540fb476674886$export$4fa3190a997c3d8f);
    }
    constructor(options){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "ignoreCase", void 0);
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $43eb887d2e10caea$var$_trie, {
            writable: true,
            value: void 0
        });
        this.ignoreCase = options?.ignoreCase ?? false;
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $43eb887d2e10caea$var$_trie, new (0, $4a447d171004e9ab$export$73571c50d0f2507e)({
            ignoreCase: this.ignoreCase
        }));
    }
}







var $15dc0feff15efbca$var$_state, $15dc0feff15efbca$var$_basename;
//#region lib/router/matcher-route-pattern.ts
var $15dc0feff15efbca$export$9f42f7e9b7c469cc = ($15dc0feff15efbca$var$_state = /*#__PURE__*/ new WeakMap(), $15dc0feff15efbca$var$_basename = /*#__PURE__*/ new WeakMap(), class {
    update(routes) {
        let branches = $15dc0feff15efbca$var$flattenRoutes(routes);
        let matcher = (0, $43eb887d2e10caea$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        let partialMatcher = (0, $43eb887d2e10caea$export$cf760d085d57ec27)({
            ignoreCase: true
        });
        for (let branch of branches){
            let routePattern = $15dc0feff15efbca$var$convertReactRouterPathToRoutePattern(branch.path);
            $15dc0feff15efbca$var$validateRoutePatternSplat(branch.path, routePattern);
            routePattern = $15dc0feff15efbca$var$addOptionalTrailingSlash(routePattern);
            matcher.add(routePattern, branch);
            if (!branch.routesMeta[branch.routesMeta.length - 1].route.index) partialMatcher.add(routePattern === "/" ? `/*__rr_partial` : `${routePattern}(/*__rr_partial)`, branch);
        }
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_state, {
            branches: branches,
            matcher: matcher,
            partialMatcher: partialMatcher
        });
        return branches;
    }
    match(locationArg, allowPartial = false) {
        let pathname = (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)((typeof locationArg === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(locationArg) : locationArg).pathname || "/", (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_basename));
        if (pathname == null) return null;
        let decoded = (0, $f1195701c85e5ce2$export$cd27bea214d030c2)(pathname);
        let url = new URL("http://reactrouter.local");
        url.pathname = pathname.endsWith("/") ? pathname : `${pathname}/`;
        (0, $072a56029499ae6c$export$f5708dca728d7177)((0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_state), "Route pattern routes must be initialized before matching.");
        let matches = (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_state).matcher.matchAll(url);
        if (allowPartial) matches.push(...(0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_state).partialMatcher.matchAll(url));
        for (let match of $15dc0feff15efbca$var$prioritizeValidatedMatches(matches)){
            let routeMatches = $15dc0feff15efbca$var$convertRoutePatternMatchToRouteMatches(match, decoded, allowPartial);
            if (routeMatches && $15dc0feff15efbca$var$validateRouteMatchParams(routeMatches)) return routeMatches;
        }
        return null;
    }
    constructor(basename){
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_state, {
            writable: true,
            value: void 0
        });
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_basename, {
            writable: true,
            value: void 0
        });
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $15dc0feff15efbca$var$_basename, basename);
    }
});
function $15dc0feff15efbca$var$validateRoutePatternSplat(routePath, routePattern) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)($15dc0feff15efbca$var$getRoutePatternSplatIndexes(routePattern).length <= 1 && $15dc0feff15efbca$var$isTerminalRoutePatternSplat(routePattern), `Route path "${routePath}" is not supported with \`future.unstable_routePatternMatching\` because React Router only supports a single splat at the end of a route path.`);
}
function $15dc0feff15efbca$var$getRoutePatternSplatIndexes(routePattern) {
    let splatIndexes = [];
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char === "*") splatIndexes.push(i);
    }
    return splatIndexes;
}
function $15dc0feff15efbca$var$isTerminalRoutePatternSplat(routePattern) {
    for(let i = 0; i < routePattern.length; i++){
        let char = routePattern[i];
        if (char === "\\") {
            i++;
            continue;
        }
        if (char !== "*") continue;
        let suffix = routePattern.slice(i + 1);
        return /^[a-zA-Z_$][a-zA-Z_$0-9]*$/.test(suffix) || suffix === "";
    }
    return true;
}
function $15dc0feff15efbca$var$addOptionalTrailingSlash(routePattern) {
    return routePattern === "/" ? routePattern : `${routePattern.replace(/\/+$/, "")}(/)`;
}
function $15dc0feff15efbca$var$flattenRoutes(routes, branches = [], parentsMeta = [], parentPath = "") {
    routes.forEach((route, index)=>{
        (0, $072a56029499ae6c$export$f5708dca728d7177)(route.caseSensitive !== true, "`caseSensitive` routes are not supported with `future.unstable_routePatternMatching`.");
        let meta = {
            relativePath: route.path || "",
            caseSensitive: false,
            childrenIndex: index,
            route: route
        };
        let absolutePath;
        if (meta.relativePath.startsWith("/")) {
            absolutePath = meta.relativePath;
            let parentPathMatch = (0, $f1195701c85e5ce2$export$82472424e06ad5c9)(parentPath).find((path)=>meta.relativePath.startsWith(path));
            (0, $072a56029499ae6c$export$f5708dca728d7177)(parentPathMatch != null, `Absolute route path "${meta.relativePath}" nested under path "${parentPath}" is not valid. An absolute child route path must start with the combined path of all its parent routes.`);
            meta.relativePath = meta.relativePath.slice(parentPathMatch.length);
        }
        let routesMeta = parentsMeta.concat(meta);
        let path = absolutePath ?? (meta.relativePath ? (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
            parentPath,
            meta.relativePath
        ]) : parentPath);
        if (route.children && route.children.length > 0) {
            (0, $072a56029499ae6c$export$f5708dca728d7177)(route.index !== true, `Index routes must not have child routes. Please remove all child routes from route path "${path}".`);
            $15dc0feff15efbca$var$flattenRoutes(route.children, branches, routesMeta, path);
            if (route.children?.some((child)=>child.index)) return;
        }
        if (route.path != null || route.index) branches.push({
            path: path,
            score: 0,
            routesMeta: routesMeta
        });
    });
    return branches;
}
function $15dc0feff15efbca$var$convertReactRouterPathToRoutePattern(path) {
    (0, $072a56029499ae6c$export$491112666e282270)(path === "*" || !path.endsWith("*") || path.endsWith("/*"), `Route path "${path}" will be treated as if it were "${path.replace(/\*$/, "/*")}" because the \`*\` character must always follow a \`/\` in the pattern. To get rid of this warning, please change the route path to "${path.replace(/\*$/, "/*")}".`);
    if (path.endsWith("*") && path !== "*" && !path.endsWith("/*")) path = path.replace(/\*$/, "/*");
    path = path.replace(/^\/*/, "/");
    if (path === "") return "/";
    let segments = path.split("/");
    let pattern = segments.shift() || "";
    for(let i = 0; i < segments.length;){
        let optionalRun = [];
        while(i < segments.length && $15dc0feff15efbca$var$isOptionalRouteSegment(segments[i])){
            optionalRun.push($15dc0feff15efbca$var$convertRouteSegment(segments[i].slice(0, -1)));
            i++;
        }
        if (optionalRun.length > 0) {
            let nested = optionalRun.reduceRight((child, segment)=>`/${segment}${child ? `(${child})` : ""}`, "");
            pattern += `(${nested})`;
            continue;
        }
        pattern += `/${$15dc0feff15efbca$var$convertRouteSegment(segments[i])}`;
        i++;
    }
    return pattern || "/";
}
function $15dc0feff15efbca$var$isOptionalRouteSegment(segment) {
    return segment.endsWith("?");
}
function $15dc0feff15efbca$var$convertRouteSegment(segment) {
    if (segment === "*") return "*__rr_splat";
    let paramMatch = segment.match(/^:([\w-]+)(\?)?(.*)$/);
    if (paramMatch) {
        let [, paramName, optional, suffix] = paramMatch;
        let converted = `:${paramName}${$15dc0feff15efbca$var$escapeRoutePatternLiteral(suffix)}`;
        return optional ? `(:${paramName})${$15dc0feff15efbca$var$escapeRoutePatternLiteral(suffix)}` : converted;
    }
    return $15dc0feff15efbca$var$escapeRoutePatternLiteral(segment);
}
function $15dc0feff15efbca$var$escapeRoutePatternLiteral(value) {
    return value.replace(/[\\():*]/g, "\\$&");
}
function $15dc0feff15efbca$var$validateRouteMatchParams(matches) {
    return matches.every(({ route: route, params: params })=>route.unstable_validateParams == null || Object.keys(route.unstable_validateParams).length === 0 || Object.entries(route.unstable_validateParams).every(([param, re])=>params[param] != null ? new RegExp(re.source, re.flags).test(params[param]) : true));
}
function $15dc0feff15efbca$var$prioritizeValidatedMatches(matches) {
    return matches.sort((a, b)=>{
        let specificity = (0, $c9540fb476674886$export$4fa3190a997c3d8f)(a, b);
        if (specificity !== 0) return specificity;
        return Number($15dc0feff15efbca$var$hasParamValidators(b)) - Number($15dc0feff15efbca$var$hasParamValidators(a));
    });
}
function $15dc0feff15efbca$var$hasParamValidators(match) {
    return match.data.routesMeta.some((meta)=>meta.route.unstable_validateParams != null && Object.keys(meta.route.unstable_validateParams).length > 0);
}
function $15dc0feff15efbca$var$convertRoutePatternMatchToRouteMatches(match, pathname, allowPartial) {
    let result = $15dc0feff15efbca$var$matchRoutePatternBranch(match.data, pathname, allowPartial, 0, "/", {});
    if (result == null) return null;
    for (let routeMatch of result.matches)routeMatch.params = result.params;
    return result.matches;
}
function $15dc0feff15efbca$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex, matchedPathname, matchedParams) {
    let meta = branch.routesMeta[metaIndex];
    let end = metaIndex === branch.routesMeta.length - 1;
    let remainingPathname = matchedPathname === "/" ? pathname : pathname.slice(matchedPathname.length) || "/";
    for (let relativePath of (0, $f1195701c85e5ce2$export$82472424e06ad5c9)(meta.relativePath)){
        let pattern = {
            path: relativePath,
            caseSensitive: false,
            end: end
        };
        let pathMatch = (0, $f1195701c85e5ce2$export$81336c211d5ff295)(pattern, remainingPathname);
        if (!pathMatch && end && allowPartial && !meta.route.index) pathMatch = (0, $f1195701c85e5ce2$export$81336c211d5ff295)({
            ...pattern,
            end: false
        }, remainingPathname);
        if (!pathMatch) continue;
        let params = {
            ...matchedParams,
            ...pathMatch.params
        };
        let routeMatch = {
            params: params,
            pathname: (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathname
            ]),
            pathnameBase: (0, $f1195701c85e5ce2$export$a5c6d149b50c1d86)((0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
                matchedPathname,
                pathMatch.pathnameBase
            ])),
            route: meta.route
        };
        let nextMatchedPathname = pathMatch.pathnameBase === "/" ? matchedPathname : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
            matchedPathname,
            pathMatch.pathnameBase
        ]);
        if (end) return {
            matches: [
                routeMatch
            ],
            params: params
        };
        let childResult = $15dc0feff15efbca$var$matchRoutePatternBranch(branch, pathname, allowPartial, metaIndex + 1, nextMatchedPathname, params);
        if (childResult) return {
            matches: [
                routeMatch,
                ...childResult.matches
            ],
            params: childResult.params
        };
    }
    return null;
}


//#region lib/router/matcher-route-pattern.preload.ts
let $c0892298cd612c0c$var$RoutePatternMatcher;
function $c0892298cd612c0c$export$45cda2a841115322() {
    return $c0892298cd612c0c$var$RoutePatternMatcher;
}
/**
* Initialize the route-pattern matcher before creating a Data Router or static
* handler with `future.unstable_routePatternMatching` enabled. Import from
* `react-router/route-pattern` and call this once during application startup.
* Server and browser applications must each preload their own matcher.
*
* The matcher is statically imported by this module. Tree-shaking bundlers can
* remove it from applications that do not use this function. Initialization is
* synchronous, and repeated calls are safe.
*
* @public
* @category Data Routers
* @mode data
* @returns {void}
*/ function $c0892298cd612c0c$export$c6cb8c636109e21b() {
    $c0892298cd612c0c$var$RoutePatternMatcher = (0, $15dc0feff15efbca$export$9f42f7e9b7c469cc);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/router/navigation.ts
const $0179caaefc35c7e3$var$DEFAULT_NAVIGATION_URL = new URL("http://localhost");
function $0179caaefc35c7e3$export$1da545bc000055cf(navigator) {
    if (navigator.createURL) return navigator.createURL("/");
    try {
        return new URL(navigator.createHref("/"), $0179caaefc35c7e3$var$DEFAULT_NAVIGATION_URL);
    } catch  {
        return $0179caaefc35c7e3$var$DEFAULT_NAVIGATION_URL;
    }
}
function $0179caaefc35c7e3$var$isSameOrigin(a, b) {
    return a.origin === b.origin && (a.origin !== "null" || a.protocol === b.protocol && a.host === b.host);
}
function $0179caaefc35c7e3$var$isExplicitUrl(destination, target) {
    if (destination.startsWith("//")) return true;
    let protocol = target.protocol.toLowerCase();
    if (!destination.toLowerCase().startsWith(protocol)) return false;
    return target.host === "" || destination.slice(protocol.length).startsWith("//");
}
function $0179caaefc35c7e3$export$6c8e41f66e7aa990(original, resolved, currentUrl, externalPolicy) {
    let originalUrl = null;
    try {
        originalUrl = original == null ? null : new URL(original, currentUrl);
    } catch  {}
    let resolvedUrl = new URL(resolved, currentUrl);
    let originalIsExternal = originalUrl != null && !$0179caaefc35c7e3$var$isSameOrigin(originalUrl, currentUrl);
    let resolvedIsExternal = !$0179caaefc35c7e3$var$isSameOrigin(resolvedUrl, currentUrl);
    if (externalPolicy === "reject") {
        if (originalIsExternal || resolvedIsExternal) throw new Error("External navigation is not allowed");
    } else if (resolvedIsExternal) {
        if (originalUrl == null || !$0179caaefc35c7e3$var$isExplicitUrl(original, originalUrl) || !$0179caaefc35c7e3$var$isSameOrigin(originalUrl, resolvedUrl)) throw new Error("External navigation is not allowed");
    }
}


var $9915aeece4ba52df$var$_routes, $9915aeece4ba52df$var$_hmrRoutes, $9915aeece4ba52df$var$_matcher;
//#region lib/router/router.ts
const $9915aeece4ba52df$var$validMutationMethodsArr = [
    "POST",
    "PUT",
    "PATCH",
    "DELETE"
];
const $9915aeece4ba52df$var$validMutationMethods = new Set($9915aeece4ba52df$var$validMutationMethodsArr);
const $9915aeece4ba52df$var$validRequestMethodsArr = [
    "GET",
    ...$9915aeece4ba52df$var$validMutationMethodsArr
];
const $9915aeece4ba52df$var$validRequestMethods = new Set($9915aeece4ba52df$var$validRequestMethodsArr);
const $9915aeece4ba52df$var$redirectStatusCodes = new Set([
    301,
    302,
    303,
    307,
    308
]);
const $9915aeece4ba52df$var$redirectPreserveMethodStatusCodes = new Set([
    307,
    308
]);
const $9915aeece4ba52df$export$ed3e14b2f9e105d0 = {
    state: "idle",
    location: void 0,
    matches: void 0,
    historyAction: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $9915aeece4ba52df$export$52eace9c284d3585 = {
    state: "idle",
    data: void 0,
    formMethod: void 0,
    formAction: void 0,
    formEncType: void 0,
    formData: void 0,
    json: void 0,
    text: void 0
};
const $9915aeece4ba52df$export$386d57f03f0b2883 = {
    state: "unblocked",
    proceed: void 0,
    reset: void 0,
    location: void 0
};
const $9915aeece4ba52df$var$TRANSITIONS_STORAGE_KEY = "remix-router-transitions";
const $9915aeece4ba52df$var$ResetLoaderDataSymbol = Symbol("ResetLoaderData");
function $9915aeece4ba52df$export$5e64b3b9d7e2ec36(future, basename) {
    if (future.unstable_routePatternMatching) {
        let RoutePatternMatcher = (0, $c0892298cd612c0c$export$45cda2a841115322)();
        (0, $072a56029499ae6c$export$f5708dca728d7177)(RoutePatternMatcher, "You must call unstable_preloadRoutePattern() from \"react-router/route-pattern\" before enabling future.unstable_routePatternMatching.");
        return new RoutePatternMatcher(basename);
    }
    return new (0, $63ab57b16d380f6c$export$92541312f2982378)(basename);
}
/**
* Encapsulates the stable and in-flight route trees together with their
* pre-computed branch caches so the structures always stay in sync.
*/ var $9915aeece4ba52df$var$DataRoutes = ($9915aeece4ba52df$var$_routes = /*#__PURE__*/ new WeakMap(), $9915aeece4ba52df$var$_hmrRoutes = /*#__PURE__*/ new WeakMap(), $9915aeece4ba52df$var$_matcher = /*#__PURE__*/ new WeakMap(), class {
    /** The stable route tree */ get stableRoutes() {
        return (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes);
    }
    /** The in-flight route tree if one is active, otherwise the stable tree */ get activeRoutes() {
        return (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes) ?? (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes);
    }
    get hasHMRRoutes() {
        return (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes) != null;
    }
    /** Replace the stable route tree and recompute its branches */ setRoutes(routes) {
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes, routes);
        if (!(0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes)) (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_matcher).update(routes);
    }
    /** Set a new in-flight route tree and recompute its branches */ setHmrRoutes(routes) {
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes, routes);
        (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_matcher).update(routes);
    }
    /** Commit in-flight routes/branches to the stable slot and clear in-flight */ commitHmrRoutes() {
        if ((0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes)) {
            (0, $4e65168814c8101e$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes, (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes));
            (0, $4e65168814c8101e$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes, void 0);
            (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_matcher).update((0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes));
        }
    }
    constructor(routes, matcher){
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes, {
            writable: true,
            value: void 0
        });
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_hmrRoutes, {
            writable: true,
            value: void 0
        });
        (0, $385e6fada99f052b$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_matcher, {
            writable: true,
            value: void 0
        });
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_routes, routes);
        (0, $4e65168814c8101e$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_matcher, matcher);
        (0, $138bdba4f9532a1d$export$71511d61b312f219)(this, $9915aeece4ba52df$var$_matcher).update(routes);
    }
});
/**
* Create a router and listen to history POP navigations
*/ function $9915aeece4ba52df$export$baddd0131ee8c05b(init) {
    const routerWindow = init.window ? init.window : typeof window !== "undefined" ? window : void 0;
    const isBrowser = typeof routerWindow !== "undefined" && typeof routerWindow.document !== "undefined" && typeof routerWindow.document.createElement !== "undefined";
    (0, $072a56029499ae6c$export$f5708dca728d7177)(init.routes.length > 0, "You must provide a non-empty routes array to createRouter");
    let hydrationRouteProperties = init.hydrationRouteProperties || [];
    let _mapRouteProperties = init.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    if (init.instrumentations) {
        let instrumentations = init.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $faa62a10fd016f72$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let future = {
        ...init.future
    };
    let basename = init.basename || "/";
    if (!basename.startsWith("/")) basename = `/${basename}`;
    let dataRouteMatcher = $9915aeece4ba52df$export$5e64b3b9d7e2ec36(future, basename);
    let manifest = {};
    let dataRoutes = new $9915aeece4ba52df$var$DataRoutes((0, $f1195701c85e5ce2$export$87cb1a9238dc3fba)(init.routes, mapRouteProperties, void 0, manifest), dataRouteMatcher);
    let dataStrategyImpl = init.dataStrategy || $9915aeece4ba52df$var$defaultDataStrategyWithMiddleware;
    let unlistenHistory = null;
    let subscribers = /* @__PURE__ */ new Set();
    let bufferedInitialStateUpdate = null;
    let savedScrollPositions = null;
    let getScrollRestorationKey = null;
    let getScrollPosition = null;
    let initialScrollRestored = init.hydrationData != null;
    let initialMatches = dataRouteMatcher.match(init.history.location);
    let initialMatchesIsFOW = false;
    let initialErrors = null;
    let initialized;
    let renderFallback;
    if (initialMatches == null && !init.patchRoutesOnNavigation) {
        let error = $9915aeece4ba52df$var$getInternalRouterError(404, {
            pathname: init.history.location.pathname
        });
        let { matches: matches, route: route } = $9915aeece4ba52df$var$getShortCircuitMatches(dataRoutes.activeRoutes);
        initialized = true;
        renderFallback = !initialized;
        initialMatches = matches;
        initialErrors = {
            [route.id]: error
        };
    } else {
        if (initialMatches && !init.hydrationData) {
            if (checkFogOfWar(initialMatches, init.history.location.pathname).active) initialMatches = null;
        }
        if (!initialMatches) {
            initialized = false;
            renderFallback = !initialized;
            initialMatches = [];
            let fogOfWar = checkFogOfWar(null, init.history.location.pathname);
            if (fogOfWar.active && fogOfWar.matches) {
                initialMatchesIsFOW = true;
                initialMatches = fogOfWar.matches;
            }
        } else if (initialMatches.some((m)=>m.route.lazy)) {
            initialized = false;
            renderFallback = !initialized;
        } else if (!initialMatches.some((m)=>$9915aeece4ba52df$var$routeHasLoaderOrMiddleware(m.route))) {
            initialized = true;
            renderFallback = !initialized;
        } else {
            let loaderData = init.hydrationData ? init.hydrationData.loaderData : null;
            let errors = init.hydrationData ? init.hydrationData.errors : null;
            let relevantMatches = initialMatches;
            if (errors) {
                let idx = initialMatches.findIndex((m)=>errors[m.route.id] !== void 0);
                relevantMatches = relevantMatches.slice(0, idx + 1);
            }
            renderFallback = false;
            initialized = true;
            relevantMatches.forEach((m)=>{
                let status = $9915aeece4ba52df$var$getRouteHydrationStatus(m.route, loaderData, errors);
                renderFallback = renderFallback || status.renderFallback;
                initialized = initialized && !status.shouldLoad;
            });
        }
    }
    let router;
    let state = {
        historyAction: init.history.action,
        location: init.history.location,
        matches: initialMatches,
        initialized: initialized,
        renderFallback: renderFallback,
        navigation: $9915aeece4ba52df$export$ed3e14b2f9e105d0,
        restoreScrollPosition: init.hydrationData != null ? false : null,
        preventScrollReset: false,
        revalidation: "idle",
        loaderData: init.hydrationData && init.hydrationData.loaderData || {},
        actionData: init.hydrationData && init.hydrationData.actionData || null,
        errors: init.hydrationData && init.hydrationData.errors || initialErrors,
        fetchers: /* @__PURE__ */ new Map(),
        blockers: /* @__PURE__ */ new Map()
    };
    let pendingAction = "POP";
    let pendingPopstateNavigationDfd = null;
    let pendingPreventScrollReset = false;
    let pendingNavigationController;
    let pendingViewTransitionEnabled = false;
    let appliedViewTransitions = /* @__PURE__ */ new Map();
    let removePageHideEventListener = null;
    let isUninterruptedRevalidation = false;
    let isRevalidationRequired = false;
    let cancelledFetcherLoads = /* @__PURE__ */ new Set();
    let fetchControllers = /* @__PURE__ */ new Map();
    let incrementingLoadId = 0;
    let pendingNavigationLoadId = -1;
    let fetchReloadIds = /* @__PURE__ */ new Map();
    let fetchRedirectIds = /* @__PURE__ */ new Set();
    let fetchLoadMatches = /* @__PURE__ */ new Map();
    let activeFetchers = /* @__PURE__ */ new Map();
    let fetchersQueuedForDeletion = /* @__PURE__ */ new Set();
    let blockerFunctions = /* @__PURE__ */ new Map();
    let unblockBlockerHistoryUpdate = void 0;
    let pendingRevalidationDfd = null;
    function initialize() {
        unlistenHistory = init.history.listen(({ action: historyAction, location: location, delta: delta })=>{
            if (unblockBlockerHistoryUpdate) {
                unblockBlockerHistoryUpdate();
                unblockBlockerHistoryUpdate = void 0;
                return;
            }
            (0, $072a56029499ae6c$export$491112666e282270)(blockerFunctions.size === 0 || delta != null, "You are trying to use a blocker on a POP navigation to a location that was not created by @remix-run/router. This will fail silently in production. This can happen if you are navigating outside the router via `window.history.pushState`/`window.location.hash` instead of using router navigation APIs.  This can also happen if you are using createHashRouter and the user manually changes the URL.");
            let blockerKey = shouldBlockNavigation({
                currentLocation: state.location,
                nextLocation: location,
                historyAction: historyAction
            });
            if (blockerKey && delta != null) {
                let nextHistoryUpdatePromise = new Promise((resolve)=>{
                    unblockBlockerHistoryUpdate = resolve;
                });
                init.history.go(delta * -1);
                updateBlocker(blockerKey, {
                    state: "blocked",
                    location: location,
                    proceed () {
                        updateBlocker(blockerKey, {
                            state: "proceeding",
                            proceed: void 0,
                            reset: void 0,
                            location: location
                        });
                        nextHistoryUpdatePromise.then(()=>init.history.go(delta));
                    },
                    reset () {
                        let blockers = new Map(state.blockers);
                        blockers.set(blockerKey, $9915aeece4ba52df$export$386d57f03f0b2883);
                        updateState({
                            blockers: blockers
                        });
                    }
                });
                pendingPopstateNavigationDfd?.resolve();
                pendingPopstateNavigationDfd = null;
                return;
            }
            return startNavigation(historyAction, location);
        });
        if (isBrowser) {
            $9915aeece4ba52df$var$restoreAppliedTransitions(routerWindow, appliedViewTransitions);
            let _saveAppliedTransitions = ()=>$9915aeece4ba52df$var$persistAppliedTransitions(routerWindow, appliedViewTransitions);
            routerWindow.addEventListener("pagehide", _saveAppliedTransitions);
            removePageHideEventListener = ()=>routerWindow.removeEventListener("pagehide", _saveAppliedTransitions);
        }
        if (!state.initialized) startNavigation("POP", state.location, {
            initialHydration: true
        });
        return router;
    }
    function dispose() {
        if (unlistenHistory) unlistenHistory();
        if (removePageHideEventListener) removePageHideEventListener();
        subscribers.clear();
        pendingNavigationController && pendingNavigationController.abort();
        state.fetchers.forEach((_, key)=>deleteFetcher(state.fetchers, key));
        state.blockers.forEach((_, key)=>deleteBlocker(key));
    }
    function subscribe(fn) {
        subscribers.add(fn);
        if (bufferedInitialStateUpdate) {
            let { newErrors: newErrors } = bufferedInitialStateUpdate;
            bufferedInitialStateUpdate = null;
            fn(state, {
                deletedFetchers: [],
                newErrors: newErrors,
                viewTransitionOpts: void 0,
                flushSync: false
            });
        }
        return ()=>subscribers.delete(fn);
    }
    function updateState(newState, opts = {}) {
        if (newState.matches) newState.matches = newState.matches.map((m)=>{
            let route = manifest[m.route.id];
            let matchRoute = m.route;
            if (matchRoute.element !== route.element || matchRoute.errorElement !== route.errorElement || matchRoute.hydrateFallbackElement !== route.hydrateFallbackElement) return {
                ...m,
                route: route
            };
            return m;
        });
        state = {
            ...state,
            ...newState
        };
        let unmountedFetchers = [];
        let mountedFetchers = [];
        state.fetchers.forEach((fetcher, key)=>{
            if (fetcher.state === "idle") {
                if (fetchersQueuedForDeletion.has(key)) unmountedFetchers.push(key);
                else mountedFetchers.push(key);
            }
        });
        fetchersQueuedForDeletion.forEach((key)=>{
            if (!state.fetchers.has(key) && !fetchControllers.has(key)) unmountedFetchers.push(key);
        });
        if (subscribers.size === 0) bufferedInitialStateUpdate = {
            newErrors: newState.errors ?? null
        };
        [
            ...subscribers
        ].forEach((subscriber)=>subscriber(state, {
                deletedFetchers: unmountedFetchers,
                newErrors: newState.errors ?? null,
                viewTransitionOpts: opts.viewTransitionOpts,
                flushSync: opts.flushSync === true
            }));
        unmountedFetchers.forEach((key)=>deleteFetcher(state.fetchers, key));
        mountedFetchers.forEach((key)=>state.fetchers.delete(key));
    }
    function completeNavigation(location, newState, { flushSync: flushSync } = {}) {
        let isActionReload = state.actionData != null && state.navigation.formMethod != null && $9915aeece4ba52df$export$cbae47800eb95bc3(state.navigation.formMethod) && state.navigation.state === "loading" && location.state?._isRedirect !== true;
        let actionData;
        if (newState.actionData) {
            if (Object.keys(newState.actionData).length > 0) actionData = newState.actionData;
            else actionData = null;
        } else if (isActionReload) actionData = state.actionData;
        else actionData = null;
        let loaderData = newState.loaderData ? $9915aeece4ba52df$var$mergeLoaderData(state.loaderData, newState.loaderData, newState.matches || [], newState.errors) : state.loaderData;
        let blockers = state.blockers;
        if (blockers.size > 0 && !isUninterruptedRevalidation) {
            blockers = new Map(blockers);
            blockers.forEach((_, k)=>blockers.set(k, $9915aeece4ba52df$export$386d57f03f0b2883));
        }
        let restoreScrollPosition = isUninterruptedRevalidation ? false : getSavedScrollPosition(location, newState.matches || state.matches);
        let preventScrollReset = pendingPreventScrollReset === true || state.navigation.formMethod != null && $9915aeece4ba52df$export$cbae47800eb95bc3(state.navigation.formMethod) && location.state?._isRedirect !== true;
        dataRoutes.commitHmrRoutes();
        if (isUninterruptedRevalidation) ;
        else if (pendingAction === "POP") ;
        else if (pendingAction === "PUSH") init.history.push(location, location.state);
        else if (pendingAction === "REPLACE") init.history.replace(location, location.state);
        let viewTransitionOpts;
        if (pendingAction === "POP" && !isUninterruptedRevalidation && location !== state.location) {
            let priorPaths = appliedViewTransitions.get(state.location.pathname);
            if (priorPaths && priorPaths.has(location.pathname)) viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
            else if (appliedViewTransitions.has(location.pathname)) viewTransitionOpts = {
                currentLocation: location,
                nextLocation: state.location
            };
        } else if (pendingViewTransitionEnabled) {
            let toPaths = appliedViewTransitions.get(state.location.pathname);
            if (toPaths) toPaths.add(location.pathname);
            else {
                toPaths = new Set([
                    location.pathname
                ]);
                appliedViewTransitions.set(state.location.pathname, toPaths);
            }
            viewTransitionOpts = {
                currentLocation: state.location,
                nextLocation: location
            };
        }
        updateState({
            ...newState,
            actionData: actionData,
            loaderData: loaderData,
            historyAction: pendingAction,
            location: location,
            initialized: true,
            renderFallback: false,
            navigation: $9915aeece4ba52df$export$ed3e14b2f9e105d0,
            revalidation: "idle",
            restoreScrollPosition: restoreScrollPosition,
            preventScrollReset: preventScrollReset,
            blockers: blockers
        }, {
            viewTransitionOpts: viewTransitionOpts,
            flushSync: flushSync === true
        });
        pendingAction = "POP";
        pendingPreventScrollReset = false;
        pendingViewTransitionEnabled = false;
        isUninterruptedRevalidation = false;
        isRevalidationRequired = false;
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        pendingRevalidationDfd?.resolve();
        pendingRevalidationDfd = null;
    }
    async function navigate(to, opts) {
        pendingPopstateNavigationDfd?.resolve();
        pendingPopstateNavigationDfd = null;
        if (typeof to === "number") {
            if (!pendingPopstateNavigationDfd) pendingPopstateNavigationDfd = $9915aeece4ba52df$var$createDeferred();
            let promise = pendingPopstateNavigationDfd.promise;
            init.history.go(to);
            return promise;
        }
        let instrumentationNavigateMetaReceiver = (0, $faa62a10fd016f72$export$5579798e35f5560e)(router);
        let { path: path, submission: submission, error: error } = $9915aeece4ba52df$var$normalizeNavigateOptions(false, $9915aeece4ba52df$var$normalizeTo(state.location, state.matches, basename, to, opts?.fromRouteId, opts?.relative), opts);
        let maskPath;
        if (opts?.mask) {
            let partialPath = typeof opts.mask === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(opts.mask) : {
                ...state.location.mask,
                ...opts.mask
            };
            maskPath = {
                pathname: partialPath.pathname ?? "",
                search: partialPath.search ?? "",
                hash: partialPath.hash ?? ""
            };
            if ((0, $d4078e32874468f1$export$825a82322d91916e).test(maskPath.pathname)) throw new Error("External navigation is not allowed");
            else if (maskPath.pathname.startsWith("\\")) maskPath.pathname = maskPath.pathname.replace(/^\\+/, "/");
            (0, $0179caaefc35c7e3$export$6c8e41f66e7aa990)(typeof opts.mask === "string" ? opts.mask : (0, $072a56029499ae6c$export$fe53371bee54353d)(opts.mask), (0, $072a56029499ae6c$export$fe53371bee54353d)(maskPath), init.history.createURL("/"), "reject");
        }
        let currentLocation = state.location;
        let nextLocation = (0, $072a56029499ae6c$export$90c043f1c57770b8)(currentLocation, path, opts && opts.state, void 0, maskPath);
        nextLocation = {
            ...nextLocation,
            ...init.history.encodeLocation(nextLocation)
        };
        (0, $0179caaefc35c7e3$export$6c8e41f66e7aa990)(to == null ? init.history.createHref(state.location) : typeof to === "string" ? to : (0, $072a56029499ae6c$export$fe53371bee54353d)(to), init.history.createHref(nextLocation.mask || nextLocation), init.history.createURL("/"), "reject");
        let userReplace = opts && opts.replace != null ? opts.replace : void 0;
        let historyAction = "PUSH";
        if (userReplace === true) historyAction = "REPLACE";
        else if (userReplace === false) ;
        else if (submission != null && $9915aeece4ba52df$export$cbae47800eb95bc3(submission.formMethod) && submission.formAction === state.location.pathname + state.location.search) historyAction = "REPLACE";
        let preventScrollReset = opts && "preventScrollReset" in opts ? opts.preventScrollReset === true : void 0;
        let flushSync = (opts && opts.flushSync) === true;
        let blockerKey = shouldBlockNavigation({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        });
        if (blockerKey) {
            updateBlocker(blockerKey, {
                state: "blocked",
                location: nextLocation,
                proceed () {
                    updateBlocker(blockerKey, {
                        state: "proceeding",
                        proceed: void 0,
                        reset: void 0,
                        location: nextLocation
                    });
                    navigate(to, opts);
                },
                reset () {
                    let blockers = new Map(state.blockers);
                    blockers.set(blockerKey, $9915aeece4ba52df$export$386d57f03f0b2883);
                    updateState({
                        blockers: blockers
                    });
                }
            });
            return;
        }
        await startNavigation(historyAction, nextLocation, {
            submission: submission,
            pendingError: error,
            preventScrollReset: preventScrollReset,
            replace: opts && opts.replace,
            enableViewTransition: opts && opts.viewTransition,
            flushSync: flushSync,
            callSiteDefaultShouldRevalidate: opts && opts.defaultShouldRevalidate,
            instrumentationNavigateMetaReceiver: instrumentationNavigateMetaReceiver
        });
    }
    function revalidate() {
        if (!pendingRevalidationDfd) pendingRevalidationDfd = $9915aeece4ba52df$var$createDeferred();
        interruptActiveLoads();
        updateState({
            revalidation: "loading"
        });
        let promise = pendingRevalidationDfd.promise;
        if (state.navigation.state === "submitting") return promise;
        if (state.navigation.state === "idle") {
            startNavigation(state.historyAction, state.location, {
                startUninterruptedRevalidation: true
            });
            return promise;
        }
        startNavigation(pendingAction || state.historyAction, state.navigation.location, {
            overrideNavigation: state.navigation,
            enableViewTransition: pendingViewTransitionEnabled === true
        });
        return promise;
    }
    async function startNavigation(historyAction, location, opts) {
        pendingNavigationController && pendingNavigationController.abort();
        pendingNavigationController = null;
        pendingAction = historyAction;
        isUninterruptedRevalidation = (opts && opts.startUninterruptedRevalidation) === true;
        saveScrollPosition(state.location, state.matches);
        pendingPreventScrollReset = (opts && opts.preventScrollReset) === true;
        pendingViewTransitionEnabled = (opts && opts.enableViewTransition) === true;
        let matches = opts?.initialHydration && state.matches && state.matches.length > 0 && !initialMatchesIsFOW ? state.matches : dataRouteMatcher.match(location);
        let flushSync = (opts && opts.flushSync) === true;
        if (matches && state.initialized && !isRevalidationRequired && $9915aeece4ba52df$var$isHashChangeOnly(state.location, location) && !(opts && opts.submission && $9915aeece4ba52df$export$cbae47800eb95bc3(opts.submission.formMethod))) {
            completeNavigation(location, {
                matches: matches
            }, {
                flushSync: flushSync
            });
            return;
        }
        let fogOfWar = checkFogOfWar(matches, location.pathname);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (opts?.instrumentationNavigateMetaReceiver) {
            let meta = $9915aeece4ba52df$var$getInstrumentationNavigateMeta(init.history, location, matches);
            opts.instrumentationNavigateMetaReceiver(meta);
        }
        if (!matches) {
            let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
            completeNavigation(location, {
                matches: notFoundMatches,
                loaderData: {},
                errors: {
                    [route.id]: error
                }
            }, {
                flushSync: flushSync
            });
            return;
        }
        let loadingNavigation = opts && opts.overrideNavigation ? {
            ...opts.overrideNavigation,
            matches: matches,
            historyAction: historyAction
        } : void 0;
        pendingNavigationController = new AbortController();
        let request = $9915aeece4ba52df$var$createClientSideRequest(init.history, location, pendingNavigationController.signal, opts && opts.submission);
        let scopedContext = init.getContext ? await init.getContext() : new (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04)();
        let pendingActionResult;
        if (opts && opts.pendingError) pendingActionResult = [
            $9915aeece4ba52df$var$findNearestBoundary(matches).route.id,
            {
                type: "error",
                error: opts.pendingError
            }
        ];
        else if (opts && opts.submission && $9915aeece4ba52df$export$cbae47800eb95bc3(opts.submission.formMethod)) {
            let actionResult = await handleAction(request, location, opts.submission, matches, historyAction, scopedContext, fogOfWar.active, opts && opts.initialHydration === true, {
                replace: opts.replace,
                flushSync: flushSync
            });
            if (actionResult.shortCircuited) return;
            if (actionResult.pendingActionResult) {
                let [routeId, result] = actionResult.pendingActionResult;
                if ($9915aeece4ba52df$var$isErrorResult(result) && (0, $f1195701c85e5ce2$export$972111febbeef05b)(result.error) && result.error.status === 404) {
                    pendingNavigationController = null;
                    completeNavigation(location, {
                        matches: actionResult.matches,
                        loaderData: {},
                        errors: {
                            [routeId]: result.error
                        }
                    });
                    return;
                }
            }
            matches = actionResult.matches || matches;
            pendingActionResult = actionResult.pendingActionResult;
            loadingNavigation = $9915aeece4ba52df$var$getLoadingNavigation(location, matches, historyAction, opts.submission);
            flushSync = false;
            fogOfWar.active = false;
            request = $9915aeece4ba52df$var$createClientSideRequest(init.history, request.url, request.signal);
        }
        let { shortCircuited: shortCircuited, matches: updatedMatches, loaderData: loaderData, errors: errors, workingFetchers: workingFetchers } = await handleLoaders(request, location, matches, historyAction, scopedContext, fogOfWar.active, loadingNavigation, opts && opts.submission, opts && opts.fetcherSubmission, opts && opts.replace, opts && opts.initialHydration === true, flushSync, pendingActionResult, opts && opts.callSiteDefaultShouldRevalidate);
        if (shortCircuited) return;
        pendingNavigationController = null;
        completeNavigation(location, {
            matches: updatedMatches || matches,
            ...$9915aeece4ba52df$var$getActionDataForCommit(pendingActionResult),
            loaderData: loaderData,
            errors: errors,
            ...workingFetchers ? {
                fetchers: workingFetchers
            } : {}
        });
    }
    async function handleAction(request, location, submission, matches, historyAction, scopedContext, isFogOfWar, initialHydration, opts = {}) {
        interruptActiveLoads();
        updateState({
            navigation: $9915aeece4ba52df$var$getSubmittingNavigation(location, matches, historyAction, submission)
        }, {
            flushSync: opts.flushSync === true
        });
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $9915aeece4ba52df$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        pendingActionResult: [
                            route.id,
                            {
                                type: "error",
                                error: discoverResult.error
                            }
                        ]
                    };
                }
                let boundaryId = $9915aeece4ba52df$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    pendingActionResult: [
                        boundaryId,
                        {
                            type: "error",
                            error: discoverResult.error
                        }
                    ]
                };
            } else if (!discoverResult.matches) {
                let { notFoundMatches: notFoundMatches, error: error, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    pendingActionResult: [
                        route.id,
                        {
                            type: "error",
                            error: error
                        }
                    ]
                };
            } else matches = discoverResult.matches;
        }
        let result;
        let actionMatch = $9915aeece4ba52df$var$getTargetMatch(matches, location);
        if (!actionMatch.route.action && !actionMatch.route.lazy) result = {
            type: "error",
            error: $9915aeece4ba52df$var$getInternalRouterError(405, {
                method: request.method,
                pathname: location.pathname,
                routeId: actionMatch.route.id
            })
        };
        else {
            let results = await callDataStrategy(request, location, $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, initialHydration ? [] : hydrationRouteProperties, scopedContext), scopedContext, null);
            result = results[actionMatch.route.id];
            if (!result) {
                for (let match of matches)if (results[match.route.id]) {
                    result = results[match.route.id];
                    break;
                }
            }
            if (request.signal.aborted) return {
                shortCircuited: true
            };
        }
        if ($9915aeece4ba52df$var$isRedirectResult(result)) {
            let replace;
            if (opts && opts.replace != null) replace = opts.replace;
            else replace = $9915aeece4ba52df$var$normalizeRedirectLocation(result.response.headers.get("Location"), new URL(request.url), basename, init.history) === state.location.pathname + state.location.search;
            await startRedirectNavigation(request, result, true, {
                submission: submission,
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        if ($9915aeece4ba52df$var$isErrorResult(result)) {
            let boundaryMatch = $9915aeece4ba52df$var$findNearestBoundary(matches, actionMatch.route.id);
            if ((opts && opts.replace) !== true) pendingAction = "PUSH";
            return {
                matches: matches,
                pendingActionResult: [
                    boundaryMatch.route.id,
                    result,
                    actionMatch.route.id
                ]
            };
        }
        return {
            matches: matches,
            pendingActionResult: [
                actionMatch.route.id,
                result
            ]
        };
    }
    async function handleLoaders(request, location, matches, historyAction, scopedContext, isFogOfWar, overrideNavigation, submission, fetcherSubmission, replace, initialHydration, flushSync, pendingActionResult, callSiteDefaultShouldRevalidate) {
        let loadingNavigation = overrideNavigation || $9915aeece4ba52df$var$getLoadingNavigation(location, matches, historyAction, submission);
        let activeSubmission = submission || fetcherSubmission || $9915aeece4ba52df$var$getSubmissionFromNavigation(loadingNavigation);
        let shouldUpdateNavigationState = !isUninterruptedRevalidation && !initialHydration;
        if (isFogOfWar) {
            if (shouldUpdateNavigationState) {
                let actionData = getUpdatedActionData(pendingActionResult);
                updateState({
                    navigation: loadingNavigation,
                    ...actionData !== void 0 ? {
                        actionData: actionData
                    } : {}
                }, {
                    flushSync: flushSync
                });
            }
            let discoverResult = await discoverRoutes(matches, location.pathname, request.signal);
            if (discoverResult.type === "aborted") return {
                shortCircuited: true
            };
            else if (discoverResult.type === "error") {
                if (discoverResult.partialMatches.length === 0) {
                    let { matches: matches, route: route } = $9915aeece4ba52df$var$getShortCircuitMatches(dataRoutes.activeRoutes);
                    return {
                        matches: matches,
                        loaderData: {},
                        errors: {
                            [route.id]: discoverResult.error
                        }
                    };
                }
                let boundaryId = $9915aeece4ba52df$var$findNearestBoundary(discoverResult.partialMatches).route.id;
                return {
                    matches: discoverResult.partialMatches,
                    loaderData: {},
                    errors: {
                        [boundaryId]: discoverResult.error
                    }
                };
            } else if (!discoverResult.matches) {
                let { error: error, notFoundMatches: notFoundMatches, route: route } = handleNavigational404(location.pathname);
                return {
                    matches: notFoundMatches,
                    loaderData: {},
                    errors: {
                        [route.id]: error
                    }
                };
            } else matches = discoverResult.matches;
        }
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $9915aeece4ba52df$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, init.history, state, matches, activeSubmission, location, initialHydration ? [] : hydrationRouteProperties, initialHydration === true, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate);
        pendingNavigationLoadId = ++incrementingLoadId;
        if (!init.dataStrategy && !dsMatches.some((m)=>m.shouldLoad) && !dsMatches.some((m)=>m.route.middleware && m.route.middleware.length > 0) && revalidatingFetchers.length === 0) {
            let workingFetchers = new Map(state.fetchers);
            let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
            completeNavigation(location, {
                matches: matches,
                loaderData: {},
                errors: pendingActionResult && $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1]) ? {
                    [pendingActionResult[0]]: pendingActionResult[1].error
                } : null,
                ...$9915aeece4ba52df$var$getActionDataForCommit(pendingActionResult),
                ...didUpdateFetcherRedirects ? {
                    fetchers: workingFetchers
                } : {}
            }, {
                flushSync: flushSync
            });
            return {
                shortCircuited: true
            };
        }
        if (shouldUpdateNavigationState) {
            let updates = {};
            if (!isFogOfWar) {
                updates.navigation = loadingNavigation;
                let actionData = getUpdatedActionData(pendingActionResult);
                if (actionData !== void 0) updates.actionData = actionData;
            }
            if (revalidatingFetchers.length > 0) updates.fetchers = getUpdatedRevalidatingFetchers(revalidatingFetchers);
            updateState(updates, {
                flushSync: flushSync
            });
        }
        revalidatingFetchers.forEach((rf)=>{
            abortFetcher(rf.key);
            if (rf.controller) fetchControllers.set(rf.key, rf.controller);
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((f)=>abortFetcher(f.key));
        if (pendingNavigationController) pendingNavigationController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, request, location, scopedContext);
        if (request.signal.aborted) return {
            shortCircuited: true
        };
        if (pendingNavigationController) pendingNavigationController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        revalidatingFetchers.forEach((rf)=>fetchControllers.delete(rf.key));
        let redirect = $9915aeece4ba52df$var$findRedirect(loaderResults);
        if (redirect) {
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        redirect = $9915aeece4ba52df$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            await startRedirectNavigation(request, redirect.result, true, {
                replace: replace
            });
            return {
                shortCircuited: true
            };
        }
        let workingFetchers = new Map(state.fetchers);
        let { loaderData: loaderData, errors: errors } = $9915aeece4ba52df$var$processLoaderData(state, matches, loaderResults, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers);
        if (initialHydration && state.errors) errors = {
            ...state.errors,
            ...errors
        };
        let didUpdateFetcherRedirects = markFetchRedirectsDone(workingFetchers);
        let didAbortFetchLoads = abortStaleFetchLoads(pendingNavigationLoadId, workingFetchers);
        let shouldUpdateFetchers = didUpdateFetcherRedirects || didAbortFetchLoads || revalidatingFetchers.length > 0;
        return {
            matches: matches,
            loaderData: loaderData,
            errors: errors,
            ...shouldUpdateFetchers ? {
                workingFetchers: workingFetchers
            } : {}
        };
    }
    function getUpdatedActionData(pendingActionResult) {
        if (pendingActionResult && !$9915aeece4ba52df$var$isErrorResult(pendingActionResult[1])) return {
            [pendingActionResult[0]]: pendingActionResult[1].data
        };
        else if (state.actionData) {
            if (Object.keys(state.actionData).length === 0) return null;
            else return state.actionData;
        }
    }
    function getUpdatedRevalidatingFetchers(revalidatingFetchers) {
        let workingFetchers = new Map(state.fetchers);
        revalidatingFetchers.forEach((rf)=>{
            let fetcher = workingFetchers.get(rf.key);
            let revalidatingFetcher = $9915aeece4ba52df$var$getLoadingFetcher(void 0, fetcher ? fetcher.data : void 0);
            workingFetchers.set(rf.key, revalidatingFetcher);
        });
        return workingFetchers;
    }
    async function fetch(key, routeId, href, opts) {
        abortFetcher(key);
        let flushSync = (opts && opts.flushSync) === true;
        let instrumentationResultMetaReceiver = (0, $faa62a10fd016f72$export$5579798e35f5560e)(router);
        let normalizedPath = $9915aeece4ba52df$var$normalizeTo(state.location, state.matches, basename, href, routeId, opts?.relative);
        let matches = dataRouteMatcher.match(normalizedPath);
        let fogOfWar = checkFogOfWar(matches, normalizedPath);
        if (fogOfWar.active && fogOfWar.matches) matches = fogOfWar.matches;
        if (instrumentationResultMetaReceiver) instrumentationResultMetaReceiver($9915aeece4ba52df$var$getInstrumentationNavigateMeta(init.history, normalizedPath, matches));
        if (!matches) {
            setFetcherError(key, routeId, $9915aeece4ba52df$var$getInternalRouterError(404, {
                pathname: normalizedPath
            }), {
                flushSync: flushSync
            });
            return;
        }
        let { path: path, submission: submission, error: error } = $9915aeece4ba52df$var$normalizeNavigateOptions(true, normalizedPath, opts);
        if (error) {
            setFetcherError(key, routeId, error, {
                flushSync: flushSync
            });
            return;
        }
        let scopedContext = init.getContext ? await init.getContext() : new (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04)();
        let preventScrollReset = (opts && opts.preventScrollReset) === true;
        if (submission && $9915aeece4ba52df$export$cbae47800eb95bc3(submission.formMethod)) {
            await handleFetcherAction(key, routeId, path, matches, scopedContext, fogOfWar.active, flushSync, preventScrollReset, submission, opts && opts.defaultShouldRevalidate);
            return;
        }
        let loadMatch = {
            routeId: routeId,
            path: path,
            isDiscovering: fogOfWar.active
        };
        fetchLoadMatches.set(key, loadMatch);
        await handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission);
    }
    async function handleFetcherAction(key, routeId, path, requestMatches, scopedContext, isFogOfWar, flushSync, preventScrollReset, submission, callSiteDefaultShouldRevalidate) {
        interruptActiveLoads();
        fetchLoadMatches.delete(key);
        updateFetcherState(key, $9915aeece4ba52df$var$getSubmittingFetcher(submission, state.fetchers.get(key)), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9915aeece4ba52df$var$createClientSideRequest(init.history, path, abortController.signal, submission);
        if (isFogOfWar) {
            let discoverResult = await discoverRoutes(requestMatches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9915aeece4ba52df$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else requestMatches = discoverResult.matches;
        }
        let match = $9915aeece4ba52df$var$getTargetMatch(requestMatches, path);
        if (!match.route.action && !match.route.lazy) {
            setFetcherError(key, routeId, $9915aeece4ba52df$var$getInternalRouterError(405, {
                method: submission.formMethod,
                pathname: path,
                routeId: routeId
            }), {
                flushSync: flushSync
            });
            return;
        }
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let fetchMatches = $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, requestMatches, match, hydrationRouteProperties, scopedContext);
        let actionResults = await callDataStrategy(fetchRequest, path, fetchMatches, scopedContext, key);
        let actionResult = actionResults[match.route.id];
        if (!actionResult) {
            for (let match of fetchMatches)if (actionResults[match.route.id]) {
                actionResult = actionResults[match.route.id];
                break;
            }
        }
        if (fetchRequest.signal.aborted) {
            if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
            return;
        }
        if (fetchersQueuedForDeletion.has(key)) {
            if ($9915aeece4ba52df$var$isRedirectResult(actionResult) || $9915aeece4ba52df$var$isErrorResult(actionResult)) {
                updateFetcherState(key, $9915aeece4ba52df$var$getDoneFetcher(void 0));
                return;
            }
        } else {
            if ($9915aeece4ba52df$var$isRedirectResult(actionResult)) {
                fetchControllers.delete(key);
                if (pendingNavigationLoadId > originatingLoadId) {
                    updateFetcherState(key, $9915aeece4ba52df$var$getDoneFetcher(void 0));
                    return;
                } else {
                    fetchRedirectIds.add(key);
                    updateFetcherState(key, $9915aeece4ba52df$var$getLoadingFetcher(submission));
                    return startRedirectNavigation(fetchRequest, actionResult, false, {
                        fetcherSubmission: submission,
                        preventScrollReset: preventScrollReset
                    });
                }
            }
            if ($9915aeece4ba52df$var$isErrorResult(actionResult)) {
                setFetcherError(key, routeId, actionResult.error);
                return;
            }
        }
        let nextLocation = state.navigation.location || state.location;
        let revalidationRequest = $9915aeece4ba52df$var$createClientSideRequest(init.history, nextLocation, abortController.signal);
        let matches = state.navigation.state !== "idle" ? dataRouteMatcher.match(state.navigation.location) : state.matches;
        (0, $072a56029499ae6c$export$f5708dca728d7177)(matches, "Didn't find any matches after fetcher action");
        let loadId = ++incrementingLoadId;
        fetchReloadIds.set(key, loadId);
        let { dsMatches: dsMatches, revalidatingFetchers: revalidatingFetchers } = $9915aeece4ba52df$var$getMatchesToLoad(revalidationRequest, scopedContext, mapRouteProperties, manifest, init.history, state, matches, submission, nextLocation, hydrationRouteProperties, false, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, [
            match.route.id,
            actionResult
        ], callSiteDefaultShouldRevalidate);
        let loadFetcher = $9915aeece4ba52df$var$getLoadingFetcher(submission, actionResult.data);
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, loadFetcher);
        revalidatingFetchers.filter((rf)=>rf.key !== key).forEach((rf)=>{
            let staleKey = rf.key;
            let existingFetcher = workingFetchers.get(staleKey);
            let revalidatingFetcher = $9915aeece4ba52df$var$getLoadingFetcher(void 0, existingFetcher ? existingFetcher.data : void 0);
            workingFetchers.set(staleKey, revalidatingFetcher);
            abortFetcher(staleKey);
            if (rf.controller) fetchControllers.set(staleKey, rf.controller);
        });
        updateState({
            fetchers: workingFetchers
        });
        let abortPendingFetchRevalidations = ()=>revalidatingFetchers.forEach((rf)=>abortFetcher(rf.key));
        abortController.signal.addEventListener("abort", abortPendingFetchRevalidations);
        let { loaderResults: loaderResults, fetcherResults: fetcherResults } = await callLoadersAndMaybeResolveData(dsMatches, revalidatingFetchers, revalidationRequest, nextLocation, scopedContext);
        if (abortController.signal.aborted) {
            if (fetchReloadIds.get(key) === loadId) fetchReloadIds.delete(key);
            return;
        }
        abortController.signal.removeEventListener("abort", abortPendingFetchRevalidations);
        fetchReloadIds.delete(key);
        fetchControllers.delete(key);
        revalidatingFetchers.forEach((r)=>fetchControllers.delete(r.key));
        let fetcherIsMounted = state.fetchers.has(key);
        let getRedirectStateWithDoneFetcher = (s)=>{
            if (!fetcherIsMounted) return s;
            let workingFetchers = new Map(s.fetchers);
            workingFetchers.set(key, $9915aeece4ba52df$var$getDoneFetcher(actionResult.data));
            return {
                ...s,
                fetchers: workingFetchers
            };
        };
        let redirect = $9915aeece4ba52df$var$findRedirect(loaderResults);
        if (redirect) {
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        redirect = $9915aeece4ba52df$var$findRedirect(fetcherResults);
        if (redirect) {
            fetchRedirectIds.add(redirect.key);
            state = getRedirectStateWithDoneFetcher(state);
            return startRedirectNavigation(revalidationRequest, redirect.result, false, {
                preventScrollReset: preventScrollReset
            });
        }
        let finalFetchers = new Map(state.fetchers);
        if (fetcherIsMounted) finalFetchers.set(key, $9915aeece4ba52df$var$getDoneFetcher(actionResult.data));
        let { loaderData: loaderData, errors: errors } = $9915aeece4ba52df$var$processLoaderData(state, matches, loaderResults, void 0, revalidatingFetchers, fetcherResults, finalFetchers);
        abortStaleFetchLoads(loadId, finalFetchers);
        if (state.navigation.state === "loading" && loadId > pendingNavigationLoadId) {
            (0, $072a56029499ae6c$export$f5708dca728d7177)(pendingAction, "Expected pending action");
            pendingNavigationController && pendingNavigationController.abort();
            completeNavigation(state.navigation.location, {
                matches: matches,
                loaderData: loaderData,
                errors: errors,
                fetchers: finalFetchers
            });
        } else {
            updateState({
                errors: errors,
                loaderData: $9915aeece4ba52df$var$mergeLoaderData(state.loaderData, loaderData, matches, errors),
                fetchers: finalFetchers
            });
            isRevalidationRequired = false;
        }
    }
    async function handleFetcherLoader(key, loadMatch, matches, scopedContext, flushSync, preventScrollReset, submission) {
        let { routeId: routeId, path: path } = loadMatch;
        let existingFetcher = state.fetchers.get(key);
        updateFetcherState(key, $9915aeece4ba52df$var$getLoadingFetcher(submission, existingFetcher ? existingFetcher.data : void 0), {
            flushSync: flushSync
        });
        let abortController = new AbortController();
        let fetchRequest = $9915aeece4ba52df$var$createClientSideRequest(init.history, path, abortController.signal);
        if (loadMatch.isDiscovering) {
            let discoverResult = await discoverRoutes(matches, new URL(fetchRequest.url).pathname, fetchRequest.signal, key);
            if (discoverResult.type === "aborted") return;
            else if (discoverResult.type === "error") {
                setFetcherError(key, routeId, discoverResult.error, {
                    flushSync: flushSync
                });
                return;
            } else if (!discoverResult.matches) {
                setFetcherError(key, routeId, $9915aeece4ba52df$var$getInternalRouterError(404, {
                    pathname: path
                }), {
                    flushSync: flushSync
                });
                return;
            } else {
                matches = discoverResult.matches;
                loadMatch.isDiscovering = false;
            }
        }
        let match = $9915aeece4ba52df$var$getTargetMatch(matches, path);
        fetchControllers.set(key, abortController);
        let originatingLoadId = incrementingLoadId;
        let results = await callDataStrategy(fetchRequest, path, $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, path, matches, match, hydrationRouteProperties, scopedContext), scopedContext, key);
        let result = results[match.route.id];
        if (!result) {
            for (let match of matches)if (results[match.route.id]) {
                result = results[match.route.id];
                break;
            }
        }
        if (fetchControllers.get(key) === abortController) fetchControllers.delete(key);
        if (fetchRequest.signal.aborted) return;
        if (fetchersQueuedForDeletion.has(key)) {
            updateFetcherState(key, $9915aeece4ba52df$var$getDoneFetcher(void 0));
            return;
        }
        if ($9915aeece4ba52df$var$isRedirectResult(result)) {
            if (pendingNavigationLoadId > originatingLoadId) {
                updateFetcherState(key, $9915aeece4ba52df$var$getDoneFetcher(void 0));
                return;
            } else {
                fetchRedirectIds.add(key);
                await startRedirectNavigation(fetchRequest, result, false, {
                    preventScrollReset: preventScrollReset
                });
                return;
            }
        }
        if ($9915aeece4ba52df$var$isErrorResult(result)) {
            setFetcherError(key, routeId, result.error);
            return;
        }
        updateFetcherState(key, $9915aeece4ba52df$var$getDoneFetcher(result.data));
    }
    /**
	* Utility function to handle redirects returned from an action or loader.
	* Normally, a redirect "replaces" the navigation that triggered it.  So, for
	* example:
	*
	*  - user is on /a
	*  - user clicks a link to /b
	*  - loader for /b redirects to /c
	*
	* In a non-JS app the browser would track the in-flight navigation to /b and
	* then replace it with /c when it encountered the redirect response.  In
	* the end it would only ever update the URL bar with /c.
	*
	* In client-side routing using pushState/replaceState, we aim to emulate
	* this behavior and we also do not update history until the end of the
	* navigation (including processed redirects).  This means that we never
	* actually touch history until we've processed redirects, so we just use
	* the history action from the original navigation (PUSH or REPLACE).
	*/ async function startRedirectNavigation(request, redirect, isNavigation, { submission: submission, fetcherSubmission: fetcherSubmission, preventScrollReset: preventScrollReset, replace: replace } = {}) {
        if (!isNavigation) {
            pendingPopstateNavigationDfd?.resolve();
            pendingPopstateNavigationDfd = null;
        }
        if (redirect.response.headers.has("X-Remix-Revalidate")) isRevalidationRequired = true;
        let location = redirect.response.headers.get("Location");
        (0, $072a56029499ae6c$export$f5708dca728d7177)(location, "Expected a Location header on the redirect Response");
        let originalLocation = location;
        let currentUrl = new URL(request.url);
        location = $9915aeece4ba52df$var$normalizeRedirectLocation(location, currentUrl, basename, init.history);
        (0, $0179caaefc35c7e3$export$6c8e41f66e7aa990)(originalLocation, location, currentUrl, "allow-explicit");
        let redirectLocation = (0, $072a56029499ae6c$export$90c043f1c57770b8)(state.location, location, {
            _isRedirect: true
        });
        if (isBrowser) {
            let isDocumentReload = false;
            if (redirect.response.headers.has("X-Remix-Reload-Document")) isDocumentReload = true;
            else if ((0, $f1195701c85e5ce2$export$a1cbf2de32a9fd1)(location)) {
                const url = (0, $072a56029499ae6c$export$e2450fce17852bf2)(routerWindow, location, true);
                isDocumentReload = url.origin !== routerWindow.location.origin || (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(url.pathname, basename) == null;
            }
            if (isDocumentReload) {
                if (replace) routerWindow.location.replace(location);
                else routerWindow.location.assign(location);
                return;
            }
        }
        pendingNavigationController = null;
        let redirectNavigationType = replace === true || redirect.response.headers.has("X-Remix-Replace") ? "REPLACE" : "PUSH";
        let { formMethod: formMethod, formAction: formAction, formEncType: formEncType } = state.navigation;
        if (!submission && !fetcherSubmission && formMethod && formAction && formEncType) submission = $9915aeece4ba52df$var$getSubmissionFromNavigation(state.navigation);
        let activeSubmission = submission || fetcherSubmission;
        if ($9915aeece4ba52df$var$redirectPreserveMethodStatusCodes.has(redirect.response.status) && activeSubmission && $9915aeece4ba52df$export$cbae47800eb95bc3(activeSubmission.formMethod)) await startNavigation(redirectNavigationType, redirectLocation, {
            submission: {
                ...activeSubmission,
                formAction: location
            },
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
        else await startNavigation(redirectNavigationType, redirectLocation, {
            overrideNavigation: $9915aeece4ba52df$var$getLoadingNavigation(redirectLocation, [], redirectNavigationType, submission),
            fetcherSubmission: fetcherSubmission,
            preventScrollReset: preventScrollReset || pendingPreventScrollReset,
            enableViewTransition: isNavigation ? pendingViewTransitionEnabled : void 0
        });
    }
    async function callDataStrategy(request, path, matches, scopedContext, fetcherKey) {
        let results;
        let dataResults = {};
        try {
            results = await $9915aeece4ba52df$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, false);
        } catch (e) {
            matches.filter((m)=>m.shouldLoad).forEach((m)=>{
                dataResults[m.route.id] = {
                    type: "error",
                    error: e
                };
            });
            return dataResults;
        }
        if (request.signal.aborted) return dataResults;
        if (!$9915aeece4ba52df$export$cbae47800eb95bc3(request.method)) for (let match of matches){
            if (results[match.route.id]?.type === "error") break;
            if (!results.hasOwnProperty(match.route.id) && !state.loaderData.hasOwnProperty(match.route.id) && (!state.errors || !state.errors.hasOwnProperty(match.route.id)) && match.shouldCallHandler()) results[match.route.id] = {
                type: "error",
                result: /* @__PURE__ */ new Error(`No result returned from dataStrategy for route ${match.route.id}`)
            };
        }
        for (let [routeId, result] of Object.entries(results))if ($9915aeece4ba52df$var$isRedirectDataStrategyResult(result)) {
            let response = result.result;
            dataResults[routeId] = {
                type: "redirect",
                response: $9915aeece4ba52df$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename)
            };
        } else dataResults[routeId] = await $9915aeece4ba52df$var$convertDataStrategyResultToDataResult(result);
        return dataResults;
    }
    async function callLoadersAndMaybeResolveData(matches, fetchersToLoad, request, location, scopedContext) {
        let loaderResultsPromise = callDataStrategy(request, location, matches, scopedContext, null);
        let fetcherResultsPromise = Promise.all(fetchersToLoad.map(async (f)=>{
            if (f.matches && f.match && f.request && f.controller) {
                let result = (await callDataStrategy(f.request, f.path, f.matches, scopedContext, f.key))[f.match.route.id];
                return {
                    [f.key]: result
                };
            } else return Promise.resolve({
                [f.key]: {
                    type: "error",
                    error: $9915aeece4ba52df$var$getInternalRouterError(404, {
                        pathname: f.path
                    })
                }
            });
        }));
        return {
            loaderResults: await loaderResultsPromise,
            fetcherResults: (await fetcherResultsPromise).reduce((acc, r)=>Object.assign(acc, r), {})
        };
    }
    function interruptActiveLoads() {
        isRevalidationRequired = true;
        fetchLoadMatches.forEach((_, key)=>{
            if (fetchControllers.has(key)) cancelledFetcherLoads.add(key);
            abortFetcher(key);
        });
    }
    function updateFetcherState(key, fetcher, opts = {}) {
        let workingFetchers = new Map(state.fetchers);
        workingFetchers.set(key, fetcher);
        updateState({
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function setFetcherError(key, routeId, error, opts = {}) {
        let boundaryMatch = $9915aeece4ba52df$var$findNearestBoundary(state.matches, routeId);
        let workingFetchers = new Map(state.fetchers);
        deleteFetcher(workingFetchers, key);
        updateState({
            errors: {
                [boundaryMatch.route.id]: error
            },
            fetchers: workingFetchers
        }, {
            flushSync: (opts && opts.flushSync) === true
        });
    }
    function getFetcher(key) {
        activeFetchers.set(key, (activeFetchers.get(key) || 0) + 1);
        if (fetchersQueuedForDeletion.has(key)) fetchersQueuedForDeletion.delete(key);
        return state.fetchers.get(key) || $9915aeece4ba52df$export$52eace9c284d3585;
    }
    function resetFetcher(key, opts) {
        abortFetcher(key, opts?.reason);
        updateFetcherState(key, $9915aeece4ba52df$var$getDoneFetcher(null));
    }
    function deleteFetcher(fetchers, key) {
        let fetcher = state.fetchers.get(key);
        if (fetchControllers.has(key) && !(fetcher && fetcher.state === "loading" && fetchReloadIds.has(key))) abortFetcher(key);
        fetchLoadMatches.delete(key);
        fetchReloadIds.delete(key);
        fetchRedirectIds.delete(key);
        fetchersQueuedForDeletion.delete(key);
        cancelledFetcherLoads.delete(key);
        fetchers.delete(key);
    }
    function queueFetcherForDeletion(key) {
        let count = (activeFetchers.get(key) || 0) - 1;
        if (count <= 0) {
            activeFetchers.delete(key);
            fetchersQueuedForDeletion.add(key);
        } else activeFetchers.set(key, count);
        updateState({
            fetchers: new Map(state.fetchers)
        });
    }
    function abortFetcher(key, reason) {
        let controller = fetchControllers.get(key);
        if (controller) {
            controller.abort(reason);
            fetchControllers.delete(key);
        }
    }
    function markFetchersDone(keys, fetchers) {
        for (let key of keys){
            let fetcher = fetchers.get(key);
            (0, $072a56029499ae6c$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            let doneFetcher = $9915aeece4ba52df$var$getDoneFetcher(fetcher.data);
            fetchers.set(key, doneFetcher);
        }
    }
    function markFetchRedirectsDone(fetchers) {
        let doneKeys = [];
        let didUpdateFetchers = false;
        for (let key of fetchRedirectIds){
            let fetcher = fetchers.get(key);
            (0, $072a56029499ae6c$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                fetchRedirectIds.delete(key);
                doneKeys.push(key);
                didUpdateFetchers = true;
            }
        }
        markFetchersDone(doneKeys, fetchers);
        return didUpdateFetchers;
    }
    function abortStaleFetchLoads(landedId, fetchers) {
        let yeetedKeys = [];
        for (let [key, id] of fetchReloadIds)if (id < landedId) {
            let fetcher = fetchers.get(key);
            (0, $072a56029499ae6c$export$f5708dca728d7177)(fetcher, `Expected fetcher: ${key}`);
            if (fetcher.state === "loading") {
                abortFetcher(key);
                fetchReloadIds.delete(key);
                yeetedKeys.push(key);
            }
        }
        markFetchersDone(yeetedKeys, fetchers);
        return yeetedKeys.length > 0;
    }
    function getBlocker(key, fn) {
        let blocker = state.blockers.get(key) || $9915aeece4ba52df$export$386d57f03f0b2883;
        if (blockerFunctions.get(key) !== fn) blockerFunctions.set(key, fn);
        return blocker;
    }
    function deleteBlocker(key) {
        state.blockers.delete(key);
        blockerFunctions.delete(key);
    }
    function updateBlocker(key, newBlocker) {
        let blocker = state.blockers.get(key) || $9915aeece4ba52df$export$386d57f03f0b2883;
        (0, $072a56029499ae6c$export$f5708dca728d7177)(blocker.state === "unblocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "blocked" || blocker.state === "blocked" && newBlocker.state === "proceeding" || blocker.state === "blocked" && newBlocker.state === "unblocked" || blocker.state === "proceeding" && newBlocker.state === "unblocked", `Invalid blocker state transition: ${blocker.state} -> ${newBlocker.state}`);
        let blockers = new Map(state.blockers);
        blockers.set(key, newBlocker);
        updateState({
            blockers: blockers
        });
    }
    function shouldBlockNavigation({ currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction }) {
        if (blockerFunctions.size === 0) return;
        if (blockerFunctions.size > 1) (0, $072a56029499ae6c$export$491112666e282270)(false, "A router only supports one blocker at a time");
        let entries = Array.from(blockerFunctions.entries());
        let [blockerKey, blockerFunction] = entries[entries.length - 1];
        let blocker = state.blockers.get(blockerKey);
        if (blocker && blocker.state === "proceeding") return;
        if (blockerFunction({
            currentLocation: currentLocation,
            nextLocation: nextLocation,
            historyAction: historyAction
        })) return blockerKey;
    }
    function handleNavigational404(pathname) {
        let error = $9915aeece4ba52df$var$getInternalRouterError(404, {
            pathname: pathname
        });
        let routesToUse = dataRoutes.activeRoutes;
        let { matches: matches, route: route } = $9915aeece4ba52df$var$getShortCircuitMatches(routesToUse);
        return {
            notFoundMatches: matches,
            route: route,
            error: error
        };
    }
    function enableScrollRestoration(positions, getPosition, getKey) {
        savedScrollPositions = positions;
        getScrollPosition = getPosition;
        getScrollRestorationKey = getKey || null;
        if (!initialScrollRestored && state.navigation === $9915aeece4ba52df$export$ed3e14b2f9e105d0) {
            initialScrollRestored = true;
            let y = getSavedScrollPosition(state.location, state.matches);
            if (y != null) updateState({
                restoreScrollPosition: y
            });
        }
        return ()=>{
            savedScrollPositions = null;
            getScrollPosition = null;
            getScrollRestorationKey = null;
        };
    }
    function getScrollKey(location, matches) {
        if (getScrollRestorationKey) return getScrollRestorationKey(location, matches.map((m)=>(0, $f1195701c85e5ce2$export$fcf533780bf49ee2)(m, state.loaderData))) || location.key;
        return location.key;
    }
    function saveScrollPosition(location, matches) {
        if (savedScrollPositions && getScrollPosition) {
            let key = getScrollKey(location, matches);
            savedScrollPositions[key] = getScrollPosition();
        }
    }
    function getSavedScrollPosition(location, matches) {
        if (savedScrollPositions) {
            let key = getScrollKey(location, matches);
            let y = savedScrollPositions[key];
            if (typeof y === "number") return y;
        }
        return null;
    }
    function checkFogOfWar(matches, pathname) {
        if (init.patchRoutesOnNavigation) {
            if (!matches) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true) || []
            };
            else if (Object.keys(matches[0].params).length > 0) return {
                active: true,
                matches: dataRouteMatcher.match(pathname, true)
            };
        }
        return {
            active: false,
            matches: null
        };
    }
    async function discoverRoutes(matches, pathname, signal, fetcherKey) {
        if (!init.patchRoutesOnNavigation) return {
            type: "success",
            matches: matches
        };
        let partialMatches = matches;
        while(true){
            let localManifest = manifest;
            try {
                await init.patchRoutesOnNavigation({
                    signal: signal,
                    path: pathname,
                    matches: partialMatches,
                    fetcherKey: fetcherKey,
                    patch: (routeId, children)=>{
                        if (signal.aborted) return;
                        $9915aeece4ba52df$var$patchRoutesImpl(routeId, children, dataRoutes, localManifest, mapRouteProperties, false);
                    }
                });
            } catch (e) {
                return {
                    type: "error",
                    error: e,
                    partialMatches: partialMatches
                };
            }
            if (signal.aborted) return {
                type: "aborted"
            };
            let newMatches = dataRouteMatcher.match(pathname);
            let newPartialMatches = null;
            if (newMatches) {
                if (Object.keys(newMatches[0].params).length === 0) return {
                    type: "success",
                    matches: newMatches
                };
                else {
                    newPartialMatches = dataRouteMatcher.match(pathname, true);
                    if (!(newPartialMatches && partialMatches.length < newPartialMatches.length && compareMatches(partialMatches, newPartialMatches.slice(0, partialMatches.length)))) return {
                        type: "success",
                        matches: newMatches
                    };
                }
            }
            if (!newPartialMatches) newPartialMatches = dataRouteMatcher.match(pathname, true);
            if (!newPartialMatches || compareMatches(partialMatches, newPartialMatches)) return {
                type: "success",
                matches: null
            };
            partialMatches = newPartialMatches;
        }
    }
    function compareMatches(a, b) {
        return a.length === b.length && a.every((m, i)=>m.route.id === b[i].route.id);
    }
    function _internalSetRoutes(newRoutes) {
        manifest = {};
        dataRoutes.setHmrRoutes((0, $f1195701c85e5ce2$export$87cb1a9238dc3fba)(newRoutes, mapRouteProperties, void 0, manifest));
    }
    function patchRoutes(routeId, children, unstable_allowElementMutations = false) {
        $9915aeece4ba52df$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, unstable_allowElementMutations);
        if (!dataRoutes.hasHMRRoutes) updateState({});
    }
    router = {
        get basename () {
            return basename;
        },
        get future () {
            return future;
        },
        get state () {
            return state;
        },
        get routes () {
            return dataRoutes.stableRoutes;
        },
        match (locationArg) {
            return dataRouteMatcher.match(locationArg);
        },
        get manifest () {
            return manifest;
        },
        get window () {
            return routerWindow;
        },
        initialize: initialize,
        subscribe: subscribe,
        enableScrollRestoration: enableScrollRestoration,
        navigate: navigate,
        fetch: fetch,
        revalidate: revalidate,
        createHref: (to)=>init.history.createHref(to),
        createURL: (to)=>init.history.createURL(to),
        encodeLocation: (to)=>init.history.encodeLocation(to),
        getFetcher: getFetcher,
        resetFetcher: resetFetcher,
        deleteFetcher: queueFetcherForDeletion,
        dispose: dispose,
        getBlocker: getBlocker,
        deleteBlocker: deleteBlocker,
        patchRoutes: patchRoutes,
        _internalFetchControllers: fetchControllers,
        _internalSetRoutes: _internalSetRoutes,
        _internalSetStateDoNotUseOrYouWillBreakYourApp (newState) {
            updateState(newState);
        }
    };
    if (init.instrumentations) router = (0, $faa62a10fd016f72$export$ac4df491f31cbbfc)(router, init.instrumentations.map((i)=>i.router).filter(Boolean));
    return router;
}
/**
* Create a static handler to perform server-side data loading
*
* @example
* export async function handleRequest(request: Request) {
*   let { query, dataRoutes } = createStaticHandler(routes);
*   let context = await query(request);
*
*   if (context instanceof Response) {
*     return context;
*   }
*
*   let router = createStaticRouter(dataRoutes, context);
*   return new Response(
*     ReactDOMServer.renderToString(<StaticRouterProvider ... />),
*     { headers: { "Content-Type": "text/html" } }
*   );
* }
*
* @public
* @category Data Routers
* @mode data
* @param routes The {@link RouteObject | route objects} to create a static
* handler for
* @param opts Options
* @param opts.basename The base URL for the static handler (default: `/`)
* @param opts.future Future flags for the static handler
* @returns A static handler that can be used to query data for the provided
* routes
*/ function $9915aeece4ba52df$export$3336b097a6fbc59a(routes, opts) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)(routes.length > 0, "You must provide a non-empty routes array to createStaticHandler");
    let manifest = {};
    let basename = (opts ? opts.basename : null) || "/";
    let _mapRouteProperties = opts?.mapRouteProperties;
    let mapRouteProperties = _mapRouteProperties ? _mapRouteProperties : ()=>({});
    let dataRouteMatcher = $9915aeece4ba52df$export$5e64b3b9d7e2ec36({
        ...opts?.future
    }, basename);
    if (opts?.instrumentations) {
        let instrumentations = opts.instrumentations;
        mapRouteProperties = (route)=>{
            return {
                ..._mapRouteProperties?.(route),
                ...(0, $faa62a10fd016f72$export$3cb8f5f9ecc770ef)(instrumentations.map((i)=>i.route).filter(Boolean), route)
            };
        };
    }
    let dataRoutes = (0, $f1195701c85e5ce2$export$87cb1a9238dc3fba)(routes, mapRouteProperties, void 0, manifest);
    dataRouteMatcher.update(dataRoutes);
    let match = (locationArg)=>dataRouteMatcher.match(locationArg);
    /**
	* The query() method is intended for document requests, in which we want to
	* call an optional action and potentially multiple loaders for all nested
	* routes.  It returns a StaticHandlerContext object, which is very similar
	* to the router state (location, loaderData, actionData, errors, etc.) and
	* also adds SSR-specific information such as the statusCode and headers
	* from action/loaders Responses.
	*
	* It _should_ never throw and should report all errors through the
	* returned handlerContext.errors object, properly associating errors to
	* their error boundary.  Additionally, it tracks _deepestRenderedBoundaryId
	* which can be used to emulate React error boundaries during SSR by performing
	* a second pass only down to the boundaryId.
	*
	* The one exception where we do not return a StaticHandlerContext is when a
	* redirect response is returned or thrown from any action/loader.  We
	* propagate that out and return the raw Response so the HTTP server can
	* return it directly.
	*
	* - `opts.requestContext` is an optional server context that will be passed
	*   to actions/loaders in the `context` parameter
	* - `opts.skipLoaderErrorBubbling` is an optional parameter that will prevent
	*   the bubbling of errors which allows single-fetch-type implementations
	*   where the client will handle the bubbling and we may need to return data
	*   for the handling route
	*/ async function query(request, { requestContext: requestContext, filterMatchesToLoad: filterMatchesToLoad, skipLoaderErrorBubbling: skipLoaderErrorBubbling, skipRevalidation: skipRevalidation, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $9915aeece4ba52df$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $072a56029499ae6c$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04)();
        if (!$9915aeece4ba52df$var$isValidMethod(method) && method !== "HEAD") {
            let error = $9915aeece4ba52df$var$getInternalRouterError(405, {
                method: method
            });
            let { matches: methodNotAllowedMatches, route: route } = $9915aeece4ba52df$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: methodNotAllowedMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        } else if (!matches) {
            let error = $9915aeece4ba52df$var$getInternalRouterError(404, {
                pathname: location.pathname
            });
            let { matches: notFoundMatches, route: route } = $9915aeece4ba52df$var$getShortCircuitMatches(dataRoutes);
            let staticContext = {
                basename: basename,
                location: location,
                matches: notFoundMatches,
                loaderData: {},
                actionData: null,
                errors: {
                    [route.id]: error
                },
                statusCode: error.status,
                loaderHeaders: {},
                actionHeaders: {},
                _match: match
            };
            return generateMiddlewareResponse ? generateMiddlewareResponse(()=>Promise.resolve(staticContext)) : staticContext;
        }
        if (generateMiddlewareResponse) {
            (0, $072a56029499ae6c$export$f5708dca728d7177)(requestContext instanceof (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.query()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            try {
                await $9915aeece4ba52df$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
                let renderedStaticContext;
                let response = await $9915aeece4ba52df$var$runServerMiddlewarePipeline({
                    request: request,
                    url: (0, $f1195701c85e5ce2$export$141d98e45b4b08e4)(request, location),
                    pattern: (0, $f1195701c85e5ce2$export$d738435097971c09)(matches),
                    matches: matches,
                    params: matches[0].params,
                    context: requestContext
                }, async ()=>{
                    return await generateMiddlewareResponse(async (revalidationRequest, opts = {})=>{
                        let result = await queryImpl(revalidationRequest, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, "filterMatchesToLoad" in opts ? opts.filterMatchesToLoad ?? null : filterMatchesToLoad ?? null, skipRevalidation === true);
                        if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(result)) return result;
                        renderedStaticContext = {
                            location: location,
                            basename: basename,
                            ...result,
                            _match: match
                        };
                        return renderedStaticContext;
                    });
                }, async (error, routeId)=>{
                    if ($9915aeece4ba52df$export$6e80290866a84dd4(error)) return error;
                    if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(error)) try {
                        error = new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(error.status, error.statusText, await $9915aeece4ba52df$var$parseResponseBody(error));
                    } catch (e) {
                        error = e;
                    }
                    if ($9915aeece4ba52df$export$e0163cfdf7bc9cfa(error)) error = $9915aeece4ba52df$var$dataWithResponseInitToErrorResponse(error);
                    if (renderedStaticContext) {
                        if (routeId in renderedStaticContext.loaderData) renderedStaticContext.loaderData[routeId] = void 0;
                        let staticContext = $9915aeece4ba52df$export$fec11da027c70692(dataRoutes, renderedStaticContext, error, skipLoaderErrorBubbling ? routeId : $9915aeece4ba52df$var$findNearestBoundary(matches, routeId).route.id);
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    } else {
                        let staticContext = {
                            matches: matches,
                            location: location,
                            basename: basename,
                            loaderData: {},
                            actionData: null,
                            errors: {
                                [skipLoaderErrorBubbling ? routeId : $9915aeece4ba52df$var$findNearestBoundary(matches, matches.find((m)=>m.route.id === routeId || m.route.loader)?.route.id || routeId).route.id]: error
                            },
                            statusCode: (0, $f1195701c85e5ce2$export$972111febbeef05b)(error) ? error.status : 500,
                            actionHeaders: {},
                            loaderHeaders: {},
                            _match: match
                        };
                        return generateMiddlewareResponse(()=>Promise.resolve(staticContext));
                    }
                });
                (0, $072a56029499ae6c$export$f5708dca728d7177)($9915aeece4ba52df$export$3f1eb41d9a6a6a27(response), "Expected a response in query()");
                return response;
            } catch (e) {
                if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(e)) return e;
                throw e;
            }
        }
        let result = await queryImpl(request, location, matches, requestContext, dataStrategy || null, skipLoaderErrorBubbling === true, null, filterMatchesToLoad || null, skipRevalidation === true);
        if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(result)) return result;
        return {
            location: location,
            basename: basename,
            ...result,
            _match: match
        };
    }
    /**
	* The queryRoute() method is intended for targeted route requests, either
	* for fetch ?_data requests or resource route requests.  In this case, we
	* are only ever calling a single action or loader, and we are returning the
	* returned value directly.  In most cases, this will be a Response returned
	* from the action/loader, but it may be a primitive or other value as well -
	* and in such cases the calling context should handle that accordingly.
	*
	* We do respect the throw/return differentiation, so if an action/loader
	* throws, then this method will throw the value.  This is important so we
	* can do proper boundary identification in Remix where a thrown Response
	* must go to the Catch Boundary but a returned Response is happy-path.
	*
	* One thing to note is that any Router-initiated Errors that make sense
	* to associate with a status code will be thrown as an ErrorResponse
	* instance which include the raw Error, such that the calling context can
	* serialize the error as they see fit while including the proper response
	* code.  Examples here are 404 and 405 errors that occur prior to reaching
	* any user-defined loaders.
	*
	* - `opts.routeId` allows you to specify the specific route handler to call.
	*   If not provided the handler will determine the proper route by matching
	*   against `request.url`
	* - `opts.requestContext` is an optional server context that will be passed
	*    to actions/loaders in the `context` parameter
	*/ async function queryRoute(request, { routeId: routeId, requestContext: requestContext, dataStrategy: dataStrategy, generateMiddlewareResponse: generateMiddlewareResponse, normalizePath: normalizePath } = {}) {
        let normalizePathImpl = normalizePath || $9915aeece4ba52df$var$defaultNormalizePath;
        let method = request.method;
        let location = (0, $072a56029499ae6c$export$90c043f1c57770b8)("", normalizePathImpl(request), null, "default");
        let matches = dataRouteMatcher.match(location);
        requestContext = requestContext != null ? requestContext : new (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04)();
        if (!$9915aeece4ba52df$var$isValidMethod(method) && method !== "HEAD" && method !== "OPTIONS") throw $9915aeece4ba52df$var$getInternalRouterError(405, {
            method: method
        });
        else if (!matches) throw $9915aeece4ba52df$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        let match = routeId ? matches.find((m)=>m.route.id === routeId) : $9915aeece4ba52df$var$getTargetMatch(matches, location);
        if (routeId && !match) throw $9915aeece4ba52df$var$getInternalRouterError(403, {
            pathname: location.pathname,
            routeId: routeId
        });
        else if (!match) throw $9915aeece4ba52df$var$getInternalRouterError(404, {
            pathname: location.pathname
        });
        if (generateMiddlewareResponse) {
            (0, $072a56029499ae6c$export$f5708dca728d7177)(requestContext instanceof (0, $f1195701c85e5ce2$export$b8d3e69d4b3eff04), "When using middleware in `staticHandler.queryRoute()`, any provided `requestContext` must be an instance of `RouterContextProvider`");
            await $9915aeece4ba52df$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties);
            return await $9915aeece4ba52df$var$runServerMiddlewarePipeline({
                request: request,
                url: (0, $f1195701c85e5ce2$export$141d98e45b4b08e4)(request, location),
                pattern: (0, $f1195701c85e5ce2$export$d738435097971c09)(matches),
                matches: matches,
                params: matches[0].params,
                context: requestContext
            }, async ()=>{
                return await generateMiddlewareResponse(async (innerRequest)=>{
                    let processed = handleQueryResult(await queryImpl(innerRequest, location, matches, requestContext, dataStrategy || null, false, match, null, false));
                    return $9915aeece4ba52df$export$3f1eb41d9a6a6a27(processed) ? processed : typeof processed === "string" ? new Response(processed) : Response.json(processed);
                });
            }, (error)=>{
                if ($9915aeece4ba52df$export$e0163cfdf7bc9cfa(error)) return Promise.resolve($9915aeece4ba52df$var$dataWithResponseInitToResponse(error));
                if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(error)) return Promise.resolve(error);
                throw error;
            });
        }
        return handleQueryResult(await queryImpl(request, location, matches, requestContext, dataStrategy || null, false, match, null, false));
        function handleQueryResult(result) {
            if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(result)) return result;
            let error = result.errors ? Object.values(result.errors)[0] : void 0;
            if (error !== void 0) throw error;
            if (result.actionData) return Object.values(result.actionData)[0];
            if (result.loaderData) return Object.values(result.loaderData)[0];
        }
    }
    async function queryImpl(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, skipRevalidation) {
        (0, $072a56029499ae6c$export$f5708dca728d7177)(request.signal, "query()/queryRoute() requests must contain an AbortController signal");
        try {
            if ($9915aeece4ba52df$export$cbae47800eb95bc3(request.method)) return await submit(request, location, matches, routeMatch || $9915aeece4ba52df$var$getTargetMatch(matches, location), requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch != null, filterMatchesToLoad, skipRevalidation);
            let result = await loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad);
            return $9915aeece4ba52df$export$3f1eb41d9a6a6a27(result) ? result : {
                ...result,
                actionData: null,
                actionHeaders: {}
            };
        } catch (e) {
            if ($9915aeece4ba52df$var$isDataStrategyResult(e) && $9915aeece4ba52df$export$3f1eb41d9a6a6a27(e.result)) {
                if (e.type === "error") throw e.result;
                return e.result;
            }
            if ($9915aeece4ba52df$export$6e80290866a84dd4(e)) return e;
            throw e;
        }
    }
    async function submit(request, location, matches, actionMatch, requestContext, dataStrategy, skipLoaderErrorBubbling, isRouteRequest, filterMatchesToLoad, skipRevalidation) {
        let result;
        if (!actionMatch.route.action && !actionMatch.route.lazy) {
            let error = $9915aeece4ba52df$var$getInternalRouterError(405, {
                method: request.method,
                pathname: new URL(request.url).pathname,
                routeId: actionMatch.route.id
            });
            if (isRouteRequest) throw error;
            result = {
                type: "error",
                error: error
            };
        } else {
            result = (await callDataStrategy(request, location, $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, actionMatch, [], requestContext), isRouteRequest, requestContext, dataStrategy))[actionMatch.route.id];
            if (request.signal.aborted) $9915aeece4ba52df$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        }
        if ($9915aeece4ba52df$var$isRedirectResult(result)) throw new Response(null, {
            status: result.response.status,
            headers: {
                Location: result.response.headers.get("Location")
            }
        });
        if (isRouteRequest) {
            if ($9915aeece4ba52df$var$isErrorResult(result)) throw result.error;
            return {
                matches: [
                    actionMatch
                ],
                loaderData: {},
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                errors: null,
                statusCode: 200,
                loaderHeaders: {},
                actionHeaders: {}
            };
        }
        if (skipRevalidation) {
            if ($9915aeece4ba52df$var$isErrorResult(result)) {
                let boundaryMatch = skipLoaderErrorBubbling ? actionMatch : $9915aeece4ba52df$var$findNearestBoundary(matches, actionMatch.route.id);
                return {
                    statusCode: (0, $f1195701c85e5ce2$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
                    actionData: null,
                    actionHeaders: {
                        ...result.headers ? {
                            [actionMatch.route.id]: result.headers
                        } : {}
                    },
                    matches: matches,
                    loaderData: {},
                    errors: {
                        [boundaryMatch.route.id]: result.error
                    },
                    loaderHeaders: {}
                };
            } else return {
                actionData: {
                    [actionMatch.route.id]: result.data
                },
                actionHeaders: result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {},
                matches: matches,
                loaderData: {},
                errors: null,
                statusCode: result.statusCode || 200,
                loaderHeaders: {}
            };
        }
        let loaderRequest = new Request(request.url, {
            headers: request.headers,
            redirect: request.redirect,
            signal: request.signal
        });
        if ($9915aeece4ba52df$var$isErrorResult(result)) return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad, [
                (skipLoaderErrorBubbling ? actionMatch : $9915aeece4ba52df$var$findNearestBoundary(matches, actionMatch.route.id)).route.id,
                result
            ]),
            statusCode: (0, $f1195701c85e5ce2$export$972111febbeef05b)(result.error) ? result.error.status : result.statusCode != null ? result.statusCode : 500,
            actionData: null,
            actionHeaders: {
                ...result.headers ? {
                    [actionMatch.route.id]: result.headers
                } : {}
            }
        };
        return {
            ...await loadRouteData(loaderRequest, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, null, filterMatchesToLoad),
            actionData: {
                [actionMatch.route.id]: result.data
            },
            ...result.statusCode ? {
                statusCode: result.statusCode
            } : {},
            actionHeaders: result.headers ? {
                [actionMatch.route.id]: result.headers
            } : {}
        };
    }
    async function loadRouteData(request, location, matches, requestContext, dataStrategy, skipLoaderErrorBubbling, routeMatch, filterMatchesToLoad, pendingActionResult) {
        let isRouteRequest = routeMatch != null;
        if (isRouteRequest && !routeMatch?.route.loader && !routeMatch?.route.lazy) throw $9915aeece4ba52df$var$getInternalRouterError(400, {
            method: request.method,
            pathname: new URL(request.url).pathname,
            routeId: routeMatch?.route.id
        });
        let dsMatches;
        if (routeMatch) dsMatches = $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, location, matches, routeMatch, [], requestContext);
        else {
            let maxIdx = pendingActionResult && $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1]) ? matches.findIndex((m)=>m.route.id === pendingActionResult[0]) - 1 : void 0;
            let pattern = (0, $f1195701c85e5ce2$export$d738435097971c09)(matches);
            dsMatches = matches.map((match, index)=>{
                if (maxIdx != null && index > maxIdx) return $9915aeece4ba52df$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, false);
                return $9915aeece4ba52df$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, [], requestContext, (match.route.loader || match.route.lazy) != null && (!filterMatchesToLoad || filterMatchesToLoad(match)));
            });
        }
        if (!dataStrategy && !dsMatches.some((m)=>m.shouldLoad)) return {
            matches: matches,
            loaderData: {},
            errors: pendingActionResult && $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1]) ? {
                [pendingActionResult[0]]: pendingActionResult[1].error
            } : null,
            statusCode: 200,
            loaderHeaders: {}
        };
        let results = await callDataStrategy(request, location, dsMatches, isRouteRequest, requestContext, dataStrategy);
        if (request.signal.aborted) $9915aeece4ba52df$var$throwStaticHandlerAbortedError(request, isRouteRequest);
        return {
            ...$9915aeece4ba52df$var$processRouteLoaderData(matches, results, pendingActionResult, true, skipLoaderErrorBubbling),
            matches: matches
        };
    }
    async function callDataStrategy(request, location, matches, isRouteRequest, requestContext, dataStrategy) {
        let results = await $9915aeece4ba52df$var$callDataStrategyImpl(dataStrategy || $9915aeece4ba52df$var$defaultDataStrategy, request, location, matches, null, requestContext, true);
        let dataResults = {};
        await Promise.all(matches.map(async (match)=>{
            if (!(match.route.id in results)) return;
            let result = results[match.route.id];
            if ($9915aeece4ba52df$var$isRedirectDataStrategyResult(result)) {
                let response = result.result;
                throw $9915aeece4ba52df$var$normalizeRelativeRoutingRedirectResponse(response, request, match.route.id, matches, basename);
            }
            if (isRouteRequest) {
                if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(result.result)) throw result;
                else if ($9915aeece4ba52df$export$e0163cfdf7bc9cfa(result.result)) throw $9915aeece4ba52df$var$dataWithResponseInitToResponse(result.result);
            }
            dataResults[match.route.id] = await $9915aeece4ba52df$var$convertDataStrategyResultToDataResult(result);
        }));
        return dataResults;
    }
    return {
        dataRoutes: dataRoutes,
        match: match,
        query: query,
        queryRoute: queryRoute
    };
}
/**
* Given an existing StaticHandlerContext and an error thrown at render time,
* provide an updated StaticHandlerContext suitable for a second SSR render
*
* @category Utils
*/ function $9915aeece4ba52df$export$fec11da027c70692(routes, handlerContext, error, boundaryId) {
    let errorBoundaryId = boundaryId || handlerContext._deepestRenderedBoundaryId || routes[0].id;
    return {
        ...handlerContext,
        statusCode: (0, $f1195701c85e5ce2$export$972111febbeef05b)(error) ? error.status : 500,
        errors: {
            [errorBoundaryId]: error
        }
    };
}
function $9915aeece4ba52df$var$throwStaticHandlerAbortedError(request, isRouteRequest) {
    if (request.signal.reason !== void 0) throw request.signal.reason;
    throw new Error(`${isRouteRequest ? "queryRoute" : "query"}() call aborted without an \`AbortSignal.reason\`: ${request.method} ${request.url}`);
}
function $9915aeece4ba52df$var$isSubmissionNavigation(opts) {
    return opts != null && ("formData" in opts && opts.formData != null || "body" in opts && opts.body !== void 0);
}
function $9915aeece4ba52df$var$defaultNormalizePath(request) {
    let url = new URL(request.url);
    return {
        pathname: url.pathname,
        search: url.search,
        hash: url.hash
    };
}
function $9915aeece4ba52df$var$normalizeTo(location, matches, basename, to, fromRouteId, relative) {
    let contextualMatches;
    let activeRouteMatch;
    if (fromRouteId) {
        contextualMatches = [];
        for (let match of matches){
            contextualMatches.push(match);
            if (match.route.id === fromRouteId) {
                activeRouteMatch = match;
                break;
            }
        }
    } else {
        contextualMatches = matches;
        activeRouteMatch = matches[matches.length - 1];
    }
    let path = (0, $f1195701c85e5ce2$export$cae722b0cc860f13)(to ? to : ".", (0, $f1195701c85e5ce2$export$fe6dbc5de95f53ab)(contextualMatches), (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname, relative === "path");
    if (to == null) {
        path.search = location.search;
        path.hash = location.hash;
    }
    if ((to == null || to === "" || to === ".") && activeRouteMatch) {
        let nakedIndex = $9915aeece4ba52df$var$hasNakedIndexQuery(path.search);
        if (activeRouteMatch.route.index && !nakedIndex) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
        else if (!activeRouteMatch.route.index && nakedIndex) {
            let params = new URLSearchParams(path.search);
            let indexValues = params.getAll("index");
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if (basename !== "/") path.pathname = (0, $f1195701c85e5ce2$export$e9a5bfadbc179142)({
        basename: basename,
        pathname: path.pathname
    });
    return (0, $072a56029499ae6c$export$fe53371bee54353d)(path);
}
function $9915aeece4ba52df$var$normalizeNavigateOptions(isFetcher, path, opts) {
    if (!opts || !$9915aeece4ba52df$var$isSubmissionNavigation(opts)) return {
        path: path
    };
    if (opts.formMethod && !$9915aeece4ba52df$var$isValidMethod(opts.formMethod)) return {
        path: path,
        error: $9915aeece4ba52df$var$getInternalRouterError(405, {
            method: opts.formMethod
        })
    };
    let getInvalidBodyError = ()=>({
            path: path,
            error: $9915aeece4ba52df$var$getInternalRouterError(400, {
                type: "invalid-body"
            })
        });
    let formMethod = (opts.formMethod || "get").toUpperCase();
    let formAction = $9915aeece4ba52df$var$stripHashFromPath(path);
    if (opts.body !== void 0) {
        if (opts.formEncType === "text/plain") {
            if (!$9915aeece4ba52df$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            let text = typeof opts.body === "string" ? opts.body : opts.body instanceof FormData || opts.body instanceof URLSearchParams ? Array.from(opts.body.entries()).reduce((acc, [name, value])=>`${acc}${name}=${value}\n`, "") : String(opts.body);
            return {
                path: path,
                submission: {
                    formMethod: formMethod,
                    formAction: formAction,
                    formEncType: opts.formEncType,
                    formData: void 0,
                    json: void 0,
                    text: text
                }
            };
        } else if (opts.formEncType === "application/json") {
            if (!$9915aeece4ba52df$export$cbae47800eb95bc3(formMethod)) return getInvalidBodyError();
            try {
                let json = typeof opts.body === "string" ? JSON.parse(opts.body) : opts.body;
                return {
                    path: path,
                    submission: {
                        formMethod: formMethod,
                        formAction: formAction,
                        formEncType: opts.formEncType,
                        formData: void 0,
                        json: json,
                        text: void 0
                    }
                };
            } catch  {
                return getInvalidBodyError();
            }
        }
    }
    (0, $072a56029499ae6c$export$f5708dca728d7177)(typeof FormData === "function", "FormData is not available in this environment");
    let searchParams;
    let formData;
    if (opts.formData) {
        searchParams = $9915aeece4ba52df$var$convertFormDataToSearchParams(opts.formData);
        formData = opts.formData;
    } else if (opts.body instanceof FormData) {
        searchParams = $9915aeece4ba52df$var$convertFormDataToSearchParams(opts.body);
        formData = opts.body;
    } else if (opts.body instanceof URLSearchParams) {
        searchParams = opts.body;
        formData = $9915aeece4ba52df$var$convertSearchParamsToFormData(searchParams);
    } else if (opts.body == null) {
        searchParams = new URLSearchParams();
        formData = new FormData();
    } else try {
        searchParams = new URLSearchParams(opts.body);
        formData = $9915aeece4ba52df$var$convertSearchParamsToFormData(searchParams);
    } catch  {
        return getInvalidBodyError();
    }
    let submission = {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: opts && opts.formEncType || "application/x-www-form-urlencoded",
        formData: formData,
        json: void 0,
        text: void 0
    };
    if ($9915aeece4ba52df$export$cbae47800eb95bc3(submission.formMethod)) return {
        path: path,
        submission: submission
    };
    let parsedPath = (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(path);
    if (isFetcher && parsedPath.search && $9915aeece4ba52df$var$hasNakedIndexQuery(parsedPath.search)) searchParams.append("index", "");
    parsedPath.search = `?${searchParams}`;
    return {
        path: (0, $072a56029499ae6c$export$fe53371bee54353d)(parsedPath),
        submission: submission
    };
}
function $9915aeece4ba52df$var$getMatchesToLoad(request, scopedContext, mapRouteProperties, manifest, history, state, matches, submission, location, lazyRoutePropertiesToSkip, initialHydration, isRevalidationRequired, cancelledFetcherLoads, fetchersQueuedForDeletion, fetchLoadMatches, fetchRedirectIds, dataRouteMatcher, pendingActionResult, callSiteDefaultShouldRevalidate) {
    let actionResult = pendingActionResult ? $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : pendingActionResult[1].data : void 0;
    let currentUrl = history.createURL(state.location);
    let nextUrl = history.createURL(location);
    let maxIdx;
    if (initialHydration && state.errors) {
        let boundaryId = Object.keys(state.errors)[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId);
    } else if (pendingActionResult && $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1])) {
        let boundaryId = pendingActionResult[0];
        maxIdx = matches.findIndex((m)=>m.route.id === boundaryId) - 1;
    }
    let actionStatus = pendingActionResult ? pendingActionResult[1].statusCode : void 0;
    let shouldSkipRevalidation = actionStatus && actionStatus >= 400;
    let baseShouldRevalidateArgs = {
        currentUrl: currentUrl,
        currentParams: state.matches[0]?.params || {},
        nextUrl: nextUrl,
        nextParams: matches[0].params,
        ...submission,
        actionResult: actionResult,
        actionStatus: actionStatus
    };
    let pattern = (0, $f1195701c85e5ce2$export$d738435097971c09)(matches);
    let dsMatches = matches.map((match, index)=>{
        let { route: route } = match;
        let forceShouldLoad = null;
        if (maxIdx != null && index > maxIdx) forceShouldLoad = false;
        else if (route.lazy) forceShouldLoad = true;
        else if (!$9915aeece4ba52df$var$routeHasLoaderOrMiddleware(route)) forceShouldLoad = false;
        else if (initialHydration) {
            let { shouldLoad: shouldLoad } = $9915aeece4ba52df$var$getRouteHydrationStatus(route, state.loaderData, state.errors);
            forceShouldLoad = shouldLoad;
        } else if ($9915aeece4ba52df$var$isNewLoader(state.loaderData, state.matches[index], match)) forceShouldLoad = true;
        if (forceShouldLoad !== null) return $9915aeece4ba52df$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, forceShouldLoad);
        let defaultShouldRevalidate = false;
        if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
        else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
        else if (isRevalidationRequired) defaultShouldRevalidate = true;
        else if (currentUrl.pathname + currentUrl.search === nextUrl.pathname + nextUrl.search) defaultShouldRevalidate = true;
        else if (currentUrl.search !== nextUrl.search) defaultShouldRevalidate = true;
        else if ($9915aeece4ba52df$var$isNewRouteInstance(state.matches[index], match)) defaultShouldRevalidate = true;
        let shouldRevalidateArgs = {
            ...baseShouldRevalidateArgs,
            defaultShouldRevalidate: defaultShouldRevalidate
        };
        return $9915aeece4ba52df$var$getDataStrategyMatch(mapRouteProperties, manifest, request, location, pattern, match, lazyRoutePropertiesToSkip, scopedContext, $9915aeece4ba52df$var$shouldRevalidateLoader(match, shouldRevalidateArgs), shouldRevalidateArgs, callSiteDefaultShouldRevalidate);
    });
    let revalidatingFetchers = [];
    fetchLoadMatches.forEach((f, key)=>{
        if (initialHydration || !matches.some((m)=>m.route.id === f.routeId) || fetchersQueuedForDeletion.has(key) || f.isDiscovering) return;
        let fetcher = state.fetchers.get(key);
        let isMidInitialLoad = fetcher && fetcher.state !== "idle" && fetcher.data === void 0;
        let fetcherMatches = dataRouteMatcher.match(f.path);
        if (!fetcherMatches) {
            revalidatingFetchers.push({
                key: key,
                routeId: f.routeId,
                path: f.path,
                matches: null,
                match: null,
                request: null,
                controller: null
            });
            return;
        }
        if (fetchRedirectIds.has(key)) return;
        let fetcherMatch = $9915aeece4ba52df$var$getTargetMatch(fetcherMatches, f.path);
        let fetchController = new AbortController();
        let fetchRequest = $9915aeece4ba52df$var$createClientSideRequest(history, f.path, fetchController.signal);
        let fetcherDsMatches = null;
        if (cancelledFetcherLoads.has(key)) {
            cancelledFetcherLoads.delete(key);
            fetcherDsMatches = $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else if (isMidInitialLoad) {
            if (isRevalidationRequired) fetcherDsMatches = $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext);
        } else {
            let defaultShouldRevalidate;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") defaultShouldRevalidate = callSiteDefaultShouldRevalidate;
            else if (shouldSkipRevalidation) defaultShouldRevalidate = false;
            else defaultShouldRevalidate = isRevalidationRequired;
            let shouldRevalidateArgs = {
                ...baseShouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            };
            if ($9915aeece4ba52df$var$shouldRevalidateLoader(fetcherMatch, shouldRevalidateArgs)) fetcherDsMatches = $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, fetchRequest, f.path, fetcherMatches, fetcherMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs);
        }
        if (fetcherDsMatches) revalidatingFetchers.push({
            key: key,
            routeId: f.routeId,
            path: f.path,
            matches: fetcherDsMatches,
            match: fetcherMatch,
            request: fetchRequest,
            controller: fetchController
        });
    });
    return {
        dsMatches: dsMatches,
        revalidatingFetchers: revalidatingFetchers
    };
}
function $9915aeece4ba52df$var$routeHasLoaderOrMiddleware(route) {
    return route.loader != null || route.middleware != null && route.middleware.length > 0;
}
function $9915aeece4ba52df$var$getRouteHydrationStatus(route, loaderData, errors) {
    if (route.lazy) return {
        shouldLoad: true,
        renderFallback: true
    };
    if (!$9915aeece4ba52df$var$routeHasLoaderOrMiddleware(route)) return {
        shouldLoad: false,
        renderFallback: false
    };
    let hasData = loaderData != null && route.id in loaderData;
    let hasError = errors != null && errors[route.id] !== void 0;
    if (!hasData && hasError) return {
        shouldLoad: false,
        renderFallback: false
    };
    if (typeof route.loader === "function" && route.loader.hydrate === true) return {
        shouldLoad: true,
        renderFallback: !hasData
    };
    let shouldLoad = !hasData && !hasError;
    return {
        shouldLoad: shouldLoad,
        renderFallback: shouldLoad
    };
}
function $9915aeece4ba52df$var$isNewLoader(currentLoaderData, currentMatch, match) {
    let isNew = !currentMatch || match.route.id !== currentMatch.route.id;
    let isMissingData = !currentLoaderData.hasOwnProperty(match.route.id);
    return isNew || isMissingData;
}
function $9915aeece4ba52df$var$isNewRouteInstance(currentMatch, match) {
    let currentPath = currentMatch.route.path;
    return currentMatch.pathname !== match.pathname || currentPath != null && currentPath.endsWith("*") && currentMatch.params["*"] !== match.params["*"];
}
function $9915aeece4ba52df$var$shouldRevalidateLoader(loaderMatch, arg) {
    if (loaderMatch.route.shouldRevalidate) {
        let routeChoice = loaderMatch.route.shouldRevalidate(arg);
        if (typeof routeChoice === "boolean") return routeChoice;
    }
    return arg.defaultShouldRevalidate;
}
function $9915aeece4ba52df$var$patchRoutesImpl(routeId, children, dataRoutes, manifest, mapRouteProperties, allowElementMutations) {
    let childrenToPatch;
    if (routeId) {
        let route = manifest[routeId];
        (0, $072a56029499ae6c$export$f5708dca728d7177)(route, `No route found to patch children into: routeId = ${routeId}`);
        if (!route.children) route.children = [];
        childrenToPatch = route.children;
    } else childrenToPatch = dataRoutes.activeRoutes;
    let uniqueChildren = [];
    let existingChildren = [];
    children.forEach((newRoute)=>{
        let existingRoute = childrenToPatch.find((existingRoute)=>$9915aeece4ba52df$var$isSameRoute(newRoute, existingRoute));
        if (existingRoute) existingChildren.push({
            existingRoute: existingRoute,
            newRoute: newRoute
        });
        else uniqueChildren.push(newRoute);
    });
    if (uniqueChildren.length > 0) {
        let newRoutes = (0, $f1195701c85e5ce2$export$87cb1a9238dc3fba)(uniqueChildren, mapRouteProperties, [
            routeId || "_",
            "patch",
            String(childrenToPatch?.length || "0")
        ], manifest);
        childrenToPatch.push(...newRoutes);
    }
    if (allowElementMutations && existingChildren.length > 0) for(let i = 0; i < existingChildren.length; i++){
        let { existingRoute: existingRoute, newRoute: newRoute } = existingChildren[i];
        let existingRouteTyped = existingRoute;
        let [newRouteTyped] = (0, $f1195701c85e5ce2$export$87cb1a9238dc3fba)([
            newRoute
        ], mapRouteProperties, [], {}, true);
        Object.assign(existingRouteTyped, {
            element: newRouteTyped.element ? newRouteTyped.element : existingRouteTyped.element,
            errorElement: newRouteTyped.errorElement ? newRouteTyped.errorElement : existingRouteTyped.errorElement,
            hydrateFallbackElement: newRouteTyped.hydrateFallbackElement ? newRouteTyped.hydrateFallbackElement : existingRouteTyped.hydrateFallbackElement
        });
    }
    if (!dataRoutes.hasHMRRoutes) dataRoutes.setRoutes([
        ...dataRoutes.activeRoutes
    ]);
}
function $9915aeece4ba52df$var$isSameRoute(newRoute, existingRoute) {
    if ("id" in newRoute && "id" in existingRoute && newRoute.id === existingRoute.id) return true;
    if (!(newRoute.index === existingRoute.index && newRoute.path === existingRoute.path && newRoute.caseSensitive === existingRoute.caseSensitive)) return false;
    if ((!newRoute.children || newRoute.children.length === 0) && (!existingRoute.children || existingRoute.children.length === 0)) return true;
    return newRoute.children?.every((aChild, i)=>existingRoute.children?.some((bChild)=>$9915aeece4ba52df$var$isSameRoute(aChild, bChild))) ?? false;
}
const $9915aeece4ba52df$var$lazyRoutePropertyCache = /* @__PURE__ */ new WeakMap();
const $9915aeece4ba52df$var$loadLazyRouteProperty = ({ key: key, route: route, manifest: manifest, mapRouteProperties: mapRouteProperties })=>{
    let routeToUpdate = manifest[route.id];
    (0, $072a56029499ae6c$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!routeToUpdate.lazy || typeof routeToUpdate.lazy !== "object") return;
    let lazyFn = routeToUpdate.lazy[key];
    if (!lazyFn) return;
    let cache = $9915aeece4ba52df$var$lazyRoutePropertyCache.get(routeToUpdate);
    if (!cache) {
        cache = {};
        $9915aeece4ba52df$var$lazyRoutePropertyCache.set(routeToUpdate, cache);
    }
    let cachedPromise = cache[key];
    if (cachedPromise) return cachedPromise;
    let propertyPromise = (async ()=>{
        let isUnsupported = (0, $f1195701c85e5ce2$export$3e22299e33adeed1)(key);
        let isStaticallyDefined = routeToUpdate[key] !== void 0;
        if (isUnsupported) {
            (0, $072a56029499ae6c$export$491112666e282270)(!isUnsupported, "Route property " + key + " is not a supported lazy route property. This property will be ignored.");
            cache[key] = Promise.resolve();
        } else if (isStaticallyDefined) (0, $072a56029499ae6c$export$491112666e282270)(false, `Route "${routeToUpdate.id}" has a static property "${key}" defined. The lazy property will be ignored.`);
        else {
            let value = await lazyFn();
            if (value != null) {
                Object.assign(routeToUpdate, {
                    [key]: value
                });
                Object.assign(routeToUpdate, mapRouteProperties(routeToUpdate));
            }
        }
        if (typeof routeToUpdate.lazy === "object") {
            routeToUpdate.lazy[key] = void 0;
            if (Object.values(routeToUpdate.lazy).every((value)=>value === void 0)) routeToUpdate.lazy = void 0;
        }
    })();
    cache[key] = propertyPromise;
    return propertyPromise;
};
const $9915aeece4ba52df$var$lazyRouteFunctionCache = /* @__PURE__ */ new WeakMap();
/**
* Execute route.lazy functions to lazily load route modules (loader, action,
* shouldRevalidate) and update the routeManifest in place which shares objects
* with dataRoutes so those get updated as well.
*/ function $9915aeece4ba52df$var$loadLazyRoute(route, type, manifest, mapRouteProperties, lazyRoutePropertiesToSkip) {
    let routeToUpdate = manifest[route.id];
    (0, $072a56029499ae6c$export$f5708dca728d7177)(routeToUpdate, "No route found in manifest");
    if (!route.lazy) return {
        lazyRoutePromise: void 0,
        lazyHandlerPromise: void 0
    };
    if (typeof route.lazy === "function") {
        let cachedPromise = $9915aeece4ba52df$var$lazyRouteFunctionCache.get(routeToUpdate);
        if (cachedPromise) return {
            lazyRoutePromise: cachedPromise,
            lazyHandlerPromise: cachedPromise
        };
        let lazyRoutePromise = (async ()=>{
            (0, $072a56029499ae6c$export$f5708dca728d7177)(typeof route.lazy === "function", "No lazy route function found");
            let lazyRoute = await route.lazy();
            let routeUpdates = {};
            for(let lazyRouteProperty in lazyRoute){
                let lazyValue = lazyRoute[lazyRouteProperty];
                if (lazyValue === void 0) continue;
                let isUnsupported = (0, $f1195701c85e5ce2$export$a89d811eaa209e85)(lazyRouteProperty);
                let isStaticallyDefined = routeToUpdate[lazyRouteProperty] !== void 0;
                if (isUnsupported) (0, $072a56029499ae6c$export$491112666e282270)(!isUnsupported, "Route property " + lazyRouteProperty + " is not a supported property to be returned from a lazy route function. This property will be ignored.");
                else if (isStaticallyDefined) (0, $072a56029499ae6c$export$491112666e282270)(!isStaticallyDefined, `Route "${routeToUpdate.id}" has a static property "${lazyRouteProperty}" defined but its lazy function is also returning a value for this property. The lazy route property "${lazyRouteProperty}" will be ignored.`);
                else routeUpdates[lazyRouteProperty] = lazyValue;
            }
            Object.assign(routeToUpdate, routeUpdates);
            Object.assign(routeToUpdate, {
                ...mapRouteProperties(routeToUpdate),
                lazy: void 0
            });
        })();
        $9915aeece4ba52df$var$lazyRouteFunctionCache.set(routeToUpdate, lazyRoutePromise);
        lazyRoutePromise.catch(()=>{});
        return {
            lazyRoutePromise: lazyRoutePromise,
            lazyHandlerPromise: lazyRoutePromise
        };
    }
    let lazyKeys = Object.keys(route.lazy);
    let lazyPropertyPromises = [];
    let lazyHandlerPromise = void 0;
    for (let key of lazyKeys){
        if (lazyRoutePropertiesToSkip && lazyRoutePropertiesToSkip.includes(key)) continue;
        let promise = $9915aeece4ba52df$var$loadLazyRouteProperty({
            key: key,
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
        if (promise) {
            lazyPropertyPromises.push(promise);
            if (key === type) lazyHandlerPromise = promise;
        }
    }
    let lazyRoutePromise = lazyPropertyPromises.length > 0 ? Promise.all(lazyPropertyPromises).then(()=>{}) : void 0;
    lazyRoutePromise?.catch(()=>{});
    lazyHandlerPromise?.catch(()=>{});
    return {
        lazyRoutePromise: lazyRoutePromise,
        lazyHandlerPromise: lazyHandlerPromise
    };
}
function $9915aeece4ba52df$var$isNonNullable(value) {
    return value !== void 0;
}
function $9915aeece4ba52df$var$loadLazyMiddlewareForMatches(matches, manifest, mapRouteProperties) {
    let promises = matches.map(({ route: route })=>{
        if (typeof route.lazy !== "object" || !route.lazy.middleware) return;
        return $9915aeece4ba52df$var$loadLazyRouteProperty({
            key: "middleware",
            route: route,
            manifest: manifest,
            mapRouteProperties: mapRouteProperties
        });
    }).filter($9915aeece4ba52df$var$isNonNullable);
    return promises.length > 0 ? Promise.all(promises) : void 0;
}
async function $9915aeece4ba52df$var$defaultDataStrategy(args) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldLoad);
    let keyedResults = {};
    (await Promise.all(matchesToLoad.map((m)=>m.resolve()))).forEach((result, i)=>{
        keyedResults[matchesToLoad[i].route.id] = result;
    });
    return keyedResults;
}
async function $9915aeece4ba52df$var$defaultDataStrategyWithMiddleware(args) {
    if (!args.matches.some((m)=>m.route.middleware)) return $9915aeece4ba52df$var$defaultDataStrategy(args);
    return $9915aeece4ba52df$var$runClientMiddlewarePipeline(args, ()=>$9915aeece4ba52df$var$defaultDataStrategy(args));
}
function $9915aeece4ba52df$var$runServerMiddlewarePipeline(args, handler, errorHandler) {
    return $9915aeece4ba52df$var$runMiddlewarePipeline(args, handler, processResult, $9915aeece4ba52df$export$3f1eb41d9a6a6a27, errorHandler);
    function processResult(result) {
        return $9915aeece4ba52df$export$e0163cfdf7bc9cfa(result) ? $9915aeece4ba52df$var$dataWithResponseInitToResponse(result) : result;
    }
}
function $9915aeece4ba52df$var$runClientMiddlewarePipeline(args, handler) {
    return $9915aeece4ba52df$var$runMiddlewarePipeline(args, handler, (r)=>{
        if ($9915aeece4ba52df$export$6e80290866a84dd4(r)) throw r;
        return r;
    }, $9915aeece4ba52df$var$isDataStrategyResults, errorHandler);
    async function errorHandler(error, routeId, nextResult) {
        if (nextResult) return Object.assign(nextResult.value, {
            [routeId]: {
                type: "error",
                result: error
            }
        });
        else {
            let { matches: matches } = args;
            let maxBoundaryIdx = Math.min(Math.max(matches.findIndex((m)=>m.route.id === routeId), 0), Math.max(matches.findIndex((m)=>m.shouldCallHandler()), 0));
            let deepestRouteId = matches[maxBoundaryIdx].route.id;
            for (let match of matches.slice(0, maxBoundaryIdx + 1))try {
                await match._lazyPromises?.route;
            } catch  {
                deepestRouteId = match.route.id;
                break;
            }
            return {
                [$9915aeece4ba52df$var$findNearestBoundary(matches, deepestRouteId).route.id]: {
                    type: "error",
                    result: error
                }
            };
        }
    }
}
async function $9915aeece4ba52df$var$runMiddlewarePipeline(args, handler, processResult, isResult, errorHandler) {
    let { matches: matches, ...dataFnArgs } = args;
    return await $9915aeece4ba52df$var$callRouteMiddleware(dataFnArgs, matches.flatMap((m)=>m.route.middleware ? m.route.middleware.map((fn)=>[
                m.route.id,
                fn
            ]) : []), handler, processResult, isResult, errorHandler);
}
async function $9915aeece4ba52df$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx = 0) {
    let { request: request } = args;
    if (request.signal.aborted) throw request.signal.reason ?? /* @__PURE__ */ new Error(`Request aborted: ${request.method} ${request.url}`);
    let tuple = middlewares[idx];
    if (!tuple) return await handler();
    let [routeId, middleware] = tuple;
    let nextResult;
    let next = async ()=>{
        if (nextResult) throw new Error("You may only call `next()` once per middleware");
        try {
            nextResult = {
                value: await $9915aeece4ba52df$var$callRouteMiddleware(args, middlewares, handler, processResult, isResult, errorHandler, idx + 1)
            };
            return nextResult.value;
        } catch (error) {
            nextResult = {
                value: await errorHandler(error, routeId, nextResult)
            };
            return nextResult.value;
        }
    };
    try {
        let value = await middleware(args, next);
        let result = value != null ? processResult(value) : void 0;
        if (isResult(result)) return result;
        else if (nextResult) return result ?? nextResult.value;
        else {
            nextResult = {
                value: await next()
            };
            return nextResult.value;
        }
    } catch (error) {
        return await errorHandler(error, routeId, nextResult);
    }
}
function $9915aeece4ba52df$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip) {
    let lazyMiddlewarePromise = $9915aeece4ba52df$var$loadLazyRouteProperty({
        key: "middleware",
        route: match.route,
        manifest: manifest,
        mapRouteProperties: mapRouteProperties
    });
    let lazyRoutePromises = $9915aeece4ba52df$var$loadLazyRoute(match.route, $9915aeece4ba52df$export$cbae47800eb95bc3(request.method) ? "action" : "loader", manifest, mapRouteProperties, lazyRoutePropertiesToSkip);
    return {
        middleware: lazyMiddlewarePromise,
        route: lazyRoutePromises.lazyRoutePromise,
        handler: lazyRoutePromises.lazyHandlerPromise
    };
}
function $9915aeece4ba52df$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, pattern, match, lazyRoutePropertiesToSkip, scopedContext, shouldLoad, shouldRevalidateArgs = null, callSiteDefaultShouldRevalidate) {
    let isUsingNewApi = false;
    let _lazyPromises = $9915aeece4ba52df$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip);
    return {
        ...match,
        _lazyPromises: _lazyPromises,
        shouldLoad: shouldLoad,
        shouldRevalidateArgs: shouldRevalidateArgs,
        shouldCallHandler (defaultShouldRevalidate) {
            isUsingNewApi = true;
            if (!shouldRevalidateArgs) return shouldLoad;
            if (typeof callSiteDefaultShouldRevalidate === "boolean") return $9915aeece4ba52df$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: callSiteDefaultShouldRevalidate
            });
            if (typeof defaultShouldRevalidate === "boolean") return $9915aeece4ba52df$var$shouldRevalidateLoader(match, {
                ...shouldRevalidateArgs,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
            return $9915aeece4ba52df$var$shouldRevalidateLoader(match, shouldRevalidateArgs);
        },
        resolve (handlerOverride) {
            let { lazy: lazy, loader: loader, middleware: middleware } = match.route;
            let callHandler = isUsingNewApi || shouldLoad || handlerOverride && !$9915aeece4ba52df$export$cbae47800eb95bc3(request.method) && (lazy || loader);
            let isMiddlewareOnlyRoute = middleware && middleware.length > 0 && !loader && !lazy;
            if (callHandler && ($9915aeece4ba52df$export$cbae47800eb95bc3(request.method) || !isMiddlewareOnlyRoute)) return $9915aeece4ba52df$var$callLoaderOrAction({
                request: request,
                path: path,
                pattern: pattern,
                match: match,
                lazyHandlerPromise: _lazyPromises?.handler,
                lazyRoutePromise: _lazyPromises?.route,
                handlerOverride: handlerOverride,
                scopedContext: scopedContext
            });
            return Promise.resolve({
                type: "data",
                result: void 0
            });
        }
    };
}
function $9915aeece4ba52df$var$getTargetedDataStrategyMatches(mapRouteProperties, manifest, request, path, matches, targetMatch, lazyRoutePropertiesToSkip, scopedContext, shouldRevalidateArgs = null) {
    return matches.map((match)=>{
        if (match.route.id !== targetMatch.route.id) return {
            ...match,
            shouldLoad: false,
            shouldRevalidateArgs: shouldRevalidateArgs,
            shouldCallHandler: ()=>false,
            _lazyPromises: $9915aeece4ba52df$var$getDataStrategyMatchLazyPromises(mapRouteProperties, manifest, request, match, lazyRoutePropertiesToSkip),
            resolve: ()=>Promise.resolve({
                    type: "data",
                    result: void 0
                })
        };
        return $9915aeece4ba52df$var$getDataStrategyMatch(mapRouteProperties, manifest, request, path, (0, $f1195701c85e5ce2$export$d738435097971c09)(matches), match, lazyRoutePropertiesToSkip, scopedContext, true, shouldRevalidateArgs);
    });
}
async function $9915aeece4ba52df$var$callDataStrategyImpl(dataStrategyImpl, request, path, matches, fetcherKey, scopedContext, isStaticHandler) {
    if (matches.some((m)=>m._lazyPromises?.middleware)) await Promise.all(matches.map((m)=>m._lazyPromises?.middleware));
    let dataStrategyArgs = {
        request: request,
        url: (0, $f1195701c85e5ce2$export$141d98e45b4b08e4)(request, path),
        pattern: (0, $f1195701c85e5ce2$export$d738435097971c09)(matches),
        params: matches[0].params,
        context: scopedContext,
        matches: matches
    };
    let runClientMiddleware = isStaticHandler ? ()=>{
        throw new Error("You cannot call `runClientMiddleware()` from a static handler `dataStrategy`. Middleware is run outside of `dataStrategy` during SSR in order to bubble up the Response.  You can enable middleware via the `respond` API in `query`/`queryRoute`");
    } : (cb)=>{
        let typedDataStrategyArgs = dataStrategyArgs;
        return $9915aeece4ba52df$var$runClientMiddlewarePipeline(typedDataStrategyArgs, ()=>{
            return cb({
                ...typedDataStrategyArgs,
                fetcherKey: fetcherKey,
                runClientMiddleware: ()=>{
                    throw new Error("Cannot call `runClientMiddleware()` from within an `runClientMiddleware` handler");
                }
            });
        });
    };
    let results = await dataStrategyImpl({
        ...dataStrategyArgs,
        fetcherKey: fetcherKey,
        runClientMiddleware: runClientMiddleware
    });
    try {
        await Promise.all(matches.flatMap((m)=>[
                m._lazyPromises?.handler,
                m._lazyPromises?.route
            ]));
    } catch  {}
    return results;
}
async function $9915aeece4ba52df$var$callLoaderOrAction({ request: request, path: path, pattern: pattern, match: match, lazyHandlerPromise: lazyHandlerPromise, lazyRoutePromise: lazyRoutePromise, handlerOverride: handlerOverride, scopedContext: scopedContext }) {
    let result;
    let onReject;
    let isAction = $9915aeece4ba52df$export$cbae47800eb95bc3(request.method);
    let type = isAction ? "action" : "loader";
    let runHandler = (handler)=>{
        let reject;
        let abortPromise = new Promise((_, r)=>reject = r);
        onReject = ()=>reject();
        request.signal.addEventListener("abort", onReject);
        let actualHandler = (ctx)=>{
            if (typeof handler !== "function") return Promise.reject(/* @__PURE__ */ new Error(`You cannot call the handler for a route which defines a boolean "${type}" [routeId: ${match.route.id}]`));
            return handler({
                request: request,
                url: (0, $f1195701c85e5ce2$export$141d98e45b4b08e4)(request, path),
                pattern: pattern,
                params: match.params,
                context: scopedContext
            }, ...ctx !== void 0 ? [
                ctx
            ] : []);
        };
        let handlerPromise = (async ()=>{
            try {
                return {
                    type: "data",
                    result: await (handlerOverride ? handlerOverride((ctx)=>actualHandler(ctx)) : actualHandler())
                };
            } catch (e) {
                return {
                    type: "error",
                    result: e
                };
            }
        })();
        return Promise.race([
            handlerPromise,
            abortPromise
        ]);
    };
    try {
        let handler = isAction ? match.route.action : match.route.loader;
        if (lazyHandlerPromise || lazyRoutePromise) {
            if (handler) {
                let handlerError;
                let [value] = await Promise.all([
                    runHandler(handler).catch((e)=>{
                        handlerError = e;
                    }),
                    lazyHandlerPromise,
                    lazyRoutePromise
                ]);
                if (handlerError !== void 0) throw handlerError;
                result = value;
            } else {
                await lazyHandlerPromise;
                let handler = isAction ? match.route.action : match.route.loader;
                if (handler) [result] = await Promise.all([
                    runHandler(handler),
                    lazyRoutePromise
                ]);
                else if (type === "action") {
                    let url = new URL(request.url);
                    let pathname = url.pathname + url.search;
                    throw $9915aeece4ba52df$var$getInternalRouterError(405, {
                        method: request.method,
                        pathname: pathname,
                        routeId: match.route.id
                    });
                } else return {
                    type: "data",
                    result: void 0
                };
            }
        } else if (!handler) {
            let url = new URL(request.url);
            throw $9915aeece4ba52df$var$getInternalRouterError(404, {
                pathname: url.pathname + url.search
            });
        } else result = await runHandler(handler);
    } catch (e) {
        return {
            type: "error",
            result: e
        };
    } finally{
        if (onReject) request.signal.removeEventListener("abort", onReject);
    }
    return result;
}
async function $9915aeece4ba52df$var$parseResponseBody(response) {
    let contentType = response.headers.get("Content-Type");
    if (contentType && /\bapplication\/json\b/.test(contentType)) return response.body == null ? null : response.json();
    return response.text();
}
async function $9915aeece4ba52df$var$convertDataStrategyResultToDataResult(dataStrategyResult) {
    let { result: result, type: type } = dataStrategyResult;
    if ($9915aeece4ba52df$export$3f1eb41d9a6a6a27(result)) {
        let data;
        try {
            data = await $9915aeece4ba52df$var$parseResponseBody(result);
        } catch (e) {
            return {
                type: "error",
                error: e
            };
        }
        if (type === "error") return {
            type: "error",
            error: new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(result.status, result.statusText, data),
            statusCode: result.status,
            headers: result.headers
        };
        return {
            type: "data",
            data: data,
            statusCode: result.status,
            headers: result.headers
        };
    }
    if (type === "error") {
        if ($9915aeece4ba52df$export$e0163cfdf7bc9cfa(result)) {
            if (result.data instanceof Error) return {
                type: "error",
                error: result.data,
                statusCode: result.init?.status,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
            return {
                type: "error",
                error: $9915aeece4ba52df$var$dataWithResponseInitToErrorResponse(result),
                statusCode: (0, $f1195701c85e5ce2$export$972111febbeef05b)(result) ? result.status : void 0,
                headers: result.init?.headers ? new Headers(result.init.headers) : void 0
            };
        }
        return {
            type: "error",
            error: result,
            statusCode: (0, $f1195701c85e5ce2$export$972111febbeef05b)(result) ? result.status : void 0
        };
    }
    if ($9915aeece4ba52df$export$e0163cfdf7bc9cfa(result)) return {
        type: "data",
        data: result.data,
        statusCode: result.init?.status,
        headers: result.init?.headers ? new Headers(result.init.headers) : void 0
    };
    return {
        type: "data",
        data: result
    };
}
function $9915aeece4ba52df$var$normalizeRelativeRoutingRedirectResponse(response, request, routeId, matches, basename) {
    let location = response.headers.get("Location");
    (0, $072a56029499ae6c$export$f5708dca728d7177)(location, "Redirects returned/thrown from loaders/actions must have a Location header");
    if (!(0, $f1195701c85e5ce2$export$a1cbf2de32a9fd1)(location)) {
        let trimmedMatches = matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1);
        location = $9915aeece4ba52df$var$normalizeTo(new URL(request.url), trimmedMatches, basename, location);
        response.headers.set("Location", location);
    }
    return response;
}
const $9915aeece4ba52df$var$invalidProtocols = [
    "about:",
    "blob:",
    "chrome:",
    "chrome-untrusted:",
    "content:",
    "data:",
    "devtools:",
    "file:",
    "filesystem:",
    "javascript:"
];
function $9915aeece4ba52df$export$961a3ef7a4da3a39(location) {
    try {
        return $9915aeece4ba52df$var$invalidProtocols.includes(new URL(location).protocol);
    } catch  {
        return false;
    }
}
function $9915aeece4ba52df$var$normalizeRedirectLocation(location, currentUrl, basename, historyInstance) {
    if ((0, $f1195701c85e5ce2$export$a1cbf2de32a9fd1)(location)) {
        let normalizedLocation = location;
        let url = (0, $d4078e32874468f1$export$825a82322d91916e).test(normalizedLocation) ? new URL((0, $d4078e32874468f1$export$977999b735cd4f26)(normalizedLocation, currentUrl.protocol)) : new URL(normalizedLocation);
        if ($9915aeece4ba52df$export$961a3ef7a4da3a39(url.toString())) throw new Error("Invalid redirect location");
        let isSameBasename = (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(url.pathname, basename) != null;
        if (url.origin === currentUrl.origin && isSameBasename) return (0, $f1195701c85e5ce2$export$f857a07c5bd323b8)(url.pathname) + url.search + url.hash;
    }
    try {
        if ($9915aeece4ba52df$export$961a3ef7a4da3a39(historyInstance.createURL(location).toString())) throw new Error("Invalid redirect location");
    } catch  {}
    return location;
}
function $9915aeece4ba52df$var$createClientSideRequest(history, location, signal, submission) {
    let url = history.createURL($9915aeece4ba52df$var$stripHashFromPath(location)).toString();
    let init = {
        signal: signal
    };
    if (submission && $9915aeece4ba52df$export$cbae47800eb95bc3(submission.formMethod)) {
        let { formMethod: formMethod, formEncType: formEncType } = submission;
        init.method = formMethod.toUpperCase();
        if (formEncType === "application/json") {
            init.headers = new Headers({
                "Content-Type": formEncType
            });
            init.body = JSON.stringify(submission.json);
        } else if (formEncType === "text/plain") init.body = submission.text;
        else if (formEncType === "application/x-www-form-urlencoded" && submission.formData) init.body = $9915aeece4ba52df$var$convertFormDataToSearchParams(submission.formData);
        else init.body = submission.formData;
    }
    return new Request(url, init);
}
function $9915aeece4ba52df$var$convertFormDataToSearchParams(formData) {
    let searchParams = new URLSearchParams();
    for (let [key, value] of formData.entries())searchParams.append(key, typeof value === "string" ? value : value.name);
    return searchParams;
}
function $9915aeece4ba52df$var$convertSearchParamsToFormData(searchParams) {
    let formData = new FormData();
    for (let [key, value] of searchParams.entries())formData.append(key, value);
    return formData;
}
function $9915aeece4ba52df$var$processRouteLoaderData(matches, results, pendingActionResult, isStaticHandler = false, skipLoaderErrorBubbling = false) {
    let loaderData = {};
    let errors = null;
    let statusCode;
    let foundError = false;
    let loaderHeaders = {};
    let pendingError = pendingActionResult && $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1]) ? pendingActionResult[1].error : void 0;
    matches.forEach((match)=>{
        if (!(match.route.id in results)) return;
        let id = match.route.id;
        let result = results[id];
        (0, $072a56029499ae6c$export$f5708dca728d7177)(!$9915aeece4ba52df$var$isRedirectResult(result), "Cannot handle redirect results in processLoaderData");
        if ($9915aeece4ba52df$var$isErrorResult(result)) {
            let error = result.error;
            if (pendingError !== void 0) {
                error = pendingError;
                pendingError = void 0;
            }
            errors = errors || {};
            if (skipLoaderErrorBubbling) errors[id] = error;
            else {
                let boundaryMatch = $9915aeece4ba52df$var$findNearestBoundary(matches, id);
                if (errors[boundaryMatch.route.id] == null) errors[boundaryMatch.route.id] = error;
            }
            if (!isStaticHandler) loaderData[id] = $9915aeece4ba52df$var$ResetLoaderDataSymbol;
            if (!foundError) {
                foundError = true;
                statusCode = (0, $f1195701c85e5ce2$export$972111febbeef05b)(result.error) ? result.error.status : 500;
            }
            if (result.headers) loaderHeaders[id] = result.headers;
        } else {
            loaderData[id] = result.data;
            if (result.statusCode && result.statusCode !== 200 && !foundError) statusCode = result.statusCode;
            if (result.headers) loaderHeaders[id] = result.headers;
        }
    });
    if (pendingError !== void 0 && pendingActionResult) {
        errors = {
            [pendingActionResult[0]]: pendingError
        };
        if (pendingActionResult[2]) loaderData[pendingActionResult[2]] = void 0;
    }
    return {
        loaderData: loaderData,
        errors: errors,
        statusCode: statusCode || 200,
        loaderHeaders: loaderHeaders
    };
}
function $9915aeece4ba52df$var$processLoaderData(state, matches, results, pendingActionResult, revalidatingFetchers, fetcherResults, workingFetchers) {
    let { loaderData: loaderData, errors: errors } = $9915aeece4ba52df$var$processRouteLoaderData(matches, results, pendingActionResult);
    revalidatingFetchers.filter((f)=>!f.matches || f.matches.some((m)=>m.shouldLoad)).forEach((rf)=>{
        let { key: key, match: match, controller: controller } = rf;
        if (controller && controller.signal.aborted) return;
        let result = fetcherResults[key];
        (0, $072a56029499ae6c$export$f5708dca728d7177)(result, "Did not find corresponding fetcher result");
        if ($9915aeece4ba52df$var$isErrorResult(result)) {
            let boundaryMatch = $9915aeece4ba52df$var$findNearestBoundary(state.matches, match?.route.id);
            if (!(errors && errors[boundaryMatch.route.id])) errors = {
                ...errors,
                [boundaryMatch.route.id]: result.error
            };
            workingFetchers.delete(key);
        } else if ($9915aeece4ba52df$var$isRedirectResult(result)) (0, $072a56029499ae6c$export$f5708dca728d7177)(false, "Unhandled fetcher revalidation redirect");
        else {
            let doneFetcher = $9915aeece4ba52df$var$getDoneFetcher(result.data);
            workingFetchers.set(key, doneFetcher);
        }
    });
    return {
        loaderData: loaderData,
        errors: errors
    };
}
function $9915aeece4ba52df$var$mergeLoaderData(loaderData, newLoaderData, matches, errors) {
    let mergedLoaderData = Object.entries(newLoaderData).filter(([, v])=>v !== $9915aeece4ba52df$var$ResetLoaderDataSymbol).reduce((merged, [k, v])=>{
        merged[k] = v;
        return merged;
    }, {});
    let preservedCount = 0;
    for (let match of matches){
        let id = match.route.id;
        if (!newLoaderData.hasOwnProperty(id) && loaderData.hasOwnProperty(id) && match.route.loader) {
            mergedLoaderData[id] = loaderData[id];
            preservedCount++;
        }
        if (errors && errors.hasOwnProperty(id)) break;
    }
    return Object.keys(newLoaderData).length === 0 && preservedCount === Object.keys(loaderData).length ? loaderData : mergedLoaderData;
}
function $9915aeece4ba52df$var$getActionDataForCommit(pendingActionResult) {
    if (!pendingActionResult) return {};
    return $9915aeece4ba52df$var$isErrorResult(pendingActionResult[1]) ? {
        actionData: {}
    } : {
        actionData: {
            [pendingActionResult[0]]: pendingActionResult[1].data
        }
    };
}
function $9915aeece4ba52df$var$findNearestBoundary(matches, routeId) {
    return (routeId ? matches.slice(0, matches.findIndex((m)=>m.route.id === routeId) + 1) : [
        ...matches
    ]).reverse().find((m)=>m.route.ErrorBoundary != null || m.route.errorElement != null) || matches[0];
}
function $9915aeece4ba52df$var$getShortCircuitMatches(routes) {
    let route = routes.length === 1 ? routes[0] : routes.find((r)=>r.index || !r.path || r.path === "/") || {
        id: `__shim-error-route__`
    };
    return {
        matches: [
            {
                params: {},
                pathname: "",
                pathnameBase: "",
                route: route
            }
        ],
        route: route
    };
}
function $9915aeece4ba52df$var$getInternalRouterError(status, { pathname: pathname, routeId: routeId, method: method, type: type, message: message } = {}) {
    let statusText = "Unknown Server Error";
    let errorMessage = "Unknown @remix-run/router error";
    if (status === 400) {
        statusText = "Bad Request";
        if (method && pathname && routeId) errorMessage = `You made a ${method} request to "${pathname}" but did not provide a \`loader\` for route "${routeId}", so there is no way to handle the request.`;
        else if (type === "invalid-body") errorMessage = "Unable to encode submission body";
    } else if (status === 403) {
        statusText = "Forbidden";
        errorMessage = `Route "${routeId}" does not match URL "${pathname}"`;
    } else if (status === 404) {
        statusText = "Not Found";
        errorMessage = `No route matches URL "${pathname}"`;
    } else if (status === 405) {
        statusText = "Method Not Allowed";
        if (method && pathname && routeId) errorMessage = `You made a ${method.toUpperCase()} request to "${pathname}" but did not provide an \`action\` for route "${routeId}", so there is no way to handle the request.`;
        else if (method) errorMessage = `Invalid request method "${method.toUpperCase()}"`;
    }
    return new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(status || 500, statusText, new Error(errorMessage), true);
}
function $9915aeece4ba52df$var$findRedirect(results) {
    let entries = Object.entries(results);
    for(let i = entries.length - 1; i >= 0; i--){
        let [key, result] = entries[i];
        if ($9915aeece4ba52df$var$isRedirectResult(result)) return {
            key: key,
            result: result
        };
    }
}
function $9915aeece4ba52df$var$stripHashFromPath(path) {
    return (0, $072a56029499ae6c$export$fe53371bee54353d)({
        ...typeof path === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(path) : path,
        hash: ""
    });
}
function $9915aeece4ba52df$var$isHashChangeOnly(a, b) {
    if (a.pathname !== b.pathname || a.search !== b.search) return false;
    if (a.hash === "") return b.hash !== "";
    else if (a.hash === b.hash) return true;
    else if (b.hash !== "") return true;
    return false;
}
function $9915aeece4ba52df$var$dataWithResponseInitToResponse(data) {
    return Response.json(data.data, data.init ?? void 0);
}
function $9915aeece4ba52df$var$dataWithResponseInitToErrorResponse(data) {
    return new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(data.init?.status ?? 500, data.init?.statusText ?? "Internal Server Error", data.data);
}
function $9915aeece4ba52df$var$isDataStrategyResults(result) {
    return result != null && typeof result === "object" && Object.entries(result).every(([key, value])=>typeof key === "string" && $9915aeece4ba52df$var$isDataStrategyResult(value));
}
function $9915aeece4ba52df$var$isDataStrategyResult(result) {
    return result != null && typeof result === "object" && "type" in result && "result" in result && (result.type === "data" || result.type === "error");
}
function $9915aeece4ba52df$var$isRedirectDataStrategyResult(result) {
    return $9915aeece4ba52df$export$3f1eb41d9a6a6a27(result.result) && $9915aeece4ba52df$var$redirectStatusCodes.has(result.result.status);
}
function $9915aeece4ba52df$var$isErrorResult(result) {
    return result.type === "error";
}
function $9915aeece4ba52df$var$isRedirectResult(result) {
    return (result && result.type) === "redirect";
}
function $9915aeece4ba52df$export$e0163cfdf7bc9cfa(value) {
    return typeof value === "object" && value != null && "type" in value && "data" in value && "init" in value && value.type === "DataWithResponseInit";
}
function $9915aeece4ba52df$export$3f1eb41d9a6a6a27(value) {
    return value != null && typeof value.status === "number" && typeof value.statusText === "string" && typeof value.headers === "object" && typeof value.body !== "undefined";
}
function $9915aeece4ba52df$export$794b2760043cf8cd(statusCode) {
    return $9915aeece4ba52df$var$redirectStatusCodes.has(statusCode);
}
function $9915aeece4ba52df$export$6e80290866a84dd4(result) {
    return $9915aeece4ba52df$export$3f1eb41d9a6a6a27(result) && $9915aeece4ba52df$export$794b2760043cf8cd(result.status) && result.headers.has("Location");
}
function $9915aeece4ba52df$var$isValidMethod(method) {
    return $9915aeece4ba52df$var$validRequestMethods.has(method.toUpperCase());
}
function $9915aeece4ba52df$export$cbae47800eb95bc3(method) {
    return $9915aeece4ba52df$var$validMutationMethods.has(method.toUpperCase());
}
function $9915aeece4ba52df$var$hasNakedIndexQuery(search) {
    return new URLSearchParams(search).getAll("index").some((v)=>v === "");
}
function $9915aeece4ba52df$var$getTargetMatch(matches, location) {
    let search = typeof location === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(location).search : location.search;
    if (matches[matches.length - 1].route.index && $9915aeece4ba52df$var$hasNakedIndexQuery(search || "")) return matches[matches.length - 1];
    let pathMatches = (0, $f1195701c85e5ce2$export$b234c29a3bb68fc8)(matches);
    return pathMatches[pathMatches.length - 1];
}
function $9915aeece4ba52df$var$getInstrumentationNavigateMeta(history, location, matches) {
    return {
        url: (0, $f1195701c85e5ce2$export$141d98e45b4b08e4)(history.createURL(location), location),
        pattern: matches ? (0, $f1195701c85e5ce2$export$d738435097971c09)(matches) : "",
        params: matches?.[0]?.params ? {
            ...matches[0].params
        } : {}
    };
}
function $9915aeece4ba52df$var$getSubmissionFromNavigation(navigation) {
    let { formMethod: formMethod, formAction: formAction, formEncType: formEncType, text: text, formData: formData, json: json } = navigation;
    if (!formMethod || !formAction || !formEncType) return;
    if (text != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: void 0,
        text: text
    };
    else if (formData != null) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: formData,
        json: void 0,
        text: void 0
    };
    else if (json !== void 0) return {
        formMethod: formMethod,
        formAction: formAction,
        formEncType: formEncType,
        formData: void 0,
        json: json,
        text: void 0
    };
}
function $9915aeece4ba52df$var$getLoadingNavigation(location, matches, historyAction, submission) {
    if (submission) return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
    else return {
        state: "loading",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0
    };
}
function $9915aeece4ba52df$var$getSubmittingNavigation(location, matches, historyAction, submission) {
    return {
        state: "submitting",
        location: location,
        matches: matches,
        historyAction: historyAction,
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text
    };
}
function $9915aeece4ba52df$var$getLoadingFetcher(submission, data) {
    if (submission) return {
        state: "loading",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: data
    };
    else return {
        state: "loading",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $9915aeece4ba52df$var$getSubmittingFetcher(submission, existingFetcher) {
    return {
        state: "submitting",
        formMethod: submission.formMethod,
        formAction: submission.formAction,
        formEncType: submission.formEncType,
        formData: submission.formData,
        json: submission.json,
        text: submission.text,
        data: existingFetcher ? existingFetcher.data : void 0
    };
}
function $9915aeece4ba52df$var$getDoneFetcher(data) {
    return {
        state: "idle",
        formMethod: void 0,
        formAction: void 0,
        formEncType: void 0,
        formData: void 0,
        json: void 0,
        text: void 0,
        data: data
    };
}
function $9915aeece4ba52df$var$restoreAppliedTransitions(_window, transitions) {
    try {
        let sessionPositions = _window.sessionStorage.getItem($9915aeece4ba52df$var$TRANSITIONS_STORAGE_KEY);
        if (sessionPositions) {
            let json = JSON.parse(sessionPositions);
            for (let [k, v] of Object.entries(json || {}))if (v && Array.isArray(v)) transitions.set(k, new Set(v || []));
        }
    } catch  {}
}
function $9915aeece4ba52df$var$persistAppliedTransitions(_window, transitions) {
    if (transitions.size > 0) {
        let json = {};
        for (let [k, v] of transitions)json[k] = [
            ...v
        ];
        try {
            _window.sessionStorage.setItem($9915aeece4ba52df$var$TRANSITIONS_STORAGE_KEY, JSON.stringify(json));
        } catch (error) {
            (0, $072a56029499ae6c$export$491112666e282270)(false, `Failed to save applied view transitions in sessionStorage (${error}).`);
        }
    }
}
function $9915aeece4ba52df$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
var $aZSru = parcelRequire("aZSru");
//#region lib/context.ts
const $b71c75740e61495f$export$2eeee58951ff3c1c = $aZSru.createContext(null);
$b71c75740e61495f$export$2eeee58951ff3c1c.displayName = "DataRouter";
const $b71c75740e61495f$export$315e3ffb01f217 = $aZSru.createContext(null);
$b71c75740e61495f$export$315e3ffb01f217.displayName = "DataRouterState";
const $b71c75740e61495f$export$19d7395466bdeac8 = $aZSru.createContext(null);
$b71c75740e61495f$export$19d7395466bdeac8.displayName = "DataRouterData";
const $b71c75740e61495f$export$2473c5952c6a10d1 = $aZSru.createContext(null);
$b71c75740e61495f$export$2473c5952c6a10d1.displayName = "DataRouterNavigation";
const $b71c75740e61495f$export$717f757c655223f1 = $aZSru.createContext(false);
function $b71c75740e61495f$export$6e1eeb090b3ec35b() {
    return $aZSru.useContext($b71c75740e61495f$export$717f757c655223f1);
}
const $b71c75740e61495f$export$3681f408decb40d1 = $aZSru.createContext({
    isTransitioning: false
});
$b71c75740e61495f$export$3681f408decb40d1.displayName = "ViewTransition";
const $b71c75740e61495f$export$cb3f1df1bef00a39 = $aZSru.createContext(null);
$b71c75740e61495f$export$cb3f1df1bef00a39.displayName = "Fetchers";
const $b71c75740e61495f$export$804c460aade54ac8 = $aZSru.createContext(null);
$b71c75740e61495f$export$804c460aade54ac8.displayName = "Await";
const $b71c75740e61495f$export$2666c20e15407622 = (props)=>$aZSru.createElement($b71c75740e61495f$export$804c460aade54ac8.Provider, props);
const $b71c75740e61495f$export$3044ab7fdabeaee6 = $aZSru.createContext(null);
$b71c75740e61495f$export$3044ab7fdabeaee6.displayName = "Navigation";
const $b71c75740e61495f$export$e6a44b110a0c44d3 = $aZSru.createContext(null);
$b71c75740e61495f$export$e6a44b110a0c44d3.displayName = "Location";
const $b71c75740e61495f$export$aac280ed165a4397 = $aZSru.createContext({
    outlet: null,
    matches: [],
    isDataRoute: false
});
$b71c75740e61495f$export$aac280ed165a4397.displayName = "Route";
const $b71c75740e61495f$export$efd71bfc7ccfba1 = $aZSru.createContext(false);
$b71c75740e61495f$export$efd71bfc7ccfba1.displayName = "IsDataRoute";
const $b71c75740e61495f$export$92d0be8f6ef5c7bf = $aZSru.createContext(void 0);
$b71c75740e61495f$export$92d0be8f6ef5c7bf.displayName = "RouteId";
const $b71c75740e61495f$export$af8bd2647fea9c11 = $aZSru.createContext(null);
$b71c75740e61495f$export$af8bd2647fea9c11.displayName = "RouteError";


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 





/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
//#region lib/errors.ts
const $797efbaf00c8dba6$var$ERROR_DIGEST_BASE = "REACT_ROUTER_ERROR";
const $797efbaf00c8dba6$var$ERROR_DIGEST_REDIRECT = "REDIRECT";
const $797efbaf00c8dba6$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE = "ROUTE_ERROR_RESPONSE";
function $797efbaf00c8dba6$export$30db792b333fd2ee(digest) {
    if (digest.startsWith(`${$797efbaf00c8dba6$var$ERROR_DIGEST_BASE}:${$797efbaf00c8dba6$var$ERROR_DIGEST_REDIRECT}:{`)) try {
        let parsed = JSON.parse(digest.slice(28));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string" && typeof parsed.location === "string" && typeof parsed.reloadDocument === "boolean" && typeof parsed.replace === "boolean") return parsed;
    } catch  {}
}
function $797efbaf00c8dba6$export$2b5950305b3e7eaf(digest) {
    if (digest.startsWith(`${$797efbaf00c8dba6$var$ERROR_DIGEST_BASE}:${$797efbaf00c8dba6$var$ERROR_DIGEST_ROUTE_ERROR_RESPONSE}:{`)) try {
        let parsed = JSON.parse(digest.slice(40));
        if (typeof parsed === "object" && parsed && typeof parsed.status === "number" && typeof parsed.statusText === "string") return new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(parsed.status, parsed.statusText, parsed.data);
    } catch  {}
}



var $aZSru = parcelRequire("aZSru");
var $da3cac5a2aaa7b71$var$_React$1_Component, $da3cac5a2aaa7b71$var$_class;
//#region lib/hooks.tsx
/**
* Resolves a URL against the current {@link Location}.
*
* @example
* import { useHref } from "react-router";
*
* function SomeComponent() {
*   let href = useHref("some/where");
*   // "/resolved/some/where"
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the
* route tree.
* Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved href string
*/ function $da3cac5a2aaa7b71$export$b66bb29c5006f12f(to, { relative: relative } = {}) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)($da3cac5a2aaa7b71$export$9c954a9d03d32f4a(), `useHref() may be used only in the context of a <Router> component.`);
    let { basename: basename, navigator: navigator } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let { hash: hash, pathname: pathname, search: search } = $da3cac5a2aaa7b71$export$e75d2a2d1b3c245b(to, {
        relative: relative
    });
    let joinedPathname = pathname;
    if (basename !== "/") joinedPathname = pathname === "/" ? basename : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
        basename,
        pathname
    ]);
    return navigator.createHref({
        pathname: joinedPathname,
        search: search,
        hash: hash
    });
}
/**
* Returns `true` if this component is a descendant of a {@link Router}, useful
* to ensure a component is used within a {@link Router}.
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns Whether the component is within a {@link Router} context
*/ function $da3cac5a2aaa7b71$export$9c954a9d03d32f4a() {
    return $aZSru.useContext((0, $b71c75740e61495f$export$e6a44b110a0c44d3)) != null;
}
/**
* Returns the current {@link Location}. This can be useful if you'd like to
* perform some side effect whenever it changes.
*
* @example
* import * as React from 'react'
* import { useLocation } from 'react-router'
*
* function SomeComponent() {
*   let location = useLocation()
*
*   React.useEffect(() => {
*     // Google Analytics
*     ga('send', 'pageview')
*   }, [location]);
*
*   return (
*     // ...
*   );
* }
*
* @public
* @category Hooks
* @returns The current {@link Location} object
*/ function $da3cac5a2aaa7b71$export$45d76561a5302f2b() {
    (0, $072a56029499ae6c$export$f5708dca728d7177)($da3cac5a2aaa7b71$export$9c954a9d03d32f4a(), `useLocation() may be used only in the context of a <Router> component.`);
    return $aZSru.useContext((0, $b71c75740e61495f$export$e6a44b110a0c44d3)).location;
}
/**
* Returns the current {@link Navigation} action which describes how the router
* came to the current {@link Location}, either by a pop, push, or replace on
* the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack.
*
* @public
* @category Hooks
* @returns The current {@link NavigationType} (`"POP"`, `"PUSH"`, or `"REPLACE"`)
*/ function $da3cac5a2aaa7b71$export$1b3f31771c5d07c() {
    return $aZSru.useContext((0, $b71c75740e61495f$export$e6a44b110a0c44d3)).navigationType;
}
/**
* Returns a {@link PathMatch} object if the given pattern matches the current URL.
* This is useful for components that need to know "active" state, e.g.
* {@link NavLink | `<NavLink>`}.
*
* @public
* @category Hooks
* @param pattern The pattern to match against the current {@link Location}
* @returns The path match object if the pattern matches, `null` otherwise
*/ function $da3cac5a2aaa7b71$export$6c330e8992e8a295(pattern) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)($da3cac5a2aaa7b71$export$9c954a9d03d32f4a(), `useMatch() may be used only in the context of a <Router> component.`);
    let { pathname: pathname } = $da3cac5a2aaa7b71$export$45d76561a5302f2b();
    return $aZSru.useMemo(()=>(0, $f1195701c85e5ce2$export$81336c211d5ff295)(pattern, (0, $f1195701c85e5ce2$export$cd27bea214d030c2)(pathname)), [
        pathname,
        pattern
    ]);
}
const $da3cac5a2aaa7b71$var$navigateEffectWarning = "You should call navigate() in a React.useEffect(), not when your component is first rendered.";
/**
* Returns a function that lets you navigate programmatically in the browser in
* response to user interactions or effects.
*
* It's often better to use {@link redirect} in [`action`](../../start/framework/route-module#action)/[`loader`](../../start/framework/route-module#loader)
* functions than this hook.
*
* The returned function signature is `navigate(to, options?)`/`navigate(delta)` where:
*
* * `to` can be a string path, a {@link To} object, or a number (delta)
* * `options` contains options for modifying the navigation
*   * These options work in all modes (Framework, Data, and Declarative):
*     * `relative`: `"route"` or `"path"` to control relative routing logic
*     * `replace`: Replace the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History) stack
*     * `state`: Optional [`history.state`](https://developer.mozilla.org/en-US/docs/Web/API/History/state) to include with the new {@link Location}
*   * These options only work in Framework and Data modes:
*     * `flushSync`: Wrap the DOM updates in [`ReactDom.flushSync`](https://react.dev/reference/react-dom/flushSync)
*     * `preventScrollReset`: Do not scroll back to the top of the page after navigation
*     * `viewTransition`: Enable [`document.startViewTransition`](https://developer.mozilla.org/en-US/docs/Web/API/Document/startViewTransition) for this navigation
*
* @example
* import { useNavigate } from "react-router";
*
* function SomeComponent() {
*   let navigate = useNavigate();
*   return (
*     <button onClick={() => navigate(-1)}>
*       Go Back
*     </button>
*   );
* }
*
* @additionalExamples
* ### Navigate to another path
*
* ```tsx
* navigate("/some/route");
* navigate("/some/route?search=param");
* ```
*
* ### Navigate with a {@link To} object
*
* All properties are optional.
*
* ```tsx
* navigate(
*   {
*     pathname: "/some/route",
*     search: "?search=param",
*     hash: "#hash",
*   },
*   {
*     state: { some: "state" },
*   },
* );
* ```
*
* If you use `state`, that will be available on the {@link Location} object on
* the next page. Access it with `useLocation().state` (see {@link useLocation}).
*
* ### Navigate back or forward in the history stack
*
* ```tsx
* // back
* // often used to close modals
* navigate(-1);
*
* // forward
* // often used in a multistep wizard workflows
* navigate(1);
* ```
*
* Be cautious with `navigate(number)`. If your application can load up to a
* route that has a button that tries to navigate forward/back, there may not be
* a [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry to go back or forward to, or it can go somewhere you don't expect
* (like a different domain).
*
* Only use this if you're sure they will have an entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack to navigate to.
*
* ### Replace the current entry in the history stack
*
* This will remove the current entry in the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, replacing it with a new one, similar to a server side redirect.
*
* ```tsx
* navigate("/some/route", { replace: true });
* ```
*
* ### Prevent Scroll Reset
*
* [MODES: framework, data]
*
* <br/>
* <br/>
*
* To prevent {@link ScrollRestoration | `<ScrollRestoration>`} from resetting
* the scroll position, use the `preventScrollReset` option.
*
* ```tsx
* navigate("?some-tab=1", { preventScrollReset: true });
* ```
*
* For example, if you have a tab interface connected to search params in the
* middle of a page, and you don't want it to scroll to the top when a tab is
* clicked.
*
* ### Return Type Augmentation
*
* Internally, `useNavigate` uses a separate implementation when you are in
* Declarative mode versus Data/Framework mode - the primary difference being
* that the latter is able to return a stable reference that does not change
* identity across navigations. The implementation in Data/Framework mode also
* returns a [`Promise`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise)
* that resolves when the navigation is completed. This means the return type of
* `useNavigate` is `void | Promise<void>`. This is accurate, but can lead to
* some red squigglies based on the union in the return value:
*
* - If you're using `typescript-eslint`, you may see errors from
*   [`@typescript-eslint/no-floating-promises`](https://typescript-eslint.io/rules/no-floating-promises)
* - In Framework/Data mode, `React.use(navigate())` will show a false-positive
*   `Argument of type 'void | Promise<void>' is not assignable to parameter of
*   type 'Usable<void>'` error
*
* The easiest way to work around these issues is to augment the type based on the
* router you're using:
*
* ```ts
* // If using <BrowserRouter>
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): void;
*     (delta: number): void;
*   }
* }
*
* // If using <RouterProvider> or Framework mode
* declare module "react-router" {
*   interface NavigateFunction {
*     (to: To, options?: NavigateOptions): Promise<void>;
*     (delta: number): Promise<void>;
*   }
* }
* ```
*
* @public
* @category Hooks
* @returns A navigate function for programmatic navigation
*/ function $da3cac5a2aaa7b71$export$9770f232ac06a008() {
    return $aZSru.useContext((0, $b71c75740e61495f$export$efd71bfc7ccfba1)) ? $da3cac5a2aaa7b71$var$useNavigateStable() : $da3cac5a2aaa7b71$var$useNavigateUnstable();
}
function $da3cac5a2aaa7b71$var$useNavigateUnstable() {
    (0, $072a56029499ae6c$export$f5708dca728d7177)($da3cac5a2aaa7b71$export$9c954a9d03d32f4a(), `useNavigate() may be used only in the context of a <Router> component.`);
    let dataRouterContext = $aZSru.useContext((0, $b71c75740e61495f$export$2eeee58951ff3c1c));
    let { basename: basename, navigator: navigator } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let { matches: matches } = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397));
    let { pathname: locationPathname } = $da3cac5a2aaa7b71$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f1195701c85e5ce2$export$fe6dbc5de95f53ab)(matches));
    let activeRef = $aZSru.useRef(false);
    $aZSru.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $aZSru.useCallback((to, options = {})=>{
        (0, $072a56029499ae6c$export$491112666e282270)(activeRef.current, $da3cac5a2aaa7b71$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") {
            navigator.go(to);
            return;
        }
        let path = (0, $f1195701c85e5ce2$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, options.relative === "path");
        if (dataRouterContext == null && basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
            basename,
            path.pathname
        ]);
        (0, $0179caaefc35c7e3$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $072a56029499ae6c$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $0179caaefc35c7e3$export$1da545bc000055cf)(navigator), "reject");
        (!!options.replace ? navigator.replace : navigator.push)(path, options.state, options);
    }, [
        basename,
        navigator,
        routePathnamesJson,
        locationPathname,
        dataRouterContext
    ]);
}
const $da3cac5a2aaa7b71$var$OutletContext = $aZSru.createContext(null);
/**
* Returns the parent route {@link Outlet | `<Outlet context>`}.
*
* Often parent routes manage state or other values you want shared with child
* routes. You can create your own [context provider](https://react.dev/learn/passing-data-deeply-with-context)
* if you like, but this is such a common situation that it's built-into
* {@link Outlet | `<Outlet>`}.
*
* ```tsx
* // Parent route
* function Parent() {
*   const [count, setCount] = React.useState(0);
*   return <Outlet context={[count, setCount]} />;
* }
* ```
*
* ```tsx
* // Child route
* import { useOutletContext } from "react-router";
*
* function Child() {
*   const [count, setCount] = useOutletContext();
*   const increment = () => setCount((c) => c + 1);
*   return <button onClick={increment}>{count}</button>;
* }
* ```
*
* If you're using TypeScript, we recommend the parent component provide a
* custom hook for accessing the context value. This makes it easier for
* consumers to get nice typings, control consumers, and know who's consuming
* the context value.
*
* Here's a more realistic example:
*
* ```tsx filename=src/routes/dashboard.tsx lines=[14,20]
* import { useState } from "react";
* import { Outlet, useOutletContext } from "react-router";
*
* import type { User } from "./types";
*
* type ContextType = { user: User | null };
*
* export default function Dashboard() {
*   const [user, setUser] = useState<User | null>(null);
*
*   return (
*     <div>
*       <h1>Dashboard</h1>
*       <Outlet context={{ user } satisfies ContextType} />
*     </div>
*   );
* }
*
* export function useUser() {
*   return useOutletContext<ContextType>();
* }
* ```
*
* ```tsx filename=src/routes/dashboard/messages.tsx lines=[1,4]
* import { useUser } from "../dashboard";
*
* export default function DashboardMessages() {
*   const { user } = useUser();
*   return (
*     <div>
*       <h2>Messages</h2>
*       <p>Hello, {user.name}!</p>
*     </div>
*   );
* }
* ```
*
* @public
* @category Hooks
* @returns The context value passed to the parent {@link Outlet} component
*/ function $da3cac5a2aaa7b71$export$4138103a3ae699cc() {
    return $aZSru.useContext($da3cac5a2aaa7b71$var$OutletContext);
}
/**
* Returns the element for the child route at this level of the route
* hierarchy. Used internally by {@link Outlet | `<Outlet>`} to render child
* routes.
*
* @public
* @category Hooks
* @param context The context to pass to the outlet
* @returns The child route element or `null` if no child routes match
*/ function $da3cac5a2aaa7b71$export$a3be3530d8e40d0b(context) {
    let outlet = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397)).outlet;
    return $aZSru.useMemo(()=>outlet && /* @__PURE__ */ $aZSru.createElement($da3cac5a2aaa7b71$var$OutletContext.Provider, {
            value: context
        }, outlet), [
        outlet,
        context
    ]);
}
/**
* Returns an object of key/value-pairs of the dynamic params from the current
* URL that were matched by the routes. Child routes inherit all params from
* their parent routes.
*
* Assuming a route pattern like `/posts/:postId` is matched by `/posts/123`
* then `params.postId` will be `"123"`.
*
* @example
* import { useParams } from "react-router";
*
* function SomeComponent() {
*   let params = useParams();
*   params.postId;
* }
*
* @additionalExamples
* ### Basic Usage
*
* ```tsx
* import { useParams } from "react-router";
*
* // given a route like:
* <Route path="/posts/:postId" element={<Post />} />;
*
* // or a data route like:
* createBrowserRouter([
*   {
*     path: "/posts/:postId",
*     component: Post,
*   },
* ]);
*
* // or in routes.ts
* route("/posts/:postId", "routes/post.tsx");
* ```
*
* Access the params in a component:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return <h1>Post: {params.postId}</h1>;
* }
* ```
*
* ### Multiple Params
*
* Patterns can have multiple params:
*
* ```tsx
* "/posts/:postId/comments/:commentId";
* ```
*
* All will be available in the params object:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function Post() {
*   let params = useParams();
*   return (
*     <h1>
*       Post: {params.postId}, Comment: {params.commentId}
*     </h1>
*   );
* }
* ```
*
* ### Catchall Params
*
* Catchall params are defined with `*`:
*
* ```tsx
* "/files/*";
* ```
*
* The matched value will be available in the params object as follows:
*
* ```tsx
* import { useParams } from "react-router";
*
* export default function File() {
*   let params = useParams();
*   let catchall = params["*"];
*   // ...
* }
* ```
*
* You can destructure the catchall param:
*
* ```tsx
* export default function File() {
*   let { "*": catchall } = useParams();
*   console.log(catchall);
* }
* ```
*
* @public
* @category Hooks
* @returns An object containing the dynamic route parameters
*/ function $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef() {
    let { matches: matches } = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397));
    return matches[matches.length - 1]?.params ?? {};
}
/**
* Resolves the pathname of the given `to` value against the current
* {@link Location}. Similar to {@link useHref}, but returns a
* {@link Path} instead of a string.
*
* @example
* import { useResolvedPath } from "react-router";
*
* function SomeComponent() {
*   // if the user is at /dashboard/profile
*   let path = useResolvedPath("../accounts");
*   path.pathname; // "/dashboard/accounts"
*   path.search; // ""
*   path.hash; // ""
* }
*
* @public
* @category Hooks
* @param to The path to resolve
* @param options Options
* @param options.relative Defaults to `"route"` so routing is relative to the route tree.
*                         Set to `"path"` to make relative routing operate against path segments.
* @returns The resolved {@link Path} object with `pathname`, `search`, and `hash`
*/ function $da3cac5a2aaa7b71$export$e75d2a2d1b3c245b(to, { relative: relative } = {}) {
    let { matches: matches } = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397));
    let { pathname: locationPathname } = $da3cac5a2aaa7b71$export$45d76561a5302f2b();
    let routePathnamesJson = JSON.stringify((0, $f1195701c85e5ce2$export$fe6dbc5de95f53ab)(matches));
    return $aZSru.useMemo(()=>(0, $f1195701c85e5ce2$export$cae722b0cc860f13)(to, JSON.parse(routePathnamesJson), locationPathname, relative === "path"), [
        to,
        routePathnamesJson,
        locationPathname,
        relative
    ]);
}
/**
* Hook version of {@link Routes | `<Routes>`} that uses objects instead of
* components. These objects have the same properties as the component props.
* The return value of `useRoutes` is either a valid React element you can use
* to render the route tree, or `null` if nothing matched.
*
* @example
* import { useRoutes } from "react-router";
*
* function App() {
*   let element = useRoutes([
*     {
*       path: "/",
*       element: <Dashboard />,
*       children: [
*         {
*           path: "messages",
*           element: <DashboardMessages />,
*         },
*         { path: "tasks", element: <DashboardTasks /> },
*       ],
*     },
*     { path: "team", element: <AboutPage /> },
*   ]);
*
*   return element;
* }
*
* @public
* @category Hooks
* @param routes An array of {@link RouteObject}s that define the route hierarchy
* @param locationArg An optional {@link Location} object or pathname string to
* use instead of the current {@link Location}
* @returns A React element to render the matched route, or `null` if no routes matched
*/ function $da3cac5a2aaa7b71$export$5d3fca4a98652595(routes, locationArg) {
    return $da3cac5a2aaa7b71$export$f7ce0646a48561fb(routes, locationArg);
}
function $da3cac5a2aaa7b71$export$f7ce0646a48561fb(routes, locationArg, dataRouterOpts) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)($da3cac5a2aaa7b71$export$9c954a9d03d32f4a(), `useRoutes() may be used only in the context of a <Router> component.`);
    let { navigator: navigator } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let { matches: parentMatches } = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397));
    let routeMatch = parentMatches[parentMatches.length - 1];
    let parentParams = routeMatch ? routeMatch.params : {};
    routeMatch && routeMatch.pathname;
    let parentPathnameBase = routeMatch ? routeMatch.pathnameBase : "/";
    routeMatch && routeMatch.route;
    let locationFromContext = $da3cac5a2aaa7b71$export$45d76561a5302f2b();
    let location;
    if (locationArg) {
        let parsedLocationArg = typeof locationArg === "string" ? (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(locationArg) : locationArg;
        (0, $072a56029499ae6c$export$f5708dca728d7177)(parentPathnameBase === "/" || parsedLocationArg.pathname?.startsWith(parentPathnameBase), `When overriding the location using \`<Routes location>\` or \`useRoutes(routes, location)\`, the location pathname must begin with the portion of the URL pathname that was matched by all parent routes. The current pathname base is "${parentPathnameBase}" but pathname "${parsedLocationArg.pathname}" was given in the \`location\` prop.`);
        location = parsedLocationArg;
    } else location = locationFromContext;
    let pathname = location.pathname || "/";
    let remainingPathname = pathname;
    if (parentPathnameBase !== "/") {
        let parentSegments = parentPathnameBase.replace(/^\//, "").split("/");
        remainingPathname = "/" + pathname.replace(/^\//, "").split("/").slice(parentSegments.length).join("/");
    }
    let matches;
    if (dataRouterOpts) {
        if (dataRouterOpts.state.matches.length) matches = dataRouterOpts.state.matches.map((m)=>Object.assign(m, {
                route: dataRouterOpts.manifest[m.route.id] || m.route
            }));
        else matches = dataRouterOpts.router.match(dataRouterOpts.state.location);
    } else matches = (0, $f1195701c85e5ce2$export$2708184779ceb39d)(routes, {
        pathname: remainingPathname
    });
    let renderedMatches = $da3cac5a2aaa7b71$export$569816e95a012c39(matches && matches.map((match)=>Object.assign({}, match, {
            params: Object.assign({}, parentParams, match.params),
            pathname: (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathname.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathname
            ]),
            pathnameBase: match.pathnameBase === "/" ? parentPathnameBase : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
                parentPathnameBase,
                navigator.encodeLocation ? navigator.encodeLocation(match.pathnameBase.replace(/%/g, "%25").replace(/\?/g, "%3F").replace(/#/g, "%23")).pathname : match.pathnameBase
            ])
        })), parentMatches, dataRouterOpts);
    if (locationArg && renderedMatches) return /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$e6a44b110a0c44d3).Provider, {
        value: {
            location: {
                pathname: "/",
                search: "",
                hash: "",
                state: null,
                key: "default",
                mask: void 0,
                ...location
            },
            navigationType: "POP"
        }
    }, renderedMatches);
    return renderedMatches;
}
function $da3cac5a2aaa7b71$var$DefaultErrorComponent() {
    let error = $da3cac5a2aaa7b71$export$ed527bf60f6e05f2();
    let message = (0, $f1195701c85e5ce2$export$972111febbeef05b)(error) ? `${error.status} ${error.statusText}` : error instanceof Error ? error.message : JSON.stringify(error);
    let stack = error instanceof Error ? error.stack : null;
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, /* @__PURE__ */ $aZSru.createElement("h2", null, "Unexpected Application Error!"), /* @__PURE__ */ $aZSru.createElement("h3", {
        style: {
            fontStyle: "italic"
        }
    }, message), stack ? /* @__PURE__ */ $aZSru.createElement("pre", {
        style: {
            padding: "0.5rem",
            backgroundColor: "rgba(200,200,200, 0.5)"
        }
    }, stack) : null, null);
}
const $da3cac5a2aaa7b71$var$defaultErrorElement = /* @__PURE__ */ $aZSru.createElement($da3cac5a2aaa7b71$var$DefaultErrorComponent, null);
var $da3cac5a2aaa7b71$var$RenderErrorBoundary = ($da3cac5a2aaa7b71$var$_class = class extends ($da3cac5a2aaa7b71$var$_React$1_Component = $aZSru.Component) {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location || state.revalidation !== "idle" && props.revalidation === "idle") return {
            error: props.error,
            location: props.location,
            revalidation: props.revalidation
        };
        return {
            error: props.error !== void 0 ? props.error : state.error,
            location: state.location,
            revalidation: props.revalidation || state.revalidation
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("React Router caught the following error during render", error);
    }
    render() {
        let error = this.state.error;
        if (this.context && typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
            const decoded = (0, $797efbaf00c8dba6$export$2b5950305b3e7eaf)(error.digest);
            if (decoded) error = decoded;
        }
        let result = error !== void 0 ? /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$aac280ed165a4397).Provider, {
            value: this.props.routeContext
        }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$efd71bfc7ccfba1).Provider, {
            value: this.props.routeContext.isDataRoute
        }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$92d0be8f6ef5c7bf).Provider, {
            value: this.props.routeContext.matches[this.props.routeContext.matches.length - 1]?.route.id
        }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$af8bd2647fea9c11).Provider, {
            value: error,
            children: this.props.component
        })))) : this.props.children;
        if (this.context) return /* @__PURE__ */ $aZSru.createElement($da3cac5a2aaa7b71$var$RSCErrorHandler, {
            error: error
        }, result);
        return result;
    }
    constructor(props){
        super(props);
        this.state = {
            location: props.location,
            revalidation: props.revalidation,
            error: props.error
        };
    }
}, (0, $b08ae6015a2ae0d0$export$71511d61b312f219)($da3cac5a2aaa7b71$var$_class, "contextType", (0, $b71c75740e61495f$export$717f757c655223f1)), $da3cac5a2aaa7b71$var$_class);
const $da3cac5a2aaa7b71$var$errorRedirectHandledMap = /* @__PURE__ */ new WeakMap();
function $da3cac5a2aaa7b71$var$RSCErrorHandler({ children: children, error: error }) {
    let { basename: basename, navigator: navigator } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    if (typeof error === "object" && error && "digest" in error && typeof error.digest === "string") {
        let redirect = (0, $797efbaf00c8dba6$export$30db792b333fd2ee)(error.digest);
        if (redirect) {
            let existingRedirect = $da3cac5a2aaa7b71$var$errorRedirectHandledMap.get(error);
            if (existingRedirect) throw existingRedirect;
            let parsed = (0, $f1195701c85e5ce2$export$ac5aeb949e84fd96)(redirect.location, basename);
            let target = parsed.absoluteURL || parsed.to;
            (0, $0179caaefc35c7e3$export$6c8e41f66e7aa990)(redirect.location, target, (0, $0179caaefc35c7e3$export$1da545bc000055cf)(navigator), "allow-explicit");
            if ((0, $9915aeece4ba52df$export$961a3ef7a4da3a39)(target)) throw new Error("Invalid redirect location");
            if ((0, $f1195701c85e5ce2$export$4e09c449d6c407f7) && !$da3cac5a2aaa7b71$var$errorRedirectHandledMap.get(error)) {
                if (parsed.isExternal || redirect.reloadDocument) window.location.href = target;
                else {
                    const redirectPromise = Promise.resolve().then(()=>window.__reactRouterDataRouter.navigate(parsed.to, {
                            replace: redirect.replace
                        }));
                    $da3cac5a2aaa7b71$var$errorRedirectHandledMap.set(error, redirectPromise);
                    throw redirectPromise;
                }
            }
            return /* @__PURE__ */ $aZSru.createElement("meta", {
                httpEquiv: "refresh",
                content: `0;url=${target}`
            });
        }
    }
    return children;
}
function $da3cac5a2aaa7b71$var$RenderedRoute({ routeContext: routeContext, match: match, children: children }) {
    let dataRouterContext = $aZSru.useContext((0, $b71c75740e61495f$export$2eeee58951ff3c1c));
    if (dataRouterContext && dataRouterContext.static && dataRouterContext.staticContext && (match.route.errorElement || match.route.ErrorBoundary)) dataRouterContext.staticContext._deepestRenderedBoundaryId = match.route.id;
    return /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$aac280ed165a4397).Provider, {
        value: routeContext
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$efd71bfc7ccfba1).Provider, {
        value: routeContext.isDataRoute
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$92d0be8f6ef5c7bf).Provider, {
        value: match.route.id
    }, children)));
}
function $da3cac5a2aaa7b71$export$569816e95a012c39(matches, parentMatches = [], dataRouterOpts) {
    let dataRouterState = dataRouterOpts?.state;
    if (matches == null) {
        if (!dataRouterState) return null;
        if (dataRouterState.errors) matches = dataRouterState.matches;
        else if (parentMatches.length === 0 && !dataRouterState.initialized && dataRouterState.matches.length > 0) matches = dataRouterState.matches;
        else return null;
    }
    let renderedMatches = matches;
    let errors = dataRouterState?.errors;
    if (errors != null) {
        let errorIndex = renderedMatches.findIndex((m)=>m.route.id && errors?.[m.route.id] !== void 0);
        (0, $072a56029499ae6c$export$f5708dca728d7177)(errorIndex >= 0, `Could not find a matching route for errors on route IDs: ${Object.keys(errors).join(",")}`);
        renderedMatches = renderedMatches.slice(0, Math.min(renderedMatches.length, errorIndex + 1));
    }
    let renderFallback = false;
    let fallbackIndex = -1;
    if (dataRouterOpts && dataRouterState) {
        renderFallback = dataRouterState.renderFallback;
        for(let i = 0; i < renderedMatches.length; i++){
            let match = renderedMatches[i];
            if (match.route.HydrateFallback || match.route.hydrateFallbackElement) fallbackIndex = i;
            if (match.route.id) {
                let { loaderData: loaderData, errors: errors } = dataRouterState;
                let needsToRunLoader = match.route.loader && !loaderData.hasOwnProperty(match.route.id) && (!errors || errors[match.route.id] === void 0);
                if (match.route.lazy || needsToRunLoader) {
                    if (dataRouterOpts.isStatic) renderFallback = true;
                    if (fallbackIndex >= 0) renderedMatches = renderedMatches.slice(0, fallbackIndex + 1);
                    else renderedMatches = [
                        renderedMatches[0]
                    ];
                    break;
                }
            }
        }
    }
    let onErrorHandler = dataRouterOpts?.onError;
    let onError = dataRouterState && onErrorHandler ? (error, errorInfo)=>{
        onErrorHandler(error, {
            location: dataRouterState.location,
            params: dataRouterState.matches?.[0]?.params ?? {},
            pattern: (0, $f1195701c85e5ce2$export$d738435097971c09)(dataRouterState.matches),
            errorInfo: errorInfo
        });
    } : void 0;
    return renderedMatches.reduceRight((outlet, match, index)=>{
        let error;
        let shouldRenderHydrateFallback = false;
        let errorElement = null;
        let hydrateFallbackElement = null;
        if (dataRouterState) {
            error = errors && match.route.id ? errors[match.route.id] : void 0;
            errorElement = match.route.errorElement || $da3cac5a2aaa7b71$var$defaultErrorElement;
            if (renderFallback) {
                if (fallbackIndex < 0 && index === 0) {
                    $da3cac5a2aaa7b71$var$warningOnce("route-fallback", false, "No `HydrateFallback` element provided to render during initial hydration");
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = null;
                } else if (fallbackIndex === index) {
                    shouldRenderHydrateFallback = true;
                    hydrateFallbackElement = match.route.hydrateFallbackElement || null;
                }
            }
        }
        let matches = parentMatches.concat(renderedMatches.slice(0, index + 1));
        let getChildren = ()=>{
            let children;
            if (error) children = errorElement;
            else if (shouldRenderHydrateFallback) children = hydrateFallbackElement;
            else if (match.route.Component) children = /* @__PURE__ */ $aZSru.createElement(match.route.Component, null);
            else if (match.route.element) children = match.route.element;
            else children = outlet;
            return /* @__PURE__ */ $aZSru.createElement($da3cac5a2aaa7b71$var$RenderedRoute, {
                match: match,
                routeContext: {
                    outlet: outlet,
                    matches: matches,
                    isDataRoute: dataRouterState != null
                },
                children: children
            });
        };
        return dataRouterState && (match.route.ErrorBoundary || match.route.errorElement || index === 0) ? /* @__PURE__ */ $aZSru.createElement($da3cac5a2aaa7b71$var$RenderErrorBoundary, {
            location: dataRouterState.location,
            revalidation: dataRouterState.revalidation,
            component: errorElement,
            error: error,
            children: getChildren(),
            routeContext: {
                outlet: null,
                matches: matches,
                isDataRoute: true
            },
            onError: onError
        }) : getChildren();
    }, null);
}
function $da3cac5a2aaa7b71$var$getDataRouterConsoleError(hookName) {
    return `${hookName} must be used within a data router.  See https://reactrouter.com/en/main/routers/picking-a-router.`;
}
function $da3cac5a2aaa7b71$export$ae09415e57d46628(hookName) {
    let ctx = $aZSru.useContext((0, $b71c75740e61495f$export$2eeee58951ff3c1c));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(ctx, $da3cac5a2aaa7b71$var$getDataRouterConsoleError(hookName));
    return ctx;
}
function $da3cac5a2aaa7b71$export$f93124018767f269(hookName) {
    let state = $aZSru.useContext((0, $b71c75740e61495f$export$315e3ffb01f217));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(state, $da3cac5a2aaa7b71$var$getDataRouterConsoleError(hookName));
    return state;
}
function $da3cac5a2aaa7b71$export$c6e4e4d7047d4ffe(hookName) {
    let fetchers = $aZSru.useContext((0, $b71c75740e61495f$export$cb3f1df1bef00a39));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(fetchers, $da3cac5a2aaa7b71$var$getDataRouterConsoleError(hookName));
    return fetchers;
}
function $da3cac5a2aaa7b71$export$798168c290ba5b3d(hookName) {
    let data = $aZSru.useContext((0, $b71c75740e61495f$export$19d7395466bdeac8));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(data, $da3cac5a2aaa7b71$var$getDataRouterConsoleError(hookName));
    return data;
}
function $da3cac5a2aaa7b71$var$useDataRouterNavigation(hookName) {
    let navigation = $aZSru.useContext((0, $b71c75740e61495f$export$2473c5952c6a10d1));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(navigation, $da3cac5a2aaa7b71$var$getDataRouterConsoleError(hookName));
    return navigation;
}
function $da3cac5a2aaa7b71$export$501a3f562d56eac6(hookName) {
    let routeId = $aZSru.useContext((0, $b71c75740e61495f$export$92d0be8f6ef5c7bf));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(routeId, `${hookName} can only be used on routes that contain a unique "id"`);
    return routeId;
}
/**
* Returns the current {@link Navigation}, defaulting to an "idle" navigation
* when no navigation is in progress. You can use this to render pending UI
* (like a global spinner) or read [`FormData`](https://developer.mozilla.org/en-US/docs/Web/API/FormData)
* from a form navigation.
*
* @example
* import { useNavigation } from "react-router";
*
* function SomeComponent() {
*   let navigation = useNavigation();
*   navigation.state;
*   navigation.formData;
*   // etc.
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current {@link Navigation} object
*/ function $da3cac5a2aaa7b71$export$d0fd4b7106de2769() {
    let { navigation: navigation } = $da3cac5a2aaa7b71$var$useDataRouterNavigation("useNavigation");
    return $aZSru.useMemo(()=>{
        let { matches: matches, historyAction: historyAction, ...rest } = navigation;
        return rest;
    }, [
        navigation
    ]);
}
/**
* Revalidate the data on the page for reasons outside of normal data mutations
* like [`Window` focus](https://developer.mozilla.org/en-US/docs/Web/API/Window/focus_event)
* or polling on an interval.
*
* Note that page data is already revalidated automatically after actions.
* If you find yourself using this for normal CRUD operations on your data in
* response to user interactions, you're probably not taking advantage of the
* other APIs like {@link useFetcher}, {@link Form}, {@link useSubmit} that do
* this automatically.
*
* @example
* import { useRevalidator } from "react-router";
*
* function WindowFocusRevalidator() {
*   const revalidator = useRevalidator();
*
*   useFakeWindowFocus(() => {
*     revalidator.revalidate();
*   });
*
*   return (
*     <div hidden={revalidator.state === "idle"}>
*       Revalidating...
*     </div>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An object with a `revalidate` function and the current revalidation
* `state`
*/ function $da3cac5a2aaa7b71$export$600dc272ed516c15() {
    let dataRouterContext = $da3cac5a2aaa7b71$export$ae09415e57d46628("useRevalidator");
    let { revalidation: revalidation } = $da3cac5a2aaa7b71$var$useDataRouterNavigation("useRevalidator");
    let revalidate = $aZSru.useCallback(async ()=>{
        await dataRouterContext.router.revalidate();
    }, [
        dataRouterContext.router
    ]);
    return $aZSru.useMemo(()=>({
            revalidate: revalidate,
            state: revalidation
        }), [
        revalidate,
        revalidation
    ]);
}
/**
* Returns the active route matches, useful for accessing `loaderData` for
* parent/child routes or the route [`handle`](../../start/framework/route-module#handle)
* property
*
* Pairing the route `handle` with `useMatches` gets very powerful since you can put
* whatever you want on a route handle and have access to `useMatches` anywhere.
* Please see the [handle](../../how-to/using-handle) documentation for an example
* of breadcrumbs via `useMatches`/`handle`.
*
* ```tsx
* import { useMatches } from "react-router";
*
* function SomeComponent() {
*   const matches = useMatches();
*   // matches[i].id          // route id
*   // matches[i].pathname    // the portion of the URL the route matched
*   // matches[i].params      // the parsed params from the URL
*   // matches[i].loaderData  // the data from the loader
*   // matches[i].handle      // the route handle with any app specific data
* }
* ```
*
* <docs-info>useMatches only works with a data router like `createBrowserRouter`,
* since they know the full route tree up front and can provide all of the current
* matches. Additionally, `useMatches` will not match down into any descendant route
* trees since the router isn't aware of the descendant routes.</docs-info>
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of {@link UIMatch | UI matches} for the current route hierarchy
*/ function $da3cac5a2aaa7b71$export$2378eb7f5ff86053() {
    let { matches: matches } = $da3cac5a2aaa7b71$export$f93124018767f269("useMatches");
    let { loaderData: loaderData } = $da3cac5a2aaa7b71$export$798168c290ba5b3d("useMatches");
    return $aZSru.useMemo(()=>matches.map((m)=>(0, $f1195701c85e5ce2$export$fcf533780bf49ee2)(m, loaderData)), [
        matches,
        loaderData
    ]);
}
/**
* Returns the data from the closest route
* [`loader`](../../start/framework/route-module#loader) or
* [`clientLoader`](../../start/framework/route-module#clientloader).
*
* @example
* import { useLoaderData } from "react-router";
*
* export async function loader() {
*   return await fakeDb.invoices.findAll();
* }
*
* export default function Invoices() {
*   let invoices = useLoaderData<typeof loader>();
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`loader`](../../start/framework/route-module#loader) or [`clientLoader`](../../start/framework/route-module#clientloader) function
*/ function $da3cac5a2aaa7b71$export$1448a5050d252c4d() {
    let data = $da3cac5a2aaa7b71$export$798168c290ba5b3d("useLoaderData");
    let routeId = $da3cac5a2aaa7b71$export$501a3f562d56eac6("useLoaderData");
    return data.loaderData[routeId];
}
/**
* Returns the [`loader`](../../start/framework/route-module#loader) data for a
* given route by route ID.
*
* Route IDs are created automatically. They are simply the path of the route file
* relative to the app folder without the extension.
*
* | Route Filename               | Route ID               |
* | ---------------------------- | ---------------------- |
* | `app/root.tsx`               | `"root"`               |
* | `app/routes/teams.tsx`       | `"routes/teams"`       |
* | `app/whatever/teams.$id.tsx` | `"whatever/teams.$id"` |
*
* @example
* import { useRouteLoaderData } from "react-router";
*
* function SomeComponent() {
*   const { user } = useRouteLoaderData("root");
* }
*
* // You can also specify your own route ID's manually in your routes.ts file:
* route("/", "containers/app.tsx", { id: "app" })
* useRouteLoaderData("app");
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param routeId The ID of the route to return loader data from
* @returns The data returned from the specified route's [`loader`](../../start/framework/route-module#loader)
* function, or `undefined` if not found
*/ function $da3cac5a2aaa7b71$export$fd5d37484eab868d(routeId) {
    return $da3cac5a2aaa7b71$export$798168c290ba5b3d("useRouteLoaderData").loaderData[routeId];
}
/**
* Returns the [`action`](../../start/framework/route-module#action) data from
* the most recent `POST` navigation form submission or `undefined` if there
* hasn't been one.
*
* @example
* import { Form, useActionData } from "react-router";
*
* export async function action({ request }) {
*   const body = await request.formData();
*   const name = body.get("visitorsName");
*   return { message: `Hello, ${name}` };
* }
*
* export default function Invoices() {
*   const data = useActionData();
*   return (
*     <Form method="post">
*       <input type="text" name="visitorsName" />
*       {data ? data.message : "Waiting..."}
*     </Form>
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The data returned from the route's [`action`](../../start/framework/route-module#action)
* function, or `undefined` if no [`action`](../../start/framework/route-module#action)
* has been called
*/ function $da3cac5a2aaa7b71$export$fdc00f3f26066d5e() {
    let data = $da3cac5a2aaa7b71$export$798168c290ba5b3d("useActionData");
    let routeId = $da3cac5a2aaa7b71$export$501a3f562d56eac6("useActionData");
    return data.actionData ? data.actionData[routeId] : void 0;
}
/**
* Accesses the error thrown during an
* [`action`](../../start/framework/route-module#action),
* [`loader`](../../start/framework/route-module#loader),
* or component render to be used in a route module
* [`ErrorBoundary`](../../start/framework/route-module#errorboundary).
*
* @example
* export function ErrorBoundary() {
*   const error = useRouteError();
*   return <div>{error.message}</div>;
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown during route [loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action) execution, or rendering
*/ function $da3cac5a2aaa7b71$export$ed527bf60f6e05f2() {
    let error = $aZSru.useContext((0, $b71c75740e61495f$export$af8bd2647fea9c11));
    let data = $da3cac5a2aaa7b71$export$798168c290ba5b3d("useRouteError");
    let routeId = $da3cac5a2aaa7b71$export$501a3f562d56eac6("useRouteError");
    if (error !== void 0) return error;
    return data.errors?.[routeId];
}
/**
* Returns the resolved promise value from the closest {@link Await | `<Await>`}.
*
* @example
* function SomeDescendant() {
*   const value = useAsyncValue();
*   // ...
* }
*
* // somewhere in your app
* <Await resolve={somePromise}>
*   <SomeDescendant />
* </Await>;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The resolved value from the nearest {@link Await} component
*/ function $da3cac5a2aaa7b71$export$78a72ddb39bdd145() {
    return $aZSru.useContext((0, $b71c75740e61495f$export$804c460aade54ac8))?._data;
}
/**
* Returns the rejection value from the closest {@link Await | `<Await>`}.
*
* @example
* import { Await, useAsyncError } from "react-router";
*
* function ErrorElement() {
*   const error = useAsyncError();
*   return (
*     <p>Uh Oh, something went wrong! {error.message}</p>
*   );
* }
*
* // somewhere in your app
* <Await
*   resolve={promiseThatRejects}
*   errorElement={<ErrorElement />}
* />;
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The error that was thrown in the nearest {@link Await} component
*/ function $da3cac5a2aaa7b71$export$17f53340677d5831() {
    return $aZSru.useContext((0, $b71c75740e61495f$export$804c460aade54ac8))?._error;
}
let $da3cac5a2aaa7b71$var$blockerId = 0;
/**
* Allow the application to block navigations within the SPA and present the
* user a confirmation dialog to confirm the navigation. Mostly used to avoid
* using half-filled form data. This does not handle hard-reloads or
* cross-origin navigations.
*
* The {@link Blocker} object returned by the hook has the following properties:
*
* - **`state`**
*   - `unblocked` - the blocker is idle and has not prevented any navigation
*   - `blocked` - the blocker has prevented a navigation
*   - `proceeding` - the blocker is proceeding through from a blocked navigation
* - **`location`**
*   - When in a `blocked` state, this represents the {@link Location} to which
*     we blocked a navigation. When in a `proceeding` state, this is the
*     location being navigated to after a `blocker.proceed()` call.
* - **`proceed()`**
*   - When in a `blocked` state, you may call `blocker.proceed()` to proceed to
*     the blocked location.
* - **`reset()`**
*   - When in a `blocked` state, you may call `blocker.reset()` to return the
*     blocker to an `unblocked` state and leave the user at the current
*     location.
*
* @example
* // Boolean version
* let blocker = useBlocker(value !== "");
*
* // Function version
* let blocker = useBlocker(
*   ({ currentLocation, nextLocation, historyAction }) =>
*     value !== "" &&
*     currentLocation.pathname !== nextLocation.pathname
* );
*
* @additionalExamples
* ```tsx
* import { useCallback, useState } from "react";
* import { BlockerFunction, useBlocker } from "react-router";
*
* export function ImportantForm() {
*   const [value, setValue] = useState("");
*
*   const shouldBlock = useCallback<BlockerFunction>(
*     () => value !== "",
*     [value]
*   );
*   const blocker = useBlocker(shouldBlock);
*
*   return (
*     <form
*       onSubmit={(e) => {
*         e.preventDefault();
*         setValue("");
*         if (blocker.state === "blocked") {
*           blocker.proceed();
*         }
*       }}
*     >
*       <input
*         name="data"
*         value={value}
*         onChange={(e) => setValue(e.target.value)}
*       />
*
*       <button type="submit">Save</button>
*
*       {blocker.state === "blocked" ? (
*         <>
*           <p style={{ color: "red" }}>
*             Blocked the last navigation to
*           </p>
*           <button
*             type="button"
*             onClick={() => blocker.proceed()}
*           >
*             Let me through
*           </button>
*           <button
*             type="button"
*             onClick={() => blocker.reset()}
*           >
*             Keep me here
*           </button>
*         </>
*       ) : blocker.state === "proceeding" ? (
*         <p style={{ color: "orange" }}>
*           Proceeding through blocked navigation
*         </p>
*       ) : (
*         <p style={{ color: "green" }}>
*           Blocker is currently unblocked
*         </p>
*       )}
*     </form>
*   );
* }
* ```
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param shouldBlock Either a boolean or a function returning a boolean which
* indicates whether the navigation should be blocked. The function format
* receives a single object parameter containing the `currentLocation`,
* `nextLocation`, and `historyAction` of the potential navigation.
* @returns A {@link Blocker} object with state and reset functionality
*/ function $da3cac5a2aaa7b71$export$b273b3273281a049(shouldBlock) {
    let { router: router, basename: basename } = $da3cac5a2aaa7b71$export$ae09415e57d46628("useBlocker");
    let state = $da3cac5a2aaa7b71$export$f93124018767f269("useBlocker");
    let [blockerKey, setBlockerKey] = $aZSru.useState("");
    let blockerFunction = $aZSru.useCallback((arg)=>{
        if (typeof shouldBlock !== "function") return !!shouldBlock;
        if (basename === "/") return shouldBlock(arg);
        let { currentLocation: currentLocation, nextLocation: nextLocation, historyAction: historyAction } = arg;
        return shouldBlock({
            currentLocation: {
                ...currentLocation,
                pathname: (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(currentLocation.pathname, basename) || currentLocation.pathname
            },
            nextLocation: {
                ...nextLocation,
                pathname: (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(nextLocation.pathname, basename) || nextLocation.pathname
            },
            historyAction: historyAction
        });
    }, [
        basename,
        shouldBlock
    ]);
    $aZSru.useEffect(()=>{
        let key = String(++$da3cac5a2aaa7b71$var$blockerId);
        setBlockerKey(key);
        return ()=>router.deleteBlocker(key);
    }, [
        router
    ]);
    $aZSru.useEffect(()=>{
        if (blockerKey !== "") router.getBlocker(blockerKey, blockerFunction);
    }, [
        router,
        blockerKey,
        blockerFunction
    ]);
    return blockerKey && state.blockers.has(blockerKey) ? state.blockers.get(blockerKey) : (0, $9915aeece4ba52df$export$386d57f03f0b2883);
}
function $da3cac5a2aaa7b71$var$useNavigateStable() {
    let { router: router } = $da3cac5a2aaa7b71$export$ae09415e57d46628("useNavigate");
    let id = $da3cac5a2aaa7b71$export$501a3f562d56eac6("useNavigate");
    let activeRef = $aZSru.useRef(false);
    $aZSru.useLayoutEffect(()=>{
        activeRef.current = true;
    });
    return $aZSru.useCallback(async (to, options = {})=>{
        (0, $072a56029499ae6c$export$491112666e282270)(activeRef.current, $da3cac5a2aaa7b71$var$navigateEffectWarning);
        if (!activeRef.current) return;
        if (typeof to === "number") await router.navigate(to);
        else await router.navigate(to, {
            fromRouteId: id,
            ...options
        });
    }, [
        router,
        id
    ]);
}
const $da3cac5a2aaa7b71$var$alreadyWarned = {};
function $da3cac5a2aaa7b71$var$warningOnce(key, cond, message) {
    if (!cond && !$da3cac5a2aaa7b71$var$alreadyWarned[key]) {
        $da3cac5a2aaa7b71$var$alreadyWarned[key] = true;
        (0, $072a56029499ae6c$export$491112666e282270)(false, message);
    }
}
function $da3cac5a2aaa7b71$export$3f79f0b98112cf57(...args) {
    const currentRouteId = $da3cac5a2aaa7b71$export$501a3f562d56eac6("useRoute");
    const id = args[0] ?? currentRouteId;
    const state = $da3cac5a2aaa7b71$export$f93124018767f269("useRoute");
    const data = $da3cac5a2aaa7b71$export$798168c290ba5b3d("useRoute");
    const route = state.matches.find(({ route: route })=>route.id === id);
    if (route === void 0) return void 0;
    return {
        handle: route.route.handle,
        loaderData: data.loaderData[id],
        actionData: data.actionData?.[id]
    };
}
function $da3cac5a2aaa7b71$var$toRouterStateMatch(match) {
    return {
        id: match.route.id,
        pathname: match.pathname,
        params: match.params,
        handle: match.route.handle
    };
}
/**
* A unified hook for reading router state: current (`active`) and in-flight
* (`pending`) locations, search params, params, matches, and navigation type.
*
* This hook consolidates the information you used to get from {@link useLocation},
* {@link useSearchParams}, {@link useParams}, {@link useMatches}, {@link useNavigation},
* and {@link useNavigationType} into a single hook.
*
*
* @example
* import { unstable_useRouterState as useRouterState } from "react-router";
*
* let { active, pending } = unstable_useRouterState();
*
* // Active is always populated with the current location
* active.location; // replaces `useLocation()`
* active.searchParams; // replaces `useSearchParams()[0]`
* active.params; // replaces `useParams()`
* active.matches; // replaces `useMatches()`
* active.type; // replaces `useNavigationType()`
*
* // Pending is only populated during a navigation
* pending.location; // replaces `useNavigation().location`
* pending.searchParams; // equivalent to `new URLSearchParams(useNavigation().search)`
* pending.params; // Not directly accessible today
* pending.matches; // Not directly accessible today
* pending.type; // Not directly accessible today
* pending.state; // replaces `useNavigation().state`
* pending.formMethod; // replaces useNavigation().formMethod
* pending.formAction; // replaces useNavigation().formAction
* pending.formEncType; // replaces useNavigation().formEncType
* pending.formData; // replaces useNavigation().formData
* pending.json; // replaces useNavigation().json
* pending.text; // replaces useNavigation().text
*
* @name unstable_useRouterState
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns The current router state with `active` and `pending` variants
*/ function $da3cac5a2aaa7b71$export$dbb5ccc270afbbb4() {
    let { location: location, historyAction: type, matches: matches } = $da3cac5a2aaa7b71$export$f93124018767f269("unstable_useRouterState");
    let { navigation: navigation } = $da3cac5a2aaa7b71$var$useDataRouterNavigation("unstable_useRouterState");
    let active = $aZSru.useMemo(()=>({
            type: type,
            location: location,
            searchParams: new URLSearchParams(location.search),
            params: matches[matches.length - 1]?.params ?? {},
            matches: matches.map((m)=>$da3cac5a2aaa7b71$var$toRouterStateMatch(m))
        }), [
        location,
        matches,
        type
    ]);
    let pending = $aZSru.useMemo(()=>{
        if (navigation.state === "idle") return null;
        let shared = {
            type: navigation.historyAction,
            location: navigation.location,
            searchParams: new URLSearchParams(navigation.location.search),
            params: navigation.matches[navigation.matches.length - 1]?.params ?? {},
            matches: navigation.matches.map((m)=>$da3cac5a2aaa7b71$var$toRouterStateMatch(m))
        };
        return navigation.state === "loading" ? {
            ...shared,
            state: "loading",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        } : {
            ...shared,
            state: "submitting",
            formMethod: navigation.formMethod,
            formAction: navigation.formAction,
            formEncType: navigation.formEncType,
            formData: navigation.formData,
            json: navigation.json,
            text: navigation.text
        };
    }, [
        navigation
    ]);
    return $aZSru.useMemo(()=>({
            active: active,
            pending: pending
        }), [
        active,
        pending
    ]);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 






/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/server-runtime/warnings.ts
const $ff197d758123498e$var$alreadyWarned = {};
function $ff197d758123498e$export$5b28268982f175ba(condition, message) {
    if (!condition && !$ff197d758123498e$var$alreadyWarned[message]) {
        $ff197d758123498e$var$alreadyWarned[message] = true;
        console.warn(message);
    }
}



var $aZSru = parcelRequire("aZSru");
//#region lib/components.tsx
const $5b2f026c239847ab$export$e2fd2c03906469db = [
    "HydrateFallback",
    "hydrateFallbackElement"
];
/**
* Create a new {@link DataRouter} that manages the application path using an
* in-memory [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack. Useful for non-browser environments without a DOM API.
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {MemoryRouterOpts.basename} opts.basename n/a
* @param {MemoryRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {MemoryRouterOpts.future} opts.future n/a
* @param {MemoryRouterOpts.getContext} opts.getContext n/a
* @param {MemoryRouterOpts.hydrationData} opts.hydrationData n/a
* @param {MemoryRouterOpts.initialEntries} opts.initialEntries n/a
* @param {MemoryRouterOpts.initialIndex} opts.initialIndex n/a
* @param {MemoryRouterOpts.instrumentations} opts.instrumentations n/a
* @param {MemoryRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @returns An initialized {@link DataRouter} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $5b2f026c239847ab$export$f30f7e456d254e83(routes, opts) {
    return (0, $9915aeece4ba52df$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $072a56029499ae6c$export$2b76ad033c6e6d08)({
            initialEntries: opts?.initialEntries,
            initialIndex: opts?.initialIndex
        }),
        hydrationData: opts?.hydrationData,
        routes: routes,
        mapRouteProperties: (0, $f1195701c85e5ce2$export$6bc17138063be773),
        hydrationRouteProperties: $5b2f026c239847ab$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        instrumentations: opts?.instrumentations
    }).initialize();
}
var $5b2f026c239847ab$var$Deferred = class {
    constructor(){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "status", "pending");
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "promise", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "resolve", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "reject", void 0);
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = (value)=>{
                if (this.status === "pending") {
                    this.status = "resolved";
                    resolve(value);
                }
            };
            this.reject = (reason)=>{
                if (this.status === "pending") {
                    this.status = "rejected";
                    reject(reason);
                }
            };
        });
    }
};
/**
* Render the UI for the given {@link DataRouter}. This component should
* typically be at the top of an app's element tree. The router prop should
* be a single router instance created outside of the React tree. Avoid
* creating new routers during React renders/re-renders.
*
* ```tsx
* import { createBrowserRouter } from "react-router";
* import { RouterProvider } from "react-router/dom";
* import { createRoot } from "react-dom/client";
*
* const router = createBrowserRouter(routes);
* createRoot(document.getElementById("root")).render(
*   <RouterProvider router={router} />
* );
* ```
*
* <docs-info>Please note that this component is exported both from
* `react-router` and `react-router/dom` with the only difference being that the
* latter automatically wires up `react-dom`'s [`flushSync`](https://react.dev/reference/react-dom/flushSync)
* implementation. You _almost always_ want to use the version from
* `react-router/dom` unless you're running in a non-DOM environment.</docs-info>
*
*
* @public
* @category Data Routers
* @mode data
* @param props Props
* @param {RouterProviderProps.flushSync} props.flushSync n/a
* @param {RouterProviderProps.onError} props.onError n/a
* @param {RouterProviderProps.router} props.router n/a
* @param {RouterProviderProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router
*/ function $5b2f026c239847ab$export$323e4fc2fa4753fb({ router: router, flushSync: reactDomFlushSyncImpl, onError: onError, useTransitions: useTransitions }) {
    useTransitions = (0, $b71c75740e61495f$export$6e1eeb090b3ec35b)() || useTransitions;
    let [_state, setStateImpl] = $aZSru.useState(router.state);
    let [state, setOptimisticState] = (0, $aZSru.useOptimistic)(_state);
    let [pendingState, setPendingState] = $aZSru.useState();
    let [vtContext, setVtContext] = $aZSru.useState({
        isTransitioning: false
    });
    let [renderDfd, setRenderDfd] = $aZSru.useState();
    let [transition, setTransition] = $aZSru.useState();
    let [interruption, setInterruption] = $aZSru.useState();
    let fetcherData = $aZSru.useRef(/* @__PURE__ */ new Map());
    let setState = $aZSru.useCallback((newState, { deletedFetchers: deletedFetchers, newErrors: newErrors, flushSync: flushSync, viewTransitionOpts: viewTransitionOpts })=>{
        if (newErrors && onError) Object.values(newErrors).forEach((error)=>onError(error, {
                location: newState.location,
                params: newState.matches[0]?.params ?? {},
                pattern: (0, $f1195701c85e5ce2$export$d738435097971c09)(newState.matches)
            }));
        newState.fetchers.forEach((fetcher, key)=>{
            if (fetcher.data !== void 0) fetcherData.current.set(key, fetcher.data);
        });
        deletedFetchers.forEach((key)=>fetcherData.current.delete(key));
        (0, $ff197d758123498e$export$5b28268982f175ba)(flushSync === false || reactDomFlushSyncImpl != null, "You provided the `flushSync` option to a router update, but you are not using the `<RouterProvider>` from `react-router/dom` so `ReactDOM.flushSync()` is unavailable.  Please update your app to `import { RouterProvider } from \"react-router/dom\"` and ensure you have `react-dom` installed as a dependency to use the `flushSync` option.");
        let isViewTransitionAvailable = router.window != null && router.window.document != null && typeof router.window.document.startViewTransition === "function";
        (0, $ff197d758123498e$export$5b28268982f175ba)(viewTransitionOpts == null || isViewTransitionAvailable, "You provided the `viewTransition` option to a router update, but you do not appear to be running in a DOM environment as `window.startViewTransition` is not available.");
        if (!viewTransitionOpts || !isViewTransitionAvailable) {
            if (reactDomFlushSyncImpl && flushSync) reactDomFlushSyncImpl(()=>setStateImpl(newState));
            else if (useTransitions === false) setStateImpl(newState);
            else $aZSru.startTransition(()=>{
                if (useTransitions === true) setOptimisticState((s)=>$5b2f026c239847ab$var$getOptimisticRouterState(s, newState));
                setStateImpl(newState);
            });
            return;
        }
        if (reactDomFlushSyncImpl && flushSync) {
            reactDomFlushSyncImpl(()=>{
                if (transition) {
                    renderDfd?.resolve();
                    transition.skipTransition();
                }
                setVtContext({
                    isTransitioning: true,
                    flushSync: true,
                    currentLocation: viewTransitionOpts.currentLocation,
                    nextLocation: viewTransitionOpts.nextLocation
                });
            });
            let t = router.window.document.startViewTransition(()=>{
                reactDomFlushSyncImpl(()=>setStateImpl(newState));
            });
            t.finished.finally(()=>{
                reactDomFlushSyncImpl(()=>{
                    setRenderDfd(void 0);
                    setTransition(void 0);
                    setPendingState(void 0);
                    setVtContext({
                        isTransitioning: false
                    });
                });
            });
            reactDomFlushSyncImpl(()=>setTransition(t));
            return;
        }
        if (transition) {
            renderDfd?.resolve();
            transition.skipTransition();
            setInterruption({
                state: newState,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        } else {
            setPendingState(newState);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: viewTransitionOpts.currentLocation,
                nextLocation: viewTransitionOpts.nextLocation
            });
        }
    }, [
        router.window,
        reactDomFlushSyncImpl,
        transition,
        renderDfd,
        useTransitions,
        setOptimisticState,
        onError
    ]);
    $aZSru.useLayoutEffect(()=>router.subscribe(setState), [
        router,
        setState
    ]);
    $aZSru.useEffect(()=>{
        if (vtContext.isTransitioning && !vtContext.flushSync) setRenderDfd(new $5b2f026c239847ab$var$Deferred());
    }, [
        vtContext
    ]);
    $aZSru.useEffect(()=>{
        if (renderDfd && pendingState && router.window) {
            let newState = pendingState;
            let renderPromise = renderDfd.promise;
            let transition = router.window.document.startViewTransition(async ()=>{
                if (useTransitions === false) setStateImpl(newState);
                else $aZSru.startTransition(()=>{
                    if (useTransitions === true) setOptimisticState((s)=>$5b2f026c239847ab$var$getOptimisticRouterState(s, newState));
                    setStateImpl(newState);
                });
                await renderPromise;
            });
            transition.finished.finally(()=>{
                setRenderDfd(void 0);
                setTransition(void 0);
                setPendingState(void 0);
                setVtContext({
                    isTransitioning: false
                });
            });
            setTransition(transition);
        }
    }, [
        pendingState,
        renderDfd,
        router.window,
        useTransitions,
        setOptimisticState
    ]);
    $aZSru.useEffect(()=>{
        if (renderDfd && pendingState && state.location.key === pendingState.location.key) renderDfd.resolve();
    }, [
        renderDfd,
        transition,
        state.location,
        pendingState
    ]);
    $aZSru.useEffect(()=>{
        if (!vtContext.isTransitioning && interruption) {
            setPendingState(interruption.state);
            setVtContext({
                isTransitioning: true,
                flushSync: false,
                currentLocation: interruption.currentLocation,
                nextLocation: interruption.nextLocation
            });
            setInterruption(void 0);
        }
    }, [
        vtContext.isTransitioning,
        interruption
    ]);
    let navigator = $aZSru.useMemo(()=>{
        return {
            createHref: router.createHref,
            createURL: router.createURL,
            encodeLocation: router.encodeLocation,
            go: (n)=>router.navigate(n),
            push: (to, state, opts)=>router.navigate(to, {
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                }),
            replace: (to, state, opts)=>router.navigate(to, {
                    replace: true,
                    state: state,
                    preventScrollReset: opts?.preventScrollReset
                })
        };
    }, [
        router
    ]);
    let basename = router.basename || "/";
    let dataRouterContext = $aZSru.useMemo(()=>({
            router: router,
            navigator: navigator,
            static: false,
            basename: basename,
            onError: onError
        }), [
        router,
        navigator,
        basename,
        onError
    ]);
    let dataRouterState = $aZSru.useMemo(()=>({
            historyAction: state.historyAction,
            location: state.location,
            matches: state.matches,
            initialized: state.initialized,
            renderFallback: state.renderFallback,
            restoreScrollPosition: state.restoreScrollPosition,
            preventScrollReset: state.preventScrollReset,
            blockers: state.blockers
        }), [
        state.historyAction,
        state.location,
        state.matches,
        state.initialized,
        state.renderFallback,
        state.restoreScrollPosition,
        state.preventScrollReset,
        state.blockers
    ]);
    let dataRouterNavigation = $aZSru.useMemo(()=>({
            navigation: state.navigation,
            revalidation: state.revalidation
        }), [
        state.navigation,
        state.revalidation
    ]);
    let dataRouterData = $aZSru.useMemo(()=>({
            loaderData: state.loaderData,
            actionData: state.actionData,
            errors: state.errors
        }), [
        state.loaderData,
        state.actionData,
        state.errors
    ]);
    let fetchersContext = $aZSru.useMemo(()=>({
            fetchers: state.fetchers,
            fetcherData: fetcherData.current
        }), [
        state.fetchers
    ]);
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$2eeee58951ff3c1c).Provider, {
        value: dataRouterContext
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$315e3ffb01f217).Provider, {
        value: dataRouterState
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$2473c5952c6a10d1).Provider, {
        value: dataRouterNavigation
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$19d7395466bdeac8).Provider, {
        value: dataRouterData
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$cb3f1df1bef00a39).Provider, {
        value: fetchersContext
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$3681f408decb40d1).Provider, {
        value: vtContext
    }, /* @__PURE__ */ $aZSru.createElement($5b2f026c239847ab$export$55185c17a0fcbe46, {
        basename: basename,
        location: state.location,
        navigationType: state.historyAction,
        navigator: navigator,
        useTransitions: useTransitions
    }, /* @__PURE__ */ $aZSru.createElement($5b2f026c239847ab$var$MemoizedDataRoutes, {
        routes: router.routes,
        manifest: router.manifest,
        state: state,
        isStatic: false,
        onError: onError
    })))))))), null);
}
function $5b2f026c239847ab$var$getOptimisticRouterState(currentState, newState) {
    return {
        ...currentState,
        navigation: newState.navigation.state !== "idle" ? newState.navigation : currentState.navigation,
        revalidation: newState.revalidation !== "idle" ? newState.revalidation : currentState.revalidation,
        actionData: newState.navigation.state !== "submitting" ? newState.actionData : currentState.actionData,
        fetchers: newState.fetchers
    };
}
const $5b2f026c239847ab$var$MemoizedDataRoutes = $aZSru.memo($5b2f026c239847ab$export$699f06c8afb533c9);
function $5b2f026c239847ab$export$699f06c8afb533c9({ routes: routes, manifest: manifest, state: state, isStatic: isStatic, onError: onError }) {
    let dataRouterContext = $aZSru.useContext((0, $b71c75740e61495f$export$2eeee58951ff3c1c));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(dataRouterContext, "You must render this element inside a <DataRouterContext.Provider> element");
    return (0, $da3cac5a2aaa7b71$export$f7ce0646a48561fb)(routes, void 0, {
        router: dataRouterContext.router,
        manifest: manifest,
        state: state,
        isStatic: isStatic,
        onError: onError
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores all entries in memory.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {MemoryRouterProps.basename} props.basename n/a
* @param {MemoryRouterProps.children} props.children n/a
* @param {MemoryRouterProps.initialEntries} props.initialEntries n/a
* @param {MemoryRouterProps.initialIndex} props.initialIndex n/a
* @param {MemoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative in-memory {@link Router | `<Router>`} for client-side
* routing.
*/ function $5b2f026c239847ab$export$ae46f04cfaffe093({ basename: basename, children: children, initialEntries: initialEntries, initialIndex: initialIndex, useTransitions: useTransitions }) {
    let historyRef = $aZSru.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $072a56029499ae6c$export$2b76ad033c6e6d08)({
        initialEntries: initialEntries,
        initialIndex: initialIndex,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aZSru.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aZSru.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $aZSru.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $aZSru.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aZSru.createElement($5b2f026c239847ab$export$55185c17a0fcbe46, {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A component-based version of {@link useNavigate} to use in a
* [`React.Component` class](https://react.dev/reference/react/Component) where
* hooks cannot be used.
*
* It's recommended to avoid using this component in favor of {@link useNavigate}.
*
* @example
* <Navigate to="/tasks" />
*
* @public
* @category Components
* @param props Props
* @param {NavigateProps.relative} props.relative n/a
* @param {NavigateProps.replace} props.replace n/a
* @param {NavigateProps.state} props.state n/a
* @param {NavigateProps.to} props.to n/a
* @returns {void}
*
*/ function $5b2f026c239847ab$export$444b3ab0cb9aec40({ to: to, replace: replace, state: state, relative: relative }) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)((0, $da3cac5a2aaa7b71$export$9c954a9d03d32f4a)(), `<Navigate> may be used only in the context of a <Router> component.`);
    let { static: isStatic, navigator: navigator } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    (0, $072a56029499ae6c$export$491112666e282270)(!isStatic, "<Navigate> must not be used on the initial render in a <StaticRouter>. This is a no-op, but you should modify your code so the <Navigate> is only ever rendered in response to some user interaction or state change.");
    let { matches: matches } = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397));
    let { pathname: locationPathname } = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let navigate = (0, $da3cac5a2aaa7b71$export$9770f232ac06a008)();
    let path = (0, $f1195701c85e5ce2$export$cae722b0cc860f13)(to, (0, $f1195701c85e5ce2$export$fe6dbc5de95f53ab)(matches), locationPathname, relative === "path");
    (0, $0179caaefc35c7e3$export$6c8e41f66e7aa990)(typeof to === "string" ? to : (0, $072a56029499ae6c$export$fe53371bee54353d)(to), navigator.createHref(path), (0, $0179caaefc35c7e3$export$1da545bc000055cf)(navigator), "reject");
    let jsonPath = JSON.stringify(path);
    $aZSru.useEffect(()=>{
        navigate(JSON.parse(jsonPath), {
            replace: replace,
            state: state,
            relative: relative
        });
    }, [
        navigate,
        jsonPath,
        relative,
        replace,
        state
    ]);
    return null;
}
/**
* Renders the matching child route of a parent route or nothing if no child
* route matches.
*
* @example
* import { Outlet } from "react-router";
*
* export default function SomeParent() {
*   return (
*     <div>
*       <h1>Parent Content</h1>
*       <Outlet />
*     </div>
*   );
* }
*
* @public
* @category Components
* @param props Props
* @param {OutletProps.context} props.context n/a
* @returns React element for the rendered outlet or `null` if no child route matches.
*/ function $5b2f026c239847ab$export$910ae8079b2c2852(props) {
    return (0, $da3cac5a2aaa7b71$export$a3be3530d8e40d0b)(props.context);
}
/**
* Configures an element to render when a pattern matches the current location.
* It must be rendered within a {@link Routes} element. Note that these routes
* do not participate in data loading, actions, code splitting, or any other
* route module features.
*
* @example
* // Usually used in a declarative router
* function App() {
*   return (
*     <BrowserRouter>
*       <Routes>
*         <Route index element={<StepOne />} />
*         <Route path="step-2" element={<StepTwo />} />
*         <Route path="step-3" element={<StepThree />} />
*       </Routes>
*    </BrowserRouter>
*   );
* }
*
* // But can be used with a data router as well if you prefer the JSX notation
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @public
* @category Components
* @param props Props
* @param {PathRouteProps.action} props.action n/a
* @param {PathRouteProps.caseSensitive} props.caseSensitive n/a
* @param {PathRouteProps.Component} props.Component n/a
* @param {PathRouteProps.children} props.children n/a
* @param {PathRouteProps.element} props.element n/a
* @param {PathRouteProps.ErrorBoundary} props.ErrorBoundary n/a
* @param {PathRouteProps.errorElement} props.errorElement n/a
* @param {PathRouteProps.handle} props.handle n/a
* @param {PathRouteProps.HydrateFallback} props.HydrateFallback n/a
* @param {PathRouteProps.hydrateFallbackElement} props.hydrateFallbackElement n/a
* @param {PathRouteProps.id} props.id n/a
* @param {PathRouteProps.index} props.index n/a
* @param {PathRouteProps.lazy} props.lazy n/a
* @param {PathRouteProps.loader} props.loader n/a
* @param {PathRouteProps.path} props.path n/a
* @param {PathRouteProps.shouldRevalidate} props.shouldRevalidate n/a
* @returns {void}
*/ function $5b2f026c239847ab$export$e7b0ac011bb776c6(props) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)(false, "A <Route> is only ever to be used as the child of <Routes> element, never rendered directly. Please wrap your <Route> in a <Routes>.");
}
/**
* Provides location context for the rest of the app.
*
* Note: You usually won't render a `<Router>` directly. Instead, you'll render a
* router that is more specific to your environment such as a {@link BrowserRouter}
* in web browsers or a {@link ServerRouter} for server rendering.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {RouterProps.basename} props.basename n/a
* @param {RouterProps.children} props.children n/a
* @param {RouterProps.location} props.location n/a
* @param {RouterProps.navigationType} props.navigationType n/a
* @param {RouterProps.navigator} props.navigator n/a
* @param {RouterProps.static} props.static n/a
* @param {RouterProps.useTransitions} props.useTransitions n/a
* @returns React element for the rendered router or `null` if the location does
* not match the {@link props.basename}
*/ function $5b2f026c239847ab$export$55185c17a0fcbe46({ basename: basenameProp = "/", children: children = null, location: locationProp, navigationType: navigationType = "POP", navigator: navigator, static: staticProp = false, useTransitions: useTransitions }) {
    (0, $072a56029499ae6c$export$f5708dca728d7177)(!(0, $da3cac5a2aaa7b71$export$9c954a9d03d32f4a)(), "You cannot render a <Router> inside another <Router>. You should never have more than one in your app.");
    let basename = basenameProp.replace(/^\/*/, "/");
    let navigationContext = $aZSru.useMemo(()=>({
            basename: basename,
            navigator: navigator,
            static: staticProp,
            useTransitions: useTransitions,
            future: {}
        }), [
        basename,
        navigator,
        staticProp,
        useTransitions
    ]);
    if (typeof locationProp === "string") locationProp = (0, $072a56029499ae6c$export$8ccf933b0513f8d0)(locationProp);
    let { pathname: pathname = "/", search: search = "", hash: hash = "", state: state = null, key: key = "default", mask: mask } = locationProp;
    let locationContext = $aZSru.useMemo(()=>{
        let trailingPathname = (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(pathname, basename);
        if (trailingPathname == null) return null;
        return {
            location: {
                pathname: trailingPathname,
                search: search,
                hash: hash,
                state: state,
                key: key,
                mask: mask
            },
            navigationType: navigationType
        };
    }, [
        basename,
        pathname,
        search,
        hash,
        state,
        key,
        navigationType,
        mask
    ]);
    (0, $072a56029499ae6c$export$491112666e282270)(locationContext != null, `<Router basename="${basename}"> is not able to match the URL "${pathname}${search}${hash}" because it does not start with the basename, so the <Router> won't render anything.`);
    if (locationContext == null) return null;
    return /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$3044ab7fdabeaee6).Provider, {
        value: navigationContext
    }, /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$e6a44b110a0c44d3).Provider, {
        children: children,
        value: locationContext
    }));
}
/**
* Renders a branch of {@link Route | `<Route>`s} that best matches the current
* location. Note that these routes do not participate in [data loading](../../start/framework/route-module#loader),
* [`action`](../../start/framework/route-module#action), code splitting, or
* any other [route module](../../start/framework/route-module) features.
*
* @example
* import { Route, Routes } from "react-router";
*
* <Routes>
*   <Route index element={<StepOne />} />
*   <Route path="step-2" element={<StepTwo />} />
*   <Route path="step-3" element={<StepThree />} />
* </Routes>
*
* @public
* @category Components
* @param props Props
* @param {RoutesProps.children} props.children n/a
* @param {RoutesProps.location} props.location n/a
* @returns React element for the rendered routes or `null` if no route matches
*/ function $5b2f026c239847ab$export$3565eb3d00ca5a74({ children: children, location: location }) {
    return (0, $da3cac5a2aaa7b71$export$5d3fca4a98652595)($5b2f026c239847ab$export$16da398f5434bdec(children), location);
}
/**
* Used to render promise values with automatic error handling.
*
* **Note:** `<Await>` expects to be rendered inside a [`<React.Suspense>`](https://react.dev/reference/react/Suspense)
*
* @example
* import { Await, useLoaderData } from "react-router";
*
* export async function loader() {
*   // not awaited
*   const reviews = getReviews();
*   // awaited (blocks the transition)
*   const book = await fetch("/api/book").then((res) => res.json());
*   return { book, reviews };
* }
*
* function Book() {
*   const { book, reviews } = useLoaderData();
*   return (
*     <div>
*       <h1>{book.title}</h1>
*       <p>{book.description}</p>
*       <React.Suspense fallback={<ReviewsSkeleton />}>
*         <Await
*           resolve={reviews}
*           errorElement={
*             <div>Could not load reviews 😬</div>
*           }
*           children={(resolvedReviews) => (
*             <Reviews items={resolvedReviews} />
*           )}
*         />
*       </React.Suspense>
*     </div>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {AwaitProps.children} props.children n/a
* @param {AwaitProps.errorElement} props.errorElement n/a
* @param {AwaitProps.resolve} props.resolve n/a
* @returns React element for the rendered awaited value
*/ function $5b2f026c239847ab$export$6ddabde395c8c576({ children: children, errorElement: errorElement, resolve: resolve }) {
    let dataRouterContext = $aZSru.useContext((0, $b71c75740e61495f$export$2eeee58951ff3c1c));
    let dataRouterStateContext = $aZSru.useContext((0, $b71c75740e61495f$export$315e3ffb01f217));
    let onError = $aZSru.useCallback((error, errorInfo)=>{
        if (dataRouterContext && dataRouterContext.onError && dataRouterStateContext) dataRouterContext.onError(error, {
            location: dataRouterStateContext.location,
            params: dataRouterStateContext.matches[0]?.params || {},
            pattern: (0, $f1195701c85e5ce2$export$d738435097971c09)(dataRouterStateContext.matches),
            errorInfo: errorInfo
        });
    }, [
        dataRouterContext,
        dataRouterStateContext
    ]);
    return /* @__PURE__ */ $aZSru.createElement($5b2f026c239847ab$var$AwaitErrorBoundary, {
        resolve: resolve,
        errorElement: errorElement,
        onError: onError
    }, /* @__PURE__ */ $aZSru.createElement($5b2f026c239847ab$var$ResolveAwait, null, children));
}
var $5b2f026c239847ab$var$AwaitErrorBoundary = class extends $aZSru.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    componentDidCatch(error, errorInfo) {
        if (this.props.onError) this.props.onError(error, errorInfo);
        else console.error("<Await> caught the following error during render", error, errorInfo);
    }
    render() {
        let { children: children, errorElement: errorElement, resolve: resolve } = this.props;
        let promise = null;
        let status = 0;
        if (!(resolve instanceof Promise)) {
            status = 1;
            promise = Promise.resolve();
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_data", {
                get: ()=>resolve
            });
        } else if (this.state.error) {
            status = 2;
            let renderError = this.state.error;
            promise = Promise.reject().catch(()=>{});
            Object.defineProperty(promise, "_tracked", {
                get: ()=>true
            });
            Object.defineProperty(promise, "_error", {
                get: ()=>renderError
            });
        } else if (resolve._tracked) {
            promise = resolve;
            status = "_error" in promise ? 2 : "_data" in promise ? 1 : 0;
        } else {
            status = 0;
            Object.defineProperty(resolve, "_tracked", {
                get: ()=>true
            });
            promise = resolve.then((data)=>Object.defineProperty(resolve, "_data", {
                    get: ()=>data
                }), (error)=>{
                this.props.onError?.(error);
                Object.defineProperty(resolve, "_error", {
                    get: ()=>error
                });
            });
        }
        if (status === 2 && !errorElement) throw promise._error;
        if (status === 2) return /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$804c460aade54ac8).Provider, {
            value: promise,
            children: errorElement
        });
        if (status === 1) return /* @__PURE__ */ $aZSru.createElement((0, $b71c75740e61495f$export$804c460aade54ac8).Provider, {
            value: promise,
            children: children
        });
        throw promise;
    }
    constructor(props){
        super(props);
        this.state = {
            error: null
        };
    }
};
function $5b2f026c239847ab$var$ResolveAwait({ children: children }) {
    let data = (0, $da3cac5a2aaa7b71$export$78a72ddb39bdd145)();
    let toRender = typeof children === "function" ? children(data) : children;
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, toRender);
}
/**
* Creates a route config from a React "children" object, which is usually
* either a `<Route>` element or an array of them. Used internally by
* `<Routes>` to create a route config from its children.
*
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ function $5b2f026c239847ab$export$16da398f5434bdec(children, parentPath = []) {
    let routes = [];
    $aZSru.Children.forEach(children, (element, index)=>{
        if (!$aZSru.isValidElement(element)) return;
        let treePath = [
            ...parentPath,
            index
        ];
        if (element.type === $aZSru.Fragment) {
            routes.push.apply(routes, $5b2f026c239847ab$export$16da398f5434bdec(element.props.children, treePath));
            return;
        }
        (0, $072a56029499ae6c$export$f5708dca728d7177)(element.type === $5b2f026c239847ab$export$e7b0ac011bb776c6, `[${typeof element.type === "string" ? element.type : element.type.name}] is not a <Route> component. All component children of <Routes> must be a <Route> or <React.Fragment>`);
        let props = element.props;
        (0, $072a56029499ae6c$export$f5708dca728d7177)(!props.index || !props.children, "An index route cannot have child routes.");
        let route = {
            id: props.id || treePath.join("-"),
            caseSensitive: props.caseSensitive,
            element: props.element,
            Component: props.Component,
            index: props.index,
            path: props.path,
            middleware: props.middleware,
            loader: props.loader,
            action: props.action,
            hydrateFallbackElement: props.hydrateFallbackElement,
            HydrateFallback: props.HydrateFallback,
            errorElement: props.errorElement,
            ErrorBoundary: props.ErrorBoundary,
            shouldRevalidate: props.shouldRevalidate,
            handle: props.handle,
            lazy: props.lazy
        };
        if (props.children) route.children = $5b2f026c239847ab$export$16da398f5434bdec(props.children, treePath);
        routes.push(route);
    });
    return routes;
}
/**
* Create route objects from JSX elements instead of arrays of objects.
*
* @example
* const routes = createRoutesFromElements(
*   <>
*     <Route index loader={step1Loader} Component={StepOne} />
*     <Route path="step-2" loader={step2Loader} Component={StepTwo} />
*     <Route path="step-3" loader={step3Loader} Component={StepThree} />
*   </>
* );
*
* const router = createBrowserRouter(routes);
*
* function App() {
*   return <RouterProvider router={router} />;
* }
*
* @name createRoutesFromElements
* @public
* @category Utils
* @mode data
* @param children The React children to convert into a route config
* @param parentPath The path of the parent route, used to generate unique IDs.
* This is used for internal recursion and is not intended to be used by the
* application developer.
* @returns An array of {@link RouteObject}s that can be used with a {@link DataRouter}
*/ const $5b2f026c239847ab$export$9b5b6d122dea0c88 = $5b2f026c239847ab$export$16da398f5434bdec;
/**
* Renders the result of {@link matchRoutes} into a React element.
*
* @public
* @category Utils
* @param matches The array of {@link RouteMatch | route matches} to render
* @returns A React element that renders the matched routes or `null` if no matches
*/ function $5b2f026c239847ab$export$daf73786167a7f72(matches) {
    return (0, $da3cac5a2aaa7b71$export$569816e95a012c39)(matches);
}
function $5b2f026c239847ab$var$useRouteComponentProps() {
    return {
        params: (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $da3cac5a2aaa7b71$export$1448a5050d252c4d)(),
        actionData: (0, $da3cac5a2aaa7b71$export$fdc00f3f26066d5e)(),
        matches: (0, $da3cac5a2aaa7b71$export$2378eb7f5ff86053)()
    };
}
function $5b2f026c239847ab$export$6c4f3826290c37af({ children: children }) {
    const props = $5b2f026c239847ab$var$useRouteComponentProps();
    return $aZSru.cloneElement(children, props);
}
function $5b2f026c239847ab$export$1a5de91a5c3255e0(Component) {
    return function WithComponentProps() {
        const props = $5b2f026c239847ab$var$useRouteComponentProps();
        return $aZSru.createElement(Component, props);
    };
}
function $5b2f026c239847ab$var$useHydrateFallbackProps() {
    return {
        params: (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $da3cac5a2aaa7b71$export$1448a5050d252c4d)(),
        actionData: (0, $da3cac5a2aaa7b71$export$fdc00f3f26066d5e)()
    };
}
function $5b2f026c239847ab$export$f8cff34f39c1932a({ children: children }) {
    const props = $5b2f026c239847ab$var$useHydrateFallbackProps();
    return $aZSru.cloneElement(children, props);
}
function $5b2f026c239847ab$export$cd4a5850c74ba029(HydrateFallback) {
    return function WithHydrateFallbackProps() {
        const props = $5b2f026c239847ab$var$useHydrateFallbackProps();
        return $aZSru.createElement(HydrateFallback, props);
    };
}
function $5b2f026c239847ab$var$useErrorBoundaryProps() {
    return {
        params: (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)(),
        loaderData: (0, $da3cac5a2aaa7b71$export$1448a5050d252c4d)(),
        actionData: (0, $da3cac5a2aaa7b71$export$fdc00f3f26066d5e)(),
        error: (0, $da3cac5a2aaa7b71$export$ed527bf60f6e05f2)()
    };
}
function $5b2f026c239847ab$export$e5afde5c4b6d747b({ children: children }) {
    const props = $5b2f026c239847ab$var$useErrorBoundaryProps();
    return $aZSru.cloneElement(children, props);
}
function $5b2f026c239847ab$export$26aea97ad016e70c(ErrorBoundary) {
    return function WithErrorBoundaryProps() {
        const props = $5b2f026c239847ab$var$useErrorBoundaryProps();
        return $aZSru.createElement(ErrorBoundary, props);
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

const $4dd09bbb5ef36460$var$defaultEncType = "application/x-www-form-urlencoded";
function $4dd09bbb5ef36460$var$isHtmlElement(object) {
    return typeof HTMLElement !== "undefined" && object instanceof HTMLElement;
}
function $4dd09bbb5ef36460$var$isButtonElement(object) {
    return $4dd09bbb5ef36460$var$isHtmlElement(object) && object.tagName.toLowerCase() === "button";
}
function $4dd09bbb5ef36460$var$isFormElement(object) {
    return $4dd09bbb5ef36460$var$isHtmlElement(object) && object.tagName.toLowerCase() === "form";
}
function $4dd09bbb5ef36460$var$isInputElement(object) {
    return $4dd09bbb5ef36460$var$isHtmlElement(object) && object.tagName.toLowerCase() === "input";
}
function $4dd09bbb5ef36460$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
function $4dd09bbb5ef36460$export$4c2d35dce1b682e(event, target) {
    return event.button === 0 && (!target || target === "_self") && !$4dd09bbb5ef36460$var$isModifiedEvent(event);
}
/**
* Creates a URLSearchParams object using the given initializer.
*
* This is identical to `new URLSearchParams(init)` except it also supports
* arrays as values in the object form of the initializer instead of just
* strings. This is convenient when you need multiple values for a given key,
* but don't want to use an array initializer.
*
* @example
* // Instead of:
* let searchParams = new URLSearchParams([
*   ["sort", "name"],
*   ["sort", "price"],
* ]);
*
* // You can do:
* let searchParams = createSearchParams({
*   sort: ["name", "price"],
* });
*
* @public
* @category Utils
* @param init The value used to initialize the URL search parameters.
* @returns A URLSearchParams object containing the initialized search
* parameters.
*/ function $4dd09bbb5ef36460$export$a2e4e2dcc7b1f22f(init = "") {
    return new URLSearchParams(typeof init === "string" || Array.isArray(init) || init instanceof URLSearchParams ? init : Object.keys(init).reduce((memo, key)=>{
        let value = init[key];
        return memo.concat(Array.isArray(value) ? value.map((v)=>[
                key,
                v
            ]) : [
            [
                key,
                value
            ]
        ]);
    }, []));
}
function $4dd09bbb5ef36460$export$4370c962fe3096e6(locationSearch, defaultSearchParams) {
    let searchParams = $4dd09bbb5ef36460$export$a2e4e2dcc7b1f22f(locationSearch);
    if (defaultSearchParams) defaultSearchParams.forEach((_, key)=>{
        if (!searchParams.has(key)) defaultSearchParams.getAll(key).forEach((value)=>{
            searchParams.append(key, value);
        });
    });
    return searchParams;
}
let $4dd09bbb5ef36460$var$_formDataSupportsSubmitter = null;
function $4dd09bbb5ef36460$var$isFormDataSubmitterSupported() {
    if ($4dd09bbb5ef36460$var$_formDataSupportsSubmitter === null) try {
        new FormData(document.createElement("form"), 0);
        $4dd09bbb5ef36460$var$_formDataSupportsSubmitter = false;
    } catch  {
        $4dd09bbb5ef36460$var$_formDataSupportsSubmitter = true;
    }
    return $4dd09bbb5ef36460$var$_formDataSupportsSubmitter;
}
const $4dd09bbb5ef36460$var$supportedFormEncTypes = new Set([
    "application/x-www-form-urlencoded",
    "multipart/form-data",
    "text/plain"
]);
function $4dd09bbb5ef36460$var$getFormEncType(encType) {
    if (encType != null && !$4dd09bbb5ef36460$var$supportedFormEncTypes.has(encType)) {
        (0, $072a56029499ae6c$export$491112666e282270)(false, `"${encType}" is not a valid \`encType\` for \`<Form>\`/\`<fetcher.Form>\` and will default to "${$4dd09bbb5ef36460$var$defaultEncType}"`);
        return null;
    }
    return encType;
}
function $4dd09bbb5ef36460$export$80917616746b9ab4(target, basename) {
    let method;
    let action;
    let encType;
    let formData;
    let body;
    if ($4dd09bbb5ef36460$var$isFormElement(target)) {
        let attr = target.getAttribute("action");
        action = attr ? (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("method") || "get";
        encType = $4dd09bbb5ef36460$var$getFormEncType(target.getAttribute("enctype")) || $4dd09bbb5ef36460$var$defaultEncType;
        formData = new FormData(target);
    } else if ($4dd09bbb5ef36460$var$isButtonElement(target) || $4dd09bbb5ef36460$var$isInputElement(target) && (target.type === "submit" || target.type === "image")) {
        let form = target.form;
        if (form == null) throw new Error(`Cannot submit a <button> or <input type="submit"> without a <form>`);
        let attr = target.getAttribute("formaction") || form.getAttribute("action");
        action = attr ? (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(attr, basename) : null;
        method = target.getAttribute("formmethod") || form.getAttribute("method") || "get";
        encType = $4dd09bbb5ef36460$var$getFormEncType(target.getAttribute("formenctype")) || $4dd09bbb5ef36460$var$getFormEncType(form.getAttribute("enctype")) || $4dd09bbb5ef36460$var$defaultEncType;
        formData = new FormData(form, target);
        if (!$4dd09bbb5ef36460$var$isFormDataSubmitterSupported()) {
            let { name: name, type: type, value: value } = target;
            if (type === "image") {
                let prefix = name ? `${name}.` : "";
                formData.append(`${prefix}x`, "0");
                formData.append(`${prefix}y`, "0");
            } else if (name) formData.append(name, value);
        }
    } else if ($4dd09bbb5ef36460$var$isHtmlElement(target)) throw new Error("Cannot submit element that is not <form>, <button>, or <input type=\"submit|image\">");
    else {
        method = "get";
        action = null;
        encType = $4dd09bbb5ef36460$var$defaultEncType;
        body = target;
    }
    if (formData && encType === "text/plain") {
        body = formData;
        formData = void 0;
    }
    return {
        action: action,
        method: method.toLowerCase(),
        encType: encType,
        formData: formData,
        body: body
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/markup.ts
const $3a95c051359f4bfb$var$ESCAPE_LOOKUP = {
    "&": "\\u0026",
    ">": "\\u003e",
    "<": "\\u003c",
    "\u2028": "\\u2028",
    "\u2029": "\\u2029"
};
const $3a95c051359f4bfb$var$ESCAPE_REGEX = /[&><\u2028\u2029]/g;
function $3a95c051359f4bfb$export$4cf11838cdc2a8a8(html) {
    return html.replace($3a95c051359f4bfb$var$ESCAPE_REGEX, (match)=>$3a95c051359f4bfb$var$ESCAPE_LOOKUP[match]);
}
function $3a95c051359f4bfb$export$30330f3d5eb70e11(value) {
    return value.replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/invariant.ts
function $a1cfca9399783296$export$2e2bcd8739ae039(value, message) {
    if (value === false || value === null || typeof value === "undefined") throw new Error(message);
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ /**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/routeModules.ts
var $7e5d214b95152fe5$import_meta = Object.assign(Object.create(null), {
    url: "file:///node_modules/react-router/dist/production/lib/dom/ssr/routeModules.js"
});
async function $7e5d214b95152fe5$export$d9c4a4e8105733a6(route, routeModulesCache) {
    if (route.id in routeModulesCache) return routeModulesCache[route.id];
    try {
        let routeModule = await import(/* @vite-ignore */ /* webpackIgnore: true */ route.module);
        routeModulesCache[route.id] = routeModule;
        return routeModule;
    } catch (error) {
        console.error(`Error loading route module \`${route.module}\`, reloading page...`);
        console.error(error);
        if (window.__reactRouterContext && window.__reactRouterContext.isSpaMode && $7e5d214b95152fe5$import_meta.hot) throw error;
        window.location.reload();
        return new Promise(()=>{});
    }
}


//#region lib/dom/ssr/links.ts
/**
* Gets all the links for a set of matches. The modules are assumed to have been
* loaded already.
*/ function $8db8717086a501b5$export$c43eb07eab2c950a(matches, routeModules, manifest) {
    return $8db8717086a501b5$var$dedupeLinkDescriptors(matches.map((match)=>{
        let module = routeModules[match.route.id];
        let route = manifest.routes[match.route.id];
        return [
            route && route.css ? route.css.map((href)=>({
                    rel: "stylesheet",
                    href: href
                })) : [],
            module?.links?.() || []
        ];
    }).flat(2), $8db8717086a501b5$export$442b9e023f41af00(matches, manifest));
}
function $8db8717086a501b5$var$getRouteCssDescriptors(route) {
    if (!route.css) return [];
    return route.css.map((href)=>({
            rel: "stylesheet",
            href: href
        }));
}
async function $8db8717086a501b5$export$2ee8f5601ba37b41(route) {
    if (!route.css) return;
    let descriptors = $8db8717086a501b5$var$getRouteCssDescriptors(route);
    await Promise.all(descriptors.map($8db8717086a501b5$var$prefetchStyleLink));
}
async function $8db8717086a501b5$export$26f28bc6dfd6cfc6(route, routeModule) {
    if (!route.css && !routeModule.links || !$8db8717086a501b5$var$isPreloadSupported()) return;
    let descriptors = [];
    if (route.css) descriptors.push(...$8db8717086a501b5$var$getRouteCssDescriptors(route));
    if (routeModule.links) descriptors.push(...routeModule.links());
    if (descriptors.length === 0) return;
    let styleLinks = [];
    for (let descriptor of descriptors)if (!$8db8717086a501b5$export$aea1aca0de10baae(descriptor) && descriptor.rel === "stylesheet") styleLinks.push({
        ...descriptor,
        rel: "preload",
        as: "style"
    });
    await Promise.all(styleLinks.map($8db8717086a501b5$var$prefetchStyleLink));
}
async function $8db8717086a501b5$var$prefetchStyleLink(descriptor) {
    return new Promise((resolve)=>{
        if (descriptor.media && !window.matchMedia(descriptor.media).matches || document.querySelector(`link[rel="stylesheet"][href="${descriptor.href}"]`)) return resolve();
        let link = document.createElement("link");
        Object.assign(link, descriptor);
        function removeLink() {
            if (document.head.contains(link)) document.head.removeChild(link);
        }
        link.onload = ()=>{
            removeLink();
            resolve();
        };
        link.onerror = ()=>{
            removeLink();
            resolve();
        };
        document.head.appendChild(link);
    });
}
function $8db8717086a501b5$export$aea1aca0de10baae(object) {
    return object != null && typeof object.page === "string";
}
function $8db8717086a501b5$var$isHtmlLinkDescriptor(object) {
    if (object == null) return false;
    if (object.href == null) return object.rel === "preload" && typeof object.imageSrcSet === "string" && typeof object.imageSizes === "string";
    return typeof object.rel === "string" && typeof object.href === "string";
}
async function $8db8717086a501b5$export$98f31d7a23772264(matches, manifest, routeModules) {
    return $8db8717086a501b5$var$dedupeLinkDescriptors((await Promise.all(matches.map(async (match)=>{
        let route = manifest.routes[match.route.id];
        if (route) {
            let mod = await (0, $7e5d214b95152fe5$export$d9c4a4e8105733a6)(route, routeModules);
            return mod.links ? mod.links() : [];
        }
        return [];
    }))).flat(1).filter($8db8717086a501b5$var$isHtmlLinkDescriptor).filter((link)=>link.rel === "stylesheet" || link.rel === "preload").map((link)=>link.rel === "stylesheet" ? {
            ...link,
            rel: "prefetch",
            as: "style"
        } : {
            ...link,
            rel: "prefetch"
        }));
}
function $8db8717086a501b5$export$4af547f9516933c(page, nextMatches, currentMatches, manifest, location, mode) {
    let isNew = (match, index)=>{
        if (!currentMatches[index]) return true;
        return match.route.id !== currentMatches[index].route.id;
    };
    let matchPathChanged = (match, index)=>{
        return currentMatches[index].pathname !== match.pathname || currentMatches[index].route.path?.endsWith("*") && currentMatches[index].params["*"] !== match.params["*"];
    };
    if (mode === "assets") return nextMatches.filter((match, index)=>isNew(match, index) || matchPathChanged(match, index));
    if (mode === "data") return nextMatches.filter((match, index)=>{
        let manifestRoute = manifest.routes[match.route.id];
        if (!manifestRoute || !manifestRoute.hasLoader) return false;
        if (isNew(match, index) || matchPathChanged(match, index)) return true;
        if (match.route.shouldRevalidate) {
            let routeChoice = match.route.shouldRevalidate({
                currentUrl: new URL(location.pathname + location.search + location.hash, window.origin),
                currentParams: currentMatches[0]?.params || {},
                nextUrl: new URL(page, window.origin),
                nextParams: match.params,
                defaultShouldRevalidate: true
            });
            if (typeof routeChoice === "boolean") return routeChoice;
        }
        return true;
    });
    return [];
}
function $8db8717086a501b5$export$442b9e023f41af00(matches, manifest, { includeHydrateFallback: includeHydrateFallback } = {}) {
    return $8db8717086a501b5$var$dedupeHrefs(matches.map((match)=>{
        let route = manifest.routes[match.route.id];
        if (!route) return [];
        let hrefs = [
            route.module
        ];
        if (route.clientActionModule) hrefs = hrefs.concat(route.clientActionModule);
        if (route.clientLoaderModule) hrefs = hrefs.concat(route.clientLoaderModule);
        if (includeHydrateFallback && route.hydrateFallbackModule) hrefs = hrefs.concat(route.hydrateFallbackModule);
        if (route.imports) hrefs = hrefs.concat(route.imports);
        return hrefs;
    }).flat(1));
}
function $8db8717086a501b5$var$dedupeHrefs(hrefs) {
    return [
        ...new Set(hrefs)
    ];
}
function $8db8717086a501b5$var$sortKeys(obj) {
    let sorted = {};
    let keys = Object.keys(obj).sort();
    for (let key of keys)sorted[key] = obj[key];
    return sorted;
}
function $8db8717086a501b5$var$dedupeLinkDescriptors(descriptors, preloads) {
    let set = /* @__PURE__ */ new Set();
    let preloadsSet = new Set(preloads);
    return descriptors.reduce((deduped, descriptor)=>{
        if (preloads && !$8db8717086a501b5$export$aea1aca0de10baae(descriptor) && descriptor.as === "script" && descriptor.href && preloadsSet.has(descriptor.href)) return deduped;
        let key = JSON.stringify($8db8717086a501b5$var$sortKeys(descriptor));
        if (!set.has(key)) {
            set.add(key);
            deduped.push({
                key: key,
                link: descriptor
            });
        }
        return deduped;
    }, []);
}
let $8db8717086a501b5$var$_isPreloadSupported;
function $8db8717086a501b5$var$isPreloadSupported() {
    if ($8db8717086a501b5$var$_isPreloadSupported !== void 0) return $8db8717086a501b5$var$_isPreloadSupported;
    let el = document.createElement("link");
    $8db8717086a501b5$var$_isPreloadSupported = el.relList.supports("preload");
    el = null;
    return $8db8717086a501b5$var$_isPreloadSupported;
}



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 



/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 
/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/utils.ts

var $199de99078bd1ae0$export$85f6557964517f1a = class {
    constructor(){
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "promise", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "resolve", void 0);
        (0, $b08ae6015a2ae0d0$export$71511d61b312f219)(this, "reject", void 0);
        this.promise = new Promise((resolve, reject)=>{
            this.resolve = resolve;
            this.reject = reject;
        });
    }
};
function $199de99078bd1ae0$export$4786a9f20844482d() {
    const decoder = new TextDecoder();
    let leftover = "";
    return new TransformStream({
        transform (chunk, controller) {
            const str = decoder.decode(chunk, {
                stream: true
            });
            const parts = (leftover + str).split("\n");
            leftover = parts.pop() || "";
            for (const part of parts)controller.enqueue(part);
        },
        flush (controller) {
            if (leftover) controller.enqueue(leftover);
        }
    });
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region vendor/turbo-stream-v2/flatten.ts
const $890951be67aef86c$var$TIME_LIMIT_MS = 1;
const $890951be67aef86c$var$getNow = ()=>Date.now();
const $890951be67aef86c$var$yieldToMain = ()=>new Promise((resolve)=>setTimeout(resolve, 0));
async function $890951be67aef86c$export$bffa455ba8c619a6(input) {
    const { indices: indices } = this;
    const existing = indices.get(input);
    if (existing) return [
        existing
    ];
    if (input === void 0) return -7;
    if (input === null) return -5;
    if (Number.isNaN(input)) return -2;
    if (input === Number.POSITIVE_INFINITY) return -6;
    if (input === Number.NEGATIVE_INFINITY) return -3;
    if (input === 0 && 1 / input < 0) return -4;
    const index = this.index++;
    indices.set(input, index);
    const stack = [
        [
            input,
            index
        ]
    ];
    await $890951be67aef86c$var$stringify.call(this, stack);
    return index;
}
async function $890951be67aef86c$var$stringify(stack) {
    const { deferred: deferred, indices: indices, plugins: plugins, postPlugins: postPlugins } = this;
    const str = this.stringified;
    let lastYieldTime = $890951be67aef86c$var$getNow();
    const flattenValue = (value)=>{
        const existing = indices.get(value);
        if (existing) return [
            existing
        ];
        if (value === void 0) return -7;
        if (value === null) return -5;
        if (Number.isNaN(value)) return -2;
        if (value === Number.POSITIVE_INFINITY) return -6;
        if (value === Number.NEGATIVE_INFINITY) return -3;
        if (value === 0 && 1 / value < 0) return -4;
        const index = this.index++;
        indices.set(value, index);
        stack.push([
            value,
            index
        ]);
        return index;
    };
    let i = 0;
    while(stack.length > 0){
        const now = $890951be67aef86c$var$getNow();
        if (++i % 6e3 === 0 && now - lastYieldTime >= $890951be67aef86c$var$TIME_LIMIT_MS) {
            await $890951be67aef86c$var$yieldToMain();
            lastYieldTime = $890951be67aef86c$var$getNow();
        }
        const [input, index] = stack.pop();
        const partsForObj = (obj)=>Object.keys(obj).map((k)=>`"_${flattenValue(k)}":${flattenValue(obj[k])}`).join(",");
        let error = null;
        switch(typeof input){
            case "boolean":
            case "number":
            case "string":
                str[index] = JSON.stringify(input);
                break;
            case "bigint":
                str[index] = `["B","${input}"]`;
                break;
            case "symbol":
                {
                    const keyFor = Symbol.keyFor(input);
                    if (!keyFor) error = /* @__PURE__ */ new Error("Cannot encode symbol unless created with Symbol.for()");
                    else str[index] = `["Y",${JSON.stringify(keyFor)}]`;
                    break;
                }
            case "object":
                {
                    if (!input) {
                        str[index] = `-5`;
                        break;
                    }
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) {
                        let result = isArray ? "[" : "{";
                        if (isArray) {
                            for(let i = 0; i < input.length; i++)result += (i ? "," : "") + (i in input ? flattenValue(input[i]) : -1);
                            str[index] = `${result}]`;
                        } else if (input instanceof Date) {
                            const dateTime = input.getTime();
                            str[index] = `["D",${Number.isNaN(dateTime) ? JSON.stringify("invalid") : dateTime}]`;
                        } else if (input instanceof URL) str[index] = `["U",${JSON.stringify(input.href)}]`;
                        else if (input instanceof RegExp) str[index] = `["R",${JSON.stringify(input.source)},${JSON.stringify(input.flags)}]`;
                        else if (input instanceof Set) {
                            if (input.size > 0) str[index] = `["S",${[
                                ...input
                            ].map((val)=>flattenValue(val)).join(",")}]`;
                            else str[index] = `["S"]`;
                        } else if (input instanceof Map) {
                            if (input.size > 0) str[index] = `["M",${[
                                ...input
                            ].flatMap(([k, v])=>[
                                    flattenValue(k),
                                    flattenValue(v)
                                ]).join(",")}]`;
                            else str[index] = `["M"]`;
                        } else if (input instanceof Promise) {
                            str[index] = `["P",${index}]`;
                            deferred[index] = input;
                        } else if (input instanceof Error) {
                            str[index] = `["E",${JSON.stringify(input.message)}`;
                            if (input.name !== "Error") str[index] += `,${JSON.stringify(input.name)}`;
                            str[index] += "]";
                        } else if (Object.getPrototypeOf(input) === null) str[index] = `["N",{${partsForObj(input)}}]`;
                        else if ($890951be67aef86c$var$isPlainObject(input)) str[index] = `{${partsForObj(input)}}`;
                        else error = /* @__PURE__ */ new Error("Cannot encode object with prototype");
                    }
                    break;
                }
            default:
                {
                    const isArray = Array.isArray(input);
                    let pluginHandled = false;
                    if (!isArray && plugins) for (const plugin of plugins){
                        const pluginResult = plugin(input);
                        if (Array.isArray(pluginResult)) {
                            pluginHandled = true;
                            const [pluginIdentifier, ...rest] = pluginResult;
                            str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                            if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                            str[index] += "]";
                            break;
                        }
                    }
                    if (!pluginHandled) error = /* @__PURE__ */ new Error("Cannot encode function or unexpected type");
                }
        }
        if (error) {
            let pluginHandled = false;
            if (postPlugins) for (const plugin of postPlugins){
                const pluginResult = plugin(input);
                if (Array.isArray(pluginResult)) {
                    pluginHandled = true;
                    const [pluginIdentifier, ...rest] = pluginResult;
                    str[index] = `[${JSON.stringify(pluginIdentifier)}`;
                    if (rest.length > 0) str[index] += `,${rest.map((v)=>flattenValue(v)).join(",")}`;
                    str[index] += "]";
                    break;
                }
            }
            if (!pluginHandled) throw error;
        }
    }
}
const $890951be67aef86c$var$objectProtoNames = Object.getOwnPropertyNames(Object.prototype).sort().join("\0");
function $890951be67aef86c$var$isPlainObject(thing) {
    const proto = Object.getPrototypeOf(thing);
    return proto === Object.prototype || proto === null || Object.getOwnPropertyNames(proto).sort().join("\0") === $890951be67aef86c$var$objectProtoNames;
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

//#region vendor/turbo-stream-v2/unflatten.ts
const $d1a01a5811db74cf$var$globalObj = typeof window !== "undefined" ? window : typeof globalThis !== "undefined" ? globalThis : void 0;
function $d1a01a5811db74cf$export$4315a2af848d75d7(parsed) {
    const { hydrated: hydrated, values: values } = this;
    if (typeof parsed === "number") return $d1a01a5811db74cf$var$hydrate.call(this, parsed);
    if (!Array.isArray(parsed) || !parsed.length) throw new SyntaxError();
    const startIndex = values.length;
    for (const value of parsed)values.push(value);
    hydrated.length = values.length;
    return $d1a01a5811db74cf$var$hydrate.call(this, startIndex);
}
function $d1a01a5811db74cf$var$hydrate(index) {
    const { hydrated: hydrated, values: values, deferred: deferred, plugins: plugins } = this;
    let result;
    const stack = [
        [
            index,
            (v)=>{
                result = v;
            }
        ]
    ];
    let postRun = [];
    while(stack.length > 0){
        const [index, set] = stack.pop();
        switch(index){
            case -7:
                set(void 0);
                continue;
            case -5:
                set(null);
                continue;
            case -2:
                set(NaN);
                continue;
            case -6:
                set(Infinity);
                continue;
            case -3:
                set(-Infinity);
                continue;
            case -4:
                set(-0);
                continue;
        }
        if (hydrated[index]) {
            set(hydrated[index]);
            continue;
        }
        const value = values[index];
        if (!value || typeof value !== "object") {
            hydrated[index] = value;
            set(value);
            continue;
        }
        if (Array.isArray(value)) {
            if (typeof value[0] === "string") {
                const [type, b, c] = value;
                switch(type){
                    case "D":
                        set(hydrated[index] = new Date(b));
                        continue;
                    case "U":
                        set(hydrated[index] = new URL(b));
                        continue;
                    case "B":
                        set(hydrated[index] = BigInt(b));
                        continue;
                    case "R":
                        set(hydrated[index] = new RegExp(b, c));
                        continue;
                    case "Y":
                        set(hydrated[index] = Symbol.for(b));
                        continue;
                    case "S":
                        const newSet = /* @__PURE__ */ new Set();
                        hydrated[index] = newSet;
                        for(let i = value.length - 1; i > 0; i--)stack.push([
                            value[i],
                            (v)=>{
                                newSet.add(v);
                            }
                        ]);
                        set(newSet);
                        continue;
                    case "M":
                        const map = /* @__PURE__ */ new Map();
                        hydrated[index] = map;
                        for(let i = value.length - 2; i > 0; i -= 2){
                            const r = [];
                            stack.push([
                                value[i + 1],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                value[i],
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                map.set(r[0], r[1]);
                            });
                        }
                        set(map);
                        continue;
                    case "N":
                        const obj = Object.create(null);
                        hydrated[index] = obj;
                        for (const key of Object.keys(b).reverse()){
                            const r = [];
                            stack.push([
                                b[key],
                                (v)=>{
                                    r[1] = v;
                                }
                            ]);
                            stack.push([
                                Number(key.slice(1)),
                                (k)=>{
                                    r[0] = k;
                                }
                            ]);
                            postRun.push(()=>{
                                obj[r[0]] = r[1];
                            });
                        }
                        set(obj);
                        continue;
                    case "P":
                        if (hydrated[b]) set(hydrated[index] = hydrated[b]);
                        else {
                            const d = new (0, $199de99078bd1ae0$export$85f6557964517f1a)();
                            deferred[b] = d;
                            set(hydrated[index] = d.promise);
                        }
                        continue;
                    case "E":
                        const [, message, errorType] = value;
                        let error = errorType && $d1a01a5811db74cf$var$globalObj && (0, $f1195701c85e5ce2$export$1a235bd2b33434e5).includes(errorType) && errorType in $d1a01a5811db74cf$var$globalObj && typeof $d1a01a5811db74cf$var$globalObj[errorType] === "function" ? new $d1a01a5811db74cf$var$globalObj[errorType](message) : new Error(message);
                        hydrated[index] = error;
                        set(error);
                        continue;
                    case "Z":
                        set(hydrated[index] = hydrated[b]);
                        continue;
                    default:
                        if (Array.isArray(plugins)) {
                            const r = [];
                            const vals = value.slice(1);
                            for(let i = 0; i < vals.length; i++){
                                const v = vals[i];
                                stack.push([
                                    v,
                                    (v)=>{
                                        r[i] = v;
                                    }
                                ]);
                            }
                            postRun.push(()=>{
                                for (const plugin of plugins){
                                    const result = plugin(value[0], ...r);
                                    if (result) {
                                        set(hydrated[index] = result.value);
                                        return;
                                    }
                                }
                                throw new SyntaxError();
                            });
                            continue;
                        }
                        throw new SyntaxError();
                }
            } else {
                const array = [];
                hydrated[index] = array;
                for(let i = 0; i < value.length; i++){
                    const n = value[i];
                    if (n !== -1) stack.push([
                        n,
                        (v)=>{
                            array[i] = v;
                        }
                    ]);
                }
                set(array);
                continue;
            }
        } else {
            const object = {};
            hydrated[index] = object;
            for (const key of Object.keys(value).reverse()){
                const r = [];
                stack.push([
                    value[key],
                    (v)=>{
                        r[1] = v;
                    }
                ]);
                stack.push([
                    Number(key.slice(1)),
                    (k)=>{
                        r[0] = k;
                    }
                ]);
                postRun.push(()=>{
                    object[r[0]] = r[1];
                });
            }
            set(object);
            continue;
        }
    }
    while(postRun.length > 0)postRun.pop()();
    return result;
}


//#region vendor/turbo-stream-v2/turbo-stream.ts
async function $ab9f754ee454fb69$export$2f872c0f2117be69(readable, options) {
    const { plugins: plugins } = options ?? {};
    const done = new (0, $199de99078bd1ae0$export$85f6557964517f1a)();
    const reader = readable.pipeThrough((0, $199de99078bd1ae0$export$4786a9f20844482d)()).getReader();
    const decoder = {
        values: [],
        hydrated: [],
        deferred: {},
        plugins: plugins
    };
    const decoded = await $ab9f754ee454fb69$var$decodeInitial.call(decoder, reader);
    let donePromise = done.promise;
    if (decoded.done) done.resolve();
    else donePromise = $ab9f754ee454fb69$var$decodeDeferred.call(decoder, reader).then(done.resolve).catch((reason)=>{
        for (const deferred of Object.values(decoder.deferred))deferred.reject(reason);
        done.reject(reason);
    });
    return {
        done: donePromise.then(()=>reader.closed),
        value: decoded.value
    };
}
async function $ab9f754ee454fb69$var$decodeInitial(reader) {
    const read = await reader.read();
    if (!read.value) throw new SyntaxError();
    let line;
    try {
        line = JSON.parse(read.value);
    } catch  {
        throw new SyntaxError();
    }
    return {
        done: read.done,
        value: (0, $d1a01a5811db74cf$export$4315a2af848d75d7).call(this, line)
    };
}
async function $ab9f754ee454fb69$var$decodeDeferred(reader) {
    let read = await reader.read();
    while(!read.done){
        if (!read.value) continue;
        const line = read.value;
        switch(line[0]){
            case "P":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $d1a01a5811db74cf$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.resolve(value);
                    break;
                }
            case "E":
                {
                    const colonIndex = line.indexOf(":");
                    const deferredId = Number(line.slice(1, colonIndex));
                    const deferred = this.deferred[deferredId];
                    if (!deferred) throw new Error(`Deferred ID ${deferredId} not found in stream`);
                    const lineData = line.slice(colonIndex + 1);
                    let jsonLine;
                    try {
                        jsonLine = JSON.parse(lineData);
                    } catch  {
                        throw new SyntaxError();
                    }
                    const value = (0, $d1a01a5811db74cf$export$4315a2af848d75d7).call(this, jsonLine);
                    deferred.reject(value);
                    break;
                }
            default:
                throw new SyntaxError();
        }
        read = await reader.read();
    }
}
function $ab9f754ee454fb69$export$c564cdbbe6da493(input, options) {
    const { onComplete: onComplete, plugins: plugins, postPlugins: postPlugins, signal: signal } = options ?? {};
    const encoder = {
        deferred: {},
        index: 0,
        indices: /* @__PURE__ */ new Map(),
        stringified: [],
        plugins: plugins,
        postPlugins: postPlugins,
        signal: signal
    };
    const textEncoder = new TextEncoder();
    let lastSentIndex = 0;
    return new ReadableStream({
        async start (controller) {
            const id = await (0, $890951be67aef86c$export$bffa455ba8c619a6).call(encoder, input);
            if (Array.isArray(id)) throw new Error("This should never happen");
            if (id < 0) controller.enqueue(textEncoder.encode(`${id}\n`));
            else {
                controller.enqueue(textEncoder.encode(`[${encoder.stringified.join(",")}]\n`));
                lastSentIndex = encoder.stringified.length - 1;
            }
            const seenPromises = /* @__PURE__ */ new WeakSet();
            let processingChain = Promise.resolve();
            if (Object.keys(encoder.deferred).length) {
                let raceDone;
                const racePromise = new Promise((resolve, reject)=>{
                    raceDone = resolve;
                    if (signal) {
                        const rejectPromise = ()=>reject(signal.reason || /* @__PURE__ */ new Error("Signal was aborted."));
                        if (signal.aborted) rejectPromise();
                        else signal.addEventListener("abort", (event)=>{
                            rejectPromise();
                        });
                    }
                });
                while(Object.keys(encoder.deferred).length > 0){
                    for (const [deferredId, deferred] of Object.entries(encoder.deferred)){
                        if (seenPromises.has(deferred)) continue;
                        seenPromises.add(encoder.deferred[Number(deferredId)] = Promise.race([
                            racePromise,
                            deferred
                        ]).then((resolved)=>{
                            processingChain = processingChain.then(async ()=>{
                                const id = await (0, $890951be67aef86c$export$bffa455ba8c619a6).call(encoder, resolved);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`P${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`P${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }, (reason)=>{
                            processingChain = processingChain.then(async ()=>{
                                if (!reason || typeof reason !== "object" || !(reason instanceof Error)) reason = /* @__PURE__ */ new Error("An unknown error occurred");
                                const id = await (0, $890951be67aef86c$export$bffa455ba8c619a6).call(encoder, reason);
                                if (Array.isArray(id)) {
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[["Z",${id[0]}]]\n`));
                                    encoder.index++;
                                    lastSentIndex++;
                                } else if (id < 0) controller.enqueue(textEncoder.encode(`E${deferredId}:${id}\n`));
                                else {
                                    const values = encoder.stringified.slice(lastSentIndex + 1).join(",");
                                    controller.enqueue(textEncoder.encode(`E${deferredId}:[${values}]\n`));
                                    lastSentIndex = encoder.stringified.length - 1;
                                }
                            });
                            return processingChain;
                        }).finally(()=>{
                            delete encoder.deferred[Number(deferredId)];
                        }));
                    }
                    await Promise.race(Object.values(encoder.deferred));
                }
                raceDone();
            }
            await Promise.all(Object.values(encoder.deferred));
            await processingChain;
            controller.close();
            onComplete?.();
        }
    });
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ //#region lib/dom/ssr/data.ts
async function $cf8dd289ddec0d3e$export$a30aa2a0fce6c468(request) {
    let init = {
        signal: request.signal
    };
    if (request.method !== "GET") {
        init.method = request.method;
        let contentType = request.headers.get("Content-Type");
        if (contentType && /\bapplication\/json\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = JSON.stringify(await request.json());
        } else if (contentType && /\btext\/plain\b/.test(contentType)) {
            init.headers = {
                "Content-Type": contentType
            };
            init.body = await request.text();
        } else if (contentType && /\bapplication\/x-www-form-urlencoded\b/.test(contentType)) init.body = new URLSearchParams(await request.text());
        else init.body = await request.formData();
    }
    return init;
}



var $aZSru = parcelRequire("aZSru");
//#region lib/dom/ssr/single-fetch.tsx
const $6ffd78d3e88a89f1$export$60644022b8b46aaa = Symbol("SingleFetchRedirect");
var $6ffd78d3e88a89f1$var$SingleFetchNoResultError = class extends Error {
};
const $6ffd78d3e88a89f1$export$e35ccdcde387134d = new Set([
    100,
    101,
    204,
    205
]);
function $6ffd78d3e88a89f1$export$2b0b5f24fd77a79f({ context: context, identifier: identifier, reader: reader, textDecoder: textDecoder, nonce: nonce }) {
    if (!context.renderMeta || !context.renderMeta.didRenderScripts) return null;
    if (!context.renderMeta.streamCache) context.renderMeta.streamCache = {};
    let { streamCache: streamCache } = context.renderMeta;
    let promise = streamCache[identifier];
    if (!promise) promise = streamCache[identifier] = reader.read().then((result)=>{
        streamCache[identifier].result = {
            done: result.done,
            value: textDecoder.decode(result.value, {
                stream: true
            })
        };
    }).catch((e)=>{
        streamCache[identifier].error = e;
    });
    if (promise.error) throw promise.error;
    if (promise.result === void 0) throw promise;
    let { done: done, value: value } = promise.result;
    let scriptTag = value ? /* @__PURE__ */ $aZSru.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.enqueue(${(0, $3a95c051359f4bfb$export$4cf11838cdc2a8a8)(JSON.stringify(value))});`
        }
    }) : null;
    if (done) return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, scriptTag, /* @__PURE__ */ $aZSru.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `window.__reactRouterContext.streamController.close();`
        }
    }));
    else return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, scriptTag, /* @__PURE__ */ $aZSru.createElement($aZSru.Suspense, null, /* @__PURE__ */ $aZSru.createElement($6ffd78d3e88a89f1$export$2b0b5f24fd77a79f, {
        context: context,
        identifier: identifier + 1,
        reader: reader,
        textDecoder: textDecoder,
        nonce: nonce
    })));
}
function $6ffd78d3e88a89f1$export$77d7799427e365da(getRouter, manifest, routeModules, ssr) {
    let dataStrategy = $6ffd78d3e88a89f1$export$7144ac7f1a8613d3(getRouter, (match)=>{
        let manifestRoute = manifest.routes[match.route.id];
        (0, $a1cfca9399783296$export$2e2bcd8739ae039)(manifestRoute, "Route not found in manifest");
        return {
            hasLoader: manifestRoute.hasLoader,
            hasClientLoader: manifestRoute.hasClientLoader
        };
    }, $6ffd78d3e88a89f1$var$fetchAndDecodeViaTurboStream, ssr);
    return async (args)=>args.runClientMiddleware(dataStrategy);
}
function $6ffd78d3e88a89f1$export$7144ac7f1a8613d3(getRouter, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    return async (args)=>{
        let { request: request, matches: matches, fetcherKey: fetcherKey } = args;
        let router = getRouter();
        if (request.method !== "GET") return $6ffd78d3e88a89f1$var$singleFetchActionStrategy(args, fetchAndDecode);
        let foundRevalidatingServerLoader = matches.some((m)=>{
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return m.shouldCallHandler() && hasLoader && !hasClientLoader;
        });
        if (!ssr && !foundRevalidatingServerLoader) return $6ffd78d3e88a89f1$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode);
        if (fetcherKey) return $6ffd78d3e88a89f1$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode);
        return $6ffd78d3e88a89f1$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut);
    };
}
async function $6ffd78d3e88a89f1$var$singleFetchActionStrategy(args, fetchAndDecode) {
    let actionMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(actionMatch, "No action match found");
    let actionStatus = void 0;
    let result = await actionMatch.resolve(async (handler)=>{
        return await handler(async ()=>{
            let { data: data, status: status } = await fetchAndDecode(args, [
                actionMatch.route.id
            ]);
            actionStatus = status;
            return $6ffd78d3e88a89f1$var$unwrapSingleFetchResult(data, actionMatch.route.id);
        });
    });
    if ((0, $9915aeece4ba52df$export$3f1eb41d9a6a6a27)(result.result) || (0, $f1195701c85e5ce2$export$972111febbeef05b)(result.result) || (0, $9915aeece4ba52df$export$e0163cfdf7bc9cfa)(result.result)) return {
        [actionMatch.route.id]: result
    };
    return {
        [actionMatch.route.id]: {
            type: result.type,
            result: (0, $f1195701c85e5ce2$export$4051a07651545597)(result.result, actionStatus)
        }
    };
}
async function $6ffd78d3e88a89f1$var$nonSsrStrategy(args, getRouteInfo, fetchAndDecode) {
    let matchesToLoad = args.matches.filter((m)=>m.shouldCallHandler());
    let results = {};
    await Promise.all(matchesToLoad.map(async (m)=>{
        let routeId = m.route.id;
        results[routeId] = await m.resolve(async (handler)=>{
            let { hasClientLoader: hasClientLoader } = getRouteInfo(m);
            return hasClientLoader ? handler(async ()=>{
                let { data: data } = await fetchAndDecode(args, [
                    routeId
                ]);
                return $6ffd78d3e88a89f1$var$unwrapSingleFetchResult(data, routeId);
            }) : handler();
        });
    }));
    return results;
}
async function $6ffd78d3e88a89f1$var$singleFetchLoaderNavigationStrategy(args, router, getRouteInfo, fetchAndDecode, ssr, shouldAllowOptOut = ()=>true) {
    let routesParams = /* @__PURE__ */ new Set();
    let foundOptOutRoute = false;
    let routeDfds = args.matches.map(()=>$6ffd78d3e88a89f1$var$createDeferred());
    let singleFetchDfd = $6ffd78d3e88a89f1$var$createDeferred();
    let results = {};
    let resolvePromise = Promise.all(args.matches.map(async (m, i)=>m.resolve(async (handler)=>{
            routeDfds[i].resolve();
            let routeId = m.route.id;
            let { hasLoader: hasLoader, hasClientLoader: hasClientLoader } = getRouteInfo(m);
            let defaultShouldRevalidate = !m.shouldRevalidateArgs || m.shouldRevalidateArgs.actionStatus == null || m.shouldRevalidateArgs.actionStatus < 400;
            if (!m.shouldCallHandler(defaultShouldRevalidate)) {
                foundOptOutRoute || (foundOptOutRoute = m.shouldRevalidateArgs != null && hasLoader);
                return;
            }
            if (shouldAllowOptOut(m) && hasClientLoader) {
                if (hasLoader) foundOptOutRoute = true;
                try {
                    results[routeId] = {
                        type: "data",
                        result: await handler(async ()=>{
                            let { data: data } = await fetchAndDecode(args, [
                                routeId
                            ]);
                            return $6ffd78d3e88a89f1$var$unwrapSingleFetchResult(data, routeId);
                        })
                    };
                } catch (e) {
                    results[routeId] = {
                        type: "error",
                        result: e
                    };
                }
                return;
            }
            if (hasLoader) routesParams.add(routeId);
            try {
                results[routeId] = {
                    type: "data",
                    result: await handler(async ()=>{
                        return $6ffd78d3e88a89f1$var$unwrapSingleFetchResult(await singleFetchDfd.promise, routeId);
                    })
                };
            } catch (e) {
                results[routeId] = {
                    type: "error",
                    result: e
                };
            }
        })));
    await Promise.all(routeDfds.map((d)=>d.promise));
    if ((!router.state.initialized && router.state.navigation.state === "idle" || routesParams.size === 0) && !window.__reactRouterHdrActive) singleFetchDfd.resolve({
        routes: {}
    });
    else {
        let targetRoutes = ssr && foundOptOutRoute && routesParams.size > 0 ? [
            ...routesParams.keys()
        ] : void 0;
        try {
            let data = await fetchAndDecode(args, targetRoutes);
            singleFetchDfd.resolve(data.data);
        } catch (e) {
            singleFetchDfd.reject(e);
        }
    }
    await resolvePromise;
    await $6ffd78d3e88a89f1$var$bubbleMiddlewareErrors(singleFetchDfd.promise, args.matches, routesParams, results);
    return results;
}
async function $6ffd78d3e88a89f1$var$bubbleMiddlewareErrors(singleFetchPromise, matches, routesParams, results) {
    try {
        let middlewareError;
        let fetchedData = await singleFetchPromise;
        if ("routes" in fetchedData) {
            for (let match of matches)if (match.route.id in fetchedData.routes) {
                let routeResult = fetchedData.routes[match.route.id];
                if ("error" in routeResult) {
                    middlewareError = routeResult.error;
                    if (results[match.route.id]?.result == null) results[match.route.id] = {
                        type: "error",
                        result: middlewareError
                    };
                    break;
                }
            }
        }
        if (middlewareError !== void 0) Array.from(routesParams.values()).forEach((routeId)=>{
            if (results[routeId].result instanceof $6ffd78d3e88a89f1$var$SingleFetchNoResultError) results[routeId].result = middlewareError;
        });
    } catch  {}
}
async function $6ffd78d3e88a89f1$var$singleFetchLoaderFetcherStrategy(args, fetchAndDecode) {
    let fetcherMatch = args.matches.find((m)=>m.shouldCallHandler());
    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(fetcherMatch, "No fetcher match found");
    let routeId = fetcherMatch.route.id;
    let result = await fetcherMatch.resolve(async (handler)=>handler(async ()=>{
            let { data: data } = await fetchAndDecode(args, [
                routeId
            ]);
            return $6ffd78d3e88a89f1$var$unwrapSingleFetchResult(data, routeId);
        }));
    return {
        [fetcherMatch.route.id]: result
    };
}
function $6ffd78d3e88a89f1$export$425969b7f98e2c9c(url) {
    let indexValues = url.searchParams.getAll("index");
    url.searchParams.delete("index");
    let indexValuesToKeep = [];
    for (let indexValue of indexValues)if (indexValue) indexValuesToKeep.push(indexValue);
    for (let toKeep of indexValuesToKeep)url.searchParams.append("index", toKeep);
    return url;
}
function $6ffd78d3e88a89f1$export$7b977381851b2c(reqUrl, extension) {
    let url = typeof reqUrl === "string" ? new URL(reqUrl, typeof window === "undefined" ? "server://singlefetch/" : window.location.origin) : reqUrl;
    if (url.pathname.endsWith("/")) url.pathname = `${url.pathname}_.${extension}`;
    else url.pathname = `${url.pathname}.${extension}`;
    return url;
}
async function $6ffd78d3e88a89f1$var$fetchAndDecodeViaTurboStream(args, targetRoutes) {
    let { request: request } = args;
    let url = $6ffd78d3e88a89f1$export$7b977381851b2c(request.url, "data");
    if (request.method === "GET") {
        url = $6ffd78d3e88a89f1$export$425969b7f98e2c9c(url);
        if (targetRoutes) url.searchParams.set("_routes", targetRoutes.join(","));
    }
    let res = await fetch(url, await (0, $cf8dd289ddec0d3e$export$a30aa2a0fce6c468)(request));
    if (res.status >= 400 && !res.headers.has("X-Remix-Response")) throw new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(res.status, res.statusText, await res.text());
    if (res.status === 204 && res.headers.has("X-Remix-Redirect")) return {
        status: 202,
        data: {
            redirect: {
                redirect: res.headers.get("X-Remix-Redirect"),
                status: Number(res.headers.get("X-Remix-Status") || "302"),
                revalidate: res.headers.get("X-Remix-Revalidate") === "true",
                reload: res.headers.get("X-Remix-Reload-Document") === "true",
                replace: res.headers.get("X-Remix-Replace") === "true"
            }
        }
    };
    if ($6ffd78d3e88a89f1$export$e35ccdcde387134d.has(res.status)) {
        let routes = {};
        if (targetRoutes && request.method !== "GET") routes[targetRoutes[0]] = {
            data: void 0
        };
        return {
            status: res.status,
            data: {
                routes: routes
            }
        };
    }
    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(res.body, "No response body to decode");
    try {
        let decoded = await $6ffd78d3e88a89f1$export$4023ad4ecd4126a2(res.body, window);
        let data;
        if (request.method === "GET") {
            let typed = decoded.value;
            if ($6ffd78d3e88a89f1$export$60644022b8b46aaa in typed) data = {
                redirect: typed[$6ffd78d3e88a89f1$export$60644022b8b46aaa]
            };
            else data = {
                routes: typed
            };
        } else {
            let typed = decoded.value;
            let routeId = targetRoutes?.[0];
            (0, $a1cfca9399783296$export$2e2bcd8739ae039)(routeId, "No routeId found for single fetch call decoding");
            if ("redirect" in typed) data = {
                redirect: typed
            };
            else data = {
                routes: {
                    [routeId]: typed
                }
            };
        }
        return {
            status: res.status,
            data: data
        };
    } catch (cause) {
        throw new Error("Unable to decode turbo-stream response", {
            cause: cause
        });
    }
}
function $6ffd78d3e88a89f1$export$4023ad4ecd4126a2(body, global) {
    return (0, $ab9f754ee454fb69$export$2f872c0f2117be69)(body, {
        plugins: [
            (type, ...rest)=>{
                if (type === "SanitizedError") {
                    let [name, message, stack] = rest;
                    let Constructor = Error;
                    if (name && (0, $f1195701c85e5ce2$export$1a235bd2b33434e5).includes(name) && name in global && typeof global[name] === "function") Constructor = global[name];
                    let error = new Constructor(message);
                    error.stack = stack;
                    return {
                        value: error
                    };
                }
                if (type === "ErrorResponse") {
                    let [data, status, statusText] = rest;
                    return {
                        value: new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(status, statusText, data)
                    };
                }
                if (type === "SingleFetchRedirect") return {
                    value: {
                        [$6ffd78d3e88a89f1$export$60644022b8b46aaa]: rest[0]
                    }
                };
                if (type === "SingleFetchClassInstance") return {
                    value: rest[0]
                };
                if (type === "SingleFetchFallback") return {
                    value: void 0
                };
            }
        ]
    });
}
function $6ffd78d3e88a89f1$var$unwrapSingleFetchResult(result, routeId) {
    if ("redirect" in result) {
        let { redirect: location, revalidate: revalidate, reload: reload, replace: replace, status: status } = result.redirect;
        throw (0, $f1195701c85e5ce2$export$89e12c5b50f7529d)(location, {
            status: status,
            headers: {
                ...revalidate ? {
                    "X-Remix-Revalidate": "yes"
                } : null,
                ...reload ? {
                    "X-Remix-Reload-Document": "yes"
                } : null,
                ...replace ? {
                    "X-Remix-Replace": "yes"
                } : null
            }
        });
    }
    let routeResult = result.routes[routeId];
    if (routeResult == null) throw new $6ffd78d3e88a89f1$var$SingleFetchNoResultError(`No result found for routeId "${routeId}"`);
    else if ("error" in routeResult) throw routeResult.error;
    else if ("data" in routeResult) return routeResult.data;
    else throw new Error(`Invalid response found for routeId "${routeId}"`);
}
function $6ffd78d3e88a89f1$var$createDeferred() {
    let resolve;
    let reject;
    let promise = new Promise((res, rej)=>{
        resolve = async (val)=>{
            res(val);
            try {
                await promise;
            } catch  {}
        };
        reject = async (error)=>{
            rej(error);
            try {
                await promise;
            } catch  {}
        };
    });
    return {
        promise: promise,
        resolve: resolve,
        reject: reject
    };
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 

/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 




/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $aZSru = parcelRequire("aZSru");
//#region lib/dom/ssr/errorBoundaries.tsx
var $b654c9d089bcfe55$export$32e57f52df4b6e34 = class extends $aZSru.Component {
    static getDerivedStateFromError(error) {
        return {
            error: error
        };
    }
    static getDerivedStateFromProps(props, state) {
        if (state.location !== props.location) return {
            error: props.error || null,
            location: props.location
        };
        return {
            error: props.error || state.error,
            location: state.location
        };
    }
    render() {
        if (this.state.error) return /* @__PURE__ */ $aZSru.createElement($b654c9d089bcfe55$export$20b33acd14692c9, {
            error: this.state.error,
            isOutsideRemixApp: true
        });
        else return this.props.children;
    }
    constructor(props){
        super(props);
        this.state = {
            error: props.error || null,
            location: props.location
        };
    }
};
/**
* When app's don't provide a root level ErrorBoundary, we default to this.
*/ function $b654c9d089bcfe55$export$20b33acd14692c9({ error: error, isOutsideRemixApp: isOutsideRemixApp }) {
    let { nonce: nonce } = (0, $e17f0a7fb7c1208d$export$17134ff624fc6bc2)();
    console.error(error);
    let heyDeveloper = /* @__PURE__ */ $aZSru.createElement("script", {
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: `
        console.log(
          "\u{1F4BF} Hey developer \u{1F44B}. You can provide a way better UX than this when your app throws errors. Check out https://reactrouter.com/how-to/error-boundary for more information."
        );
      `
        }
    });
    if ((0, $f1195701c85e5ce2$export$972111febbeef05b)(error)) return /* @__PURE__ */ $aZSru.createElement($b654c9d089bcfe55$export$cf8626ebc6a4ba63, {
        title: "Unhandled Thrown Response!"
    }, /* @__PURE__ */ $aZSru.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, error.status, " ", error.statusText), null);
    let errorInstance;
    if (error instanceof Error) errorInstance = error;
    else {
        let errorString = error == null ? "Unknown Error" : typeof error === "object" && "toString" in error ? error.toString() : JSON.stringify(error);
        errorInstance = new Error(errorString);
    }
    return /* @__PURE__ */ $aZSru.createElement($b654c9d089bcfe55$export$cf8626ebc6a4ba63, {
        title: "Application Error!",
        isOutsideRemixApp: isOutsideRemixApp
    }, /* @__PURE__ */ $aZSru.createElement("h1", {
        style: {
            fontSize: "24px"
        }
    }, "Application Error"), /* @__PURE__ */ $aZSru.createElement("pre", {
        style: {
            padding: "2rem",
            background: "hsla(10, 50%, 50%, 0.1)",
            color: "red",
            overflow: "auto"
        }
    }, errorInstance.stack), heyDeveloper);
}
function $b654c9d089bcfe55$export$cf8626ebc6a4ba63({ title: title, renderScripts: renderScripts, isOutsideRemixApp: isOutsideRemixApp, children: children }) {
    let { routeModules: routeModules } = (0, $e17f0a7fb7c1208d$export$17134ff624fc6bc2)();
    if (routeModules.root?.Layout && !isOutsideRemixApp) return children;
    return /* @__PURE__ */ $aZSru.createElement("html", {
        lang: "en"
    }, /* @__PURE__ */ $aZSru.createElement("head", null, /* @__PURE__ */ $aZSru.createElement("meta", {
        charSet: "utf-8"
    }), /* @__PURE__ */ $aZSru.createElement("meta", {
        name: "viewport",
        content: "width=device-width,initial-scale=1,viewport-fit=cover"
    }), /* @__PURE__ */ $aZSru.createElement("title", null, title)), /* @__PURE__ */ $aZSru.createElement("body", null, /* @__PURE__ */ $aZSru.createElement("main", {
        style: {
            fontFamily: "system-ui, sans-serif",
            padding: "2rem"
        }
    }, children, renderScripts ? /* @__PURE__ */ $aZSru.createElement((0, $e17f0a7fb7c1208d$export$ff0bf87698939488), null) : null)));
}


/**
 * react-router v8.4.0
 *
 * Copyright (c) Remix Software Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE.md file in the root directory of this source tree.
 *
 * @license MIT
 */ 


var $aZSru = parcelRequire("aZSru");
//#region lib/dom/ssr/fallback.tsx
function $7a56b19e3b968fa5$export$7e8143a7b6df36d9() {
    let { nonce: nonce } = (0, $e17f0a7fb7c1208d$export$17134ff624fc6bc2)();
    return /* @__PURE__ */ $aZSru.createElement((0, $b654c9d089bcfe55$export$cf8626ebc6a4ba63), {
        title: "Loading...",
        renderScripts: true
    }, null);
}



var $aZSru = parcelRequire("aZSru");
//#region lib/dom/ssr/routes.tsx
function $65d62b3153f0f55b$var$groupRoutesByParentId(manifest) {
    let routes = {};
    Object.values(manifest).forEach((route)=>{
        if (route) {
            let parentId = route.parentId || "";
            if (!routes[parentId]) routes[parentId] = [];
            routes[parentId].push(route);
        }
    });
    return routes;
}
function $65d62b3153f0f55b$var$getRouteComponents(route, routeModule, isSpaMode) {
    let Component = $65d62b3153f0f55b$var$getRouteModuleComponent(routeModule);
    let HydrateFallback = routeModule.HydrateFallback && (!isSpaMode || route.id === "root") ? routeModule.HydrateFallback : route.id === "root" ? (0, $7a56b19e3b968fa5$export$7e8143a7b6df36d9) : void 0;
    let ErrorBoundary = routeModule.ErrorBoundary ? routeModule.ErrorBoundary : route.id === "root" ? ()=>/* @__PURE__ */ $aZSru.createElement((0, $b654c9d089bcfe55$export$20b33acd14692c9), {
            error: (0, $da3cac5a2aaa7b71$export$ed527bf60f6e05f2)()
        }) : void 0;
    if (route.id === "root" && routeModule.Layout) return {
        ...Component ? {
            element: /* @__PURE__ */ $aZSru.createElement(routeModule.Layout, null, /* @__PURE__ */ $aZSru.createElement(Component, null))
        } : {
            Component: Component
        },
        ...ErrorBoundary ? {
            errorElement: /* @__PURE__ */ $aZSru.createElement(routeModule.Layout, null, /* @__PURE__ */ $aZSru.createElement(ErrorBoundary, null))
        } : {
            ErrorBoundary: ErrorBoundary
        },
        ...HydrateFallback ? {
            hydrateFallbackElement: /* @__PURE__ */ $aZSru.createElement(routeModule.Layout, null, /* @__PURE__ */ $aZSru.createElement(HydrateFallback, null))
        } : {
            HydrateFallback: HydrateFallback
        }
    };
    return {
        Component: Component,
        ErrorBoundary: ErrorBoundary,
        HydrateFallback: HydrateFallback
    };
}
function $65d62b3153f0f55b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, parentId = "", routesByParentId = $65d62b3153f0f55b$var$groupRoutesByParentId(manifest), spaModeLazyPromise = Promise.resolve({
    Component: ()=>null
})) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModules[route.id];
        (0, $a1cfca9399783296$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available to create server routes");
        let dataRoute = {
            ...$65d62b3153f0f55b$var$getRouteComponents(route, routeModule, isSpaMode),
            caseSensitive: route.caseSensitive,
            id: route.id,
            index: route.index,
            path: route.path,
            handle: routeModule.handle,
            lazy: isSpaMode ? ()=>spaModeLazyPromise : void 0,
            loader: route.hasLoader || route.hasClientLoader ? ()=>null : void 0
        };
        let children = $65d62b3153f0f55b$export$5be2318464878170(manifest, routeModules, future, isSpaMode, route.id, routesByParentId, spaModeLazyPromise);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $65d62b3153f0f55b$export$49d9dc160d22054c(needsRevalidation, manifest, routeModulesCache, initialState, ssr, isSpaMode) {
    return $65d62b3153f0f55b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, "", $65d62b3153f0f55b$var$groupRoutesByParentId(manifest), needsRevalidation);
}
function $65d62b3153f0f55b$var$preventInvalidServerHandlerCall(type, route) {
    if (type === "loader" && !route.hasLoader || type === "action" && !route.hasAction) {
        let msg = `You are trying to call ${type === "action" ? "serverAction()" : "serverLoader()"} on a route that does not have a server ${type} (routeId: "${route.id}")`;
        console.error(msg);
        throw new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(400, "Bad Request", new Error(msg), true);
    }
}
function $65d62b3153f0f55b$export$2754e84c8e66e57d(type, routeId) {
    let article = type === "clientAction" ? "a" : "an";
    let msg = `Route "${routeId}" does not have ${article} ${type}, but you are trying to submit to it. To fix this, please add ${article} \`${type}\` function to the route`;
    console.error(msg);
    throw new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(405, "Method Not Allowed", new Error(msg), true);
}
function $65d62b3153f0f55b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, parentId = "", routesByParentId = $65d62b3153f0f55b$var$groupRoutesByParentId(manifest), needsRevalidation) {
    return (routesByParentId[parentId] || []).map((route)=>{
        let routeModule = routeModulesCache[route.id];
        function fetchServerHandler(singleFetch) {
            (0, $a1cfca9399783296$export$2e2bcd8739ae039)(typeof singleFetch === "function", "No single fetch function available for route handler");
            return singleFetch();
        }
        function fetchServerLoader(singleFetch) {
            if (!route.hasLoader) return Promise.resolve(null);
            return fetchServerHandler(singleFetch);
        }
        function fetchServerAction(singleFetch) {
            if (!route.hasAction) throw $65d62b3153f0f55b$export$2754e84c8e66e57d("action", route.id);
            return fetchServerHandler(singleFetch);
        }
        function prefetchModule(modulePath) {
            import(/* @vite-ignore */ /* webpackIgnore: true */ modulePath);
        }
        function prefetchRouteModuleChunks(route) {
            if (route.clientActionModule) prefetchModule(route.clientActionModule);
            if (route.clientLoaderModule) prefetchModule(route.clientLoaderModule);
        }
        async function prefetchStylesAndCallHandler(handler) {
            let cachedModule = routeModulesCache[route.id];
            let linkPrefetchPromise = cachedModule ? (0, $8db8717086a501b5$export$26f28bc6dfd6cfc6)(route, cachedModule) : Promise.resolve();
            try {
                return handler();
            } finally{
                await linkPrefetchPromise;
            }
        }
        let dataRoute = {
            id: route.id,
            index: route.index,
            path: route.path
        };
        if (routeModule) {
            Object.assign(dataRoute, {
                ...dataRoute,
                ...$65d62b3153f0f55b$var$getRouteComponents(route, routeModule, isSpaMode),
                middleware: routeModule.clientMiddleware,
                handle: routeModule.handle,
                shouldRevalidate: $65d62b3153f0f55b$var$getShouldRevalidateFunction(dataRoute.path, routeModule, route, ssr, needsRevalidation)
            });
            let hasInitialData = initialState && initialState.loaderData && route.id in initialState.loaderData;
            let initialData = hasInitialData ? initialState?.loaderData?.[route.id] : void 0;
            let hasInitialError = initialState && initialState.errors && route.id in initialState.errors;
            let initialError = hasInitialError ? initialState?.errors?.[route.id] : void 0;
            let isHydrationRequest = needsRevalidation == null && (routeModule.clientLoader?.hydrate === true || !route.hasLoader);
            dataRoute.loader = async ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                let _isHydrationRequest = isHydrationRequest;
                isHydrationRequest = false;
                return await prefetchStylesAndCallHandler(async ()=>{
                    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route loader");
                    if (!routeModule.clientLoader) return fetchServerLoader(singleFetch);
                    return routeModule.clientLoader({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverLoader () {
                            $65d62b3153f0f55b$var$preventInvalidServerHandlerCall("loader", route);
                            if (_isHydrationRequest) {
                                if (hasInitialData) return initialData;
                                if (hasInitialError) throw initialError;
                            }
                            return fetchServerLoader(singleFetch);
                        }
                    });
                });
            };
            dataRoute.loader.hydrate = $65d62b3153f0f55b$export$6ac68922d4e92125(route.id, routeModule.clientLoader, route.hasLoader, isSpaMode);
            dataRoute.action = ({ request: request, params: params, context: context, pattern: pattern, url: url }, singleFetch)=>{
                return prefetchStylesAndCallHandler(async ()=>{
                    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(routeModule, "No `routeModule` available for critical-route action");
                    if (!routeModule.clientAction) {
                        if (isSpaMode) throw $65d62b3153f0f55b$export$2754e84c8e66e57d("clientAction", route.id);
                        return fetchServerAction(singleFetch);
                    }
                    return routeModule.clientAction({
                        request: request,
                        params: params,
                        context: context,
                        pattern: pattern,
                        url: url,
                        async serverAction () {
                            $65d62b3153f0f55b$var$preventInvalidServerHandlerCall("action", route);
                            return fetchServerAction(singleFetch);
                        }
                    });
                });
            };
        } else {
            if (!route.hasClientLoader) dataRoute.loader = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    return fetchServerLoader(singleFetch);
                });
            if (!route.hasClientAction) dataRoute.action = (_, singleFetch)=>prefetchStylesAndCallHandler(()=>{
                    if (isSpaMode) throw $65d62b3153f0f55b$export$2754e84c8e66e57d("clientAction", route.id);
                    return fetchServerAction(singleFetch);
                });
            let lazyRoutePromise;
            async function getLazyRoute() {
                if (lazyRoutePromise) return await lazyRoutePromise;
                lazyRoutePromise = (async ()=>{
                    if (route.clientLoaderModule || route.clientActionModule) await new Promise((resolve)=>setTimeout(resolve, 0));
                    let routeModulePromise = $65d62b3153f0f55b$var$loadRouteModuleWithBlockingLinks(route, routeModulesCache);
                    prefetchRouteModuleChunks(route);
                    return await routeModulePromise;
                })();
                return await lazyRoutePromise;
            }
            dataRoute.lazy = {
                loader: route.hasClientLoader ? async ()=>{
                    let { clientLoader: clientLoader } = route.clientLoaderModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientLoaderModule) : await getLazyRoute();
                    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(clientLoader, "No `clientLoader` export found");
                    return (args, singleFetch)=>clientLoader({
                            ...args,
                            async serverLoader () {
                                $65d62b3153f0f55b$var$preventInvalidServerHandlerCall("loader", route);
                                return fetchServerLoader(singleFetch);
                            }
                        });
                } : void 0,
                action: route.hasClientAction ? async ()=>{
                    let clientActionPromise = route.clientActionModule ? import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientActionModule) : getLazyRoute();
                    prefetchRouteModuleChunks(route);
                    let { clientAction: clientAction } = await clientActionPromise;
                    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(clientAction, "No `clientAction` export found");
                    return (args, singleFetch)=>clientAction({
                            ...args,
                            async serverAction () {
                                $65d62b3153f0f55b$var$preventInvalidServerHandlerCall("action", route);
                                return fetchServerAction(singleFetch);
                            }
                        });
                } : void 0,
                middleware: route.hasClientMiddleware ? async ()=>{
                    let { clientMiddleware: clientMiddleware } = route.clientMiddlewareModule ? await import(/* @vite-ignore */ /* webpackIgnore: true */ route.clientMiddlewareModule) : await getLazyRoute();
                    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(clientMiddleware, "No `clientMiddleware` export found");
                    return clientMiddleware;
                } : void 0,
                shouldRevalidate: async ()=>{
                    let lazyRoute = await getLazyRoute();
                    return $65d62b3153f0f55b$var$getShouldRevalidateFunction(dataRoute.path, lazyRoute, route, ssr, needsRevalidation);
                },
                handle: async ()=>(await getLazyRoute()).handle,
                Component: async ()=>(await getLazyRoute()).Component,
                ErrorBoundary: route.hasErrorBoundary ? async ()=>(await getLazyRoute()).ErrorBoundary : void 0
            };
        }
        let children = $65d62b3153f0f55b$export$af76e85f27ba0229(manifest, routeModulesCache, initialState, ssr, isSpaMode, route.id, routesByParentId, needsRevalidation);
        if (children.length > 0) dataRoute.children = children;
        return dataRoute;
    });
}
function $65d62b3153f0f55b$var$getShouldRevalidateFunction(path, route, manifestRoute, ssr, needsRevalidation) {
    if (needsRevalidation) return $65d62b3153f0f55b$var$wrapShouldRevalidateForHdr(manifestRoute.id, route.shouldRevalidate, needsRevalidation);
    if (!ssr && manifestRoute.hasLoader && !manifestRoute.hasClientLoader) {
        let myParams = path ? (0, $f1195701c85e5ce2$export$d726f29eb2425705)(path)[1].map((p)=>p.paramName) : [];
        const didParamsChange = (opts)=>myParams.some((p)=>opts.currentParams[p] !== opts.nextParams[p]);
        if (route.shouldRevalidate) {
            let fn = route.shouldRevalidate;
            return (opts)=>fn({
                    ...opts,
                    defaultShouldRevalidate: didParamsChange(opts)
                });
        } else return (opts)=>didParamsChange(opts);
    }
    return route.shouldRevalidate;
}
function $65d62b3153f0f55b$var$wrapShouldRevalidateForHdr(routeId, routeShouldRevalidate, needsRevalidation) {
    let handledRevalidation = false;
    return (arg)=>{
        if (!handledRevalidation) {
            handledRevalidation = true;
            return needsRevalidation.has(routeId);
        }
        return routeShouldRevalidate ? routeShouldRevalidate(arg) : arg.defaultShouldRevalidate;
    };
}
async function $65d62b3153f0f55b$var$loadRouteModuleWithBlockingLinks(route, routeModules) {
    let routeModulePromise = (0, $7e5d214b95152fe5$export$d9c4a4e8105733a6)(route, routeModules);
    let prefetchRouteCssPromise = (0, $8db8717086a501b5$export$2ee8f5601ba37b41)(route);
    let routeModule = await routeModulePromise;
    await Promise.all([
        prefetchRouteCssPromise,
        (0, $8db8717086a501b5$export$26f28bc6dfd6cfc6)(route, routeModule)
    ]);
    return {
        Component: $65d62b3153f0f55b$var$getRouteModuleComponent(routeModule),
        ErrorBoundary: routeModule.ErrorBoundary,
        clientMiddleware: routeModule.clientMiddleware,
        clientAction: routeModule.clientAction,
        clientLoader: routeModule.clientLoader,
        handle: routeModule.handle,
        links: routeModule.links,
        meta: routeModule.meta,
        shouldRevalidate: routeModule.shouldRevalidate
    };
}
function $65d62b3153f0f55b$var$getRouteModuleComponent(routeModule) {
    if (routeModule.default == null) return void 0;
    if (!(typeof routeModule.default === "object" && Object.keys(routeModule.default).length === 0)) return routeModule.default;
}
function $65d62b3153f0f55b$export$6ac68922d4e92125(routeId, clientLoader, hasLoader, isSpaMode) {
    return isSpaMode && routeId !== "root" || clientLoader != null && (clientLoader.hydrate === true || hasLoader !== true);
}



var $aZSru = parcelRequire("aZSru");
//#region lib/dom/ssr/fog-of-war.ts
const $c48c3ce287273f66$var$nextPaths = /* @__PURE__ */ new Set();
const $c48c3ce287273f66$var$discoveredPathsMaxSize = 1e3;
const $c48c3ce287273f66$var$discoveredPaths = /* @__PURE__ */ new Set();
const $c48c3ce287273f66$export$b5915cf27fa06b9f = 7680;
function $c48c3ce287273f66$export$791cac19ae57137a(paths) {
    let result = /* @__PURE__ */ new Set();
    paths.forEach((path)=>{
        if (!path.startsWith("/")) path = `/${path}`;
        for(let i = 1; i < path.length; i++)if (path[i] === "/") result.add(path.slice(0, i));
        result.add(path);
    });
    return Array.from(result);
}
function $c48c3ce287273f66$export$741d98b28dbfd(routeDiscovery, ssr) {
    return routeDiscovery.mode === "lazy" && ssr === true;
}
function $c48c3ce287273f66$export$ae5150779dbcc11a({ sri: sri, ...manifest }, router) {
    let routeIds = new Set(router.state.matches.map((m)=>m.route.id));
    let segments = router.state.location.pathname.split("/").filter(Boolean);
    let paths = [
        "/"
    ];
    segments.pop();
    while(segments.length > 0){
        paths.push(`/${segments.join("/")}`);
        segments.pop();
    }
    paths.forEach((path)=>{
        let matches = router.match(path);
        if (matches) matches.forEach((m)=>routeIds.add(m.route.id));
    });
    let initialRoutes = [
        ...routeIds
    ].reduce((acc, id)=>Object.assign(acc, {
            [id]: manifest.routes[id]
        }), {});
    return {
        ...manifest,
        routes: initialRoutes,
        sri: sri ? true : void 0
    };
}
function $c48c3ce287273f66$export$72ab377a1030deb9(getRouter, manifest, routeModules, ssr, routeDiscovery, isSpaMode, basename) {
    if (!$c48c3ce287273f66$export$741d98b28dbfd(routeDiscovery, ssr)) return;
    return async ({ path: path, patch: patch, signal: signal, fetcherKey: fetcherKey })=>{
        if ($c48c3ce287273f66$var$discoveredPaths.has(path)) return;
        let { state: state } = getRouter();
        await $c48c3ce287273f66$var$fetchAndApplyManifestPatches([
            path
        ], fetcherKey ? window.location.href : (0, $072a56029499ae6c$export$fe53371bee54353d)(state.navigation.location || state.location), manifest, routeModules, ssr, isSpaMode, basename, routeDiscovery.manifestPath, patch, signal);
    };
}
function $c48c3ce287273f66$export$5ef046b23d96090d(router, manifest, routeModules, ssr, routeDiscovery, isSpaMode) {
    $aZSru.useEffect(()=>{
        if (!$c48c3ce287273f66$export$741d98b28dbfd(routeDiscovery, ssr) || window.navigator?.connection?.saveData === true) return;
        function registerElement(el) {
            let path = el.tagName === "FORM" ? el.getAttribute("action") : el.getAttribute("href");
            if (!path) return;
            let pathname = el.tagName === "A" ? el.pathname : new URL(path, window.location.origin).pathname;
            if (!$c48c3ce287273f66$var$discoveredPaths.has(pathname)) $c48c3ce287273f66$var$nextPaths.add(pathname);
        }
        async function fetchPatches() {
            document.querySelectorAll("a[data-discover], form[data-discover]").forEach(registerElement);
            let lazyPaths = Array.from($c48c3ce287273f66$var$nextPaths.keys()).filter((path)=>{
                if ($c48c3ce287273f66$var$discoveredPaths.has(path)) {
                    $c48c3ce287273f66$var$nextPaths.delete(path);
                    return false;
                }
                return true;
            });
            if (lazyPaths.length === 0) return;
            try {
                await $c48c3ce287273f66$var$fetchAndApplyManifestPatches(lazyPaths, null, manifest, routeModules, ssr, isSpaMode, router.basename, routeDiscovery.manifestPath, router.patchRoutes);
            } catch (e) {
                console.error("Failed to fetch manifest patches", e);
            }
        }
        let debouncedFetchPatches = $c48c3ce287273f66$var$debounce(fetchPatches, 100);
        fetchPatches();
        let observer = new MutationObserver(()=>debouncedFetchPatches());
        observer.observe(document.documentElement, {
            subtree: true,
            childList: true,
            attributes: true,
            attributeFilter: [
                "data-discover",
                "href",
                "action"
            ]
        });
        return ()=>observer.disconnect();
    }, [
        ssr,
        isSpaMode,
        manifest,
        routeModules,
        router,
        routeDiscovery
    ]);
}
function $c48c3ce287273f66$export$bcb79c3deff01d56(_manifestPath, basename) {
    let manifestPath = _manifestPath || "/__manifest";
    return basename == null ? manifestPath : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
        basename,
        manifestPath
    ]);
}
const $c48c3ce287273f66$var$MANIFEST_VERSION_STORAGE_KEY = "react-router-manifest-version";
const $c48c3ce287273f66$var$MANIFEST_RELOAD_TIMEOUT = 5e3;
let $c48c3ce287273f66$var$pendingManifestReload;
async function $c48c3ce287273f66$export$2f7ce2790dc2d211(needsReload, version, errorReloadPath) {
    if ($c48c3ce287273f66$var$pendingManifestReload) return $c48c3ce287273f66$var$pendingManifestReload;
    if (!needsReload) {
        try {
            sessionStorage.removeItem($c48c3ce287273f66$var$MANIFEST_VERSION_STORAGE_KEY);
        } catch  {}
        return false;
    }
    if (!errorReloadPath) {
        console.warn("Detected a manifest version mismatch during eager route discovery. The next navigation/fetch to an undiscovered route will result in a new document navigation to sync up with the latest manifest.");
        return true;
    }
    let alreadyReloaded = false;
    try {
        alreadyReloaded = sessionStorage.getItem($c48c3ce287273f66$var$MANIFEST_VERSION_STORAGE_KEY) === version;
        if (!alreadyReloaded) sessionStorage.setItem($c48c3ce287273f66$var$MANIFEST_VERSION_STORAGE_KEY, version);
    } catch  {}
    if (alreadyReloaded) throw new Error("Unable to discover routes due to manifest version mismatch.");
    let rejectReload;
    let reloadPromise = new Promise((_, reject)=>{
        rejectReload = reject;
    });
    $c48c3ce287273f66$var$pendingManifestReload = reloadPromise;
    let failReload = ()=>{
        clearTimeout(timeout);
        window.removeEventListener("pageshow", onPageShow);
        $c48c3ce287273f66$var$pendingManifestReload = void 0;
        rejectReload(/* @__PURE__ */ new Error("Unable to discover routes due to manifest version mismatch."));
    };
    let timeout = setTimeout(failReload, $c48c3ce287273f66$var$MANIFEST_RELOAD_TIMEOUT);
    let onPageShow = (event)=>{
        if (event.persisted) failReload();
    };
    window.addEventListener("pageshow", onPageShow);
    try {
        window.location.href = errorReloadPath;
        console.warn("Detected manifest version mismatch, reloading...");
    } catch  {
        failReload();
    }
    return reloadPromise;
}
async function $c48c3ce287273f66$var$fetchAndApplyManifestPatches(paths, errorReloadPath, manifest, routeModules, ssr, isSpaMode, basename, manifestPath, patchRoutes, signal) {
    paths = $c48c3ce287273f66$export$791cac19ae57137a(paths);
    const searchParams = new URLSearchParams();
    searchParams.set("paths", paths.sort().join(","));
    searchParams.set("version", manifest.version);
    let url = new URL($c48c3ce287273f66$export$bcb79c3deff01d56(manifestPath, basename), window.location.origin);
    url.search = searchParams.toString();
    if (url.toString().length > 7680) {
        $c48c3ce287273f66$var$nextPaths.clear();
        return;
    }
    let serverPatches;
    try {
        let res = await fetch(url, {
            signal: signal
        });
        if (!res.ok) throw new Error(`${res.status} ${res.statusText}`);
        if (await $c48c3ce287273f66$export$2f7ce2790dc2d211(res.status === 204 && res.headers.has("X-Remix-Reload-Document"), manifest.version, errorReloadPath)) return;
        serverPatches = await res.json();
    } catch (e) {
        if (signal?.aborted) return;
        throw e;
    }
    if (signal?.aborted) return;
    let knownRoutes = new Set(Object.keys(manifest.routes));
    let patches = Object.values(serverPatches).reduce((acc, route)=>{
        if (route && !knownRoutes.has(route.id)) acc[route.id] = route;
        return acc;
    }, {});
    Object.assign(manifest.routes, patches);
    paths.forEach((p)=>$c48c3ce287273f66$var$addToFifoQueue(p, $c48c3ce287273f66$var$discoveredPaths));
    let parentIds = /* @__PURE__ */ new Set();
    Object.values(patches).forEach((patch)=>{
        if (patch && (!patch.parentId || !patches[patch.parentId])) parentIds.add(patch.parentId);
    });
    parentIds.forEach((parentId)=>patchRoutes(parentId || null, (0, $65d62b3153f0f55b$export$af76e85f27ba0229)(patches, routeModules, null, ssr, isSpaMode, parentId)));
}
function $c48c3ce287273f66$var$addToFifoQueue(path, queue) {
    if (queue.size >= $c48c3ce287273f66$var$discoveredPathsMaxSize) {
        let first = queue.values().next().value;
        if (first !== void 0) queue.delete(first);
    }
    queue.add(path);
}
function $c48c3ce287273f66$var$debounce(callback, wait) {
    let timeoutId;
    return (...args)=>{
        window.clearTimeout(timeoutId);
        timeoutId = window.setTimeout(()=>callback(...args), wait);
    };
}



var $aZSru = parcelRequire("aZSru");
//#region lib/dom/ssr/components.tsx
const $e17f0a7fb7c1208d$export$208d6a3bc3aa62bd = $aZSru.createContext(void 0);
$e17f0a7fb7c1208d$export$208d6a3bc3aa62bd.displayName = "FrameworkContext";
function $e17f0a7fb7c1208d$export$17134ff624fc6bc2() {
    let context = $aZSru.useContext($e17f0a7fb7c1208d$export$208d6a3bc3aa62bd);
    (0, $a1cfca9399783296$export$2e2bcd8739ae039)(context, "You must render this element inside a <HydratedRouter> element");
    return context;
}
function $e17f0a7fb7c1208d$export$6eb91431f5da407c(prefetch, theirElementProps) {
    let frameworkContext = $aZSru.useContext($e17f0a7fb7c1208d$export$208d6a3bc3aa62bd);
    let [maybePrefetch, setMaybePrefetch] = $aZSru.useState(false);
    let [shouldPrefetch, setShouldPrefetch] = $aZSru.useState(false);
    let { onFocus: onFocus, onBlur: onBlur, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, onTouchStart: onTouchStart } = theirElementProps;
    let ref = $aZSru.useRef(null);
    $aZSru.useEffect(()=>{
        if (prefetch === "render") setShouldPrefetch(true);
        if (prefetch === "viewport") {
            let callback = (entries)=>{
                entries.forEach((entry)=>{
                    setShouldPrefetch(entry.isIntersecting);
                });
            };
            let observer = new IntersectionObserver(callback, {
                threshold: .5
            });
            if (ref.current) observer.observe(ref.current);
            return ()=>{
                observer.disconnect();
            };
        }
    }, [
        prefetch
    ]);
    $aZSru.useEffect(()=>{
        if (maybePrefetch) {
            let id = setTimeout(()=>{
                setShouldPrefetch(true);
            }, 100);
            return ()=>{
                clearTimeout(id);
            };
        }
    }, [
        maybePrefetch
    ]);
    let setIntent = ()=>{
        setMaybePrefetch(true);
    };
    let cancelIntent = ()=>{
        setMaybePrefetch(false);
        setShouldPrefetch(false);
    };
    if (!frameworkContext) return [
        false,
        ref,
        {}
    ];
    if (prefetch !== "intent") return [
        shouldPrefetch,
        ref,
        {}
    ];
    return [
        shouldPrefetch,
        ref,
        {
            onFocus: $e17f0a7fb7c1208d$var$composeEventHandlers(onFocus, setIntent),
            onBlur: $e17f0a7fb7c1208d$var$composeEventHandlers(onBlur, cancelIntent),
            onMouseEnter: $e17f0a7fb7c1208d$var$composeEventHandlers(onMouseEnter, setIntent),
            onMouseLeave: $e17f0a7fb7c1208d$var$composeEventHandlers(onMouseLeave, cancelIntent),
            onTouchStart: $e17f0a7fb7c1208d$var$composeEventHandlers(onTouchStart, setIntent)
        }
    ];
}
function $e17f0a7fb7c1208d$var$composeEventHandlers(theirHandler, ourHandler) {
    return (event)=>{
        theirHandler && theirHandler(event);
        if (!event.defaultPrevented) ourHandler(event);
    };
}
function $e17f0a7fb7c1208d$var$getActiveMatches(matches, errors, isSpaMode) {
    if (isSpaMode && !$e17f0a7fb7c1208d$var$isHydrated) return [
        matches[0]
    ];
    if (errors) {
        let errorIdx = matches.findIndex((m)=>errors[m.route.id] !== void 0);
        return matches.slice(0, errorIdx + 1);
    }
    return matches;
}
const $e17f0a7fb7c1208d$export$7e4ed4715c00dab0 = "data-react-router-critical-css";
/**
* Renders all the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags created by the route module's [`links`](../../start/framework/route-module#links)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Links } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Links />
*       </head>
*       <body></body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {LinksProps.nonce} props.nonce n/a
* @param {LinksProps.crossOrigin} props.crossOrigin n/a
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $e17f0a7fb7c1208d$export$b2e089eb3692b073({ nonce: nonce, crossOrigin: crossOrigin }) {
    let { isSpaMode: isSpaMode, manifest: manifest, routeModules: routeModules, criticalCss: criticalCss, nonce: contextNonce } = $e17f0a7fb7c1208d$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $da3cac5a2aaa7b71$export$f93124018767f269)("Links");
    let { errors: errors } = (0, $da3cac5a2aaa7b71$export$798168c290ba5b3d)("Links");
    let matches = $e17f0a7fb7c1208d$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let keyedLinks = $aZSru.useMemo(()=>(0, $8db8717086a501b5$export$c43eb07eab2c950a)(matches, routeModules, manifest), [
        matches,
        routeModules,
        manifest
    ]);
    if (nonce == null && contextNonce) nonce = contextNonce;
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, typeof criticalCss === "string" ? /* @__PURE__ */ $aZSru.createElement("style", {
        [$e17f0a7fb7c1208d$export$7e4ed4715c00dab0]: "",
        nonce: nonce,
        dangerouslySetInnerHTML: {
            __html: criticalCss
        }
    }) : null, typeof criticalCss === "object" ? /* @__PURE__ */ $aZSru.createElement("link", {
        [$e17f0a7fb7c1208d$export$7e4ed4715c00dab0]: "",
        rel: "stylesheet",
        href: criticalCss.href,
        nonce: nonce,
        crossOrigin: crossOrigin
    }) : null, keyedLinks.map(({ key: key, link: link })=>(0, $8db8717086a501b5$export$aea1aca0de10baae)(link) ? /* @__PURE__ */ $aZSru.createElement($e17f0a7fb7c1208d$export$60dcec93e67386bd, {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        }) : /* @__PURE__ */ $aZSru.createElement("link", {
            key: key,
            nonce: nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? crossOrigin
        })));
}
/**
* Renders [`<link rel=prefetch|modulepreload>`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel)
* tags for modules and data of another page to enable an instant navigation to
* that page. [`<Link prefetch>`](./Link#prefetch) uses this internally, but you
* can render it to prefetch a page for any other reason.
*
* For example, you may render one of this as the user types into a search field
* to prefetch search results before they click through to their selection.
*
* @example
* import { PrefetchPageLinks } from "react-router";
*
* <PrefetchPageLinks page="/absolute/path" />
*
* @public
* @category Components
* @mode framework
* @param props Props
* @param {PageLinkDescriptor.page} props.page n/a
* @param props.linkProps Additional props to spread onto the [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/crossOrigin),
* [`integrity`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/integrity),
* [`rel`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLLinkElement/rel),
* etc.
* @returns A collection of React elements for [`<link>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/link)
* tags
*/ function $e17f0a7fb7c1208d$export$60dcec93e67386bd({ page: page, ...linkProps }) {
    let rsc = (0, $b71c75740e61495f$export$6e1eeb090b3ec35b)();
    let { nonce: contextNonce } = $e17f0a7fb7c1208d$export$17134ff624fc6bc2();
    let { router: router } = (0, $da3cac5a2aaa7b71$export$ae09415e57d46628)("PrefetchPageLinks");
    let matches = $aZSru.useMemo(()=>router.match(page), [
        router,
        router.routes,
        page
    ]);
    if (!matches) return null;
    if (linkProps.nonce == null && contextNonce) linkProps = {
        ...linkProps,
        nonce: contextNonce
    };
    if (rsc) return /* @__PURE__ */ $aZSru.createElement($e17f0a7fb7c1208d$var$RSCPrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
    return /* @__PURE__ */ $aZSru.createElement($e17f0a7fb7c1208d$var$PrefetchPageLinksImpl, {
        page: page,
        matches: matches,
        ...linkProps
    });
}
function $e17f0a7fb7c1208d$var$useKeyedPrefetchLinks(matches) {
    let { manifest: manifest, routeModules: routeModules } = $e17f0a7fb7c1208d$export$17134ff624fc6bc2();
    let [keyedPrefetchLinks, setKeyedPrefetchLinks] = $aZSru.useState([]);
    $aZSru.useEffect(()=>{
        let interrupted = false;
        (0, $8db8717086a501b5$export$98f31d7a23772264)(matches, manifest, routeModules).then((links)=>{
            if (!interrupted) setKeyedPrefetchLinks(links);
        });
        return ()=>{
            interrupted = true;
        };
    }, [
        matches,
        manifest,
        routeModules
    ]);
    return keyedPrefetchLinks;
}
function $e17f0a7fb7c1208d$var$RSCPrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let dataHrefs = $aZSru.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let url = (0, $6ffd78d3e88a89f1$export$7b977381851b2c)(page, "rsc");
        let hasSomeRoutesWithShouldRevalidate = false;
        let targetRoutes = [];
        for (let match of nextMatches)if (typeof match.route.shouldRevalidate === "function") hasSomeRoutesWithShouldRevalidate = true;
        else targetRoutes.push(match.route.id);
        if (hasSomeRoutesWithShouldRevalidate && targetRoutes.length > 0) url.searchParams.set("_routes", targetRoutes.join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        page,
        location,
        nextMatches
    ]);
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $aZSru.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })));
}
function $e17f0a7fb7c1208d$var$PrefetchPageLinksImpl({ page: page, matches: nextMatches, ...linkProps }) {
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let { manifest: manifest, routeModules: routeModules } = $e17f0a7fb7c1208d$export$17134ff624fc6bc2();
    let { matches: matches } = (0, $da3cac5a2aaa7b71$export$f93124018767f269)("PrefetchPageLinks");
    let { loaderData: loaderData } = (0, $da3cac5a2aaa7b71$export$798168c290ba5b3d)("PrefetchPageLinks");
    let newMatchesForData = $aZSru.useMemo(()=>(0, $8db8717086a501b5$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "data"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let newMatchesForAssets = $aZSru.useMemo(()=>(0, $8db8717086a501b5$export$4af547f9516933c)(page, nextMatches, matches, manifest, location, "assets"), [
        page,
        nextMatches,
        matches,
        manifest,
        location
    ]);
    let dataHrefs = $aZSru.useMemo(()=>{
        if (page === location.pathname + location.search + location.hash) return [];
        let routesParams = /* @__PURE__ */ new Set();
        let foundOptOutRoute = false;
        nextMatches.forEach((m)=>{
            let manifestRoute = manifest.routes[m.route.id];
            if (!manifestRoute || !manifestRoute.hasLoader) return;
            if (!newMatchesForData.some((m2)=>m2.route.id === m.route.id) && m.route.id in loaderData && routeModules[m.route.id]?.shouldRevalidate) foundOptOutRoute = true;
            else if (manifestRoute.hasClientLoader) foundOptOutRoute = true;
            else routesParams.add(m.route.id);
        });
        if (routesParams.size === 0) return [];
        let url = (0, $6ffd78d3e88a89f1$export$7b977381851b2c)(page, "data");
        if (foundOptOutRoute && routesParams.size > 0) url.searchParams.set("_routes", nextMatches.filter((m)=>routesParams.has(m.route.id)).map((m)=>m.route.id).join(","));
        return [
            url.pathname + url.search
        ];
    }, [
        loaderData,
        location,
        manifest,
        newMatchesForData,
        nextMatches,
        page,
        routeModules
    ]);
    let moduleHrefs = $aZSru.useMemo(()=>(0, $8db8717086a501b5$export$442b9e023f41af00)(newMatchesForAssets, manifest), [
        newMatchesForAssets,
        manifest
    ]);
    let keyedPrefetchLinks = $e17f0a7fb7c1208d$var$useKeyedPrefetchLinks(newMatchesForAssets);
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, dataHrefs.map((href)=>/* @__PURE__ */ $aZSru.createElement("link", {
            key: href,
            rel: "prefetch",
            as: "fetch",
            href: href,
            ...linkProps
        })), moduleHrefs.map((href)=>/* @__PURE__ */ $aZSru.createElement("link", {
            key: href,
            rel: "modulepreload",
            href: href,
            ...linkProps
        })), keyedPrefetchLinks.map(({ key: key, link: link })=>/* @__PURE__ */ $aZSru.createElement("link", {
            key: key,
            nonce: linkProps.nonce,
            ...link,
            crossOrigin: link.crossOrigin ?? linkProps.crossOrigin
        })));
}
/**
* Renders all the [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags created by the route module's [`meta`](../../start/framework/route-module#meta)
* export. You should render it inside the [`<head>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/head)
* of your document.
*
* @example
* import { Meta } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head>
*         <Meta />
*       </head>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @returns A collection of React elements for [`<meta>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/meta)
* tags
*/ function $e17f0a7fb7c1208d$export$b08a9033b36413fb() {
    let { isSpaMode: isSpaMode, routeModules: routeModules } = $e17f0a7fb7c1208d$export$17134ff624fc6bc2();
    let { matches: routerMatches } = (0, $da3cac5a2aaa7b71$export$f93124018767f269)("Meta");
    let { errors: errors, loaderData: loaderData } = (0, $da3cac5a2aaa7b71$export$798168c290ba5b3d)("Meta");
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let _matches = $e17f0a7fb7c1208d$var$getActiveMatches(routerMatches, errors, isSpaMode);
    let error = null;
    if (errors) error = errors[_matches[_matches.length - 1].route.id];
    let meta = [];
    let leafMeta = null;
    let matches = [];
    for(let i = 0; i < _matches.length; i++){
        let _match = _matches[i];
        let routeId = _match.route.id;
        let data = loaderData[routeId];
        let params = _match.params;
        let routeModule = routeModules[routeId];
        let routeMeta = [];
        let match = {
            id: routeId,
            loaderData: data,
            meta: [],
            params: _match.params,
            pathname: _match.pathname,
            handle: _match.route.handle,
            error: error
        };
        matches[i] = match;
        if (routeModule?.meta) routeMeta = typeof routeModule.meta === "function" ? routeModule.meta({
            loaderData: data,
            params: params,
            location: location,
            matches: matches,
            error: error
        }) : Array.isArray(routeModule.meta) ? [
            ...routeModule.meta
        ] : routeModule.meta;
        else if (leafMeta) routeMeta = [
            ...leafMeta
        ];
        routeMeta = routeMeta || [];
        if (!Array.isArray(routeMeta)) throw new Error("The route at " + _match.route.path + " returns an invalid value. All route meta functions must return an array of meta objects.\n\nTo reference the meta function API, see https://reactrouter.com/start/framework/route-module#meta");
        match.meta = routeMeta;
        matches[i] = match;
        meta = [
            ...routeMeta
        ];
        leafMeta = meta;
    }
    return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, meta.flat().map((metaProps)=>{
        if (!metaProps) return null;
        if ("tagName" in metaProps) {
            let { tagName: tagName, ...rest } = metaProps;
            if (!$e17f0a7fb7c1208d$var$isValidMetaTag(tagName)) {
                console.warn(`A meta object uses an invalid tagName: ${tagName}. Expected either 'link' or 'meta'`);
                return null;
            }
            let Comp = tagName;
            return /* @__PURE__ */ $aZSru.createElement(Comp, {
                key: JSON.stringify(rest),
                ...rest
            });
        }
        if ("title" in metaProps) return /* @__PURE__ */ $aZSru.createElement("title", {
            key: "title"
        }, String(metaProps.title));
        if ("charset" in metaProps) {
            var _metaProps;
            (_metaProps = metaProps).charSet ?? (_metaProps.charSet = metaProps.charset);
            delete metaProps.charset;
        }
        if ("charSet" in metaProps && metaProps.charSet != null) return typeof metaProps.charSet === "string" ? /* @__PURE__ */ $aZSru.createElement("meta", {
            key: "charSet",
            charSet: metaProps.charSet
        }) : null;
        if ("script:ld+json" in metaProps) try {
            let json = JSON.stringify(metaProps["script:ld+json"]);
            return /* @__PURE__ */ $aZSru.createElement("script", {
                key: `script:ld+json:${json}`,
                type: "application/ld+json",
                dangerouslySetInnerHTML: {
                    __html: (0, $3a95c051359f4bfb$export$4cf11838cdc2a8a8)(json)
                }
            });
        } catch  {
            return null;
        }
        return /* @__PURE__ */ $aZSru.createElement("meta", {
            key: JSON.stringify(metaProps),
            ...metaProps
        });
    }));
}
function $e17f0a7fb7c1208d$var$isValidMetaTag(tagName) {
    return typeof tagName === "string" && /^(meta|link)$/.test(tagName);
}
/**
* Tracks whether hydration is finished, so scripts can be skipped
* during client-side updates.
*/ let $e17f0a7fb7c1208d$var$isHydrated = false;
function $e17f0a7fb7c1208d$export$3be068dde909e563() {
    $e17f0a7fb7c1208d$var$isHydrated = true;
}
/**
* Renders the client runtime of your app. It should be rendered inside the
* [`<body>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/body)
*  of the document.
*
* If server rendering, you can omit `<Scripts/>` and the app will work as a
* traditional web app without JavaScript, relying solely on HTML and browser
* behaviors.
*
* @example
* import { Scripts } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <head />
*       <body>
*         <Scripts />
*       </body>
*     </html>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @param scriptProps Additional props to spread onto the [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags, such as [`crossOrigin`](https://developer.mozilla.org/en-US/docs/Web/API/HTMLScriptElement/crossOrigin),
* [`nonce`](https://developer.mozilla.org/en-US/docs/Web/HTML/Reference/Global_attributes/nonce),
* etc.
* @returns A collection of React elements for [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tags
*/ function $e17f0a7fb7c1208d$export$ff0bf87698939488(scriptProps) {
    let { manifest: manifest, serverHandoffString: serverHandoffString, isSpaMode: isSpaMode, renderMeta: renderMeta, routeDiscovery: routeDiscovery, ssr: ssr, nonce: contextNonce } = $e17f0a7fb7c1208d$export$17134ff624fc6bc2();
    let { router: router, static: isStatic, staticContext: staticContext } = (0, $da3cac5a2aaa7b71$export$ae09415e57d46628)("Scripts");
    let { matches: routerMatches } = (0, $da3cac5a2aaa7b71$export$f93124018767f269)("Scripts");
    let isRSCRouterContext = (0, $b71c75740e61495f$export$6e1eeb090b3ec35b)();
    let enableFogOfWar = (0, $c48c3ce287273f66$export$741d98b28dbfd)(routeDiscovery, ssr);
    if (scriptProps.nonce == null && contextNonce) scriptProps = {
        ...scriptProps,
        nonce: contextNonce
    };
    if (renderMeta) renderMeta.didRenderScripts = true;
    let matches = $e17f0a7fb7c1208d$var$getActiveMatches(routerMatches, null, isSpaMode);
    $aZSru.useEffect(()=>{
        $e17f0a7fb7c1208d$export$3be068dde909e563();
    }, []);
    let initialScripts = $aZSru.useMemo(()=>{
        if (isRSCRouterContext) return null;
        let contextScript = staticContext ? `window.__reactRouterContext = ${serverHandoffString};window.__reactRouterContext.stream = new ReadableStream({start(controller){window.__reactRouterContext.streamController = controller;}}).pipeThrough(new TextEncoderStream());` : " ";
        let routeModulesScript = !isStatic ? " " : `${manifest.hmr?.runtime ? `import ${JSON.stringify(manifest.hmr.runtime)};` : ""}${!enableFogOfWar ? `import ${JSON.stringify(manifest.url)}` : ""};
${matches.map((match, routeIndex)=>{
            let routeVarName = `route${routeIndex}`;
            let manifestEntry = manifest.routes[match.route.id];
            (0, $a1cfca9399783296$export$2e2bcd8739ae039)(manifestEntry, `Route ${match.route.id} not found in manifest`);
            let { clientActionModule: clientActionModule, clientLoaderModule: clientLoaderModule, clientMiddlewareModule: clientMiddlewareModule, hydrateFallbackModule: hydrateFallbackModule, module: module } = manifestEntry;
            let chunks = [
                ...clientActionModule ? [
                    {
                        module: clientActionModule,
                        varName: `${routeVarName}_clientAction`
                    }
                ] : [],
                ...clientLoaderModule ? [
                    {
                        module: clientLoaderModule,
                        varName: `${routeVarName}_clientLoader`
                    }
                ] : [],
                ...clientMiddlewareModule ? [
                    {
                        module: clientMiddlewareModule,
                        varName: `${routeVarName}_clientMiddleware`
                    }
                ] : [],
                ...hydrateFallbackModule ? [
                    {
                        module: hydrateFallbackModule,
                        varName: `${routeVarName}_HydrateFallback`
                    }
                ] : [],
                {
                    module: module,
                    varName: `${routeVarName}_main`
                }
            ];
            if (chunks.length === 1) return `import * as ${routeVarName} from ${JSON.stringify(module)};`;
            return [
                chunks.map((chunk)=>`import * as ${chunk.varName} from "${chunk.module}";`).join("\n"),
                `const ${routeVarName} = {${chunks.map((chunk)=>`...${chunk.varName}`).join(",")}};`
            ].join("\n");
        }).join("\n")}
  ${enableFogOfWar ? `window.__reactRouterManifest = ${JSON.stringify((0, $c48c3ce287273f66$export$ae5150779dbcc11a)(manifest, router), null, 2)};` : ""}
  window.__reactRouterRouteModules = {${matches.map((match, index)=>`${JSON.stringify(match.route.id)}:route${index}`).join(",")}};

import(${JSON.stringify(manifest.entry.module)});`;
        return /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, /* @__PURE__ */ $aZSru.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: contextScript
            },
            type: void 0
        }), /* @__PURE__ */ $aZSru.createElement("script", {
            ...scriptProps,
            suppressHydrationWarning: true,
            dangerouslySetInnerHTML: {
                __html: routeModulesScript
            },
            type: "module",
            async: true
        }));
    }, []);
    let preloads = $e17f0a7fb7c1208d$var$isHydrated || isRSCRouterContext ? [] : [
        ...new Set(manifest.entry.imports.concat((0, $8db8717086a501b5$export$442b9e023f41af00)(matches, manifest, {
            includeHydrateFallback: true
        })))
    ];
    let sri = typeof manifest.sri === "object" ? manifest.sri : {};
    (0, $ff197d758123498e$export$5b28268982f175ba)(!isRSCRouterContext, "The <Scripts /> element is a no-op when using RSC and can be safely removed.");
    return $e17f0a7fb7c1208d$var$isHydrated || isRSCRouterContext ? null : /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, typeof manifest.sri === "object" ? /* @__PURE__ */ $aZSru.createElement("script", {
        ...scriptProps,
        "rr-importmap": "",
        type: "importmap",
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: JSON.stringify({
                integrity: sri
            })
        }
    }) : null, !enableFogOfWar ? /* @__PURE__ */ $aZSru.createElement("link", {
        rel: "modulepreload",
        href: manifest.url,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.url],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }) : null, /* @__PURE__ */ $aZSru.createElement("link", {
        rel: "modulepreload",
        href: manifest.entry.module,
        crossOrigin: scriptProps.crossOrigin,
        integrity: sri[manifest.entry.module],
        nonce: scriptProps.nonce,
        suppressHydrationWarning: true
    }), preloads.map((path)=>/* @__PURE__ */ $aZSru.createElement("link", {
            key: path,
            rel: "modulepreload",
            href: path,
            crossOrigin: scriptProps.crossOrigin,
            integrity: sri[path],
            nonce: scriptProps.nonce,
            suppressHydrationWarning: true
        })), initialScripts);
}
function $e17f0a7fb7c1208d$export$c9058316764c140e(...refs) {
    return (value)=>{
        refs.forEach((ref)=>{
            if (typeof ref === "function") ref(value);
            else if (ref != null) ref.current = value;
        });
    };
}



var $aZSru = parcelRequire("aZSru");
//#region lib/dom/lib.tsx
const $69dc2b7fd4148745$var$isBrowser = typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined";
try {
    if ($69dc2b7fd4148745$var$isBrowser) window.__reactRouterVersion = "8";
} catch  {}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via [`history.pushState`](https://developer.mozilla.org/en-US/docs/Web/API/History/pushState)
* and [`history.replaceState`](https://developer.mozilla.org/en-US/docs/Web/API/History/replaceState).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $69dc2b7fd4148745$export$1f3f55432a00e06d(routes, opts) {
    return (0, $9915aeece4ba52df$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $072a56029499ae6c$export$719fc203c4e16dee)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $69dc2b7fd4148745$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f1195701c85e5ce2$export$6bc17138063be773),
        hydrationRouteProperties: $5b2f026c239847ab$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
/**
* Create a new {@link DataRouter| data router} that manages the application
* path via the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash).
*
* Data Routers should not be held in React state. You should create your router
* once outside of the React tree and pass it to {@link RouterProvider | `<RouterProvider>`}.
* You can use `patchRoutesOnNavigation` to add additional routes programmatically.
*
* @public
* @category Data Routers
* @mode data
* @param routes Application routes
* @param opts Options
* @param {DOMRouterOpts.basename} opts.basename n/a
* @param {DOMRouterOpts.future} opts.future n/a
* @param {DOMRouterOpts.getContext} opts.getContext n/a
* @param {DOMRouterOpts.hydrationData} opts.hydrationData n/a
* @param {DOMRouterOpts.instrumentations} opts.instrumentations n/a
* @param {DOMRouterOpts.dataStrategy} opts.dataStrategy n/a
* @param {DOMRouterOpts.patchRoutesOnNavigation} opts.patchRoutesOnNavigation n/a
* @param {DOMRouterOpts.window} opts.window n/a
* @returns An initialized {@link DataRouter| data router} to pass to {@link RouterProvider | `<RouterProvider>`}
*/ function $69dc2b7fd4148745$export$1ba7ed8a3a7b3765(routes, opts) {
    return (0, $9915aeece4ba52df$export$baddd0131ee8c05b)({
        basename: opts?.basename,
        getContext: opts?.getContext,
        future: opts?.future,
        history: (0, $072a56029499ae6c$export$b71fdd3798280242)({
            window: opts?.window
        }),
        hydrationData: opts?.hydrationData || $69dc2b7fd4148745$var$parseHydrationData(),
        routes: routes,
        mapRouteProperties: (0, $f1195701c85e5ce2$export$6bc17138063be773),
        hydrationRouteProperties: $5b2f026c239847ab$export$e2fd2c03906469db,
        dataStrategy: opts?.dataStrategy,
        patchRoutesOnNavigation: opts?.patchRoutesOnNavigation,
        window: opts?.window,
        instrumentations: opts?.instrumentations
    }).initialize();
}
function $69dc2b7fd4148745$var$parseHydrationData() {
    let state = window?.__staticRouterHydrationData;
    if (state && state.errors) state = {
        ...state,
        errors: $69dc2b7fd4148745$var$deserializeErrors(state.errors)
    };
    return state;
}
function $69dc2b7fd4148745$var$deserializeErrors(errors) {
    if (!errors) return null;
    let entries = Object.entries(errors);
    let serialized = {};
    for (let [key, val] of entries)if (val && val.__type === "RouteErrorResponse") serialized[key] = new (0, $f1195701c85e5ce2$export$f2680fa305b734ca)(val.status, val.statusText, val.data, val.internal === true);
    else if (val && val.__type === "Error") {
        if (typeof val.__subType === "string" && (0, $f1195701c85e5ce2$export$1a235bd2b33434e5).includes(val.__subType)) {
            let ErrorConstructor = window[val.__subType];
            if (typeof ErrorConstructor === "function") try {
                let error = new ErrorConstructor(val.message);
                error.stack = "";
                serialized[key] = error;
            } catch  {}
        }
        if (serialized[key] == null) {
            let error = new Error(val.message);
            error.stack = "";
            serialized[key] = error;
        }
    } else serialized[key] = val;
    return serialized;
}
/**
* A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {BrowserRouterProps.basename} props.basename n/a
* @param {BrowserRouterProps.children} props.children n/a
* @param {BrowserRouterProps.useTransitions} props.useTransitions n/a
* @param {BrowserRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* API for client-side routing.
*/ function $69dc2b7fd4148745$export$9ba4e89fdfa1fc54({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $aZSru.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $072a56029499ae6c$export$719fc203c4e16dee)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aZSru.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aZSru.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $aZSru.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $aZSru.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aZSru.createElement((0, $5b2f026c239847ab$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that stores the location in the
* [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash) portion
* of the URL so it is not sent to the server.
*
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HashRouterProps.basename} props.basename n/a
* @param {HashRouterProps.children} props.children n/a
* @param {HashRouterProps.useTransitions} props.useTransitions n/a
* @param {HashRouterProps.window} props.window n/a
* @returns A declarative {@link Router | `<Router>`} using the URL [`hash`](https://developer.mozilla.org/en-US/docs/Web/API/URL/hash)
* for client-side routing.
*/ function $69dc2b7fd4148745$export$7221d69dcfc8e36b({ basename: basename, children: children, useTransitions: useTransitions, window: window1 }) {
    let historyRef = $aZSru.useRef(null);
    if (historyRef.current == null) historyRef.current = (0, $072a56029499ae6c$export$b71fdd3798280242)({
        window: window1,
        v5Compat: true
    });
    let history = historyRef.current;
    let [state, setStateImpl] = $aZSru.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aZSru.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $aZSru.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $aZSru.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aZSru.createElement((0, $5b2f026c239847ab$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
/**
* A declarative {@link Router | `<Router>`} that accepts a pre-instantiated
* `history` object.
* It's important to note that using your own `history` object is highly discouraged
* and may add two versions of the `history` library to your bundles unless you use
* the same version of the `history` library that React Router uses internally.
*
* @name unstable_HistoryRouter
* @public
* @category Declarative Routers
* @mode declarative
* @param props Props
* @param {HistoryRouterProps.basename} props.basename n/a
* @param {HistoryRouterProps.children} props.children n/a
* @param {HistoryRouterProps.history} props.history n/a
* @param {HistoryRouterProps.useTransitions} props.useTransitions n/a
* @returns A declarative {@link Router | `<Router>`} using the provided history
* implementation for client-side routing.
*/ function $69dc2b7fd4148745$export$de73885c9336221c({ basename: basename, children: children, history: history, useTransitions: useTransitions }) {
    let [state, setStateImpl] = $aZSru.useState({
        action: history.action,
        location: history.location
    });
    let setState = $aZSru.useCallback((newState)=>{
        if (useTransitions === false) setStateImpl(newState);
        else $aZSru.startTransition(()=>setStateImpl(newState));
    }, [
        useTransitions
    ]);
    $aZSru.useLayoutEffect(()=>history.listen(setState), [
        history,
        setState
    ]);
    return /* @__PURE__ */ $aZSru.createElement((0, $5b2f026c239847ab$export$55185c17a0fcbe46), {
        basename: basename,
        children: children,
        location: state.location,
        navigationType: state.action,
        navigator: history,
        useTransitions: useTransitions
    });
}
$69dc2b7fd4148745$export$de73885c9336221c.displayName = "unstable_HistoryRouter";
/**
* A progressively enhanced [`<a href>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/a)
* wrapper to enable navigation with client-side routing.
*
* @example
* import { Link } from "react-router";
*
* <Link to="/dashboard">Dashboard</Link>;
*
* <Link
*   to={{
*     pathname: "/some/path",
*     search: "?query=string",
*     hash: "#hash",
*   }}
* />;
*
* @public
* @category Components
* @param {LinkProps.discover} props.discover [modes: framework] n/a
* @param {LinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {LinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {LinkProps.relative} props.relative n/a
* @param {LinkProps.reloadDocument} props.reloadDocument n/a
* @param {LinkProps.replace} props.replace n/a
* @param {LinkProps.state} props.state n/a
* @param {LinkProps.to} props.to n/a
* @param {LinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
* @param {LinkProps.defaultShouldRevalidate} props.defaultShouldRevalidate n/a
* @param {LinkProps.mask} props.mask [modes: framework, data] n/a
*/ const $69dc2b7fd4148745$export$a6c7ac8248d6e38a = $aZSru.forwardRef(function LinkWithRef({ onClick: onClick, discover: discover = "render", prefetch: prefetch = "none", relative: relative, reloadDocument: reloadDocument, replace: replace, mask: mask, state: state, target: target, to: to, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...rest }, forwardedRef) {
    let { basename: basename, navigator: navigator, useTransitions: useTransitions } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let isAbsolute = typeof to === "string" && (0, $d4078e32874468f1$export$6c52c2011d568bd0).test(to);
    let parsed = (0, $f1195701c85e5ce2$export$ac5aeb949e84fd96)(to, basename);
    to = parsed.to;
    let href = (0, $da3cac5a2aaa7b71$export$b66bb29c5006f12f)(to, {
        relative: relative
    });
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let maskedHref = null;
    if (mask) {
        let resolved = (0, $f1195701c85e5ce2$export$cae722b0cc860f13)(mask, [], location.mask ? location.mask.pathname : "/", true);
        if (basename !== "/") resolved.pathname = resolved.pathname === "/" ? basename : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
            basename,
            resolved.pathname
        ]);
        maskedHref = navigator.createHref(resolved);
    }
    let [shouldPrefetch, prefetchRef, prefetchHandlers] = (0, $e17f0a7fb7c1208d$export$6eb91431f5da407c)(prefetch, rest);
    let internalOnClick = $69dc2b7fd4148745$export$67621102c14d847(to, {
        replace: replace,
        mask: mask,
        state: state,
        target: target,
        preventScrollReset: preventScrollReset,
        relative: relative,
        viewTransition: viewTransition,
        defaultShouldRevalidate: defaultShouldRevalidate,
        useTransitions: useTransitions
    });
    function handleClick(event) {
        if (onClick) onClick(event);
        if (!event.defaultPrevented) internalOnClick(event);
    }
    let isSpaLink = !(parsed.isExternal || reloadDocument);
    let link = /* @__PURE__ */ $aZSru.createElement("a", {
        ...rest,
        ...prefetchHandlers,
        href: (isSpaLink ? maskedHref : void 0) || parsed.absoluteURL || href,
        onClick: isSpaLink ? handleClick : onClick,
        ref: (0, $e17f0a7fb7c1208d$export$c9058316764c140e)(forwardedRef, prefetchRef),
        target: target,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
    return shouldPrefetch && !isAbsolute ? /* @__PURE__ */ $aZSru.createElement($aZSru.Fragment, null, link, /* @__PURE__ */ $aZSru.createElement((0, $e17f0a7fb7c1208d$export$60dcec93e67386bd), {
        page: href
    })) : link;
});
$69dc2b7fd4148745$export$a6c7ac8248d6e38a.displayName = "Link";
/**
* Wraps {@link Link | `<Link>`} with additional props for styling active and
* pending states.
*
* - Automatically applies classes to the link based on its `active` and `pending`
* states, see {@link NavLinkProps.className}
*   - Note that `pending` is only available with Framework and Data modes.
* - Automatically applies `aria-current="page"` to the link when the link is active.
* See [`aria-current`](https://developer.mozilla.org/en-US/docs/Web/Accessibility/ARIA/Attributes/aria-current)
* on MDN.
* - States are additionally available through the className, style, and children
* render props. See {@link NavLinkRenderProps}.
*
* @example
* <NavLink to="/message">Messages</NavLink>
*
* // Using render props
* <NavLink
*   to="/messages"
*   className={({ isActive, isPending }) =>
*     isPending ? "pending" : isActive ? "active" : ""
*   }
* >
*   Messages
* </NavLink>
*
* @public
* @category Components
* @param {NavLinkProps.caseSensitive} props.caseSensitive n/a
* @param {NavLinkProps.children} props.children n/a
* @param {NavLinkProps.className} props.className n/a
* @param {NavLinkProps.discover} props.discover [modes: framework] n/a
* @param {NavLinkProps.end} props.end n/a
* @param {NavLinkProps.prefetch} props.prefetch [modes: framework] n/a
* @param {NavLinkProps.preventScrollReset} props.preventScrollReset [modes: framework, data] n/a
* @param {NavLinkProps.relative} props.relative n/a
* @param {NavLinkProps.reloadDocument} props.reloadDocument n/a
* @param {NavLinkProps.replace} props.replace n/a
* @param {NavLinkProps.state} props.state n/a
* @param {NavLinkProps.style} props.style n/a
* @param {NavLinkProps.to} props.to n/a
* @param {NavLinkProps.viewTransition} props.viewTransition [modes: framework, data] n/a
*/ const $69dc2b7fd4148745$export$b0d92dbee9b5b60d = $aZSru.forwardRef(function NavLinkWithRef({ "aria-current": ariaCurrentProp = "page", caseSensitive: caseSensitive = false, className: classNameProp = "", end: end = false, style: styleProp, to: to, viewTransition: viewTransition, children: children, ...rest }, ref) {
    let path = (0, $da3cac5a2aaa7b71$export$e75d2a2d1b3c245b)(to, {
        relative: rest.relative
    });
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let routerNavigation = $aZSru.useContext((0, $b71c75740e61495f$export$2473c5952c6a10d1));
    let { navigator: navigator, basename: basename } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let isTransitioning = routerNavigation != null && $69dc2b7fd4148745$export$e262bd1977bea848(path) && viewTransition === true;
    let toPathname = navigator.encodeLocation ? navigator.encodeLocation(path).pathname : path.pathname;
    let locationPathname = location.pathname;
    let nextLocationPathname = routerNavigation?.navigation.location ? routerNavigation.navigation.location.pathname : null;
    if (!caseSensitive) {
        locationPathname = locationPathname.toLowerCase();
        nextLocationPathname = nextLocationPathname ? nextLocationPathname.toLowerCase() : null;
        toPathname = toPathname.toLowerCase();
    }
    if (nextLocationPathname && basename) nextLocationPathname = (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(nextLocationPathname, basename) || nextLocationPathname;
    const endSlashPosition = toPathname !== "/" && toPathname.endsWith("/") ? toPathname.length - 1 : toPathname.length;
    let isActive = locationPathname === toPathname || !end && locationPathname.startsWith(toPathname) && locationPathname.charAt(endSlashPosition) === "/";
    let isPending = nextLocationPathname != null && (nextLocationPathname === toPathname || !end && nextLocationPathname.startsWith(toPathname) && nextLocationPathname.charAt(endSlashPosition) === "/");
    let renderProps = {
        isActive: isActive,
        isPending: isPending,
        isTransitioning: isTransitioning
    };
    let ariaCurrent = isActive ? ariaCurrentProp : void 0;
    let className;
    if (typeof classNameProp === "function") className = classNameProp(renderProps);
    else className = [
        classNameProp,
        isActive ? "active" : null,
        isPending ? "pending" : null,
        isTransitioning ? "transitioning" : null
    ].filter(Boolean).join(" ");
    let style = typeof styleProp === "function" ? styleProp(renderProps) : styleProp;
    return /* @__PURE__ */ $aZSru.createElement($69dc2b7fd4148745$export$a6c7ac8248d6e38a, {
        ...rest,
        "aria-current": ariaCurrent,
        className: className,
        ref: ref,
        style: style,
        to: to,
        viewTransition: viewTransition
    }, typeof children === "function" ? children(renderProps) : children);
});
$69dc2b7fd4148745$export$b0d92dbee9b5b60d.displayName = "NavLink";
/**
* A progressively enhanced HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form)
* that submits data to actions via [`fetch`](https://developer.mozilla.org/en-US/docs/Web/API/fetch),
* activating pending states in {@link useNavigation} which enables advanced
* user interfaces beyond a basic HTML [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form).
* After a form's `action` completes, all data on the page is automatically
* revalidated to keep the UI in sync with the data.
*
* Because it uses the HTML form API, server rendered pages are interactive at a
* basic level before JavaScript loads. Instead of React Router managing the
* submission, the browser manages the submission as well as the pending states
* (like the spinning favicon). After JavaScript loads, React Router takes over
* enabling web application user experiences.
*
* `Form` is most useful for submissions that should also change the URL or
* otherwise add an entry to the browser history stack. For forms that shouldn't
* manipulate the browser [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* stack, use {@link FetcherWithComponents.Form | `<fetcher.Form>`}.
*
* @example
* import { Form } from "react-router";
*
* function NewEvent() {
*   return (
*     <Form action="/events" method="post">
*       <input name="title" type="text" />
*       <input name="description" type="text" />
*     </Form>
*   );
* }
*
* @public
* @category Components
* @mode framework
* @mode data
* @param {FormProps.action} action n/a
* @param {FormProps.discover} discover n/a
* @param {FormProps.encType} encType n/a
* @param {FormProps.fetcherKey} fetcherKey n/a
* @param {FormProps.method} method n/a
* @param {FormProps.navigate} navigate n/a
* @param {FormProps.preventScrollReset} preventScrollReset n/a
* @param {FormProps.relative} relative n/a
* @param {FormProps.reloadDocument} reloadDocument n/a
* @param {FormProps.replace} replace n/a
* @param {FormProps.state} state n/a
* @param {FormProps.viewTransition} viewTransition n/a
* @param {FormProps.defaultShouldRevalidate} defaultShouldRevalidate n/a
* @returns A progressively enhanced [`<form>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/form) component
*/ const $69dc2b7fd4148745$export$a7fed597f4b8afd8 = $aZSru.forwardRef(({ discover: discover = "render", fetcherKey: fetcherKey, navigate: navigate, reloadDocument: reloadDocument, replace: replace, state: state, method: method = "get", action: action, onSubmit: onSubmit, relative: relative, preventScrollReset: preventScrollReset, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, ...props }, forwardedRef)=>{
    let { useTransitions: useTransitions } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let submit = $69dc2b7fd4148745$export$47c85c6e3a081d3();
    let formAction = $69dc2b7fd4148745$export$89a6bd6db0d97c56(action, {
        relative: relative
    });
    let formMethod = method.toLowerCase() === "get" ? "get" : "post";
    let isAbsolute = typeof action === "string" && (0, $d4078e32874468f1$export$6c52c2011d568bd0).test(action);
    let submitHandler = (event)=>{
        onSubmit && onSubmit(event);
        if (event.defaultPrevented) return;
        event.preventDefault();
        let submitter = event.nativeEvent.submitter;
        let submitMethod = submitter?.getAttribute("formmethod") || method;
        let doSubmit = ()=>submit(submitter || event.currentTarget, {
                fetcherKey: fetcherKey,
                method: submitMethod,
                navigate: navigate,
                replace: replace,
                state: state,
                relative: relative,
                preventScrollReset: preventScrollReset,
                viewTransition: viewTransition,
                defaultShouldRevalidate: defaultShouldRevalidate
            });
        if (useTransitions && navigate !== false) $aZSru.startTransition(()=>doSubmit());
        else doSubmit();
    };
    return /* @__PURE__ */ $aZSru.createElement("form", {
        ref: forwardedRef,
        method: formMethod,
        action: formAction,
        onSubmit: reloadDocument ? onSubmit : submitHandler,
        ...props,
        "data-discover": !isAbsolute && discover === "render" ? "true" : void 0
    });
});
$69dc2b7fd4148745$export$a7fed597f4b8afd8.displayName = "Form";
/**
* Emulates the browser's scroll restoration on location changes. Apps should only render one of these, right before the {@link Scripts} component.
*
* ```tsx
* import { ScrollRestoration } from "react-router";
*
* export default function Root() {
*   return (
*     <html>
*       <body>
*         <ScrollRestoration />
*         <Scripts />
*       </body>
*     </html>
*   );
* }
* ```
*
* This component renders an inline `<script>` to prevent scroll flashing. The
* `nonce` prop will be passed down to the script tag to allow CSP nonce usage.
* If not provided in Framework Mode, it will default to any
* {@link ServerRouter | `<ServerRouter nonce>`} prop.
*
* ```tsx
* <ScrollRestoration nonce={cspNonce} />
* ```
*
* @public
* @category Components
* @mode framework
* @mode data
* @param props Props
* @param {ScrollRestorationProps.getKey} props.getKey n/a
* @param {ScriptsProps.nonce} props.nonce n/a
* @param {ScrollRestorationProps.storageKey} props.storageKey n/a
* @returns A [`<script>`](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/script)
* tag that restores scroll positions on navigation.
*/ function $69dc2b7fd4148745$export$11aac1aab828f1fa({ getKey: getKey, storageKey: storageKey, ...props }) {
    let remixContext = $aZSru.useContext((0, $e17f0a7fb7c1208d$export$208d6a3bc3aa62bd));
    let { basename: basename } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let matches = (0, $da3cac5a2aaa7b71$export$2378eb7f5ff86053)();
    $69dc2b7fd4148745$export$c4ffdfe23dd48040({
        getKey: getKey,
        storageKey: storageKey
    });
    let ssrKey = $aZSru.useMemo(()=>{
        if (!remixContext || !getKey) return null;
        let userKey = $69dc2b7fd4148745$var$getScrollRestorationKey(location, matches, basename, getKey);
        return userKey !== location.key ? userKey : null;
    }, []);
    if (!remixContext || remixContext.isSpaMode) return null;
    let restoreScroll = ((storageKey, restoreKey)=>{
        if (!window.history.state || !window.history.state.key) {
            let key = Math.random().toString(32).slice(2);
            window.history.replaceState({
                key: key
            }, "");
        }
        try {
            let storedY = JSON.parse(sessionStorage.getItem(storageKey) || "{}")[restoreKey || window.history.state.key];
            if (typeof storedY === "number") window.scrollTo(0, storedY);
        } catch (error) {
            console.error(error);
            sessionStorage.removeItem(storageKey);
        }
    }).toString();
    if (props.nonce == null && remixContext?.nonce) props.nonce = remixContext.nonce;
    return /* @__PURE__ */ $aZSru.createElement("script", {
        ...props,
        suppressHydrationWarning: true,
        dangerouslySetInnerHTML: {
            __html: `(${restoreScroll})(${(0, $3a95c051359f4bfb$export$4cf11838cdc2a8a8)(JSON.stringify(storageKey || $69dc2b7fd4148745$var$SCROLL_RESTORATION_STORAGE_KEY))}, ${(0, $3a95c051359f4bfb$export$4cf11838cdc2a8a8)(JSON.stringify(ssrKey))})`
        }
    });
}
$69dc2b7fd4148745$export$11aac1aab828f1fa.displayName = "ScrollRestoration";
/**
* Handles the click behavior for router {@link Link | `<Link>`} components.This
* is useful if you need to create custom {@link Link | `<Link>`} components with
* the same click behavior we use in our exported {@link Link | `<Link>`}.
*
* @public
* @category Hooks
* @param to The URL to navigate to, can be a string or a partial {@link Path}.
* @param options Options
* @param options.preventScrollReset Whether to prevent the scroll position from
* being reset to the top of the viewport on completion of the navigation when
* using the {@link ScrollRestoration} component. Defaults to `false`.
* @param options.relative The {@link RelativeRoutingType | relative routing type}
* to use for the link. Defaults to `"route"`.
* @param options.replace Whether to replace the current [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry instead of pushing a new one. Defaults to `false`.
* @param options.state The state to add to the [`History`](https://developer.mozilla.org/en-US/docs/Web/API/History)
* entry for this navigation. Defaults to `undefined`.
* @param options.target The target attribute for the link. Defaults to `undefined`.
* @param options.viewTransition Enables a [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* for this navigation. To apply specific styles during the transition, see
* {@link useViewTransitionState}. Defaults to `false`.
* @param options.defaultShouldRevalidate Specify the default revalidation
* behavior for the navigation. When not specified, loaders revalidate
* according to the router's standard revalidation behavior.
* @param options.mask Masked location to display in the browser instead
* of the router location. Defaults to `undefined`.
* @param options.useTransitions Wraps the navigation in
* [`React.startTransition`](https://react.dev/reference/react/startTransition)
* for concurrent rendering. Defaults to `false`.
* @returns A click handler function that can be used in a custom {@link Link} component.
*/ function $69dc2b7fd4148745$export$67621102c14d847(to, { target: target, replace: replaceProp, mask: mask, state: state, preventScrollReset: preventScrollReset, relative: relative, viewTransition: viewTransition, defaultShouldRevalidate: defaultShouldRevalidate, useTransitions: useTransitions } = {}) {
    let navigate = (0, $da3cac5a2aaa7b71$export$9770f232ac06a008)();
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let path = (0, $da3cac5a2aaa7b71$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    return $aZSru.useCallback((event)=>{
        if ((0, $4dd09bbb5ef36460$export$4c2d35dce1b682e)(event, target)) {
            event.preventDefault();
            let replace = replaceProp !== void 0 ? replaceProp : (0, $072a56029499ae6c$export$fe53371bee54353d)(location) === (0, $072a56029499ae6c$export$fe53371bee54353d)(path);
            let doNavigate = ()=>navigate(to, {
                    replace: replace,
                    mask: mask,
                    state: state,
                    preventScrollReset: preventScrollReset,
                    relative: relative,
                    viewTransition: viewTransition,
                    defaultShouldRevalidate: defaultShouldRevalidate
                });
            if (useTransitions) $aZSru.startTransition(()=>doNavigate());
            else doNavigate();
        }
    }, [
        location,
        navigate,
        path,
        replaceProp,
        mask,
        state,
        target,
        to,
        preventScrollReset,
        relative,
        viewTransition,
        defaultShouldRevalidate,
        useTransitions
    ]);
}
/**
* Returns a tuple of the current URL's [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them. Setting the search params causes a navigation.
*
* ```tsx
* import { useSearchParams } from "react-router";
*
* export function SomeComponent() {
*   const [searchParams, setSearchParams] = useSearchParams();
*   // ...
* }
* ```
*
* ### `setSearchParams` function
*
* The second element of the tuple is a function that can be used to update the
* search params. It accepts the same types as `defaultInit` and will cause a
* navigation to the new URL.
*
* ```tsx
* let [searchParams, setSearchParams] = useSearchParams();
*
* // a search param string
* setSearchParams("?tab=1");
*
* // a shorthand object
* setSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* setSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* setSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* setSearchParams(new URLSearchParams("?tab=1"));
* ```
*
* It also supports a function callback like React's
* [`setState`](https://react.dev/reference/react/useState#setstate):
*
* ```tsx
* setSearchParams((searchParams) => {
*   searchParams.set("tab", "2");
*   return searchParams;
* });
* ```
*
* <docs-warning>The function callback version of `setSearchParams` does not support
* the [queueing](https://react.dev/reference/react/useState#setstate-parameters)
* logic that React's `setState` implements.  Multiple calls to `setSearchParams`
* in the same tick will not build on the prior value.  If you need this behavior,
* you can use `setState` manually.</docs-warning>
*
* ### Notes
*
* Note that `searchParams` is a stable reference, so you can reliably use it
* as a dependency in React's [`useEffect`](https://react.dev/reference/react/useEffect)
* hooks.
*
* ```tsx
* useEffect(() => {
*   console.log(searchParams.get("tab"));
* }, [searchParams]);
* ```
*
* However, this also means it's mutable. If you change the object without
* calling `setSearchParams`, its values will change between renders if some
* other state causes the component to re-render and URL will not reflect the
* values.
*
* @public
* @category Hooks
* @param defaultInit
* You can initialize the search params with a default value, though it **will
* not** change the URL on the first render.
*
* ```tsx
* // a search param string
* useSearchParams("?tab=1");
*
* // a shorthand object
* useSearchParams({ tab: "1" });
*
* // object keys can be arrays for multiple values on the key
* useSearchParams({ brand: ["nike", "reebok"] });
*
* // an array of tuples
* useSearchParams([["tab", "1"]]);
*
* // a `URLSearchParams` object
* useSearchParams(new URLSearchParams("?tab=1"));
* ```
* @returns A tuple of the current [`URLSearchParams`](https://developer.mozilla.org/en-US/docs/Web/API/URLSearchParams)
* and a function to update them.
*/ function $69dc2b7fd4148745$export$f1a78c17382fe22a(defaultInit) {
    (0, $072a56029499ae6c$export$491112666e282270)(typeof URLSearchParams !== "undefined", "You cannot use the `useSearchParams` hook in a browser that does not support the URLSearchParams API. If you need to support Internet Explorer 11, we recommend you load a polyfill such as https://github.com/ungap/url-search-params.");
    let defaultSearchParamsRef = $aZSru.useRef((0, $4dd09bbb5ef36460$export$a2e4e2dcc7b1f22f)(defaultInit));
    let hasSetSearchParamsRef = $aZSru.useRef(false);
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let searchParams = $aZSru.useMemo(()=>(0, $4dd09bbb5ef36460$export$4370c962fe3096e6)(location.search, hasSetSearchParamsRef.current ? null : defaultSearchParamsRef.current), [
        location.search
    ]);
    let navigate = (0, $da3cac5a2aaa7b71$export$9770f232ac06a008)();
    return [
        searchParams,
        $aZSru.useCallback((nextInit, navigateOptions)=>{
            const newSearchParams = (0, $4dd09bbb5ef36460$export$a2e4e2dcc7b1f22f)(typeof nextInit === "function" ? nextInit(new URLSearchParams(searchParams)) : nextInit);
            hasSetSearchParamsRef.current = true;
            navigate("?" + newSearchParams, navigateOptions);
        }, [
            navigate,
            searchParams
        ])
    ];
}
let $69dc2b7fd4148745$var$fetcherId = 0;
let $69dc2b7fd4148745$var$getUniqueFetcherId = ()=>`__${String(++$69dc2b7fd4148745$var$fetcherId)}__`;
/**
* The imperative version of {@link Form | `<Form>`} that lets you submit a form
* from code instead of a user interaction.
*
* @example
* import { useSubmit } from "react-router";
*
* function SomeComponent() {
*   const submit = useSubmit();
*   return (
*     <Form onChange={(event) => submit(event.currentTarget)} />
*   );
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns A function that can be called to submit a {@link Form} imperatively.
*/ function $69dc2b7fd4148745$export$47c85c6e3a081d3() {
    let { router: router } = (0, $da3cac5a2aaa7b71$export$ae09415e57d46628)("useSubmit");
    let { basename: basename } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let currentRouteId = (0, $da3cac5a2aaa7b71$export$501a3f562d56eac6)("useSubmit");
    let routerFetch = router.fetch;
    let routerNavigate = router.navigate;
    return $aZSru.useCallback(async (target, options = {})=>{
        let { action: action, method: method, encType: encType, formData: formData, body: body } = (0, $4dd09bbb5ef36460$export$80917616746b9ab4)(target, basename);
        if (options.navigate === false) await routerFetch(options.fetcherKey || $69dc2b7fd4148745$var$getUniqueFetcherId(), currentRouteId, options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            flushSync: options.flushSync
        });
        else await routerNavigate(options.action || action, {
            defaultShouldRevalidate: options.defaultShouldRevalidate,
            preventScrollReset: options.preventScrollReset,
            relative: options.relative,
            formData: formData,
            body: body,
            formMethod: options.method || method,
            formEncType: options.encType || encType,
            replace: options.replace,
            state: options.state,
            fromRouteId: currentRouteId,
            flushSync: options.flushSync,
            viewTransition: options.viewTransition
        });
    }, [
        routerFetch,
        routerNavigate,
        basename,
        currentRouteId
    ]);
}
/**
* Resolves the URL to the closest route in the component hierarchy instead of
* the current URL of the app.
*
* This is used internally by {@link Form} to resolve the `action` to the closest
* route, but can be used generically as well.
*
* ```ts
* import { useFormAction } from "react-router";
*
* function SomeComponent() {
*   // closest route URL
*   let action = useFormAction();
*
*   // closest route URL + "destroy"
*   let destroyAction = useFormAction("destroy");
* }
* ```
*
* <docs-info>This hook adds a `basename` if your app specifies one, so that it
* can be used with raw `<form>` elements in a progressively enhanced way.  If
* you are using this to provide an `action` to `<Form>` or `fetcher.submit`, you
* will need to remove the `basename` since both of those will prepend it
* internally.</docs-info>
*
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param action The action to append to the closest route URL. Defaults to the
* closest route URL.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* action. Defaults to `"route"`.
* @returns The resolved action URL.
*/ function $69dc2b7fd4148745$export$89a6bd6db0d97c56(action, { relative: relative } = {}) {
    let { basename: basename } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let routeContext = $aZSru.useContext((0, $b71c75740e61495f$export$aac280ed165a4397));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(routeContext, "useFormAction must be used inside a RouteContext");
    let [match] = routeContext.matches.slice(-1);
    let path = {
        ...(0, $da3cac5a2aaa7b71$export$e75d2a2d1b3c245b)(action ? action : ".", {
            relative: relative
        })
    };
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    if (action == null) {
        path.search = location.search;
        let params = new URLSearchParams(path.search);
        let indexValues = params.getAll("index");
        if (indexValues.some((v)=>v === "")) {
            params.delete("index");
            indexValues.filter((v)=>v).forEach((v)=>params.append("index", v));
            let qs = params.toString();
            path.search = qs ? `?${qs}` : "";
        }
    }
    if ((!action || action === ".") && match.route.index) path.search = path.search ? path.search.replace(/^\?/, "?index&") : "?index";
    if (basename !== "/") path.pathname = path.pathname === "/" ? basename : (0, $f1195701c85e5ce2$export$86d9a7913e44197e)([
        basename,
        path.pathname
    ]);
    return (0, $072a56029499ae6c$export$fe53371bee54353d)(path);
}
/**
* Useful for creating complex, dynamic user interfaces that require multiple,
* concurrent data interactions without causing a navigation.
*
* Fetchers track their own, independent state and can be used to load data, submit
* forms, and generally interact with [`action`](../../start/framework/route-module#action)
* and [`loader`](../../start/framework/route-module#loader) functions.
*
* @example
* import { useFetcher } from "react-router"
*
* function SomeComponent() {
*   let fetcher = useFetcher()
*
*   // states are available on the fetcher
*   fetcher.state // "idle" | "loading" | "submitting"
*   fetcher.data // the data returned from the action or loader
*
*   // render a form
*   <fetcher.Form method="post" />
*
*   // load data
*   fetcher.load("/some/route")
*
*   // submit data
*   fetcher.submit(someFormRef, { method: "post" })
*   fetcher.submit(someData, {
*     method: "post",
*     encType: "application/json"
*   })
*
*   // reset fetcher
*   fetcher.reset()
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.key A unique key to identify the fetcher.
*
*
* By default, `useFetcher` generates a unique fetcher scoped to that component.
* If you want to identify a fetcher with your own key such that you can access
* it from elsewhere in your app, you can do that with the `key` option:
*
* ```tsx
* function SomeComp() {
*   let fetcher = useFetcher({ key: "my-key" })
*   // ...
* }
*
* // Somewhere else
* function AnotherComp() {
*   // this will be the same fetcher, sharing the state across the app
*   let fetcher = useFetcher({ key: "my-key" });
*   // ...
* }
* ```
* @returns A {@link FetcherWithComponents} object that contains the fetcher's state, data, and components for submitting forms and loading data.
*/ function $69dc2b7fd4148745$export$5b0d2d9a9921565a({ key: key } = {}) {
    let { router: router } = (0, $da3cac5a2aaa7b71$export$ae09415e57d46628)("useFetcher");
    let fetchersContext = (0, $da3cac5a2aaa7b71$export$c6e4e4d7047d4ffe)("useFetcher");
    let routeId = (0, $da3cac5a2aaa7b71$export$501a3f562d56eac6)("useFetcher");
    let defaultKey = $aZSru.useId();
    let [fetcherKey, setFetcherKey] = $aZSru.useState(key || defaultKey);
    if (key && key !== fetcherKey) setFetcherKey(key);
    let { deleteFetcher: deleteFetcher, getFetcher: getFetcher, resetFetcher: resetFetcher, fetch: routerFetch } = router;
    $aZSru.useEffect(()=>{
        getFetcher(fetcherKey);
        return ()=>deleteFetcher(fetcherKey);
    }, [
        deleteFetcher,
        getFetcher,
        fetcherKey
    ]);
    let load = $aZSru.useCallback(async (href, opts)=>{
        (0, $072a56029499ae6c$export$f5708dca728d7177)(routeId, "No routeId available for fetcher.load()");
        await routerFetch(fetcherKey, routeId, href, opts);
    }, [
        fetcherKey,
        routeId,
        routerFetch
    ]);
    let submitImpl = $69dc2b7fd4148745$export$47c85c6e3a081d3();
    let submit = $aZSru.useCallback(async (target, opts)=>{
        await submitImpl(target, {
            ...opts,
            navigate: false,
            fetcherKey: fetcherKey
        });
    }, [
        fetcherKey,
        submitImpl
    ]);
    let reset = $aZSru.useCallback((opts)=>resetFetcher(fetcherKey, opts), [
        resetFetcher,
        fetcherKey
    ]);
    let FetcherForm = $aZSru.useMemo(()=>{
        let FetcherForm = $aZSru.forwardRef((props, ref)=>{
            return /* @__PURE__ */ $aZSru.createElement($69dc2b7fd4148745$export$a7fed597f4b8afd8, {
                ...props,
                navigate: false,
                fetcherKey: fetcherKey,
                ref: ref
            });
        });
        FetcherForm.displayName = "fetcher.Form";
        return FetcherForm;
    }, [
        fetcherKey
    ]);
    let fetcher = fetchersContext.fetchers.get(fetcherKey) || (0, $9915aeece4ba52df$export$52eace9c284d3585);
    let data = fetchersContext.fetcherData.get(fetcherKey);
    return $aZSru.useMemo(()=>({
            Form: FetcherForm,
            submit: submit,
            load: load,
            reset: reset,
            ...fetcher,
            data: data
        }), [
        FetcherForm,
        submit,
        load,
        reset,
        fetcher,
        data
    ]);
}
/**
* Returns an array of all in-flight {@link Fetcher}s. This is useful for components
* throughout the app that didn't create the fetchers but want to use their submissions
* to participate in optimistic UI.
*
* @example
* import { useFetchers } from "react-router";
*
* function SomeComponent() {
*   const fetchers = useFetchers();
*   fetchers[0].formData; // FormData
*   fetchers[0].state; // etc.
*   // ...
* }
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @returns An array of all in-flight {@link Fetcher}s, each with a unique `key`
* property.
*/ function $69dc2b7fd4148745$export$fa996778a3a31087() {
    let { fetchers: fetchers } = (0, $da3cac5a2aaa7b71$export$c6e4e4d7047d4ffe)("useFetchers");
    return $aZSru.useMemo(()=>Array.from(fetchers.entries()).map(([key, fetcher])=>({
                ...fetcher,
                key: key
            })), [
        fetchers
    ]);
}
const $69dc2b7fd4148745$var$SCROLL_RESTORATION_STORAGE_KEY = "react-router-scroll-positions";
let $69dc2b7fd4148745$var$savedScrollPositions = {};
function $69dc2b7fd4148745$var$getScrollRestorationKey(location, matches, basename, getKey) {
    let key = null;
    if (getKey) {
        if (basename !== "/") key = getKey({
            ...location,
            pathname: (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(location.pathname, basename) || location.pathname
        }, matches);
        else key = getKey(location, matches);
    }
    if (key == null) key = location.key;
    return key;
}
/**
* When rendered inside a {@link RouterProvider}, will restore scroll positions
* on navigations
*
* <!--
* Not marked `@public` because we only export as UNSAFE_ and therefore we don't
* maintain an .md file for this hook
* -->
*
* @name UNSAFE_useScrollRestoration
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.getKey A function that returns a key to use for scroll restoration.
* This is useful for custom scroll restoration logic, such as using only the pathname
* so that subsequent navigations to prior paths will restore the scroll. Defaults
* to `location.key`.
* @param options.storageKey The key to use for storing scroll positions in
* `sessionStorage`. Defaults to `"react-router-scroll-positions"`.
* @returns {void}
*/ function $69dc2b7fd4148745$export$c4ffdfe23dd48040({ getKey: getKey, storageKey: storageKey } = {}) {
    let { router: router } = (0, $da3cac5a2aaa7b71$export$ae09415e57d46628)("useScrollRestoration");
    let { restoreScrollPosition: restoreScrollPosition, preventScrollReset: preventScrollReset } = (0, $da3cac5a2aaa7b71$export$f93124018767f269)("useScrollRestoration");
    let { basename: basename } = $aZSru.useContext((0, $b71c75740e61495f$export$3044ab7fdabeaee6));
    let location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    let matches = (0, $da3cac5a2aaa7b71$export$2378eb7f5ff86053)();
    let navigation = (0, $da3cac5a2aaa7b71$export$d0fd4b7106de2769)();
    $aZSru.useEffect(()=>{
        window.history.scrollRestoration = "manual";
        return ()=>{
            window.history.scrollRestoration = "auto";
        };
    }, []);
    $69dc2b7fd4148745$var$usePageShow($aZSru.useCallback((event)=>{
        if (event.persisted) window.history.scrollRestoration = "manual";
    }, []));
    $69dc2b7fd4148745$var$usePageHide($aZSru.useCallback(()=>{
        if (navigation.state === "idle") {
            let key = $69dc2b7fd4148745$var$getScrollRestorationKey(location, matches, basename, getKey);
            $69dc2b7fd4148745$var$savedScrollPositions[key] = window.scrollY;
        }
        try {
            sessionStorage.setItem(storageKey || $69dc2b7fd4148745$var$SCROLL_RESTORATION_STORAGE_KEY, JSON.stringify($69dc2b7fd4148745$var$savedScrollPositions));
        } catch (error) {
            (0, $072a56029499ae6c$export$491112666e282270)(false, `Failed to save scroll positions in sessionStorage, <ScrollRestoration /> will not work properly (${error}).`);
        }
        window.history.scrollRestoration = "auto";
    }, [
        navigation.state,
        getKey,
        basename,
        location,
        matches,
        storageKey
    ]));
    if (typeof document !== "undefined") {
        $aZSru.useLayoutEffect(()=>{
            try {
                let sessionPositions = sessionStorage.getItem(storageKey || $69dc2b7fd4148745$var$SCROLL_RESTORATION_STORAGE_KEY);
                if (sessionPositions) $69dc2b7fd4148745$var$savedScrollPositions = JSON.parse(sessionPositions);
            } catch  {}
        }, [
            storageKey
        ]);
        $aZSru.useLayoutEffect(()=>{
            let disableScrollRestoration = router?.enableScrollRestoration($69dc2b7fd4148745$var$savedScrollPositions, ()=>window.scrollY, getKey ? (location, matches)=>$69dc2b7fd4148745$var$getScrollRestorationKey(location, matches, basename, getKey) : void 0);
            return ()=>disableScrollRestoration && disableScrollRestoration();
        }, [
            router,
            basename,
            getKey
        ]);
        $aZSru.useLayoutEffect(()=>{
            if (restoreScrollPosition === false) return;
            if (typeof restoreScrollPosition === "number") {
                window.scrollTo(0, restoreScrollPosition);
                return;
            }
            try {
                if (location.hash) {
                    let el = document.getElementById(decodeURIComponent(location.hash.slice(1)));
                    if (el) {
                        el.scrollIntoView();
                        return;
                    }
                }
            } catch  {
                (0, $072a56029499ae6c$export$491112666e282270)(false, `"${location.hash.slice(1)}" is not a decodable element ID. The view will not scroll to it.`);
            }
            if (preventScrollReset === true) return;
            window.scrollTo(0, 0);
        }, [
            location,
            restoreScrollPosition,
            preventScrollReset
        ]);
    }
}
/**
* Set up a callback to be fired on [Window's `beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event).
*
* @public
* @category Hooks
* @param callback The callback to be called when the [`beforeunload` event](https://developer.mozilla.org/en-US/docs/Web/API/Window/beforeunload_event)
* is fired.
* @param options Options
* @param options.capture If `true`, the event will be captured during the capture
* phase. Defaults to `false`.
* @returns {void}
*/ function $69dc2b7fd4148745$export$c0a586b329cae57d(callback, options) {
    let { capture: capture } = options || {};
    $aZSru.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("beforeunload", callback, opts);
        return ()=>{
            window.removeEventListener("beforeunload", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $69dc2b7fd4148745$var$usePageHide(callback, options) {
    let { capture: capture } = options || {};
    $aZSru.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pagehide", callback, opts);
        return ()=>{
            window.removeEventListener("pagehide", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
function $69dc2b7fd4148745$var$usePageShow(callback, options) {
    let { capture: capture } = options || {};
    $aZSru.useEffect(()=>{
        let opts = capture != null ? {
            capture: capture
        } : void 0;
        window.addEventListener("pageshow", callback, opts);
        return ()=>{
            window.removeEventListener("pageshow", callback, opts);
        };
    }, [
        callback,
        capture
    ]);
}
/**
* Wrapper around {@link useBlocker} to show a [`window.confirm`](https://developer.mozilla.org/en-US/docs/Web/API/Window/confirm)
* prompt to users instead of building a custom UI with {@link useBlocker}.
*
* The `unstable_` flag will not be removed because this technique has a lot of
* rough edges and behaves very differently (and incorrectly sometimes) across
* browsers if users click addition back/forward navigations while the
* confirmation is open. Use at your own risk.
*
* @example
* function ImportantForm() {
*   let [value, setValue] = React.useState("");
*
*   // Block navigating elsewhere when data has been entered into the input
*   unstable_usePrompt({
*     message: "Are you sure?",
*     when: ({ currentLocation, nextLocation }) =>
*       value !== "" &&
*       currentLocation.pathname !== nextLocation.pathname,
*   });
*
*   return (
*     <Form method="post">
*       <label>
*         Enter some important data:
*         <input
*           name="data"
*           value={value}
*           onChange={(e) => setValue(e.target.value)}
*         />
*       </label>
*       <button type="submit">Save</button>
*     </Form>
*   );
* }
*
* @name unstable_usePrompt
* @public
* @category Hooks
* @mode framework
* @mode data
* @param options Options
* @param options.message The message to show in the confirmation dialog.
* @param options.when A boolean or a function that returns a boolean indicating
* whether to block the navigation. If a function is provided, it will receive an
* object with `currentLocation` and `nextLocation` properties.
* @returns {void}
*/ function $69dc2b7fd4148745$export$fc7731b33eb53a93({ when: when, message: message }) {
    let blocker = (0, $da3cac5a2aaa7b71$export$b273b3273281a049)(when);
    $aZSru.useEffect(()=>{
        if (blocker.state === "blocked") {
            if (window.confirm(message)) setTimeout(blocker.proceed, 0);
            else blocker.reset();
        }
    }, [
        blocker,
        message
    ]);
    $aZSru.useEffect(()=>{
        if (blocker.state === "blocked" && !when) blocker.reset();
    }, [
        blocker,
        when
    ]);
}
/**
* This hook returns `true` when there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the specified location matches either side of the navigation (the URL you are
* navigating **to** or the URL you are navigating **from**). This can be used to apply finer-grained styles to
* elements to further customize the view transition. This requires that view
* transitions have been enabled for the given navigation via {@link LinkProps.viewTransition}
* (or the `Form`, `submit`, or `navigate` call)
*
* @public
* @category Hooks
* @mode framework
* @mode data
* @param to The {@link To} location to compare against the active transition's current
* and next URLs.
* @param options Options
* @param options.relative The relative routing type to use when resolving the
* `to` location, defaults to `"route"`. See {@link RelativeRoutingType} for
* more details.
* @returns `true` if there is an active [View Transition](https://developer.mozilla.org/en-US/docs/Web/API/View_Transitions_API)
* and the resolved path matches the transition's destination or source pathname, otherwise `false`.
*/ function $69dc2b7fd4148745$export$e262bd1977bea848(to, { relative: relative } = {}) {
    let vtContext = $aZSru.useContext((0, $b71c75740e61495f$export$3681f408decb40d1));
    (0, $072a56029499ae6c$export$f5708dca728d7177)(vtContext != null, "`useViewTransitionState` must be used within `react-router/dom`'s `RouterProvider`.  Did you accidentally import `RouterProvider` from `react-router`?");
    let { basename: basename } = (0, $da3cac5a2aaa7b71$export$ae09415e57d46628)("useViewTransitionState");
    let path = (0, $da3cac5a2aaa7b71$export$e75d2a2d1b3c245b)(to, {
        relative: relative
    });
    if (!vtContext.isTransitioning) return false;
    let currentPath = (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(vtContext.currentLocation.pathname, basename) || vtContext.currentLocation.pathname;
    let nextPath = (0, $f1195701c85e5ce2$export$b69e3301ce081aa3)(vtContext.nextLocation.pathname, basename) || vtContext.nextLocation.pathname;
    return (0, $f1195701c85e5ce2$export$81336c211d5ff295)(path.pathname, nextPath) != null || (0, $f1195701c85e5ce2$export$81336c211d5ff295)(path.pathname, currentPath) != null;
}



parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");

const $3afdd3e5f726b03e$var$_excluded = [
    "as",
    "disabled"
];
function $3afdd3e5f726b03e$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $3afdd3e5f726b03e$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
function $3afdd3e5f726b03e$export$a0ee72f2c720a5c3({ tagName: tagName, disabled: disabled, href: href, target: target, rel: rel, role: role, onClick: onClick, tabIndex: tabIndex = 0, type: type }) {
    if (!tagName) {
        if (href != null || target != null || rel != null) tagName = 'a';
        else tagName = 'button';
    }
    const meta = {
        tagName: tagName
    };
    if (tagName === 'button') return [
        {
            type: type || 'button',
            disabled: disabled
        },
        meta
    ];
    const handleClick = (event)=>{
        if (disabled || tagName === 'a' && $3afdd3e5f726b03e$export$72369ab2cc99204b(href)) event.preventDefault();
        if (disabled) {
            event.stopPropagation();
            return;
        }
        onClick == null || onClick(event);
    };
    const handleKeyDown = (event)=>{
        if (event.key === ' ') {
            event.preventDefault();
            handleClick(event);
        }
    };
    if (tagName === 'a') {
        // Ensure there's a href so Enter can trigger anchor button.
        href || (href = '#');
        if (disabled) href = undefined;
    }
    return [
        {
            role: role != null ? role : 'button',
            // explicitly undefined so that it overrides the props disabled in a spread
            // e.g. <Tag {...props} {...hookProps} />
            disabled: undefined,
            tabIndex: disabled ? undefined : tabIndex,
            href: href,
            target: tagName === 'a' ? target : undefined,
            'aria-disabled': !disabled ? undefined : disabled,
            rel: tagName === 'a' ? rel : undefined,
            onClick: handleClick,
            onKeyDown: handleKeyDown
        },
        meta
    ];
}
const $3afdd3e5f726b03e$var$Button = /*#__PURE__*/ $aZSru.forwardRef((_ref, ref)=>{
    let { as: asProp, disabled: disabled } = _ref, props = $3afdd3e5f726b03e$var$_objectWithoutPropertiesLoose(_ref, $3afdd3e5f726b03e$var$_excluded);
    const [buttonProps, { tagName: Component }] = $3afdd3e5f726b03e$export$a0ee72f2c720a5c3(Object.assign({
        tagName: asProp,
        disabled: disabled
    }, props));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, Object.assign({}, props, buttonProps, {
        ref: ref
    }));
});
$3afdd3e5f726b03e$var$Button.displayName = 'Button';
var $3afdd3e5f726b03e$export$2e2bcd8739ae039 = $3afdd3e5f726b03e$var$Button;




"use client";
const $125bc3f756529a6e$var$Button = /*#__PURE__*/ $aZSru.forwardRef(({ as: as, bsPrefix: bsPrefix, variant: variant = 'primary', size: size, active: active = false, disabled: disabled = false, className: className, ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'btn');
    const [buttonProps, { tagName: tagName }] = (0, $3afdd3e5f726b03e$export$a0ee72f2c720a5c3)({
        tagName: as,
        disabled: disabled,
        ...props
    });
    const Component = tagName;
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...buttonProps,
        ...props,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, prefix, active && 'active', variant && `${prefix}-${variant}`, size && `${prefix}-${size}`, props.href && disabled && 'disabled')
    });
});
$125bc3f756529a6e$var$Button.displayName = 'Button';
var $125bc3f756529a6e$export$2e2bcd8739ae039 = $125bc3f756529a6e$var$Button;



/* eslint-disable no-return-assign */ var $d74d83caf9feb6ec$export$2e2bcd8739ae039 = !!(typeof window !== 'undefined' && window.document && window.document.createElement);


var $eeb6ca5e41ee8cd7$export$63fefd044b2bc624 = false;
var $eeb6ca5e41ee8cd7$export$a614c6b395900f69 = false;
try {
    var $eeb6ca5e41ee8cd7$var$options = {
        get passive () {
            return $eeb6ca5e41ee8cd7$export$63fefd044b2bc624 = true;
        },
        get once () {
            // eslint-disable-next-line no-multi-assign
            return $eeb6ca5e41ee8cd7$export$a614c6b395900f69 = $eeb6ca5e41ee8cd7$export$63fefd044b2bc624 = true;
        }
    };
    if (0, $d74d83caf9feb6ec$export$2e2bcd8739ae039) {
        window.addEventListener('test', $eeb6ca5e41ee8cd7$var$options, $eeb6ca5e41ee8cd7$var$options);
        window.removeEventListener('test', $eeb6ca5e41ee8cd7$var$options, true);
    }
} catch (e) {
/* */ }
/**
 * An `addEventListener` ponyfill, supports the `once` option
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $eeb6ca5e41ee8cd7$var$addEventListener(node, eventName, handler, options) {
    if (options && typeof options !== 'boolean' && !$eeb6ca5e41ee8cd7$export$a614c6b395900f69) {
        var once = options.once, capture = options.capture;
        var wrappedHandler = handler;
        if (!$eeb6ca5e41ee8cd7$export$a614c6b395900f69 && once) {
            wrappedHandler = handler.__once || function onceHandler(event) {
                this.removeEventListener(eventName, onceHandler, capture);
                handler.call(this, event);
            };
            handler.__once = wrappedHandler;
        }
        node.addEventListener(eventName, wrappedHandler, $eeb6ca5e41ee8cd7$export$63fefd044b2bc624 ? options : capture);
    }
    node.addEventListener(eventName, handler, options);
}
var $eeb6ca5e41ee8cd7$export$2e2bcd8739ae039 = $eeb6ca5e41ee8cd7$var$addEventListener;



/**
 * Returns the owner document of a given element.
 * 
 * @param node the element
 */ function $0948e8b135437cc0$export$2e2bcd8739ae039(node) {
    return node && node.ownerDocument || document;
}


/**
 * A `removeEventListener` ponyfill
 * 
 * @param node the element
 * @param eventName the event name
 * @param handle the handler
 * @param options event options
 */ function $0e8cc2312f875d83$var$removeEventListener(node, eventName, handler, options) {
    var capture = options && typeof options !== 'boolean' ? options.capture : options;
    node.removeEventListener(eventName, handler, capture);
    if (handler.__once) node.removeEventListener(eventName, handler.__once, capture);
}
var $0e8cc2312f875d83$export$2e2bcd8739ae039 = $0e8cc2312f875d83$var$removeEventListener;



var $0a701287a48181ce$var$size;
function $0a701287a48181ce$export$2e2bcd8739ae039(recalc) {
    if (!$0a701287a48181ce$var$size && $0a701287a48181ce$var$size !== 0 || recalc) {
        if (0, $d74d83caf9feb6ec$export$2e2bcd8739ae039) {
            var scrollDiv = document.createElement('div');
            scrollDiv.style.position = 'absolute';
            scrollDiv.style.top = '-9999px';
            scrollDiv.style.width = '50px';
            scrollDiv.style.height = '50px';
            scrollDiv.style.overflow = 'scroll';
            document.body.appendChild(scrollDiv);
            $0a701287a48181ce$var$size = scrollDiv.offsetWidth - scrollDiv.clientWidth;
            document.body.removeChild(scrollDiv);
        }
    }
    return $0a701287a48181ce$var$size;
}



var $aZSru = parcelRequire("aZSru");
function $82c614494db0315a$export$2e2bcd8739ae039() {
    return (0, $aZSru.useState)(null);
}



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $8a045044d981058f$var$useCommittedRef(value) {
    const ref = (0, $aZSru.useRef)(value);
    (0, $aZSru.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $8a045044d981058f$export$2e2bcd8739ae039 = $8a045044d981058f$var$useCommittedRef;


function $ab8374406972b2d1$export$2e2bcd8739ae039(fn) {
    const ref = (0, $8a045044d981058f$export$2e2bcd8739ae039)(fn);
    return (0, $aZSru.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



var $aZSru = parcelRequire("aZSru");
const $dfc8aef1afa68cbb$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $dfc8aef1afa68cbb$export$c9058316764c140e(refA, refB) {
    const a = $dfc8aef1afa68cbb$var$toFnRef(refA);
    const b = $dfc8aef1afa68cbb$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $dfc8aef1afa68cbb$var$useMergedRefs(refA, refB) {
    return (0, $aZSru.useMemo)(()=>$dfc8aef1afa68cbb$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $dfc8aef1afa68cbb$export$2e2bcd8739ae039 = $dfc8aef1afa68cbb$var$useMergedRefs;



var $aZSru = parcelRequire("aZSru");
function $196c0758abd87f83$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $aZSru.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $aZSru = parcelRequire("aZSru");
function $d4fe19c6dc8995e6$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $196c0758abd87f83$export$2e2bcd8739ae039)(fn);
    (0, $aZSru.useEffect)(()=>()=>onUnmount.current(), []);
}



function $e48f308496c19f02$export$2e2bcd8739ae039(node) {
    var doc = (0, $0948e8b135437cc0$export$2e2bcd8739ae039)(node);
    return doc && doc.defaultView || window;
}


function $74470fe8055f5647$export$2e2bcd8739ae039(node, psuedoElement) {
    return (0, $e48f308496c19f02$export$2e2bcd8739ae039)(node).getComputedStyle(node, psuedoElement);
}


/**
 * Copyright 2013-2014, Facebook, Inc.
 * All rights reserved.
 * https://github.com/facebook/react/blob/2aeb8a2a6beb00617a4217f7f8284924fa2ad819/src/vendor/core/hyphenateStyleName.js
 */ var $0fdedfb744aab7ac$var$rUpper = /([A-Z])/g;
function $0fdedfb744aab7ac$export$2e2bcd8739ae039(string) {
    return string.replace($0fdedfb744aab7ac$var$rUpper, '-$1').toLowerCase();
}


var $fe089f72b46d74ff$var$msPattern = /^ms-/;
function $fe089f72b46d74ff$export$2e2bcd8739ae039(string) {
    return (0, $0fdedfb744aab7ac$export$2e2bcd8739ae039)(string).replace($fe089f72b46d74ff$var$msPattern, '-ms-');
}


var $1916da711e9adaa8$var$supportedTransforms = /^((translate|rotate|scale)(X|Y|Z|3d)?|matrix(3d)?|perspective|skew(X|Y)?)$/i;
function $1916da711e9adaa8$export$2e2bcd8739ae039(value) {
    return !!(value && $1916da711e9adaa8$var$supportedTransforms.test(value));
}


function $2b17b1a684deb938$var$style(node, property) {
    var css = '';
    var transforms = '';
    if (typeof property === 'string') return node.style.getPropertyValue((0, $fe089f72b46d74ff$export$2e2bcd8739ae039)(property)) || (0, $74470fe8055f5647$export$2e2bcd8739ae039)(node).getPropertyValue((0, $fe089f72b46d74ff$export$2e2bcd8739ae039)(property));
    Object.keys(property).forEach(function(key) {
        var value = property[key];
        if (!value && value !== 0) node.style.removeProperty((0, $fe089f72b46d74ff$export$2e2bcd8739ae039)(key));
        else if ((0, $1916da711e9adaa8$export$2e2bcd8739ae039)(key)) transforms += key + "(" + value + ") ";
        else css += (0, $fe089f72b46d74ff$export$2e2bcd8739ae039)(key) + ": " + value + ";";
    });
    if (transforms) css += "transform: " + transforms + ";";
    node.style.cssText += ";" + css;
}
var $2b17b1a684deb938$export$2e2bcd8739ae039 = $2b17b1a684deb938$var$style;




function $ef3c54910b074bb2$var$listen(node, eventName, handler, options) {
    (0, $eeb6ca5e41ee8cd7$export$2e2bcd8739ae039)(node, eventName, handler, options);
    return function() {
        (0, $0e8cc2312f875d83$export$2e2bcd8739ae039)(node, eventName, handler, options);
    };
}
var $ef3c54910b074bb2$export$2e2bcd8739ae039 = $ef3c54910b074bb2$var$listen;


/**
 * Triggers an event on a given element.
 * 
 * @param node the element
 * @param eventName the event name to trigger
 * @param bubbles whether the event should bubble up
 * @param cancelable whether the event should be cancelable
 */ function $338ec465f03dd92d$export$2e2bcd8739ae039(node, eventName, bubbles, cancelable) {
    if (bubbles === void 0) bubbles = false;
    if (cancelable === void 0) cancelable = true;
    if (node) {
        var event = document.createEvent('HTMLEvents');
        event.initEvent(eventName, bubbles, cancelable);
        node.dispatchEvent(event);
    }
}


function $4ef3015a5648ec5e$var$parseDuration(node) {
    var str = (0, $2b17b1a684deb938$export$2e2bcd8739ae039)(node, 'transitionDuration') || '';
    var mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $4ef3015a5648ec5e$var$emulateTransitionEnd(element, duration, padding) {
    if (padding === void 0) padding = 5;
    var called = false;
    var handle = setTimeout(function() {
        if (!called) (0, $338ec465f03dd92d$export$2e2bcd8739ae039)(element, 'transitionend', true);
    }, duration + padding);
    var remove = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(element, 'transitionend', function() {
        called = true;
    }, {
        once: true
    });
    return function() {
        clearTimeout(handle);
        remove();
    };
}
function $4ef3015a5648ec5e$export$2e2bcd8739ae039(element, handler, duration, padding) {
    if (duration == null) duration = $4ef3015a5648ec5e$var$parseDuration(element) || 0;
    var removeEmulate = $4ef3015a5648ec5e$var$emulateTransitionEnd(element, duration, padding);
    var remove = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(element, 'transitionend', handler);
    return function() {
        removeEmulate();
        remove();
    };
}



var $aZSru = parcelRequire("aZSru");

function $71e34d281ec43e55$export$2e2bcd8739ae039(doc) {
    if (doc === void 0) doc = (0, $0948e8b135437cc0$export$2e2bcd8739ae039)();
    // Support: IE 9 only
    // IE9 throws an "Unspecified error" accessing document.activeElement from an <iframe>
    try {
        var active = doc.activeElement; // IE11 returns a seemingly empty object in some cases when accessing
        // document.activeElement from an <iframe>
        if (!active || !active.nodeName) return null;
        return active;
    } catch (e) {
        /* ie throws if no active element */ return doc.body;
    }
}


/* eslint-disable no-bitwise, no-cond-assign */ /**
 * Checks if an element contains another given element.
 * 
 * @param context the context element
 * @param node the element to check
 */ function $5f0a0ff0971fd3a0$export$2e2bcd8739ae039(context, node) {
    // HTML DOM and SVG DOM may have different support levels,
    // so we need to check on context instead of a document root element.
    if (context.contains) return context.contains(node);
    if (context.compareDocumentPosition) return context === node || !!(context.compareDocumentPosition(node) & 16);
}





var $aZSru = parcelRequire("aZSru");

var $4lOAY = parcelRequire("4lOAY");

var $aZSru = parcelRequire("aZSru");
function $6c37138eb2d45e09$export$2e2bcd8739ae039() {
    const mounted = (0, $aZSru.useRef)(true);
    const isMounted = (0, $aZSru.useRef)(()=>mounted.current);
    (0, $aZSru.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



var $aZSru = parcelRequire("aZSru");
function $ba58d49e37183428$export$2e2bcd8739ae039(value) {
    const valueRef = (0, $aZSru.useRef)(value);
    valueRef.current = value;
    return valueRef;
}



var $aZSru = parcelRequire("aZSru");
function $83f0c8d661203421$export$2e2bcd8739ae039(fn) {
    const onUnmount = (0, $ba58d49e37183428$export$2e2bcd8739ae039)(fn);
    (0, $aZSru.useEffect)(()=>()=>onUnmount.current(), []);
}



var $aZSru = parcelRequire("aZSru");
function $5bbee511ad3f9d2a$export$2e2bcd8739ae039(value) {
    const ref = (0, $aZSru.useRef)(null);
    (0, $aZSru.useEffect)(()=>{
        ref.current = value;
    });
    return ref.current;
}



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
/**
 * Creates a `Ref` whose value is updated in an effect, ensuring the most recent
 * value is the one rendered with. Generally only required for Concurrent mode usage
 * where previous work in `render()` may be discarded before being used.
 *
 * This is safe to access in an event handler.
 *
 * @param value The `Ref` value
 */ function $06f3026ef7ede8e0$var$useCommittedRef(value) {
    const ref = (0, $aZSru.useRef)(value);
    (0, $aZSru.useEffect)(()=>{
        ref.current = value;
    }, [
        value
    ]);
    return ref;
}
var $06f3026ef7ede8e0$export$2e2bcd8739ae039 = $06f3026ef7ede8e0$var$useCommittedRef;


function $21bc47d5cee5541a$export$2e2bcd8739ae039(fn) {
    const ref = (0, $06f3026ef7ede8e0$export$2e2bcd8739ae039)(fn);
    return (0, $aZSru.useCallback)(function(...args) {
        return ref.current && ref.current(...args);
    }, [
        ref
    ]);
}



const $fb1d98baa2553a7e$export$fd7bcb7e9bef4e8a = `data-rr-ui-`;
const $fb1d98baa2553a7e$export$635202801f9383a0 = `rrUi`;
function $fb1d98baa2553a7e$export$5cc3b7b83e34ade7(property) {
    return `${$fb1d98baa2553a7e$export$fd7bcb7e9bef4e8a}${property}`;
}
function $fb1d98baa2553a7e$export$7776c0a7cd2eb3e0(property) {
    return `${$fb1d98baa2553a7e$export$635202801f9383a0}${property}`;
}


/**
 * Get the width of the vertical window scrollbar if it's visible
 */ function $194e0f54a9152fac$export$2e2bcd8739ae039(ownerDocument = document) {
    const window = ownerDocument.defaultView;
    return Math.abs(window.innerWidth - ownerDocument.documentElement.clientWidth);
}


const $6e98511f90b05d28$export$1a88c12b8b979fa0 = (0, $fb1d98baa2553a7e$export$5cc3b7b83e34ade7)('modal-open');
/**
 * Manages a stack of Modals as well as ensuring
 * body scrolling is is disabled and padding accounted for
 */ class $6e98511f90b05d28$var$ModalManager {
    getScrollbarWidth() {
        return (0, $194e0f54a9152fac$export$2e2bcd8739ae039)(this.ownerDocument);
    }
    getElement() {
        return (this.ownerDocument || document).body;
    }
    setModalAttributes(_modal) {
    // For overriding
    }
    removeModalAttributes(_modal) {
    // For overriding
    }
    setContainerStyle(containerState) {
        const style = {
            overflow: 'hidden'
        };
        // we are only interested in the actual `style` here
        // because we will override it
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const container = this.getElement();
        containerState.style = {
            overflow: container.style.overflow,
            [paddingProp]: container.style[paddingProp]
        };
        if (containerState.scrollBarWidth) // use computed style, here to get the real padding
        // to add our scrollbar width
        style[paddingProp] = `${parseInt((0, $2b17b1a684deb938$export$2e2bcd8739ae039)(container, paddingProp) || '0', 10) + containerState.scrollBarWidth}px`;
        container.setAttribute($6e98511f90b05d28$export$1a88c12b8b979fa0, '');
        (0, $2b17b1a684deb938$export$2e2bcd8739ae039)(container, style);
    }
    reset() {
        [
            ...this.modals
        ].forEach((m)=>this.remove(m));
    }
    removeContainerStyle(containerState) {
        const container = this.getElement();
        container.removeAttribute($6e98511f90b05d28$export$1a88c12b8b979fa0);
        Object.assign(container.style, containerState.style);
    }
    add(modal) {
        let modalIdx = this.modals.indexOf(modal);
        if (modalIdx !== -1) return modalIdx;
        modalIdx = this.modals.length;
        this.modals.push(modal);
        this.setModalAttributes(modal);
        if (modalIdx !== 0) return modalIdx;
        this.state = {
            scrollBarWidth: this.getScrollbarWidth(),
            style: {}
        };
        if (this.handleContainerOverflow) this.setContainerStyle(this.state);
        return modalIdx;
    }
    remove(modal) {
        const modalIdx = this.modals.indexOf(modal);
        if (modalIdx === -1) return;
        this.modals.splice(modalIdx, 1);
        // if that was the last modal in a container,
        // clean up the container
        if (!this.modals.length && this.handleContainerOverflow) this.removeContainerStyle(this.state);
        this.removeModalAttributes(modal);
    }
    isTopModal(modal) {
        return !!this.modals.length && this.modals[this.modals.length - 1] === modal;
    }
    constructor({ ownerDocument: ownerDocument, handleContainerOverflow: handleContainerOverflow = true, isRTL: isRTL = false } = {}){
        this.handleContainerOverflow = handleContainerOverflow;
        this.isRTL = isRTL;
        this.modals = [];
        this.ownerDocument = ownerDocument;
    }
}
var $6e98511f90b05d28$export$2e2bcd8739ae039 = $6e98511f90b05d28$var$ModalManager;





var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");

const $ec77d80a6d882524$var$Context = /*#__PURE__*/ (0, $aZSru.createContext)((0, $d74d83caf9feb6ec$export$2e2bcd8739ae039) ? window : undefined);
const $ec77d80a6d882524$export$f7d306aeb1cf5fbc = $ec77d80a6d882524$var$Context.Provider;
function $ec77d80a6d882524$export$2e2bcd8739ae039() {
    return (0, $aZSru.useContext)($ec77d80a6d882524$var$Context);
}


const $c1fcdab6ce610b72$export$c91fd81e6d65f84a = (ref, document)=>{
    if (!(0, $d74d83caf9feb6ec$export$2e2bcd8739ae039)) return null;
    if (ref == null) return (document || (0, $0948e8b135437cc0$export$2e2bcd8739ae039)()).body;
    if (typeof ref === 'function') ref = ref();
    if (ref && 'current' in ref) ref = ref.current;
    if (ref && ('nodeType' in ref || ref.getBoundingClientRect)) return ref;
    return null;
};
function $c1fcdab6ce610b72$export$2e2bcd8739ae039(ref, onResolved) {
    const window = (0, $ec77d80a6d882524$export$2e2bcd8739ae039)();
    const [resolvedRef, setRef] = (0, $aZSru.useState)(()=>$c1fcdab6ce610b72$export$c91fd81e6d65f84a(ref, window == null ? void 0 : window.document));
    if (!resolvedRef) {
        const earlyRef = $c1fcdab6ce610b72$export$c91fd81e6d65f84a(ref);
        if (earlyRef) setRef(earlyRef);
    }
    (0, $aZSru.useEffect)(()=>{
        if (onResolved && resolvedRef) onResolved(resolvedRef);
    }, [
        onResolved,
        resolvedRef
    ]);
    (0, $aZSru.useEffect)(()=>{
        const nextRef = $c1fcdab6ce610b72$export$c91fd81e6d65f84a(ref);
        if (nextRef !== resolvedRef) setRef(nextRef);
    }, [
        ref,
        resolvedRef
    ]);
    return resolvedRef;
}




var $aZSru = parcelRequire("aZSru");
const $bb2998387863b2cb$var$toFnRef = (ref)=>!ref || typeof ref === 'function' ? ref : (value)=>{
        ref.current = value;
    };
function $bb2998387863b2cb$export$c9058316764c140e(refA, refB) {
    const a = $bb2998387863b2cb$var$toFnRef(refA);
    const b = $bb2998387863b2cb$var$toFnRef(refB);
    return (value)=>{
        if (a) a(value);
        if (b) b(value);
    };
}
/**
 * Create and returns a single callback ref composed from two other Refs.
 *
 * ```tsx
 * const Button = React.forwardRef((props, ref) => {
 *   const [element, attachRef] = useCallbackRef<HTMLButtonElement>();
 *   const mergedRef = useMergedRefs(ref, attachRef);
 *
 *   return <button ref={mergedRef} {...props}/>
 * })
 * ```
 *
 * @param refA A Callback or mutable Ref
 * @param refB A Callback or mutable Ref
 * @category refs
 */ function $bb2998387863b2cb$var$useMergedRefs(refA, refB) {
    return (0, $aZSru.useMemo)(()=>$bb2998387863b2cb$export$c9058316764c140e(refA, refB), [
        refA,
        refB
    ]);
}
var $bb2998387863b2cb$export$2e2bcd8739ae039 = $bb2998387863b2cb$var$useMergedRefs;




var $aZSru = parcelRequire("aZSru");
const $dbc6fa0f772d7f41$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $dbc6fa0f772d7f41$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $dbc6fa0f772d7f41$export$2e2bcd8739ae039 = $dbc6fa0f772d7f41$var$isDOM || $dbc6fa0f772d7f41$var$isReactNative ? (0, $aZSru.useLayoutEffect) : (0, $aZSru.useEffect);



var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
function $6de6cf4b5106e807$export$806fcc22e55e107d(e) {
    return e.code === 'Escape' || e.keyCode === 27;
}
function $6de6cf4b5106e807$export$13e065f3a74cfe36() {
    const parts = $aZSru.version.split('.');
    return {
        major: +parts[0],
        minor: +parts[1],
        patch: +parts[2]
    };
}
function $6de6cf4b5106e807$export$87943f2672146d57(element) {
    if (!element || typeof element === 'function') return null;
    const { major: major } = $6de6cf4b5106e807$export$13e065f3a74cfe36();
    const childRef = major >= 19 ? element.props.ref : element.ref;
    return childRef;
}


function $cbfbb4cb88e35820$var$NoopTransition({ children: children, in: inProp, onExited: onExited, mountOnEnter: mountOnEnter, unmountOnExit: unmountOnExit }) {
    const ref = (0, $aZSru.useRef)(null);
    const hasEnteredRef = (0, $aZSru.useRef)(inProp);
    const handleExited = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(onExited);
    (0, $aZSru.useEffect)(()=>{
        if (inProp) hasEnteredRef.current = true;
        else handleExited(ref.current);
    }, [
        inProp,
        handleExited
    ]);
    const combinedRef = (0, $bb2998387863b2cb$export$2e2bcd8739ae039)(ref, (0, $6de6cf4b5106e807$export$87943f2672146d57)(children));
    const child = /*#__PURE__*/ (0, $aZSru.cloneElement)(children, {
        ref: combinedRef
    });
    if (inProp) return child;
    if (unmountOnExit) return null;
    if (!hasEnteredRef.current && mountOnEnter) return null;
    return child;
}
var $cbfbb4cb88e35820$export$2e2bcd8739ae039 = $cbfbb4cb88e35820$var$NoopTransition;



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");


const $ec5373d01b3dba14$var$_excluded = [
    "onEnter",
    "onEntering",
    "onEntered",
    "onExit",
    "onExiting",
    "onExited",
    "addEndListener",
    "children"
];
function $ec5373d01b3dba14$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $ec5373d01b3dba14$export$2e2bcd8739ae039(_ref) {
    let { onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children } = _ref, props = $ec5373d01b3dba14$var$_objectWithoutPropertiesLoose(_ref, $ec5373d01b3dba14$var$_excluded);
    const nodeRef = (0, $aZSru.useRef)(null);
    const mergedRef = (0, $bb2998387863b2cb$export$2e2bcd8739ae039)(nodeRef, (0, $6de6cf4b5106e807$export$87943f2672146d57)(children));
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    /* eslint-disable react-hooks/exhaustive-deps */ const handleEnter = (0, $aZSru.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $aZSru.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $aZSru.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $aZSru.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $aZSru.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $aZSru.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $aZSru.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    /* eslint-enable react-hooks/exhaustive-deps */ return Object.assign({}, props, {
        nodeRef: nodeRef
    }, onEnter && {
        onEnter: handleEnter
    }, onEntering && {
        onEntering: handleEntering
    }, onEntered && {
        onEntered: handleEntered
    }, onExit && {
        onExit: handleExit
    }, onExiting && {
        onExiting: handleExiting
    }, onExited && {
        onExited: handleExited
    }, addEndListener && {
        addEndListener: handleAddEndListener
    }, {
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, Object.assign({}, innerProps, {
                ref: mergedRef
            })) : /*#__PURE__*/ (0, $aZSru.cloneElement)(children, {
            ref: mergedRef
        })
    });
}



const $dd530f8fff3bf1c8$var$_excluded = [
    "component"
];
function $dd530f8fff3bf1c8$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// Normalizes Transition callbacks when nodeRef is used.
const $dd530f8fff3bf1c8$var$RTGTransition = /*#__PURE__*/ $aZSru.forwardRef((_ref, ref)=>{
    let { component: Component } = _ref, props = $dd530f8fff3bf1c8$var$_objectWithoutPropertiesLoose(_ref, $dd530f8fff3bf1c8$var$_excluded);
    const transitionProps = (0, $ec5373d01b3dba14$export$2e2bcd8739ae039)(props);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, Object.assign({
        ref: ref
    }, transitionProps));
});
var $dd530f8fff3bf1c8$export$2e2bcd8739ae039 = $dd530f8fff3bf1c8$var$RTGTransition;




function $7a90b9204ab52ce8$export$7b286972b8d8ccbf({ in: inProp, onTransition: onTransition }) {
    const ref = (0, $aZSru.useRef)(null);
    const isInitialRef = (0, $aZSru.useRef)(true);
    const handleTransition = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(onTransition);
    (0, $dbc6fa0f772d7f41$export$2e2bcd8739ae039)(()=>{
        if (!ref.current) return undefined;
        let stale = false;
        handleTransition({
            in: inProp,
            element: ref.current,
            initial: isInitialRef.current,
            isStale: ()=>stale
        });
        return ()=>{
            stale = true;
        };
    }, [
        inProp,
        handleTransition
    ]);
    (0, $dbc6fa0f772d7f41$export$2e2bcd8739ae039)(()=>{
        isInitialRef.current = false;
        // this is for strict mode
        return ()=>{
            isInitialRef.current = true;
        };
    }, []);
    return ref;
}
function $7a90b9204ab52ce8$export$2e2bcd8739ae039({ children: children, in: inProp, onExited: onExited, onEntered: onEntered, transition: transition }) {
    const [exited, setExited] = (0, $aZSru.useState)(!inProp);
    // TODO: I think this needs to be in an effect
    if (inProp && exited) setExited(false);
    const ref = $7a90b9204ab52ce8$export$7b286972b8d8ccbf({
        in: !!inProp,
        onTransition: (options)=>{
            const onFinish = ()=>{
                if (options.isStale()) return;
                if (options.in) onEntered == null || onEntered(options.element, options.initial);
                else {
                    setExited(true);
                    onExited == null || onExited(options.element);
                }
            };
            Promise.resolve(transition(options)).then(onFinish, (error)=>{
                if (!options.in) setExited(true);
                throw error;
            });
        }
    });
    const combinedRef = (0, $bb2998387863b2cb$export$2e2bcd8739ae039)(ref, (0, $6de6cf4b5106e807$export$87943f2672146d57)(children));
    return exited && !inProp ? null : /*#__PURE__*/ (0, $aZSru.cloneElement)(children, {
        ref: combinedRef
    });
}
function $7a90b9204ab52ce8$export$f41d64aae6d6dba5(component, runTransition, props) {
    if (component) return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $dd530f8fff3bf1c8$export$2e2bcd8739ae039), Object.assign({}, props, {
        component: component
    }));
    if (runTransition) return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($7a90b9204ab52ce8$export$2e2bcd8739ae039, Object.assign({}, props, {
        transition: runTransition
    }));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $cbfbb4cb88e35820$export$2e2bcd8739ae039), Object.assign({}, props));
}




const $8fd58f8475a0c86a$var$_excluded = [
    "show",
    "role",
    "className",
    "style",
    "children",
    "backdrop",
    "keyboard",
    "onBackdropClick",
    "onEscapeKeyDown",
    "transition",
    "runTransition",
    "backdropTransition",
    "runBackdropTransition",
    "autoFocus",
    "enforceFocus",
    "restoreFocus",
    "restoreFocusOptions",
    "renderDialog",
    "renderBackdrop",
    "manager",
    "container",
    "onShow",
    "onHide",
    "onExit",
    "onExited",
    "onExiting",
    "onEnter",
    "onEntering",
    "onEntered"
];
function $8fd58f8475a0c86a$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
let $8fd58f8475a0c86a$var$manager;
/*
  Modal props are split into a version with and without index signature so that you can fully use them in another projects
  This is due to Typescript not playing well with index signatures e.g. when using Omit
*/ function $8fd58f8475a0c86a$var$getManager(window) {
    if (!$8fd58f8475a0c86a$var$manager) $8fd58f8475a0c86a$var$manager = new (0, $6e98511f90b05d28$export$2e2bcd8739ae039)({
        ownerDocument: window == null ? void 0 : window.document
    });
    return $8fd58f8475a0c86a$var$manager;
}
function $8fd58f8475a0c86a$var$useModalManager(provided) {
    const window = (0, $ec77d80a6d882524$export$2e2bcd8739ae039)();
    const modalManager = provided || $8fd58f8475a0c86a$var$getManager(window);
    const modal = (0, $aZSru.useRef)({
        dialog: null,
        backdrop: null
    });
    return Object.assign(modal.current, {
        add: ()=>modalManager.add(modal.current),
        remove: ()=>modalManager.remove(modal.current),
        isTopModal: ()=>modalManager.isTopModal(modal.current),
        setDialogRef: (0, $aZSru.useCallback)((ref)=>{
            modal.current.dialog = ref;
        }, []),
        setBackdropRef: (0, $aZSru.useCallback)((ref)=>{
            modal.current.backdrop = ref;
        }, [])
    });
}
const $8fd58f8475a0c86a$var$Modal = /*#__PURE__*/ (0, $aZSru.forwardRef)((_ref, ref)=>{
    let { show: show = false, role: role = 'dialog', className: className, style: style, children: children, backdrop: backdrop = true, keyboard: keyboard = true, onBackdropClick: onBackdropClick, onEscapeKeyDown: onEscapeKeyDown, transition: transition, runTransition: runTransition, backdropTransition: backdropTransition, runBackdropTransition: runBackdropTransition, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, renderDialog: renderDialog, renderBackdrop: renderBackdrop = (props)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", Object.assign({}, props)), manager: providedManager, container: containerRef, onShow: onShow, onHide: onHide = ()=>{}, onExit: onExit, onExited: onExited, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = _ref, rest = $8fd58f8475a0c86a$var$_objectWithoutPropertiesLoose(_ref, $8fd58f8475a0c86a$var$_excluded);
    const ownerWindow = (0, $ec77d80a6d882524$export$2e2bcd8739ae039)();
    const container = (0, $c1fcdab6ce610b72$export$2e2bcd8739ae039)(containerRef);
    const modal = $8fd58f8475a0c86a$var$useModalManager(providedManager);
    const isMounted = (0, $6c37138eb2d45e09$export$2e2bcd8739ae039)();
    const prevShow = (0, $5bbee511ad3f9d2a$export$2e2bcd8739ae039)(show);
    const [exited, setExited] = (0, $aZSru.useState)(!show);
    const lastFocusRef = (0, $aZSru.useRef)(null);
    (0, $aZSru.useImperativeHandle)(ref, ()=>modal, [
        modal
    ]);
    if ((0, $d74d83caf9feb6ec$export$2e2bcd8739ae039) && !prevShow && show) lastFocusRef.current = (0, $71e34d281ec43e55$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
    // TODO: I think this needs to be in an effect
    if (show && exited) setExited(false);
    const handleShow = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(()=>{
        modal.add();
        removeKeydownListenerRef.current = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(document, 'keydown', handleDocumentKeyDown);
        removeFocusListenerRef.current = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(document, 'focus', // the timeout is necessary b/c this will run before the new modal is mounted
        // and so steals focus from it
        ()=>setTimeout(handleEnforceFocus), true);
        if (onShow) onShow();
        // autofocus after onShow to not trigger a focus event for previous
        // modals before this one is shown.
        if (autoFocus) {
            var _modal$dialog$ownerDo, _modal$dialog;
            const currentActiveElement = (0, $71e34d281ec43e55$export$2e2bcd8739ae039)((_modal$dialog$ownerDo = (_modal$dialog = modal.dialog) == null ? void 0 : _modal$dialog.ownerDocument) != null ? _modal$dialog$ownerDo : ownerWindow == null ? void 0 : ownerWindow.document);
            if (modal.dialog && currentActiveElement && !(0, $5f0a0ff0971fd3a0$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) {
                lastFocusRef.current = currentActiveElement;
                modal.dialog.focus();
            }
        }
    });
    const handleHide = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(()=>{
        modal.remove();
        removeKeydownListenerRef.current == null || removeKeydownListenerRef.current();
        removeFocusListenerRef.current == null || removeFocusListenerRef.current();
        if (restoreFocus) {
            var _lastFocusRef$current;
            // Support: <=IE11 doesn't support `focus()` on svg elements (RB: #917)
            (_lastFocusRef$current = lastFocusRef.current) == null || _lastFocusRef$current.focus == null || _lastFocusRef$current.focus(restoreFocusOptions);
            lastFocusRef.current = null;
        }
    });
    // TODO: try and combine these effects: https://github.com/react-bootstrap/react-overlays/pull/794#discussion_r409954120
    // Show logic when:
    //  - show is `true` _and_ `container` has resolved
    (0, $aZSru.useEffect)(()=>{
        if (!show || !container) return;
        handleShow();
    }, [
        show,
        container,
        /* should never change: */ handleShow
    ]);
    // Hide cleanup logic when:
    //  - `exited` switches to true
    //  - component unmounts;
    (0, $aZSru.useEffect)(()=>{
        if (!exited) return;
        handleHide();
    }, [
        exited,
        handleHide
    ]);
    (0, $83f0c8d661203421$export$2e2bcd8739ae039)(()=>{
        handleHide();
    });
    // --------------------------------
    const handleEnforceFocus = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(()=>{
        if (!enforceFocus || !isMounted() || !modal.isTopModal()) return;
        const currentActiveElement = (0, $71e34d281ec43e55$export$2e2bcd8739ae039)(ownerWindow == null ? void 0 : ownerWindow.document);
        if (modal.dialog && currentActiveElement && !(0, $5f0a0ff0971fd3a0$export$2e2bcd8739ae039)(modal.dialog, currentActiveElement)) modal.dialog.focus();
    });
    const handleBackdropClick = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        if (e.target !== e.currentTarget) return;
        onBackdropClick == null || onBackdropClick(e);
        if (backdrop === true) onHide();
    });
    const handleDocumentKeyDown = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        if (keyboard && (0, $6de6cf4b5106e807$export$806fcc22e55e107d)(e) && modal.isTopModal()) {
            onEscapeKeyDown == null || onEscapeKeyDown(e);
            if (!e.defaultPrevented) onHide();
        }
    });
    const removeFocusListenerRef = (0, $aZSru.useRef)();
    const removeKeydownListenerRef = (0, $aZSru.useRef)();
    const handleHidden = (...args)=>{
        setExited(true);
        onExited == null || onExited(...args);
    };
    if (!container) return null;
    const dialogProps = Object.assign({
        role: role,
        ref: modal.setDialogRef,
        // apparently only works on the dialog role element
        'aria-modal': role === 'dialog' ? true : undefined
    }, rest, {
        style: style,
        className: className,
        tabIndex: -1
    });
    let dialog = renderDialog ? renderDialog(dialogProps) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", Object.assign({}, dialogProps, {
        children: /*#__PURE__*/ $aZSru.cloneElement(children, {
            role: 'document'
        })
    }));
    dialog = (0, $7a90b9204ab52ce8$export$f41d64aae6d6dba5)(transition, runTransition, {
        unmountOnExit: true,
        mountOnEnter: true,
        appear: true,
        in: !!show,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered,
        children: dialog
    });
    let backdropElement = null;
    if (backdrop) {
        backdropElement = renderBackdrop({
            ref: modal.setBackdropRef,
            onClick: handleBackdropClick
        });
        backdropElement = (0, $7a90b9204ab52ce8$export$f41d64aae6d6dba5)(backdropTransition, runBackdropTransition, {
            in: !!show,
            appear: true,
            mountOnEnter: true,
            unmountOnExit: true,
            children: backdropElement
        });
    }
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
        children: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).createPortal(/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
            children: [
                backdropElement,
                dialog
            ]
        }), container)
    });
});
$8fd58f8475a0c86a$var$Modal.displayName = 'Modal';
var $8fd58f8475a0c86a$export$2e2bcd8739ae039 = Object.assign($8fd58f8475a0c86a$var$Modal, {
    Manager: (0, $6e98511f90b05d28$export$2e2bcd8739ae039)
});


/**
 * Checks if a given element has a CSS class.
 * 
 * @param element the element
 * @param className the CSS class name
 */ function $424c8a7de98bf84a$export$2e2bcd8739ae039(element, className) {
    if (element.classList) return !!className && element.classList.contains(className);
    return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
}


function $be4b431da667ca6b$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.add(className);
    else if (!(0, $424c8a7de98bf84a$export$2e2bcd8739ae039)(element, className)) {
        if (typeof element.className === 'string') element.className = element.className + " " + className;
        else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
    }
}



var $3345a36ae1e7dd7c$var$toArray = Function.prototype.bind.call(Function.prototype.call, [].slice);
function $3345a36ae1e7dd7c$export$2e2bcd8739ae039(element, selector) {
    return $3345a36ae1e7dd7c$var$toArray(element.querySelectorAll(selector));
}


function $998b8eeca1915a12$var$replaceClassName(origClass, classToRemove) {
    return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
}
function $998b8eeca1915a12$export$2e2bcd8739ae039(element, className) {
    if (element.classList) element.classList.remove(className);
    else if (typeof element.className === 'string') element.className = $998b8eeca1915a12$var$replaceClassName(element.className, className);
    else element.setAttribute('class', $998b8eeca1915a12$var$replaceClassName(element.className && element.className.baseVal || '', className));
}



const $9000de8b194da122$var$Selector = {
    FIXED_CONTENT: '.fixed-top, .fixed-bottom, .is-fixed, .sticky-top',
    STICKY_CONTENT: '.sticky-top',
    NAVBAR_TOGGLER: '.navbar-toggler'
};
class $9000de8b194da122$var$BootstrapModalManager extends (0, $6e98511f90b05d28$export$2e2bcd8739ae039) {
    adjustAndStore(prop, element, adjust) {
        const actual = element.style[prop];
        // @ts-expect-error TODO: DOMStringMap and CSSStyleDeclaration aren't strictly compatible
        element.dataset[prop] = actual;
        (0, $2b17b1a684deb938$export$2e2bcd8739ae039)(element, {
            [prop]: `${parseFloat((0, $2b17b1a684deb938$export$2e2bcd8739ae039)(element, prop)) + adjust}px`
        });
    }
    restore(prop, element) {
        const value = element.dataset[prop];
        if (value !== undefined) {
            delete element.dataset[prop];
            (0, $2b17b1a684deb938$export$2e2bcd8739ae039)(element, {
                [prop]: value
            });
        }
    }
    setContainerStyle(containerState) {
        super.setContainerStyle(containerState);
        const container = this.getElement();
        (0, $be4b431da667ca6b$export$2e2bcd8739ae039)(container, 'modal-open');
        if (!containerState.scrollBarWidth) return;
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(container, $9000de8b194da122$var$Selector.FIXED_CONTENT).forEach((el)=>this.adjustAndStore(paddingProp, el, containerState.scrollBarWidth));
        (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(container, $9000de8b194da122$var$Selector.STICKY_CONTENT).forEach((el)=>this.adjustAndStore(marginProp, el, -containerState.scrollBarWidth));
        (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(container, $9000de8b194da122$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.adjustAndStore(marginProp, el, containerState.scrollBarWidth));
    }
    removeContainerStyle(containerState) {
        super.removeContainerStyle(containerState);
        const container = this.getElement();
        (0, $998b8eeca1915a12$export$2e2bcd8739ae039)(container, 'modal-open');
        const paddingProp = this.isRTL ? 'paddingLeft' : 'paddingRight';
        const marginProp = this.isRTL ? 'marginLeft' : 'marginRight';
        (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(container, $9000de8b194da122$var$Selector.FIXED_CONTENT).forEach((el)=>this.restore(paddingProp, el));
        (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(container, $9000de8b194da122$var$Selector.STICKY_CONTENT).forEach((el)=>this.restore(marginProp, el));
        (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(container, $9000de8b194da122$var$Selector.NAVBAR_TOGGLER).forEach((el)=>this.restore(marginProp, el));
    }
}
let $9000de8b194da122$var$sharedManager;
function $9000de8b194da122$export$a03641438014b436(options) {
    if (!$9000de8b194da122$var$sharedManager) $9000de8b194da122$var$sharedManager = new $9000de8b194da122$var$BootstrapModalManager(options);
    return $9000de8b194da122$var$sharedManager;
}
var $9000de8b194da122$export$2e2bcd8739ae039 = $9000de8b194da122$var$BootstrapModalManager;




var $aZSru = parcelRequire("aZSru");
function $1f98745f98dacb58$export$2e2bcd8739ae039(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (-1 !== e.indexOf(n)) continue;
        t[n] = r[n];
    }
    return t;
}


function $9a21ef1972bbc1c8$export$2e2bcd8739ae039(t, e) {
    return $9a21ef1972bbc1c8$export$2e2bcd8739ae039 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(t, e) {
        return t.__proto__ = e, t;
    }, $9a21ef1972bbc1c8$export$2e2bcd8739ae039(t, e);
}


function $58313b8798d38f75$export$2e2bcd8739ae039(t, o) {
    t.prototype = Object.create(o.prototype), t.prototype.constructor = t, (0, $9a21ef1972bbc1c8$export$2e2bcd8739ae039)(t, o);
}




var $aZSru = parcelRequire("aZSru");

var $4lOAY = parcelRequire("4lOAY");
var $3aebcddab7527d93$export$2e2bcd8739ae039 = {
    disabled: false
};




var $aZSru = parcelRequire("aZSru");
var $2ec131dc4cbf1f95$export$2e2bcd8739ae039 = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createContext(null);


var $99130f05e48f5018$export$7d26bbb1236dafd6 = function forceReflow(node) {
    return node.scrollTop;
};


var $61e0c3d460fb69c2$export$bb38bb9a1161268 = 'unmounted';
var $61e0c3d460fb69c2$export$84cbff306f539230 = 'exited';
var $61e0c3d460fb69c2$export$df38205c966be359 = 'entering';
var $61e0c3d460fb69c2$export$78e9e6e3e014d60a = 'entered';
var $61e0c3d460fb69c2$export$4aacc83d4d59139f = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 1 },
 *   entered:  { opacity: 1 },
 *   exiting:  { opacity: 0 },
 *   exited:  { opacity: 0 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */ var $61e0c3d460fb69c2$var$Transition = /*#__PURE__*/ function(_React$Component) {
    (0, $58313b8798d38f75$export$2e2bcd8739ae039)(Transition, _React$Component);
    function Transition(props, context) {
        var _this;
        _this = _React$Component.call(this, props, context) || this;
        var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
        var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
        var initialStatus;
        _this.appearStatus = null;
        if (props.in) {
            if (appear) {
                initialStatus = $61e0c3d460fb69c2$export$84cbff306f539230;
                _this.appearStatus = $61e0c3d460fb69c2$export$df38205c966be359;
            } else initialStatus = $61e0c3d460fb69c2$export$78e9e6e3e014d60a;
        } else if (props.unmountOnExit || props.mountOnEnter) initialStatus = $61e0c3d460fb69c2$export$bb38bb9a1161268;
        else initialStatus = $61e0c3d460fb69c2$export$84cbff306f539230;
        _this.state = {
            status: initialStatus
        };
        _this.nextCallback = null;
        return _this;
    }
    Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
        var nextIn = _ref.in;
        if (nextIn && prevState.status === $61e0c3d460fb69c2$export$bb38bb9a1161268) return {
            status: $61e0c3d460fb69c2$export$84cbff306f539230
        };
        return null;
    } // getSnapshotBeforeUpdate(prevProps) {
    ;
    var _proto = Transition.prototype;
    _proto.componentDidMount = function componentDidMount() {
        this.updateStatus(true, this.appearStatus);
    };
    _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
        var nextStatus = null;
        if (prevProps !== this.props) {
            var status = this.state.status;
            if (this.props.in) {
                if (status !== $61e0c3d460fb69c2$export$df38205c966be359 && status !== $61e0c3d460fb69c2$export$78e9e6e3e014d60a) nextStatus = $61e0c3d460fb69c2$export$df38205c966be359;
            } else if (status === $61e0c3d460fb69c2$export$df38205c966be359 || status === $61e0c3d460fb69c2$export$78e9e6e3e014d60a) nextStatus = $61e0c3d460fb69c2$export$4aacc83d4d59139f;
        }
        this.updateStatus(false, nextStatus);
    };
    _proto.componentWillUnmount = function componentWillUnmount() {
        this.cancelNextCallback();
    };
    _proto.getTimeouts = function getTimeouts() {
        var timeout = this.props.timeout;
        var exit, enter, appear;
        exit = enter = appear = timeout;
        if (timeout != null && typeof timeout !== 'number') {
            exit = timeout.exit;
            enter = timeout.enter; // TODO: remove fallback for next major
            appear = timeout.appear !== undefined ? timeout.appear : enter;
        }
        return {
            exit: exit,
            enter: enter,
            appear: appear
        };
    };
    _proto.updateStatus = function updateStatus(mounting, nextStatus) {
        if (mounting === void 0) mounting = false;
        if (nextStatus !== null) {
            // nextStatus will always be ENTERING or EXITING.
            this.cancelNextCallback();
            if (nextStatus === $61e0c3d460fb69c2$export$df38205c966be359) {
                if (this.props.unmountOnExit || this.props.mountOnEnter) {
                    var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).findDOMNode(this); // https://github.com/reactjs/react-transition-group/pull/749
                    // With unmountOnExit or mountOnEnter, the enter animation should happen at the transition between `exited` and `entering`.
                    // To make the animation happen,  we have to separate each rendering and avoid being processed as batched.
                    if (node) (0, $99130f05e48f5018$export$7d26bbb1236dafd6)(node);
                }
                this.performEnter(mounting);
            } else this.performExit();
        } else if (this.props.unmountOnExit && this.state.status === $61e0c3d460fb69c2$export$84cbff306f539230) this.setState({
            status: $61e0c3d460fb69c2$export$bb38bb9a1161268
        });
    };
    _proto.performEnter = function performEnter(mounting) {
        var _this2 = this;
        var enter = this.props.enter;
        var appearing = this.context ? this.context.isMounting : mounting;
        var _ref2 = this.props.nodeRef ? [
            appearing
        ] : [
            (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).findDOMNode(this),
            appearing
        ], maybeNode = _ref2[0], maybeAppearing = _ref2[1];
        var timeouts = this.getTimeouts();
        var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
        // if we are mounting and running this it means appear _must_ be set
        if (!mounting && !enter || (0, $3aebcddab7527d93$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $61e0c3d460fb69c2$export$78e9e6e3e014d60a
            }, function() {
                _this2.props.onEntered(maybeNode);
            });
            return;
        }
        this.props.onEnter(maybeNode, maybeAppearing);
        this.safeSetState({
            status: $61e0c3d460fb69c2$export$df38205c966be359
        }, function() {
            _this2.props.onEntering(maybeNode, maybeAppearing);
            _this2.onTransitionEnd(enterTimeout, function() {
                _this2.safeSetState({
                    status: $61e0c3d460fb69c2$export$78e9e6e3e014d60a
                }, function() {
                    _this2.props.onEntered(maybeNode, maybeAppearing);
                });
            });
        });
    };
    _proto.performExit = function performExit() {
        var _this3 = this;
        var exit = this.props.exit;
        var timeouts = this.getTimeouts();
        var maybeNode = this.props.nodeRef ? undefined : (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).findDOMNode(this); // no exit animation skip right to EXITED
        if (!exit || (0, $3aebcddab7527d93$export$2e2bcd8739ae039).disabled) {
            this.safeSetState({
                status: $61e0c3d460fb69c2$export$84cbff306f539230
            }, function() {
                _this3.props.onExited(maybeNode);
            });
            return;
        }
        this.props.onExit(maybeNode);
        this.safeSetState({
            status: $61e0c3d460fb69c2$export$4aacc83d4d59139f
        }, function() {
            _this3.props.onExiting(maybeNode);
            _this3.onTransitionEnd(timeouts.exit, function() {
                _this3.safeSetState({
                    status: $61e0c3d460fb69c2$export$84cbff306f539230
                }, function() {
                    _this3.props.onExited(maybeNode);
                });
            });
        });
    };
    _proto.cancelNextCallback = function cancelNextCallback() {
        if (this.nextCallback !== null) {
            this.nextCallback.cancel();
            this.nextCallback = null;
        }
    };
    _proto.safeSetState = function safeSetState(nextState, callback) {
        // This shouldn't be necessary, but there are weird race conditions with
        // setState callbacks and unmounting in testing, so always make sure that
        // we can cancel any pending setState callbacks after we unmount.
        callback = this.setNextCallback(callback);
        this.setState(nextState, callback);
    };
    _proto.setNextCallback = function setNextCallback(callback) {
        var _this4 = this;
        var active = true;
        this.nextCallback = function(event) {
            if (active) {
                active = false;
                _this4.nextCallback = null;
                callback(event);
            }
        };
        this.nextCallback.cancel = function() {
            active = false;
        };
        return this.nextCallback;
    };
    _proto.onTransitionEnd = function onTransitionEnd(timeout, handler) {
        this.setNextCallback(handler);
        var node = this.props.nodeRef ? this.props.nodeRef.current : (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).findDOMNode(this);
        var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
        if (!node || doesNotHaveTimeoutOrListener) {
            setTimeout(this.nextCallback, 0);
            return;
        }
        if (this.props.addEndListener) {
            var _ref3 = this.props.nodeRef ? [
                this.nextCallback
            ] : [
                node,
                this.nextCallback
            ], maybeNode = _ref3[0], maybeNextCallback = _ref3[1];
            this.props.addEndListener(maybeNode, maybeNextCallback);
        }
        if (timeout != null) setTimeout(this.nextCallback, timeout);
    };
    _proto.render = function render() {
        var status = this.state.status;
        if (status === $61e0c3d460fb69c2$export$bb38bb9a1161268) return null;
        var _this$props = this.props, children = _this$props.children, _in = _this$props.in, _mountOnEnter = _this$props.mountOnEnter, _unmountOnExit = _this$props.unmountOnExit, _appear = _this$props.appear, _enter = _this$props.enter, _exit = _this$props.exit, _timeout = _this$props.timeout, _addEndListener = _this$props.addEndListener, _onEnter = _this$props.onEnter, _onEntering = _this$props.onEntering, _onEntered = _this$props.onEntered, _onExit = _this$props.onExit, _onExiting = _this$props.onExiting, _onExited = _this$props.onExited, _nodeRef = _this$props.nodeRef, childProps = (0, $1f98745f98dacb58$export$2e2bcd8739ae039)(_this$props, [
            "children",
            "in",
            "mountOnEnter",
            "unmountOnExit",
            "appear",
            "enter",
            "exit",
            "timeout",
            "addEndListener",
            "onEnter",
            "onEntering",
            "onEntered",
            "onExit",
            "onExiting",
            "onExited",
            "nodeRef"
        ]);
        return(/*#__PURE__*/ // allows for nested Transitions
        (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement((0, $2ec131dc4cbf1f95$export$2e2bcd8739ae039).Provider, {
            value: null
        }, typeof children === 'function' ? children(status, childProps) : (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).cloneElement((0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).Children.only(children), childProps)));
    };
    return Transition;
}((0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).Component);
$61e0c3d460fb69c2$var$Transition.contextType = (0, $2ec131dc4cbf1f95$export$2e2bcd8739ae039);
$61e0c3d460fb69c2$var$Transition.propTypes = {}; // Name the function so it is clearer in the documentation
function $61e0c3d460fb69c2$var$noop() {}
$61e0c3d460fb69c2$var$Transition.defaultProps = {
    in: false,
    mountOnEnter: false,
    unmountOnExit: false,
    appear: false,
    enter: true,
    exit: true,
    onEnter: $61e0c3d460fb69c2$var$noop,
    onEntering: $61e0c3d460fb69c2$var$noop,
    onEntered: $61e0c3d460fb69c2$var$noop,
    onExit: $61e0c3d460fb69c2$var$noop,
    onExiting: $61e0c3d460fb69c2$var$noop,
    onExited: $61e0c3d460fb69c2$var$noop
};
$61e0c3d460fb69c2$var$Transition.UNMOUNTED = $61e0c3d460fb69c2$export$bb38bb9a1161268;
$61e0c3d460fb69c2$var$Transition.EXITED = $61e0c3d460fb69c2$export$84cbff306f539230;
$61e0c3d460fb69c2$var$Transition.ENTERING = $61e0c3d460fb69c2$export$df38205c966be359;
$61e0c3d460fb69c2$var$Transition.ENTERED = $61e0c3d460fb69c2$export$78e9e6e3e014d60a;
$61e0c3d460fb69c2$var$Transition.EXITING = $61e0c3d460fb69c2$export$4aacc83d4d59139f;
var $61e0c3d460fb69c2$export$2e2bcd8739ae039 = $61e0c3d460fb69c2$var$Transition;





function $d91e207b7882051e$var$parseDuration(node, property) {
    const str = (0, $2b17b1a684deb938$export$2e2bcd8739ae039)(node, property) || '';
    const mult = str.indexOf('ms') === -1 ? 1000 : 1;
    return parseFloat(str) * mult;
}
function $d91e207b7882051e$export$2e2bcd8739ae039(element, handler) {
    const duration = $d91e207b7882051e$var$parseDuration(element, 'transitionDuration');
    const delay = $d91e207b7882051e$var$parseDuration(element, 'transitionDelay');
    const remove = (0, $4ef3015a5648ec5e$export$2e2bcd8739ae039)(element, (e)=>{
        if (e.target === element) {
            remove();
            handler(e);
        }
    }, duration + delay);
}


// reading a dimension prop will cause the browser to recalculate,
// which will let our animations work
function $b19f86f2ec605864$export$2e2bcd8739ae039(node) {
    // eslint-disable-next-line @typescript-eslint/no-unused-expressions
    node.offsetHeight;
}



var $aZSru = parcelRequire("aZSru");



var $4lOAY = parcelRequire("4lOAY");
function $4504d0e8962fecda$export$2e2bcd8739ae039(componentOrElement) {
    if (componentOrElement && 'setState' in componentOrElement) // TODO: Remove in next major.
    // eslint-disable-next-line react/no-find-dom-node
    return (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).findDOMNode(componentOrElement);
    return componentOrElement != null ? componentOrElement : null;
}



"use client";
// Normalizes Transition callbacks when nodeRef is used.
const $8968d694d76052a6$var$TransitionWrapper = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onExited: onExited, addEndListener: addEndListener, children: children, childRef: childRef, ...props }, ref)=>{
    const nodeRef = (0, $aZSru.useRef)(null);
    const mergedRef = (0, $dfc8aef1afa68cbb$export$2e2bcd8739ae039)(nodeRef, childRef);
    const attachRef = (r)=>{
        mergedRef((0, $4504d0e8962fecda$export$2e2bcd8739ae039)(r));
    };
    const normalize = (callback)=>(param)=>{
            if (callback && nodeRef.current) callback(nodeRef.current, param);
        };
    const handleEnter = (0, $aZSru.useCallback)(normalize(onEnter), [
        onEnter
    ]);
    const handleEntering = (0, $aZSru.useCallback)(normalize(onEntering), [
        onEntering
    ]);
    const handleEntered = (0, $aZSru.useCallback)(normalize(onEntered), [
        onEntered
    ]);
    const handleExit = (0, $aZSru.useCallback)(normalize(onExit), [
        onExit
    ]);
    const handleExiting = (0, $aZSru.useCallback)(normalize(onExiting), [
        onExiting
    ]);
    const handleExited = (0, $aZSru.useCallback)(normalize(onExited), [
        onExited
    ]);
    const handleAddEndListener = (0, $aZSru.useCallback)(normalize(addEndListener), [
        addEndListener
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $61e0c3d460fb69c2$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        onEnter: handleEnter,
        onEntered: handleEntered,
        onEntering: handleEntering,
        onExit: handleExit,
        onExited: handleExited,
        onExiting: handleExiting,
        addEndListener: handleAddEndListener,
        nodeRef: nodeRef,
        children: typeof children === 'function' ? (status, innerProps)=>// TODO: Types for RTG missing innerProps, so need to cast.
            children(status, {
                ...innerProps,
                ref: attachRef
            }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).cloneElement(children, {
            ref: attachRef
        })
    });
});
$8968d694d76052a6$var$TransitionWrapper.displayName = 'TransitionWrapper';
var $8968d694d76052a6$export$2e2bcd8739ae039 = $8968d694d76052a6$var$TransitionWrapper;



const $75d062e47e20887d$var$fadeStyles = {
    [(0, $61e0c3d460fb69c2$export$df38205c966be359)]: 'show',
    [(0, $61e0c3d460fb69c2$export$78e9e6e3e014d60a)]: 'show'
};
const $75d062e47e20887d$var$Fade = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, children: children, transitionClasses: transitionClasses = {}, onEnter: onEnter, ...rest }, ref)=>{
    const props = {
        in: false,
        timeout: 300,
        mountOnEnter: false,
        unmountOnExit: false,
        appear: false,
        ...rest
    };
    const handleEnter = (0, $aZSru.useCallback)((node, isAppearing)=>{
        (0, $b19f86f2ec605864$export$2e2bcd8739ae039)(node);
        onEnter == null || onEnter(node, isAppearing);
    }, [
        onEnter
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $8968d694d76052a6$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $d91e207b7882051e$export$2e2bcd8739ae039),
        ...props,
        onEnter: handleEnter,
        childRef: (0, $6de6cf4b5106e807$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $aZSru.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))('fade', className, children.props.className, $75d062e47e20887d$var$fadeStyles[status], transitionClasses[status])
            })
    });
});
$75d062e47e20887d$var$Fade.displayName = 'Fade';
var $75d062e47e20887d$export$2e2bcd8739ae039 = $75d062e47e20887d$var$Fade;



var $aZSru = parcelRequire("aZSru");



"use client";
const $62f4b3992b48630e$var$ModalBody = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'modal-body');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$62f4b3992b48630e$var$ModalBody.displayName = 'ModalBody';
var $62f4b3992b48630e$export$2e2bcd8739ae039 = $62f4b3992b48630e$var$ModalBody;



var $aZSru = parcelRequire("aZSru");
"use client";
const $b53269eaf5c24589$var$ModalContext = /*#__PURE__*/ $aZSru.createContext({
    onHide () {}
});
var $b53269eaf5c24589$export$2e2bcd8739ae039 = $b53269eaf5c24589$var$ModalContext;




var $aZSru = parcelRequire("aZSru");


"use client";
const $8013c3975077c6bf$var$ModalDialog = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, contentClassName: contentClassName, centered: centered, size: size, fullscreen: fullscreen, children: children, scrollable: scrollable, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const dialogClass = `${bsPrefix}-dialog`;
    const fullScreenClass = typeof fullscreen === 'string' ? `${bsPrefix}-fullscreen-${fullscreen}` : `${bsPrefix}-fullscreen`;
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(dialogClass, className, size && `${bsPrefix}-${size}`, centered && `${dialogClass}-centered`, scrollable && `${dialogClass}-scrollable`, fullscreen && fullScreenClass),
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(`${bsPrefix}-content`, contentClassName),
            children: children
        })
    });
});
$8013c3975077c6bf$var$ModalDialog.displayName = 'ModalDialog';
var $8013c3975077c6bf$export$2e2bcd8739ae039 = $8013c3975077c6bf$var$ModalDialog;



var $aZSru = parcelRequire("aZSru");



"use client";
const $7888319058435823$var$ModalFooter = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'modal-footer');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$7888319058435823$var$ModalFooter.displayName = 'ModalFooter';
var $7888319058435823$export$2e2bcd8739ae039 = $7888319058435823$var$ModalFooter;




var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");

var $881de41d83720631$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ var $881de41d83720631$var$ReactIs, $881de41d83720631$var$throwOnDirectAccess;

// By explicitly using `prop-types` you are opting into new production behavior.
// http://fb.me/prop-types-in-prod
$881de41d83720631$exports = (parcelRequire("bNXdN"))();



var $aZSru = parcelRequire("aZSru");


const $28b70858a725e27d$var$propTypes = {
    /** An accessible label indicating the relevant information about the Close Button. */ 'aria-label': (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).string,
    /** A callback fired after the Close Button is clicked. */ onClick: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).func,
    /**
   * Render different color variant for the button.
   *
   * Omitting this will render the default dark color.
   */ variant: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).oneOf([
        'white'
    ])
};
const $28b70858a725e27d$var$CloseButton = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, variant: variant, 'aria-label': ariaLabel = 'Close', ...props }, ref)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("button", {
        ref: ref,
        type: "button",
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))('btn-close', variant && `btn-close-${variant}`, className),
        "aria-label": ariaLabel,
        ...props
    }));
$28b70858a725e27d$var$CloseButton.displayName = 'CloseButton';
$28b70858a725e27d$var$CloseButton.propTypes = $28b70858a725e27d$var$propTypes;
var $28b70858a725e27d$export$2e2bcd8739ae039 = $28b70858a725e27d$var$CloseButton;




"use client";
const $1b8c24e6ae54dfb7$var$AbstractModalHeader = /*#__PURE__*/ $aZSru.forwardRef(({ closeLabel: closeLabel = 'Close', closeVariant: closeVariant, closeButton: closeButton = false, onHide: onHide, children: children, ...props }, ref)=>{
    const context = (0, $aZSru.useContext)((0, $b53269eaf5c24589$export$2e2bcd8739ae039));
    const handleClick = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)(()=>{
        context == null || context.onHide();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
        ref: ref,
        ...props,
        children: [
            children,
            closeButton && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $28b70858a725e27d$export$2e2bcd8739ae039), {
                "aria-label": closeLabel,
                variant: closeVariant,
                onClick: handleClick
            })
        ]
    });
});
$1b8c24e6ae54dfb7$var$AbstractModalHeader.displayName = 'AbstractModalHeader';
var $1b8c24e6ae54dfb7$export$2e2bcd8739ae039 = $1b8c24e6ae54dfb7$var$AbstractModalHeader;



"use client";
const $a67cefd604df3b8e$var$ModalHeader = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'modal-header');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $1b8c24e6ae54dfb7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$a67cefd604df3b8e$var$ModalHeader.displayName = 'ModalHeader';
var $a67cefd604df3b8e$export$2e2bcd8739ae039 = $a67cefd604df3b8e$var$ModalHeader;



var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");


var $b8cdaec40b680c86$export$2e2bcd8739ae039 = (className)=>/*#__PURE__*/ // eslint-disable-next-line react/display-name
    $aZSru.forwardRef((p, ref)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            ...p,
            ref: ref,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(p.className, className)
        }));




"use client";
const $22be01e174bb5682$var$DivStyledAsH4 = (0, $b8cdaec40b680c86$export$2e2bcd8739ae039)('h4');
const $22be01e174bb5682$var$ModalTitle = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $22be01e174bb5682$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'modal-title');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$22be01e174bb5682$var$ModalTitle.displayName = 'ModalTitle';
var $22be01e174bb5682$export$2e2bcd8739ae039 = $22be01e174bb5682$var$ModalTitle;




"use client";
function $759954fadbb369bc$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $75d062e47e20887d$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
function $759954fadbb369bc$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $75d062e47e20887d$export$2e2bcd8739ae039), {
        ...props,
        timeout: null
    });
}
const $759954fadbb369bc$var$Modal = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, style: style, dialogClassName: dialogClassName, contentClassName: contentClassName, children: children, dialogAs: Dialog = (0, $8013c3975077c6bf$export$2e2bcd8739ae039), 'data-bs-theme': dataBsTheme, 'aria-labelledby': ariaLabelledby, 'aria-describedby': ariaDescribedby, 'aria-label': ariaLabel, show: /* BaseModal props */ show = false, animation: animation = true, backdrop: backdrop = true, keyboard: keyboard = true, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, ...props }, ref)=>{
    const [modalStyle, setStyle] = (0, $aZSru.useState)({});
    const [animateStaticModal, setAnimateStaticModal] = (0, $aZSru.useState)(false);
    const waitingForMouseUpRef = (0, $aZSru.useRef)(false);
    const ignoreBackdropClickRef = (0, $aZSru.useRef)(false);
    const removeStaticModalAnimationRef = (0, $aZSru.useRef)(null);
    const [modal, setModalRef] = (0, $82c614494db0315a$export$2e2bcd8739ae039)();
    const mergedRef = (0, $dfc8aef1afa68cbb$export$2e2bcd8739ae039)(ref, setModalRef);
    const handleHide = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)(onHide);
    const isRTL = (0, $7c127cff4998859a$export$35e511eefa30ac5a)();
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'modal');
    const modalContext = (0, $aZSru.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        return (0, $9000de8b194da122$export$a03641438014b436)({
            isRTL: isRTL
        });
    }
    function updateDialogStyle(node) {
        if (!(0, $d74d83caf9feb6ec$export$2e2bcd8739ae039)) return;
        const containerIsOverflowing = getModalManager().getScrollbarWidth() > 0;
        const modalIsOverflowing = node.scrollHeight > (0, $0948e8b135437cc0$export$2e2bcd8739ae039)(node).documentElement.clientHeight;
        setStyle({
            paddingRight: containerIsOverflowing && !modalIsOverflowing ? (0, $0a701287a48181ce$export$2e2bcd8739ae039)() : undefined,
            paddingLeft: !containerIsOverflowing && modalIsOverflowing ? (0, $0a701287a48181ce$export$2e2bcd8739ae039)() : undefined
        });
    }
    const handleWindowResize = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)(()=>{
        if (modal) updateDialogStyle(modal.dialog);
    });
    (0, $d4fe19c6dc8995e6$export$2e2bcd8739ae039)(()=>{
        (0, $0e8cc2312f875d83$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
    });
    // We prevent the modal from closing during a drag by detecting where the
    // click originates from. If it starts in the modal and then ends outside
    // don't close.
    const handleDialogMouseDown = ()=>{
        waitingForMouseUpRef.current = true;
    };
    const handleMouseUp = (e)=>{
        if (waitingForMouseUpRef.current && modal && e.target === modal.dialog) ignoreBackdropClickRef.current = true;
        waitingForMouseUpRef.current = false;
    };
    const handleStaticModalAnimation = ()=>{
        setAnimateStaticModal(true);
        removeStaticModalAnimationRef.current = (0, $4ef3015a5648ec5e$export$2e2bcd8739ae039)(modal.dialog, ()=>{
            setAnimateStaticModal(false);
        });
    };
    const handleStaticBackdropClick = (e)=>{
        if (e.target !== e.currentTarget) return;
        handleStaticModalAnimation();
    };
    const handleClick = (e)=>{
        if (backdrop === 'static') {
            handleStaticBackdropClick(e);
            return;
        }
        if (ignoreBackdropClickRef.current || e.target !== e.currentTarget) {
            ignoreBackdropClickRef.current = false;
            return;
        }
        onHide == null || onHide();
    };
    const handleEscapeKeyDown = (e)=>{
        if (keyboard) onEscapeKeyDown == null || onEscapeKeyDown(e);
        else {
            // Call preventDefault to stop modal from closing in @restart/ui.
            e.preventDefault();
            if (backdrop === 'static') // Play static modal animation.
            handleStaticModalAnimation();
        }
    };
    const handleEnter = (node, isAppearing)=>{
        if (node) updateDialogStyle(node);
        onEnter == null || onEnter(node, isAppearing);
    };
    const handleExit = (node)=>{
        removeStaticModalAnimationRef.current == null || removeStaticModalAnimationRef.current();
        onExit == null || onExit(node);
    };
    const handleEntering = (node, isAppearing)=>{
        onEntering == null || onEntering(node, isAppearing);
        // FIXME: This should work even when animation is disabled.
        (0, $eeb6ca5e41ee8cd7$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const handleExited = (node)=>{
        if (node) node.style.display = ''; // RHL removes it sometimes
        onExited == null || onExited(node);
        // FIXME: This should work even when animation is disabled.
        (0, $0e8cc2312f875d83$export$2e2bcd8739ae039)(window, 'resize', handleWindowResize);
    };
    const renderBackdrop = (0, $aZSru.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(`${bsPrefix}-backdrop`, backdropClassName, !animation && 'show')
        }), [
        animation,
        backdropClassName,
        bsPrefix
    ]);
    const baseModalStyle = {
        ...style,
        ...modalStyle
    };
    // If `display` is not set to block, autoFocus inside the modal fails
    // https://github.com/react-bootstrap/react-bootstrap/issues/5102
    baseModalStyle.display = 'block';
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            role: "dialog",
            ...dialogProps,
            style: baseModalStyle,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, animateStaticModal && `${bsPrefix}-static`, !animation && 'show'),
            onClick: backdrop ? handleClick : undefined,
            onMouseUp: handleMouseUp,
            "data-bs-theme": dataBsTheme,
            "aria-label": ariaLabel,
            "aria-labelledby": ariaLabelledby,
            "aria-describedby": ariaDescribedby,
            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Dialog, {
                ...props,
                onMouseDown: handleDialogMouseDown,
                className: dialogClassName,
                contentClassName: contentClassName,
                children: children
            })
        });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b53269eaf5c24589$export$2e2bcd8739ae039).Provider, {
        value: modalContext,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $8fd58f8475a0c86a$export$2e2bcd8739ae039), {
            show: show,
            ref: mergedRef,
            backdrop: backdrop,
            container: container,
            keyboard: true // Always set true - see handleEscapeKeyDown
            ,
            autoFocus: autoFocus,
            enforceFocus: enforceFocus,
            restoreFocus: restoreFocus,
            restoreFocusOptions: restoreFocusOptions,
            onEscapeKeyDown: handleEscapeKeyDown,
            onShow: onShow,
            onHide: onHide,
            onEnter: handleEnter,
            onEntering: handleEntering,
            onEntered: onEntered,
            onExit: handleExit,
            onExiting: onExiting,
            onExited: handleExited,
            manager: getModalManager(),
            transition: animation ? $759954fadbb369bc$var$DialogTransition : undefined,
            backdropTransition: animation ? $759954fadbb369bc$var$BackdropTransition : undefined,
            renderBackdrop: renderBackdrop,
            renderDialog: renderDialog
        })
    });
});
$759954fadbb369bc$var$Modal.displayName = 'Modal';
var $759954fadbb369bc$export$2e2bcd8739ae039 = Object.assign($759954fadbb369bc$var$Modal, {
    Body: (0, $62f4b3992b48630e$export$2e2bcd8739ae039),
    Header: (0, $a67cefd604df3b8e$export$2e2bcd8739ae039),
    Title: (0, $22be01e174bb5682$export$2e2bcd8739ae039),
    Footer: (0, $7888319058435823$export$2e2bcd8739ae039),
    Dialog: (0, $8013c3975077c6bf$export$2e2bcd8739ae039),
    TRANSITION_DURATION: 300,
    BACKDROP_TRANSITION_DURATION: 150
});




var $aZSru = parcelRequire("aZSru");

function $e976e77cda1edce6$export$c1cbdee04e18ea8b({ observable: observable, children: children }) {
    const setValueTimeout = (0, $aZSru.useRef)(0);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const instanceName = (0, $ff1fe7435e7c9214$export$bb389a67188b58a7)("Observer");
    const prevObservable = (0, $aZSru.useRef)(undefined);
    const unsubscriber = (0, $aZSru.useRef)(undefined);
    const [value, setValue] = (0, $aZSru.useState)(subscribe);
    if (prevObservable.current !== observable) setValue(subscribe());
    (0, $aZSru.useEffect)(()=>unsubscribe, []);
    return children(value);
    function subscribe() {
        unsubscribe();
        prevObservable.current = observable;
        unsubscriber.current = observable.subscribe((v)=>{
            // console.log(`${instanceName} got %O`, v);
            // delay to avoid recursive updates in react because that makes it sad
            if (setValueTimeout.current) window.clearTimeout(setValueTimeout.current);
            setValueTimeout.current = window.setTimeout(()=>{
                setValueTimeout.current = 0;
                setValue(v);
            }, 0);
        });
        const value = observable.getValue();
        // console.log(`${instanceName} set to %O`, value);
        return value;
    }
    function unsubscribe() {
        if (setValueTimeout.current) {
            window.clearTimeout(setValueTimeout.current);
            setValueTimeout.current = 0;
        }
        if (unsubscriber.current) unsubscriber.current();
    }
}


const $5e84440fc542f600$export$b8704437d11c7fe7 = ({ children: children, primaryButtonText: primaryButtonText, onDismiss: onDismiss })=>{
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        show: true,
        onHide: ()=>onDismiss(false),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Are you sure?"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: children
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "danger",
                        onClick: ()=>onDismiss(true),
                        children: primaryButtonText
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: ()=>onDismiss(false),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
};
let $5e84440fc542f600$var$nextDialogId = 0;
const $5e84440fc542f600$var$dialogs = new (0, $aedc866c4cacb991$export$2b76b04f92326cd)([]);
function $5e84440fc542f600$export$61e0a65f251cfdb3(renderDialog) {
    const id = $5e84440fc542f600$var$nextDialogId++;
    const remover = ()=>{
        $5e84440fc542f600$var$dialogs.setValue($5e84440fc542f600$var$dialogs.getValue().filter((d)=>d.id !== id));
    };
    const renderer = ()=>renderDialog(remover);
    $5e84440fc542f600$var$dialogs.push({
        id: id,
        renderDialog: renderer
    });
}
function $5e84440fc542f600$export$add63f471a2df484(text, primaryButtonText) {
    return new Promise((resolve)=>{
        $5e84440fc542f600$export$61e0a65f251cfdb3((onDismiss)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($5e84440fc542f600$export$b8704437d11c7fe7, {
                primaryButtonText: primaryButtonText,
                onDismiss: (confirmed)=>{
                    onDismiss();
                    resolve(confirmed);
                },
                children: text
            }));
    });
}
function $5e84440fc542f600$var$DialogManager({ dialogs: dialogs }) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
        observable: dialogs,
        children: (observedDialogs)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                className: "dialogs",
                children: observedDialogs.map((d)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                        children: d.renderDialog()
                    }, d.id))
            })
    });
}
const $5e84440fc542f600$export$c907ef9a792ea8cb = ()=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($5e84440fc542f600$var$DialogManager, {
        dialogs: $5e84440fc542f600$var$dialogs
    });




var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");
function $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039() {
    return $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039 = Object.assign ? Object.assign.bind() : function(n) {
        for(var e = 1; e < arguments.length; e++){
            var t = arguments[e];
            for(var r in t)({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
        }
        return n;
    }, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039.apply(null, arguments);
}




var $aZSru = parcelRequire("aZSru");
var $6982d5f9fda9f777$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $6982d5f9fda9f777$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = 'Invariant Violation';
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$6982d5f9fda9f777$exports = $6982d5f9fda9f777$var$invariant;


var $d48da1367c961ae7$var$noop = function noop() {};
function $d48da1367c961ae7$var$readOnlyPropType(handler, name) {
    return function(props, propName) {
        if (props[propName] !== undefined) {
            if (!props[handler]) return new Error("You have provided a `" + propName + "` prop to `" + name + "` " + ("without an `" + handler + "` handler prop. This will render a read-only field. ") + ("If the field should be mutable use `" + $d48da1367c961ae7$export$26cbf8c37e721e67(propName) + "`. ") + ("Otherwise, set `" + handler + "`."));
        }
    };
}
function $d48da1367c961ae7$export$8abd944bed26e726(controlledValues, displayName) {
    var propTypes = {};
    Object.keys(controlledValues).forEach(function(prop) {
        // add default propTypes for folks that use runtime checks
        propTypes[$d48da1367c961ae7$export$26cbf8c37e721e67(prop)] = $d48da1367c961ae7$var$noop;
        var handler;
    });
    return propTypes;
}
function $d48da1367c961ae7$export$12ae2baa35bd9b8b(props, prop) {
    return props[prop] !== undefined;
}
function $d48da1367c961ae7$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $d48da1367c961ae7$export$95e5b18573b29087(component) {
    return !!component && (typeof component !== 'function' || component.prototype && component.prototype.isReactComponent);
}


function $1df078ddfa34638e$var$_toPropertyKey(arg) {
    var key = $1df078ddfa34638e$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $1df078ddfa34638e$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $1df078ddfa34638e$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    var wasPropRef = (0, $aZSru.useRef)(propValue !== undefined);
    var _useState = (0, $aZSru.useState)(defaultValue), stateValue = _useState[0], setState = _useState[1];
    var isProp = propValue !== undefined;
    var wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $aZSru.useCallback)(function(value) {
            for(var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++)args[_key - 1] = arguments[_key];
            if (handler) handler.apply(void 0, [
                value
            ].concat(args));
            setState(value);
        }, [
            handler
        ])
    ];
}
function $1df078ddfa34638e$export$2e2bcd8739ae039(props, config) {
    return Object.keys(config).reduce(function(result, fieldName) {
        var _extends2;
        var _ref = result, defaultValue = _ref[$d48da1367c961ae7$export$26cbf8c37e721e67(fieldName)], propsValue = _ref[fieldName], rest = (0, $1f98745f98dacb58$export$2e2bcd8739ae039)(_ref, [
            $d48da1367c961ae7$export$26cbf8c37e721e67(fieldName),
            fieldName
        ].map($1df078ddfa34638e$var$_toPropertyKey));
        var handlerName = config[fieldName];
        var _useUncontrolledProp = $1df078ddfa34638e$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]), value = _useUncontrolledProp[0], handler = _useUncontrolledProp[1];
        return (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)({}, rest, (_extends2 = {}, _extends2[fieldName] = value, _extends2[handlerName] = handler, _extends2));
    }, props);
}






var $aZSru = parcelRequire("aZSru");
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ function $99d95cfefb31f27e$var$componentWillMount() {
    // Call this.constructor.gDSFP to support sub-classes.
    var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
    if (state !== null && state !== undefined) this.setState(state);
}
function $99d95cfefb31f27e$var$componentWillReceiveProps(nextProps) {
    // Call this.constructor.gDSFP to support sub-classes.
    // Use the setState() updater to ensure state isn't stale in certain edge cases.
    function updater(prevState) {
        var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
        return state !== null && state !== undefined ? state : null;
    }
    // Binding "this" is important for shallow renderer support.
    this.setState(updater.bind(this));
}
function $99d95cfefb31f27e$var$componentWillUpdate(nextProps, nextState) {
    try {
        var prevProps = this.props;
        var prevState = this.state;
        this.props = nextProps;
        this.state = nextState;
        this.__reactInternalSnapshotFlag = true;
        this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(prevProps, prevState);
    } finally{
        this.props = prevProps;
        this.state = prevState;
    }
}
// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
$99d95cfefb31f27e$var$componentWillMount.__suppressDeprecationWarning = true;
$99d95cfefb31f27e$var$componentWillReceiveProps.__suppressDeprecationWarning = true;
$99d95cfefb31f27e$var$componentWillUpdate.__suppressDeprecationWarning = true;
function $99d95cfefb31f27e$export$cea1c58a6db52bca(Component) {
    var prototype = Component.prototype;
    if (!prototype || !prototype.isReactComponent) throw new Error('Can only polyfill class components');
    if (typeof Component.getDerivedStateFromProps !== 'function' && typeof prototype.getSnapshotBeforeUpdate !== 'function') return Component;
    // If new component APIs are defined, "unsafe" lifecycles won't be called.
    // Error if any of these lifecycles are present,
    // Because they would work differently between older and newer (16.3+) versions of React.
    var foundWillMountName = null;
    var foundWillReceivePropsName = null;
    var foundWillUpdateName = null;
    if (typeof prototype.componentWillMount === 'function') foundWillMountName = 'componentWillMount';
    else if (typeof prototype.UNSAFE_componentWillMount === 'function') foundWillMountName = 'UNSAFE_componentWillMount';
    if (typeof prototype.componentWillReceiveProps === 'function') foundWillReceivePropsName = 'componentWillReceiveProps';
    else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
    if (typeof prototype.componentWillUpdate === 'function') foundWillUpdateName = 'componentWillUpdate';
    else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') foundWillUpdateName = 'UNSAFE_componentWillUpdate';
    if (foundWillMountName !== null || foundWillReceivePropsName !== null || foundWillUpdateName !== null) {
        var componentName = Component.displayName || Component.name;
        var newApiName = typeof Component.getDerivedStateFromProps === 'function' ? 'getDerivedStateFromProps()' : 'getSnapshotBeforeUpdate()';
        throw Error('Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' + componentName + ' uses ' + newApiName + ' but also contains the following legacy lifecycles:' + (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') + (foundWillReceivePropsName !== null ? '\n  ' + foundWillReceivePropsName : '') + (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') + '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' + 'https://fb.me/react-async-component-lifecycle-hooks');
    }
    // React <= 16.2 does not support static getDerivedStateFromProps.
    // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
    // Newer versions of React will ignore these lifecycles if gDSFP exists.
    if (typeof Component.getDerivedStateFromProps === 'function') {
        prototype.componentWillMount = $99d95cfefb31f27e$var$componentWillMount;
        prototype.componentWillReceiveProps = $99d95cfefb31f27e$var$componentWillReceiveProps;
    }
    // React <= 16.2 does not support getSnapshotBeforeUpdate.
    // As a workaround, use cWU to invoke the new lifecycle.
    // Newer versions of React will ignore that lifecycle if gSBU exists.
    if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
        if (typeof prototype.componentDidUpdate !== 'function') throw new Error('Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype');
        prototype.componentWillUpdate = $99d95cfefb31f27e$var$componentWillUpdate;
        var componentDidUpdate = prototype.componentDidUpdate;
        prototype.componentDidUpdate = function componentDidUpdatePolyfill(prevProps, prevState, maybeSnapshot) {
            // 16.3+ will not execute our will-update method;
            // It will pass a snapshot value to did-update though.
            // Older versions will require our polyfilled will-update value.
            // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
            // Because for <= 15.x versions this might be a "prevContext" object.
            // We also can't just check "__reactInternalSnapshot",
            // Because get-snapshot might return a falsy value.
            // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
            var snapshot = this.__reactInternalSnapshotFlag ? this.__reactInternalSnapshot : maybeSnapshot;
            componentDidUpdate.call(this, prevProps, prevState, snapshot);
        };
    }
    return Component;
}




var $9b7e24a311cfafc2$var$_jsxFileName = "/Users/jquense/src/uncontrollable/src/uncontrollable.js";
function $9b7e24a311cfafc2$export$2e2bcd8739ae039(Component, controlledValues, methods) {
    if (methods === void 0) methods = [];
    var displayName = Component.displayName || Component.name || 'Component';
    var canAcceptRef = $d48da1367c961ae7$export$95e5b18573b29087(Component);
    var controlledProps = Object.keys(controlledValues);
    var PROPS_TO_OMIT = controlledProps.map($d48da1367c961ae7$export$26cbf8c37e721e67);
    !(canAcceptRef || !methods.length) && (0, (/*@__PURE__*/$parcel$interopDefault($6982d5f9fda9f777$exports)))(false);
    var UncontrolledComponent = /*#__PURE__*/ function(_React$Component) {
        (0, $58313b8798d38f75$export$2e2bcd8739ae039)(UncontrolledComponent, _React$Component);
        function UncontrolledComponent() {
            var _this;
            for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
            _this = _React$Component.call.apply(_React$Component, [
                this
            ].concat(args)) || this;
            _this.handlers = Object.create(null);
            controlledProps.forEach(function(propName) {
                var handlerName = controlledValues[propName];
                var handleChange = function handleChange(value) {
                    if (_this.props[handlerName]) {
                        var _this$props;
                        _this._notifying = true;
                        for(var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++)args[_key2 - 1] = arguments[_key2];
                        (_this$props = _this.props)[handlerName].apply(_this$props, [
                            value
                        ].concat(args));
                        _this._notifying = false;
                    }
                    if (!_this.unmounted) _this.setState(function(_ref) {
                        var _extends2;
                        var values = _ref.values;
                        return {
                            values: (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)(Object.create(null), values, (_extends2 = {}, _extends2[propName] = value, _extends2))
                        };
                    });
                };
                _this.handlers[handlerName] = handleChange;
            });
            if (methods.length) _this.attachRef = function(ref) {
                _this.inner = ref;
            };
            var values = Object.create(null);
            controlledProps.forEach(function(key) {
                values[key] = _this.props[$d48da1367c961ae7$export$26cbf8c37e721e67(key)];
            });
            _this.state = {
                values: values,
                prevProps: {}
            };
            return _this;
        }
        var _proto = UncontrolledComponent.prototype;
        _proto.shouldComponentUpdate = function shouldComponentUpdate() {
            //let setState trigger the update
            return !this._notifying;
        };
        UncontrolledComponent.getDerivedStateFromProps = function getDerivedStateFromProps(props, _ref2) {
            var values = _ref2.values, prevProps = _ref2.prevProps;
            var nextState = {
                values: (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)(Object.create(null), values),
                prevProps: {}
            };
            controlledProps.forEach(function(key) {
                /**
         * If a prop switches from controlled to Uncontrolled
         * reset its value to the defaultValue
         */ nextState.prevProps[key] = props[key];
                if (!$d48da1367c961ae7$export$12ae2baa35bd9b8b(props, key) && $d48da1367c961ae7$export$12ae2baa35bd9b8b(prevProps, key)) nextState.values[key] = props[$d48da1367c961ae7$export$26cbf8c37e721e67(key)];
            });
            return nextState;
        };
        _proto.componentWillUnmount = function componentWillUnmount() {
            this.unmounted = true;
        };
        _proto.render = function render() {
            var _this2 = this;
            var _this$props2 = this.props, innerRef = _this$props2.innerRef, props = (0, $1f98745f98dacb58$export$2e2bcd8739ae039)(_this$props2, [
                "innerRef"
            ]);
            PROPS_TO_OMIT.forEach(function(prop) {
                delete props[prop];
            });
            var newProps = {};
            controlledProps.forEach(function(propName) {
                var propValue = _this2.props[propName];
                newProps[propName] = propValue !== undefined ? propValue : _this2.state.values[propName];
            });
            return (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement(Component, (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)({}, props, newProps, this.handlers, {
                ref: innerRef || this.attachRef
            }));
        };
        return UncontrolledComponent;
    }((0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).Component);
    (0, $99d95cfefb31f27e$export$cea1c58a6db52bca)(UncontrolledComponent);
    UncontrolledComponent.displayName = "Uncontrolled(" + displayName + ")";
    UncontrolledComponent.propTypes = (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)({
        innerRef: function innerRef() {}
    }, $d48da1367c961ae7$export$8abd944bed26e726(controlledValues, displayName));
    methods.forEach(function(method) {
        UncontrolledComponent.prototype[method] = function $proxiedMethod() {
            var _this$inner;
            return (_this$inner = this.inner)[method].apply(_this$inner, arguments);
        };
    });
    var WrappedComponent = UncontrolledComponent;
    if ((0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).forwardRef) {
        WrappedComponent = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).forwardRef(function(props, ref) {
            return (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement(UncontrolledComponent, (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)({}, props, {
                innerRef: ref,
                __source: {
                    fileName: $9b7e24a311cfafc2$var$_jsxFileName,
                    lineNumber: 128
                },
                __self: this
            }));
        });
        WrappedComponent.propTypes = UncontrolledComponent.propTypes;
    }
    WrappedComponent.ControlledComponent = Component;
    /**
   * useful when wrapping a Component and you want to control
   * everything
   */ WrappedComponent.deferControlTo = function(newComponent, additions, nextMethods) {
        if (additions === void 0) additions = {};
        return $9b7e24a311cfafc2$export$2e2bcd8739ae039(newComponent, (0, $d2e3aa4d30e8a2e8$export$2e2bcd8739ae039)({}, controlledValues, additions), nextMethods);
    };
    return WrappedComponent;
}







var $aZSru = parcelRequire("aZSru");




"use client";
const $c7a3ba9a6b966f39$var$DivStyledAsH4 = (0, $b8cdaec40b680c86$export$2e2bcd8739ae039)('h4');
$c7a3ba9a6b966f39$var$DivStyledAsH4.displayName = 'DivStyledAsH4';
const $c7a3ba9a6b966f39$var$AlertHeading = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $c7a3ba9a6b966f39$var$DivStyledAsH4, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'alert-heading');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$c7a3ba9a6b966f39$var$AlertHeading.displayName = 'AlertHeading';
var $c7a3ba9a6b966f39$export$2e2bcd8739ae039 = $c7a3ba9a6b966f39$var$AlertHeading;



var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
function $59a38f3069ca3009$export$2e2bcd8739ae039() {
    return (0, $aZSru.useState)(null);
}





var $aZSru = parcelRequire("aZSru");

function $54456e04bbc1b0f1$export$2e2bcd8739ae039(eventTarget, event, listener, capture = false) {
    const handler = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(listener);
    (0, $aZSru.useEffect)(()=>{
        const target = typeof eventTarget === 'function' ? eventTarget() : eventTarget;
        target.addEventListener(event, handler, capture);
        return ()=>target.removeEventListener(event, handler, capture);
    }, [
        eventTarget
    ]);
}




var $aZSru = parcelRequire("aZSru");
function $6b2cc9f0135e4a98$export$2e2bcd8739ae039(event, handler, capture = false) {
    const documentTarget = (0, $aZSru.useCallback)(()=>document, []);
    return (0, $54456e04bbc1b0f1$export$2e2bcd8739ae039)(documentTarget, event, handler, capture);
}



var $aZSru = parcelRequire("aZSru");

/**
 * Creates a `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  function Timer() {
 *    const [timer, setTimer] = useState(0)
 *    useInterval(() => setTimer(i => i + 1), 1000)
 *
 *    return <span>{timer} seconds past</span>
 *  }
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 */ /**
 * Creates a pausable `setInterval` that is properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [paused, setPaused] = useState(false)
 *  const [timer, setTimer] = useState(0)
 *
 *  useInterval(() => setTimer(i => i + 1), 1000, paused)
 *
 *  return (
 *    <span>
 *      {timer} seconds past
 *
 *      <button onClick={() => setPaused(p => !p)}>{paused ? 'Play' : 'Pause' }</button>
 *    </span>
 * )
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 */ /**
 * Creates a pausable `setInterval` that _fires_ immediately and is
 * properly cleaned up when a component unmounted
 *
 * ```tsx
 *  const [timer, setTimer] = useState(-1)
 *  useInterval(() => setTimer(i => i + 1), 1000, false, true)
 *
 *  // will update to 0 on the first effect
 *  return <span>{timer} seconds past</span>
 * ```
 *
 * @param fn an function run on each interval
 * @param ms The milliseconds duration of the interval
 * @param paused Whether or not the interval is currently running
 * @param runImmediately Whether to run the function immediately on mount or unpause
 * rather than waiting for the first interval to elapse
 *

 */ function $c343020dff5afd59$var$useInterval(fn, ms, paused = false, runImmediately = false) {
    let handle;
    const fnRef = (0, $06f3026ef7ede8e0$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $06f3026ef7ede8e0$export$2e2bcd8739ae039)(paused);
    const tick = ()=>{
        if (pausedRef.current) return;
        fnRef.current();
        schedule(); // eslint-disable-line no-use-before-define
    };
    const schedule = ()=>{
        clearTimeout(handle);
        handle = setTimeout(tick, ms);
    };
    (0, $aZSru.useEffect)(()=>{
        if (runImmediately) tick();
        else schedule();
        return ()=>clearTimeout(handle);
    }, [
        paused,
        runImmediately
    ]);
}
var $c343020dff5afd59$export$2e2bcd8739ae039 = $c343020dff5afd59$var$useInterval;



var $aZSru = parcelRequire("aZSru");

function $8f714b399883abdf$var$useRafInterval(fn, ms, paused = false) {
    let handle;
    let start = new Date().getTime();
    const fnRef = (0, $06f3026ef7ede8e0$export$2e2bcd8739ae039)(fn);
    // this ref is necessary b/c useEffect will sometimes miss a paused toggle
    // orphaning a setTimeout chain in the aether, so relying on it's refresh logic is not reliable.
    const pausedRef = (0, $06f3026ef7ede8e0$export$2e2bcd8739ae039)(paused);
    function loop() {
        const current = new Date().getTime();
        const delta = current - start;
        if (pausedRef.current) return;
        if (delta >= ms && fnRef.current) {
            fnRef.current();
            start = new Date().getTime();
        }
        cancelAnimationFrame(handle);
        handle = requestAnimationFrame(loop);
    }
    (0, $aZSru.useEffect)(()=>{
        handle = requestAnimationFrame(loop);
        return ()=>cancelAnimationFrame(handle);
    }, []);
}
var $8f714b399883abdf$export$2e2bcd8739ae039 = $8f714b399883abdf$var$useRafInterval;



var $aZSru = parcelRequire("aZSru");
function $b726f5500aca1807$export$2e2bcd8739ae039(initialState) {
    const [state, setState] = (0, $aZSru.useState)(initialState);
    const updater = (0, $aZSru.useCallback)((update)=>{
        if (update === null) return;
        if (typeof update === 'function') setState((state)=>{
            const nextState = update(state);
            return nextState == null ? state : Object.assign({}, state, nextState);
        });
        else setState((state)=>Object.assign({}, state, update));
    }, [
        setState
    ]);
    return [
        state,
        updater
    ];
}



function $98ef78e935dbe1cd$export$2e2bcd8739ae039(props, gDSFP, initialState) {
    const [state, setState] = (0, $b726f5500aca1807$export$2e2bcd8739ae039)(initialState);
    const nextState = gDSFP(props, state);
    if (nextState !== null) setState(nextState);
    return [
        state,
        setState
    ];
}





var $aZSru = parcelRequire("aZSru");
function $35bd6619d02928cc$export$2e2bcd8739ae039(imageOrUrl, crossOrigin) {
    const [state, setState] = (0, $aZSru.useState)({
        image: null,
        error: null
    });
    (0, $aZSru.useEffect)(()=>{
        if (!imageOrUrl) return undefined;
        let image;
        if (typeof imageOrUrl === 'string') {
            image = new Image();
            if (crossOrigin) image.crossOrigin = crossOrigin;
            image.src = imageOrUrl;
        } else {
            image = imageOrUrl;
            if (image.complete && image.naturalHeight > 0) {
                setState({
                    image: image,
                    error: null
                });
                return;
            }
        }
        function onLoad() {
            setState({
                image: image,
                error: null
            });
        }
        function onError(error) {
            setState({
                image: image,
                error: error
            });
        }
        image.addEventListener('load', onLoad);
        image.addEventListener('error', onError);
        return ()=>{
            image.removeEventListener('load', onLoad);
            image.removeEventListener('error', onError);
        };
    }, [
        imageOrUrl,
        crossOrigin
    ]);
    return state;
}



var $aZSru = parcelRequire("aZSru");

const $ebb9ce3f2b9ef568$var$targetMap = new WeakMap();
let $ebb9ce3f2b9ef568$var$resizeObserver;
function $ebb9ce3f2b9ef568$var$getResizeObserver() {
    // eslint-disable-next-line no-return-assign
    return $ebb9ce3f2b9ef568$var$resizeObserver = $ebb9ce3f2b9ef568$var$resizeObserver || new window.ResizeObserver((entries)=>{
        entries.forEach((entry)=>{
            const handler = $ebb9ce3f2b9ef568$var$targetMap.get(entry.target);
            if (handler) handler(entry.contentRect);
        });
    });
}
function $ebb9ce3f2b9ef568$export$2e2bcd8739ae039(element) {
    const [rect, setRect] = (0, $aZSru.useState)(null);
    (0, $dbc6fa0f772d7f41$export$2e2bcd8739ae039)(()=>{
        if (!element) return;
        $ebb9ce3f2b9ef568$var$getResizeObserver().observe(element);
        setRect(element.getBoundingClientRect());
        $ebb9ce3f2b9ef568$var$targetMap.set(element, (rect)=>{
            setRect(rect);
        });
        return ()=>{
            $ebb9ce3f2b9ef568$var$targetMap.delete(element);
        };
    }, [
        element
    ]);
    return rect;
}






const $a0e9365cba08db2b$var$_excluded = [
    "onKeyDown"
];
function $a0e9365cba08db2b$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a0e9365cba08db2b$export$72369ab2cc99204b(href) {
    return !href || href.trim() === '#';
}
/**
 * An generic `<a>` component that covers a few A11y cases, ensuring that
 * cases where the `href` is missing or trivial like "#" are treated like buttons.
 */ const $a0e9365cba08db2b$var$Anchor = /*#__PURE__*/ $aZSru.forwardRef((_ref, ref)=>{
    let { onKeyDown: onKeyDown } = _ref, props = $a0e9365cba08db2b$var$_objectWithoutPropertiesLoose(_ref, $a0e9365cba08db2b$var$_excluded);
    const [buttonProps] = (0, $3afdd3e5f726b03e$export$a0ee72f2c720a5c3)(Object.assign({
        tagName: 'a'
    }, props));
    const handleKeyDown = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        buttonProps.onKeyDown(e);
        onKeyDown == null || onKeyDown(e);
    });
    if ($a0e9365cba08db2b$export$72369ab2cc99204b(props.href) || props.role === 'button') return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, buttonProps, {
        onKeyDown: handleKeyDown
    }));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("a", Object.assign({
        ref: ref
    }, props, {
        onKeyDown: onKeyDown
    }));
});
$a0e9365cba08db2b$var$Anchor.displayName = 'Anchor';
var $a0e9365cba08db2b$export$2e2bcd8739ae039 = $a0e9365cba08db2b$var$Anchor;




"use client";
const $0d52c37f244003c1$var$AlertLink = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = (0, $a0e9365cba08db2b$export$2e2bcd8739ae039), ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'alert-link');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$0d52c37f244003c1$var$AlertLink.displayName = 'AlertLink';
var $0d52c37f244003c1$export$2e2bcd8739ae039 = $0d52c37f244003c1$var$AlertLink;





"use client";
const $f08299be39369952$var$Alert = /*#__PURE__*/ $aZSru.forwardRef((uncontrolledProps, ref)=>{
    const { bsPrefix: bsPrefix, show: show = true, closeLabel: closeLabel = 'Close alert', closeVariant: closeVariant, className: className, children: children, variant: variant = 'primary', onClose: onClose, dismissible: dismissible, transition: transition = (0, $75d062e47e20887d$export$2e2bcd8739ae039), ...props } = (0, $1df078ddfa34638e$export$2e2bcd8739ae039)(uncontrolledProps, {
        show: 'onClose'
    });
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'alert');
    const handleClose = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)((e)=>{
        if (onClose) onClose(false, e);
    });
    const Transition = transition === true ? (0, $75d062e47e20887d$export$2e2bcd8739ae039) : transition;
    const alert = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
        role: "alert",
        ...!Transition ? props : undefined,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, prefix, variant && `${prefix}-${variant}`, dismissible && `${prefix}-dismissible`),
        children: [
            dismissible && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $28b70858a725e27d$export$2e2bcd8739ae039), {
                onClick: handleClose,
                "aria-label": closeLabel,
                variant: closeVariant
            }),
            children
        ]
    });
    if (!Transition) return show ? alert : null;
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Transition, {
        unmountOnExit: true,
        ...props,
        ref: undefined,
        in: show,
        children: alert
    });
});
$f08299be39369952$var$Alert.displayName = 'Alert';
var $f08299be39369952$export$2e2bcd8739ae039 = Object.assign($f08299be39369952$var$Alert, {
    Link: (0, $0d52c37f244003c1$export$2e2bcd8739ae039),
    Heading: (0, $c7a3ba9a6b966f39$export$2e2bcd8739ae039)
});




const $b326521242f35736$export$b060d577040138d8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createContext({
    message: undefined,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setMessage: ()=>{}
});
function $b326521242f35736$export$42de33f7652dc3de(props) {
    const [message, setMessage] = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).useState(undefined);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($b326521242f35736$export$b060d577040138d8.Provider, {
        value: {
            message: message,
            setMessage: setMessage
        },
        children: props.children
    });
}
function $b326521242f35736$export$3771c484b4b495d0({ errorCollection: errorCollection }) {
    const messageContext = (0, $aZSru.useContext)($b326521242f35736$export$b060d577040138d8);
    const location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                observable: errorCollection,
                children: (errors)=>errors.length > 0 ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "danger",
                        dismissible: true,
                        onClose: ()=>errorCollection.clear(),
                        children: errors.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                                children: e
                            }, i))
                    }) : null
            }),
            messageContext.message?.location === location.pathname && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                variant: "success",
                dismissible: true,
                onClose: ()=>messageContext.setMessage(undefined),
                children: messageContext.message.text
            })
        ]
    });
}




var $aZSru = parcelRequire("aZSru");




var $aZSru = parcelRequire("aZSru");


"use client";
function $fb07b04ce85e701b$export$2ed43d61a0a9f5a3({ as: as, bsPrefix: bsPrefix, className: className, ...props }) {
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'col');
    const breakpoints = (0, $7c127cff4998859a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $7c127cff4998859a$export$d926d6ef38f3fd32)();
    const spans = [];
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let span;
        let offset;
        let order;
        if (typeof propValue === 'object' && propValue != null) ({ span: span, offset: offset, order: order } = propValue);
        else span = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (span) spans.push(span === true ? `${bsPrefix}${infix}` : `${bsPrefix}${infix}-${span}`);
        if (order != null) classes.push(`order${infix}-${order}`);
        if (offset != null) classes.push(`offset${infix}-${offset}`);
    });
    return [
        {
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, ...spans, ...classes)
        },
        {
            as: as,
            bsPrefix: bsPrefix,
            spans: spans
        }
    ];
}
const $fb07b04ce85e701b$var$Col = /*#__PURE__*/ $aZSru.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
(props, ref)=>{
    const [{ className: className, ...colProps }, { as: Component = 'div', bsPrefix: bsPrefix, spans: spans }] = $fb07b04ce85e701b$export$2ed43d61a0a9f5a3(props);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...colProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, !spans.length && bsPrefix)
    });
});
$fb07b04ce85e701b$var$Col.displayName = 'Col';
var $fb07b04ce85e701b$export$2e2bcd8739ae039 = $fb07b04ce85e701b$var$Col;





var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");


const $d5164f32882f24e7$var$propTypes = {
    /**
   * Specify whether the feedback is for valid or invalid fields
   *
   * @type {('valid'|'invalid')}
   */ type: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).string,
    /** Display feedback as a tooltip. */ tooltip: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).elementType
};
const $d5164f32882f24e7$var$Feedback = /*#__PURE__*/ $aZSru.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ as: Component = 'div', className: className, type: type = 'valid', tooltip: tooltip = false, ...props }, ref)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, `${type}-${tooltip ? 'tooltip' : 'feedback'}`)
    }));
$d5164f32882f24e7$var$Feedback.displayName = 'Feedback';
$d5164f32882f24e7$var$Feedback.propTypes = $d5164f32882f24e7$var$propTypes;
var $d5164f32882f24e7$export$2e2bcd8739ae039 = $d5164f32882f24e7$var$Feedback;




var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
"use client";
// TODO
const $e0c63108b2824d3f$var$FormContext = /*#__PURE__*/ $aZSru.createContext({});
var $e0c63108b2824d3f$export$2e2bcd8739ae039 = $e0c63108b2824d3f$var$FormContext;




"use client";
const $3a415cff2556f253$var$FormCheckInput = /*#__PURE__*/ $aZSru.forwardRef(({ id: id, bsPrefix: bsPrefix, className: className, type: type = 'checkbox', isValid: isValid = false, isInvalid: isInvalid = false, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-check-input');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ref: ref,
        type: type,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$3a415cff2556f253$var$FormCheckInput.displayName = 'FormCheckInput';
var $3a415cff2556f253$export$2e2bcd8739ae039 = $3a415cff2556f253$var$FormCheckInput;




var $aZSru = parcelRequire("aZSru");



"use client";
const $9db5fb64964ad901$var$FormCheckLabel = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-check-label');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("label", {
        ...props,
        ref: ref,
        htmlFor: htmlFor || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix)
    });
});
$9db5fb64964ad901$var$FormCheckLabel.displayName = 'FormCheckLabel';
var $9db5fb64964ad901$export$2e2bcd8739ae039 = $9db5fb64964ad901$var$FormCheckLabel;





var $aZSru = parcelRequire("aZSru");
/**
 * Iterates through children that are typically specified as `props.children`,
 * but only maps over children that are "valid elements".
 *
 * The mapFunction provided index will be normalised to the components mapped,
 * so an invalid component would not increase the index.
 *
 */ function $a8699ea6a81c0318$export$871de8747c9eaa88(children, func) {
    let index = 0;
    return $aZSru.Children.map(children, (child)=>/*#__PURE__*/ $aZSru.isValidElement(child) ? func(child, index++) : child);
}
/**
 * Iterates through children that are "valid elements".
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child with the index reflecting the position relative to "valid components".
 */ function $a8699ea6a81c0318$export$4b80e395e36b5a56(children, func) {
    let index = 0;
    $aZSru.Children.forEach(children, (child)=>{
        if (/*#__PURE__*/ $aZSru.isValidElement(child)) func(child, index++);
    });
}
/**
 * Finds whether a component's `children` prop includes a React element of the
 * specified type.
 */ function $a8699ea6a81c0318$export$500fd6099226ffae(children, type) {
    return $aZSru.Children.toArray(children).some((child)=>/*#__PURE__*/ $aZSru.isValidElement(child) && child.type === type);
}



"use client";
const $d3f8e565ed3d069c$var$FormCheck = /*#__PURE__*/ $aZSru.forwardRef(({ id: id, bsPrefix: bsPrefix, bsSwitchPrefix: bsSwitchPrefix, inline: inline = false, reverse: reverse = false, disabled: disabled = false, isValid: isValid = false, isInvalid: isInvalid = false, feedbackTooltip: feedbackTooltip = false, feedback: feedback, feedbackType: feedbackType, className: className, style: style, title: title = '', type: type = 'checkbox', label: label, children: children, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as = 'input', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-check');
    bsSwitchPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsSwitchPrefix, 'form-switch');
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    const innerFormContext = (0, $aZSru.useMemo)(()=>({
            controlId: id || controlId
        }), [
        controlId,
        id
    ]);
    const hasLabel = !children && label != null && label !== false || (0, $a8699ea6a81c0318$export$500fd6099226ffae)(children, (0, $9db5fb64964ad901$export$2e2bcd8739ae039));
    const input = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $3a415cff2556f253$export$2e2bcd8739ae039), {
        ...props,
        type: type === 'switch' ? 'checkbox' : type,
        ref: ref,
        isValid: isValid,
        isInvalid: isInvalid,
        disabled: disabled,
        as: as
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039).Provider, {
        value: innerFormContext,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            style: style,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, hasLabel && bsPrefix, inline && `${bsPrefix}-inline`, reverse && `${bsPrefix}-reverse`, type === 'switch' && bsSwitchPrefix),
            children: children || /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
                children: [
                    input,
                    hasLabel && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $9db5fb64964ad901$export$2e2bcd8739ae039), {
                        title: title,
                        children: label
                    }),
                    feedback && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d5164f32882f24e7$export$2e2bcd8739ae039), {
                        type: feedbackType,
                        tooltip: feedbackTooltip,
                        children: feedback
                    })
                ]
            })
        })
    });
});
$d3f8e565ed3d069c$var$FormCheck.displayName = 'FormCheck';
var $d3f8e565ed3d069c$export$2e2bcd8739ae039 = Object.assign($d3f8e565ed3d069c$var$FormCheck, {
    Input: (0, $3a415cff2556f253$export$2e2bcd8739ae039),
    Label: (0, $9db5fb64964ad901$export$2e2bcd8739ae039)
});




var $aZSru = parcelRequire("aZSru");
var $e9c991cfa2287529$exports = {};
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ 'use strict';
/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */ var $e9c991cfa2287529$var$__DEV__ = false;
var $e9c991cfa2287529$var$warning = function() {};
if ($e9c991cfa2287529$var$__DEV__) {
    var $e9c991cfa2287529$var$printWarning = function printWarning(format, args) {
        var len = arguments.length;
        args = new Array(len > 1 ? len - 1 : 0);
        for(var key = 1; key < len; key++)args[key - 1] = arguments[key];
        var argIndex = 0;
        var message = 'Warning: ' + format.replace(/%s/g, function() {
            return args[argIndex++];
        });
        if (typeof console !== 'undefined') console.error(message);
        try {
            // --- Welcome to debugging React ---
            // This error was thrown as a convenience so that you can use this stack
            // to find the callsite that caused this warning to fire.
            throw new Error(message);
        } catch (x) {}
    };
    $e9c991cfa2287529$var$warning = function(condition, format, args) {
        var len = arguments.length;
        args = new Array(len > 2 ? len - 2 : 0);
        for(var key = 2; key < len; key++)args[key - 2] = arguments[key];
        if (format === undefined) throw new Error("`warning(condition, format, ...args)` requires a warning message argument");
        if (!condition) $e9c991cfa2287529$var$printWarning.apply(null, [
            format
        ].concat(args));
    };
}
$e9c991cfa2287529$exports = $e9c991cfa2287529$var$warning;






"use client";
const $6ee5219cd06472c0$var$FormControl = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, type: type, size: size, htmlSize: htmlSize, id: id, className: className, isValid: isValid = false, isInvalid: isInvalid = false, plaintext: plaintext, readOnly: readOnly, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'input', ...props }, ref)=>{
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-control');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        type: type,
        size: htmlSize,
        ref: ref,
        readOnly: readOnly,
        id: id || controlId,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, plaintext ? `${bsPrefix}-plaintext` : bsPrefix, size && `${bsPrefix}-${size}`, type === 'color' && `${bsPrefix}-color`, isValid && 'is-valid', isInvalid && 'is-invalid')
    });
});
$6ee5219cd06472c0$var$FormControl.displayName = 'FormControl';
var $6ee5219cd06472c0$export$2e2bcd8739ae039 = Object.assign($6ee5219cd06472c0$var$FormControl, {
    Feedback: $d5164f32882f24e7$export$2e2bcd8739ae039
});



var $aZSru = parcelRequire("aZSru");



"use client";
const $95df091b4461ae6e$var$FormFloating = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$95df091b4461ae6e$var$FormFloating.displayName = 'FormFloating';
var $95df091b4461ae6e$export$2e2bcd8739ae039 = $95df091b4461ae6e$var$FormFloating;



var $aZSru = parcelRequire("aZSru");


const $c415c8f0ee14d351$var$FormGroup = /*#__PURE__*/ $aZSru.forwardRef(({ controlId: controlId, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const context = (0, $aZSru.useMemo)(()=>({
            controlId: controlId
        }), [
        controlId
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
            ...props,
            ref: ref
        })
    });
});
$c415c8f0ee14d351$var$FormGroup.displayName = 'FormGroup';
var $c415c8f0ee14d351$export$2e2bcd8739ae039 = $c415c8f0ee14d351$var$FormGroup;




var $aZSru = parcelRequire("aZSru");





"use client";
const $f92b33309c85890c$var$FormLabel = /*#__PURE__*/ $aZSru.forwardRef(({ // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'label', bsPrefix: bsPrefix, column: column = false, visuallyHidden: visuallyHidden = false, className: className, htmlFor: htmlFor, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-label');
    let columnClass = 'col-form-label';
    if (typeof column === 'string') columnClass = `${columnClass} ${columnClass}-${column}`;
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, visuallyHidden && 'visually-hidden', column && columnClass);
    htmlFor = htmlFor || controlId;
    if (column) return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
        ref: ref,
        as: "label",
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: classes,
        htmlFor: htmlFor,
        ...props
    });
});
$f92b33309c85890c$var$FormLabel.displayName = 'FormLabel';
var $f92b33309c85890c$export$2e2bcd8739ae039 = $f92b33309c85890c$var$FormLabel;




var $aZSru = parcelRequire("aZSru");



"use client";
const $af79509b436655e4$var$FormRange = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-range');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("input", {
        ...props,
        type: "range",
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        id: id || controlId
    });
});
$af79509b436655e4$var$FormRange.displayName = 'FormRange';
var $af79509b436655e4$export$2e2bcd8739ae039 = $af79509b436655e4$var$FormRange;




var $aZSru = parcelRequire("aZSru");



"use client";
const $ed2bb84ca559761b$var$FormSelect = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, size: size, htmlSize: htmlSize, className: className, isValid: isValid = false, isInvalid: isInvalid = false, id: id, ...props }, ref)=>{
    const { controlId: controlId } = (0, $aZSru.useContext)((0, $e0c63108b2824d3f$export$2e2bcd8739ae039));
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-select');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("select", {
        ...props,
        size: htmlSize,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, size && `${bsPrefix}-${size}`, isValid && `is-valid`, isInvalid && `is-invalid`),
        id: id || controlId
    });
});
$ed2bb84ca559761b$var$FormSelect.displayName = 'FormSelect';
var $ed2bb84ca559761b$export$2e2bcd8739ae039 = $ed2bb84ca559761b$var$FormSelect;




var $aZSru = parcelRequire("aZSru");


"use client";
const $64a226279952d90e$var$FormText = /*#__PURE__*/ $aZSru.forwardRef(// Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
({ bsPrefix: bsPrefix, className: className, as: Component = 'small', muted: muted, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-text');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, muted && 'text-muted')
    });
});
$64a226279952d90e$var$FormText.displayName = 'FormText';
var $64a226279952d90e$export$2e2bcd8739ae039 = $64a226279952d90e$var$FormText;



var $aZSru = parcelRequire("aZSru");


const $043e03ea63e2927b$var$Switch = /*#__PURE__*/ $aZSru.forwardRef((props, ref)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d3f8e565ed3d069c$export$2e2bcd8739ae039), {
        ...props,
        ref: ref,
        type: "switch"
    }));
$043e03ea63e2927b$var$Switch.displayName = 'Switch';
var $043e03ea63e2927b$export$2e2bcd8739ae039 = Object.assign($043e03ea63e2927b$var$Switch, {
    Input: (0, $d3f8e565ed3d069c$export$2e2bcd8739ae039).Input,
    Label: (0, $d3f8e565ed3d069c$export$2e2bcd8739ae039).Label
});




var $aZSru = parcelRequire("aZSru");



"use client";
const $d3905f470037d471$var$FloatingLabel = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, controlId: controlId, label: label, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'form-floating');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $c415c8f0ee14d351$export$2e2bcd8739ae039), {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        controlId: controlId,
        ...props,
        children: [
            children,
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("label", {
                htmlFor: controlId,
                children: label
            })
        ]
    });
});
$d3905f470037d471$var$FloatingLabel.displayName = 'FloatingLabel';
var $d3905f470037d471$export$2e2bcd8739ae039 = $d3905f470037d471$var$FloatingLabel;



const $24747a49448ba319$var$propTypes = {
    /**
   * The Form `ref` will be forwarded to the underlying element,
   * which means, unless it's rendered `as` a composite component,
   * it will be a DOM node, when resolved.
   *
   * @type {ReactRef}
   * @alias ref
   */ _ref: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).any,
    /**
   * Mark a form as having been validated. Setting it to `true` will
   * toggle any validation styles on the forms elements.
   */ validated: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).bool,
    as: (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).elementType
};
const $24747a49448ba319$var$Form = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, validated: validated, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'form', ...props }, ref)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, validated && 'was-validated')
    }));
$24747a49448ba319$var$Form.displayName = 'Form';
$24747a49448ba319$var$Form.propTypes = $24747a49448ba319$var$propTypes;
var $24747a49448ba319$export$2e2bcd8739ae039 = Object.assign($24747a49448ba319$var$Form, {
    Group: (0, $c415c8f0ee14d351$export$2e2bcd8739ae039),
    Control: (0, $6ee5219cd06472c0$export$2e2bcd8739ae039),
    Floating: (0, $95df091b4461ae6e$export$2e2bcd8739ae039),
    Check: (0, $d3f8e565ed3d069c$export$2e2bcd8739ae039),
    Switch: $043e03ea63e2927b$export$2e2bcd8739ae039,
    Label: (0, $f92b33309c85890c$export$2e2bcd8739ae039),
    Text: (0, $64a226279952d90e$export$2e2bcd8739ae039),
    Range: (0, $af79509b436655e4$export$2e2bcd8739ae039),
    Select: (0, $ed2bb84ca559761b$export$2e2bcd8739ae039),
    FloatingLabel: $d3905f470037d471$export$2e2bcd8739ae039
});





var $aZSru = parcelRequire("aZSru");


"use client";
const $c35f7703bec14998$var$Row = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', ...props }, ref)=>{
    const decoratedBsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'row');
    const breakpoints = (0, $7c127cff4998859a$export$8970c8db816a5863)();
    const minBreakpoint = (0, $7c127cff4998859a$export$d926d6ef38f3fd32)();
    const sizePrefix = `${decoratedBsPrefix}-cols`;
    const classes = [];
    breakpoints.forEach((brkPoint)=>{
        const propValue = props[brkPoint];
        delete props[brkPoint];
        let cols;
        if (propValue != null && typeof propValue === 'object') ({ cols: cols } = propValue);
        else cols = propValue;
        const infix = brkPoint !== minBreakpoint ? `-${brkPoint}` : '';
        if (cols != null) classes.push(`${sizePrefix}${infix}-${cols}`);
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, decoratedBsPrefix, ...classes)
    });
});
$c35f7703bec14998$var$Row.displayName = 'Row';
var $c35f7703bec14998$export$2e2bcd8739ae039 = $c35f7703bec14998$var$Row;




var $aZSru = parcelRequire("aZSru");


"use client";
const $6f42ca4961eaabf8$var$Spinner = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, variant: variant, animation: animation = 'border', size: size, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', className: className, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'spinner');
    const bsSpinnerPrefix = `${bsPrefix}-${animation}`;
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsSpinnerPrefix, size && `${bsSpinnerPrefix}-${size}`, variant && `text-${variant}`)
    });
});
$6f42ca4961eaabf8$var$Spinner.displayName = 'Spinner';
var $6f42ca4961eaabf8$export$2e2bcd8739ae039 = $6f42ca4961eaabf8$var$Spinner;




var $aZSru = parcelRequire("aZSru");


"use client";
const $87037ff43d18545e$var$Table = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, striped: striped, bordered: bordered, borderless: borderless, hover: hover, size: size, variant: variant, responsive: responsive, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'table');
    const classes = (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, decoratedBsPrefix, variant && `${decoratedBsPrefix}-${variant}`, size && `${decoratedBsPrefix}-${size}`, striped && `${decoratedBsPrefix}-${typeof striped === 'string' ? `striped-${striped}` : 'striped'}`, bordered && `${decoratedBsPrefix}-bordered`, borderless && `${decoratedBsPrefix}-borderless`, hover && `${decoratedBsPrefix}-hover`);
    const table = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("table", {
        ...props,
        className: classes,
        ref: ref
    });
    if (responsive) {
        let responsiveClass = `${decoratedBsPrefix}-responsive`;
        if (typeof responsive === 'string') responsiveClass = `${responsiveClass}-${responsive}`;
        return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            className: responsiveClass,
            children: table
        });
    }
    return table;
});
$87037ff43d18545e$var$Table.displayName = 'Table';
var $87037ff43d18545e$export$2e2bcd8739ae039 = $87037ff43d18545e$var$Table;


var $73e551fe3a921874$exports = {};



$73e551fe3a921874$exports = function(e) {
    var t = {};
    function n(r) {
        if (t[r]) return t[r].exports;
        var o = t[r] = {
            i: r,
            l: !1,
            exports: {}
        };
        return e[r].call(o.exports, o, o.exports, n), o.l = !0, o.exports;
    }
    return n.m = e, n.c = t, n.d = function(e, t, r) {
        n.o(e, t) || Object.defineProperty(e, t, {
            enumerable: !0,
            get: r
        });
    }, n.r = function(e) {
        "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
        }), Object.defineProperty(e, "__esModule", {
            value: !0
        });
    }, n.t = function(e, t) {
        if (1 & t && (e = n(e)), 8 & t) return e;
        if (4 & t && "object" == typeof e && e && e.__esModule) return e;
        var r = Object.create(null);
        if (n.r(r), Object.defineProperty(r, "default", {
            enumerable: !0,
            value: e
        }), 2 & t && "string" != typeof e) for(var o in e)n.d(r, o, (function(t) {
            return e[t];
        }).bind(null, o));
        return r;
    }, n.n = function(e) {
        var t = e && e.__esModule ? function() {
            return e.default;
        } : function() {
            return e;
        };
        return n.d(t, "a", t), t;
    }, n.o = function(e, t) {
        return Object.prototype.hasOwnProperty.call(e, t);
    }, n.p = "", n(n.s = 4);
}([
    function(e, t) {
        e.exports = (parcelRequire("aZSru"));
    },
    function(e, t) {
        e.exports = (parcelRequire("94eCw"));
    },
    function(e, t) {
        e.exports = (parcelRequire("4lOAY"));
    },
    function(e, t, n) {
        e.exports = n(5)();
    },
    function(e, t, n) {
        e.exports = n(7);
    },
    function(e, t, n) {
        "use strict";
        var r = n(6);
        function o() {}
        function i() {}
        i.resetWarningCache = o, e.exports = function() {
            function e(e, t, n, o, i, a) {
                if (a !== r) {
                    var s = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use PropTypes.checkPropTypes() to call them. Read more at http://fb.me/use-check-prop-types");
                    throw s.name = "Invariant Violation", s;
                }
            }
            function t() {
                return e;
            }
            e.isRequired = e;
            var n = {
                array: e,
                bigint: e,
                bool: e,
                func: e,
                number: e,
                object: e,
                string: e,
                symbol: e,
                any: e,
                arrayOf: t,
                element: e,
                elementType: e,
                instanceOf: t,
                node: e,
                objectOf: t,
                oneOf: t,
                oneOfType: t,
                shape: t,
                exact: t,
                checkPropTypes: i,
                resetWarningCache: o
            };
            return n.PropTypes = n, n;
        };
    },
    function(e, t, n) {
        "use strict";
        e.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    },
    function(e, t, n) {
        "use strict";
        n.r(t);
        var r = n(3), o = n.n(r), i = n(1), a = n.n(i), s = n(0), c = n.n(s);
        function u() {
            return (u = Object.assign ? Object.assign.bind() : function(e) {
                for(var t = 1; t < arguments.length; t++){
                    var n = arguments[t];
                    for(var r in n)Object.prototype.hasOwnProperty.call(n, r) && (e[r] = n[r]);
                }
                return e;
            }).apply(this, arguments);
        }
        function l(e) {
            var t = e.onClickPrev, n = e.onClickSwitch, r = e.onClickNext, o = e.switchContent, i = e.switchColSpan, a = e.switchProps;
            return c.a.createElement("tr", null, c.a.createElement("th", {
                className: "rdtPrev",
                onClick: t
            }, c.a.createElement("span", null, "\u2039")), c.a.createElement("th", u({
                className: "rdtSwitch",
                colSpan: i,
                onClick: n
            }, a), o), c.a.createElement("th", {
                className: "rdtNext",
                onClick: r
            }, c.a.createElement("span", null, "\u203A")));
        }
        function p(e) {
            return (p = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function f(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function d(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function h(e, t) {
            return (h = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function y(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = b(e);
                if (t) {
                    var o = b(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return m(this, n);
            };
        }
        function m(e, t) {
            if (t && ("object" === p(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return v(e);
        }
        function v(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function b(e) {
            return (b = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function O(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        var g = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && h(e, t);
            }(i, e);
            var t, n, r, o = y(i);
            function i() {
                var e;
                f(this, i);
                for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                return O(v(e = o.call.apply(o, [
                    this
                ].concat(n))), "_setDate", function(t) {
                    e.props.updateDate(t);
                }), e;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: "rdtDays"
                        }, c.a.createElement("table", null, c.a.createElement("thead", null, this.renderNavigation(), this.renderDayHeaders()), c.a.createElement("tbody", null, this.renderDays()), this.renderFooter()));
                    }
                },
                {
                    key: "renderNavigation",
                    value: function() {
                        var e = this, t = this.props.viewDate, n = t.localeData();
                        return c.a.createElement(l, {
                            onClickPrev: function() {
                                return e.props.navigate(-1, "months");
                            },
                            onClickSwitch: function() {
                                return e.props.showView("months");
                            },
                            onClickNext: function() {
                                return e.props.navigate(1, "months");
                            },
                            switchContent: n.months(t) + " " + t.year(),
                            switchColSpan: 5,
                            switchProps: {
                                "data-value": this.props.viewDate.month()
                            }
                        });
                    }
                },
                {
                    key: "renderDayHeaders",
                    value: function() {
                        var e = (function(e) {
                            var t = e.firstDayOfWeek(), n = [], r = 0;
                            return e._weekdaysMin.forEach(function(e) {
                                n[(7 + r++ - t) % 7] = e;
                            }), n;
                        })(this.props.viewDate.localeData()).map(function(e, t) {
                            return c.a.createElement("th", {
                                key: e + t,
                                className: "dow"
                            }, e);
                        });
                        return c.a.createElement("tr", null, e);
                    }
                },
                {
                    key: "renderDays",
                    value: function() {
                        var e = this.props.viewDate, t = e.clone().startOf("month"), n = e.clone().endOf("month"), r = [
                            [],
                            [],
                            [],
                            [],
                            [],
                            []
                        ], o = e.clone().subtract(1, "months");
                        o.date(o.daysInMonth()).startOf("week");
                        for(var i = o.clone().add(42, "d"), a = 0; o.isBefore(i);)w(r, a++).push(this.renderDay(o, t, n)), o.add(1, "d");
                        return r.map(function(e, t) {
                            return c.a.createElement("tr", {
                                key: "".concat(i.month(), "_").concat(t)
                            }, e);
                        });
                    }
                },
                {
                    key: "renderDay",
                    value: function(e, t, n) {
                        var r = this.props.selectedDate, o = {
                            key: e.format("M_D"),
                            "data-value": e.date(),
                            "data-month": e.month(),
                            "data-year": e.year()
                        }, i = "rdtDay";
                        return e.isBefore(t) ? i += " rdtOld" : e.isAfter(n) && (i += " rdtNew"), r && e.isSame(r, "day") && (i += " rdtActive"), e.isSame(this.props.moment(), "day") && (i += " rdtToday"), this.props.isValidDate(e) ? o.onClick = this._setDate : i += " rdtDisabled", o.className = i, this.props.renderDay(o, e.clone(), r && r.clone());
                    }
                },
                {
                    key: "renderFooter",
                    value: function() {
                        var e = this;
                        if (this.props.timeFormat) {
                            var t = this.props.viewDate;
                            return c.a.createElement("tfoot", null, c.a.createElement("tr", null, c.a.createElement("td", {
                                onClick: function() {
                                    return e.props.showView("time");
                                },
                                colSpan: 7,
                                className: "rdtTimeToggle"
                            }, t.format(this.props.timeFormat))));
                        }
                    }
                }
            ], d(t.prototype, n), r && d(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function w(e, t) {
            return e[Math.floor(t / 7)];
        }
        function D(e) {
            return (D = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function k(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function C(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function P(e, t) {
            return (P = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function _(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = S(e);
                if (t) {
                    var o = S(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return E(this, n);
            };
        }
        function E(e, t) {
            if (t && ("object" === D(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return j(e);
        }
        function j(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function S(e) {
            return (S = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function V(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        O(g, "defaultProps", {
            isValidDate: function() {
                return !0;
            },
            renderDay: function(e, t) {
                return c.a.createElement("td", e, t.date());
            }
        });
        var T = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && P(e, t);
            }(i, e);
            var t, n, r, o = _(i);
            function i() {
                var e;
                k(this, i);
                for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                return V(j(e = o.call.apply(o, [
                    this
                ].concat(n))), "_updateSelectedMonth", function(t) {
                    e.props.updateDate(t);
                }), e;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: "rdtMonths"
                        }, c.a.createElement("table", null, c.a.createElement("thead", null, this.renderNavigation())), c.a.createElement("table", null, c.a.createElement("tbody", null, this.renderMonths())));
                    }
                },
                {
                    key: "renderNavigation",
                    value: function() {
                        var e = this, t = this.props.viewDate.year();
                        return c.a.createElement(l, {
                            onClickPrev: function() {
                                return e.props.navigate(-1, "years");
                            },
                            onClickSwitch: function() {
                                return e.props.showView("years");
                            },
                            onClickNext: function() {
                                return e.props.navigate(1, "years");
                            },
                            switchContent: t,
                            switchColSpan: "2"
                        });
                    }
                },
                {
                    key: "renderMonths",
                    value: function() {
                        for(var e = [
                            [],
                            [],
                            []
                        ], t = 0; t < 12; t++)N(e, t).push(this.renderMonth(t));
                        return e.map(function(e, t) {
                            return c.a.createElement("tr", {
                                key: t
                            }, e);
                        });
                    }
                },
                {
                    key: "renderMonth",
                    value: function(e) {
                        var t, n = this.props.selectedDate, r = "rdtMonth";
                        this.isDisabledMonth(e) ? r += " rdtDisabled" : t = this._updateSelectedMonth, n && n.year() === this.props.viewDate.year() && n.month() === e && (r += " rdtActive");
                        var o = {
                            key: e,
                            className: r,
                            "data-value": e,
                            onClick: t
                        };
                        return this.props.renderMonth ? this.props.renderMonth(o, e, this.props.viewDate.year(), this.props.selectedDate && this.props.selectedDate.clone()) : c.a.createElement("td", o, this.getMonthText(e));
                    }
                },
                {
                    key: "isDisabledMonth",
                    value: function(e) {
                        var t = this.props.isValidDate;
                        if (!t) return !1;
                        for(var n = this.props.viewDate.clone().set({
                            month: e
                        }), r = n.endOf("month").date() + 1; r-- > 1;)if (t(n.date(r))) return !1;
                        return !0;
                    }
                },
                {
                    key: "getMonthText",
                    value: function(e) {
                        var t, n = this.props.viewDate, r = n.localeData().monthsShort(n.month(e));
                        return (t = r.substring(0, 3)).charAt(0).toUpperCase() + t.slice(1);
                    }
                }
            ], C(t.prototype, n), r && C(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function N(e, t) {
            return t < 4 ? e[0] : t < 8 ? e[1] : e[2];
        }
        function x(e) {
            return (x = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function F(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function I(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function R(e, t) {
            return (R = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function M(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = B(e);
                if (t) {
                    var o = B(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return Y(this, n);
            };
        }
        function Y(e, t) {
            if (t && ("object" === x(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return L(e);
        }
        function L(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function B(e) {
            return (B = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function A(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        var H = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && R(e, t);
            }(i, e);
            var t, n, r, o = M(i);
            function i() {
                var e;
                F(this, i);
                for(var t = arguments.length, n = new Array(t), r = 0; r < t; r++)n[r] = arguments[r];
                return A(L(e = o.call.apply(o, [
                    this
                ].concat(n))), "disabledYearsCache", {}), A(L(e), "_updateSelectedYear", function(t) {
                    e.props.updateDate(t);
                }), e;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: "rdtYears"
                        }, c.a.createElement("table", null, c.a.createElement("thead", null, this.renderNavigation())), c.a.createElement("table", null, c.a.createElement("tbody", null, this.renderYears())));
                    }
                },
                {
                    key: "renderNavigation",
                    value: function() {
                        var e = this, t = this.getViewYear();
                        return c.a.createElement(l, {
                            onClickPrev: function() {
                                return e.props.navigate(-10, "years");
                            },
                            onClickSwitch: function() {
                                return e.props.showView("years");
                            },
                            onClickNext: function() {
                                return e.props.navigate(10, "years");
                            },
                            switchContent: "".concat(t, "-").concat(t + 9)
                        });
                    }
                },
                {
                    key: "renderYears",
                    value: function() {
                        for(var e = this.getViewYear(), t = [
                            [],
                            [],
                            []
                        ], n = e - 1; n < e + 11; n++)U(t, n - e).push(this.renderYear(n));
                        return t.map(function(e, t) {
                            return c.a.createElement("tr", {
                                key: t
                            }, e);
                        });
                    }
                },
                {
                    key: "renderYear",
                    value: function(e) {
                        var t, n = this.getSelectedYear(), r = "rdtYear";
                        this.isDisabledYear(e) ? r += " rdtDisabled" : t = this._updateSelectedYear, n === e && (r += " rdtActive");
                        var o = {
                            key: e,
                            className: r,
                            "data-value": e,
                            onClick: t
                        };
                        return this.props.renderYear(o, e, this.props.selectedDate && this.props.selectedDate.clone());
                    }
                },
                {
                    key: "getViewYear",
                    value: function() {
                        return 10 * parseInt(this.props.viewDate.year() / 10, 10);
                    }
                },
                {
                    key: "getSelectedYear",
                    value: function() {
                        return this.props.selectedDate && this.props.selectedDate.year();
                    }
                },
                {
                    key: "isDisabledYear",
                    value: function(e) {
                        var t = this.disabledYearsCache;
                        if (void 0 !== t[e]) return t[e];
                        var n = this.props.isValidDate;
                        if (!n) return !1;
                        for(var r = this.props.viewDate.clone().set({
                            year: e
                        }), o = r.endOf("year").dayOfYear() + 1; o-- > 1;)if (n(r.dayOfYear(o))) return t[e] = !1, !1;
                        return t[e] = !0, !0;
                    }
                }
            ], I(t.prototype, n), r && I(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function U(e, t) {
            return t < 3 ? e[0] : t < 7 ? e[1] : e[2];
        }
        function Z(e) {
            return (Z = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function W(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function z(e, t) {
            return (z = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function q(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = X(e);
                if (t) {
                    var o = X(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return K(this, n);
            };
        }
        function K(e, t) {
            if (t && ("object" === Z(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return function(e) {
                if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
                return e;
            }(e);
        }
        function X(e) {
            return (X = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function G(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function J(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? G(Object(n), !0).forEach(function(t) {
                    Q(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : G(Object(n)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
            }
            return e;
        }
        function Q(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        A(H, "defaultProps", {
            renderYear: function(e, t) {
                return c.a.createElement("td", e, t);
            }
        });
        var $ = {
            hours: {
                min: 0,
                max: 23,
                step: 1
            },
            minutes: {
                min: 0,
                max: 59,
                step: 1
            },
            seconds: {
                min: 0,
                max: 59,
                step: 1
            },
            milliseconds: {
                min: 0,
                max: 999,
                step: 1
            }
        };
        var ee = function(e) {
            !function(e, t) {
                if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
                e.prototype = Object.create(t && t.prototype, {
                    constructor: {
                        value: e,
                        writable: !0,
                        configurable: !0
                    }
                }), Object.defineProperty(e, "prototype", {
                    writable: !1
                }), t && z(e, t);
            }(i, e);
            var t, n, r, o = q(i);
            function i(e) {
                var t, n, r;
                return function(e, t) {
                    if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
                }(this, i), (t = o.call(this, e)).constraints = (n = e.timeConstraints, r = {}, Object.keys($).forEach(function(e) {
                    r[e] = J(J({}, $[e]), n[e] || {});
                }), r), t.state = t.getTimeParts(e.selectedDate || e.viewDate), t;
            }
            return t = i, n = [
                {
                    key: "render",
                    value: function() {
                        var e = this, t = [], n = this.state;
                        return this.getCounters().forEach(function(r, o) {
                            o && "ampm" !== r && t.push(c.a.createElement("div", {
                                key: "sep".concat(o),
                                className: "rdtCounterSeparator"
                            }, ":")), t.push(e.renderCounter(r, n[r]));
                        }), c.a.createElement("div", {
                            className: "rdtTime"
                        }, c.a.createElement("table", null, this.renderHeader(), c.a.createElement("tbody", null, c.a.createElement("tr", null, c.a.createElement("td", null, c.a.createElement("div", {
                            className: "rdtCounters"
                        }, t))))));
                    }
                },
                {
                    key: "renderCounter",
                    value: function(e, t) {
                        var n = this;
                        return "hours" === e && this.isAMPM() && 0 == (t = (t - 1) % 12 + 1) && (t = 12), "ampm" === e && (t = -1 !== this.props.timeFormat.indexOf(" A") ? this.props.viewDate.format("A") : this.props.viewDate.format("a")), c.a.createElement("div", {
                            key: e,
                            className: "rdtCounter"
                        }, c.a.createElement("span", {
                            className: "rdtBtn",
                            onMouseDown: function(t) {
                                return n.onStartClicking(t, "increase", e);
                            }
                        }, "\u25B2"), c.a.createElement("div", {
                            className: "rdtCount"
                        }, t), c.a.createElement("span", {
                            className: "rdtBtn",
                            onMouseDown: function(t) {
                                return n.onStartClicking(t, "decrease", e);
                            }
                        }, "\u25BC"));
                    }
                },
                {
                    key: "renderHeader",
                    value: function() {
                        var e = this;
                        if (this.props.dateFormat) {
                            var t = this.props.selectedDate || this.props.viewDate;
                            return c.a.createElement("thead", null, c.a.createElement("tr", null, c.a.createElement("td", {
                                className: "rdtSwitch",
                                colSpan: "4",
                                onClick: function() {
                                    return e.props.showView("days");
                                }
                            }, t.format(this.props.dateFormat))));
                        }
                    }
                },
                {
                    key: "onStartClicking",
                    value: function(e, t, n) {
                        var r = this;
                        if (!e || !e.button || 0 === e.button) {
                            if ("ampm" === n) return this.toggleDayPart();
                            var o = {}, i = document.body;
                            o[n] = this[t](n), this.setState(o), this.timer = setTimeout(function() {
                                r.increaseTimer = setInterval(function() {
                                    o[n] = r[t](n), r.setState(o);
                                }, 70);
                            }, 500), this.mouseUpListener = function() {
                                clearTimeout(r.timer), clearInterval(r.increaseTimer), r.props.setTime(n, parseInt(r.state[n], 10)), i.removeEventListener("mouseup", r.mouseUpListener), i.removeEventListener("touchend", r.mouseUpListener);
                            }, i.addEventListener("mouseup", this.mouseUpListener), i.addEventListener("touchend", this.mouseUpListener);
                        }
                    }
                },
                {
                    key: "toggleDayPart",
                    value: function() {
                        var e = parseInt(this.state.hours, 10);
                        e >= 12 ? e -= 12 : e += 12, this.props.setTime("hours", e);
                    }
                },
                {
                    key: "increase",
                    value: function(e) {
                        var t = this.constraints[e], n = parseInt(this.state[e], 10) + t.step;
                        return n > t.max && (n = t.min + (n - (t.max + 1))), te(e, n);
                    }
                },
                {
                    key: "decrease",
                    value: function(e) {
                        var t = this.constraints[e], n = parseInt(this.state[e], 10) - t.step;
                        return n < t.min && (n = t.max + 1 - (t.min - n)), te(e, n);
                    }
                },
                {
                    key: "getCounters",
                    value: function() {
                        var e = [], t = this.props.timeFormat;
                        return -1 !== t.toLowerCase().indexOf("h") && (e.push("hours"), -1 !== t.indexOf("m") && (e.push("minutes"), -1 !== t.indexOf("s") && (e.push("seconds"), -1 !== t.indexOf("S") && e.push("milliseconds")))), this.isAMPM() && e.push("ampm"), e;
                    }
                },
                {
                    key: "isAMPM",
                    value: function() {
                        return -1 !== this.props.timeFormat.toLowerCase().indexOf(" a");
                    }
                },
                {
                    key: "getTimeParts",
                    value: function(e) {
                        var t = e.hours();
                        return {
                            hours: te("hours", t),
                            minutes: te("minutes", e.minutes()),
                            seconds: te("seconds", e.seconds()),
                            milliseconds: te("milliseconds", e.milliseconds()),
                            ampm: t < 12 ? "am" : "pm"
                        };
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e) {
                        this.props.selectedDate ? this.props.selectedDate !== e.selectedDate && this.setState(this.getTimeParts(this.props.selectedDate)) : e.viewDate !== this.props.viewDate && this.setState(this.getTimeParts(this.props.viewDate));
                    }
                }
            ], W(t.prototype, n), r && W(t, r), Object.defineProperty(t, "prototype", {
                writable: !1
            }), i;
        }(c.a.Component);
        function te(e, t) {
            for(var n = {
                hours: 1,
                minutes: 2,
                seconds: 2,
                milliseconds: 3
            }, r = t + ""; r.length < n[e];)r = "0" + r;
            return r;
        }
        var ne = n(2);
        function re(e, t) {
            return (re = Object.setPrototypeOf || function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function oe(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function ie(e, t, n) {
            return e === t || (e.correspondingElement ? e.correspondingElement.classList.contains(n) : e.classList.contains(n));
        }
        var ae, se, ce = (void 0 === ae && (ae = 0), function() {
            return ++ae;
        }), ue = {}, le = {}, pe = [
            "touchstart",
            "touchmove"
        ];
        function fe(e, t) {
            var n = null;
            return -1 !== pe.indexOf(t) && se && (n = {
                passive: !e.props.preventDefault
            }), n;
        }
        var de = function(e, t) {
            var n, r, o = e.displayName || e.name || "Component";
            return r = n = function(n) {
                var r, i;
                function a(e) {
                    var r;
                    return (r = n.call(this, e) || this).__outsideClickHandler = function(e) {
                        if ("function" != typeof r.__clickOutsideHandlerProp) {
                            var t = r.getInstance();
                            if ("function" != typeof t.props.handleClickOutside) {
                                if ("function" != typeof t.handleClickOutside) throw new Error("WrappedComponent: " + o + " lacks a handleClickOutside(event) function for processing outside click events.");
                                t.handleClickOutside(e);
                            } else t.props.handleClickOutside(e);
                        } else r.__clickOutsideHandlerProp(e);
                    }, r.__getComponentNode = function() {
                        var e = r.getInstance();
                        return t && "function" == typeof t.setClickOutsideRef ? t.setClickOutsideRef()(e) : "function" == typeof e.setClickOutsideRef ? e.setClickOutsideRef() : Object(ne.findDOMNode)(e);
                    }, r.enableOnClickOutside = function() {
                        if ("undefined" != typeof document && !le[r._uid]) {
                            void 0 === se && (se = function() {
                                if ("undefined" != typeof window && "function" == typeof window.addEventListener) {
                                    var e = !1, t = Object.defineProperty({}, "passive", {
                                        get: function() {
                                            e = !0;
                                        }
                                    }), n = function() {};
                                    return window.addEventListener("testPassiveEventSupport", n, t), window.removeEventListener("testPassiveEventSupport", n, t), e;
                                }
                            }()), le[r._uid] = !0;
                            var e = r.props.eventTypes;
                            e.forEach || (e = [
                                e
                            ]), ue[r._uid] = function(e) {
                                var t;
                                null !== r.componentNode && (r.props.preventDefault && e.preventDefault(), r.props.stopPropagation && e.stopPropagation(), r.props.excludeScrollbar && (t = e, document.documentElement.clientWidth <= t.clientX || document.documentElement.clientHeight <= t.clientY) || function(e, t, n) {
                                    if (e === t) return !0;
                                    for(; e.parentNode || e.host;){
                                        if (e.parentNode && ie(e, t, n)) return !0;
                                        e = e.parentNode || e.host;
                                    }
                                    return e;
                                }(e.composed && e.composedPath && e.composedPath().shift() || e.target, r.componentNode, r.props.outsideClickIgnoreClass) === document && r.__outsideClickHandler(e));
                            }, e.forEach(function(e) {
                                document.addEventListener(e, ue[r._uid], fe(oe(r), e));
                            });
                        }
                    }, r.disableOnClickOutside = function() {
                        delete le[r._uid];
                        var e = ue[r._uid];
                        if (e && "undefined" != typeof document) {
                            var t = r.props.eventTypes;
                            t.forEach || (t = [
                                t
                            ]), t.forEach(function(t) {
                                return document.removeEventListener(t, e, fe(oe(r), t));
                            }), delete ue[r._uid];
                        }
                    }, r.getRef = function(e) {
                        return r.instanceRef = e;
                    }, r._uid = ce(), r;
                }
                i = n, (r = a).prototype = Object.create(i.prototype), r.prototype.constructor = r, re(r, i);
                var c = a.prototype;
                return c.getInstance = function() {
                    if (e.prototype && !e.prototype.isReactComponent) return this;
                    var t = this.instanceRef;
                    return t.getInstance ? t.getInstance() : t;
                }, c.componentDidMount = function() {
                    if ("undefined" != typeof document && document.createElement) {
                        var e = this.getInstance();
                        if (t && "function" == typeof t.handleClickOutside && (this.__clickOutsideHandlerProp = t.handleClickOutside(e), "function" != typeof this.__clickOutsideHandlerProp)) throw new Error("WrappedComponent: " + o + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
                        this.componentNode = this.__getComponentNode(), this.props.disableOnClickOutside || this.enableOnClickOutside();
                    }
                }, c.componentDidUpdate = function() {
                    this.componentNode = this.__getComponentNode();
                }, c.componentWillUnmount = function() {
                    this.disableOnClickOutside();
                }, c.render = function() {
                    var t = this.props;
                    t.excludeScrollbar;
                    var n = function(e, t) {
                        if (null == e) return {};
                        var n, r, o = {}, i = Object.keys(e);
                        for(r = 0; r < i.length; r++)n = i[r], t.indexOf(n) >= 0 || (o[n] = e[n]);
                        return o;
                    }(t, [
                        "excludeScrollbar"
                    ]);
                    return e.prototype && e.prototype.isReactComponent ? n.ref = this.getRef : n.wrappedRef = this.getRef, n.disableOnClickOutside = this.disableOnClickOutside, n.enableOnClickOutside = this.enableOnClickOutside, Object(s.createElement)(e, n);
                }, a;
            }(s.Component), n.displayName = "OnClickOutside(" + o + ")", n.defaultProps = {
                eventTypes: [
                    "mousedown",
                    "touchstart"
                ],
                excludeScrollbar: t && t.excludeScrollbar || !1,
                outsideClickIgnoreClass: "ignore-react-onclickoutside",
                preventDefault: !1,
                stopPropagation: !1
            }, n.getClass = function() {
                return e.getClass ? e.getClass() : e;
            }, r;
        };
        function he(e) {
            return (he = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function(e) {
                return typeof e;
            } : function(e) {
                return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
            })(e);
        }
        function ye(e, t) {
            var n = Object.keys(e);
            if (Object.getOwnPropertySymbols) {
                var r = Object.getOwnPropertySymbols(e);
                t && (r = r.filter(function(t) {
                    return Object.getOwnPropertyDescriptor(e, t).enumerable;
                })), n.push.apply(n, r);
            }
            return n;
        }
        function me(e) {
            for(var t = 1; t < arguments.length; t++){
                var n = null != arguments[t] ? arguments[t] : {};
                t % 2 ? ye(Object(n), !0).forEach(function(t) {
                    _e(e, t, n[t]);
                }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : ye(Object(n)).forEach(function(t) {
                    Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
                });
            }
            return e;
        }
        function ve(e, t) {
            if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }
        function be(e, t) {
            for(var n = 0; n < t.length; n++){
                var r = t[n];
                r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, r.key, r);
            }
        }
        function Oe(e, t, n) {
            return t && be(e.prototype, t), n && be(e, n), Object.defineProperty(e, "prototype", {
                writable: !1
            }), e;
        }
        function ge(e, t) {
            if ("function" != typeof t && null !== t) throw new TypeError("Super expression must either be null or a function");
            e.prototype = Object.create(t && t.prototype, {
                constructor: {
                    value: e,
                    writable: !0,
                    configurable: !0
                }
            }), Object.defineProperty(e, "prototype", {
                writable: !1
            }), t && we(e, t);
        }
        function we(e, t) {
            return (we = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function(e, t) {
                return e.__proto__ = t, e;
            })(e, t);
        }
        function De(e) {
            var t = function() {
                if ("undefined" == typeof Reflect || !Reflect.construct) return !1;
                if (Reflect.construct.sham) return !1;
                if ("function" == typeof Proxy) return !0;
                try {
                    return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {})), !0;
                } catch (e) {
                    return !1;
                }
            }();
            return function() {
                var n, r = Pe(e);
                if (t) {
                    var o = Pe(this).constructor;
                    n = Reflect.construct(r, arguments, o);
                } else n = r.apply(this, arguments);
                return ke(this, n);
            };
        }
        function ke(e, t) {
            if (t && ("object" === he(t) || "function" == typeof t)) return t;
            if (void 0 !== t) throw new TypeError("Derived constructors may only return object or undefined");
            return Ce(e);
        }
        function Ce(e) {
            if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return e;
        }
        function Pe(e) {
            return (Pe = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function(e) {
                return e.__proto__ || Object.getPrototypeOf(e);
            })(e);
        }
        function _e(e, t, n) {
            return t in e ? Object.defineProperty(e, t, {
                value: n,
                enumerable: !0,
                configurable: !0,
                writable: !0
            }) : e[t] = n, e;
        }
        n.d(t, "default", function() {
            return Fe;
        });
        var Ee = "years", je = "months", Se = "days", Ve = "time", Te = o.a, Ne = function() {}, xe = Te.oneOfType([
            Te.instanceOf(a.a),
            Te.instanceOf(Date),
            Te.string
        ]), Fe = function(e) {
            ge(n, e);
            var t = De(n);
            function n(e) {
                var r;
                return ve(this, n), _e(Ce(r = t.call(this, e)), "_renderCalendar", function() {
                    var e = r.props, t = r.state, n = {
                        viewDate: t.viewDate.clone(),
                        selectedDate: r.getSelectedDate(),
                        isValidDate: e.isValidDate,
                        updateDate: r._updateDate,
                        navigate: r._viewNavigate,
                        moment: a.a,
                        showView: r._showView
                    };
                    switch(t.currentView){
                        case Ee:
                            return n.renderYear = e.renderYear, c.a.createElement(H, n);
                        case je:
                            return n.renderMonth = e.renderMonth, c.a.createElement(T, n);
                        case Se:
                            return n.renderDay = e.renderDay, n.timeFormat = r.getFormat("time"), c.a.createElement(g, n);
                        default:
                            return n.dateFormat = r.getFormat("date"), n.timeFormat = r.getFormat("time"), n.timeConstraints = e.timeConstraints, n.setTime = r._setTime, c.a.createElement(ee, n);
                    }
                }), _e(Ce(r), "_showView", function(e, t) {
                    var n = (t || r.state.viewDate).clone(), o = r.props.onBeforeNavigate(e, r.state.currentView, n);
                    o && r.state.currentView !== o && (r.props.onNavigate(o), r.setState({
                        currentView: o
                    }));
                }), _e(Ce(r), "viewToMethod", {
                    days: "date",
                    months: "month",
                    years: "year"
                }), _e(Ce(r), "nextView", {
                    days: "time",
                    months: "days",
                    years: "months"
                }), _e(Ce(r), "_updateDate", function(e) {
                    var t = r.state.currentView, n = r.getUpdateOn(r.getFormat("date")), o = r.state.viewDate.clone();
                    o[r.viewToMethod[t]](parseInt(e.target.getAttribute("data-value"), 10)), "days" === t && (o.month(parseInt(e.target.getAttribute("data-month"), 10)), o.year(parseInt(e.target.getAttribute("data-year"), 10)));
                    var i = {
                        viewDate: o
                    };
                    t === n ? (i.selectedDate = o.clone(), i.inputValue = o.format(r.getFormat("datetime")), void 0 === r.props.open && r.props.input && r.props.closeOnSelect && r._closeCalendar(), r.props.onChange(o.clone())) : r._showView(r.nextView[t], o), r.setState(i);
                }), _e(Ce(r), "_viewNavigate", function(e, t) {
                    var n = r.state.viewDate.clone();
                    n.add(e, t), e > 0 ? r.props.onNavigateForward(e, t) : r.props.onNavigateBack(-e, t), r.setState({
                        viewDate: n
                    });
                }), _e(Ce(r), "_setTime", function(e, t) {
                    var n = (r.getSelectedDate() || r.state.viewDate).clone();
                    n[e](t), r.props.value || r.setState({
                        selectedDate: n,
                        viewDate: n.clone(),
                        inputValue: n.format(r.getFormat("datetime"))
                    }), r.props.onChange(n);
                }), _e(Ce(r), "_openCalendar", function() {
                    r.isOpen() || r.setState({
                        open: !0
                    }, r.props.onOpen);
                }), _e(Ce(r), "_closeCalendar", function() {
                    r.isOpen() && r.setState({
                        open: !1
                    }, function() {
                        r.props.onClose(r.state.selectedDate || r.state.inputValue);
                    });
                }), _e(Ce(r), "_handleClickOutside", function() {
                    var e = r.props;
                    e.input && r.state.open && void 0 === e.open && e.closeOnClickOutside && r._closeCalendar();
                }), _e(Ce(r), "_onInputFocus", function(e) {
                    r.callHandler(r.props.inputProps.onFocus, e) && r._openCalendar();
                }), _e(Ce(r), "_onInputChange", function(e) {
                    if (r.callHandler(r.props.inputProps.onChange, e)) {
                        var t = e.target ? e.target.value : e, n = r.localMoment(t, r.getFormat("datetime")), o = {
                            inputValue: t
                        };
                        n.isValid() ? (o.selectedDate = n, o.viewDate = n.clone().startOf("month")) : o.selectedDate = null, r.setState(o, function() {
                            r.props.onChange(n.isValid() ? n : r.state.inputValue);
                        });
                    }
                }), _e(Ce(r), "_onInputKeyDown", function(e) {
                    r.callHandler(r.props.inputProps.onKeyDown, e) && 9 === e.which && r.props.closeOnTab && r._closeCalendar();
                }), _e(Ce(r), "_onInputClick", function(e) {
                    r.callHandler(r.props.inputProps.onClick, e) && r._openCalendar();
                }), r.state = r.getInitialState(), r;
            }
            return Oe(n, [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement(Re, {
                            className: this.getClassName(),
                            onClickOut: this._handleClickOutside
                        }, this.renderInput(), c.a.createElement("div", {
                            className: "rdtPicker"
                        }, this.renderView()));
                    }
                },
                {
                    key: "renderInput",
                    value: function() {
                        if (this.props.input) {
                            var e = me(me({
                                type: "text",
                                className: "form-control",
                                value: this.getInputValue()
                            }, this.props.inputProps), {}, {
                                onFocus: this._onInputFocus,
                                onChange: this._onInputChange,
                                onKeyDown: this._onInputKeyDown,
                                onClick: this._onInputClick
                            });
                            return this.props.renderInput ? c.a.createElement("div", null, this.props.renderInput(e, this._openCalendar, this._closeCalendar)) : c.a.createElement("input", e);
                        }
                    }
                },
                {
                    key: "renderView",
                    value: function() {
                        return this.props.renderView(this.state.currentView, this._renderCalendar);
                    }
                },
                {
                    key: "getInitialState",
                    value: function() {
                        var e = this.props, t = this.getFormat("datetime"), n = this.parseDate(e.value || e.initialValue, t);
                        return this.checkTZ(), {
                            open: !e.input,
                            currentView: e.initialViewMode || this.getInitialView(),
                            viewDate: this.getInitialViewDate(n),
                            selectedDate: n && n.isValid() ? n : void 0,
                            inputValue: this.getInitialInputValue(n)
                        };
                    }
                },
                {
                    key: "getInitialViewDate",
                    value: function(e) {
                        var t, n = this.props.initialViewDate;
                        if (n) {
                            if ((t = this.parseDate(n, this.getFormat("datetime"))) && t.isValid()) return t;
                            Ie('The initialViewDated given "' + n + '" is not valid. Using current date instead.');
                        } else if (e && e.isValid()) return e.clone();
                        return this.getInitialDate();
                    }
                },
                {
                    key: "getInitialDate",
                    value: function() {
                        var e = this.localMoment();
                        return e.hour(0).minute(0).second(0).millisecond(0), e;
                    }
                },
                {
                    key: "getInitialView",
                    value: function() {
                        var e = this.getFormat("date");
                        return e ? this.getUpdateOn(e) : Ve;
                    }
                },
                {
                    key: "parseDate",
                    value: function(e, t) {
                        var n;
                        return e && "string" == typeof e ? n = this.localMoment(e, t) : e && (n = this.localMoment(e)), n && !n.isValid() && (n = null), n;
                    }
                },
                {
                    key: "getClassName",
                    value: function() {
                        var e = "rdt", t = this.props, n = t.className;
                        return Array.isArray(n) ? e += " " + n.join(" ") : n && (e += " " + n), t.input || (e += " rdtStatic"), this.isOpen() && (e += " rdtOpen"), e;
                    }
                },
                {
                    key: "isOpen",
                    value: function() {
                        return !this.props.input || (void 0 === this.props.open ? this.state.open : this.props.open);
                    }
                },
                {
                    key: "getUpdateOn",
                    value: function(e) {
                        return this.props.updateOnView ? this.props.updateOnView : e.match(/[lLD]/) ? Se : -1 !== e.indexOf("M") ? je : -1 !== e.indexOf("Y") ? Ee : Se;
                    }
                },
                {
                    key: "getLocaleData",
                    value: function() {
                        var e = this.props;
                        return this.localMoment(e.value || e.defaultValue || new Date).localeData();
                    }
                },
                {
                    key: "getDateFormat",
                    value: function() {
                        var e = this.getLocaleData(), t = this.props.dateFormat;
                        return !0 === t ? e.longDateFormat("L") : t || "";
                    }
                },
                {
                    key: "getTimeFormat",
                    value: function() {
                        var e = this.getLocaleData(), t = this.props.timeFormat;
                        return !0 === t ? e.longDateFormat("LT") : t || "";
                    }
                },
                {
                    key: "getFormat",
                    value: function(e) {
                        if ("date" === e) return this.getDateFormat();
                        if ("time" === e) return this.getTimeFormat();
                        var t = this.getDateFormat(), n = this.getTimeFormat();
                        return t && n ? t + " " + n : t || n;
                    }
                },
                {
                    key: "updateTime",
                    value: function(e, t, n, r) {
                        var o = {}, i = r ? "selectedDate" : "viewDate";
                        o[i] = this.state[i].clone()[e](t, n), this.setState(o);
                    }
                },
                {
                    key: "localMoment",
                    value: function(e, t, n) {
                        var r = null;
                        return r = (n = n || this.props).utc ? a.a.utc(e, t, n.strictParsing) : n.displayTimeZone ? a.a.tz(e, t, n.displayTimeZone) : a()(e, t, n.strictParsing), n.locale && r.locale(n.locale), r;
                    }
                },
                {
                    key: "checkTZ",
                    value: function() {
                        var e = this.props.displayTimeZone;
                        !e || this.tzWarning || a.a.tz || (this.tzWarning = !0, Ie('displayTimeZone prop with value "' + e + '" is used but moment.js timezone is not loaded.', "error"));
                    }
                },
                {
                    key: "componentDidUpdate",
                    value: function(e) {
                        if (e !== this.props) {
                            var t = !1, n = this.props;
                            [
                                "locale",
                                "utc",
                                "displayZone",
                                "dateFormat",
                                "timeFormat"
                            ].forEach(function(r) {
                                e[r] !== n[r] && (t = !0);
                            }), t && this.regenerateDates(), n.value && n.value !== e.value && this.setViewDate(n.value), this.checkTZ();
                        }
                    }
                },
                {
                    key: "regenerateDates",
                    value: function() {
                        var e = this.props, t = this.state.viewDate.clone(), n = this.state.selectedDate && this.state.selectedDate.clone();
                        e.locale && (t.locale(e.locale), n && n.locale(e.locale)), e.utc ? (t.utc(), n && n.utc()) : e.displayTimeZone ? (t.tz(e.displayTimeZone), n && n.tz(e.displayTimeZone)) : (t.locale(), n && n.locale());
                        var r = {
                            viewDate: t,
                            selectedDate: n
                        };
                        n && n.isValid() && (r.inputValue = n.format(this.getFormat("datetime"))), this.setState(r);
                    }
                },
                {
                    key: "getSelectedDate",
                    value: function() {
                        if (void 0 === this.props.value) return this.state.selectedDate;
                        var e = this.parseDate(this.props.value, this.getFormat("datetime"));
                        return !(!e || !e.isValid()) && e;
                    }
                },
                {
                    key: "getInitialInputValue",
                    value: function(e) {
                        var t = this.props;
                        return t.inputProps.value ? t.inputProps.value : e && e.isValid() ? e.format(this.getFormat("datetime")) : t.value && "string" == typeof t.value ? t.value : t.initialValue && "string" == typeof t.initialValue ? t.initialValue : "";
                    }
                },
                {
                    key: "getInputValue",
                    value: function() {
                        var e = this.getSelectedDate();
                        return e ? e.format(this.getFormat("datetime")) : this.state.inputValue;
                    }
                },
                {
                    key: "setViewDate",
                    value: function(e) {
                        var t, n = function() {
                            return Ie("Invalid date passed to the `setViewDate` method: " + e);
                        };
                        return e && (t = "string" == typeof e ? this.localMoment(e, this.getFormat("datetime")) : this.localMoment(e)) && t.isValid() ? void this.setState({
                            viewDate: t
                        }) : n();
                    }
                },
                {
                    key: "navigate",
                    value: function(e) {
                        this._showView(e);
                    }
                },
                {
                    key: "callHandler",
                    value: function(e, t) {
                        return !e || !1 !== e(t);
                    }
                }
            ]), n;
        }(c.a.Component);
        function Ie(e, t) {
            var n = "undefined" != typeof window && window.console;
            n && (t || (t = "warn"), n[t]("***react-datetime:" + e));
        }
        _e(Fe, "propTypes", {
            value: xe,
            initialValue: xe,
            initialViewDate: xe,
            initialViewMode: Te.oneOf([
                Ee,
                je,
                Se,
                Ve
            ]),
            onOpen: Te.func,
            onClose: Te.func,
            onChange: Te.func,
            onNavigate: Te.func,
            onBeforeNavigate: Te.func,
            onNavigateBack: Te.func,
            onNavigateForward: Te.func,
            updateOnView: Te.string,
            locale: Te.string,
            utc: Te.bool,
            displayTimeZone: Te.string,
            input: Te.bool,
            dateFormat: Te.oneOfType([
                Te.string,
                Te.bool
            ]),
            timeFormat: Te.oneOfType([
                Te.string,
                Te.bool
            ]),
            inputProps: Te.object,
            timeConstraints: Te.object,
            isValidDate: Te.func,
            open: Te.bool,
            strictParsing: Te.bool,
            closeOnSelect: Te.bool,
            closeOnTab: Te.bool,
            renderView: Te.func,
            renderInput: Te.func,
            renderDay: Te.func,
            renderMonth: Te.func,
            renderYear: Te.func
        }), _e(Fe, "defaultProps", {
            onOpen: Ne,
            onClose: Ne,
            onCalendarOpen: Ne,
            onCalendarClose: Ne,
            onChange: Ne,
            onNavigate: Ne,
            onBeforeNavigate: function(e) {
                return e;
            },
            onNavigateBack: Ne,
            onNavigateForward: Ne,
            dateFormat: !0,
            timeFormat: !0,
            utc: !1,
            className: "",
            input: !0,
            inputProps: {},
            timeConstraints: {},
            isValidDate: function() {
                return !0;
            },
            strictParsing: !0,
            closeOnSelect: !1,
            closeOnTab: !0,
            closeOnClickOutside: !0,
            renderView: function(e, t) {
                return t();
            }
        }), _e(Fe, "moment", a.a);
        var Re = de(function(e) {
            ge(n, e);
            var t = De(n);
            function n() {
                var e;
                ve(this, n);
                for(var r = arguments.length, o = new Array(r), i = 0; i < r; i++)o[i] = arguments[i];
                return _e(Ce(e = t.call.apply(t, [
                    this
                ].concat(o))), "container", c.a.createRef()), e;
            }
            return Oe(n, [
                {
                    key: "render",
                    value: function() {
                        return c.a.createElement("div", {
                            className: this.props.className,
                            ref: this.container
                        }, this.props.children);
                    }
                },
                {
                    key: "handleClickOutside",
                    value: function(e) {
                        this.props.onClickOut(e);
                    }
                },
                {
                    key: "setClickOutsideRef",
                    value: function() {
                        return this.container.current;
                    }
                }
            ]), n;
        }(c.a.Component));
    }
]);







const $9ebed2054e490b11$var$eventCache = new (0, $aa1ba0dc266f72fa$export$94affb487e701bf2)();
function $9ebed2054e490b11$export$ee2085e97a04e027(eventId, errorCollection) {
    const o = $9ebed2054e490b11$var$eventCache.get(eventId, ()=>{
        return $9ebed2054e490b11$var$fetchEvent(eventId).catch((ex)=>void errorCollection.push(ex.message));
    });
    return o;
}
function $9ebed2054e490b11$export$a970992424c1e7a5(eventId, errorCollection) {
    const o = $9ebed2054e490b11$var$eventCache.getOptional(eventId);
    if (o) o.setValue(undefined);
    return $9ebed2054e490b11$export$ee2085e97a04e027(eventId, errorCollection);
}
async function $9ebed2054e490b11$var$fetchEvent(eventId) {
    return (0, $09f8b9d3461587fb$export$f261951912e85b8d)(`/api/event/${eventId}`);
}
async function $9ebed2054e490b11$export$f531f92e2a15358f(event) {
    return (0, $09f8b9d3461587fb$export$f670e789619da3b3)("/api/event", event);
}
async function $9ebed2054e490b11$export$722f44e35c2acd00(eventId, round) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)(`/api/event/${eventId}/round`, round);
    if (Array.isArray(result)) return result;
    else if (result) $9ebed2054e490b11$var$updateCachedEvent(result);
}
async function $9ebed2054e490b11$export$f63b876860108f1c(eventId, roundId, round) {
    const result = await (0, $09f8b9d3461587fb$export$63551ada7ce593c9)(`/api/event/${eventId}/round/${roundId}`, round);
    if (Array.isArray(result)) return result;
    else if (result) $9ebed2054e490b11$var$updateCachedEvent(result);
}
async function $9ebed2054e490b11$export$97a332cdbb9101b1(eventId, roundId, option) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)(`/api/event/${eventId}/round/${roundId}/option`, option);
    if (Array.isArray(result)) return result;
    else if (result) $9ebed2054e490b11$var$updateCachedEvent(result);
}
async function $9ebed2054e490b11$export$1717f994e126a0c5(eventId, roundId, optionId) {
    const result = await (0, $09f8b9d3461587fb$export$bf66ab79f00a8669)("DELETE", `/api/event/${eventId}/round/${roundId}/option/${optionId}`);
    if (Array.isArray(result)) return result;
    else if (result) $9ebed2054e490b11$var$updateCachedEvent(result);
}
async function $9ebed2054e490b11$export$7c7155fbb6bc8d79(eventId, roundId, action) {
    const result = await (0, $09f8b9d3461587fb$export$bf66ab79f00a8669)(action === "abstain" ? "POST" : "DELETE", `/api/event/${eventId}/round/${roundId}/abstain`);
    if (Array.isArray(result)) return result;
    else if (result) $9ebed2054e490b11$var$updateCachedEvent(result);
}
async function $9ebed2054e490b11$export$eef0a990000408da(eventId, roundId, optionId, action) {
    const result = await (0, $09f8b9d3461587fb$export$bf66ab79f00a8669)(action === "add" ? "POST" : "DELETE", `/api/event/${eventId}/round/${roundId}/option/${optionId}/vote`);
    if (Array.isArray(result)) return result;
    else if (result) $9ebed2054e490b11$var$updateCachedEvent(result);
}
function $9ebed2054e490b11$var$updateCachedEvent(event) {
    const observable = $9ebed2054e490b11$var$eventCache.getOptional(event.eventId);
    if (observable) observable.setValue(event);
}
/* eslint-disable no-console */ const $9ebed2054e490b11$var$MIN_BACKOFF = 1000;
function $9ebed2054e490b11$var$_subscribe(eventId, connected) {
    const url = `/api/event/${eventId}/stream`;
    let source;
    let backoff = $9ebed2054e490b11$var$MIN_BACKOFF;
    const connect = ()=>{
        console.log("Connecting to event subscription.");
        source = new EventSource(url);
        source.onopen = (e)=>{
            connected.setValue(true);
            console.log("Connected to event subscription.");
            if (backoff > $9ebed2054e490b11$var$MIN_BACKOFF) backoff /= 2;
        };
        source.addEventListener("update", (e)=>{
            console.log("Event update received");
            const event = JSON.parse(e.data);
            $9ebed2054e490b11$var$updateCachedEvent(event);
        });
        source.onerror = async (e)=>{
            source?.close();
            source = undefined;
            connected.setValue(false);
            backoff *= 2;
            const wait = backoff + Math.random() * backoff * 0.1;
            console.log(`Lost event subscription, waiting ${wait}ms before reconnecting.`);
            await (0, $ff1fe7435e7c9214$export$1391212d75b2ee65)(wait);
            connect();
        };
    };
    connect();
    return ()=>{
        source?.close();
    };
}
const $9ebed2054e490b11$export$ec068583843480e7 = (0, $ff1fe7435e7c9214$export$cd82543cd4c649f1)($9ebed2054e490b11$var$_subscribe, 4, 60000); /* eslint-enable no-console */ 





const $e1610aabf171f616$var$teamCache = new (0, $aa1ba0dc266f72fa$export$94affb487e701bf2)();
function $e1610aabf171f616$export$491fe77f22ab2b51(teamId, errorCollection) {
    const o = $e1610aabf171f616$var$teamCache.get(teamId, ()=>{
        return $e1610aabf171f616$var$fetchTeam(teamId).catch((ex)=>void errorCollection.push(ex.message));
    });
    return o;
}
function $e1610aabf171f616$export$269955bfc389f5f4(teamId, errorCollection) {
    const o = $e1610aabf171f616$var$teamCache.getOptional(teamId);
    if (o) o.setValue(undefined);
    return $e1610aabf171f616$export$491fe77f22ab2b51(teamId, errorCollection);
}
async function $e1610aabf171f616$export$4cfc020b5d9a8d1() {
    return (0, $09f8b9d3461587fb$export$f261951912e85b8d)("/api/user/teams");
}
async function $e1610aabf171f616$export$ff848de5b4c70793() {
    return (0, $09f8b9d3461587fb$export$f261951912e85b8d)("/api/team/all");
}
async function $e1610aabf171f616$export$e44b0fb90766dd97(team) {
    return await (0, $09f8b9d3461587fb$export$f670e789619da3b3)("/api/team", team);
}
async function $e1610aabf171f616$export$47f143084f31963c(teamId) {
    try {
        const response = await fetch(`/api/team/${teamId}/join`, {
            method: "POST"
        });
        const teamObservable = $e1610aabf171f616$var$teamCache.getOptional(teamId);
        const team = teamObservable?.getValue();
        if (response.ok && teamObservable && team) teamObservable.setValue({
            ...team,
            isAdmin: !!(await (0, $81ca197868c8b74e$export$31553aaa555c1514)())?.currentUser?.isSuperAdmin,
            isMember: true
        });
        return response.ok;
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        return false;
    }
}
async function $e1610aabf171f616$export$8f526f07693a40d1(teamId) {
    try {
        const response = await fetch(`/api/team/${teamId}/leave`, {
            method: "POST"
        });
        const teamObservable = $e1610aabf171f616$var$teamCache.getOptional(teamId);
        const team = teamObservable?.getValue();
        if (response.ok && teamObservable && team) teamObservable.setValue({
            ...team,
            isAdmin: !!(await (0, $81ca197868c8b74e$export$31553aaa555c1514)())?.currentUser?.isSuperAdmin,
            isMember: false
        });
        return response.ok;
    } catch (ex) {
        // eslint-disable-next-line no-console
        console.error(ex);
        return false;
    }
}
async function $e1610aabf171f616$var$fetchTeam(teamId) {
    return (0, $09f8b9d3461587fb$export$f261951912e85b8d)(`/api/team/${teamId}`);
}
async function $e1610aabf171f616$export$e662071d38e352a1(teamId) {
    return (0, $09f8b9d3461587fb$export$f261951912e85b8d)(`/api/team/${teamId}/members`);
}
async function $e1610aabf171f616$export$6afb6efc053abf57(teamId) {
    return (0, $09f8b9d3461587fb$export$f261951912e85b8d)(`/api/team/${teamId}/events`);
}
async function $e1610aabf171f616$export$8dffcffbbf177bdd(teamId, username) {
    return (0, $09f8b9d3461587fb$export$f670e789619da3b3)(`/api/team/${teamId}/admins`, {
        username: username
    });
}
async function $e1610aabf171f616$export$71d59d3ff615c11a(teamId, username) {
    return (0, $09f8b9d3461587fb$export$6c249544e9d17d95)(`/api/team/${teamId}/admins`, {
        username: username
    });
}
async function $e1610aabf171f616$export$80143c9a921cac82(teamId) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)(`/api/team/${teamId}/updateInviteCode`, {});
    if (Array.isArray(result)) return result;
    else if (result) $e1610aabf171f616$var$teamCache.set(result.teamId, result);
}
async function $e1610aabf171f616$export$78d1d07f45abf430(teamId) {
    const result = await (0, $09f8b9d3461587fb$export$f670e789619da3b3)(`/api/team/${teamId}/clearInviteCode`, {});
    if (Array.isArray(result)) return result;
    else if (result) $e1610aabf171f616$var$teamCache.set(result.teamId, result);
}
async function $e1610aabf171f616$export$3ea71dc33336ab44(inviteCode) {
    return await (0, $09f8b9d3461587fb$export$f670e789619da3b3)(`/api/team/join/${inviteCode}`, {});
}
async function $e1610aabf171f616$export$57b1164dbe7b642f(teamId, username) {
    return (0, $09f8b9d3461587fb$export$6c249544e9d17d95)(`/api/team/${teamId}/members`, {
        username: username
    });
}






parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");



"use client";
const $7a6fc0ac75de37db$var$BreadcrumbItem = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, active: active = false, children: children, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'li', linkAs: LinkComponent = (0, $a0e9365cba08db2b$export$2e2bcd8739ae039), linkProps: linkProps = {}, href: href, title: title, target: target, ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'breadcrumb-item');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(prefix, className, {
            active: active
        }),
        "aria-current": active ? 'page' : undefined,
        children: active ? children : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(LinkComponent, {
            ...linkProps,
            href: href,
            title: title,
            target: target,
            children: children
        })
    });
});
$7a6fc0ac75de37db$var$BreadcrumbItem.displayName = 'BreadcrumbItem';
var $7a6fc0ac75de37db$export$2e2bcd8739ae039 = $7a6fc0ac75de37db$var$BreadcrumbItem;



"use client";
const $462fc53b42007d26$var$Breadcrumb = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, listProps: listProps = {}, children: children, label: label = 'breadcrumb', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'nav', ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'breadcrumb');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        "aria-label": label,
        className: className,
        ref: ref,
        ...props,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("ol", {
            ...listProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(prefix, listProps == null ? void 0 : listProps.className),
            children: children
        })
    });
});
$462fc53b42007d26$var$Breadcrumb.displayName = 'Breadcrumb';
var $462fc53b42007d26$export$2e2bcd8739ae039 = Object.assign($462fc53b42007d26$var$Breadcrumb, {
    Item: (0, $7a6fc0ac75de37db$export$2e2bcd8739ae039)
});






var $aZSru = parcelRequire("aZSru");


"use client";
const $c2a0c34732c0673f$var$ButtonToolbar = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, role: role = 'toolbar', ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'btn-toolbar');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, prefix),
        role: role
    });
});
$c2a0c34732c0673f$var$ButtonToolbar.displayName = 'ButtonToolbar';
var $c2a0c34732c0673f$export$2e2bcd8739ae039 = $c2a0c34732c0673f$var$ButtonToolbar;





var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
function $b26eb152ff7224ad$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $b26eb152ff7224ad$var$_toPropertyKey(arg) {
    var key = $b26eb152ff7224ad$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $b26eb152ff7224ad$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $b26eb152ff7224ad$export$26cbf8c37e721e67(key) {
    return 'default' + key.charAt(0).toUpperCase() + key.substr(1);
}
function $b26eb152ff7224ad$export$2ee51287a16ca325(propValue, defaultValue, handler) {
    const wasPropRef = (0, $aZSru.useRef)(propValue !== undefined);
    const [stateValue, setState] = (0, $aZSru.useState)(defaultValue);
    const isProp = propValue !== undefined;
    const wasProp = wasPropRef.current;
    wasPropRef.current = isProp;
    /**
   * If a prop switches from controlled to Uncontrolled
   * reset its value to the defaultValue
   */ if (!isProp && wasProp && stateValue !== defaultValue) setState(defaultValue);
    return [
        isProp ? propValue : stateValue,
        (0, $aZSru.useCallback)((...args)=>{
            const [value, ...rest] = args;
            let returnValue = handler == null ? void 0 : handler(value, ...rest);
            setState(value);
            return returnValue;
        }, [
            handler
        ])
    ];
}
function $b26eb152ff7224ad$export$ec55e9daaf703a7d(props, config) {
    return Object.keys(config).reduce((result, fieldName)=>{
        const _ref = result, _defaultKey = $b26eb152ff7224ad$export$26cbf8c37e721e67(fieldName), { [_defaultKey]: defaultValue, [fieldName]: propsValue } = _ref, rest = $b26eb152ff7224ad$var$_objectWithoutPropertiesLoose(_ref, [
            _defaultKey,
            fieldName
        ].map($b26eb152ff7224ad$var$_toPropertyKey));
        const handlerName = config[fieldName];
        const [value, handler] = $b26eb152ff7224ad$export$2ee51287a16ca325(propsValue, defaultValue, props[handlerName]);
        return Object.assign({}, rest, {
            [fieldName]: value,
            [handlerName]: handler
        });
    }, props);
}




var $aZSru = parcelRequire("aZSru");
function $ba7ee7ef2b39e899$export$2e2bcd8739ae039() {
    // The toggling state value is designed to defeat React optimizations for skipping
    // updates when they are strictly equal to the last state value
    const [, dispatch] = (0, $aZSru.useReducer)((revision)=>revision + 1, 0);
    return dispatch;
}





var $aZSru = parcelRequire("aZSru");
const $c1816855d30cb40e$var$DropdownContext = /*#__PURE__*/ $aZSru.createContext(null);
var $c1816855d30cb40e$export$2e2bcd8739ae039 = $c1816855d30cb40e$var$DropdownContext;



var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");
var $a63e4f0e7738f452$var$has = Object.prototype.hasOwnProperty;
function $a63e4f0e7738f452$var$find(iter, tar, key) {
    for (key of iter.keys()){
        if ($a63e4f0e7738f452$export$de8294bb3be0322f(key, tar)) return key;
    }
}
function $a63e4f0e7738f452$export$de8294bb3be0322f(foo, bar) {
    var ctor, len, tmp;
    if (foo === bar) return true;
    if (foo && bar && (ctor = foo.constructor) === bar.constructor) {
        if (ctor === Date) return foo.getTime() === bar.getTime();
        if (ctor === RegExp) return foo.toString() === bar.toString();
        if (ctor === Array) {
            if ((len = foo.length) === bar.length) {
                while(len-- && $a63e4f0e7738f452$export$de8294bb3be0322f(foo[len], bar[len]));
            }
            return len === -1;
        }
        if (ctor === Set) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len;
                if (tmp && typeof tmp === 'object') {
                    tmp = $a63e4f0e7738f452$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!bar.has(tmp)) return false;
            }
            return true;
        }
        if (ctor === Map) {
            if (foo.size !== bar.size) return false;
            for (len of foo){
                tmp = len[0];
                if (tmp && typeof tmp === 'object') {
                    tmp = $a63e4f0e7738f452$var$find(bar, tmp);
                    if (!tmp) return false;
                }
                if (!$a63e4f0e7738f452$export$de8294bb3be0322f(len[1], bar.get(tmp))) return false;
            }
            return true;
        }
        if (ctor === ArrayBuffer) {
            foo = new Uint8Array(foo);
            bar = new Uint8Array(bar);
        } else if (ctor === DataView) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo.getInt8(len) === bar.getInt8(len));
            }
            return len === -1;
        }
        if (ArrayBuffer.isView(foo)) {
            if ((len = foo.byteLength) === bar.byteLength) {
                while(len-- && foo[len] === bar[len]);
            }
            return len === -1;
        }
        if (!ctor || typeof foo === 'object') {
            len = 0;
            for(ctor in foo){
                if ($a63e4f0e7738f452$var$has.call(foo, ctor) && ++len && !$a63e4f0e7738f452$var$has.call(bar, ctor)) return false;
                if (!(ctor in bar) || !$a63e4f0e7738f452$export$de8294bb3be0322f(foo[ctor], bar[ctor])) return false;
            }
            return Object.keys(bar).length === len;
        }
    }
    return foo !== foo && bar !== bar;
}



var $aZSru = parcelRequire("aZSru");

/**
 * `useSafeState` takes the return value of a `useState` hook and wraps the
 * setter to prevent updates onces the component has unmounted. Can used
 * with `useMergeState` and `useStateAsync` as well
 *
 * @param state The return value of a useStateHook
 *
 * ```ts
 * const [show, setShow] = useSafeState(useState(true));
 * ```
 */ function $d176a434764c319a$var$useSafeState(state) {
    const isMounted = (0, $6c37138eb2d45e09$export$2e2bcd8739ae039)();
    return [
        state[0],
        (0, $aZSru.useCallback)((nextState)=>{
            if (!isMounted()) return;
            return state[1](nextState);
        }, [
            isMounted,
            state[1]
        ])
    ];
}
var $d176a434764c319a$export$2e2bcd8739ae039 = $d176a434764c319a$var$useSafeState;



function $bd94a0f70e6a31e6$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[0];
}


function $6bc817df39510492$export$2e2bcd8739ae039(node) {
    if (node == null) return window;
    if (node.toString() !== '[object Window]') {
        var ownerDocument = node.ownerDocument;
        return ownerDocument ? ownerDocument.defaultView || window : window;
    }
    return node;
}


function $8aa5d14d8a12c427$export$45a5e7f76e0caa8d(node) {
    var OwnElement = (0, $6bc817df39510492$export$2e2bcd8739ae039)(node).Element;
    return node instanceof OwnElement || node instanceof Element;
}
function $8aa5d14d8a12c427$export$1b3bfaa9684536aa(node) {
    var OwnElement = (0, $6bc817df39510492$export$2e2bcd8739ae039)(node).HTMLElement;
    return node instanceof OwnElement || node instanceof HTMLElement;
}
function $8aa5d14d8a12c427$export$af51f0f06c0f328a(node) {
    // IE 11 has no ShadowRoot
    if (typeof ShadowRoot === 'undefined') return false;
    var OwnElement = (0, $6bc817df39510492$export$2e2bcd8739ae039)(node).ShadowRoot;
    return node instanceof OwnElement || node instanceof ShadowRoot;
}


var $47158b2d5467c6d3$export$8960430cfd85939f = Math.max;
var $47158b2d5467c6d3$export$96ec731ed4dcb222 = Math.min;
var $47158b2d5467c6d3$export$2077e0241d6afd3c = Math.round;



function $e8fa2b1ff5be2e58$export$2e2bcd8739ae039() {
    var uaData = navigator.userAgentData;
    if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) return uaData.brands.map(function(item) {
        return item.brand + "/" + item.version;
    }).join(' ');
    return navigator.userAgent;
}


function $2a97ce5b619c9bcc$export$2e2bcd8739ae039() {
    return !/^((?!chrome|android).)*safari/i.test((0, $e8fa2b1ff5be2e58$export$2e2bcd8739ae039)());
}


function $e6f17403cd5beb47$export$2e2bcd8739ae039(element, includeScale, isFixedStrategy) {
    if (includeScale === void 0) includeScale = false;
    if (isFixedStrategy === void 0) isFixedStrategy = false;
    var clientRect = element.getBoundingClientRect();
    var scaleX = 1;
    var scaleY = 1;
    if (includeScale && (0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(element)) {
        scaleX = element.offsetWidth > 0 ? (0, $47158b2d5467c6d3$export$2077e0241d6afd3c)(clientRect.width) / element.offsetWidth || 1 : 1;
        scaleY = element.offsetHeight > 0 ? (0, $47158b2d5467c6d3$export$2077e0241d6afd3c)(clientRect.height) / element.offsetHeight || 1 : 1;
    }
    var _ref = (0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(element) ? (0, $6bc817df39510492$export$2e2bcd8739ae039)(element) : window, visualViewport = _ref.visualViewport;
    var addVisualOffsets = !(0, $2a97ce5b619c9bcc$export$2e2bcd8739ae039)() && isFixedStrategy;
    var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
    var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
    var width = clientRect.width / scaleX;
    var height = clientRect.height / scaleY;
    return {
        width: width,
        height: height,
        top: y,
        right: x + width,
        bottom: y + height,
        left: x,
        x: x,
        y: y
    };
}


function $65a16b582a36e525$export$2e2bcd8739ae039(element) {
    var clientRect = (0, $e6f17403cd5beb47$export$2e2bcd8739ae039)(element); // Use the clientRect sizes if it's not been transformed.
    // Fixes https://github.com/popperjs/popper-core/issues/1223
    var width = element.offsetWidth;
    var height = element.offsetHeight;
    if (Math.abs(clientRect.width - width) <= 1) width = clientRect.width;
    if (Math.abs(clientRect.height - height) <= 1) height = clientRect.height;
    return {
        x: element.offsetLeft,
        y: element.offsetTop,
        width: width,
        height: height
    };
}



function $b81de367a5450dc2$export$2e2bcd8739ae039(parent, child) {
    var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method
    if (parent.contains(child)) return true;
    else if (rootNode && (0, $8aa5d14d8a12c427$export$af51f0f06c0f328a)(rootNode)) {
        var next = child;
        do {
            if (next && parent.isSameNode(next)) return true;
             // $FlowFixMe[prop-missing]: need a better way to handle this...
            next = next.parentNode || next.host;
        }while (next);
    } // Give up, the result is false
    return false;
}



function $3b5901f208b24747$export$2e2bcd8739ae039(element) {
    return element ? (element.nodeName || '').toLowerCase() : null;
}



function $dfb311123b80588c$export$2e2bcd8739ae039(element) {
    return (0, $6bc817df39510492$export$2e2bcd8739ae039)(element).getComputedStyle(element);
}




function $360bc8200a2a5d5f$export$2e2bcd8739ae039(element) {
    return [
        'table',
        'td',
        'th'
    ].indexOf((0, $3b5901f208b24747$export$2e2bcd8739ae039)(element)) >= 0;
}




function $1c32741c776515eb$export$2e2bcd8739ae039(element) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return (((0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(element) ? element.ownerDocument : element.document) || window.document).documentElement;
}



function $1f966481ce6e2fac$export$2e2bcd8739ae039(element) {
    if ((0, $3b5901f208b24747$export$2e2bcd8739ae039)(element) === 'html') return element;
    return(// $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ((0, $8aa5d14d8a12c427$export$af51f0f06c0f328a)(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    (0, $1c32741c776515eb$export$2e2bcd8739ae039)(element) // fallback
    );
}



function $c7938117c7e91aed$var$getTrueOffsetParent(element) {
    if (!(0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(element) || // https://github.com/popperjs/popper-core/issues/837
    (0, $dfb311123b80588c$export$2e2bcd8739ae039)(element).position === 'fixed') return null;
    return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block
function $c7938117c7e91aed$var$getContainingBlock(element) {
    var isFirefox = /firefox/i.test((0, $e8fa2b1ff5be2e58$export$2e2bcd8739ae039)());
    var isIE = /Trident/i.test((0, $e8fa2b1ff5be2e58$export$2e2bcd8739ae039)());
    if (isIE && (0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(element)) {
        // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
        var elementCss = (0, $dfb311123b80588c$export$2e2bcd8739ae039)(element);
        if (elementCss.position === 'fixed') return null;
    }
    var currentNode = (0, $1f966481ce6e2fac$export$2e2bcd8739ae039)(element);
    if ((0, $8aa5d14d8a12c427$export$af51f0f06c0f328a)(currentNode)) currentNode = currentNode.host;
    while((0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(currentNode) && [
        'html',
        'body'
    ].indexOf((0, $3b5901f208b24747$export$2e2bcd8739ae039)(currentNode)) < 0){
        var css = (0, $dfb311123b80588c$export$2e2bcd8739ae039)(currentNode); // This is non-exhaustive but covers the most common CSS properties that
        // create a containing block.
        // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block
        if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || [
            'transform',
            'perspective'
        ].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') return currentNode;
        else currentNode = currentNode.parentNode;
    }
    return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
function $c7938117c7e91aed$export$2e2bcd8739ae039(element) {
    var window = (0, $6bc817df39510492$export$2e2bcd8739ae039)(element);
    var offsetParent = $c7938117c7e91aed$var$getTrueOffsetParent(element);
    while(offsetParent && (0, $360bc8200a2a5d5f$export$2e2bcd8739ae039)(offsetParent) && (0, $dfb311123b80588c$export$2e2bcd8739ae039)(offsetParent).position === 'static')offsetParent = $c7938117c7e91aed$var$getTrueOffsetParent(offsetParent);
    if (offsetParent && ((0, $3b5901f208b24747$export$2e2bcd8739ae039)(offsetParent) === 'html' || (0, $3b5901f208b24747$export$2e2bcd8739ae039)(offsetParent) === 'body' && (0, $dfb311123b80588c$export$2e2bcd8739ae039)(offsetParent).position === 'static')) return window;
    return offsetParent || $c7938117c7e91aed$var$getContainingBlock(element) || window;
}


function $dae7c41c348cb858$export$2e2bcd8739ae039(placement) {
    return [
        'top',
        'bottom'
    ].indexOf(placement) >= 0 ? 'x' : 'y';
}



function $ff192c62076041da$export$f28d906d67a997f3(min, value, max) {
    return (0, $47158b2d5467c6d3$export$8960430cfd85939f)(min, (0, $47158b2d5467c6d3$export$96ec731ed4dcb222)(value, max));
}
function $ff192c62076041da$export$86c8af6d3ef0b4a(min, value, max) {
    var v = $ff192c62076041da$export$f28d906d67a997f3(min, value, max);
    return v > max ? max : v;
}


function $23c828330233fd37$export$2e2bcd8739ae039() {
    return {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
    };
}


function $83de34a5e69e2cbb$export$2e2bcd8739ae039(paddingObject) {
    return Object.assign({}, (0, $23c828330233fd37$export$2e2bcd8739ae039)(), paddingObject);
}


function $b0c7742058780d0c$export$2e2bcd8739ae039(value, keys) {
    return keys.reduce(function(hashMap, key) {
        hashMap[key] = value;
        return hashMap;
    }, {});
}


var $ead90bd709f19827$export$1e95b668f3b82d = 'top';
var $ead90bd709f19827$export$40e543e69a8b3fbb = 'bottom';
var $ead90bd709f19827$export$79ffe56a765070d2 = 'right';
var $ead90bd709f19827$export$eabcd2c8791e7bf4 = 'left';
var $ead90bd709f19827$export$dfb5619354ba860 = 'auto';
var $ead90bd709f19827$export$aec2ce47c367b8c3 = [
    $ead90bd709f19827$export$1e95b668f3b82d,
    $ead90bd709f19827$export$40e543e69a8b3fbb,
    $ead90bd709f19827$export$79ffe56a765070d2,
    $ead90bd709f19827$export$eabcd2c8791e7bf4
];
var $ead90bd709f19827$export$b3571188c770cc5a = 'start';
var $ead90bd709f19827$export$bd5df0f255a350f8 = 'end';
var $ead90bd709f19827$export$390fd549c5303b4d = 'clippingParents';
var $ead90bd709f19827$export$d7b7311ec04a3e8f = 'viewport';
var $ead90bd709f19827$export$ae5ab1c730825774 = 'popper';
var $ead90bd709f19827$export$ca50aac9f3ba507f = 'reference';
var $ead90bd709f19827$export$368f9a87e87fa4e1 = /*#__PURE__*/ $ead90bd709f19827$export$aec2ce47c367b8c3.reduce(function(acc, placement) {
    return acc.concat([
        placement + "-" + $ead90bd709f19827$export$b3571188c770cc5a,
        placement + "-" + $ead90bd709f19827$export$bd5df0f255a350f8
    ]);
}, []);
var $ead90bd709f19827$export$803cd8101b6c182b = /*#__PURE__*/ [].concat($ead90bd709f19827$export$aec2ce47c367b8c3, [
    $ead90bd709f19827$export$dfb5619354ba860
]).reduce(function(acc, placement) {
    return acc.concat([
        placement,
        placement + "-" + $ead90bd709f19827$export$b3571188c770cc5a,
        placement + "-" + $ead90bd709f19827$export$bd5df0f255a350f8
    ]);
}, []); // modifiers that need to read the DOM
var $ead90bd709f19827$export$421679a7c3d56e = 'beforeRead';
var $ead90bd709f19827$export$aafa59e2e03f2942 = 'read';
var $ead90bd709f19827$export$6964f6c886723980 = 'afterRead'; // pure-logic modifiers
var $ead90bd709f19827$export$c65e99957a05207c = 'beforeMain';
var $ead90bd709f19827$export$f22da7240b7add18 = 'main';
var $ead90bd709f19827$export$bab79516f2d662fe = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)
var $ead90bd709f19827$export$8d4d2d70e7d46032 = 'beforeWrite';
var $ead90bd709f19827$export$68d8715fc104d294 = 'write';
var $ead90bd709f19827$export$70a6e5159acce2e6 = 'afterWrite';
var $ead90bd709f19827$export$d087d3878fdf71d5 = [
    $ead90bd709f19827$export$421679a7c3d56e,
    $ead90bd709f19827$export$aafa59e2e03f2942,
    $ead90bd709f19827$export$6964f6c886723980,
    $ead90bd709f19827$export$c65e99957a05207c,
    $ead90bd709f19827$export$f22da7240b7add18,
    $ead90bd709f19827$export$bab79516f2d662fe,
    $ead90bd709f19827$export$8d4d2d70e7d46032,
    $ead90bd709f19827$export$68d8715fc104d294,
    $ead90bd709f19827$export$70a6e5159acce2e6
];


var $45ac9c7232f5e779$var$toPaddingObject = function toPaddingObject(padding, state) {
    padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
        placement: state.placement
    })) : padding;
    return (0, $83de34a5e69e2cbb$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $b0c7742058780d0c$export$2e2bcd8739ae039)(padding, (0, $ead90bd709f19827$export$aec2ce47c367b8c3)));
};
function $45ac9c7232f5e779$var$arrow(_ref) {
    var _state$modifiersData$;
    var state = _ref.state, name = _ref.name, options = _ref.options;
    var arrowElement = state.elements.arrow;
    var popperOffsets = state.modifiersData.popperOffsets;
    var basePlacement = (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(state.placement);
    var axis = (0, $dae7c41c348cb858$export$2e2bcd8739ae039)(basePlacement);
    var isVertical = [
        (0, $ead90bd709f19827$export$eabcd2c8791e7bf4),
        (0, $ead90bd709f19827$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0;
    var len = isVertical ? 'height' : 'width';
    if (!arrowElement || !popperOffsets) return;
    var paddingObject = $45ac9c7232f5e779$var$toPaddingObject(options.padding, state);
    var arrowRect = (0, $65a16b582a36e525$export$2e2bcd8739ae039)(arrowElement);
    var minProp = axis === 'y' ? (0, $ead90bd709f19827$export$1e95b668f3b82d) : (0, $ead90bd709f19827$export$eabcd2c8791e7bf4);
    var maxProp = axis === 'y' ? (0, $ead90bd709f19827$export$40e543e69a8b3fbb) : (0, $ead90bd709f19827$export$79ffe56a765070d2);
    var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
    var startDiff = popperOffsets[axis] - state.rects.reference[axis];
    var arrowOffsetParent = (0, $c7938117c7e91aed$export$2e2bcd8739ae039)(arrowElement);
    var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
    var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
    // outside of the popper bounds
    var min = paddingObject[minProp];
    var max = clientSize - arrowRect[len] - paddingObject[maxProp];
    var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
    var offset = (0, $ff192c62076041da$export$f28d906d67a997f3)(min, center, max); // Prevents breaking syntax highlighting...
    var axisProp = axis;
    state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}
function $45ac9c7232f5e779$var$effect(_ref2) {
    var state = _ref2.state, options = _ref2.options;
    var _options$element = options.element, arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;
    if (arrowElement == null) return;
     // CSS selector
    if (typeof arrowElement === 'string') {
        arrowElement = state.elements.popper.querySelector(arrowElement);
        if (!arrowElement) return;
    }
    if (!(0, $b81de367a5450dc2$export$2e2bcd8739ae039)(state.elements.popper, arrowElement)) return;
    state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules
var $45ac9c7232f5e779$export$2e2bcd8739ae039 = {
    name: 'arrow',
    enabled: true,
    phase: 'main',
    fn: $45ac9c7232f5e779$var$arrow,
    effect: $45ac9c7232f5e779$var$effect,
    requires: [
        'popperOffsets'
    ],
    requiresIfExists: [
        'preventOverflow'
    ]
};








function $99fb66d89cf0379f$export$2e2bcd8739ae039(placement) {
    return placement.split('-')[1];
}



var $78c9dca98a97c656$var$unsetSides = {
    top: 'auto',
    right: 'auto',
    bottom: 'auto',
    left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.
function $78c9dca98a97c656$var$roundOffsetsByDPR(_ref, win) {
    var x = _ref.x, y = _ref.y;
    var dpr = win.devicePixelRatio || 1;
    return {
        x: (0, $47158b2d5467c6d3$export$2077e0241d6afd3c)(x * dpr) / dpr || 0,
        y: (0, $47158b2d5467c6d3$export$2077e0241d6afd3c)(y * dpr) / dpr || 0
    };
}
function $78c9dca98a97c656$export$378fa78a8fea596f(_ref2) {
    var _Object$assign2;
    var popper = _ref2.popper, popperRect = _ref2.popperRect, placement = _ref2.placement, variation = _ref2.variation, offsets = _ref2.offsets, position = _ref2.position, gpuAcceleration = _ref2.gpuAcceleration, adaptive = _ref2.adaptive, roundOffsets = _ref2.roundOffsets, isFixed = _ref2.isFixed;
    var _offsets$x = offsets.x, x = _offsets$x === void 0 ? 0 : _offsets$x, _offsets$y = offsets.y, y = _offsets$y === void 0 ? 0 : _offsets$y;
    var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
        x: x,
        y: y
    }) : {
        x: x,
        y: y
    };
    x = _ref3.x;
    y = _ref3.y;
    var hasX = offsets.hasOwnProperty('x');
    var hasY = offsets.hasOwnProperty('y');
    var sideX = (0, $ead90bd709f19827$export$eabcd2c8791e7bf4);
    var sideY = (0, $ead90bd709f19827$export$1e95b668f3b82d);
    var win = window;
    if (adaptive) {
        var offsetParent = (0, $c7938117c7e91aed$export$2e2bcd8739ae039)(popper);
        var heightProp = 'clientHeight';
        var widthProp = 'clientWidth';
        if (offsetParent === (0, $6bc817df39510492$export$2e2bcd8739ae039)(popper)) {
            offsetParent = (0, $1c32741c776515eb$export$2e2bcd8739ae039)(popper);
            if ((0, $dfb311123b80588c$export$2e2bcd8739ae039)(offsetParent).position !== 'static' && position === 'absolute') {
                heightProp = 'scrollHeight';
                widthProp = 'scrollWidth';
            }
        } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it
        offsetParent;
        if (placement === (0, $ead90bd709f19827$export$1e95b668f3b82d) || (placement === (0, $ead90bd709f19827$export$eabcd2c8791e7bf4) || placement === (0, $ead90bd709f19827$export$79ffe56a765070d2)) && variation === (0, $ead90bd709f19827$export$bd5df0f255a350f8)) {
            sideY = (0, $ead90bd709f19827$export$40e543e69a8b3fbb);
            var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : offsetParent[heightProp];
            y -= offsetY - popperRect.height;
            y *= gpuAcceleration ? 1 : -1;
        }
        if (placement === (0, $ead90bd709f19827$export$eabcd2c8791e7bf4) || (placement === (0, $ead90bd709f19827$export$1e95b668f3b82d) || placement === (0, $ead90bd709f19827$export$40e543e69a8b3fbb)) && variation === (0, $ead90bd709f19827$export$bd5df0f255a350f8)) {
            sideX = (0, $ead90bd709f19827$export$79ffe56a765070d2);
            var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : offsetParent[widthProp];
            x -= offsetX - popperRect.width;
            x *= gpuAcceleration ? 1 : -1;
        }
    }
    var commonStyles = Object.assign({
        position: position
    }, adaptive && $78c9dca98a97c656$var$unsetSides);
    var _ref4 = roundOffsets === true ? $78c9dca98a97c656$var$roundOffsetsByDPR({
        x: x,
        y: y
    }, (0, $6bc817df39510492$export$2e2bcd8739ae039)(popper)) : {
        x: x,
        y: y
    };
    x = _ref4.x;
    y = _ref4.y;
    if (gpuAcceleration) {
        var _Object$assign;
        return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
    }
    return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}
function $78c9dca98a97c656$var$computeStyles(_ref5) {
    var state = _ref5.state, options = _ref5.options;
    var _options$gpuAccelerat = options.gpuAcceleration, gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat, _options$adaptive = options.adaptive, adaptive = _options$adaptive === void 0 ? true : _options$adaptive, _options$roundOffsets = options.roundOffsets, roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
    var commonStyles = {
        placement: (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(state.placement),
        variation: (0, $99fb66d89cf0379f$export$2e2bcd8739ae039)(state.placement),
        popper: state.elements.popper,
        popperRect: state.rects.popper,
        gpuAcceleration: gpuAcceleration,
        isFixed: state.options.strategy === 'fixed'
    };
    if (state.modifiersData.popperOffsets != null) state.styles.popper = Object.assign({}, state.styles.popper, $78c9dca98a97c656$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.popperOffsets,
        position: state.options.strategy,
        adaptive: adaptive,
        roundOffsets: roundOffsets
    })));
    if (state.modifiersData.arrow != null) state.styles.arrow = Object.assign({}, state.styles.arrow, $78c9dca98a97c656$export$378fa78a8fea596f(Object.assign({}, commonStyles, {
        offsets: state.modifiersData.arrow,
        position: 'absolute',
        adaptive: false,
        roundOffsets: roundOffsets
    })));
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-placement': state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $78c9dca98a97c656$export$2e2bcd8739ae039 = {
    name: 'computeStyles',
    enabled: true,
    phase: 'beforeWrite',
    fn: $78c9dca98a97c656$var$computeStyles,
    data: {}
};



var $650b69635114afcc$var$passive = {
    passive: true
};
function $650b69635114afcc$var$effect(_ref) {
    var state = _ref.state, instance = _ref.instance, options = _ref.options;
    var _options$scroll = options.scroll, scroll = _options$scroll === void 0 ? true : _options$scroll, _options$resize = options.resize, resize = _options$resize === void 0 ? true : _options$resize;
    var window = (0, $6bc817df39510492$export$2e2bcd8739ae039)(state.elements.popper);
    var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);
    if (scroll) scrollParents.forEach(function(scrollParent) {
        scrollParent.addEventListener('scroll', instance.update, $650b69635114afcc$var$passive);
    });
    if (resize) window.addEventListener('resize', instance.update, $650b69635114afcc$var$passive);
    return function() {
        if (scroll) scrollParents.forEach(function(scrollParent) {
            scrollParent.removeEventListener('scroll', instance.update, $650b69635114afcc$var$passive);
        });
        if (resize) window.removeEventListener('resize', instance.update, $650b69635114afcc$var$passive);
    };
} // eslint-disable-next-line import/no-unused-modules
var $650b69635114afcc$export$2e2bcd8739ae039 = {
    name: 'eventListeners',
    enabled: true,
    phase: 'write',
    fn: function fn() {},
    effect: $650b69635114afcc$var$effect,
    data: {}
};


var $6a3bc0799af0dbf8$var$hash = {
    left: 'right',
    right: 'left',
    bottom: 'top',
    top: 'bottom'
};
function $6a3bc0799af0dbf8$export$2e2bcd8739ae039(placement) {
    return placement.replace(/left|right|bottom|top/g, function(matched) {
        return $6a3bc0799af0dbf8$var$hash[matched];
    });
}



var $2ad9092b269c449e$var$hash = {
    start: 'end',
    end: 'start'
};
function $2ad9092b269c449e$export$2e2bcd8739ae039(placement) {
    return placement.replace(/start|end/g, function(matched) {
        return $2ad9092b269c449e$var$hash[matched];
    });
}








function $db35d76dea677469$export$2e2bcd8739ae039(node) {
    var win = (0, $6bc817df39510492$export$2e2bcd8739ae039)(node);
    var scrollLeft = win.pageXOffset;
    var scrollTop = win.pageYOffset;
    return {
        scrollLeft: scrollLeft,
        scrollTop: scrollTop
    };
}


function $511b873a9d328dd3$export$2e2bcd8739ae039(element) {
    // If <html> has a CSS width greater than the viewport, then this will be
    // incorrect for RTL.
    // Popper 1 is broken in this case and never had a bug report so let's assume
    // it's not an issue. I don't think anyone ever specifies width on <html>
    // anyway.
    // Browsers where the left scrollbar doesn't cause an issue report `0` for
    // this (e.g. Edge 2019, IE11, Safari)
    return (0, $e6f17403cd5beb47$export$2e2bcd8739ae039)((0, $1c32741c776515eb$export$2e2bcd8739ae039)(element)).left + (0, $db35d76dea677469$export$2e2bcd8739ae039)(element).scrollLeft;
}



function $7805d928050c3f9d$export$2e2bcd8739ae039(element, strategy) {
    var win = (0, $6bc817df39510492$export$2e2bcd8739ae039)(element);
    var html = (0, $1c32741c776515eb$export$2e2bcd8739ae039)(element);
    var visualViewport = win.visualViewport;
    var width = html.clientWidth;
    var height = html.clientHeight;
    var x = 0;
    var y = 0;
    if (visualViewport) {
        width = visualViewport.width;
        height = visualViewport.height;
        var layoutViewport = (0, $2a97ce5b619c9bcc$export$2e2bcd8739ae039)();
        if (layoutViewport || !layoutViewport && strategy === 'fixed') {
            x = visualViewport.offsetLeft;
            y = visualViewport.offsetTop;
        }
    }
    return {
        width: width,
        height: height,
        x: x + (0, $511b873a9d328dd3$export$2e2bcd8739ae039)(element),
        y: y
    };
}







function $d6531b62da584d24$export$2e2bcd8739ae039(element) {
    var _element$ownerDocumen;
    var html = (0, $1c32741c776515eb$export$2e2bcd8739ae039)(element);
    var winScroll = (0, $db35d76dea677469$export$2e2bcd8739ae039)(element);
    var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
    var width = (0, $47158b2d5467c6d3$export$8960430cfd85939f)(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
    var height = (0, $47158b2d5467c6d3$export$8960430cfd85939f)(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
    var x = -winScroll.scrollLeft + (0, $511b873a9d328dd3$export$2e2bcd8739ae039)(element);
    var y = -winScroll.scrollTop;
    if ((0, $dfb311123b80588c$export$2e2bcd8739ae039)(body || html).direction === 'rtl') x += (0, $47158b2d5467c6d3$export$8960430cfd85939f)(html.clientWidth, body ? body.clientWidth : 0) - width;
    return {
        width: width,
        height: height,
        x: x,
        y: y
    };
}




function $56611f99dbc37003$export$2e2bcd8739ae039(element) {
    // Firefox wants us to check `-x` and `-y` variations as well
    var _getComputedStyle = (0, $dfb311123b80588c$export$2e2bcd8739ae039)(element), overflow = _getComputedStyle.overflow, overflowX = _getComputedStyle.overflowX, overflowY = _getComputedStyle.overflowY;
    return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}




function $700adff265f5a502$export$2e2bcd8739ae039(node) {
    if ([
        'html',
        'body',
        '#document'
    ].indexOf((0, $3b5901f208b24747$export$2e2bcd8739ae039)(node)) >= 0) // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
    if ((0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(node) && (0, $56611f99dbc37003$export$2e2bcd8739ae039)(node)) return node;
    return $700adff265f5a502$export$2e2bcd8739ae039((0, $1f966481ce6e2fac$export$2e2bcd8739ae039)(node));
}





function $bd957012df8dcfc1$export$2e2bcd8739ae039(element, list) {
    var _element$ownerDocumen;
    if (list === void 0) list = [];
    var scrollParent = (0, $700adff265f5a502$export$2e2bcd8739ae039)(element);
    var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
    var win = (0, $6bc817df39510492$export$2e2bcd8739ae039)(scrollParent);
    var target = isBody ? [
        win
    ].concat(win.visualViewport || [], (0, $56611f99dbc37003$export$2e2bcd8739ae039)(scrollParent) ? scrollParent : []) : scrollParent;
    var updatedList = list.concat(target);
    return isBody ? updatedList : updatedList.concat($bd957012df8dcfc1$export$2e2bcd8739ae039((0, $1f966481ce6e2fac$export$2e2bcd8739ae039)(target)));
}










function $4fef99d2e4c5a615$export$2e2bcd8739ae039(rect) {
    return Object.assign({}, rect, {
        left: rect.x,
        top: rect.y,
        right: rect.x + rect.width,
        bottom: rect.y + rect.height
    });
}



function $2100cca639e30e77$var$getInnerBoundingClientRect(element, strategy) {
    var rect = (0, $e6f17403cd5beb47$export$2e2bcd8739ae039)(element, false, strategy === 'fixed');
    rect.top = rect.top + element.clientTop;
    rect.left = rect.left + element.clientLeft;
    rect.bottom = rect.top + element.clientHeight;
    rect.right = rect.left + element.clientWidth;
    rect.width = element.clientWidth;
    rect.height = element.clientHeight;
    rect.x = rect.left;
    rect.y = rect.top;
    return rect;
}
function $2100cca639e30e77$var$getClientRectFromMixedType(element, clippingParent, strategy) {
    return clippingParent === (0, $ead90bd709f19827$export$d7b7311ec04a3e8f) ? (0, $4fef99d2e4c5a615$export$2e2bcd8739ae039)((0, $7805d928050c3f9d$export$2e2bcd8739ae039)(element, strategy)) : (0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(clippingParent) ? $2100cca639e30e77$var$getInnerBoundingClientRect(clippingParent, strategy) : (0, $4fef99d2e4c5a615$export$2e2bcd8739ae039)((0, $d6531b62da584d24$export$2e2bcd8739ae039)((0, $1c32741c776515eb$export$2e2bcd8739ae039)(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`
function $2100cca639e30e77$var$getClippingParents(element) {
    var clippingParents = (0, $bd957012df8dcfc1$export$2e2bcd8739ae039)((0, $1f966481ce6e2fac$export$2e2bcd8739ae039)(element));
    var canEscapeClipping = [
        'absolute',
        'fixed'
    ].indexOf((0, $dfb311123b80588c$export$2e2bcd8739ae039)(element).position) >= 0;
    var clipperElement = canEscapeClipping && (0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(element) ? (0, $c7938117c7e91aed$export$2e2bcd8739ae039)(element) : element;
    if (!(0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(clipperElement)) return [];
     // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414
    return clippingParents.filter(function(clippingParent) {
        return (0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(clippingParent) && (0, $b81de367a5450dc2$export$2e2bcd8739ae039)(clippingParent, clipperElement) && (0, $3b5901f208b24747$export$2e2bcd8739ae039)(clippingParent) !== 'body';
    });
} // Gets the maximum area that the element is visible in due to any number of
function $2100cca639e30e77$export$2e2bcd8739ae039(element, boundary, rootBoundary, strategy) {
    var mainClippingParents = boundary === 'clippingParents' ? $2100cca639e30e77$var$getClippingParents(element) : [].concat(boundary);
    var clippingParents = [].concat(mainClippingParents, [
        rootBoundary
    ]);
    var firstClippingParent = clippingParents[0];
    var clippingRect = clippingParents.reduce(function(accRect, clippingParent) {
        var rect = $2100cca639e30e77$var$getClientRectFromMixedType(element, clippingParent, strategy);
        accRect.top = (0, $47158b2d5467c6d3$export$8960430cfd85939f)(rect.top, accRect.top);
        accRect.right = (0, $47158b2d5467c6d3$export$96ec731ed4dcb222)(rect.right, accRect.right);
        accRect.bottom = (0, $47158b2d5467c6d3$export$96ec731ed4dcb222)(rect.bottom, accRect.bottom);
        accRect.left = (0, $47158b2d5467c6d3$export$8960430cfd85939f)(rect.left, accRect.left);
        return accRect;
    }, $2100cca639e30e77$var$getClientRectFromMixedType(element, firstClippingParent, strategy));
    clippingRect.width = clippingRect.right - clippingRect.left;
    clippingRect.height = clippingRect.bottom - clippingRect.top;
    clippingRect.x = clippingRect.left;
    clippingRect.y = clippingRect.top;
    return clippingRect;
}








function $8b882cf8c421e74c$export$2e2bcd8739ae039(_ref) {
    var reference = _ref.reference, element = _ref.element, placement = _ref.placement;
    var basePlacement = placement ? (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(placement) : null;
    var variation = placement ? (0, $99fb66d89cf0379f$export$2e2bcd8739ae039)(placement) : null;
    var commonX = reference.x + reference.width / 2 - element.width / 2;
    var commonY = reference.y + reference.height / 2 - element.height / 2;
    var offsets;
    switch(basePlacement){
        case 0, $ead90bd709f19827$export$1e95b668f3b82d:
            offsets = {
                x: commonX,
                y: reference.y - element.height
            };
            break;
        case 0, $ead90bd709f19827$export$40e543e69a8b3fbb:
            offsets = {
                x: commonX,
                y: reference.y + reference.height
            };
            break;
        case 0, $ead90bd709f19827$export$79ffe56a765070d2:
            offsets = {
                x: reference.x + reference.width,
                y: commonY
            };
            break;
        case 0, $ead90bd709f19827$export$eabcd2c8791e7bf4:
            offsets = {
                x: reference.x - element.width,
                y: commonY
            };
            break;
        default:
            offsets = {
                x: reference.x,
                y: reference.y
            };
    }
    var mainAxis = basePlacement ? (0, $dae7c41c348cb858$export$2e2bcd8739ae039)(basePlacement) : null;
    if (mainAxis != null) {
        var len = mainAxis === 'y' ? 'height' : 'width';
        switch(variation){
            case 0, $ead90bd709f19827$export$b3571188c770cc5a:
                offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
                break;
            case 0, $ead90bd709f19827$export$bd5df0f255a350f8:
                offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
                break;
            default:
        }
    }
    return offsets;
}







function $6391331b5cbe9ed8$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, _options$placement = _options.placement, placement = _options$placement === void 0 ? state.placement : _options$placement, _options$strategy = _options.strategy, strategy = _options$strategy === void 0 ? state.strategy : _options$strategy, _options$boundary = _options.boundary, boundary = _options$boundary === void 0 ? (0, $ead90bd709f19827$export$390fd549c5303b4d) : _options$boundary, _options$rootBoundary = _options.rootBoundary, rootBoundary = _options$rootBoundary === void 0 ? (0, $ead90bd709f19827$export$d7b7311ec04a3e8f) : _options$rootBoundary, _options$elementConte = _options.elementContext, elementContext = _options$elementConte === void 0 ? (0, $ead90bd709f19827$export$ae5ab1c730825774) : _options$elementConte, _options$altBoundary = _options.altBoundary, altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary, _options$padding = _options.padding, padding = _options$padding === void 0 ? 0 : _options$padding;
    var paddingObject = (0, $83de34a5e69e2cbb$export$2e2bcd8739ae039)(typeof padding !== 'number' ? padding : (0, $b0c7742058780d0c$export$2e2bcd8739ae039)(padding, (0, $ead90bd709f19827$export$aec2ce47c367b8c3)));
    var altContext = elementContext === (0, $ead90bd709f19827$export$ae5ab1c730825774) ? (0, $ead90bd709f19827$export$ca50aac9f3ba507f) : (0, $ead90bd709f19827$export$ae5ab1c730825774);
    var popperRect = state.rects.popper;
    var element = state.elements[altBoundary ? altContext : elementContext];
    var clippingClientRect = (0, $2100cca639e30e77$export$2e2bcd8739ae039)((0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(element) ? element : element.contextElement || (0, $1c32741c776515eb$export$2e2bcd8739ae039)(state.elements.popper), boundary, rootBoundary, strategy);
    var referenceClientRect = (0, $e6f17403cd5beb47$export$2e2bcd8739ae039)(state.elements.reference);
    var popperOffsets = (0, $8b882cf8c421e74c$export$2e2bcd8739ae039)({
        reference: referenceClientRect,
        element: popperRect,
        strategy: 'absolute',
        placement: placement
    });
    var popperClientRect = (0, $4fef99d2e4c5a615$export$2e2bcd8739ae039)(Object.assign({}, popperRect, popperOffsets));
    var elementClientRect = elementContext === (0, $ead90bd709f19827$export$ae5ab1c730825774) ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
    // 0 or negative = within the clipping rect
    var overflowOffsets = {
        top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
        bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
        left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
        right: elementClientRect.right - clippingClientRect.right + paddingObject.right
    };
    var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element
    if (elementContext === (0, $ead90bd709f19827$export$ae5ab1c730825774) && offsetData) {
        var offset = offsetData[placement];
        Object.keys(overflowOffsets).forEach(function(key) {
            var multiply = [
                (0, $ead90bd709f19827$export$79ffe56a765070d2),
                (0, $ead90bd709f19827$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 1 : -1;
            var axis = [
                (0, $ead90bd709f19827$export$1e95b668f3b82d),
                (0, $ead90bd709f19827$export$40e543e69a8b3fbb)
            ].indexOf(key) >= 0 ? 'y' : 'x';
            overflowOffsets[key] += offset[axis] * multiply;
        });
    }
    return overflowOffsets;
}






function $c918ce9072c0cd32$export$2e2bcd8739ae039(state, options) {
    if (options === void 0) options = {};
    var _options = options, placement = _options.placement, boundary = _options.boundary, rootBoundary = _options.rootBoundary, padding = _options.padding, flipVariations = _options.flipVariations, _options$allowedAutoP = _options.allowedAutoPlacements, allowedAutoPlacements = _options$allowedAutoP === void 0 ? (0, $ead90bd709f19827$export$803cd8101b6c182b) : _options$allowedAutoP;
    var variation = (0, $99fb66d89cf0379f$export$2e2bcd8739ae039)(placement);
    var placements = variation ? flipVariations ? (0, $ead90bd709f19827$export$368f9a87e87fa4e1) : (0, $ead90bd709f19827$export$368f9a87e87fa4e1).filter(function(placement) {
        return (0, $99fb66d89cf0379f$export$2e2bcd8739ae039)(placement) === variation;
    }) : (0, $ead90bd709f19827$export$aec2ce47c367b8c3);
    var allowedPlacements = placements.filter(function(placement) {
        return allowedAutoPlacements.indexOf(placement) >= 0;
    });
    if (allowedPlacements.length === 0) allowedPlacements = placements;
     // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...
    var overflows = allowedPlacements.reduce(function(acc, placement) {
        acc[placement] = (0, $6391331b5cbe9ed8$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding
        })[(0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(placement)];
        return acc;
    }, {});
    return Object.keys(overflows).sort(function(a, b) {
        return overflows[a] - overflows[b];
    });
}




function $98db3bf16e58ef49$var$getExpandedFallbackPlacements(placement) {
    if ((0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(placement) === (0, $ead90bd709f19827$export$dfb5619354ba860)) return [];
    var oppositePlacement = (0, $6a3bc0799af0dbf8$export$2e2bcd8739ae039)(placement);
    return [
        (0, $2ad9092b269c449e$export$2e2bcd8739ae039)(placement),
        oppositePlacement,
        (0, $2ad9092b269c449e$export$2e2bcd8739ae039)(oppositePlacement)
    ];
}
function $98db3bf16e58ef49$var$flip(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    if (state.modifiersData[name]._skip) return;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis, specifiedFallbackPlacements = options.fallbackPlacements, padding = options.padding, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, _options$flipVariatio = options.flipVariations, flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio, allowedAutoPlacements = options.allowedAutoPlacements;
    var preferredPlacement = state.options.placement;
    var basePlacement = (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(preferredPlacement);
    var isBasePlacement = basePlacement === preferredPlacement;
    var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [
        (0, $6a3bc0799af0dbf8$export$2e2bcd8739ae039)(preferredPlacement)
    ] : $98db3bf16e58ef49$var$getExpandedFallbackPlacements(preferredPlacement));
    var placements = [
        preferredPlacement
    ].concat(fallbackPlacements).reduce(function(acc, placement) {
        return acc.concat((0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(placement) === (0, $ead90bd709f19827$export$dfb5619354ba860) ? (0, $c918ce9072c0cd32$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            padding: padding,
            flipVariations: flipVariations,
            allowedAutoPlacements: allowedAutoPlacements
        }) : placement);
    }, []);
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var checksMap = new Map();
    var makeFallbackChecks = true;
    var firstFittingPlacement = placements[0];
    for(var i = 0; i < placements.length; i++){
        var placement = placements[i];
        var _basePlacement = (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(placement);
        var isStartVariation = (0, $99fb66d89cf0379f$export$2e2bcd8739ae039)(placement) === (0, $ead90bd709f19827$export$b3571188c770cc5a);
        var isVertical = [
            (0, $ead90bd709f19827$export$1e95b668f3b82d),
            (0, $ead90bd709f19827$export$40e543e69a8b3fbb)
        ].indexOf(_basePlacement) >= 0;
        var len = isVertical ? 'width' : 'height';
        var overflow = (0, $6391331b5cbe9ed8$export$2e2bcd8739ae039)(state, {
            placement: placement,
            boundary: boundary,
            rootBoundary: rootBoundary,
            altBoundary: altBoundary,
            padding: padding
        });
        var mainVariationSide = isVertical ? isStartVariation ? (0, $ead90bd709f19827$export$79ffe56a765070d2) : (0, $ead90bd709f19827$export$eabcd2c8791e7bf4) : isStartVariation ? (0, $ead90bd709f19827$export$40e543e69a8b3fbb) : (0, $ead90bd709f19827$export$1e95b668f3b82d);
        if (referenceRect[len] > popperRect[len]) mainVariationSide = (0, $6a3bc0799af0dbf8$export$2e2bcd8739ae039)(mainVariationSide);
        var altVariationSide = (0, $6a3bc0799af0dbf8$export$2e2bcd8739ae039)(mainVariationSide);
        var checks = [];
        if (checkMainAxis) checks.push(overflow[_basePlacement] <= 0);
        if (checkAltAxis) checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
        if (checks.every(function(check) {
            return check;
        })) {
            firstFittingPlacement = placement;
            makeFallbackChecks = false;
            break;
        }
        checksMap.set(placement, checks);
    }
    if (makeFallbackChecks) {
        // `2` may be desired in some cases – research later
        var numberOfChecks = flipVariations ? 3 : 1;
        var _loop = function _loop(_i) {
            var fittingPlacement = placements.find(function(placement) {
                var checks = checksMap.get(placement);
                if (checks) return checks.slice(0, _i).every(function(check) {
                    return check;
                });
            });
            if (fittingPlacement) {
                firstFittingPlacement = fittingPlacement;
                return "break";
            }
        };
        for(var _i = numberOfChecks; _i > 0; _i--){
            var _ret = _loop(_i);
            if (_ret === "break") break;
        }
    }
    if (state.placement !== firstFittingPlacement) {
        state.modifiersData[name]._skip = true;
        state.placement = firstFittingPlacement;
        state.reset = true;
    }
} // eslint-disable-next-line import/no-unused-modules
var $98db3bf16e58ef49$export$2e2bcd8739ae039 = {
    name: 'flip',
    enabled: true,
    phase: 'main',
    fn: $98db3bf16e58ef49$var$flip,
    requiresIfExists: [
        'offset'
    ],
    data: {
        _skip: false
    }
};




function $58f3589dbc489f3a$var$getSideOffsets(overflow, rect, preventedOffsets) {
    if (preventedOffsets === void 0) preventedOffsets = {
        x: 0,
        y: 0
    };
    return {
        top: overflow.top - rect.height - preventedOffsets.y,
        right: overflow.right - rect.width + preventedOffsets.x,
        bottom: overflow.bottom - rect.height + preventedOffsets.y,
        left: overflow.left - rect.width - preventedOffsets.x
    };
}
function $58f3589dbc489f3a$var$isAnySideFullyClipped(overflow) {
    return [
        (0, $ead90bd709f19827$export$1e95b668f3b82d),
        (0, $ead90bd709f19827$export$79ffe56a765070d2),
        (0, $ead90bd709f19827$export$40e543e69a8b3fbb),
        (0, $ead90bd709f19827$export$eabcd2c8791e7bf4)
    ].some(function(side) {
        return overflow[side] >= 0;
    });
}
function $58f3589dbc489f3a$var$hide(_ref) {
    var state = _ref.state, name = _ref.name;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var preventedOffsets = state.modifiersData.preventOverflow;
    var referenceOverflow = (0, $6391331b5cbe9ed8$export$2e2bcd8739ae039)(state, {
        elementContext: 'reference'
    });
    var popperAltOverflow = (0, $6391331b5cbe9ed8$export$2e2bcd8739ae039)(state, {
        altBoundary: true
    });
    var referenceClippingOffsets = $58f3589dbc489f3a$var$getSideOffsets(referenceOverflow, referenceRect);
    var popperEscapeOffsets = $58f3589dbc489f3a$var$getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
    var isReferenceHidden = $58f3589dbc489f3a$var$isAnySideFullyClipped(referenceClippingOffsets);
    var hasPopperEscaped = $58f3589dbc489f3a$var$isAnySideFullyClipped(popperEscapeOffsets);
    state.modifiersData[name] = {
        referenceClippingOffsets: referenceClippingOffsets,
        popperEscapeOffsets: popperEscapeOffsets,
        isReferenceHidden: isReferenceHidden,
        hasPopperEscaped: hasPopperEscaped
    };
    state.attributes.popper = Object.assign({}, state.attributes.popper, {
        'data-popper-reference-hidden': isReferenceHidden,
        'data-popper-escaped': hasPopperEscaped
    });
} // eslint-disable-next-line import/no-unused-modules
var $58f3589dbc489f3a$export$2e2bcd8739ae039 = {
    name: 'hide',
    enabled: true,
    phase: 'main',
    requiresIfExists: [
        'preventOverflow'
    ],
    fn: $58f3589dbc489f3a$var$hide
};




function $4fc1165d37196198$export$7fa02d8595b015ed(placement, rects, offset) {
    var basePlacement = (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(placement);
    var invertDistance = [
        (0, $ead90bd709f19827$export$eabcd2c8791e7bf4),
        (0, $ead90bd709f19827$export$1e95b668f3b82d)
    ].indexOf(basePlacement) >= 0 ? -1 : 1;
    var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
        placement: placement
    })) : offset, skidding = _ref[0], distance = _ref[1];
    skidding = skidding || 0;
    distance = (distance || 0) * invertDistance;
    return [
        (0, $ead90bd709f19827$export$eabcd2c8791e7bf4),
        (0, $ead90bd709f19827$export$79ffe56a765070d2)
    ].indexOf(basePlacement) >= 0 ? {
        x: distance,
        y: skidding
    } : {
        x: skidding,
        y: distance
    };
}
function $4fc1165d37196198$var$offset(_ref2) {
    var state = _ref2.state, options = _ref2.options, name = _ref2.name;
    var _options$offset = options.offset, offset = _options$offset === void 0 ? [
        0,
        0
    ] : _options$offset;
    var data = (0, $ead90bd709f19827$export$803cd8101b6c182b).reduce(function(acc, placement) {
        acc[placement] = $4fc1165d37196198$export$7fa02d8595b015ed(placement, state.rects, offset);
        return acc;
    }, {});
    var _data$state$placement = data[state.placement], x = _data$state$placement.x, y = _data$state$placement.y;
    if (state.modifiersData.popperOffsets != null) {
        state.modifiersData.popperOffsets.x += x;
        state.modifiersData.popperOffsets.y += y;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $4fc1165d37196198$export$2e2bcd8739ae039 = {
    name: 'offset',
    enabled: true,
    phase: 'main',
    requires: [
        'popperOffsets'
    ],
    fn: $4fc1165d37196198$var$offset
};



function $b7ff5c84f2edefc6$var$popperOffsets(_ref) {
    var state = _ref.state, name = _ref.name;
    // Offsets are the actual position the popper needs to have to be
    // properly positioned near its reference element
    // This is the most basic placement, and will be adjusted by
    // the modifiers in the next step
    state.modifiersData[name] = (0, $8b882cf8c421e74c$export$2e2bcd8739ae039)({
        reference: state.rects.reference,
        element: state.rects.popper,
        strategy: 'absolute',
        placement: state.placement
    });
} // eslint-disable-next-line import/no-unused-modules
var $b7ff5c84f2edefc6$export$2e2bcd8739ae039 = {
    name: 'popperOffsets',
    enabled: true,
    phase: 'read',
    fn: $b7ff5c84f2edefc6$var$popperOffsets,
    data: {}
};





function $e16c71e9bc6bdd8c$export$2e2bcd8739ae039(axis) {
    return axis === 'x' ? 'y' : 'x';
}









function $5e97894f20755499$var$preventOverflow(_ref) {
    var state = _ref.state, options = _ref.options, name = _ref.name;
    var _options$mainAxis = options.mainAxis, checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis, _options$altAxis = options.altAxis, checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis, boundary = options.boundary, rootBoundary = options.rootBoundary, altBoundary = options.altBoundary, padding = options.padding, _options$tether = options.tether, tether = _options$tether === void 0 ? true : _options$tether, _options$tetherOffset = options.tetherOffset, tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
    var overflow = (0, $6391331b5cbe9ed8$export$2e2bcd8739ae039)(state, {
        boundary: boundary,
        rootBoundary: rootBoundary,
        padding: padding,
        altBoundary: altBoundary
    });
    var basePlacement = (0, $bd94a0f70e6a31e6$export$2e2bcd8739ae039)(state.placement);
    var variation = (0, $99fb66d89cf0379f$export$2e2bcd8739ae039)(state.placement);
    var isBasePlacement = !variation;
    var mainAxis = (0, $dae7c41c348cb858$export$2e2bcd8739ae039)(basePlacement);
    var altAxis = (0, $e16c71e9bc6bdd8c$export$2e2bcd8739ae039)(mainAxis);
    var popperOffsets = state.modifiersData.popperOffsets;
    var referenceRect = state.rects.reference;
    var popperRect = state.rects.popper;
    var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
        placement: state.placement
    })) : tetherOffset;
    var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
        mainAxis: tetherOffsetValue,
        altAxis: tetherOffsetValue
    } : Object.assign({
        mainAxis: 0,
        altAxis: 0
    }, tetherOffsetValue);
    var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
    var data = {
        x: 0,
        y: 0
    };
    if (!popperOffsets) return;
    if (checkMainAxis) {
        var _offsetModifierState$;
        var mainSide = mainAxis === 'y' ? (0, $ead90bd709f19827$export$1e95b668f3b82d) : (0, $ead90bd709f19827$export$eabcd2c8791e7bf4);
        var altSide = mainAxis === 'y' ? (0, $ead90bd709f19827$export$40e543e69a8b3fbb) : (0, $ead90bd709f19827$export$79ffe56a765070d2);
        var len = mainAxis === 'y' ? 'height' : 'width';
        var offset = popperOffsets[mainAxis];
        var min = offset + overflow[mainSide];
        var max = offset - overflow[altSide];
        var additive = tether ? -popperRect[len] / 2 : 0;
        var minLen = variation === (0, $ead90bd709f19827$export$b3571188c770cc5a) ? referenceRect[len] : popperRect[len];
        var maxLen = variation === (0, $ead90bd709f19827$export$b3571188c770cc5a) ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
        // outside the reference bounds
        var arrowElement = state.elements.arrow;
        var arrowRect = tether && arrowElement ? (0, $65a16b582a36e525$export$2e2bcd8739ae039)(arrowElement) : {
            width: 0,
            height: 0
        };
        var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : (0, $23c828330233fd37$export$2e2bcd8739ae039)();
        var arrowPaddingMin = arrowPaddingObject[mainSide];
        var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
        // to include its full size in the calculation. If the reference is small
        // and near the edge of a boundary, the popper can overflow even if the
        // reference is not overflowing as well (e.g. virtual elements with no
        // width or height)
        var arrowLen = (0, $ff192c62076041da$export$f28d906d67a997f3)(0, referenceRect[len], arrowRect[len]);
        var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
        var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
        var arrowOffsetParent = state.elements.arrow && (0, $c7938117c7e91aed$export$2e2bcd8739ae039)(state.elements.arrow);
        var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
        var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
        var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
        var tetherMax = offset + maxOffset - offsetModifierValue;
        var preventedOffset = (0, $ff192c62076041da$export$f28d906d67a997f3)(tether ? (0, $47158b2d5467c6d3$export$96ec731ed4dcb222)(min, tetherMin) : min, offset, tether ? (0, $47158b2d5467c6d3$export$8960430cfd85939f)(max, tetherMax) : max);
        popperOffsets[mainAxis] = preventedOffset;
        data[mainAxis] = preventedOffset - offset;
    }
    if (checkAltAxis) {
        var _offsetModifierState$2;
        var _mainSide = mainAxis === 'x' ? (0, $ead90bd709f19827$export$1e95b668f3b82d) : (0, $ead90bd709f19827$export$eabcd2c8791e7bf4);
        var _altSide = mainAxis === 'x' ? (0, $ead90bd709f19827$export$40e543e69a8b3fbb) : (0, $ead90bd709f19827$export$79ffe56a765070d2);
        var _offset = popperOffsets[altAxis];
        var _len = altAxis === 'y' ? 'height' : 'width';
        var _min = _offset + overflow[_mainSide];
        var _max = _offset - overflow[_altSide];
        var isOriginSide = [
            (0, $ead90bd709f19827$export$1e95b668f3b82d),
            (0, $ead90bd709f19827$export$eabcd2c8791e7bf4)
        ].indexOf(basePlacement) !== -1;
        var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;
        var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;
        var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;
        var _preventedOffset = tether && isOriginSide ? (0, $ff192c62076041da$export$86c8af6d3ef0b4a)(_tetherMin, _offset, _tetherMax) : (0, $ff192c62076041da$export$f28d906d67a997f3)(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);
        popperOffsets[altAxis] = _preventedOffset;
        data[altAxis] = _preventedOffset - _offset;
    }
    state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules
var $5e97894f20755499$export$2e2bcd8739ae039 = {
    name: 'preventOverflow',
    enabled: true,
    phase: 'main',
    fn: $5e97894f20755499$var$preventOverflow,
    requiresIfExists: [
        'offset'
    ]
};







function $c5b18026fbc620ad$export$2e2bcd8739ae039(element) {
    return {
        scrollLeft: element.scrollLeft,
        scrollTop: element.scrollTop
    };
}


function $ed0db9adee01a116$export$2e2bcd8739ae039(node) {
    if (node === (0, $6bc817df39510492$export$2e2bcd8739ae039)(node) || !(0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(node)) return (0, $db35d76dea677469$export$2e2bcd8739ae039)(node);
    else return (0, $c5b18026fbc620ad$export$2e2bcd8739ae039)(node);
}








function $655953b9ffbb055f$var$isElementScaled(element) {
    var rect = element.getBoundingClientRect();
    var scaleX = (0, $47158b2d5467c6d3$export$2077e0241d6afd3c)(rect.width) / element.offsetWidth || 1;
    var scaleY = (0, $47158b2d5467c6d3$export$2077e0241d6afd3c)(rect.height) / element.offsetHeight || 1;
    return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
function $655953b9ffbb055f$export$2e2bcd8739ae039(elementOrVirtualElement, offsetParent, isFixed) {
    if (isFixed === void 0) isFixed = false;
    var isOffsetParentAnElement = (0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(offsetParent);
    var offsetParentIsScaled = (0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(offsetParent) && $655953b9ffbb055f$var$isElementScaled(offsetParent);
    var documentElement = (0, $1c32741c776515eb$export$2e2bcd8739ae039)(offsetParent);
    var rect = (0, $e6f17403cd5beb47$export$2e2bcd8739ae039)(elementOrVirtualElement, offsetParentIsScaled, isFixed);
    var scroll = {
        scrollLeft: 0,
        scrollTop: 0
    };
    var offsets = {
        x: 0,
        y: 0
    };
    if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
        if ((0, $3b5901f208b24747$export$2e2bcd8739ae039)(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
        (0, $56611f99dbc37003$export$2e2bcd8739ae039)(documentElement)) scroll = (0, $ed0db9adee01a116$export$2e2bcd8739ae039)(offsetParent);
        if ((0, $8aa5d14d8a12c427$export$1b3bfaa9684536aa)(offsetParent)) {
            offsets = (0, $e6f17403cd5beb47$export$2e2bcd8739ae039)(offsetParent, true);
            offsets.x += offsetParent.clientLeft;
            offsets.y += offsetParent.clientTop;
        } else if (documentElement) offsets.x = (0, $511b873a9d328dd3$export$2e2bcd8739ae039)(documentElement);
    }
    return {
        x: rect.left + scroll.scrollLeft - offsets.x,
        y: rect.top + scroll.scrollTop - offsets.y,
        width: rect.width,
        height: rect.height
    };
}






function $e98b0c48a48cc698$var$order(modifiers) {
    var map = new Map();
    var visited = new Set();
    var result = [];
    modifiers.forEach(function(modifier) {
        map.set(modifier.name, modifier);
    }); // On visiting object, check for its dependencies and visit them recursively
    function sort(modifier) {
        visited.add(modifier.name);
        var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
        requires.forEach(function(dep) {
            if (!visited.has(dep)) {
                var depModifier = map.get(dep);
                if (depModifier) sort(depModifier);
            }
        });
        result.push(modifier);
    }
    modifiers.forEach(function(modifier) {
        if (!visited.has(modifier.name)) // check for visited object
        sort(modifier);
    });
    return result;
}
function $e98b0c48a48cc698$export$2e2bcd8739ae039(modifiers) {
    // order based on dependencies
    var orderedModifiers = $e98b0c48a48cc698$var$order(modifiers); // order based on phase
    return (0, $ead90bd709f19827$export$d087d3878fdf71d5).reduce(function(acc, phase) {
        return acc.concat(orderedModifiers.filter(function(modifier) {
            return modifier.phase === phase;
        }));
    }, []);
}


function $616d3bf42332f0c9$export$2e2bcd8739ae039(fn) {
    var pending;
    return function() {
        if (!pending) pending = new Promise(function(resolve) {
            Promise.resolve().then(function() {
                pending = undefined;
                resolve(fn());
            });
        });
        return pending;
    };
}


function $e0e631bb5a5b7b5f$export$2e2bcd8739ae039(modifiers) {
    var merged = modifiers.reduce(function(merged, current) {
        var existing = merged[current.name];
        merged[current.name] = existing ? Object.assign({}, existing, current, {
            options: Object.assign({}, existing.options, current.options),
            data: Object.assign({}, existing.data, current.data)
        }) : current;
        return merged;
    }, {}); // IE11 does not support Object.values
    return Object.keys(merged).map(function(key) {
        return merged[key];
    });
}




var $65e80a3feb7edced$var$DEFAULT_OPTIONS = {
    placement: 'bottom',
    modifiers: [],
    strategy: 'absolute'
};
function $65e80a3feb7edced$var$areValidElements() {
    for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
    return !args.some(function(element) {
        return !(element && typeof element.getBoundingClientRect === 'function');
    });
}
function $65e80a3feb7edced$export$ed5e13716264f202(generatorOptions) {
    if (generatorOptions === void 0) generatorOptions = {};
    var _generatorOptions = generatorOptions, _generatorOptions$def = _generatorOptions.defaultModifiers, defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def, _generatorOptions$def2 = _generatorOptions.defaultOptions, defaultOptions = _generatorOptions$def2 === void 0 ? $65e80a3feb7edced$var$DEFAULT_OPTIONS : _generatorOptions$def2;
    return function createPopper(reference, popper, options) {
        if (options === void 0) options = defaultOptions;
        var state = {
            placement: 'bottom',
            orderedModifiers: [],
            options: Object.assign({}, $65e80a3feb7edced$var$DEFAULT_OPTIONS, defaultOptions),
            modifiersData: {},
            elements: {
                reference: reference,
                popper: popper
            },
            attributes: {},
            styles: {}
        };
        var effectCleanupFns = [];
        var isDestroyed = false;
        var instance = {
            state: state,
            setOptions: function setOptions(setOptionsAction) {
                var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
                cleanupModifierEffects();
                state.options = Object.assign({}, defaultOptions, state.options, options);
                state.scrollParents = {
                    reference: (0, $8aa5d14d8a12c427$export$45a5e7f76e0caa8d)(reference) ? (0, $bd957012df8dcfc1$export$2e2bcd8739ae039)(reference) : reference.contextElement ? (0, $bd957012df8dcfc1$export$2e2bcd8739ae039)(reference.contextElement) : [],
                    popper: (0, $bd957012df8dcfc1$export$2e2bcd8739ae039)(popper)
                }; // Orders the modifiers based on their dependencies and `phase`
                // properties
                var orderedModifiers = (0, $e98b0c48a48cc698$export$2e2bcd8739ae039)((0, $e0e631bb5a5b7b5f$export$2e2bcd8739ae039)([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers
                state.orderedModifiers = orderedModifiers.filter(function(m) {
                    return m.enabled;
                });
                runModifierEffects();
                return instance.update();
            },
            // Sync update – it will always be executed, even if not necessary. This
            // is useful for low frequency updates where sync behavior simplifies the
            // logic.
            // For high frequency updates (e.g. `resize` and `scroll` events), always
            // prefer the async Popper#update method
            forceUpdate: function forceUpdate() {
                if (isDestroyed) return;
                var _state$elements = state.elements, reference = _state$elements.reference, popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
                // anymore
                if (!$65e80a3feb7edced$var$areValidElements(reference, popper)) return;
                 // Store the reference and popper rects to be read by modifiers
                state.rects = {
                    reference: (0, $655953b9ffbb055f$export$2e2bcd8739ae039)(reference, (0, $c7938117c7e91aed$export$2e2bcd8739ae039)(popper), state.options.strategy === 'fixed'),
                    popper: (0, $65a16b582a36e525$export$2e2bcd8739ae039)(popper)
                }; // Modifiers have the ability to reset the current update cycle. The
                // most common use case for this is the `flip` modifier changing the
                // placement, which then needs to re-run all the modifiers, because the
                // logic was previously ran for the previous placement and is therefore
                // stale/incorrect
                state.reset = false;
                state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
                // is filled with the initial data specified by the modifier. This means
                // it doesn't persist and is fresh on each update.
                // To ensure persistent data, use `${name}#persistent`
                state.orderedModifiers.forEach(function(modifier) {
                    return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
                });
                for(var index = 0; index < state.orderedModifiers.length; index++){
                    if (state.reset === true) {
                        state.reset = false;
                        index = -1;
                        continue;
                    }
                    var _state$orderedModifie = state.orderedModifiers[index], fn = _state$orderedModifie.fn, _state$orderedModifie2 = _state$orderedModifie.options, _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2, name = _state$orderedModifie.name;
                    if (typeof fn === 'function') state = fn({
                        state: state,
                        options: _options,
                        name: name,
                        instance: instance
                    }) || state;
                }
            },
            // Async and optimistically optimized update – it will not be executed if
            // not necessary (debounced to run at most once-per-tick)
            update: (0, $616d3bf42332f0c9$export$2e2bcd8739ae039)(function() {
                return new Promise(function(resolve) {
                    instance.forceUpdate();
                    resolve(state);
                });
            }),
            destroy: function destroy() {
                cleanupModifierEffects();
                isDestroyed = true;
            }
        };
        if (!$65e80a3feb7edced$var$areValidElements(reference, popper)) return instance;
        instance.setOptions(options).then(function(state) {
            if (!isDestroyed && options.onFirstUpdate) options.onFirstUpdate(state);
        }); // Modifiers have the ability to execute arbitrary code before the first
        // update cycle runs. They will be executed in the same order as the update
        // cycle. This is useful when a modifier adds some persistent data that
        // other modifiers need to use, but the modifier is run after the dependent
        // one.
        function runModifierEffects() {
            state.orderedModifiers.forEach(function(_ref) {
                var name = _ref.name, _ref$options = _ref.options, options = _ref$options === void 0 ? {} : _ref$options, effect = _ref.effect;
                if (typeof effect === 'function') {
                    var cleanupFn = effect({
                        state: state,
                        name: name,
                        instance: instance,
                        options: options
                    });
                    var noopFn = function noopFn() {};
                    effectCleanupFns.push(cleanupFn || noopFn);
                }
            });
        }
        function cleanupModifierEffects() {
            effectCleanupFns.forEach(function(fn) {
                return fn();
            });
            effectCleanupFns = [];
        }
        return instance;
    };
}
var $65e80a3feb7edced$export$8f7491d57c8f97a9 = /*#__PURE__*/ $65e80a3feb7edced$export$ed5e13716264f202(); // eslint-disable-next-line import/no-unused-modules


const $169ad63f874a6d13$export$8f7491d57c8f97a9 = (0, $65e80a3feb7edced$export$ed5e13716264f202)({
    defaultModifiers: [
        (0, $58f3589dbc489f3a$export$2e2bcd8739ae039),
        (0, $b7ff5c84f2edefc6$export$2e2bcd8739ae039),
        (0, $78c9dca98a97c656$export$2e2bcd8739ae039),
        (0, $650b69635114afcc$export$2e2bcd8739ae039),
        (0, $4fc1165d37196198$export$2e2bcd8739ae039),
        (0, $98db3bf16e58ef49$export$2e2bcd8739ae039),
        (0, $5e97894f20755499$export$2e2bcd8739ae039),
        (0, $45ac9c7232f5e779$export$2e2bcd8739ae039)
    ]
});


const $08679a5baa924333$var$_excluded = [
    "enabled",
    "placement",
    "strategy",
    "modifiers"
];
function $08679a5baa924333$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $08679a5baa924333$var$disabledApplyStylesModifier = {
    name: 'applyStyles',
    enabled: false,
    phase: 'afterWrite',
    fn: ()=>undefined
};
// until docjs supports type exports...
const $08679a5baa924333$var$ariaDescribedByModifier = {
    name: 'ariaDescribedBy',
    enabled: true,
    phase: 'afterWrite',
    effect: ({ state: state })=>()=>{
            const { reference: reference, popper: popper } = state.elements;
            if ('removeAttribute' in reference) {
                const ids = (reference.getAttribute('aria-describedby') || '').split(',').filter((id)=>id.trim() !== popper.id);
                if (!ids.length) reference.removeAttribute('aria-describedby');
                else reference.setAttribute('aria-describedby', ids.join(','));
            }
        },
    fn: ({ state: state })=>{
        var _popper$getAttribute;
        const { popper: popper, reference: reference } = state.elements;
        const role = (_popper$getAttribute = popper.getAttribute('role')) == null ? void 0 : _popper$getAttribute.toLowerCase();
        if (popper.id && role === 'tooltip' && 'setAttribute' in reference) {
            const ids = reference.getAttribute('aria-describedby');
            if (ids && ids.split(',').indexOf(popper.id) !== -1) return;
            reference.setAttribute('aria-describedby', ids ? `${ids},${popper.id}` : popper.id);
        }
    }
};
const $08679a5baa924333$var$EMPTY_MODIFIERS = [];
/**
 * Position an element relative some reference element using Popper.js
 *
 * @param referenceElement
 * @param popperElement
 * @param {object}      options
 * @param {object=}     options.modifiers Popper.js modifiers
 * @param {boolean=}    options.enabled toggle the popper functionality on/off
 * @param {string=}     options.placement The popper element placement relative to the reference element
 * @param {string=}     options.strategy the positioning strategy
 * @param {function=}   options.onCreate called when the popper is created
 * @param {function=}   options.onUpdate called when the popper is updated
 *
 * @returns {UsePopperState} The popper state
 */ function $08679a5baa924333$var$usePopper(referenceElement, popperElement, _ref = {}) {
    let { enabled: enabled = true, placement: placement = 'bottom', strategy: strategy = 'absolute', modifiers: modifiers = $08679a5baa924333$var$EMPTY_MODIFIERS } = _ref, config = $08679a5baa924333$var$_objectWithoutPropertiesLoose(_ref, $08679a5baa924333$var$_excluded);
    const prevModifiers = (0, $aZSru.useRef)(modifiers);
    const popperInstanceRef = (0, $aZSru.useRef)();
    const update = (0, $aZSru.useCallback)(()=>{
        var _popperInstanceRef$cu;
        (_popperInstanceRef$cu = popperInstanceRef.current) == null || _popperInstanceRef$cu.update();
    }, []);
    const forceUpdate = (0, $aZSru.useCallback)(()=>{
        var _popperInstanceRef$cu2;
        (_popperInstanceRef$cu2 = popperInstanceRef.current) == null || _popperInstanceRef$cu2.forceUpdate();
    }, []);
    const [popperState, setState] = (0, $d176a434764c319a$export$2e2bcd8739ae039)((0, $aZSru.useState)({
        placement: placement,
        update: update,
        forceUpdate: forceUpdate,
        attributes: {},
        styles: {
            popper: {},
            arrow: {}
        }
    }));
    const updateModifier = (0, $aZSru.useMemo)(()=>({
            name: 'updateStateModifier',
            enabled: true,
            phase: 'write',
            requires: [
                'computeStyles'
            ],
            fn: ({ state: state })=>{
                const styles = {};
                const attributes = {};
                Object.keys(state.elements).forEach((element)=>{
                    styles[element] = state.styles[element];
                    attributes[element] = state.attributes[element];
                });
                setState({
                    state: state,
                    styles: styles,
                    attributes: attributes,
                    update: update,
                    forceUpdate: forceUpdate,
                    placement: state.placement
                });
            }
        }), [
        update,
        forceUpdate,
        setState
    ]);
    const nextModifiers = (0, $aZSru.useMemo)(()=>{
        if (!(0, $a63e4f0e7738f452$export$de8294bb3be0322f)(prevModifiers.current, modifiers)) prevModifiers.current = modifiers;
        return prevModifiers.current;
    }, [
        modifiers
    ]);
    (0, $aZSru.useEffect)(()=>{
        if (!popperInstanceRef.current || !enabled) return;
        popperInstanceRef.current.setOptions({
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                updateModifier,
                $08679a5baa924333$var$disabledApplyStylesModifier
            ]
        });
    }, [
        strategy,
        placement,
        updateModifier,
        enabled,
        nextModifiers
    ]);
    (0, $aZSru.useEffect)(()=>{
        if (!enabled || referenceElement == null || popperElement == null) return undefined;
        popperInstanceRef.current = (0, $169ad63f874a6d13$export$8f7491d57c8f97a9)(referenceElement, popperElement, Object.assign({}, config, {
            placement: placement,
            strategy: strategy,
            modifiers: [
                ...nextModifiers,
                $08679a5baa924333$var$ariaDescribedByModifier,
                updateModifier
            ]
        }));
        return ()=>{
            if (popperInstanceRef.current != null) {
                popperInstanceRef.current.destroy();
                popperInstanceRef.current = undefined;
                setState((s)=>Object.assign({}, s, {
                        attributes: {},
                        styles: {
                            popper: {}
                        }
                    }));
            }
        };
    // This is only run once to _create_ the popper
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        enabled,
        referenceElement,
        popperElement
    ]);
    return popperState;
}
var $08679a5baa924333$export$2e2bcd8739ae039 = $08679a5baa924333$var$usePopper;






var $aZSru = parcelRequire("aZSru");


const $8f487b0e3d0e1b9f$var$noop = ()=>{};
function $8f487b0e3d0e1b9f$var$isLeftClickEvent(event) {
    return event.button === 0;
}
function $8f487b0e3d0e1b9f$var$isModifiedEvent(event) {
    return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
}
const $8f487b0e3d0e1b9f$export$347601c75fcd4732 = (ref)=>ref && ('current' in ref ? ref.current : ref);
const $8f487b0e3d0e1b9f$var$InitialTriggerEvents = {
    click: 'mousedown',
    mouseup: 'mousedown',
    pointerup: 'pointerdown'
};
/**
 * The `useClickOutside` hook registers your callback on the document that fires
 * when a pointer event is registered outside of the provided ref or element.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onClickOutside
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $8f487b0e3d0e1b9f$var$useClickOutside(ref, onClickOutside = $8f487b0e3d0e1b9f$var$noop, { disabled: disabled, clickTrigger: clickTrigger = 'click' } = {}) {
    const preventMouseClickOutsideRef = (0, $aZSru.useRef)(false);
    const waitingForTrigger = (0, $aZSru.useRef)(false);
    const handleMouseCapture = (0, $aZSru.useCallback)((e)=>{
        const currentTarget = $8f487b0e3d0e1b9f$export$347601c75fcd4732(ref);
        (0, (/*@__PURE__*/$parcel$interopDefault($e9c991cfa2287529$exports)))(!!currentTarget, "ClickOutside captured a close event but does not have a ref to compare it to. useClickOutside(), should be passed a ref that resolves to a DOM node");
        preventMouseClickOutsideRef.current = !currentTarget || $8f487b0e3d0e1b9f$var$isModifiedEvent(e) || !$8f487b0e3d0e1b9f$var$isLeftClickEvent(e) || !!(0, $5f0a0ff0971fd3a0$export$2e2bcd8739ae039)(currentTarget, e.target) || waitingForTrigger.current;
        waitingForTrigger.current = false;
    }, [
        ref
    ]);
    const handleInitialMouse = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        const currentTarget = $8f487b0e3d0e1b9f$export$347601c75fcd4732(ref);
        if (currentTarget && (0, $5f0a0ff0971fd3a0$export$2e2bcd8739ae039)(currentTarget, e.target)) waitingForTrigger.current = true;
        else // When clicking on scrollbars within current target, click events are not triggered, so this ref
        // is never reset inside `handleMouseCapture`. This would cause a bug where it requires 2 clicks
        // to close the overlay.
        waitingForTrigger.current = false;
    });
    const handleMouse = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        if (!preventMouseClickOutsideRef.current) onClickOutside(e);
    });
    (0, $aZSru.useEffect)(()=>{
        var _ownerWindow$event, _ownerWindow$parent;
        if (disabled || ref == null) return undefined;
        const doc = (0, $0948e8b135437cc0$export$2e2bcd8739ae039)($8f487b0e3d0e1b9f$export$347601c75fcd4732(ref));
        const ownerWindow = doc.defaultView || window;
        // Store the current event to avoid triggering handlers immediately
        // For things rendered in an iframe, the event might originate on the parent window
        // so we should fall back to that global event if the local one doesn't exist
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (_ownerWindow$event = ownerWindow.event) != null ? _ownerWindow$event : (_ownerWindow$parent = ownerWindow.parent) == null ? void 0 : _ownerWindow$parent.event;
        let removeInitialTriggerListener = null;
        if ($8f487b0e3d0e1b9f$var$InitialTriggerEvents[clickTrigger]) removeInitialTriggerListener = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(doc, $8f487b0e3d0e1b9f$var$InitialTriggerEvents[clickTrigger], handleInitialMouse, true);
        // Use capture for this listener so it fires before React's listener, to
        // avoid false positives in the contains() check below if the target DOM
        // element is removed in the React mouse callback.
        const removeMouseCaptureListener = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(doc, clickTrigger, handleMouseCapture, true);
        const removeMouseListener = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(doc, clickTrigger, (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleMouse(e);
        });
        let mobileSafariHackListeners = [];
        if ('ontouchstart' in doc.documentElement) mobileSafariHackListeners = [].slice.call(doc.body.children).map((el)=>(0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(el, 'mousemove', $8f487b0e3d0e1b9f$var$noop));
        return ()=>{
            removeInitialTriggerListener == null || removeInitialTriggerListener();
            removeMouseCaptureListener();
            removeMouseListener();
            mobileSafariHackListeners.forEach((remove)=>remove());
        };
    }, [
        ref,
        disabled,
        clickTrigger,
        handleMouseCapture,
        handleInitialMouse,
        handleMouse
    ]);
}
var $8f487b0e3d0e1b9f$export$2e2bcd8739ae039 = $8f487b0e3d0e1b9f$var$useClickOutside;


function $731996e3e45e1d4f$export$ba6dad097c8f5c38(modifiers) {
    const result = {};
    if (!Array.isArray(modifiers)) return modifiers || result;
    // eslint-disable-next-line no-unused-expressions
    modifiers == null || modifiers.forEach((m)=>{
        result[m.name] = m;
    });
    return result;
}
function $731996e3e45e1d4f$export$af3a999d4a134c86(map = {}) {
    if (Array.isArray(map)) return map;
    return Object.keys(map).map((k)=>{
        map[k].name = k;
        return map[k];
    });
}
function $731996e3e45e1d4f$export$2e2bcd8739ae039({ enabled: enabled, enableEvents: enableEvents, placement: placement, flip: flip, offset: offset, fixed: fixed, containerPadding: containerPadding, arrowElement: arrowElement, popperConfig: popperConfig = {} }) {
    var _modifiers$eventListe, _modifiers$preventOve, _modifiers$preventOve2, _modifiers$offset, _modifiers$arrow;
    const modifiers = $731996e3e45e1d4f$export$ba6dad097c8f5c38(popperConfig.modifiers);
    return Object.assign({}, popperConfig, {
        placement: placement,
        enabled: enabled,
        strategy: fixed ? 'fixed' : popperConfig.strategy,
        modifiers: $731996e3e45e1d4f$export$af3a999d4a134c86(Object.assign({}, modifiers, {
            eventListeners: {
                enabled: enableEvents,
                options: (_modifiers$eventListe = modifiers.eventListeners) == null ? void 0 : _modifiers$eventListe.options
            },
            preventOverflow: Object.assign({}, modifiers.preventOverflow, {
                options: containerPadding ? Object.assign({
                    padding: containerPadding
                }, (_modifiers$preventOve = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve.options) : (_modifiers$preventOve2 = modifiers.preventOverflow) == null ? void 0 : _modifiers$preventOve2.options
            }),
            offset: {
                options: Object.assign({
                    offset: offset
                }, (_modifiers$offset = modifiers.offset) == null ? void 0 : _modifiers$offset.options)
            },
            arrow: Object.assign({}, modifiers.arrow, {
                enabled: !!arrowElement,
                options: Object.assign({}, (_modifiers$arrow = modifiers.arrow) == null ? void 0 : _modifiers$arrow.options, {
                    element: arrowElement
                })
            }),
            flip: Object.assign({
                enabled: !!flip
            }, modifiers.flip)
        }))
    });
}



const $f441b42c39d58baf$var$_excluded = [
    "children",
    "usePopper"
];
function $f441b42c39d58baf$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
const $f441b42c39d58baf$var$noop = ()=>{};
function $f441b42c39d58baf$export$133c4d08f3775d64(options = {}) {
    const context = (0, $aZSru.useContext)((0, $c1816855d30cb40e$export$2e2bcd8739ae039));
    const [arrowElement, attachArrowRef] = (0, $59a38f3069ca3009$export$2e2bcd8739ae039)();
    const hasShownRef = (0, $aZSru.useRef)(false);
    const { flip: flip, offset: offset, rootCloseEvent: rootCloseEvent, fixed: fixed = false, placement: placementOverride, popperConfig: popperConfig = {}, enableEventListeners: enableEventListeners = true, usePopper: shouldUsePopper = !!context } = options;
    const show = (context == null ? void 0 : context.show) == null ? !!options.show : context.show;
    if (show && !hasShownRef.current) hasShownRef.current = true;
    const handleClose = (e)=>{
        context == null || context.toggle(false, e);
    };
    const { placement: placement, setMenu: setMenu, menuElement: menuElement, toggleElement: toggleElement } = context || {};
    const popper = (0, $08679a5baa924333$export$2e2bcd8739ae039)(toggleElement, menuElement, (0, $731996e3e45e1d4f$export$2e2bcd8739ae039)({
        placement: placementOverride || placement || 'bottom-start',
        enabled: shouldUsePopper,
        enableEvents: enableEventListeners == null ? show : enableEventListeners,
        offset: offset,
        flip: flip,
        fixed: fixed,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    const menuProps = Object.assign({
        ref: setMenu || $f441b42c39d58baf$var$noop,
        'aria-labelledby': toggleElement == null ? void 0 : toggleElement.id
    }, popper.attributes.popper, {
        style: popper.styles.popper
    });
    const metadata = {
        show: show,
        placement: placement,
        hasShown: hasShownRef.current,
        toggle: context == null ? void 0 : context.toggle,
        popper: shouldUsePopper ? popper : null,
        arrowProps: shouldUsePopper ? Object.assign({
            ref: attachArrowRef
        }, popper.attributes.arrow, {
            style: popper.styles.arrow
        }) : {}
    };
    (0, $8f487b0e3d0e1b9f$export$2e2bcd8739ae039)(menuElement, handleClose, {
        clickTrigger: rootCloseEvent,
        disabled: !show
    });
    return [
        menuProps,
        metadata
    ];
}
/**
 * Also exported as `<Dropdown.Menu>` from `Dropdown`.
 *
 * @displayName DropdownMenu
 * @memberOf Dropdown
 */ function $f441b42c39d58baf$var$DropdownMenu(_ref) {
    let { children: children, usePopper: usePopperProp = true } = _ref, options = $f441b42c39d58baf$var$_objectWithoutPropertiesLoose(_ref, $f441b42c39d58baf$var$_excluded);
    const [props, meta] = $f441b42c39d58baf$export$133c4d08f3775d64(Object.assign({}, options, {
        usePopper: usePopperProp
    }));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
        children: children(props, meta)
    });
}
$f441b42c39d58baf$var$DropdownMenu.displayName = 'DropdownMenu';
var /** @component */ $f441b42c39d58baf$export$2e2bcd8739ae039 = $f441b42c39d58baf$var$DropdownMenu;



var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
/*
 * Copyright 2020 Adobe. All rights reserved.
 * This file is licensed to you under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License. You may obtain a copy
 * of the License at http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software distributed under
 * the License is distributed on an "AS IS" BASIS, WITHOUT WARRANTIES OR REPRESENTATIONS
 * OF ANY KIND, either express or implied. See the License for the specific language
 * governing permissions and limitations under the License.
 */ // We must avoid a circular dependency with @react-aria/utils, and this useLayoutEffect is
// guarded by a check that it only runs on the client side.
// eslint-disable-next-line rsp-rules/use-layout-effect-rule
// Default context value to use in case there is no SSRProvider. This is fine for
// client-only apps. In order to support multiple copies of React Aria potentially
// being on the page at once, the prefix is set to a random number. SSRProvider
// will reset this to zero for consistency between server and client, so in the
// SSR case multiple copies of React Aria is not supported.
const $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$defaultContext = {
    prefix: String(Math.round(Math.random() * 10000000000)),
    current: 0
};
const $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$SSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createContext($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$defaultContext);
const $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$IsSSRContext = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createContext(false);
// This is only used in React < 18.
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$LegacySSRProvider(props) {
    let cur = (0, $aZSru.useContext)($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$SSRContext);
    let counter = $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useCounter(cur === $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$defaultContext);
    let [isSSR, setIsSSR] = (0, $aZSru.useState)(true);
    let value = (0, $aZSru.useMemo)(()=>({
            // If this is the first SSRProvider, start with an empty string prefix, otherwise
            // append and increment the counter.
            prefix: cur === $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$defaultContext ? '' : `${cur.prefix}-${counter}`,
            current: 0
        }), [
        cur,
        counter
    ]);
    // If on the client, and the component was initially server rendered,
    // then schedule a layout effect to update the component after hydration.
    if (typeof document !== 'undefined') (0, $aZSru.useLayoutEffect)(()=>{
        // oxlint-disable-next-line react/react-compiler
        setIsSSR(false);
    }, []);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$SSRContext.Provider, {
        value: value
    }, (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$IsSSRContext.Provider, {
        value: isSSR
    }, props.children));
}
let $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$warnedAboutSSRProvider = false;
function $d50c9c24d43a5975$export$9f8ac96af4b1b2ae(props) {
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($aZSru)))['useId'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).Fragment, null, props.children);
    return (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$LegacySSRProvider, props);
}
let $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$canUseDOM = Boolean(typeof window !== 'undefined' && window.document && window.document.createElement);
let $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$componentIds = new WeakMap();
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useCounter(isDisabled = false) {
    let ctx = (0, $aZSru.useContext)($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$SSRContext);
    let ref = (0, $aZSru.useRef)(null);
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    if (ref.current === null && !isDisabled) {
        // In strict mode, React renders components twice, and the ref will be reset to null on the second render.
        // This means our id counter will be incremented twice instead of once. This is a problem because on the
        // server, components are only rendered once and so ids generated on the server won't match the client.
        // In React 18, useId was introduced to solve this, but it is not available in older versions. So to solve this
        // we need to use some React internals to access the underlying Fiber instance, which is stable between renders.
        // This is exposed as ReactCurrentOwner in development, which is all we need since StrictMode only runs in development.
        // To ensure that we only increment the global counter once, we store the starting id for this component in
        // a weak map associated with the Fiber. On the second render, we reset the global counter to this value.
        // Since React runs the second render immediately after the first, this is safe.
        let currentOwner = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED?.ReactCurrentOwner?.current;
        if (currentOwner) {
            let prevComponentValue = $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$componentIds.get(currentOwner);
            if (prevComponentValue == null) $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$componentIds.set(currentOwner, {
                id: ctx.current,
                state: currentOwner.memoizedState
            });
            else if (currentOwner.memoizedState !== prevComponentValue.state) {
                // On the second render, the memoizedState gets reset by React.
                // Reset the counter, and remove from the weak map so we don't
                // do this for subsequent useId calls.
                // oxlint-disable-next-line react/react-compiler
                ctx.current = prevComponentValue.id;
                $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$componentIds.delete(currentOwner);
            }
        }
        // eslint-disable-next-line rsp-rules/pure-render
        // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
        ref.current = ++ctx.current;
    }
    // eslint-disable-next-line rsp-rules/pure-render
    // oxlint-disable-next-line react/react-compiler, rsp-rules/pure-render
    return ref.current;
}
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId(defaultId) {
    let ctx = (0, $aZSru.useContext)($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$SSRContext);
    // If we are rendering in a non-DOM environment, and there's no SSRProvider,
    // provide a warning to hint to the developer to add one.
    ctx === $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$defaultContext && $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$canUseDOM;
    let counter = $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useCounter(!!defaultId);
    let prefix = `react-aria${ctx.prefix}`;
    return defaultId || `${prefix}-${counter}`;
}
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId(defaultId) {
    let id = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).useId();
    let [didSSR] = (0, $aZSru.useState)($d50c9c24d43a5975$export$535bd6ca7f90a273());
    let prefix = didSSR || false ? 'react-aria' : `react-aria${$d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$defaultContext.prefix}`;
    return defaultId || `${prefix}-${id}`;
}
const $d50c9c24d43a5975$export$619500959fc48b26 = typeof (0, (/*@__PURE__*/$parcel$interopDefault($aZSru)))['useId'] === 'function' ? $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useModernSSRSafeId : $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$useLegacySSRSafeId;
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$getSnapshot() {
    return false;
}
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$getServerSnapshot() {
    return true;
}
// eslint-disable-next-line @typescript-eslint/no-unused-vars
function $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$subscribe(onStoreChange) {
    // noop
    return ()=>{};
}
function $d50c9c24d43a5975$export$535bd6ca7f90a273() {
    // In React 18, we can use useSyncExternalStore to detect if we're server rendering or hydrating.
    // oxlint-disable-next-line react/react-compiler
    if (typeof (0, (/*@__PURE__*/$parcel$interopDefault($aZSru)))['useSyncExternalStore'] === 'function') return (0, (/*@__PURE__*/$parcel$interopDefault($aZSru)))['useSyncExternalStore']($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$subscribe, $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$getSnapshot, $d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$getServerSnapshot);
    // oxlint-disable-next-line react/react-compiler, react-hooks/rules-of-hooks
    return (0, $aZSru.useContext)($d50c9c24d43a5975$var$$c7eafbbe1ea5834e$var$IsSSRContext);
}




const $406d143db1e101d9$export$386b1213cf9779d8 = (el)=>{
    var _el$getAttribute;
    return ((_el$getAttribute = el.getAttribute('role')) == null ? void 0 : _el$getAttribute.toLowerCase()) === 'menu';
};
const $406d143db1e101d9$var$noop = ()=>{};
function $406d143db1e101d9$export$96df6c7c5036b9a2() {
    const id = (0, $d50c9c24d43a5975$export$619500959fc48b26)();
    const { show: show = false, toggle: toggle = $406d143db1e101d9$var$noop, setToggle: setToggle, menuElement: menuElement } = (0, $aZSru.useContext)((0, $c1816855d30cb40e$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $aZSru.useCallback)((e)=>{
        toggle(!show, e);
    }, [
        show,
        toggle
    ]);
    const props = {
        id: id,
        ref: setToggle || $406d143db1e101d9$var$noop,
        onClick: handleClick,
        'aria-expanded': !!show
    };
    // This is maybe better down in an effect, but
    // the component is going to update anyway when the menu element
    // is set so might return new props.
    if (menuElement && $406d143db1e101d9$export$386b1213cf9779d8(menuElement)) props['aria-haspopup'] = true;
    return [
        props,
        {
            show: show,
            toggle: toggle
        }
    ];
}
/**
 * Also exported as `<Dropdown.Toggle>` from `Dropdown`.
 *
 * @displayName DropdownToggle
 * @memberOf Dropdown
 */ function $406d143db1e101d9$var$DropdownToggle({ children: children }) {
    const [props, meta] = $406d143db1e101d9$export$96df6c7c5036b9a2();
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
        children: children(props, meta)
    });
}
$406d143db1e101d9$var$DropdownToggle.displayName = 'DropdownToggle';
var /** @component */ $406d143db1e101d9$export$2e2bcd8739ae039 = $406d143db1e101d9$var$DropdownToggle;



var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");
const $21bccd3f5a98e26e$var$SelectableContext = /*#__PURE__*/ $aZSru.createContext(null);
const $21bccd3f5a98e26e$export$eef49b42fde998a3 = (eventKey, href = null)=>{
    if (eventKey != null) return String(eventKey);
    return href || null;
};
var $21bccd3f5a98e26e$export$2e2bcd8739ae039 = $21bccd3f5a98e26e$var$SelectableContext;



var $aZSru = parcelRequire("aZSru");
const $53d23b4caba62fc1$var$NavContext = /*#__PURE__*/ $aZSru.createContext(null);
$53d23b4caba62fc1$var$NavContext.displayName = 'NavContext';
var $53d23b4caba62fc1$export$2e2bcd8739ae039 = $53d23b4caba62fc1$var$NavContext;





const $a64b1dc71c3927af$var$_excluded = [
    "eventKey",
    "disabled",
    "onClick",
    "active",
    "as"
];
function $a64b1dc71c3927af$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $a64b1dc71c3927af$export$522d7e1e4e0e22b2({ key: key, href: href, active: active, disabled: disabled, onClick: onClick }) {
    const onSelectCtx = (0, $aZSru.useContext)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039));
    const navContext = (0, $aZSru.useContext)((0, $53d23b4caba62fc1$export$2e2bcd8739ae039));
    const { activeKey: activeKey } = navContext || {};
    const eventKey = (0, $21bccd3f5a98e26e$export$eef49b42fde998a3)(key, href);
    const isActive = active == null && key != null ? (0, $21bccd3f5a98e26e$export$eef49b42fde998a3)(activeKey) === eventKey : active;
    const handleClick = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((event)=>{
        if (disabled) return;
        onClick == null || onClick(event);
        if (onSelectCtx && !event.isPropagationStopped()) onSelectCtx(eventKey, event);
    });
    return [
        {
            onClick: handleClick,
            'aria-disabled': disabled || undefined,
            'aria-selected': isActive,
            [(0, $fb1d98baa2553a7e$export$5cc3b7b83e34ade7)('dropdown-item')]: ''
        },
        {
            isActive: isActive
        }
    ];
}
const $a64b1dc71c3927af$var$DropdownItem = /*#__PURE__*/ $aZSru.forwardRef((_ref, ref)=>{
    let { eventKey: eventKey, disabled: disabled, onClick: onClick, active: active, as: Component = (0, $3afdd3e5f726b03e$export$2e2bcd8739ae039) } = _ref, props = $a64b1dc71c3927af$var$_objectWithoutPropertiesLoose(_ref, $a64b1dc71c3927af$var$_excluded);
    const [dropdownItemProps] = $a64b1dc71c3927af$export$522d7e1e4e0e22b2({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, Object.assign({}, props, {
        ref: ref
    }, dropdownItemProps));
});
$a64b1dc71c3927af$var$DropdownItem.displayName = 'DropdownItem';
var $a64b1dc71c3927af$export$2e2bcd8739ae039 = $a64b1dc71c3927af$var$DropdownItem;






function $17c2518da83beece$var$useRefWithUpdate() {
    const forceUpdate = (0, $ba7ee7ef2b39e899$export$2e2bcd8739ae039)();
    const ref = (0, $aZSru.useRef)(null);
    const attachRef = (0, $aZSru.useCallback)((element)=>{
        ref.current = element;
        // ensure that a menu set triggers an update for consumers
        forceUpdate();
    }, [
        forceUpdate
    ]);
    return [
        ref,
        attachRef
    ];
}
/**
 * @displayName Dropdown
 * @public
 */ function $17c2518da83beece$var$Dropdown({ defaultShow: defaultShow, show: rawShow, onSelect: onSelect, onToggle: rawOnToggle, itemSelector: itemSelector = `* [${(0, $fb1d98baa2553a7e$export$5cc3b7b83e34ade7)('dropdown-item')}]`, focusFirstItemOnShow: focusFirstItemOnShow, placement: placement = 'bottom-start', children: children }) {
    const window = (0, $ec77d80a6d882524$export$2e2bcd8739ae039)();
    const [show, onToggle] = (0, $b26eb152ff7224ad$export$2ee51287a16ca325)(rawShow, defaultShow, rawOnToggle);
    // We use normal refs instead of useCallbackRef in order to populate the
    // the value as quickly as possible, otherwise the effect to focus the element
    // may run before the state value is set
    const [menuRef, setMenu] = $17c2518da83beece$var$useRefWithUpdate();
    const menuElement = menuRef.current;
    const [toggleRef, setToggle] = $17c2518da83beece$var$useRefWithUpdate();
    const toggleElement = toggleRef.current;
    const lastShow = (0, $5bbee511ad3f9d2a$export$2e2bcd8739ae039)(show);
    const lastSourceEvent = (0, $aZSru.useRef)(null);
    const focusInDropdown = (0, $aZSru.useRef)(false);
    const onSelectCtx = (0, $aZSru.useContext)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039));
    const toggle = (0, $aZSru.useCallback)((nextShow, event, source = event == null ? void 0 : event.type)=>{
        onToggle(nextShow, {
            originalEvent: event,
            source: source
        });
    }, [
        onToggle
    ]);
    const handleSelect = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((key, event)=>{
        onSelect == null || onSelect(key, event);
        toggle(false, event, 'select');
        if (!event.isPropagationStopped()) onSelectCtx == null || onSelectCtx(key, event);
    });
    const context = (0, $aZSru.useMemo)(()=>({
            toggle: toggle,
            placement: placement,
            show: show,
            menuElement: menuElement,
            toggleElement: toggleElement,
            setMenu: setMenu,
            setToggle: setToggle
        }), [
        toggle,
        placement,
        show,
        menuElement,
        toggleElement,
        setMenu,
        setToggle
    ]);
    if (menuElement && lastShow && !show) focusInDropdown.current = menuElement.contains(menuElement.ownerDocument.activeElement);
    const focusToggle = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(()=>{
        if (toggleElement && toggleElement.focus) toggleElement.focus();
    });
    const maybeFocusFirst = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)(()=>{
        const type = lastSourceEvent.current;
        let focusType = focusFirstItemOnShow;
        if (focusType == null) focusType = menuRef.current && (0, $406d143db1e101d9$export$386b1213cf9779d8)(menuRef.current) ? 'keyboard' : false;
        if (focusType === false || focusType === 'keyboard' && !/^key.+$/.test(type)) return;
        const first = (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(menuRef.current, itemSelector)[0];
        if (first && first.focus) first.focus();
    });
    (0, $aZSru.useEffect)(()=>{
        if (show) maybeFocusFirst();
        else if (focusInDropdown.current) {
            focusInDropdown.current = false;
            focusToggle();
        }
    // only `show` should be changing
    }, [
        show,
        focusInDropdown,
        focusToggle,
        maybeFocusFirst
    ]);
    (0, $aZSru.useEffect)(()=>{
        lastSourceEvent.current = null;
    });
    const getNextFocusedChild = (current, offset)=>{
        if (!menuRef.current) return null;
        const items = (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(menuRef.current, itemSelector);
        let index = items.indexOf(current) + offset;
        index = Math.max(0, Math.min(index, items.length));
        return items[index];
    };
    (0, $54456e04bbc1b0f1$export$2e2bcd8739ae039)((0, $aZSru.useCallback)(()=>window.document, [
        window
    ]), 'keydown', (event)=>{
        var _menuRef$current, _toggleRef$current;
        const { key: key } = event;
        const target = event.target;
        const fromMenu = (_menuRef$current = menuRef.current) == null ? void 0 : _menuRef$current.contains(target);
        const fromToggle = (_toggleRef$current = toggleRef.current) == null ? void 0 : _toggleRef$current.contains(target);
        // Second only to https://github.com/twbs/bootstrap/blob/8cfbf6933b8a0146ac3fbc369f19e520bd1ebdac/js/src/dropdown.js#L400
        // in inscrutability
        const isInput = /input|textarea/i.test(target.tagName);
        if (isInput && (key === ' ' || key !== 'Escape' && fromMenu || key === 'Escape' && target.type === 'search')) return;
        if (!fromMenu && !fromToggle) return;
        if (key === 'Tab' && (!menuRef.current || !show)) return;
        lastSourceEvent.current = event.type;
        const meta = {
            originalEvent: event,
            source: event.type
        };
        switch(key){
            case 'ArrowUp':
                {
                    const next = getNextFocusedChild(target, -1);
                    if (next && next.focus) next.focus();
                    event.preventDefault();
                    return;
                }
            case 'ArrowDown':
                event.preventDefault();
                if (!show) onToggle(true, meta);
                else {
                    const next = getNextFocusedChild(target, 1);
                    if (next && next.focus) next.focus();
                }
                return;
            case 'Tab':
                // on keydown the target is the element being tabbed FROM, we need that
                // to know if this event is relevant to this dropdown (e.g. in this menu).
                // On `keyup` the target is the element being tagged TO which we use to check
                // if focus has left the menu
                (0, $eeb6ca5e41ee8cd7$export$2e2bcd8739ae039)(target.ownerDocument, 'keyup', (e)=>{
                    var _menuRef$current2;
                    if (e.key === 'Tab' && !e.target || !((_menuRef$current2 = menuRef.current) != null && _menuRef$current2.contains(e.target))) onToggle(false, meta);
                }, {
                    once: true
                });
                break;
            case 'Escape':
                if (key === 'Escape') {
                    event.preventDefault();
                    event.stopPropagation();
                }
                onToggle(false, meta);
                break;
            default:
        }
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c1816855d30cb40e$export$2e2bcd8739ae039).Provider, {
            value: context,
            children: children
        })
    });
}
$17c2518da83beece$var$Dropdown.displayName = 'Dropdown';
$17c2518da83beece$var$Dropdown.Menu = (0, $f441b42c39d58baf$export$2e2bcd8739ae039);
$17c2518da83beece$var$Dropdown.Toggle = (0, $406d143db1e101d9$export$2e2bcd8739ae039);
$17c2518da83beece$var$Dropdown.Item = (0, $a64b1dc71c3927af$export$2e2bcd8739ae039);
var $17c2518da83beece$export$2e2bcd8739ae039 = $17c2518da83beece$var$Dropdown;





var $aZSru = parcelRequire("aZSru");
"use client";
const $075e5c7befaed1d9$var$DropdownContext = /*#__PURE__*/ $aZSru.createContext({});
$075e5c7befaed1d9$var$DropdownContext.displayName = 'DropdownContext';
var $075e5c7befaed1d9$export$2e2bcd8739ae039 = $075e5c7befaed1d9$var$DropdownContext;



var $aZSru = parcelRequire("aZSru");



"use client";
const $af5dd4e2cd7d7d9d$var$DropdownDivider = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'hr', role: role = 'separator', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-divider');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$af5dd4e2cd7d7d9d$var$DropdownDivider.displayName = 'DropdownDivider';
var $af5dd4e2cd7d7d9d$export$2e2bcd8739ae039 = $af5dd4e2cd7d7d9d$var$DropdownDivider;



var $aZSru = parcelRequire("aZSru");



"use client";
const $b863707769a5ea03$var$DropdownHeader = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', role: role = 'heading', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-header');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        role: role,
        ...props
    });
});
$b863707769a5ea03$var$DropdownHeader.displayName = 'DropdownHeader';
var $b863707769a5ea03$export$2e2bcd8739ae039 = $b863707769a5ea03$var$DropdownHeader;




var $aZSru = parcelRequire("aZSru");




"use client";
const $52948b2d5b2fbd2e$var$DropdownItem = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, eventKey: eventKey, disabled: disabled = false, onClick: onClick, active: active, as: Component = (0, $a0e9365cba08db2b$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item');
    const [dropdownItemProps, meta] = (0, $a64b1dc71c3927af$export$522d7e1e4e0e22b2)({
        key: eventKey,
        href: props.href,
        disabled: disabled,
        onClick: onClick,
        active: active
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ...dropdownItemProps,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, prefix, meta.isActive && 'active', disabled && 'disabled')
    });
});
$52948b2d5b2fbd2e$var$DropdownItem.displayName = 'DropdownItem';
var $52948b2d5b2fbd2e$export$2e2bcd8739ae039 = $52948b2d5b2fbd2e$var$DropdownItem;



var $aZSru = parcelRequire("aZSru");



"use client";
const $ef9bb38589343ef1$var$DropdownItemText = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-item-text');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$ef9bb38589343ef1$var$DropdownItemText.displayName = 'DropdownItemText';
var $ef9bb38589343ef1$export$2e2bcd8739ae039 = $ef9bb38589343ef1$var$DropdownItemText;




var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");
const $7321142bf89bdf31$var$isReactNative = typeof $parcel$global !== 'undefined' && // @ts-ignore
$parcel$global.navigator && // @ts-ignore
$parcel$global.navigator.product === 'ReactNative';
const $7321142bf89bdf31$var$isDOM = typeof document !== 'undefined';
var /**
 * Is `useLayoutEffect` in a DOM or React Native environment, otherwise resolves to useEffect
 * Only useful to avoid the console warning.
 *
 * PREFER `useEffect` UNLESS YOU KNOW WHAT YOU ARE DOING.
 *
 * @category effects
 */ $7321142bf89bdf31$export$2e2bcd8739ae039 = $7321142bf89bdf31$var$isDOM || $7321142bf89bdf31$var$isReactNative ? (0, $aZSru.useLayoutEffect) : (0, $aZSru.useEffect);






var $aZSru = parcelRequire("aZSru");
"use client";
const $4c2893ccbf593bec$var$context = /*#__PURE__*/ $aZSru.createContext(null);
$4c2893ccbf593bec$var$context.displayName = 'InputGroupContext';
var $4c2893ccbf593bec$export$2e2bcd8739ae039 = $4c2893ccbf593bec$var$context;



var $aZSru = parcelRequire("aZSru");
"use client";
// TODO: check
const $3e9abdf2100dccc0$var$context = /*#__PURE__*/ $aZSru.createContext(null);
$3e9abdf2100dccc0$var$context.displayName = 'NavbarContext';
var $3e9abdf2100dccc0$export$2e2bcd8739ae039 = $3e9abdf2100dccc0$var$context;




parcelRequire("aZSru");

function $da32f1faca507cdb$export$2e2bcd8739ae039(ref, componentName) {
    return ref;
}




"use client";
function $2e1f5fe54580e595$export$a2c648e264f4a946(alignEnd, dropDirection, isRTL) {
    const topStart = isRTL ? 'top-end' : 'top-start';
    const topEnd = isRTL ? 'top-start' : 'top-end';
    const bottomStart = isRTL ? 'bottom-end' : 'bottom-start';
    const bottomEnd = isRTL ? 'bottom-start' : 'bottom-end';
    const leftStart = isRTL ? 'right-start' : 'left-start';
    const leftEnd = isRTL ? 'right-end' : 'left-end';
    const rightStart = isRTL ? 'left-start' : 'right-start';
    const rightEnd = isRTL ? 'left-end' : 'right-end';
    let placement = alignEnd ? bottomEnd : bottomStart;
    if (dropDirection === 'up') placement = alignEnd ? topEnd : topStart;
    else if (dropDirection === 'end') placement = alignEnd ? rightEnd : rightStart;
    else if (dropDirection === 'start') placement = alignEnd ? leftEnd : leftStart;
    else if (dropDirection === 'down-centered') placement = 'bottom';
    else if (dropDirection === 'up-centered') placement = 'top';
    return placement;
}
const $2e1f5fe54580e595$var$DropdownMenu = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, align: align, rootCloseEvent: rootCloseEvent, flip: flip = true, show: showProps, renderOnMount: renderOnMount, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'div', popperConfig: popperConfig, variant: variant, ...props }, ref)=>{
    let alignEnd = false;
    const isNavbar = (0, $aZSru.useContext)((0, $3e9abdf2100dccc0$export$2e2bcd8739ae039));
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-menu');
    const { align: contextAlign, drop: drop, isRTL: isRTL } = (0, $aZSru.useContext)((0, $075e5c7befaed1d9$export$2e2bcd8739ae039));
    align = align || contextAlign;
    const isInputGroup = (0, $aZSru.useContext)((0, $4c2893ccbf593bec$export$2e2bcd8739ae039));
    const alignClasses = [];
    if (align) {
        if (typeof align === 'object') {
            const keys = Object.keys(align);
            if (keys.length) {
                const brkPoint = keys[0];
                const direction = align[brkPoint];
                // .dropdown-menu-end is required for responsively aligning
                // left in addition to align left classes.
                alignEnd = direction === 'start';
                alignClasses.push(`${prefix}-${brkPoint}-${direction}`);
            }
        } else if (align === 'end') alignEnd = true;
    }
    const placement = $2e1f5fe54580e595$export$a2c648e264f4a946(alignEnd, drop, isRTL);
    const [menuProps, { hasShown: hasShown, popper: popper, show: show, toggle: toggle }] = (0, $f441b42c39d58baf$export$133c4d08f3775d64)({
        flip: flip,
        rootCloseEvent: rootCloseEvent,
        show: showProps,
        usePopper: !isNavbar && alignClasses.length === 0,
        offset: [
            0,
            2
        ],
        popperConfig: popperConfig,
        placement: placement
    });
    menuProps.ref = (0, $dfc8aef1afa68cbb$export$2e2bcd8739ae039)((0, $da32f1faca507cdb$export$2e2bcd8739ae039)(ref, 'DropdownMenu'), menuProps.ref);
    (0, $7321142bf89bdf31$export$2e2bcd8739ae039)(()=>{
        // Popper's initial position for the menu is incorrect when
        // renderOnMount=true. Need to call update() to correct it.
        if (show) popper == null || popper.update();
    }, [
        show
    ]);
    if (!hasShown && !renderOnMount && !isInputGroup) return null;
    // For custom components provide additional, non-DOM, props;
    if (typeof Component !== 'string') {
        menuProps.show = show;
        menuProps.close = ()=>toggle == null ? void 0 : toggle(false);
        menuProps.align = align;
    }
    let style = props.style;
    if (popper != null && popper.placement) {
        // we don't need the default popper style,
        // menus are display: none when not shown.
        style = {
            ...props.style,
            ...menuProps.style
        };
        props['x-placement'] = popper.placement;
    }
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ...menuProps,
        style: style,
        ...(alignClasses.length || isNavbar) && {
            'data-bs-popper': 'static'
        },
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, prefix, show && 'show', alignEnd && `${prefix}-end`, variant && `${prefix}-${variant}`, ...alignClasses)
    });
});
$2e1f5fe54580e595$var$DropdownMenu.displayName = 'DropdownMenu';
var $2e1f5fe54580e595$export$2e2bcd8739ae039 = $2e1f5fe54580e595$var$DropdownMenu;







var $aZSru = parcelRequire("aZSru");




"use client";
const $1b12a9b74ea53b13$var$DropdownToggle = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, split: split, className: className, childBsPrefix: childBsPrefix, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = (0, $125bc3f756529a6e$export$2e2bcd8739ae039), ...props }, ref)=>{
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown-toggle');
    const dropdownContext = (0, $aZSru.useContext)((0, $c1816855d30cb40e$export$2e2bcd8739ae039));
    if (childBsPrefix !== undefined) props.bsPrefix = childBsPrefix;
    const [toggleProps] = (0, $406d143db1e101d9$export$96df6c7c5036b9a2)();
    toggleProps.ref = (0, $dfc8aef1afa68cbb$export$2e2bcd8739ae039)(toggleProps.ref, (0, $da32f1faca507cdb$export$2e2bcd8739ae039)(ref, 'DropdownToggle'));
    // This intentionally forwards size and variant (if set) to the
    // underlying component, to allow it to render size and style variants.
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, prefix, split && `${prefix}-split`, (dropdownContext == null ? void 0 : dropdownContext.show) && 'show'),
        ...toggleProps,
        ...props
    });
});
$1b12a9b74ea53b13$var$DropdownToggle.displayName = 'DropdownToggle';
var $1b12a9b74ea53b13$export$2e2bcd8739ae039 = $1b12a9b74ea53b13$var$DropdownToggle;






"use client";
const $27f60f8b2b4ab939$var$Dropdown = /*#__PURE__*/ $aZSru.forwardRef((pProps, ref)=>{
    const { bsPrefix: bsPrefix, drop: drop = 'down', show: show, className: className, align: align = 'start', onSelect: onSelect, onToggle: onToggle, focusFirstItemOnShow: focusFirstItemOnShow, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', navbar: _4, autoClose: autoClose = true, ...props } = (0, $1df078ddfa34638e$export$2e2bcd8739ae039)(pProps, {
        show: 'onToggle'
    });
    const isInputGroup = (0, $aZSru.useContext)((0, $4c2893ccbf593bec$export$2e2bcd8739ae039));
    const prefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'dropdown');
    const isRTL = (0, $7c127cff4998859a$export$35e511eefa30ac5a)();
    const isClosingPermitted = (source)=>{
        // autoClose=false only permits close on button click
        if (autoClose === false) return source === 'click';
        // autoClose=inside doesn't permit close on rootClose
        if (autoClose === 'inside') return source !== 'rootClose';
        // autoClose=outside doesn't permit close on select
        if (autoClose === 'outside') return source !== 'select';
        return true;
    };
    const handleToggle = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)((nextShow, meta)=>{
        var _meta$originalEvent;
        /** Checking if target of event is ToggleButton,
     * if it is then nullify mousedown event
     */ const isToggleButton = (_meta$originalEvent = meta.originalEvent) == null || (_meta$originalEvent = _meta$originalEvent.target) == null ? void 0 : _meta$originalEvent.classList.contains('dropdown-toggle');
        if (isToggleButton && meta.source === 'mousedown') return;
        if (meta.originalEvent.currentTarget === document && (meta.source !== 'keydown' || meta.originalEvent.key === 'Escape')) meta.source = 'rootClose';
        if (isClosingPermitted(meta.source)) onToggle == null || onToggle(nextShow, meta);
    });
    const alignEnd = align === 'end';
    const placement = (0, $2e1f5fe54580e595$export$a2c648e264f4a946)(alignEnd, drop, isRTL);
    const contextValue = (0, $aZSru.useMemo)(()=>({
            align: align,
            drop: drop,
            isRTL: isRTL
        }), [
        align,
        drop,
        isRTL
    ]);
    const directionClasses = {
        down: prefix,
        'down-centered': `${prefix}-center`,
        up: 'dropup',
        'up-centered': 'dropup-center dropup',
        end: 'dropend',
        start: 'dropstart'
    };
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $075e5c7befaed1d9$export$2e2bcd8739ae039).Provider, {
        value: contextValue,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $17c2518da83beece$export$2e2bcd8739ae039), {
            placement: placement,
            show: show,
            onSelect: onSelect,
            onToggle: handleToggle,
            focusFirstItemOnShow: focusFirstItemOnShow,
            itemSelector: `.${prefix}-item:not(.disabled):not(:disabled)`,
            children: isInputGroup ? props.children : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
                ...props,
                ref: ref,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, show && 'show', directionClasses[drop])
            })
        })
    });
});
$27f60f8b2b4ab939$var$Dropdown.displayName = 'Dropdown';
var $27f60f8b2b4ab939$export$2e2bcd8739ae039 = Object.assign($27f60f8b2b4ab939$var$Dropdown, {
    Toggle: (0, $1b12a9b74ea53b13$export$2e2bcd8739ae039),
    Menu: (0, $2e1f5fe54580e595$export$2e2bcd8739ae039),
    Item: (0, $52948b2d5b2fbd2e$export$2e2bcd8739ae039),
    ItemText: (0, $ef9bb38589343ef1$export$2e2bcd8739ae039),
    Divider: (0, $af5dd4e2cd7d7d9d$export$2e2bcd8739ae039),
    Header: (0, $b863707769a5ea03$export$2e2bcd8739ae039)
});




var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");





var $aZSru = parcelRequire("aZSru");
const $aeb873a686abf977$var$TabContext = /*#__PURE__*/ $aZSru.createContext(null);
var $aeb873a686abf977$export$2e2bcd8739ae039 = $aeb873a686abf977$var$TabContext;




var $aZSru = parcelRequire("aZSru");







const $4989830148bfdcec$var$_excluded = [
    "as",
    "active",
    "eventKey"
];
function $4989830148bfdcec$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
function $4989830148bfdcec$export$d7a68693710982a({ key: key, onClick: onClick, active: active, id: id, role: role, disabled: disabled }) {
    const parentOnSelect = (0, $aZSru.useContext)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039));
    const navContext = (0, $aZSru.useContext)((0, $53d23b4caba62fc1$export$2e2bcd8739ae039));
    const tabContext = (0, $aZSru.useContext)((0, $aeb873a686abf977$export$2e2bcd8739ae039));
    let isActive = active;
    const props = {
        role: role
    };
    if (navContext) {
        if (!role && navContext.role === 'tablist') props.role = 'tab';
        const contextControllerId = navContext.getControllerId(key != null ? key : null);
        const contextControlledId = navContext.getControlledId(key != null ? key : null);
        // @ts-ignore
        props[(0, $fb1d98baa2553a7e$export$5cc3b7b83e34ade7)('event-key')] = key;
        props.id = contextControllerId || id;
        isActive = active == null && key != null ? navContext.activeKey === key : active;
        /**
     * Simplified scenario for `mountOnEnter`.
     *
     * While it would make sense to keep 'aria-controls' for tabs that have been mounted at least
     * once, it would also complicate the code quite a bit, for very little gain.
     * The following implementation is probably good enough.
     *
     * @see https://github.com/react-restart/ui/pull/40#issuecomment-1009971561
     */ if (isActive || !(tabContext != null && tabContext.unmountOnExit) && !(tabContext != null && tabContext.mountOnEnter)) props['aria-controls'] = contextControlledId;
    }
    if (props.role === 'tab') {
        props['aria-selected'] = isActive;
        if (!isActive) props.tabIndex = -1;
        if (disabled) {
            props.tabIndex = -1;
            props['aria-disabled'] = true;
        }
    }
    props.onClick = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        if (disabled) return;
        onClick == null || onClick(e);
        if (key == null) return;
        if (parentOnSelect && !e.isPropagationStopped()) parentOnSelect(key, e);
    });
    return [
        props,
        {
            isActive: isActive
        }
    ];
}
const $4989830148bfdcec$var$NavItem = /*#__PURE__*/ $aZSru.forwardRef((_ref, ref)=>{
    let { as: Component = (0, $3afdd3e5f726b03e$export$2e2bcd8739ae039), active: active, eventKey: eventKey } = _ref, options = $4989830148bfdcec$var$_objectWithoutPropertiesLoose(_ref, $4989830148bfdcec$var$_excluded);
    const [props, meta] = $4989830148bfdcec$export$d7a68693710982a(Object.assign({
        key: (0, $21bccd3f5a98e26e$export$eef49b42fde998a3)(eventKey, options.href),
        active: active
    }, options));
    // @ts-ignore
    props[(0, $fb1d98baa2553a7e$export$5cc3b7b83e34ade7)('active')] = meta.isActive;
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, Object.assign({}, options, props, {
        ref: ref
    }));
});
$4989830148bfdcec$var$NavItem.displayName = 'NavItem';
var $4989830148bfdcec$export$2e2bcd8739ae039 = $4989830148bfdcec$var$NavItem;



const $c31e2549579829fc$var$_excluded = [
    "as",
    "onSelect",
    "activeKey",
    "role",
    "onKeyDown"
];
function $c31e2549579829fc$var$_objectWithoutPropertiesLoose(r, e) {
    if (null == r) return {};
    var t = {};
    for(var n in r)if (({}).hasOwnProperty.call(r, n)) {
        if (e.indexOf(n) >= 0) continue;
        t[n] = r[n];
    }
    return t;
}
// eslint-disable-next-line @typescript-eslint/no-empty-function
const $c31e2549579829fc$var$noop = ()=>{};
const $c31e2549579829fc$var$EVENT_KEY_ATTR = (0, $fb1d98baa2553a7e$export$5cc3b7b83e34ade7)('event-key');
const $c31e2549579829fc$var$Nav = /*#__PURE__*/ $aZSru.forwardRef((_ref, ref)=>{
    let { // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'div', onSelect: onSelect, activeKey: activeKey, role: role, onKeyDown: onKeyDown } = _ref, props = $c31e2549579829fc$var$_objectWithoutPropertiesLoose(_ref, $c31e2549579829fc$var$_excluded);
    // A ref and forceUpdate for refocus, b/c we only want to trigger when needed
    // and don't want to reset the set in the effect
    const forceUpdate = (0, $ba7ee7ef2b39e899$export$2e2bcd8739ae039)();
    const needsRefocusRef = (0, $aZSru.useRef)(false);
    const parentOnSelect = (0, $aZSru.useContext)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039));
    const tabContext = (0, $aZSru.useContext)((0, $aeb873a686abf977$export$2e2bcd8739ae039));
    let getControlledId, getControllerId;
    if (tabContext) {
        role = role || 'tablist';
        activeKey = tabContext.activeKey;
        // TODO: do we need to duplicate these?
        getControlledId = tabContext.getControlledId;
        getControllerId = tabContext.getControllerId;
    }
    const listNode = (0, $aZSru.useRef)(null);
    const getNextActiveTab = (offset)=>{
        const currentListNode = listNode.current;
        if (!currentListNode) return null;
        const items = (0, $3345a36ae1e7dd7c$export$2e2bcd8739ae039)(currentListNode, `[${$c31e2549579829fc$var$EVENT_KEY_ATTR}]:not([aria-disabled=true])`);
        const activeChild = currentListNode.querySelector('[aria-selected=true]');
        if (!activeChild || activeChild !== document.activeElement) return null;
        const index = items.indexOf(activeChild);
        if (index === -1) return null;
        let nextIndex = index + offset;
        if (nextIndex >= items.length) nextIndex = 0;
        if (nextIndex < 0) nextIndex = items.length - 1;
        return items[nextIndex];
    };
    const handleSelect = (key, event)=>{
        if (key == null) return;
        onSelect == null || onSelect(key, event);
        parentOnSelect == null || parentOnSelect(key, event);
    };
    const handleKeyDown = (event)=>{
        onKeyDown == null || onKeyDown(event);
        if (!tabContext) return;
        let nextActiveChild;
        switch(event.key){
            case 'ArrowLeft':
            case 'ArrowUp':
                nextActiveChild = getNextActiveTab(-1);
                break;
            case 'ArrowRight':
            case 'ArrowDown':
                nextActiveChild = getNextActiveTab(1);
                break;
            default:
                return;
        }
        if (!nextActiveChild) return;
        event.preventDefault();
        handleSelect(nextActiveChild.dataset[(0, $fb1d98baa2553a7e$export$7776c0a7cd2eb3e0)('EventKey')] || null, event);
        needsRefocusRef.current = true;
        forceUpdate();
    };
    (0, $aZSru.useEffect)(()=>{
        if (listNode.current && needsRefocusRef.current) {
            const activeChild = listNode.current.querySelector(`[${$c31e2549579829fc$var$EVENT_KEY_ATTR}][aria-selected=true]`);
            activeChild == null || activeChild.focus();
        }
        needsRefocusRef.current = false;
    });
    const mergedRef = (0, $bb2998387863b2cb$export$2e2bcd8739ae039)(ref, listNode);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039).Provider, {
        value: handleSelect,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $53d23b4caba62fc1$export$2e2bcd8739ae039).Provider, {
            value: {
                role: role,
                // used by NavLink to determine it's role
                activeKey: (0, $21bccd3f5a98e26e$export$eef49b42fde998a3)(activeKey),
                getControlledId: getControlledId || $c31e2549579829fc$var$noop,
                getControllerId: getControllerId || $c31e2549579829fc$var$noop
            },
            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, Object.assign({}, props, {
                onKeyDown: handleKeyDown,
                ref: mergedRef,
                role: role
            }))
        })
    });
});
$c31e2549579829fc$var$Nav.displayName = 'Nav';
var $c31e2549579829fc$export$2e2bcd8739ae039 = Object.assign($c31e2549579829fc$var$Nav, {
    Item: (0, $4989830148bfdcec$export$2e2bcd8739ae039)
});





var $aZSru = parcelRequire("aZSru");
"use client";
const $b7b3f860cc420d4a$var$context = /*#__PURE__*/ $aZSru.createContext(null);
$b7b3f860cc420d4a$var$context.displayName = 'CardHeaderContext';
var $b7b3f860cc420d4a$export$2e2bcd8739ae039 = $b7b3f860cc420d4a$var$context;



var $aZSru = parcelRequire("aZSru");



"use client";
const $ba79ce76c745d372$var$NavItem = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'nav-item');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$ba79ce76c745d372$var$NavItem.displayName = 'NavItem';
var $ba79ce76c745d372$export$2e2bcd8739ae039 = $ba79ce76c745d372$var$NavItem;




var $aZSru = parcelRequire("aZSru");





"use client";
const $985545383a5dfe41$var$NavLink = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, as: Component = (0, $a0e9365cba08db2b$export$2e2bcd8739ae039), active: active, eventKey: eventKey, disabled: disabled = false, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'nav-link');
    const [navItemProps, meta] = (0, $4989830148bfdcec$export$d7a68693710982a)({
        key: (0, $21bccd3f5a98e26e$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        disabled: disabled,
        ...props
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ...navItemProps,
        ref: ref,
        disabled: disabled,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, disabled && 'disabled', meta.isActive && 'active')
    });
});
$985545383a5dfe41$var$NavLink.displayName = 'NavLink';
var $985545383a5dfe41$export$2e2bcd8739ae039 = $985545383a5dfe41$var$NavLink;



"use client";
const $ab22e28b9ae07ef3$var$Nav = /*#__PURE__*/ $aZSru.forwardRef((uncontrolledProps, ref)=>{
    const { as: as = 'div', bsPrefix: initialBsPrefix, variant: variant, fill: fill = false, justify: justify = false, navbar: navbar, navbarScroll: navbarScroll, className: className, activeKey: activeKey, ...props } = (0, $1df078ddfa34638e$export$2e2bcd8739ae039)(uncontrolledProps, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(initialBsPrefix, 'nav');
    let navbarBsPrefix;
    let cardHeaderBsPrefix;
    let isNavbar = false;
    const navbarContext = (0, $aZSru.useContext)((0, $3e9abdf2100dccc0$export$2e2bcd8739ae039));
    const cardHeaderContext = (0, $aZSru.useContext)((0, $b7b3f860cc420d4a$export$2e2bcd8739ae039));
    if (navbarContext) {
        navbarBsPrefix = navbarContext.bsPrefix;
        isNavbar = navbar == null ? true : navbar;
    } else if (cardHeaderContext) ({ cardHeaderBsPrefix: cardHeaderBsPrefix } = cardHeaderContext);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c31e2549579829fc$export$2e2bcd8739ae039), {
        as: as,
        ref: ref,
        activeKey: activeKey,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, {
            [bsPrefix]: !isNavbar,
            [`${navbarBsPrefix}-nav`]: isNavbar,
            [`${navbarBsPrefix}-nav-scroll`]: isNavbar && navbarScroll,
            [`${cardHeaderBsPrefix}-${variant}`]: !!cardHeaderBsPrefix,
            [`${bsPrefix}-${variant}`]: !!variant,
            [`${bsPrefix}-fill`]: fill,
            [`${bsPrefix}-justified`]: justify
        }),
        ...props
    });
});
$ab22e28b9ae07ef3$var$Nav.displayName = 'Nav';
var $ab22e28b9ae07ef3$export$2e2bcd8739ae039 = Object.assign($ab22e28b9ae07ef3$var$Nav, {
    Item: (0, $ba79ce76c745d372$export$2e2bcd8739ae039),
    Link: (0, $985545383a5dfe41$export$2e2bcd8739ae039)
});




var $aZSru = parcelRequire("aZSru");




var $aZSru = parcelRequire("aZSru");


"use client";
const $9c7a6dc0e57f7773$var$NavbarBrand = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, as: as, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'navbar-brand');
    const Component = as || (props.href ? 'a' : 'span');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix)
    });
});
$9c7a6dc0e57f7773$var$NavbarBrand.displayName = 'NavbarBrand';
var $9c7a6dc0e57f7773$export$2e2bcd8739ae039 = $9c7a6dc0e57f7773$var$NavbarBrand;



var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");



/**
 * Safe chained function
 *
 * Will only create a new function if needed,
 * otherwise will pass back existing functions or null.
 *
 * @param {function} functions to chain
 * @returns {function|null}
 */ function $65f39beb0031b745$var$createChainedFunction(...funcs) {
    return funcs.filter((f)=>f != null).reduce((acc, f)=>{
        if (typeof f !== 'function') throw new Error('Invalid Argument Type, must only provide functions, undefined, or null.');
        if (acc === null) return f;
        return function chainedFunction(...args) {
            // @ts-expect-error ignore "this" error
            acc.apply(this, args);
            // @ts-expect-error ignore "this" error
            f.apply(this, args);
        };
    }, null);
}
var $65f39beb0031b745$export$2e2bcd8739ae039 = $65f39beb0031b745$var$createChainedFunction;





const $3ff7b17e47e6885e$var$MARGINS = {
    height: [
        'marginTop',
        'marginBottom'
    ],
    width: [
        'marginLeft',
        'marginRight'
    ]
};
function $3ff7b17e47e6885e$var$getDefaultDimensionValue(dimension, elem) {
    const offset = `offset${dimension[0].toUpperCase()}${dimension.slice(1)}`;
    const value = elem[offset];
    const margins = $3ff7b17e47e6885e$var$MARGINS[dimension];
    return value + // @ts-expect-error TODO
    parseInt((0, $2b17b1a684deb938$export$2e2bcd8739ae039)(elem, margins[0]), 10) + // @ts-expect-error TODO
    parseInt((0, $2b17b1a684deb938$export$2e2bcd8739ae039)(elem, margins[1]), 10);
}
const $3ff7b17e47e6885e$var$collapseStyles = {
    [(0, $61e0c3d460fb69c2$export$84cbff306f539230)]: 'collapse',
    [(0, $61e0c3d460fb69c2$export$4aacc83d4d59139f)]: 'collapsing',
    [(0, $61e0c3d460fb69c2$export$df38205c966be359)]: 'collapsing',
    [(0, $61e0c3d460fb69c2$export$78e9e6e3e014d60a)]: 'collapse show'
};
const $3ff7b17e47e6885e$var$Collapse = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).forwardRef(({ onEnter: onEnter, onEntering: onEntering, onEntered: onEntered, onExit: onExit, onExiting: onExiting, className: className, children: children, dimension: dimension = 'height', in: inProp = false, timeout: timeout = 300, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, getDimensionValue: getDimensionValue = $3ff7b17e47e6885e$var$getDefaultDimensionValue, ...props }, ref)=>{
    /* Compute dimension */ const computedDimension = typeof dimension === 'function' ? dimension() : dimension;
    /* -- Expanding -- */ const handleEnter = (0, $aZSru.useMemo)(()=>(0, $65f39beb0031b745$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = '0';
        }, onEnter), [
        computedDimension,
        onEnter
    ]);
    const handleEntering = (0, $aZSru.useMemo)(()=>(0, $65f39beb0031b745$export$2e2bcd8739ae039)((elem)=>{
            const scroll = `scroll${computedDimension[0].toUpperCase()}${computedDimension.slice(1)}`;
            elem.style[computedDimension] = `${elem[scroll]}px`;
        }, onEntering), [
        computedDimension,
        onEntering
    ]);
    const handleEntered = (0, $aZSru.useMemo)(()=>(0, $65f39beb0031b745$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onEntered), [
        computedDimension,
        onEntered
    ]);
    /* -- Collapsing -- */ const handleExit = (0, $aZSru.useMemo)(()=>(0, $65f39beb0031b745$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = `${getDimensionValue(computedDimension, elem)}px`;
            (0, $b19f86f2ec605864$export$2e2bcd8739ae039)(elem);
        }, onExit), [
        onExit,
        getDimensionValue,
        computedDimension
    ]);
    const handleExiting = (0, $aZSru.useMemo)(()=>(0, $65f39beb0031b745$export$2e2bcd8739ae039)((elem)=>{
            elem.style[computedDimension] = null;
        }, onExiting), [
        computedDimension,
        onExiting
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $8968d694d76052a6$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $d91e207b7882051e$export$2e2bcd8739ae039),
        ...props,
        "aria-expanded": props.role ? inProp : null,
        onEnter: handleEnter,
        onEntering: handleEntering,
        onEntered: handleEntered,
        onExit: handleExit,
        onExiting: handleExiting,
        childRef: (0, $6de6cf4b5106e807$export$87943f2672146d57)(children),
        in: inProp,
        timeout: timeout,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        children: (state, innerProps)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, children.props.className, $3ff7b17e47e6885e$var$collapseStyles[state], computedDimension === 'width' && 'collapse-horizontal')
            })
    });
});
$3ff7b17e47e6885e$var$Collapse.displayName = 'Collapse';
var $3ff7b17e47e6885e$export$2e2bcd8739ae039 = $3ff7b17e47e6885e$var$Collapse;





"use client";
const $e04b2af0dbc50888$var$NavbarCollapse = /*#__PURE__*/ $aZSru.forwardRef(({ children: children, bsPrefix: bsPrefix, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'navbar-collapse');
    const context = (0, $aZSru.useContext)((0, $3e9abdf2100dccc0$export$2e2bcd8739ae039));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $3ff7b17e47e6885e$export$2e2bcd8739ae039), {
        in: !!(context && context.expanded),
        ...props,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            ref: ref,
            className: bsPrefix,
            children: children
        })
    });
});
$e04b2af0dbc50888$var$NavbarCollapse.displayName = 'NavbarCollapse';
var $e04b2af0dbc50888$export$2e2bcd8739ae039 = $e04b2af0dbc50888$var$NavbarCollapse;




var $aZSru = parcelRequire("aZSru");




"use client";
const $9e74e69329708e85$var$NavbarToggle = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, label: label = 'Toggle navigation', // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
as: Component = 'button', onClick: onClick, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'navbar-toggler');
    const { onToggle: onToggle, expanded: expanded } = (0, $aZSru.useContext)((0, $3e9abdf2100dccc0$export$2e2bcd8739ae039)) || {};
    const handleClick = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)((e)=>{
        if (onClick) onClick(e);
        if (onToggle) onToggle();
    });
    if (Component === 'button') props.type = 'button';
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ...props,
        ref: ref,
        onClick: handleClick,
        "aria-label": label,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, !expanded && 'collapsed'),
        children: children || /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("span", {
            className: `${bsPrefix}-icon`
        })
    });
});
$9e74e69329708e85$var$NavbarToggle.displayName = 'NavbarToggle';
var $9e74e69329708e85$export$2e2bcd8739ae039 = $9e74e69329708e85$var$NavbarToggle;



var $aZSru = parcelRequire("aZSru");




var $aZSru = parcelRequire("aZSru");
const $6364f0faa013d681$var$matchersByWindow = new WeakMap();
const $6364f0faa013d681$var$getMatcher = (query, targetWindow)=>{
    if (!query || !targetWindow) return undefined;
    const matchers = $6364f0faa013d681$var$matchersByWindow.get(targetWindow) || new Map();
    $6364f0faa013d681$var$matchersByWindow.set(targetWindow, matchers);
    let mql = matchers.get(query);
    if (!mql) {
        mql = targetWindow.matchMedia(query);
        mql.refCount = 0;
        matchers.set(mql.media, mql);
    }
    return mql;
};
function $6364f0faa013d681$export$2e2bcd8739ae039(query, targetWindow = typeof window === 'undefined' ? undefined : window) {
    const mql = $6364f0faa013d681$var$getMatcher(query, targetWindow);
    const [matches, setMatches] = (0, $aZSru.useState)(()=>mql ? mql.matches : false);
    (0, $7321142bf89bdf31$export$2e2bcd8739ae039)(()=>{
        let mql = $6364f0faa013d681$var$getMatcher(query, targetWindow);
        if (!mql) return setMatches(false);
        let matchers = $6364f0faa013d681$var$matchersByWindow.get(targetWindow);
        const handleChange = ()=>{
            setMatches(mql.matches);
        };
        mql.refCount++;
        mql.addListener(handleChange);
        handleChange();
        return ()=>{
            mql.removeListener(handleChange);
            mql.refCount--;
            if (mql.refCount <= 0) matchers == null || matchers.delete(mql.media);
            mql = undefined;
        };
    }, [
        query
    ]);
    return matches;
}



var $aZSru = parcelRequire("aZSru");
function $77701771fb553295$export$9c6950edc251641e(breakpointValues) {
    const names = Object.keys(breakpointValues);
    function and(query, next) {
        if (query === next) return next;
        return query ? `${query} and ${next}` : next;
    }
    function getNext(breakpoint) {
        return names[Math.min(names.indexOf(breakpoint) + 1, names.length - 1)];
    }
    function getMaxQuery(breakpoint) {
        const next = getNext(breakpoint);
        let value = breakpointValues[next];
        if (typeof value === 'number') value = `${value - 0.2}px`;
        else value = `calc(${value} - 0.2px)`;
        return `(max-width: ${value})`;
    }
    function getMinQuery(breakpoint) {
        let value = breakpointValues[breakpoint];
        if (typeof value === 'number') value = `${value}px`;
        return `(min-width: ${value})`;
    }
    /**
   * Match a set of breakpoints
   *
   * ```tsx
   * const MidSizeOnly = () => {
   *   const isMid = useBreakpoint({ lg: 'down', sm: 'up' });
   *
   *   if (isMid) return <div>On a Reasonable sized Screen!</div>
   *   return null;
   * }
   * ```
   * @param breakpointMap An object map of breakpoints and directions, queries are constructed using "and" to join
   * breakpoints together
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ /**
   * Match a single breakpoint exactly, up, or down.
   *
   * ```tsx
   * const PhoneOnly = () => {
   *   const isSmall = useBreakpoint('sm', 'down');
   *
   *   if (isSmall) return <div>On a Small Screen!</div>
   *   return null;
   * }
   * ```
   *
   * @param breakpoint The breakpoint key
   * @param direction A direction 'up' for a max, 'down' for min, true to match only the breakpoint
   * @param window Optionally specify the target window to match against (useful when rendering into iframes)
   */ function useBreakpoint(breakpointOrMap, direction, window) {
        let breakpointMap;
        if (typeof breakpointOrMap === 'object') {
            breakpointMap = breakpointOrMap;
            window = direction;
            direction = true;
        } else {
            direction = direction || true;
            breakpointMap = {
                [breakpointOrMap]: direction
            };
        }
        let query = (0, $aZSru.useMemo)(()=>Object.entries(breakpointMap).reduce((query, [key, direction])=>{
                if (direction === 'up' || direction === true) query = and(query, getMinQuery(key));
                if (direction === 'down' || direction === true) query = and(query, getMaxQuery(key));
                return query;
            }, ''), [
            JSON.stringify(breakpointMap)
        ]);
        return (0, $6364f0faa013d681$export$2e2bcd8739ae039)(query, window);
    }
    return useBreakpoint;
}
const $77701771fb553295$var$useBreakpoint = $77701771fb553295$export$9c6950edc251641e({
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200,
    xxl: 1400
});
var $77701771fb553295$export$2e2bcd8739ae039 = $77701771fb553295$var$useBreakpoint;




var $aZSru = parcelRequire("aZSru");



var $aZSru = parcelRequire("aZSru");



"use client";
const $a7f4a341d26e7d8c$var$OffcanvasBody = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-body');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$a7f4a341d26e7d8c$var$OffcanvasBody.displayName = 'OffcanvasBody';
var $a7f4a341d26e7d8c$export$2e2bcd8739ae039 = $a7f4a341d26e7d8c$var$OffcanvasBody;




var $aZSru = parcelRequire("aZSru");






"use client";
const $efc438adfea4e98e$var$transitionStyles = {
    [(0, $61e0c3d460fb69c2$export$df38205c966be359)]: 'show',
    [(0, $61e0c3d460fb69c2$export$78e9e6e3e014d60a)]: 'show'
};
const $efc438adfea4e98e$var$OffcanvasToggling = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, in: inProp = false, mountOnEnter: mountOnEnter = false, unmountOnExit: unmountOnExit = false, appear: appear = false, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $8968d694d76052a6$export$2e2bcd8739ae039), {
        ref: ref,
        addEndListener: (0, $d91e207b7882051e$export$2e2bcd8739ae039),
        in: inProp,
        mountOnEnter: mountOnEnter,
        unmountOnExit: unmountOnExit,
        appear: appear,
        ...props,
        childRef: (0, $6de6cf4b5106e807$export$87943f2672146d57)(children),
        children: (status, innerProps)=>/*#__PURE__*/ $aZSru.cloneElement(children, {
                ...innerProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, children.props.className, (status === (0, $61e0c3d460fb69c2$export$df38205c966be359) || status === (0, $61e0c3d460fb69c2$export$4aacc83d4d59139f)) && `${bsPrefix}-toggling`, $efc438adfea4e98e$var$transitionStyles[status])
            })
    });
});
$efc438adfea4e98e$var$OffcanvasToggling.displayName = 'OffcanvasToggling';
var $efc438adfea4e98e$export$2e2bcd8739ae039 = $efc438adfea4e98e$var$OffcanvasToggling;





var $aZSru = parcelRequire("aZSru");



"use client";
const $13140216d3632d10$var$OffcanvasHeader = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, closeLabel: closeLabel = 'Close', closeButton: closeButton = false, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-header');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $1b8c24e6ae54dfb7$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        closeLabel: closeLabel,
        closeButton: closeButton
    });
});
$13140216d3632d10$var$OffcanvasHeader.displayName = 'OffcanvasHeader';
var $13140216d3632d10$export$2e2bcd8739ae039 = $13140216d3632d10$var$OffcanvasHeader;



var $aZSru = parcelRequire("aZSru");




"use client";
const $d2bb657c08460ec9$var$DivStyledAsH5 = (0, $b8cdaec40b680c86$export$2e2bcd8739ae039)('h5');
const $d2bb657c08460ec9$var$OffcanvasTitle = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = $d2bb657c08460ec9$var$DivStyledAsH5, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas-title');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$d2bb657c08460ec9$var$OffcanvasTitle.displayName = 'OffcanvasTitle';
var $d2bb657c08460ec9$export$2e2bcd8739ae039 = $d2bb657c08460ec9$var$OffcanvasTitle;





"use client";
function $1b15a9ffdc446bc4$var$DialogTransition(props) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $efc438adfea4e98e$export$2e2bcd8739ae039), {
        ...props
    });
}
function $1b15a9ffdc446bc4$var$BackdropTransition(props) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $75d062e47e20887d$export$2e2bcd8739ae039), {
        ...props
    });
}
const $1b15a9ffdc446bc4$var$Offcanvas = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, className: className, children: children, 'aria-labelledby': ariaLabelledby, placement: placement = 'start', responsive: responsive, show: /* BaseModal props */ show = false, backdrop: backdrop = true, keyboard: keyboard = true, scroll: scroll = false, onEscapeKeyDown: onEscapeKeyDown, onShow: onShow, onHide: onHide, container: container, autoFocus: autoFocus = true, enforceFocus: enforceFocus = true, restoreFocus: restoreFocus = true, restoreFocusOptions: restoreFocusOptions, onEntered: onEntered, onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onExited: onExited, backdropClassName: backdropClassName, manager: propsManager, renderStaticNode: renderStaticNode = false, ...props }, ref)=>{
    const modalManager = (0, $aZSru.useRef)();
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'offcanvas');
    const [showOffcanvas, setShowOffcanvas] = (0, $aZSru.useState)(false);
    const handleHide = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)(onHide);
    const hideResponsiveOffcanvas = (0, $77701771fb553295$export$2e2bcd8739ae039)(responsive || 'xs', 'up');
    (0, $aZSru.useEffect)(()=>{
        // Handles the case where screen is resized while the responsive
        // offcanvas is shown. If `responsive` not provided, just use `show`.
        setShowOffcanvas(responsive ? show && !hideResponsiveOffcanvas : show);
    }, [
        show,
        responsive,
        hideResponsiveOffcanvas
    ]);
    const modalContext = (0, $aZSru.useMemo)(()=>({
            onHide: handleHide
        }), [
        handleHide
    ]);
    function getModalManager() {
        if (propsManager) return propsManager;
        if (scroll) {
            // Have to use a different modal manager since the shared
            // one handles overflow.
            if (!modalManager.current) modalManager.current = new (0, $9000de8b194da122$export$2e2bcd8739ae039)({
                handleContainerOverflow: false
            });
            return modalManager.current;
        }
        return (0, $9000de8b194da122$export$a03641438014b436)();
    }
    const handleEnter = (node, ...args)=>{
        if (node) node.style.visibility = 'visible';
        onEnter == null || onEnter(node, ...args);
    };
    const handleExited = (node, ...args)=>{
        if (node) node.style.visibility = '';
        onExited == null || onExited(...args);
    };
    const renderBackdrop = (0, $aZSru.useCallback)((backdropProps)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            ...backdropProps,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(`${bsPrefix}-backdrop`, backdropClassName)
        }), [
        backdropClassName,
        bsPrefix
    ]);
    const renderDialog = (dialogProps)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
            ...dialogProps,
            ...props,
            className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, responsive ? `${bsPrefix}-${responsive}` : bsPrefix, `${bsPrefix}-${placement}`),
            "aria-labelledby": ariaLabelledby,
            children: children
        });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            !showOffcanvas && (responsive || renderStaticNode) && renderDialog({}),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b53269eaf5c24589$export$2e2bcd8739ae039).Provider, {
                value: modalContext,
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $8fd58f8475a0c86a$export$2e2bcd8739ae039), {
                    show: showOffcanvas,
                    ref: ref,
                    backdrop: backdrop,
                    container: container,
                    keyboard: keyboard,
                    autoFocus: autoFocus,
                    enforceFocus: enforceFocus && !scroll,
                    restoreFocus: restoreFocus,
                    restoreFocusOptions: restoreFocusOptions,
                    onEscapeKeyDown: onEscapeKeyDown,
                    onShow: onShow,
                    onHide: handleHide,
                    onEnter: handleEnter,
                    onEntering: onEntering,
                    onEntered: onEntered,
                    onExit: onExit,
                    onExiting: onExiting,
                    onExited: handleExited,
                    manager: getModalManager(),
                    transition: $1b15a9ffdc446bc4$var$DialogTransition,
                    backdropTransition: $1b15a9ffdc446bc4$var$BackdropTransition,
                    renderBackdrop: renderBackdrop,
                    renderDialog: renderDialog
                })
            })
        ]
    });
});
$1b15a9ffdc446bc4$var$Offcanvas.displayName = 'Offcanvas';
var $1b15a9ffdc446bc4$export$2e2bcd8739ae039 = Object.assign($1b15a9ffdc446bc4$var$Offcanvas, {
    Body: (0, $a7f4a341d26e7d8c$export$2e2bcd8739ae039),
    Header: (0, $13140216d3632d10$export$2e2bcd8739ae039),
    Title: (0, $d2bb657c08460ec9$export$2e2bcd8739ae039)
});




"use client";
const $a0d9c4de84d193ae$var$NavbarOffcanvas = /*#__PURE__*/ $aZSru.forwardRef(({ onHide: onHide, ...props }, ref)=>{
    const context = (0, $aZSru.useContext)((0, $3e9abdf2100dccc0$export$2e2bcd8739ae039));
    const handleHide = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)(()=>{
        context == null || context.onToggle == null || context.onToggle();
        onHide == null || onHide();
    });
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $1b15a9ffdc446bc4$export$2e2bcd8739ae039), {
        ref: ref,
        show: !!(context != null && context.expanded),
        ...props,
        renderStaticNode: true,
        onHide: handleHide
    });
});
$a0d9c4de84d193ae$var$NavbarOffcanvas.displayName = 'NavbarOffcanvas';
var $a0d9c4de84d193ae$export$2e2bcd8739ae039 = $a0d9c4de84d193ae$var$NavbarOffcanvas;





var $aZSru = parcelRequire("aZSru");



"use client";
const $788b01ff6f97636b$var$NavbarText = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'span', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'navbar-text');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$788b01ff6f97636b$var$NavbarText.displayName = 'NavbarText';
var $788b01ff6f97636b$export$2e2bcd8739ae039 = $788b01ff6f97636b$var$NavbarText;



"use client";
const $216b0f0c00e7b575$var$Navbar = /*#__PURE__*/ $aZSru.forwardRef((props, ref)=>{
    const { bsPrefix: initialBsPrefix, expand: expand = true, variant: variant = 'light', bg: bg, fixed: fixed, sticky: sticky, className: className, // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as: Component = 'nav', expanded: expanded, onToggle: onToggle, onSelect: onSelect, collapseOnSelect: collapseOnSelect = false, ...controlledProps } = (0, $1df078ddfa34638e$export$2e2bcd8739ae039)(props, {
        expanded: 'onToggle'
    });
    const bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(initialBsPrefix, 'navbar');
    const handleCollapse = (0, $aZSru.useCallback)((...args)=>{
        onSelect == null || onSelect(...args);
        if (collapseOnSelect && expanded) onToggle == null || onToggle(false);
    }, [
        onSelect,
        collapseOnSelect,
        expanded,
        onToggle
    ]);
    // will result in some false positives but that seems better
    // than false negatives. strict `undefined` check allows explicit
    // "nulling" of the role if the user really doesn't want one
    if (controlledProps.role === undefined && Component !== 'nav') controlledProps.role = 'navigation';
    let expandClass = `${bsPrefix}-expand`;
    if (typeof expand === 'string') expandClass = `${expandClass}-${expand}`;
    const navbarContext = (0, $aZSru.useMemo)(()=>({
            onToggle: ()=>onToggle == null ? void 0 : onToggle(!expanded),
            bsPrefix: bsPrefix,
            expanded: !!expanded,
            expand: expand
        }), [
        bsPrefix,
        expanded,
        expand,
        onToggle
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $3e9abdf2100dccc0$export$2e2bcd8739ae039).Provider, {
        value: navbarContext,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $21bccd3f5a98e26e$export$2e2bcd8739ae039).Provider, {
            value: handleCollapse,
            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
                ref: ref,
                ...controlledProps,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, expand && expandClass, variant && `${bsPrefix}-${variant}`, bg && `bg-${bg}`, sticky && `sticky-${sticky}`, fixed && `fixed-${fixed}`)
            })
        })
    });
});
$216b0f0c00e7b575$var$Navbar.displayName = 'Navbar';
var $216b0f0c00e7b575$export$2e2bcd8739ae039 = Object.assign($216b0f0c00e7b575$var$Navbar, {
    Brand: (0, $9c7a6dc0e57f7773$export$2e2bcd8739ae039),
    Collapse: (0, $e04b2af0dbc50888$export$2e2bcd8739ae039),
    Offcanvas: (0, $a0d9c4de84d193ae$export$2e2bcd8739ae039),
    Text: (0, $788b01ff6f97636b$export$2e2bcd8739ae039),
    Toggle: (0, $9e74e69329708e85$export$2e2bcd8739ae039)
});




var $aZSru = parcelRequire("aZSru");




"use client";
const $9ca51b153ddf2e52$var$NavDropdown = /*#__PURE__*/ $aZSru.forwardRef(({ id: id, title: title, children: children, bsPrefix: bsPrefix, className: className, rootCloseEvent: rootCloseEvent, menuRole: menuRole, disabled: disabled, active: active, renderMenuOnMount: renderMenuOnMount, menuVariant: menuVariant, ...props }, ref)=>{
    /* NavItem has no additional logic, it's purely presentational. Can set nav item class here to support "as" */ const navItemPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(undefined, 'nav-item');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039), {
        ref: ref,
        ...props,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, navItemPrefix),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Toggle, {
                id: id,
                eventKey: null,
                active: active,
                disabled: disabled,
                childBsPrefix: bsPrefix,
                as: (0, $985545383a5dfe41$export$2e2bcd8739ae039),
                children: title
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Menu, {
                role: menuRole,
                renderOnMount: renderMenuOnMount,
                rootCloseEvent: rootCloseEvent,
                variant: menuVariant,
                children: children
            })
        ]
    });
});
$9ca51b153ddf2e52$var$NavDropdown.displayName = 'NavDropdown';
var $9ca51b153ddf2e52$export$2e2bcd8739ae039 = Object.assign($9ca51b153ddf2e52$var$NavDropdown, {
    Item: (0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Item,
    ItemText: (0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).ItemText,
    Divider: (0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Divider,
    Header: (0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Header
});








parcelRequire("aZSru");
function $2b645b3d4ad1132c$export$e2255cf6045e8d47({ user: user, size: size, className: className, alt: alt }) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("img", {
        className: className,
        style: {
            width: size,
            height: size,
            borderRadius: size < 24 ? "4px" : "6px"
        },
        alt: alt || "",
        src: `${user.avatarUrl}&s=${size * 3}`
    });
}


const $076f66bb16c5e38d$export$bce550385d03c7a9 = ({ breadcrumbs: breadcrumbs, buttons: buttons })=>{
    const navigate = (0, $da3cac5a2aaa7b71$export$9770f232ac06a008)();
    const location = (0, $da3cac5a2aaa7b71$export$45d76561a5302f2b)();
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $2ecc252479907655$export$10b6fc071fe541e9).Consumer, {
                        children: (context)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $216b0f0c00e7b575$export$2e2bcd8739ae039), {
                                className: "p-0 mb-3 align-items-baseline",
                                collapseOnSelect: true,
                                expand: "md",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $216b0f0c00e7b575$export$2e2bcd8739ae039).Brand, {
                                        href: "/",
                                        onClick: (e)=>(0, $ff1fe7435e7c9214$export$569b44dc40350ca0)(e, navigate),
                                        children: "morale.events"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $216b0f0c00e7b575$export$2e2bcd8739ae039).Toggle, {
                                        className: "me-auto",
                                        "aria-controls": "navbar-collapse"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $216b0f0c00e7b575$export$2e2bcd8739ae039).Collapse, {
                                        id: "navbar-collapse",
                                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $ab22e28b9ae07ef3$export$2e2bcd8739ae039), {
                                            className: "me-auto",
                                            children: context.currentUser.isSuperAdmin && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $ab22e28b9ae07ef3$export$2e2bcd8739ae039).Link, {
                                                active: location.pathname === "/user/list",
                                                href: "/user/list",
                                                onClick: (e)=>(0, $ff1fe7435e7c9214$export$569b44dc40350ca0)(e, navigate),
                                                children: "Users"
                                            })
                                        })
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $9ca51b153ddf2e52$export$2e2bcd8739ae039), {
                                        id: "avatar-dropdown",
                                        align: "end",
                                        title: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $2b645b3d4ad1132c$export$e2255cf6045e8d47), {
                                            user: context.currentUser,
                                            size: 30,
                                            alt: "User menu"
                                        }),
                                        children: [
                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $9ca51b153ddf2e52$export$2e2bcd8739ae039).Item, {
                                                href: `https://github.com/settings/connections/applications/${context.clientId}`,
                                                target: "_blank",
                                                children: "Review GitHub Access"
                                            }),
                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $9ca51b153ddf2e52$export$2e2bcd8739ae039).Item, {
                                                onClick: async ()=>{
                                                    await $81ca197868c8b74e$export$a0973bcfe11b05c9() && (window.location.href = "/");
                                                },
                                                children: "Log Out"
                                            }),
                                            context.currentUser.isSuperAdmin && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
                                                children: [
                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $9ca51b153ddf2e52$export$2e2bcd8739ae039).Item, {
                                                        disabled: true,
                                                        children: context.version
                                                    }),
                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $9ca51b153ddf2e52$export$2e2bcd8739ae039).Item, {
                                                        disabled: true,
                                                        children: context.sha?.substring(0, 6)
                                                    })
                                                ]
                                            })
                                        ]
                                    })
                                ]
                            })
                    })
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                className: "mb-2 align-items-baseline justify-content-between",
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                        md: "auto",
                        children: breadcrumbs && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $462fc53b42007d26$export$2e2bcd8739ae039), {
                            listProps: {
                                className: "mb-0"
                            },
                            children: breadcrumbs.filter((bc)=>!!bc).map((bc, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($076f66bb16c5e38d$var$MeBreadCrumbItem, {
                                    href: bc.href,
                                    active: bc.active,
                                    children: bc.text
                                }, i))
                        })
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                        md: "auto",
                        className: "d-flex justify-content-end",
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c2a0c34732c0673f$export$2e2bcd8739ae039), {
                            children: buttons && buttons.filter((b)=>!!b).map((b, i)=>{
                                const className = "ms-2";
                                if (b.type === "dropdown") return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039), {
                                    className: className,
                                    children: [
                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Toggle, {
                                            children: b.text
                                        }),
                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Menu, {
                                            children: b.items.map((item, j)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $27f60f8b2b4ab939$export$2e2bcd8739ae039).Item, {
                                                    onClick: item.onClick,
                                                    disabled: item.disabled,
                                                    children: item.text
                                                }, j))
                                        })
                                    ]
                                }, i);
                                else return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                    className: className,
                                    variant: b.variant,
                                    onClick: b.onClick,
                                    children: b.text
                                }, i);
                            })
                        })
                    })
                ]
            })
        ]
    });
};
function $076f66bb16c5e38d$var$MeBreadCrumbItem(props) {
    const navigate = (0, $da3cac5a2aaa7b71$export$9770f232ac06a008)();
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7a6fc0ac75de37db$export$2e2bcd8739ae039), {
        ...props,
        onClick: (e)=>(0, $ff1fe7435e7c9214$export$569b44dc40350ca0)(e, navigate)
    });
}





var $94eCw = parcelRequire("94eCw");

var $aZSru = parcelRequire("aZSru");







var $aZSru = parcelRequire("aZSru");






var $aZSru = parcelRequire("aZSru");






"use client";
const $90e9c9a82639d530$var$ListGroupItem = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, active: active, disabled: disabled, eventKey: eventKey, className: className, variant: variant, action: action, as: as, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'list-group-item');
    const [navItemProps, meta] = (0, $4989830148bfdcec$export$d7a68693710982a)({
        key: (0, $21bccd3f5a98e26e$export$eef49b42fde998a3)(eventKey, props.href),
        active: active,
        ...props
    });
    const handleClick = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)((event)=>{
        if (disabled) {
            event.preventDefault();
            event.stopPropagation();
            return;
        }
        navItemProps.onClick(event);
    });
    if (disabled && props.tabIndex === undefined) {
        props.tabIndex = -1;
        props['aria-disabled'] = true;
    }
    const Component = as || (action ? props.href ? 'a' : 'button' : 'div');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        ...props,
        ...navItemProps,
        onClick: handleClick,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, meta.isActive && 'active', disabled && 'disabled', variant && `${bsPrefix}-${variant}`, action && `${bsPrefix}-action`)
    });
});
$90e9c9a82639d530$var$ListGroupItem.displayName = 'ListGroupItem';
var $90e9c9a82639d530$export$2e2bcd8739ae039 = $90e9c9a82639d530$var$ListGroupItem;



"use client";
const $7528e47a5e173e89$var$ListGroup = /*#__PURE__*/ $aZSru.forwardRef((props, ref)=>{
    const { className: className, bsPrefix: initialBsPrefix, variant: variant, horizontal: horizontal, numbered: numbered, as: // Need to define the default "as" during prop destructuring to be compatible with styled-components github.com/react-bootstrap/react-bootstrap/issues/3595
    as = 'div', ...controlledProps } = (0, $1df078ddfa34638e$export$2e2bcd8739ae039)(props, {
        activeKey: 'onSelect'
    });
    const bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(initialBsPrefix, 'list-group');
    let horizontalVariant;
    if (horizontal) horizontalVariant = horizontal === true ? 'horizontal' : `horizontal-${horizontal}`;
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c31e2549579829fc$export$2e2bcd8739ae039), {
        ref: ref,
        ...controlledProps,
        as: as,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, variant && `${bsPrefix}-${variant}`, horizontalVariant && `${bsPrefix}-${horizontalVariant}`, numbered && `${bsPrefix}-numbered`)
    });
});
$7528e47a5e173e89$var$ListGroup.displayName = 'ListGroup';
var $7528e47a5e173e89$export$2e2bcd8739ae039 = Object.assign($7528e47a5e173e89$var$ListGroup, {
    Item: (0, $90e9c9a82639d530$export$2e2bcd8739ae039)
});






var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");

var $aZSru = parcelRequire("aZSru");
function $069923caf00b01d4$export$2e2bcd8739ae039() {
    const mounted = (0, $aZSru.useRef)(true);
    const isMounted = (0, $aZSru.useRef)(()=>mounted.current);
    (0, $aZSru.useEffect)(()=>{
        mounted.current = true;
        return ()=>{
            mounted.current = false;
        };
    }, []);
    return isMounted.current;
}



/*
 * Browsers including Internet Explorer, Chrome, Safari, and Firefox store the
 * delay as a 32-bit signed integer internally. This causes an integer overflow
 * when using delays larger than 2,147,483,647 ms (about 24.8 days),
 * resulting in the timeout being executed immediately.
 *
 * via: https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout
 */ const $8bf25d4906ed5d73$var$MAX_DELAY_MS = 2 ** 31 - 1;
function $8bf25d4906ed5d73$var$setChainedTimeout(handleRef, fn, timeoutAtMs) {
    const delayMs = timeoutAtMs - Date.now();
    handleRef.current = delayMs <= $8bf25d4906ed5d73$var$MAX_DELAY_MS ? setTimeout(fn, delayMs) : setTimeout(()=>$8bf25d4906ed5d73$var$setChainedTimeout(handleRef, fn, timeoutAtMs), $8bf25d4906ed5d73$var$MAX_DELAY_MS);
}
function $8bf25d4906ed5d73$export$2e2bcd8739ae039() {
    const isMounted = (0, $069923caf00b01d4$export$2e2bcd8739ae039)();
    // types are confused between node and web here IDK
    const handleRef = (0, $aZSru.useRef)();
    (0, $d4fe19c6dc8995e6$export$2e2bcd8739ae039)(()=>clearTimeout(handleRef.current));
    return (0, $aZSru.useMemo)(()=>{
        const clear = ()=>clearTimeout(handleRef.current);
        function set(fn, delayMs = 0) {
            if (!isMounted()) return;
            clear();
            if (delayMs <= $8bf25d4906ed5d73$var$MAX_DELAY_MS) // For simplicity, if the timeout is short, just set a normal timeout.
            handleRef.current = setTimeout(fn, delayMs);
            else $8bf25d4906ed5d73$var$setChainedTimeout(handleRef, fn, Date.now() + delayMs);
        }
        return {
            set: set,
            clear: clear,
            handleRef: handleRef
        };
    }, []);
}







var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");

var $4lOAY = parcelRequire("4lOAY");






var $aZSru = parcelRequire("aZSru");



const $fcb10048f3c52bb2$var$noop = ()=>{};
/**
 * The `useRootClose` hook registers your callback on the document
 * when rendered. Powers the `<Overlay/>` component. This is used achieve modal
 * style behavior where your callback is triggered when the user tries to
 * interact with the rest of the document or hits the `esc` key.
 *
 * @param {Ref<HTMLElement>| HTMLElement} ref  The element boundary
 * @param {function} onRootClose
 * @param {object=}  options
 * @param {boolean=} options.disabled
 * @param {string=}  options.clickTrigger The DOM event name (click, mousedown, etc) to attach listeners on
 */ function $fcb10048f3c52bb2$var$useRootClose(ref, onRootClose, { disabled: disabled, clickTrigger: clickTrigger } = {}) {
    const onClose = onRootClose || $fcb10048f3c52bb2$var$noop;
    (0, $8f487b0e3d0e1b9f$export$2e2bcd8739ae039)(ref, onClose, {
        disabled: disabled,
        clickTrigger: clickTrigger
    });
    const handleKeyUp = (0, $21bc47d5cee5541a$export$2e2bcd8739ae039)((e)=>{
        if ((0, $6de6cf4b5106e807$export$806fcc22e55e107d)(e)) onClose(e);
    });
    (0, $aZSru.useEffect)(()=>{
        if (disabled || ref == null) return undefined;
        const doc = (0, $0948e8b135437cc0$export$2e2bcd8739ae039)((0, $8f487b0e3d0e1b9f$export$347601c75fcd4732)(ref));
        // Store the current event to avoid triggering handlers immediately
        // https://github.com/facebook/react/issues/20074
        let currentEvent = (doc.defaultView || window).event;
        const removeKeyupListener = (0, $ef3c54910b074bb2$export$2e2bcd8739ae039)(doc, 'keyup', (e)=>{
            // skip if this event is the same as the one running when we added the handlers
            if (e === currentEvent) {
                currentEvent = undefined;
                return;
            }
            handleKeyUp(e);
        });
        return ()=>{
            removeKeyupListener();
        };
    }, [
        ref,
        disabled,
        handleKeyUp
    ]);
}
var $fcb10048f3c52bb2$export$2e2bcd8739ae039 = $fcb10048f3c52bb2$var$useRootClose;





/**
 * Built on top of `Popper.js`, the overlay component is
 * great for custom tooltip overlays.
 */ const $825cde7442b04be7$var$Overlay = /*#__PURE__*/ $aZSru.forwardRef((props, outerRef)=>{
    const { flip: flip, offset: offset, placement: placement, containerPadding: containerPadding, popperConfig: popperConfig = {}, transition: Transition, runTransition: runTransition } = props;
    const [rootElement, attachRef] = (0, $59a38f3069ca3009$export$2e2bcd8739ae039)();
    const [arrowElement, attachArrowRef] = (0, $59a38f3069ca3009$export$2e2bcd8739ae039)();
    const mergedRef = (0, $bb2998387863b2cb$export$2e2bcd8739ae039)(attachRef, outerRef);
    const container = (0, $c1fcdab6ce610b72$export$2e2bcd8739ae039)(props.container);
    const target = (0, $c1fcdab6ce610b72$export$2e2bcd8739ae039)(props.target);
    const [exited, setExited] = (0, $aZSru.useState)(!props.show);
    const popper = (0, $08679a5baa924333$export$2e2bcd8739ae039)(target, rootElement, (0, $731996e3e45e1d4f$export$2e2bcd8739ae039)({
        placement: placement,
        enableEvents: !!props.show,
        containerPadding: containerPadding || 5,
        flip: flip,
        offset: offset,
        arrowElement: arrowElement,
        popperConfig: popperConfig
    }));
    // TODO: I think this needs to be in an effect
    if (props.show && exited) setExited(false);
    const handleHidden = (...args)=>{
        setExited(true);
        if (props.onExited) props.onExited(...args);
    };
    // Don't un-render the overlay while it's transitioning out.
    const mountOverlay = props.show || !exited;
    (0, $fcb10048f3c52bb2$export$2e2bcd8739ae039)(rootElement, props.onHide, {
        disabled: !props.rootClose || props.rootCloseDisabled,
        clickTrigger: props.rootCloseEvent
    });
    if (!mountOverlay) // Don't bother showing anything if we don't have to.
    return null;
    const { onExit: onExit, onExiting: onExiting, onEnter: onEnter, onEntering: onEntering, onEntered: onEntered } = props;
    let child = props.children(Object.assign({}, popper.attributes.popper, {
        style: popper.styles.popper,
        ref: mergedRef
    }), {
        popper: popper,
        placement: placement,
        show: !!props.show,
        arrowProps: Object.assign({}, popper.attributes.arrow, {
            style: popper.styles.arrow,
            ref: attachArrowRef
        })
    });
    child = (0, $7a90b9204ab52ce8$export$f41d64aae6d6dba5)(Transition, runTransition, {
        in: !!props.show,
        appear: true,
        mountOnEnter: true,
        unmountOnExit: true,
        children: child,
        onExit: onExit,
        onExiting: onExiting,
        onExited: handleHidden,
        onEnter: onEnter,
        onEntering: onEntering,
        onEntered: onEntered
    });
    return container ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($4lOAY))).createPortal(child, container) : null;
});
$825cde7442b04be7$var$Overlay.displayName = 'Overlay';
var $825cde7442b04be7$export$2e2bcd8739ae039 = $825cde7442b04be7$var$Overlay;






var $aZSru = parcelRequire("aZSru");




var $aZSru = parcelRequire("aZSru");


var $aZSru = parcelRequire("aZSru");



"use client";
const $46ce35865f0832a3$var$PopoverHeader = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'popover-header');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$46ce35865f0832a3$var$PopoverHeader.displayName = 'PopoverHeader';
var $46ce35865f0832a3$export$2e2bcd8739ae039 = $46ce35865f0832a3$var$PopoverHeader;



var $aZSru = parcelRequire("aZSru");



"use client";
const $66bb5de71be4d729$var$PopoverBody = /*#__PURE__*/ $aZSru.forwardRef(({ className: className, bsPrefix: bsPrefix, as: Component = 'div', ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'popover-body');
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)(Component, {
        ref: ref,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix),
        ...props
    });
});
$66bb5de71be4d729$var$PopoverBody.displayName = 'PopoverBody';
var $66bb5de71be4d729$export$2e2bcd8739ae039 = $66bb5de71be4d729$var$PopoverBody;



var $aZSru = parcelRequire("aZSru");
class $2d35d6ffaaad30a6$export$34582a676b91ff07 extends $aZSru.Component {
}
function $2d35d6ffaaad30a6$export$c15856915a9b3464(placement, isRTL) {
    let bsDirection = placement;
    if (placement === 'left') bsDirection = isRTL ? 'end' : 'start';
    else if (placement === 'right') bsDirection = isRTL ? 'start' : 'end';
    return bsDirection;
}


function $b0d6f7bd7079ecbe$export$2e2bcd8739ae039(position = 'absolute') {
    return {
        position: position,
        top: '0',
        left: '0',
        opacity: '0',
        pointerEvents: 'none'
    };
}



"use client";
const $5dac61ed1c570a51$var$Popover = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, body: body, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    const decoratedBsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'popover');
    const isRTL = (0, $7c127cff4998859a$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $2d35d6ffaaad30a6$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $b0d6f7bd7079ecbe$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
        ref: ref,
        role: "tooltip",
        style: computedStyle,
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, decoratedBsPrefix, primaryPlacement && `bs-popover-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                className: "popover-arrow",
                ...arrowProps
            }),
            body ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $66bb5de71be4d729$export$2e2bcd8739ae039), {
                children: children
            }) : children
        ]
    });
});
$5dac61ed1c570a51$var$Popover.displayName = 'Popover';
var $5dac61ed1c570a51$export$2e2bcd8739ae039 = Object.assign($5dac61ed1c570a51$var$Popover, {
    Header: (0, $46ce35865f0832a3$export$2e2bcd8739ae039),
    Body: (0, $66bb5de71be4d729$export$2e2bcd8739ae039),
    // Default popover offset.
    // https://github.com/twbs/bootstrap/blob/5c32767e0e0dbac2d934bcdee03719a65d3f1187/js/src/popover.js#L28
    POPPER_OFFSET: [
        0,
        8
    ]
});




var $aZSru = parcelRequire("aZSru");




"use client";
const $11f28e84c5a16cd0$var$Tooltip = /*#__PURE__*/ $aZSru.forwardRef(({ bsPrefix: bsPrefix, placement: placement = 'right', className: className, style: style, children: children, arrowProps: arrowProps, hasDoneInitialMeasure: hasDoneInitialMeasure, popper: popper, show: show, ...props }, ref)=>{
    bsPrefix = (0, $7c127cff4998859a$export$7f387860ebffb32c)(bsPrefix, 'tooltip');
    const isRTL = (0, $7c127cff4998859a$export$35e511eefa30ac5a)();
    const [primaryPlacement] = (placement == null ? void 0 : placement.split('-')) || [];
    const bsDirection = (0, $2d35d6ffaaad30a6$export$c15856915a9b3464)(primaryPlacement, isRTL);
    let computedStyle = style;
    if (show && !hasDoneInitialMeasure) computedStyle = {
        ...style,
        ...(0, $b0d6f7bd7079ecbe$export$2e2bcd8739ae039)(popper == null ? void 0 : popper.strategy)
    };
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
        ref: ref,
        style: computedStyle,
        role: "tooltip",
        "x-placement": primaryPlacement,
        className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(className, bsPrefix, `bs-tooltip-${bsDirection}`),
        ...props,
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                className: "tooltip-arrow",
                ...arrowProps
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                className: `${bsPrefix}-inner`,
                children: children
            })
        ]
    });
});
$11f28e84c5a16cd0$var$Tooltip.displayName = 'Tooltip';
var $11f28e84c5a16cd0$export$2e2bcd8739ae039 = Object.assign($11f28e84c5a16cd0$var$Tooltip, {
    // Default tooltip offset.
    // https://github.com/twbs/bootstrap/blob/beca2a6c7f6bc88b6449339fc76edcda832c59e5/js/src/tooltip.js#L65
    TOOLTIP_OFFSET: [
        0,
        6
    ]
});


"use client";
function $94287d9e9b9ed73b$export$2e2bcd8739ae039(customOffset) {
    const overlayRef = (0, $aZSru.useRef)(null);
    const popoverClass = (0, $7c127cff4998859a$export$7f387860ebffb32c)(undefined, 'popover');
    const tooltipClass = (0, $7c127cff4998859a$export$7f387860ebffb32c)(undefined, 'tooltip');
    const offset = (0, $aZSru.useMemo)(()=>({
            name: 'offset',
            options: {
                offset: ()=>{
                    if (customOffset) return customOffset;
                    if (overlayRef.current) {
                        if ((0, $424c8a7de98bf84a$export$2e2bcd8739ae039)(overlayRef.current, popoverClass)) return (0, $5dac61ed1c570a51$export$2e2bcd8739ae039).POPPER_OFFSET;
                        if ((0, $424c8a7de98bf84a$export$2e2bcd8739ae039)(overlayRef.current, tooltipClass)) return (0, $11f28e84c5a16cd0$export$2e2bcd8739ae039).TOOLTIP_OFFSET;
                    }
                    return [
                        0,
                        0
                    ];
                }
            }
        }), [
        customOffset,
        popoverClass,
        tooltipClass
    ]);
    return [
        overlayRef,
        [
            offset
        ]
    ];
}





"use client";
function $125420176c931362$var$wrapRefs(props, arrowProps) {
    const { ref: ref } = props;
    const { ref: aRef } = arrowProps;
    props.ref = ref.__wrapped || (ref.__wrapped = (r)=>ref((0, $4504d0e8962fecda$export$2e2bcd8739ae039)(r)));
    arrowProps.ref = aRef.__wrapped || (aRef.__wrapped = (r)=>aRef((0, $4504d0e8962fecda$export$2e2bcd8739ae039)(r)));
}
const $125420176c931362$var$Overlay = /*#__PURE__*/ $aZSru.forwardRef(({ children: overlay, transition: transition = (0, $75d062e47e20887d$export$2e2bcd8739ae039), popperConfig: popperConfig = {}, rootClose: rootClose = false, placement: placement = 'top', show: outerShow = false, ...outerProps }, outerRef)=>{
    const popperRef = (0, $aZSru.useRef)({});
    const [firstRenderedState, setFirstRenderedState] = (0, $aZSru.useState)(null);
    const [ref, modifiers] = (0, $94287d9e9b9ed73b$export$2e2bcd8739ae039)(outerProps.offset);
    const mergedRef = (0, $dfc8aef1afa68cbb$export$2e2bcd8739ae039)(outerRef, ref);
    const actualTransition = transition === true ? (0, $75d062e47e20887d$export$2e2bcd8739ae039) : transition || undefined;
    const handleFirstUpdate = (0, $ab8374406972b2d1$export$2e2bcd8739ae039)((state)=>{
        setFirstRenderedState(state);
        popperConfig == null || popperConfig.onFirstUpdate == null || popperConfig.onFirstUpdate(state);
    });
    (0, $7321142bf89bdf31$export$2e2bcd8739ae039)(()=>{
        if (firstRenderedState && outerProps.target) // Must wait for target element to resolve before updating popper.
        popperRef.current.scheduleUpdate == null || popperRef.current.scheduleUpdate();
    }, [
        firstRenderedState,
        outerProps.target
    ]);
    (0, $aZSru.useEffect)(()=>{
        if (!outerShow) setFirstRenderedState(null);
    }, [
        outerShow
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $825cde7442b04be7$export$2e2bcd8739ae039), {
        ...outerProps,
        ref: mergedRef,
        popperConfig: {
            ...popperConfig,
            modifiers: modifiers.concat(popperConfig.modifiers || []),
            onFirstUpdate: handleFirstUpdate
        },
        transition: actualTransition,
        rootClose: rootClose,
        placement: placement,
        show: outerShow,
        children: (overlayProps, { arrowProps: arrowProps, popper: popperObj, show: show })=>{
            var _popperObj$state;
            $125420176c931362$var$wrapRefs(overlayProps, arrowProps);
            // Need to get placement from popper object, handling case when overlay is flipped using 'flip' prop
            const updatedPlacement = popperObj == null ? void 0 : popperObj.placement;
            const popper = Object.assign(popperRef.current, {
                state: popperObj == null ? void 0 : popperObj.state,
                scheduleUpdate: popperObj == null ? void 0 : popperObj.update,
                placement: updatedPlacement,
                outOfBoundaries: (popperObj == null || (_popperObj$state = popperObj.state) == null || (_popperObj$state = _popperObj$state.modifiersData.hide) == null ? void 0 : _popperObj$state.isReferenceHidden) || false,
                strategy: popperConfig.strategy
            });
            const hasDoneInitialMeasure = !!firstRenderedState;
            if (typeof overlay === 'function') return overlay({
                ...overlayProps,
                placement: updatedPlacement,
                show: show,
                ...!transition && show && {
                    className: 'show'
                },
                popper: popper,
                arrowProps: arrowProps,
                hasDoneInitialMeasure: hasDoneInitialMeasure
            });
            return /*#__PURE__*/ $aZSru.cloneElement(overlay, {
                ...overlayProps,
                placement: updatedPlacement,
                arrowProps: arrowProps,
                popper: popper,
                hasDoneInitialMeasure: hasDoneInitialMeasure,
                className: (0, (/*@__PURE__*/$parcel$interopDefault($409581ffa1f40b0a$exports)))(overlay.props.className, !transition && show && 'show'),
                style: {
                    ...overlay.props.style,
                    ...overlayProps.style
                }
            });
        }
    });
});
$125420176c931362$var$Overlay.displayName = 'Overlay';
var $125420176c931362$export$2e2bcd8739ae039 = $125420176c931362$var$Overlay;




"use client";
function $c2b55618ae86a239$var$normalizeDelay(delay) {
    return delay && typeof delay === 'object' ? delay : {
        show: delay,
        hide: delay
    };
}
// Simple implementation of mouseEnter and mouseLeave.
// React's built version is broken: https://github.com/facebook/react/issues/4251
// for cases when the trigger is disabled and mouseOut/Over can cause flicker
// moving from one child element to another.
function $c2b55618ae86a239$var$handleMouseOverOut(handler, args, relatedNative) {
    const [e] = args;
    const target = e.currentTarget;
    const related = e.relatedTarget || e.nativeEvent[relatedNative];
    if ((!related || related !== target) && !(0, $5f0a0ff0971fd3a0$export$2e2bcd8739ae039)(target, related)) handler(...args);
}
const $c2b55618ae86a239$var$triggerType = (0, (/*@__PURE__*/$parcel$interopDefault($881de41d83720631$exports))).oneOf([
    'click',
    'hover',
    'focus'
]);
const $c2b55618ae86a239$var$OverlayTrigger = ({ trigger: trigger = [
    'hover',
    'focus'
], overlay: overlay, children: children, popperConfig: popperConfig = {}, show: propsShow, defaultShow: defaultShow = false, onToggle: onToggle, delay: propsDelay, placement: placement, flip: flip = placement && placement.indexOf('auto') !== -1, ...props })=>{
    const triggerNodeRef = (0, $aZSru.useRef)(null);
    const mergedRef = (0, $dfc8aef1afa68cbb$export$2e2bcd8739ae039)(triggerNodeRef, (0, $6de6cf4b5106e807$export$87943f2672146d57)(children));
    const timeout = (0, $8bf25d4906ed5d73$export$2e2bcd8739ae039)();
    const hoverStateRef = (0, $aZSru.useRef)('');
    const [show, setShow] = (0, $1df078ddfa34638e$export$2ee51287a16ca325)(propsShow, defaultShow, onToggle);
    const delay = $c2b55618ae86a239$var$normalizeDelay(propsDelay);
    const { onFocus: onFocus, onBlur: onBlur, onClick: onClick } = typeof children !== 'function' ? $aZSru.Children.only(children).props : {};
    const attachRef = (r)=>{
        mergedRef((0, $4504d0e8962fecda$export$2e2bcd8739ae039)(r));
    };
    const handleShow = (0, $aZSru.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'show';
        if (!delay.show) {
            setShow(true);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'show') setShow(true);
        }, delay.show);
    }, [
        delay.show,
        setShow,
        timeout
    ]);
    const handleHide = (0, $aZSru.useCallback)(()=>{
        timeout.clear();
        hoverStateRef.current = 'hide';
        if (!delay.hide) {
            setShow(false);
            return;
        }
        timeout.set(()=>{
            if (hoverStateRef.current === 'hide') setShow(false);
        }, delay.hide);
    }, [
        delay.hide,
        setShow,
        timeout
    ]);
    const handleFocus = (0, $aZSru.useCallback)((...args)=>{
        handleShow();
        onFocus == null || onFocus(...args);
    }, [
        handleShow,
        onFocus
    ]);
    const handleBlur = (0, $aZSru.useCallback)((...args)=>{
        handleHide();
        onBlur == null || onBlur(...args);
    }, [
        handleHide,
        onBlur
    ]);
    const handleClick = (0, $aZSru.useCallback)((...args)=>{
        setShow(!show);
        onClick == null || onClick(...args);
    }, [
        onClick,
        setShow,
        show
    ]);
    const handleMouseOver = (0, $aZSru.useCallback)((...args)=>{
        $c2b55618ae86a239$var$handleMouseOverOut(handleShow, args, 'fromElement');
    }, [
        handleShow
    ]);
    const handleMouseOut = (0, $aZSru.useCallback)((...args)=>{
        $c2b55618ae86a239$var$handleMouseOverOut(handleHide, args, 'toElement');
    }, [
        handleHide
    ]);
    const triggers = trigger == null ? [] : [].concat(trigger);
    const triggerProps = {
        ref: attachRef
    };
    if (triggers.indexOf('click') !== -1) triggerProps.onClick = handleClick;
    if (triggers.indexOf('focus') !== -1) {
        triggerProps.onFocus = handleFocus;
        triggerProps.onBlur = handleBlur;
    }
    if (triggers.indexOf('hover') !== -1) {
        triggerProps.onMouseOver = handleMouseOver;
        triggerProps.onMouseOut = handleMouseOut;
    }
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            typeof children === 'function' ? children(triggerProps) : /*#__PURE__*/ (0, $aZSru.cloneElement)(children, triggerProps),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125420176c931362$export$2e2bcd8739ae039), {
                ...props,
                show: show,
                onHide: handleHide,
                flip: flip,
                placement: placement,
                popperConfig: popperConfig,
                target: triggerNodeRef.current,
                children: overlay
            })
        ]
    });
};
var $c2b55618ae86a239$export$2e2bcd8739ae039 = $c2b55618ae86a239$var$OverlayTrigger;
















var $aZSru = parcelRequire("aZSru");

var $94eCw = parcelRequire("94eCw");
function $cc21a279a635bc02$export$b3bccf74335de5cb({ children: children, endTime: endTime }) {
    const [timeRemaining, setTimeRemaining] = (0, $aZSru.useState)(()=>$cc21a279a635bc02$var$getTimeRemaining(endTime));
    (0, $aZSru.useEffect)(()=>{
        let timeout = -1;
        function callback() {
            setTimeRemaining(()=>$cc21a279a635bc02$var$getTimeRemaining(endTime));
            timeout = window.setTimeout(callback, $cc21a279a635bc02$var$getInterval(endTime));
        }
        callback();
        return ()=>window.clearTimeout(timeout);
    }, [
        endTime
    ]);
    return children(timeRemaining);
}
function $cc21a279a635bc02$var$getInterval(endTime) {
    const timeRemaining = (endTime - Date.now()) / 1000;
    if (timeRemaining < 0) return Number.MAX_SAFE_INTEGER;
    else if (timeRemaining < 60) return 1000;
    else if (timeRemaining < 3600) return 10000;
    else return 60000;
}
function $cc21a279a635bc02$var$getTimeRemaining(endTime) {
    const timeRemainingNumber = (0, (/*@__PURE__*/$parcel$interopDefault($94eCw)))(endTime).diff(Date.now());
    return {
        timeRemainingNumber: timeRemainingNumber,
        timeRemainingString: (0, (/*@__PURE__*/$parcel$interopDefault($94eCw))).duration(timeRemainingNumber).humanize(true)
    };
}








function $c4f932e2dc516197$export$1ec56616493aa86e() {
    (0, $ff1fe7435e7c9214$export$bb389a67188b58a7)("Round");
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const { eventId: eventIdStr } = (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)();
    const eventId = Number(eventIdStr);
    const { roundId: roundId } = (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)();
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $668e1ae53336726b$export$c6bca8aef4f6673c), {
        eventId: eventId,
        errorCollection: errorCollection,
        children: ({ event: event, team: team, errorCollection: errorCollection })=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$RoundImpl, {
                event: event,
                team: team,
                errorCollection: errorCollection,
                roundId: Number(roundId)
            })
    });
}
function $c4f932e2dc516197$var$RoundImpl({ event: event, team: team, roundId: roundId, errorCollection: errorCollection }) {
    (0, $ff1fe7435e7c9214$export$bb389a67188b58a7)("RoundImpl");
    const context = (0, $aZSru.useContext)((0, $2ecc252479907655$export$10b6fc071fe541e9));
    const round = event && event.rounds[roundId];
    const canAddOption = team?.isMember && (team?.isAdmin || round?.usersCanAddOptions);
    const augmentedRound = round && team && $c4f932e2dc516197$var$augmentRound(round, roundId, team, context);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $076f66bb16c5e38d$export$bce550385d03c7a9), {
                breadcrumbs: [
                    team && {
                        text: team.name,
                        href: `/team/${team.teamId}`
                    },
                    event && {
                        text: event.name,
                        href: `/event/${event.eventId}`
                    },
                    round && {
                        text: round.name,
                        active: true
                    }
                ],
                buttons: [
                    team?.isAdmin && {
                        text: "Edit Round",
                        onClick: ()=>(0, $5e84440fc542f600$export$61e0a65f251cfdb3)((onDismiss)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$export$d672153318984326, {
                                    event: event,
                                    existing: round,
                                    existingRoundId: roundId,
                                    onDismiss: onDismiss
                                }))
                    },
                    event && team?.isAdmin && {
                        text: "Copy Options from Previous Round",
                        onClick: ()=>(0, $5e84440fc542f600$export$61e0a65f251cfdb3)((onDismiss)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$CopyOptionsDialog, {
                                    errorCollection: errorCollection,
                                    targetEvent: event,
                                    targetRoundId: roundId,
                                    team: team,
                                    onDismiss: onDismiss
                                }))
                    },
                    canAddOption && {
                        text: "Add Option",
                        onClick: ()=>(0, $5e84440fc542f600$export$61e0a65f251cfdb3)((onDismiss)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$AddOptionDialog, {
                                    event: event,
                                    roundId: roundId,
                                    onDismiss: onDismiss
                                }))
                    },
                    augmentedRound?.canAbstain && {
                        text: "Abstain",
                        onClick: ()=>(0, $9ebed2054e490b11$export$7c7155fbb6bc8d79)(event.eventId, roundId, "abstain")
                    },
                    augmentedRound?.canReturn && {
                        text: "Return",
                        onClick: ()=>(0, $9ebed2054e490b11$export$7c7155fbb6bc8d79)(event.eventId, roundId, "return")
                    }
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                    children: augmentedRound && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$RoundContent, {
                        errorCollection: errorCollection,
                        event: event,
                        round: augmentedRound,
                        roundId: roundId,
                        team: team
                    })
                })
            })
        ]
    });
}
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
function $c4f932e2dc516197$var$augmentRound(round, roundId, team, context) {
    const username = context.currentUser.username;
    const votingOpen = Date.now() < round.closeTime;
    const userVotes = round.options.filter((o)=>o.votes.includes(username)).length;
    const abstained = round.abstentions.includes(username);
    const canVote = votingOpen && team.isMember && round.votesPerUser > userVotes && !abstained;
    // highest number of votes any option has gotten
    const maxVotes = round?.options.reduce((max, o)=>o.votes.length > max ? o.votes.length : max, 0) ?? 0;
    const canSeeResults = !votingOpen || !round.hideResultsUntilVoted || userVotes >= round.votesPerUser || abstained;
    const canAbstain = canVote && userVotes === 0 && !abstained;
    const canReturn = abstained && votingOpen;
    return {
        ...round,
        abstained: abstained,
        canAbstain: canAbstain,
        canReturn: canReturn,
        canSeeResults: canSeeResults,
        canVote: canVote,
        maxVotes: maxVotes,
        roundId: roundId,
        votingOpen: votingOpen
    };
}
function $c4f932e2dc516197$var$RoundContent({ errorCollection: errorCollection, event: event, round: round, team: team }) {
    const [firstRenderTime] = (0, $aZSru.useState)(()=>Date.now());
    const [connected] = (0, $aZSru.useState)(()=>new (0, $aedc866c4cacb991$export$46dc39d249bc63d6)(true, (v)=>v ? 0 : 5000));
    const [teamMembers, setTeamMembers] = (0, $aZSru.useState)();
    (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).useMemo(()=>(0, $e1610aabf171f616$export$e662071d38e352a1)(team.teamId).then((members)=>setTeamMembers(members)), [
        team.teamId
    ]);
    const voted = (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).useMemo(()=>{
        if (!round || !teamMembers) return undefined;
        const x = {
            voted: [],
            notVoted: [],
            abstaining: []
        };
        for (const m of teamMembers){
            if (round.abstentions.includes(m.user.username)) x.abstaining.push(m.user);
            else if (round.options.some((o)=>o.votes.includes(m.user.username))) x.voted.push(m.user);
            else x.notVoted.push(m.user);
        }
        return x;
    }, [
        teamMembers,
        round
    ]);
    (0, $aZSru.useEffect)(()=>{
        if (round.votingOpen) try {
            return (0, $9ebed2054e490b11$export$ec068583843480e7)(event.eventId, connected);
        } catch (err) {
            errorCollection.push(`Error subscribing to live updates: ${(0, $ff1fe7435e7c9214$export$46c1952d522542d7)(err)}`);
        }
    }, [
        connected,
        errorCollection,
        event.eventId,
        round.votingOpen
    ]);
    const options = $c4f932e2dc516197$var$augmentOptions(round.options, firstRenderTime);
    if (round.canVote) // shuffle options while user is voting
    options.sort((a, b)=>a.order - b.order);
    else options.sort((a, b)=>b.votes.length - a.votes.length);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("p", {
                children: round.description
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $cc21a279a635bc02$export$b3bccf74335de5cb), {
                endTime: round.closeTime,
                children: (timeRemaining)=>timeRemaining.timeRemainingNumber > 0 ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("p", {
                        children: [
                            "Voting closes ",
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c2b55618ae86a239$export$2e2bcd8739ae039), {
                                overlay: (props)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $11f28e84c5a16cd0$export$2e2bcd8739ae039), {
                                        ...props,
                                        children: (0, (/*@__PURE__*/$parcel$interopDefault($94eCw)))(round.closeTime).format("LLLL")
                                    }),
                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("span", {
                                    children: [
                                        timeRemaining.timeRemainingString,
                                        "."
                                    ]
                                })
                            })
                        ]
                    }) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("p", {
                        children: "Voting is closed."
                    })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("p", {
                children: [
                    "Users can vote for",
                    round.votesPerUser === 1 ? " one option" : ` up to ${round.votesPerUser} options`,
                    " and",
                    round.usersCanAddOptions ? " can" : " cannot",
                    " add options."
                ]
            }),
            voted && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("p", {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$UserListOnHover, {
                        id: "voted-users",
                        text: (0, $ff1fe7435e7c9214$export$cefb40c9962541b5)(voted.voted.length, "1 team member has voted", `${voted.voted.length} team members have voted`),
                        users: voted.voted
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$UserListOnHover, {
                        id: "not-voted-users",
                        text: (0, $ff1fe7435e7c9214$export$cefb40c9962541b5)(voted.notVoted.length, "1 team member has not voted", `${voted.notVoted.length} team members have not voted`),
                        users: voted.notVoted
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$UserListOnHover, {
                        id: "abstaining-users",
                        text: (0, $ff1fe7435e7c9214$export$cefb40c9962541b5)(voted.abstaining.length, "1 team member has abstained", `${voted.abstaining.length} team members have abstained`),
                        users: voted.abstaining
                    })
                ]
            }),
            round.votingOpen && !team.isMember && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                variant: "info",
                children: [
                    "You must join ",
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $69dc2b7fd4148745$export$a6c7ac8248d6e38a), {
                        to: `/team/${team.teamId}`,
                        children: "this team"
                    }),
                    " before you can vote."
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                errorCollection: errorCollection
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                observable: connected,
                children: (c)=>c ? null : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "warning",
                        children: "Lost live update connection."
                    })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $de031b656976468f$export$2e2bcd8739ae039), {
                children: options.map((option)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$Option, {
                        errorCollection: errorCollection,
                        event: event,
                        option: option,
                        round: round,
                        team: team
                    }, option.optionId))
            })
        ]
    });
}
function $c4f932e2dc516197$var$Option({ errorCollection: errorCollection, event: event, option: option, round: round, team: team }) {
    const context = (0, $aZSru.useContext)((0, $2ecc252479907655$export$10b6fc071fe541e9));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
        className: "my-3 p-3 align-items-baseline border border-secondary rounded",
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                xs: 12,
                md: 3,
                className: "d-flex align-items-baseline",
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                    children: option.name
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                xs: 12,
                md: 3,
                className: "d-flex flex-column",
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
                        className: "d-flex flex-wrap justify-content-between",
                        children: [
                            round.canSeeResults && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$VoteDisplay, {
                                errorCollection: errorCollection,
                                i: option.optionId,
                                option: option
                            }),
                            round.votingOpen && (option.votes.includes(context.currentUser.username) ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                variant: "outline-primary",
                                "data-action": "remove",
                                "data-option": option.optionId,
                                size: "sm",
                                onClick: onVoteClick,
                                children: "Unvote"
                            }) : round.canVote && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                variant: "outline-primary",
                                "data-action": "add",
                                "data-option": option.optionId,
                                size: "sm",
                                onClick: onVoteClick,
                                children: "Vote!"
                            })),
                            team?.isAdmin && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                variant: "outline-danger",
                                "data-option": option.optionId,
                                size: "sm",
                                onClick: onDeleteClick,
                                children: "Delete"
                            })
                        ]
                    }),
                    round.canSeeResults && round.maxVotes > 0 && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                        className: "votebar-container",
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                            className: "votebar",
                            style: {
                                width: option.votes.length / round.maxVotes * 100 + "%"
                            }
                        })
                    })
                ]
            })
        ]
    });
    function onVoteClick(e) {
        const action = e.currentTarget.dataset["action"];
        const optionId = Number(e.currentTarget.dataset["option"]);
        if (event && !isNaN(optionId) && (action === "add" || action === "remove")) (0, $9ebed2054e490b11$export$eef0a990000408da)(event.eventId, round.roundId, optionId, action);
    }
    function onDeleteClick(e) {
        const optionId = Number(e.currentTarget.dataset["option"]);
        (0, $5e84440fc542f600$export$61e0a65f251cfdb3)((onDismiss)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$ConfirmDeleteDialog, {
                option: round.options[optionId],
                onDismiss: async (confirmed)=>{
                    onDismiss();
                    if (confirmed && event) {
                        const result = await (0, $9ebed2054e490b11$export$1717f994e126a0c5)(event.eventId, round.roundId, optionId);
                        if (result) errorCollection.setValue(result);
                    }
                }
            }));
    }
}
function $c4f932e2dc516197$var$VoteDisplay({ errorCollection: errorCollection, i: i, option: option }) {
    const content = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
        size: "sm",
        variant: "outline-dark",
        children: [
            option.votes.length,
            " ",
            option.votes.length === 1 ? "vote" : "votes"
        ]
    });
    return option.votes.length === 0 ? content : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c2b55618ae86a239$export$2e2bcd8739ae039), {
        trigger: [
            "focus",
            "hover"
        ],
        placement: "auto",
        overlay: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5dac61ed1c570a51$export$2e2bcd8739ae039), {
            id: `votes-${i}`,
            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5dac61ed1c570a51$export$2e2bcd8739ae039).Body, {
                children: option.votes.map((voterId)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                        observable: (0, $81ca197868c8b74e$export$7cbf767827cd68ba)(voterId, errorCollection),
                        children: (u)=>u ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $2b645b3d4ad1132c$export$e2255cf6045e8d47), {
                                        className: "align-baseline",
                                        user: u,
                                        size: 20
                                    }),
                                    " ",
                                    u.username
                                ]
                            }) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {})
                    }, voterId))
            })
        }),
        children: content
    });
}
function $c4f932e2dc516197$var$UserListOnHover({ id: id, text: text, users: users }) {
    const content = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
        className: "me-2",
        size: "sm",
        variant: "outline-dark",
        children: text
    });
    return users.length === 0 ? content : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c2b55618ae86a239$export$2e2bcd8739ae039), {
        trigger: [
            "focus",
            "hover"
        ],
        placement: "auto",
        overlay: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5dac61ed1c570a51$export$2e2bcd8739ae039), {
            id: id,
            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5dac61ed1c570a51$export$2e2bcd8739ae039).Body, {
                children: users.map((u)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
                        children: [
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $2b645b3d4ad1132c$export$e2255cf6045e8d47), {
                                className: "align-baseline",
                                user: u,
                                size: 20
                            }),
                            " ",
                            u.username
                        ]
                    }, u.userId))
            })
        }),
        children: content
    });
}
function $c4f932e2dc516197$var$AddOptionDialog({ event: event, roundId: roundId, onDismiss: onDismiss }) {
    const [valid, setValid] = (0, $aZSru.useState)(false);
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    const [errors, setErrors] = (0, $aZSru.useState)(null);
    const nameInput = (0, $aZSru.useRef)(null);
    (0, $aZSru.useLayoutEffect)(()=>void nameInput.current?.focus(), []);
    const isValid = ()=>!!(!busy && nameInput.current?.value);
    const updateValid = ()=>{
        if (isValid() !== valid) setValid(!valid);
    };
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        backdrop: "static",
        show: true,
        onHide: ()=>onDismiss(),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Add Option"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: [
                    errors && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "danger",
                        children: errors.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                                children: e
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039), {
                        onInput: updateValid,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onSaveClick();
                            }
                        },
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                            controlId: "optionName",
                            children: [
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                    children: "Name"
                                }),
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    maxLength: 50,
                                    ref: nameInput
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: !valid,
                        onClick: onSaveClick,
                        children: "Add Option"
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        disabled: busy,
                        onClick: ()=>onDismiss(),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onSaveClick() {
        setBusy(true);
        setErrors(null);
        const option = {
            name: nameInput.current.value
        };
        const errors = await (0, $9ebed2054e490b11$export$97a332cdbb9101b1)(event.eventId, roundId, option);
        setBusy(false);
        if (errors) setErrors(errors);
        else onDismiss();
    }
}
function $c4f932e2dc516197$var$ConfirmDeleteDialog({ option: option, onDismiss: onDismiss }) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $5e84440fc542f600$export$b8704437d11c7fe7), {
        primaryButtonText: "Delete",
        onDismiss: onDismiss,
        children: [
            "Are you sure you want to delete the option ",
            option.name,
            "?"
        ]
    });
}
function $c4f932e2dc516197$export$d672153318984326({ event: event, onDismiss: onDismiss, existing: existing, existingRoundId: existingRoundId }) {
    const editing = !!existing;
    const [valid, setValid] = (0, $aZSru.useState)(editing);
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    const [errors, setErrors] = (0, $aZSru.useState)(null);
    const [showCopyRoundDialog, setShowCopyRoundDialog] = (0, $aZSru.useState)(false);
    const [options, setOptions] = (0, $aZSru.useState)(null);
    const nameInput = (0, $aZSru.useRef)(null);
    const descriptionInput = (0, $aZSru.useRef)(null);
    const votesPerUserInput = (0, $aZSru.useRef)(null);
    const addOptionsInput = (0, $aZSru.useRef)(null);
    const hideResultsUntilVotedInput = (0, $aZSru.useRef)(null);
    const closeTime = (0, $aZSru.useRef)(existing ? existing.closeTime : 0);
    (0, $aZSru.useLayoutEffect)(()=>void nameInput.current?.focus(), []);
    const updateValid = (0, $aZSru.useCallback)(()=>{
        const v = !!(!busy && nameInput.current?.value && closeTime.current > Date.now() && Number(votesPerUserInput.current?.value) > 0);
        if (v !== valid) setValid(v);
    }, [
        busy,
        valid
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        backdrop: "static",
        show: true,
        onHide: ()=>onDismiss(),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    className: "w-100",
                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
                        className: "d-flex justify-content-between",
                        children: [
                            editing ? "Edit" : "Add",
                            " Round",
                            " ",
                            !existing && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                onClick: ()=>setShowCopyRoundDialog(true),
                                children: "Copy Previous Round"
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: [
                    errors && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "danger",
                        children: errors.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                                children: e
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039), {
                        onInput: updateValid,
                        onKeyDown: (e)=>{
                            if (e.key === "Enter" && valid && e.target.nodeName !== "TEXTAREA") {
                                e.preventDefault();
                                onSaveClick();
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "roundName",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                        type: "text",
                                        defaultValue: existing?.name,
                                        maxLength: 50,
                                        ref: nameInput
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "description",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                        as: "textarea",
                                        defaultValue: existing?.description,
                                        maxLength: 4000,
                                        ref: descriptionInput
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "eventDateTime",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "Closing Time"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73e551fe3a921874$exports))), {
                                        isValidDate: (d)=>d.isAfter((0, (/*@__PURE__*/$parcel$interopDefault($94eCw)))().subtract(1, "day")),
                                        initialValue: existing && new Date(existing.closeTime),
                                        onChange: (v)=>{
                                            closeTime.current = typeof v === "string" ? 0 : v.valueOf();
                                            updateValid();
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "votesPerUser",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "Votes per user"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                        type: "text",
                                        defaultValue: existing?.votesPerUser,
                                        maxLength: 2,
                                        pattern: "[0-9]+",
                                        ref: votesPerUserInput
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "usersCanAddOptions",
                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Check, {
                                    ref: addOptionsInput,
                                    defaultChecked: existing?.usersCanAddOptions,
                                    label: "User can add options"
                                })
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "hideResultsUntilVoted",
                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Check, {
                                    ref: hideResultsUntilVotedInput,
                                    defaultChecked: existing?.hideResultsUntilVoted,
                                    label: "Hide results until user has voted"
                                })
                            }),
                            options && options.length && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
                                children: [
                                    "Includes ",
                                    options.length,
                                    " copied options.",
                                    " ",
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                        onClick: ()=>setOptions(null),
                                        size: "sm",
                                        children: "Remove"
                                    })
                                ]
                            })
                        ]
                    }),
                    showCopyRoundDialog && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($c4f932e2dc516197$var$CopyRoundDialog, {
                        teamId: event.teamId,
                        onDismiss: onCopyRound
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: !valid,
                        onClick: onSaveClick,
                        children: [
                            editing ? "Edit" : "Add",
                            " Round"
                        ]
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        disabled: busy,
                        onClick: ()=>onDismiss(),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onSaveClick() {
        setBusy(true);
        setErrors(null);
        const round = {
            name: nameInput.current.value,
            description: descriptionInput.current.value,
            closeTime: closeTime.current,
            votesPerUser: Number(votesPerUserInput.current.value),
            usersCanAddOptions: addOptionsInput.current.checked,
            hideResultsUntilVoted: hideResultsUntilVotedInput.current.checked
        };
        if (options && options.length) round.options = options;
        let errors;
        if (existing && existingRoundId !== undefined) errors = await (0, $9ebed2054e490b11$export$f63b876860108f1c)(event.eventId, existingRoundId, round);
        else errors = await (0, $9ebed2054e490b11$export$722f44e35c2acd00)(event.eventId, round);
        setBusy(false);
        if (errors) setErrors(errors);
        else onDismiss();
    }
    function onCopyRound(result) {
        if (result) {
            const { round: round, includeOptions: includeOptions } = result;
            nameInput.current.value = round.name;
            descriptionInput.current.value = round.description;
            votesPerUserInput.current.value = String(round.votesPerUser);
            addOptionsInput.current.checked = round.usersCanAddOptions;
            hideResultsUntilVotedInput.current.checked = !!round.hideResultsUntilVoted;
            if (includeOptions) setOptions(round.options.map((o)=>({
                    name: o.name,
                    votes: []
                })));
        }
        setShowCopyRoundDialog(false);
    }
}
function $c4f932e2dc516197$var$augmentOptions(options, seed) {
    const rnd = (0, $ff1fe7435e7c9214$export$d22a027dada4117a)(seed);
    return options.map((o, optionId)=>({
            ...o,
            optionId: optionId,
            order: rnd()
        }));
}
function $c4f932e2dc516197$var$CopyOptionsDialog({ errorCollection: errorCollection, onDismiss: onDismiss, targetEvent: targetEvent, targetRoundId: targetRoundId, team: team }) {
    const [eventsObservable] = (0, $aZSru.useState)(()=>{
        const observable = new (0, $aedc866c4cacb991$export$77cea355fa80b5f4)(null);
        (0, $e1610aabf171f616$export$6afb6efc053abf57)(team.teamId).then((events)=>eventsObservable.setValue(events));
        return observable;
    });
    const [activeEvent, setActiveEvent] = (0, $aZSru.useState)(null);
    const [activeRound, setActiveRound] = (0, $aZSru.useState)(null);
    const [activeOptions, setActiveOptions] = (0, $aZSru.useState)(()=>new Set());
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        show: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Copy Options"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $de031b656976468f$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                        children: [
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                children: [
                                    "Events",
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                                        observable: eventsObservable,
                                        children: (events)=>events && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039), {
                                                children: events.map((e)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039).Item, {
                                                        active: activeEvent === e,
                                                        onClick: ()=>{
                                                            setActiveOptions(new Set());
                                                            setActiveRound(null);
                                                            setActiveEvent(e);
                                                        },
                                                        children: e.name
                                                    }, e.eventId))
                                            })
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                children: [
                                    "Rounds",
                                    activeEvent && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039), {
                                        children: activeEvent.rounds.map((r, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039).Item, {
                                                active: activeRound === r,
                                                onClick: ()=>{
                                                    setActiveRound(r);
                                                    setActiveOptions(new Set(r.options.keys()));
                                                },
                                                children: r.name
                                            }, i))
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                children: [
                                    "Options",
                                    activeRound && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039), {
                                        children: activeRound.options.sort((a, b)=>b.votes.length - a.votes.length).map((o, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $7528e47a5e173e89$export$2e2bcd8739ae039).Item, {
                                                active: activeOptions.has(i),
                                                onClick: ()=>{
                                                    setActiveOptions(activeOptions.has(i) ? (activeOptions.delete(i), new Set(activeOptions)) : new Set(activeOptions.add(i)));
                                                },
                                                children: [
                                                    o.name,
                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("span", {
                                                        className: "fs-6",
                                                        children: [
                                                            " (",
                                                            o.votes.length,
                                                            " votes)"
                                                        ]
                                                    })
                                                ]
                                            }, i))
                                    })
                                ]
                            })
                        ]
                    })
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: !(activeEvent && activeRound && activeOptions.size > 0) || busy,
                        onClick: onCopyClick,
                        children: "Copy Options"
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: ()=>onDismiss(),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onCopyClick() {
        try {
            setBusy(true);
            if (!activeRound) return;
            for(let i = 0; i < activeRound.options.length; i++)if (activeOptions.has(i)) {
                const o = activeRound.options[i];
                const result = await (0, $9ebed2054e490b11$export$97a332cdbb9101b1)(targetEvent.eventId, targetRoundId, o);
                if (result) for (const r of result)errorCollection.push(`Error copying option ${o.name}: ${r}`);
            }
            onDismiss();
        } finally{
            setBusy(false);
        }
    }
}
function $c4f932e2dc516197$var$CopyRoundDialog({ onDismiss: onDismiss, teamId: teamId }) {
    const [eventsObservable] = (0, $aZSru.useState)(()=>{
        const observable = new (0, $aedc866c4cacb991$export$77cea355fa80b5f4)(null);
        (0, $e1610aabf171f616$export$6afb6efc053abf57)(teamId).then((events)=>eventsObservable.setValue(events));
        return observable;
    });
    const [activeEvent, setActiveEvent] = (0, $aZSru.useState)(null);
    const [activeRound, setActiveRound] = (0, $aZSru.useState)(null);
    const [includeOptions, setIncludeOptions] = (0, $aZSru.useState)(true);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        show: true,
        size: "xl",
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Copy Round"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $de031b656976468f$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                            children: [
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                    children: [
                                        "Events",
                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                                            observable: eventsObservable,
                                            children: (events)=>events && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039), {
                                                    children: events.map((e)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039).Item, {
                                                            active: activeEvent === e,
                                                            onClick: ()=>{
                                                                setActiveRound(null);
                                                                setActiveEvent(e);
                                                            },
                                                            children: e.name
                                                        }, e.eventId))
                                                })
                                        })
                                    ]
                                }),
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                    children: [
                                        "Rounds",
                                        activeEvent && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039), {
                                            children: activeEvent.rounds.map((r, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7528e47a5e173e89$export$2e2bcd8739ae039).Item, {
                                                    active: activeRound === r,
                                                    onClick: ()=>{
                                                        setActiveRound(r);
                                                    },
                                                    children: r.name
                                                }, i))
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                    controlId: "includeOptions",
                                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Check, {
                                        checked: includeOptions,
                                        onChange: ()=>setIncludeOptions((v)=>!v),
                                        label: "Include options"
                                    })
                                })
                            })
                        })
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: !(activeEvent && activeRound),
                        onClick: onCopyClick,
                        children: "Copy Round"
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        onClick: ()=>onDismiss(null),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onCopyClick() {
        if (!activeRound) return;
        onDismiss({
            round: activeRound,
            includeOptions: includeOptions
        });
    }
}


function $668e1ae53336726b$export$d61e24a684f9e51() {
    const { eventId: eventIdStr } = (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)();
    const eventId = Number(eventIdStr);
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const [showAddRoundModal, setShowAddRoundModal] = (0, $aZSru.useState)(false);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($668e1ae53336726b$export$c6bca8aef4f6673c, {
            eventId: eventId,
            errorCollection: errorCollection,
            children: ({ event: event, team: team })=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $076f66bb16c5e38d$export$bce550385d03c7a9), {
                            breadcrumbs: [
                                team && {
                                    text: team.name,
                                    href: `/team/${team.teamId}`
                                },
                                event && {
                                    text: event.name,
                                    active: true
                                }
                            ],
                            buttons: [
                                event && team && team.isAdmin && {
                                    text: "Add Round",
                                    onClick: ()=>setShowAddRoundModal(true)
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                                        errorCollection: errorCollection
                                    }),
                                    event === undefined ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
                                        animation: "border"
                                    }) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
                                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $87037ff43d18545e$export$2e2bcd8739ae039), {
                                            className: "mt-3",
                                            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tbody", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                                        children: [
                                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                                children: "Round"
                                                            }),
                                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                                children: "Closing Time"
                                                            }),
                                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                                children: "Votes Per User"
                                                            }),
                                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                                children: "Users Can Add Options"
                                                            })
                                                        ]
                                                    }),
                                                    event.rounds.map((r, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $69dc2b7fd4148745$export$a6c7ac8248d6e38a), {
                                                                        to: `/event/${event.eventId}/round/${i}`,
                                                                        children: r.name
                                                                    })
                                                                }),
                                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                    children: new Date(r.closeTime).toLocaleString()
                                                                }),
                                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                    children: r.votesPerUser
                                                                }),
                                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("input", {
                                                                        type: "checkbox",
                                                                        title: "users can add options",
                                                                        checked: r.usersCanAddOptions,
                                                                        readOnly: true,
                                                                        onClick: ()=>false
                                                                    })
                                                                })
                                                            ]
                                                        }, i))
                                                ]
                                            })
                                        })
                                    })
                                ]
                            })
                        }),
                        showAddRoundModal && event && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c4f932e2dc516197$export$d672153318984326), {
                            event: event,
                            onDismiss: ()=>setShowAddRoundModal(false)
                        })
                    ]
                })
        })
    });
}
const $668e1ae53336726b$var$undefinedTeamObserver = new (0, $aedc866c4cacb991$export$77cea355fa80b5f4)(undefined);
function $668e1ae53336726b$export$c6bca8aef4f6673c({ eventId: eventId, errorCollection: errorCollection, children: children }) {
    (0, $ff1fe7435e7c9214$export$bb389a67188b58a7)("EventObserver");
    const [eventObservable] = (0, $aZSru.useState)(()=>(0, $9ebed2054e490b11$export$a970992424c1e7a5)(eventId, errorCollection));
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
        observable: eventObservable,
        children: (event)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                observable: getTeamObservable(event?.teamId),
                children: (team)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($aZSru))).createElement(children, {
                        event: event,
                        team: team,
                        errorCollection: errorCollection
                    })
            })
    });
    function getTeamObservable(teamId) {
        if (teamId !== undefined) return (0, $e1610aabf171f616$export$491fe77f22ab2b51)(teamId, errorCollection);
        else return $668e1ae53336726b$var$undefinedTeamObserver;
    }
}
function $668e1ae53336726b$export$dcdcd56da7b7ae67({ team: team, onDismiss: onDismiss }) {
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    const [errors, setErrors] = (0, $aZSru.useState)(null);
    const nameInput = (0, $aZSru.useRef)(null);
    const descriptionInput = (0, $aZSru.useRef)(null);
    const [when, setWhen] = (0, $aZSru.useState)(0);
    (0, $aZSru.useLayoutEffect)(()=>void nameInput.current?.focus(), []);
    const valid = !!(!busy && nameInput.current?.value && when > Date.now());
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        backdrop: "static",
        show: true,
        onHide: ()=>onDismiss(false),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Add Event"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: [
                    errors && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "danger",
                        children: errors.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                                children: e
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039), {
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onSaveClick();
                            }
                        },
                        children: [
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "eventName",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "Name"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                        type: "text",
                                        maxLength: 50,
                                        ref: nameInput
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "eventDescription",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "Description"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                        as: "textarea",
                                        maxLength: 4000,
                                        ref: descriptionInput
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                                controlId: "eventDateTime",
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                        children: "When"
                                    }),
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, (/*@__PURE__*/$parcel$interopDefault($73e551fe3a921874$exports))), {
                                        isValidDate: (d)=>d.isSameOrAfter(Date.now()),
                                        timeFormat: false,
                                        onChange: (v)=>setWhen(typeof v === "string" ? 0 : v.valueOf())
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: !valid,
                        onClick: onSaveClick,
                        children: "Add Event"
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        disabled: busy,
                        onClick: ()=>onDismiss(false),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onSaveClick() {
        setBusy(true);
        setErrors(null);
        const event = {
            teamId: team.teamId,
            name: nameInput.current.value,
            description: descriptionInput.current.value,
            when: when
        };
        const errors = await (0, $9ebed2054e490b11$export$f531f92e2a15358f)(event);
        setBusy(false);
        if (errors) setErrors(errors);
        else onDismiss(true);
    }
}




var $aZSru = parcelRequire("aZSru");







function $b6730daf94e36843$export$3b7b7dcc59ea67ee() {
    const { inviteCode: inviteCode } = (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)();
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const navigate = (0, $da3cac5a2aaa7b71$export$9770f232ac06a008)();
    const messageContext = (0, $aZSru.useContext)((0, $b326521242f35736$export$b060d577040138d8));
    (0, $aZSru.useEffect)(()=>{
        if (!inviteCode) errorCollection.push("No invite code provided.");
        else (0, $e1610aabf171f616$export$3ea71dc33336ab44)(inviteCode).then((res)=>{
            if (Array.isArray(res)) errorCollection.push(...res);
            else {
                const target = `/team/${res.team.teamId}`;
                if (res.newlyJoined) messageContext.setMessage({
                    text: `You have joined the team ${res.team.name}.`,
                    location: target
                });
                navigate(target);
            }
        });
    }, [
        inviteCode,
        errorCollection,
        navigate,
        messageContext
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $076f66bb16c5e38d$export$bce550385d03c7a9), {
                buttons: []
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                        errorCollection: errorCollection
                    })
                })
            })
        ]
    });
}





var $aZSru = parcelRequire("aZSru");

















function $3dc8ab809ed286a0$export$3e5d0af8e738b082() {
    const { teamId: teamId } = (0, $da3cac5a2aaa7b71$export$99eaa27ddbbb95ef)();
    const [eventList, setEventList] = (0, $aZSru.useState)();
    const [showMemberList, setShowMemberList] = (0, $aZSru.useState)(false);
    const [showAddEventModal, setShowAddEventModal] = (0, $aZSru.useState)(false);
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const [leaving, setLeaving] = (0, $aZSru.useState)(false);
    const [teamObservable] = (0, $aZSru.useState)(()=>(0, $e1610aabf171f616$export$491fe77f22ab2b51)(Number(teamId), errorCollection));
    const loadEvents = (0, $aZSru.useCallback)(()=>{
        (0, $e1610aabf171f616$export$6afb6efc053abf57)(Number(teamId)).then((list)=>setEventList(list), (e)=>errorCollection.push((0, $ff1fe7435e7c9214$export$46c1952d522542d7)(e)));
    }, [
        teamId,
        errorCollection
    ]);
    (0, $aZSru.useEffect)(()=>loadEvents(), [
        teamId,
        loadEvents
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
            observable: teamObservable,
            children: (team)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
                    children: [
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $076f66bb16c5e38d$export$bce550385d03c7a9), {
                            breadcrumbs: [
                                team && {
                                    text: team.name,
                                    active: true
                                }
                            ],
                            buttons: [
                                team?.isAdmin && {
                                    text: "Add Event",
                                    onClick: ()=>setShowAddEventModal(true)
                                },
                                team && {
                                    text: "Members",
                                    onClick: ()=>setShowMemberList(true)
                                },
                                team?.isMember && {
                                    text: "Leave Team",
                                    variant: "danger",
                                    onClick: ()=>setLeaving(true)
                                },
                                team && !team.isMember && {
                                    text: "Join Team",
                                    onClick: ()=>(0, $e1610aabf171f616$export$47f143084f31963c)(team.teamId)
                                },
                                team && !team.isAdmin && team.inviteCode && {
                                    text: "Copy Invite Link",
                                    onClick: ()=>navigator.clipboard.writeText(window.location.origin + "/team/join/" + team.inviteCode)
                                },
                                team && team.isAdmin && {
                                    type: "dropdown",
                                    text: "Invite Link",
                                    items: [
                                        {
                                            text: "Copy Invite Link",
                                            disabled: !team.inviteCode,
                                            onClick: ()=>navigator.clipboard.writeText(window.location.origin + "/team/join/" + team.inviteCode)
                                        },
                                        {
                                            text: "New Invite Link",
                                            onClick: async ()=>{
                                                if (team.inviteCode && !await (0, $5e84440fc542f600$export$add63f471a2df484)("Are you sure you want to generate a new invite link? The old one will no longer work.", "Continue")) return;
                                                const result = await (0, $e1610aabf171f616$export$80143c9a921cac82)(team.teamId);
                                                if (result) errorCollection.push(...result);
                                            }
                                        },
                                        {
                                            text: "Clear Invite Link",
                                            disabled: !team.inviteCode,
                                            onClick: async ()=>{
                                                if (team.inviteCode && !await (0, $5e84440fc542f600$export$add63f471a2df484)("Are you sure you want to clear the invite link? The old one will no longer work.", "Continue")) return;
                                                const result = await (0, $e1610aabf171f616$export$78d1d07f45abf430)(team.teamId);
                                                if (result) errorCollection.push(...result);
                                            }
                                        }
                                    ]
                                }
                            ]
                        }),
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                                children: [
                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                                        errorCollection: errorCollection
                                    }),
                                    team === undefined ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
                                        animation: "border"
                                    }) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
                                        children: [
                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $87037ff43d18545e$export$2e2bcd8739ae039), {
                                                className: "mt-3",
                                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tbody", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                                            children: [
                                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                                    children: "Event"
                                                                }),
                                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                                    children: "Date"
                                                                })
                                                            ]
                                                        }),
                                                        eventList ? eventList.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $69dc2b7fd4148745$export$a6c7ac8248d6e38a), {
                                                                            to: `/event/${e.eventId}`,
                                                                            children: e.name
                                                                        })
                                                                    }),
                                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                        children: new Date(e.when).toLocaleDateString()
                                                                    })
                                                                ]
                                                            }, i)) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("tr", {
                                                            children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
                                                                    animation: "border"
                                                                })
                                                            })
                                                        })
                                                    ]
                                                })
                                            }),
                                            showAddEventModal && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $668e1ae53336726b$export$dcdcd56da7b7ae67), {
                                                team: team,
                                                onDismiss: onAddEventDismiss
                                            }),
                                            showMemberList && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($3dc8ab809ed286a0$var$MemberListModal, {
                                                team: team,
                                                onDismiss: ()=>setShowMemberList(false)
                                            }),
                                            leaving && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($3dc8ab809ed286a0$var$ConfirmLeaveDialog, {
                                                team: team,
                                                onDismiss: onLeaveDismiss
                                            })
                                        ]
                                    })
                                ]
                            })
                        })
                    ]
                })
        })
    });
    function onAddEventDismiss(added) {
        setShowAddEventModal(false);
        if (added) {
            setEventList(undefined);
            loadEvents();
        }
    }
    async function onLeaveDismiss(confirmed) {
        setLeaving(false);
        if (confirmed) await (0, $e1610aabf171f616$export$8f526f07693a40d1)(teamObservable.getValue().teamId);
    }
}
function $3dc8ab809ed286a0$var$MemberListModal({ team: team, onDismiss: onDismiss }) {
    const [errors, setErrors] = (0, $aZSru.useState)(null);
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    const [members, setMembers] = (0, $aZSru.useState)();
    const [serial, setSerial] = (0, $aZSru.useState)(0);
    (0, $aZSru.useEffect)(()=>void (0, $e1610aabf171f616$export$e662071d38e352a1)(team.teamId).then((m)=>setMembers(m), (e)=>setErrors([
                (0, $ff1fe7435e7c9214$export$46c1952d522542d7)(e)
            ])), [
        serial,
        team.teamId
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        backdrop: "static",
        show: true,
        onHide: ()=>onDismiss(),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: [
                        team.name,
                        " Members"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: [
                    errors && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "danger",
                        children: errors.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                                children: e
                            }, i))
                    }),
                    members ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $87037ff43d18545e$export$2e2bcd8739ae039), {
                        className: "mt-3",
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tbody", {
                            children: [
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                    children: [
                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                            children: "User"
                                        }),
                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                            children: "Administrator"
                                        }),
                                        team.isAdmin && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                            children: "Remove"
                                        })
                                    ]
                                }),
                                members.map((member, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                        children: [
                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("td", {
                                                children: [
                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("img", {
                                                        src: `${member.user.avatarUrl}&s=90`,
                                                        style: {
                                                            width: "30px",
                                                            height: "30px"
                                                        }
                                                    }),
                                                    " ",
                                                    member.user.username
                                                ]
                                            }),
                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("input", {
                                                    type: "checkbox",
                                                    title: "is administrator",
                                                    checked: member.isAdmin,
                                                    readOnly: busy || !team.isAdmin,
                                                    onClick: ()=>false,
                                                    onInput: (e)=>team.isAdmin && onAdminChange(member.user.username, !member.isAdmin)
                                                })
                                            }),
                                            team.isAdmin && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                                    variant: "danger",
                                                    disabled: busy,
                                                    onClick: ()=>onRemove(member.user.username),
                                                    children: "Remove"
                                                })
                                            })
                                        ]
                                    }, i))
                            ]
                        })
                    }) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
                        animation: "border"
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                    onClick: onDismiss,
                    children: "Close"
                })
            })
        ]
    });
    async function onAdminChange(username, isAdmin) {
        try {
            setBusy(true);
            setErrors(null);
            let errors;
            if (isAdmin) errors = await (0, $e1610aabf171f616$export$8dffcffbbf177bdd)(team.teamId, username);
            else errors = await (0, $e1610aabf171f616$export$71d59d3ff615c11a)(team.teamId, username);
            if (errors) setErrors(errors);
            else {
                setMembers(undefined);
                setSerial((s)=>s + 1);
            }
        } catch (ex) {
            setErrors([
                (0, $ff1fe7435e7c9214$export$46c1952d522542d7)(ex)
            ]);
        } finally{
            setBusy(false);
        }
    }
    async function onRemove(username) {
        try {
            if (!await (0, $5e84440fc542f600$export$add63f471a2df484)(`Are you sure you want to remove ${username} from ${team.name}?`, "Remove")) return;
            setBusy(true);
            setErrors(null);
            const errors = await (0, $e1610aabf171f616$export$57b1164dbe7b642f)(team.teamId, username);
            if (errors) setErrors(errors);
            else {
                setMembers(undefined);
                setSerial((s)=>s + 1);
            }
        } catch (ex) {
            setErrors([
                (0, $ff1fe7435e7c9214$export$46c1952d522542d7)(ex)
            ]);
        } finally{
            setBusy(false);
        }
    }
}
function $3dc8ab809ed286a0$var$ConfirmLeaveDialog({ team: team, onDismiss: onDismiss }) {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $5e84440fc542f600$export$b8704437d11c7fe7), {
        primaryButtonText: "Leave team",
        onDismiss: onDismiss,
        children: [
            "Are you sure you want to leave team ",
            team.name,
            "?"
        ]
    });
}
function $3dc8ab809ed286a0$export$3c0d2c056fd75208({ context: context, onDismiss: onDismiss }) {
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    const [errors, setErrors] = (0, $aZSru.useState)(null);
    const nameInput = (0, $aZSru.useRef)(null);
    (0, $aZSru.useLayoutEffect)(()=>void nameInput.current?.focus(), []);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        backdrop: "static",
        show: true,
        onHide: ()=>onDismiss(),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Add Team"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: [
                    errors && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $f08299be39369952$export$2e2bcd8739ae039), {
                        variant: "danger",
                        children: errors.map((e, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("div", {
                                children: e
                            }, i))
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039), {
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onSave();
                            }
                        },
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                            controlId: "teamName",
                            children: [
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                    children: "Team Name"
                                }),
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    maxLength: 50,
                                    ref: nameInput
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: busy,
                        onClick: onSave,
                        children: "Add Team"
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        disabled: busy,
                        onClick: ()=>onDismiss(),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onSave() {
        setBusy(true);
        setErrors(null);
        const team = {
            name: nameInput.current.value,
            admins: [
                context.currentUser.username
            ]
        };
        const result = await (0, $e1610aabf171f616$export$e44b0fb90766dd97)(team);
        if (Array.isArray(result)) setErrors(result);
        else onDismiss(result);
        setBusy(false);
    }
}




var $aZSru = parcelRequire("aZSru");











function $95f67db9b7aee9d2$export$88d0c73111412eb0() {
    const [myTeamList, setMyTeamList] = (0, $aZSru.useState)();
    const [allTeamList, setAllTeamList] = (0, $aZSru.useState)();
    const [loadAllTeamList, setLoadAllTeamList] = (0, $aZSru.useState)(false);
    const [showAll, setShowAll] = (0, $aZSru.useState)(false);
    const [showAddModal, setShowAddModal] = (0, $aZSru.useState)(false);
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const context = (0, $aZSru.useContext)((0, $2ecc252479907655$export$10b6fc071fe541e9));
    (0, $aZSru.useEffect)(()=>void (0, $e1610aabf171f616$export$4cfc020b5d9a8d1)().then((teams)=>setMyTeamList(teams), (error)=>errorCollection.push(error.message || error)), [
        errorCollection
    ]);
    (0, $aZSru.useEffect)(()=>void (loadAllTeamList && (0, $e1610aabf171f616$export$ff848de5b4c70793)().then((teams)=>setAllTeamList(teams), (error)=>errorCollection.push(error.message || error))), [
        errorCollection,
        loadAllTeamList
    ]);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $076f66bb16c5e38d$export$bce550385d03c7a9), {
                buttons: [
                    context.currentUser.isSuperAdmin && showAll && {
                        text: "Show my teams",
                        onClick: ()=>setShowAll(false),
                        variant: "secondary"
                    },
                    context.currentUser.isSuperAdmin && !showAll && {
                        text: "Show all teams",
                        onClick: ()=>{
                            setShowAll(true);
                            setLoadAllTeamList(true);
                        },
                        variant: "secondary"
                    },
                    context.currentUser.isSuperAdmin && {
                        text: "Add Team",
                        onClick: ()=>setShowAddModal(true)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                className: "justify-content-between",
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                    md: "auto",
                    children: [
                        showAll ? "All" : "My",
                        " Teams"
                    ]
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                            errorCollection: errorCollection
                        }),
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($95f67db9b7aee9d2$var$TeamListTable, {
                            teamList: showAll ? allTeamList : myTeamList
                        })
                    ]
                })
            }),
            showAddModal && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $3dc8ab809ed286a0$export$3c0d2c056fd75208), {
                context: context,
                onDismiss: (newTeam)=>{
                    if (newTeam) {
                        setAllTeamList((allTeamList)=>allTeamList ? [
                                ...allTeamList,
                                newTeam
                            ] : allTeamList);
                        setMyTeamList((myTeamList)=>myTeamList ? [
                                ...myTeamList,
                                newTeam
                            ] : myTeamList);
                    }
                    setShowAddModal(false);
                }
            })
        ]
    });
}
function $95f67db9b7aee9d2$var$TeamListTable({ teamList: teamList }) {
    if (!teamList) return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
        animation: "border"
    });
    else if (teamList.length === 0) return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("span", {
        children: "(no teams!)"
    });
    else return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $87037ff43d18545e$export$2e2bcd8739ae039), {
        className: "mt-3",
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("tbody", {
            children: teamList ? teamList.map((t, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("tr", {
                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $69dc2b7fd4148745$export$a6c7ac8248d6e38a), {
                            to: `/team/${t.teamId}`,
                            children: t.name
                        })
                    })
                }, i)) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
                animation: "border"
            })
        })
    });
}




var $aZSru = parcelRequire("aZSru");














function $6621a1f58d70da52$export$a69f017b19597ff5() {
    const [invitedUsersObservable] = (0, $aZSru.useState)(()=>(0, $81ca197868c8b74e$export$69093b9c569a5b5b)());
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const [showAddUserModal, setShowAddUserModal] = (0, $aZSru.useState)(false);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $d2795fd092250e43$exports.Fragment), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $076f66bb16c5e38d$export$bce550385d03c7a9), {
                buttons: [
                    {
                        text: "Add User",
                        onClick: ()=>setShowAddUserModal(true)
                    }
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c35f7703bec14998$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $fb07b04ce85e701b$export$2e2bcd8739ae039), {
                    children: [
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                            errorCollection: errorCollection
                        }),
                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                            observable: invitedUsersObservable,
                            children: (users)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $d2795fd092250e43$exports.Fragment), {
                                    children: users.length === 0 && invitedUsersObservable.loading ? /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6f42ca4961eaabf8$export$2e2bcd8739ae039), {
                                        animation: "border"
                                    }) : /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $87037ff43d18545e$export$2e2bcd8739ae039), {
                                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tbody", {
                                            children: [
                                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                                    children: [
                                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                            children: "User"
                                                        }),
                                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                            children: "Status"
                                                        }),
                                                        /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("th", {
                                                            children: "Actions"
                                                        })
                                                    ]
                                                }),
                                                users.map((observable, i)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $e976e77cda1edce6$export$c1cbdee04e18ea8b), {
                                                        observable: observable,
                                                        children: (user)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("tr", {
                                                                children: [
                                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("td", {
                                                                        children: [
                                                                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $2b645b3d4ad1132c$export$e2255cf6045e8d47), {
                                                                                user: user,
                                                                                size: 30
                                                                            }),
                                                                            " ",
                                                                            user.username,
                                                                            user.isSuperAdmin && " (superadmin)"
                                                                        ]
                                                                    }),
                                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("td", {
                                                                        children: user.status
                                                                    }),
                                                                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("td", {
                                                                        children: [
                                                                            user.status !== "approved" && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                                                                onClick: ()=>(0, $81ca197868c8b74e$export$587d19d2809405b1)(observable, errorCollection),
                                                                                children: user.status === "pending" ? "Approve" : "Re-enable"
                                                                            }),
                                                                            user.status === "approved" && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                                                                                variant: "danger",
                                                                                onClick: ()=>{
                                                                                    (0, $5e84440fc542f600$export$61e0a65f251cfdb3)((onDismiss)=>/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $5e84440fc542f600$export$b8704437d11c7fe7), {
                                                                                            primaryButtonText: "Disable user",
                                                                                            onDismiss: (confirmed)=>{
                                                                                                if (confirmed) (0, $81ca197868c8b74e$export$885bfdaa8d265eb5)(observable, errorCollection);
                                                                                                onDismiss();
                                                                                            },
                                                                                            children: [
                                                                                                "Are you sure you want to disable",
                                                                                                user.username,
                                                                                                "?"
                                                                                            ]
                                                                                        }));
                                                                                },
                                                                                children: "Disable"
                                                                            })
                                                                        ]
                                                                    })
                                                                ]
                                                            })
                                                    }, i))
                                            ]
                                        })
                                    })
                                })
                        }),
                        showAddUserModal && /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)($6621a1f58d70da52$var$AddUserModal, {
                            onDismiss: ()=>setShowAddUserModal(false)
                        })
                    ]
                })
            })
        ]
    });
}
function $6621a1f58d70da52$var$AddUserModal({ onDismiss: onDismiss }) {
    const [errorCollection] = (0, $aZSru.useState)(()=>new (0, $09f8b9d3461587fb$export$d7df101172495fc)());
    const [busy, setBusy] = (0, $aZSru.useState)(false);
    const nameInput = (0, $aZSru.useRef)(null);
    (0, $aZSru.useLayoutEffect)(()=>void nameInput.current?.focus(), []);
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039), {
        backdrop: "static",
        show: true,
        onHide: ()=>onDismiss(),
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Header, {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Title, {
                    children: "Add Team"
                })
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Body, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$3771c484b4b495d0), {
                        errorCollection: errorCollection
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039), {
                        onKeyDown: (e)=>{
                            if (e.key === "Enter") {
                                e.preventDefault();
                                onSave();
                            }
                        },
                        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $24747a49448ba319$export$2e2bcd8739ae039).Group, {
                            controlId: "username",
                            children: [
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Label, {
                                    children: "GitHub Username"
                                }),
                                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $24747a49448ba319$export$2e2bcd8739ae039).Control, {
                                    type: "text",
                                    maxLength: 50,
                                    ref: nameInput
                                })
                            ]
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $759954fadbb369bc$export$2e2bcd8739ae039).Footer, {
                children: [
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "primary",
                        disabled: busy,
                        onClick: onSave,
                        children: "Add User"
                    }),
                    /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $125bc3f756529a6e$export$2e2bcd8739ae039), {
                        variant: "secondary",
                        disabled: busy,
                        onClick: ()=>onDismiss(),
                        children: "Cancel"
                    })
                ]
            })
        ]
    });
    async function onSave() {
        setBusy(true);
        errorCollection.clear();
        const errors = await (0, $81ca197868c8b74e$export$2fae2261c6cf56cd)(nameInput.current.value);
        if (Array.isArray(errors)) errorCollection.setValue(errors);
        else onDismiss();
        setBusy(false);
    }
}


function $7287e550738e7a7e$export$be92b6f5f03c0fe9() {
    return /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $69dc2b7fd4148745$export$9ba4e89fdfa1fc54), {
        children: [
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $de031b656976468f$export$2e2bcd8739ae039), {
                children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b326521242f35736$export$42de33f7652dc3de), {
                    children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)((0, $5b2f026c239847ab$export$3565eb3d00ca5a74), {
                        children: [
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5b2f026c239847ab$export$e7b0ac011bb776c6), {
                                path: "/event/:eventId/round/:roundId",
                                element: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $c4f932e2dc516197$export$1ec56616493aa86e), {})
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5b2f026c239847ab$export$e7b0ac011bb776c6), {
                                path: "/event/:eventId",
                                element: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $668e1ae53336726b$export$d61e24a684f9e51), {})
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5b2f026c239847ab$export$e7b0ac011bb776c6), {
                                path: "/team/join/:inviteCode",
                                element: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $b6730daf94e36843$export$3b7b7dcc59ea67ee), {})
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5b2f026c239847ab$export$e7b0ac011bb776c6), {
                                path: "/team/:teamId",
                                element: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $3dc8ab809ed286a0$export$3e5d0af8e738b082), {})
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5b2f026c239847ab$export$e7b0ac011bb776c6), {
                                path: "/user/list",
                                element: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $6621a1f58d70da52$export$a69f017b19597ff5), {})
                            }),
                            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $5b2f026c239847ab$export$e7b0ac011bb776c6), {
                                path: "/",
                                element: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $95f67db9b7aee9d2$export$88d0c73111412eb0), {})
                            })
                        ]
                    })
                })
            }),
            (0, $5e84440fc542f600$export$c907ef9a792ea8cb)()
        ]
    });
}


async function $07d3d587db475fac$var$go() {
    const context = await (0, $81ca197868c8b74e$export$31553aaa555c1514)();
    const container = document.getElementById("root");
    let content;
    if (context === null) {
        const cookies = $07d3d587db475fac$var$parseCookies();
        const loginUrl = `/login?r=${encodeURIComponent(document.location.pathname)}`;
        if (cookies["PreviouslyLoggedIn"]) {
            document.cookie = "PreviouslyLoggedIn=;path=/;max-age=0";
            window.location.href = loginUrl;
        }
        content = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
            children: [
                "You're going to need to log in with GitHub to access morale.events.",
                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("br", {}),
                /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("a", {
                    href: loginUrl,
                    children: "Continue"
                })
            ]
        });
    } else if (context.currentUser.status !== "approved") content = /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsxs)("div", {
        children: [
            "Your account has not yet been approved to access morale.events. Kindly remind an administrator to approve your account.",
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("br", {}),
            /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)("button", {
                onClick: async ()=>{
                    await (0, $81ca197868c8b74e$export$a0973bcfe11b05c9)() && (window.location.href = "/");
                },
                children: "Log Out"
            })
        ]
    });
    const root = (0, $63bf094b1c1499a1$exports.createRoot)(container);
    if (content) root.render(content);
    else root.render(/*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $2ecc252479907655$export$10b6fc071fe541e9).Provider, {
        value: context,
        children: /*#__PURE__*/ (0, $d2795fd092250e43$exports.jsx)((0, $7287e550738e7a7e$export$be92b6f5f03c0fe9), {})
    }));
}
$07d3d587db475fac$var$go();
function $07d3d587db475fac$var$parseCookies() {
    const cookieStrs = document.cookie.split(";");
    const cookies = {};
    cookieStrs.forEach((c)=>{
        const kvp = c.split("=");
        cookies[kvp[0].trim()] = kvp[1];
    });
    return cookies;
}


//# sourceMappingURL=client.ff7df83f.js.map
